import { GraphQLClient } from 'graphql-request';
import * as Dom from 'graphql-request/dist/types.dom';
import { print } from 'graphql';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  AnalyticsPayload: any;
  BigDecimal: any;
  Locale: any;
  URL: any;
  UUID: any;
}

export interface AIAgentEntryContextInput {
  conversationType: Scalars['String'];
  pageName: Scalars['String'];
}

export enum AcceleratorAnalyticsEventTypes {
  IMPRESSION = 'IMPRESSION',
  INTERACTION = 'INTERACTION',
  OUTCOME = 'OUTCOME',
  PAGE_VIEW = 'PAGE_VIEW',
}

export enum AcceleratorBookingChannel {
  B2B_DISTRIBUTION_NETWORK = 'B2B_DISTRIBUTION_NETWORK',
  EXPEDIA_GROUP_BRANDS = 'EXPEDIA_GROUP_BRANDS',
  EXPEDIA_GROUP_MARKETPLACE = 'EXPEDIA_GROUP_MARKETPLACE',
}

export enum AcceleratorButtonTypes {
  PAGING = 'PAGING',
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
  TERTIARY = 'TERTIARY',
}

export interface AcceleratorInput {
  /** Margin percentage of the accelerator */
  additionalMargin: Scalars['Int'];
  /** Stay dates of the accelerator */
  dateRange: DateRangeInput;
  /** Legacy Id of an existing accelerator */
  id?: InputMaybe<Scalars['Int']>;
  /** Property id on which the accelerator is to created */
  propertyId: Scalars['Int'];
}

export enum AcceleratorMetricsSourceTypeInput {
  COMPETITOR_DATA = 'COMPETITOR_DATA',
  PRODUCT_DATA = 'PRODUCT_DATA',
}

/** Inputs to fetch Accelerator Performance data */
export interface AcceleratorPerformanceInput {
  bookingChannel?: InputMaybe<AcceleratorBookingChannel>;
  ratePlanType?: InputMaybe<AcceleratorRatePlanType>;
}

export enum AcceleratorRatePlanType {
  ALL_RATE_PLANS = 'ALL_RATE_PLANS',
  B2B_DISTRIBUTION_RATES = 'B2B_DISTRIBUTION_RATES',
  PACKAGE_DISTRIBUTION_RATES = 'PACKAGE_DISTRIBUTION_RATES',
  PACKAGE_RATES = 'PACKAGE_RATES',
  STANDALONE_RATES = 'STANDALONE_RATES',
}

/** Accelerator Selection input for the side sheet */
export interface AcceleratorSelectionInput {
  key: Scalars['String'];
  margin?: InputMaybe<Scalars['String']>;
  value: Scalars['String'];
}

/** Accelerator Settings input for the side sheet */
export interface AcceleratorSettingsInput {
  selections: Array<AcceleratorSelectionInput>;
}

export interface AcceleratorsUpsertInput {
  /** Details of the accelerators to upsert */
  accelerators: Array<AcceleratorInput>;
}

export interface AccountMergeRequestContextInput {
  cmsToken?: InputMaybe<Scalars['String']>;
  flowIdentifier?: InputMaybe<Scalars['String']>;
  identityClientContext?: InputMaybe<IdentityClientContext>;
  referrerURL?: InputMaybe<Scalars['String']>;
  scenario?: InputMaybe<IdentityAuthenticationScenario>;
}

export enum Action {
  RESUME_PAYMENT = 'RESUME_PAYMENT',
  UPDATE_PAYMENT_METHOD = 'UPDATE_PAYMENT_METHOD',
  /** @deprecated Use UPDATE_PAYMENT_METHOD and RESUME_PAYMENT separately for clarity */
  UPDATE_PAYMENT_METHOD_AND_RESUME = 'UPDATE_PAYMENT_METHOD_AND_RESUME',
}

/** Describes what kind of action being described. Copy for example describes the coupon code copy behavior. Authwindow shows the login/signup dialog. */
export enum ActionDetailsType {
  /** Action to pop auth window */
  AUTHWINDOW = 'AUTHWINDOW',
  /** Action to close a dropdown option */
  CLOSE = 'CLOSE',
  /** Action to copy contents to clipboard */
  COPY = 'COPY',
  /** Action to open the date picker */
  DATEPICKER = 'DATEPICKER',
  /** Action to open an external link off */
  EXTERNAL_LINK = 'EXTERNAL_LINK',
  /** Action to display free lx message */
  FREE_LX = 'FREE_LX',
  /** Action to open a link off */
  OPEN = 'OPEN',
  /** Action to display term and conditions */
  TERMS_AND_CONDITIONS = 'TERMS_AND_CONDITIONS',
}

export interface ActionPanelContext {
  coachingParameters?: InputMaybe<SupplyContentCoachingParameters>;
  type: Scalars['String'];
  view: Scalars['String'];
}

export enum ActionResultType {
  FAIL = 'FAIL',
  SUCCESS = 'SUCCESS',
}

export enum ActionStationType {
  REVIEW_ACTIVE_REQUEST = 'REVIEW_ACTIVE_REQUEST',
  REVIEW_CANCELLATION_REQUEST = 'REVIEW_CANCELLATION_REQUEST',
  VIEW_BOOKING_DETAILS = 'VIEW_BOOKING_DETAILS',
}

export enum ActionType {
  DownloadDPReport = 'DownloadDPReport',
  Modal = 'Modal',
  Open = 'Open',
  OpenPriceChangeAlert = 'OpenPriceChangeAlert',
}

/** Indicates the coupon's active state */
export enum ActiveState {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  UNKNOWN = 'UNKNOWN',
  USED = 'USED',
}

/** Provide criteria needed to perform an activities search */
export interface ActivitiySearchCriteriaInput {
  primary: PrimaryActivitySearchCriteriaInput;
  secondary?: InputMaybe<ShoppingSearchCriteriaInput>;
}

export enum ActivityAvailabilityPriceTextTheme {
  POSITIVE = 'POSITIVE',
}

export enum ActivityBadgeType {
  CAMPAIGN_DEAL = 'CAMPAIGN_DEAL',
  DEAL_ADD_ON = 'DEAL_ADD_ON',
  DEAL_GENERIC = 'DEAL_GENERIC',
  DEAL_MEMBER = 'DEAL_MEMBER',
  GLOBAL_LOW_TIER = 'GLOBAL_LOW_TIER',
}

/** Activity banner type */
export enum ActivityBannerType {
  ALERT = 'ALERT',
  INFO = 'INFO',
  SHOP_WITH_POINTS = 'SHOP_WITH_POINTS',
}

export enum ActivityCancellationType {
  FREE_CANCELLATION = 'FREE_CANCELLATION',
  NO_CANCELLATION = 'NO_CANCELLATION',
}

export enum ActivityCategory {
  ADULTS_ONLY_SHOWS = 'ADULTS_ONLY_SHOWS',
  ADVENTURES = 'ADVENTURES',
  ADVENTURE_OUTDOOR = 'ADVENTURE_OUTDOOR',
  AIRBOAT_TOURS = 'AIRBOAT_TOURS',
  AIRPLANE_RIDES = 'AIRPLANE_RIDES',
  AIRPLANE_TOURS = 'AIRPLANE_TOURS',
  AIRPORT_GROUND_TRANSPORTATION = 'AIRPORT_GROUND_TRANSPORTATION',
  AIRPORT_LOUNGES = 'AIRPORT_LOUNGES',
  AIRPORT_TO_AIRPORT_TRANSFERS = 'AIRPORT_TO_AIRPORT_TRANSFERS',
  AIR_BALLOON_HELICOPTER_TOURS = 'AIR_BALLOON_HELICOPTER_TOURS',
  AIR_HELICOPTER_BALLOON_TOURS = 'AIR_HELICOPTER_BALLOON_TOURS',
  AMUSEMENT_THEME_PARKS = 'AMUSEMENT_THEME_PARKS',
  ARCHITECTURE_TOURS = 'ARCHITECTURE_TOURS',
  ART_CLASSES = 'ART_CLASSES',
  ART_CULTURE_HISTORY_TOURS = 'ART_CULTURE_HISTORY_TOURS',
  ART_MUSIC_LITERARYTOURS = 'ART_MUSIC_LITERARYTOURS',
  ATTRACTIONS = 'ATTRACTIONS',
  ATTRACTION_TICKETS = 'ATTRACTION_TICKETS',
  BALLOON_RIDES = 'BALLOON_RIDES',
  BALLOON_TOURS = 'BALLOON_TOURS',
  BAR_PUB_TOURS = 'BAR_PUB_TOURS',
  BEER_BREWERY_TOURS = 'BEER_BREWERY_TOURS',
  BEYOND_THE_CITY = 'BEYOND_THE_CITY',
  BIKE_MOUNTAIN_BIKE_TOURS = 'BIKE_MOUNTAIN_BIKE_TOURS',
  BIKE_RENTALS = 'BIKE_RENTALS',
  BOAT_RENTAL = 'BOAT_RENTAL',
  BOAT_TOURS = 'BOAT_TOURS',
  BOAT_TOURS_CRUISES = 'BOAT_TOURS_CRUISES',
  BRUNCHC_RUISES = 'BRUNCHC_RUISES',
  BUNGEE_JUMPING_SKYDIVING = 'BUNGEE_JUMPING_SKYDIVING',
  BUS_MINIVAN_TOURS = 'BUS_MINIVAN_TOURS',
  CABARET = 'CABARET',
  CAMPAIGN_DEALS = 'CAMPAIGN_DEALS',
  CASTLE_PALACE_TOURS = 'CASTLE_PALACE_TOURS',
  CHAUFFER_SERVICES = 'CHAUFFER_SERVICES',
  CHRISTMAS = 'CHRISTMAS',
  CIRQUE = 'CIRQUE',
  CIRQUE_DU_SOLEIL = 'CIRQUE_DU_SOLEIL',
  CIRQUE_DU_SOLEILSHOWS = 'CIRQUE_DU_SOLEILSHOWS',
  CITY_AND_ATTRACTION_TRANSFERS = 'CITY_AND_ATTRACTION_TRANSFERS',
  CITY_ATTRACTION_TRANSFERS = 'CITY_ATTRACTION_TRANSFERS',
  CITY_TOURS = 'CITY_TOURS',
  CITY_TOURS_PACKAGES = 'CITY_TOURS_PACKAGES',
  CLASSES_WORKSHOPS = 'CLASSES_WORKSHOPS',
  CLUB_AND_PARTY_BUS_TOURS = 'CLUB_AND_PARTY_BUS_TOURS',
  CLUB_PARTY_BUS_TOURS = 'CLUB_PARTY_BUS_TOURS',
  COFFEE_TEA_TOURS = 'COFFEE_TEA_TOURS',
  COMEDY_SHOWS = 'COMEDY_SHOWS',
  CONCERTS_SPECIAL_EVENTS = 'CONCERTS_SPECIAL_EVENTS',
  COOKING_CLASSES = 'COOKING_CLASSES',
  CRUISES_BOAT_TOURS = 'CRUISES_BOAT_TOURS',
  CRUISES_WATER_TOURS = 'CRUISES_WATER_TOURS',
  CULTURAL_HERITAGE_EXPERIENCES = 'CULTURAL_HERITAGE_EXPERIENCES',
  CUSTOM_PRIVATE_TOURS = 'CUSTOM_PRIVATE_TOURS',
  DANCE_CLASSES = 'DANCE_CLASSES',
  DAY_OF_THE_DEAD = 'DAY_OF_THE_DEAD',
  DAY_SPAS = 'DAY_SPAS',
  DAY_TRIPS = 'DAY_TRIPS',
  DAY_TRIPS_EXCURSIONS = 'DAY_TRIPS_EXCURSIONS',
  DINING_EXPERIENCES = 'DINING_EXPERIENCES',
  DINNER_CRUISES = 'DINNER_CRUISES',
  DINNER_THEATER = 'DINNER_THEATER',
  DISNEY = 'DISNEY',
  DISNEY_PARKS = 'DISNEY_PARKS',
  DOLPHIN_WHALE_WATCHING = 'DOLPHIN_WHALE_WATCHING',
  DOSE_OF_CULTURE = 'DOSE_OF_CULTURE',
  DUCK_TOURS = 'DUCK_TOURS',
  EASTER = 'EASTER',
  FAMILY_FRIENDLY = 'FAMILY_FRIENDLY',
  FASHION_SHOWS_TOURS = 'FASHION_SHOWS_TOURS',
  FISHING_CHARTERS_TOURS = 'FISHING_CHARTERS_TOURS',
  FISHING_TOURS_AND_CHARTERS = 'FISHING_TOURS_AND_CHARTERS',
  FOOD_DRINK = 'FOOD_DRINK',
  FOOD_DRINK_NIGHTLIFE = 'FOOD_DRINK_NIGHTLIFE',
  FOOD_TOURS = 'FOOD_TOURS',
  FUN_FOR_FOODIES = 'FUN_FOR_FOODIES',
  FUN_ON_THE_WATER = 'FUN_ON_THE_WATER',
  GALLERIES_MUSEUMS = 'GALLERIES_MUSEUMS',
  GAMES_SHOWS_SPECIAL_EVENTS = 'GAMES_SHOWS_SPECIAL_EVENTS',
  GETTING_AROUND = 'GETTING_AROUND',
  GOLF_TEE_TIMES = 'GOLF_TEE_TIMES',
  GOLF_TOURS_TEE_TIMES = 'GOLF_TOURS_TEE_TIMES',
  HALLOWEEN = 'HALLOWEEN',
  HAMMAMS_TURKISH_BATHS = 'HAMMAMS_TURKISH_BATHS',
  HELICOPTER_RIDES = 'HELICOPTER_RIDES',
  HELICOPTER_TOURS = 'HELICOPTER_TOURS',
  HIGH_SPEED_DRIVING = 'HIGH_SPEED_DRIVING',
  HIGH_SPEED_RIDES = 'HIGH_SPEED_RIDES',
  HIKING_CAMPING = 'HIKING_CAMPING',
  HISTORICAL_TOURS = 'HISTORICAL_TOURS',
  HISTORY_CULTURE = 'HISTORY_CULTURE',
  HOLIDAY_SEASONAL_TOURS = 'HOLIDAY_SEASONAL_TOURS',
  HONEYMOON_PACKAGE = 'HONEYMOON_PACKAGE',
  HONEYMOON_PACKAGES = 'HONEYMOON_PACKAGES',
  HOP_ON_HOP_OFF = 'HOP_ON_HOP_OFF',
  HOP_ON_HOP_OFF_TOURS = 'HOP_ON_HOP_OFF_TOURS',
  HORSE_CARRIAGE_RIDES = 'HORSE_CARRIAGE_RIDES',
  HOT_SPRINGS_THERMAL_SPAS = 'HOT_SPRINGS_THERMAL_SPAS',
  INTERESTS = 'INTERESTS',
  KAYAKING_CANOEING = 'KAYAKING_CANOEING',
  LATEST_GREATEST = 'LATEST_GREATEST',
  LIFT_TICKETS = 'LIFT_TICKETS',
  LIKELY_TO_SELL_OUT = 'LIKELY_TO_SELL_OUT',
  LITERARY_ART_MUSIC_TOURS = 'LITERARY_ART_MUSIC_TOURS',
  LOCAL_EXPERT_PICKS = 'LOCAL_EXPERT_PICKS',
  LUNCH_CRUISES = 'LUNCH_CRUISES',
  MOTORCYCLE_SCOOTER_TOURS = 'MOTORCYCLE_SCOOTER_TOURS',
  MOVIE_TV_TOURS = 'MOVIE_TV_TOURS',
  MULTIDAY_CRUISES = 'MULTIDAY_CRUISES',
  MULTI_DAY_EXTENDED_TOURS = 'MULTI_DAY_EXTENDED_TOURS',
  MUSEUM_TICKETS = 'MUSEUM_TICKETS',
  MUSEUM_TICKETS_PASSES = 'MUSEUM_TICKETS_PASSES',
  MUST_SEE_SIGHTS = 'MUST_SEE_SIGHTS',
  NA = 'NA',
  NATIONAL_HOLIDAYS = 'NATIONAL_HOLIDAYS',
  NEW = 'NEW',
  NEWY_EARS = 'NEWY_EARS',
  NIGHTLIFE = 'NIGHTLIFE',
  NIGHTLIFE_PASSES = 'NIGHTLIFE_PASSES',
  NIGHT_CRUISES = 'NIGHT_CRUISES',
  NIGHT_TOURS = 'NIGHT_TOURS',
  ONSENS = 'ONSENS',
  OTHER_ANIMALS_ACTIVITIES = 'OTHER_ANIMALS_ACTIVITIES',
  OTHER_ANIMAL_ACTIVITIES = 'OTHER_ANIMAL_ACTIVITIES',
  OTHER_CLASSES = 'OTHER_CLASSES',
  OTHER_OUTDOOR_ACTIVITIES = 'OTHER_OUTDOOR_ACTIVITIES',
  OTHER_SEASONAL_EVENTS = 'OTHER_SEASONAL_EVENTS',
  OTHER_TOURS = 'OTHER_TOURS',
  OTHER_TRANSFERS = 'OTHER_TRANSFERS',
  OTHER_TRANSPORTATION = 'OTHER_TRANSPORTATION',
  OTHER_WATER_ACTIVITIES = 'OTHER_WATER_ACTIVITIES',
  PHOTOGRAPHY_TOURS = 'PHOTOGRAPHY_TOURS',
  PORT_TRANSFERS = 'PORT_TRANSFERS',
  PRIVATE_CUSTOM_TOURS = 'PRIVATE_CUSTOM_TOURS',
  PRIVATE_DAY_TRIPS = 'PRIVATE_DAY_TRIPS',
  PRIVATE_TOURS = 'PRIVATE_TOURS',
  PRIVATE_TRANSFERS = 'PRIVATE_TRANSFERS',
  PURE_ROMANCE = 'PURE_ROMANCE',
  RELIGIOUS_SPIRITUAL_TOURS = 'RELIGIOUS_SPIRITUAL_TOURS',
  RIVER_HARBOUR_CRUISES = 'RIVER_HARBOUR_CRUISES',
  ROMAN_STAYCATION = 'ROMAN_STAYCATION',
  SAFARIS = 'SAFARIS',
  SAILING_TRIPS = 'SAILING_TRIPS',
  SCOOTER_RENTALS = 'SCOOTER_RENTALS',
  SEGWAY_TOURS = 'SEGWAY_TOURS',
  SHARED_TRANSFERS = 'SHARED_TRANSFERS',
  SHARK_DIVING = 'SHARK_DIVING',
  SHOPPING_FASHION = 'SHOPPING_FASHION',
  SHOPPING_PASSES_OFFERS = 'SHOPPING_PASSES_OFFERS',
  SHOPPING_TOURS = 'SHOPPING_TOURS',
  SHORE_EXCURIONS = 'SHORE_EXCURIONS',
  SHOWS_CONCERTS = 'SHOWS_CONCERTS',
  SHOW_SPORT_TICKETS = 'SHOW_SPORT_TICKETS',
  SIGHTSEEING_ATTRACTION_PASSES = 'SIGHTSEEING_ATTRACTION_PASSES',
  SIGHTSEEING_CITY_PASSES = 'SIGHTSEEING_CITY_PASSES',
  SIGHTSEEING_PASSES = 'SIGHTSEEING_PASSES',
  SKIING_RENTALS = 'SKIING_RENTALS',
  SKIP_THE_LINE_TOURS = 'SKIP_THE_LINE_TOURS',
  SNORKELING_SCUBA_DIVING = 'SNORKELING_SCUBA_DIVING',
  SNOWBOARDING_RENTALS = 'SNOWBOARDING_RENTALS',
  SNOWMOBILE_TOURS = 'SNOWMOBILE_TOURS',
  SNOWSHOEING = 'SNOWSHOEING',
  SPA = 'SPA',
  SPA_WELLNESS = 'SPA_WELLNESS',
  SPEED_BOATS_JET_SKIS = 'SPEED_BOATS_JET_SKIS',
  SPORTING_EVENTS_PACKAGES = 'SPORTING_EVENTS_PACKAGES',
  SPORTS_PACKAGES = 'SPORTS_PACKAGES',
  STAY_ACTIVE = 'STAY_ACTIVE',
  SUBMARINE_TOURS = 'SUBMARINE_TOURS',
  SUNSET_CRUISES = 'SUNSET_CRUISES',
  SUPERNATURAL_TOURS = 'SUPERNATURAL_TOURS',
  SUSTAINABLE_TOURS = 'SUSTAINABLE_TOURS',
  SWIM_WITH_DOLPHINS = 'SWIM_WITH_DOLPHINS',
  THEATER_SHOWS_MUSICALS = 'THEATER_SHOWS_MUSICALS',
  THEME_PARKS = 'THEME_PARKS',
  THEME_PARK_TICKETS_TOURS = 'THEME_PARK_TICKETS_TOURS',
  THE_GREAT_OUTDOORS = 'THE_GREAT_OUTDOORS',
  THRILL_SEEKER = 'THRILL_SEEKER',
  TICKETS = 'TICKETS',
  TOURS_ACTIVITIES = 'TOURS_ACTIVITIES',
  TOURS_SIGHTSEEING = 'TOURS_SIGHTSEEING',
  TRANSPORTATION_SERVICES = 'TRANSPORTATION_SERVICES',
  TREAT_YOURSELF = 'TREAT_YOURSELF',
  TUBING = 'TUBING',
  UNIVERSAL_THEME_PARKS = 'UNIVERSAL_THEME_PARKS',
  VALENTINES_DAY = 'VALENTINES_DAY',
  WALKING_BIKE_TOURS = 'WALKING_BIKE_TOURS',
  WALKING_TOURS = 'WALKING_TOURS',
  WATERSKIING_WAKEBOARDING = 'WATERSKIING_WAKEBOARDING',
  WATER_ACTIVITIES = 'WATER_ACTIVITIES',
  WATER_PARKS = 'WATER_PARKS',
  WEDDING_CEREMONIES = 'WEDDING_CEREMONIES',
  WEDDING_HONEYMOON = 'WEDDING_HONEYMOON',
  WEDDING_PACKAGES = 'WEDDING_PACKAGES',
  WEDDING_SHONEYMOONS = 'WEDDING_SHONEYMOONS',
  WHAT_TO_DO_WITH_GROUPS = 'WHAT_TO_DO_WITH_GROUPS',
  WHAT_TO_DO_WITH_KIDS = 'WHAT_TO_DO_WITH_KIDS',
  WHITE_WATER_RAFTING = 'WHITE_WATER_RAFTING',
  WILDLIFE_NATURE = 'WILDLIFE_NATURE',
  WINE_TASTING_WINERY_TOURS = 'WINE_TASTING_WINERY_TOURS',
  WINTER_ACTIVITIES = 'WINTER_ACTIVITIES',
  YOGA_CLASS = 'YOGA_CLASS',
  YOGA_CLASSES = 'YOGA_CLASSES',
  ZOO_TICKETS = 'ZOO_TICKETS',
  ZOO_TICKETS_PASSES = 'ZOO_TICKETS_PASSES',
}

export enum ActivityCategoryType {
  ACTIVITIES = 'ACTIVITIES',
  CATEGORIES = 'CATEGORIES',
  DEALS_PROMOTIONS = 'DEALS_PROMOTIONS',
  NA = 'NA',
  RECOMMENDATIONS = 'RECOMMENDATIONS',
  TOURS = 'TOURS',
  TRANSPORTATION = 'TRANSPORTATION',
}

export interface ActivityDateRangeInput {
  endDate: DateInput;
  startDate: DateInput;
}

/** Activity search region information */
export interface ActivityDestinationInput {
  /** Coordinates of the region, used for region (city or multicity) resolution */
  coordinates?: InputMaybe<CoordinatesInput>;
  /** activity id proposed for pinning on LX-SRP */
  pinnedActivityId?: InputMaybe<Scalars['String']>;
  /** activity id passed as a reference for activity recommendations on LX-IS */
  referencedActivityId?: InputMaybe<Scalars['String']>;
  /** Gaia region ID of the search */
  regionId?: InputMaybe<Scalars['String']>;
  /** Name of the region, used for fuzzy resolution */
  regionName?: InputMaybe<Scalars['String']>;
  /** Gaia Region Type denoted by regionId, example HOTEL OR CITY */
  regionType?: InputMaybe<Scalars['String']>;
}

/** Details view options that are not filters */
export enum ActivityDetailViewOptions {
  NON_CONSOLIDATED_OFFERS = 'NON_CONSOLIDATED_OFFERS',
  SHOP_WITH_POINTS = 'SHOP_WITH_POINTS',
  THIRD_PARTY_REVIEWS = 'THIRD_PARTY_REVIEWS',
}

export enum ActivityDiscountType {
  AIR_ATTACH_MIP = 'AIR_ATTACH_MIP',
  AIR_HOTEL_ATTACH_MIP = 'AIR_HOTEL_ATTACH_MIP',
  CAMPAIGN_DEAL = 'CAMPAIGN_DEAL',
  FREE_ACTIVITY = 'FREE_ACTIVITY',
  GUEST = 'GUEST',
  HOTEL_ATTACH_MIP = 'HOTEL_ATTACH_MIP',
  MIP = 'MIP',
  MOD = 'MOD',
  STRIKE_OUT = 'STRIKE_OUT',
}

export enum ActivityGroupType {
  ACTIVITY_LIST = 'ACTIVITY_LIST',
  ACTIVITY_MESSAGE = 'ACTIVITY_MESSAGE',
  AVAILABLE_TODAY = 'AVAILABLE_TODAY',
  CATEGORY = 'CATEGORY',
  FILTERED_ACTIVITIES = 'FILTERED_ACTIVITIES',
  INTERESTS = 'INTERESTS',
  KEYWORD_SEARCH = 'KEYWORD_SEARCH',
  MORE_ACTIVITIES = 'MORE_ACTIVITIES',
  NEIGHBOURHOOD = 'NEIGHBOURHOOD',
  PINNED_ACTIVITY = 'PINNED_ACTIVITY',
  POI = 'POI',
  POI_ACTIVITY_CAROUSEL = 'POI_ACTIVITY_CAROUSEL',
  RECOMMENDATIONS = 'RECOMMENDATIONS',
  SLIM_CATEGORY = 'SLIM_CATEGORY',
  SUB_CATEGORIES = 'SUB_CATEGORIES',
  SUB_CATEGORY = 'SUB_CATEGORY',
  SWP_SORT_SECTION = 'SWP_SORT_SECTION',
  TOP_ACTIVITIES = 'TOP_ACTIVITIES',
  TRIPS_ACTIVITY_LIST = 'TRIPS_ACTIVITY_LIST',
  XSELL_RECOMMENDATIONS = 'XSELL_RECOMMENDATIONS',
}

export enum ActivityGroupViewType {
  ACTIVITY_LIST = 'ACTIVITY_LIST',
  ACTIVITY_POI_TILES_CAROUSEL = 'ACTIVITY_POI_TILES_CAROUSEL',
  ACTIVITY_SPANNED_TILE_LIST = 'ACTIVITY_SPANNED_TILE_LIST',
  ACTIVITY_TILES_CAROUSEL = 'ACTIVITY_TILES_CAROUSEL',
  CATEGORY_TILES_CAROUSEL = 'CATEGORY_TILES_CAROUSEL',
  KEYWORD_SEARCH = 'KEYWORD_SEARCH',
  MESSAGE = 'MESSAGE',
  SLIM_CATEGORY_TILES_CAROUSEL = 'SLIM_CATEGORY_TILES_CAROUSEL',
  TEXT = 'TEXT',
}

export enum ActivityImmersiveViewNavigationType {
  SWIPE_HORIZONTAL = 'SWIPE_HORIZONTAL',
  SWIPE_VERTICAL = 'SWIPE_VERTICAL',
}

export enum ActivityMapGroupType {
  POI = 'POI',
}

/** Activity marketing information to identify sem/seo traffic */
export interface ActivityMarketingInfoInput {
  /** Marketing channel type code. */
  mctc?: InputMaybe<Scalars['Int']>;
  /** field which identifies sem channel */
  sem?: InputMaybe<Scalars['String']>;
  /** field which identifies semdtl value */
  semdtl?: InputMaybe<Scalars['String']>;
}

/** Unique identifier for a message if one needs to identify the reason for the message creation */
export enum ActivityMessageType {
  ADDON = 'ADDON',
  EARN_2X_REWARD_POINTS = 'EARN_2X_REWARD_POINTS',
  GIFTING_LX_BANNER = 'GIFTING_LX_BANNER',
  LOGIN = 'LOGIN',
  SOURCED_CAMPAIGN = 'SOURCED_CAMPAIGN',
  SUMMER_CAMPAIGN_PRIMARY = 'SUMMER_CAMPAIGN_PRIMARY',
  SUMMER_CAMPAIGN_SECONDARY = 'SUMMER_CAMPAIGN_SECONDARY',
}

/** Minimum set of data used to retrieve details about an activity product */
export interface ActivityNaturalKeyInput {
  offerToken: Scalars['String'];
  productToken: Scalars['String'];
}

export interface ActivityOfferFilterInput {
  selections?: InputMaybe<Array<ActivitySelectedValueInput>>;
  tickets?: InputMaybe<Array<ActivityTicketInput>>;
}

/** Data used to retrieve details about an activity product */
export interface ActivityOfferNaturalKeyInput {
  /** Offer Product Natural Key for offer entity which uniquely determines bookable offer of activity. This includes, site id, Offer id, Offer dates, offer locale, total travelers selected to uniquely identify an offer */
  offerProductNaturalKey: Scalars['String'];
}

export enum ActivityOfferUDSToken {
  SELECTED = 'SELECTED',
  UNSELECTED = 'UNSELECTED',
}

/** Activity page Meta Tag types - NamedMetaTag, PropertyMetaTag and so on */
export enum ActivityPageMetaTagType {
  HTTP_EQUIV = 'HTTP_EQUIV',
  NAME = 'NAME',
  PROPERTY = 'PROPERTY',
}

/** Activity Page Type - infosite */
export enum ActivityPageType {
  ACTIVITY_INFO = 'ACTIVITY_INFO',
}

/** Activity Price types */
export enum ActivityPriceType {
  GROUP = 'GROUP',
  NORMAL = 'NORMAL',
  VOLUME_BASED = 'VOLUME_BASED',
}

/** Federation type representing set of fields */
export interface ActivityProductInfoInput {
  offerToken: Scalars['String'];
}

/** enum of actions where the button click can take the user to. This can be used in UI to decide the action for button click. */
export enum ActivityProgressionBarAction {
  PDP = 'PDP',
  REVIEWS = 'REVIEWS',
  TRAVEL_GUIDE = 'TRAVEL_GUIDE',
}

export enum ActivityRedemptionType {
  PRINT = 'PRINT',
  VOUCHER_LESS = 'VOUCHER_LESS',
}

export enum ActivityReviewSort {
  HIGHEST_TO_LOWEST_RATED = 'HIGHEST_TO_LOWEST_RATED',
  LOWEST_TO_HIGHEST_RATED = 'LOWEST_TO_HIGHEST_RATED',
  NEWEST_TO_OLDEST = 'NEWEST_TO_OLDEST',
}

/** Allow to define a period of time to search for activities */
export interface ActivitySearchCriteriaDateRangeInput {
  endDate: DateInput;
  startDate: DateInput;
}

/** Region information for an activity search */
export interface ActivitySearchCriteriaLocationInput {
  /** Coordinates of the region, used for region (city or multicity) resolution */
  coordinates?: InputMaybe<CoordinatesInput>;
  /** activity id proposed for pinning on LX-SRP */
  pinnedActivityId?: InputMaybe<Scalars['String']>;
  /** activity id passed as a reference for activity recommendations on LX-IS */
  referencedActivityId?: InputMaybe<Scalars['String']>;
  /** Gaia region ID of the search */
  regionId?: InputMaybe<Scalars['String']>;
  /** Name of the region, used for fuzzy resolution */
  regionName?: InputMaybe<Scalars['String']>;
  /** Gaia Region Type denoted by regionId, example HOTEL OR CITY */
  regionType?: InputMaybe<Scalars['String']>;
}

/** Activity search filtering options */
export interface ActivitySearchFiltersInput {
  /** Filter results by user selected activity id from ESS activity Typeahead Suggestions. */
  activityId?: InputMaybe<Scalars['String']>;
  /** Filter results by user regionId to support neighborhood filters */
  regionId?: InputMaybe<Scalars['String']>;
  /**
   * Value selected by the user
   *     E.g.
   *     1. 'sort':'RECOMMENDED'
   *     2. 'slimSearchKeyword':'<KEYWORD ENTERED BY USER>'
   *     4. 'categories': 'ToursSightseeing'
   */
  selections?: InputMaybe<Array<ActivitySelectedValueInput>>;
}

/** Search options that are not filters */
export enum ActivitySearchOptions {
  /** @deprecated using ActivityGroupType now for filtering Activity Groups */
  CATEGORY = 'CATEGORY',
  FILTER_NESTED_CATEGORIES = 'FILTER_NESTED_CATEGORIES',
  GAIA_RETURN_ADDITIONAL_DISTANCE_PARAMETER = 'GAIA_RETURN_ADDITIONAL_DISTANCE_PARAMETER',
  GIFTING_ACTIVITIES = 'GIFTING_ACTIVITIES',
  /** @deprecated Guest Promotion is always true */
  GUEST_PROMO = 'GUEST_PROMO',
  NON_CONSOLIDATED_OFFERS = 'NON_CONSOLIDATED_OFFERS',
  SHOP_WITH_POINTS = 'SHOP_WITH_POINTS',
  SHOW_GT_BANNER = 'SHOW_GT_BANNER',
}

/** Search view options that are not filters */
export enum ActivitySearchViewOptions {
  DISTANCE_FROM_HOTEL_TO_ACTIVITY = 'DISTANCE_FROM_HOTEL_TO_ACTIVITY',
  FILTER_NESTED_CATEGORIES = 'FILTER_NESTED_CATEGORIES',
  NEARBY_ACTIVITIES = 'NEARBY_ACTIVITIES',
  SHOP_WITH_POINTS = 'SHOP_WITH_POINTS',
  SHOW_GT_BANNER = 'SHOW_GT_BANNER',
  THIRD_PARTY_REVIEWS = 'THIRD_PARTY_REVIEWS',
  TRAVEL_DISTANCE_FROM_HOTEL = 'TRAVEL_DISTANCE_FROM_HOTEL',
}

export interface ActivitySelectedValueInput {
  id: Scalars['String'];
  value: Scalars['String'];
}

/** Activity sort types */
export enum ActivitySort {
  CAMPAIGN_DEALS = 'CAMPAIGN_DEALS',
  DISCOUNT = 'DISCOUNT',
  DISTANCE_FROM_HOTEL = 'DISTANCE_FROM_HOTEL',
  PRICE_HIGH_TO_LOW = 'PRICE_HIGH_TO_LOW',
  PRICE_LOW_TO_HIGH = 'PRICE_LOW_TO_HIGH',
  RECOMMENDED = 'RECOMMENDED',
}

export enum ActivityTextAlignment {
  CENTRE = 'CENTRE',
  LEFT = 'LEFT',
  RIGHT = 'RIGHT',
}

export enum ActivityTextSize {
  LARGE = 'LARGE',
  MEDIUM = 'MEDIUM',
  SMALL = 'SMALL',
}

export interface ActivityTicketInput {
  code: Scalars['String'];
  count: Scalars['Int'];
}

/** Details of traveler with a specific age. Age will be used to derive the traveler type in package bookings */
export interface ActivityTravelerDetailsInput {
  /** Age of the traveler. Traveler type(adult/infant/youth) can be derived from age */
  age: Scalars['Int'];
  /** Number of travelers with specified age */
  count: Scalars['Int'];
}

/** Container of traveler information */
export interface ActivityTravelerInfoInput {
  /** number of adults from Hotel PDP */
  numberOfAdults: Scalars['Int'];
  /** number of children from Hotel PDP */
  numberOfChildren: Scalars['Int'];
  /** number of infants from Hotel PDP */
  numberOfInfants: Scalars['Int'];
}

export enum ActivityUDSToken {
  MULTI_SELECT_LIST = 'MULTI_SELECT_LIST',
  MULTI_SELECT_RANGE = 'MULTI_SELECT_RANGE',
  SINGLE_SELECT = 'SINGLE_SELECT',
  TEXT = 'TEXT',
}

/** Input to update the activity in the session */
export interface ActivityUpdateInput {
  newActivity: ActivityNaturalKeyInput;
  oldActivity: ActivityNaturalKeyInput;
}

/** Details of package traveler with a adult count and child ages. */
export interface ActivityXsellTravelerInfoInput {
  /** Number of adults in the xsell activity booking */
  adults: Scalars['Int'];
  /** List of ages of children in the xsell activity booking */
  childAges: Array<Scalars['Int']>;
}

/** Enum representing the flow of handling an ad copy */
export enum AdCopyHandleFlow {
  /** Represents the approval flow */
  APPROVED = 'APPROVED',
  /** Represents the rejection flow */
  DENIED = 'DENIED',
}

/** Ad Copy Input */
export interface AdCopyInput {
  /** Content id */
  contentId?: InputMaybe<Scalars['UUID']>;
  /** Ad content for a Flight ad */
  fslContent?: InputMaybe<FlightCreativeInput>;
  /** Ad content has been updated */
  isUpdated: Scalars['Boolean'];
  /** Ad content languages */
  languages: Array<Scalars['String']>;
  /** Ad content for a Lodging ad */
  lslContent?: InputMaybe<LodgingCreativeInput>;
}

export interface AdCopyReviewTableRequestInput {
  endDate?: InputMaybe<DateInput>;
  language?: InputMaybe<Scalars['String']>;
  nextCursor?: InputMaybe<Scalars['String']>;
  partnerAccountIdSearch?: InputMaybe<Scalars['String']>;
  partnerAccountNameSearch?: InputMaybe<Scalars['String']>;
  previousCursor?: InputMaybe<Scalars['String']>;
  resultsPerPage: Scalars['Int'];
  searchInput?: InputMaybe<Scalars['String']>;
  selectedSearchParameter?: InputMaybe<AdCopySearchFilters>;
  sortBy?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<DateInput>;
}

export enum AdCopySearchFilters {
  CAMPAIGN_ID = 'CAMPAIGN_ID',
  CAMPAIGN_NAME = 'CAMPAIGN_NAME',
  PROPERTY_ID = 'PROPERTY_ID',
  PROPERTY_NAME = 'PROPERTY_NAME',
}

/** Input for ad copy validation checks */
export interface AdCopyValidationInput {
  adCopies: Array<AdCopyValidationListItemInput>;
}

/** Input item for ad copy validation checks */
export interface AdCopyValidationListItemInput {
  adId: Scalars['String'];
  description: Scalars['String'];
  headline: Scalars['String'];
  language: Scalars['String'];
}

export enum AdCreativeType {
  CAR_BRAND_RESULT_LISTING = 'CAR_BRAND_RESULT_LISTING',
  DESTINATION_EXPERIENCE_GALLERY = 'DESTINATION_EXPERIENCE_GALLERY',
  FLIGHT_BRAND_RESULT_LISTING = 'FLIGHT_BRAND_RESULT_LISTING',
  FLIGHT_INTERSTITIAL = 'FLIGHT_INTERSTITIAL',
  LODGING_BRAND_RESULT_LISTING = 'LODGING_BRAND_RESULT_LISTING',
  MARQUEE_CARD = 'MARQUEE_CARD',
  PARTNER_GALLERY = 'PARTNER_GALLERY',
}

/** Bid Modifier Input */
export interface AdGroupBidModifierInput {
  /** Bid Modifier List */
  bidModifierList?: InputMaybe<Array<BidModifierInput>>;
  /** Bid Modifier Updated */
  isUpdated: Scalars['Boolean'];
}

/** Campaign wizard ad group input */
export interface AdGroupInput {
  /** Ad group ads */
  ads: Array<AdInput>;
  /** Ad group bid modifiers */
  bidModifiers?: InputMaybe<Array<AdGroupWizardBidModifierInput>>;
  hydrated: Scalars['Boolean'];
  /** Ad group id.  Includes temp if it is a new ad group */
  id: Scalars['String'];
  /** Ad group paused */
  isPaused: Scalars['Boolean'];
  /** Ad group locations to target */
  locations?: InputMaybe<Array<Scalars['String']>>;
  /** Ad group name */
  name: Scalars['String'];
  /** Ad group targetings */
  targetings?: InputMaybe<AdGroupWizardTargetingInput>;
}

/** Ad Group Request Inputs */
export interface AdGroupRequestInput {
  /** Ad Group Bid Modifiers */
  adGroupBidModifiers?: InputMaybe<AdGroupBidModifierInput>;
  /** Ad Group Id */
  adGroupId?: InputMaybe<Scalars['UUID']>;
  /** Ad Group Name */
  adGroupName: Scalars['String'];
  /** Ad Group Targeting */
  adGroupTargeting: AdGroupTargetingInput;
  /** Campaign Ad list */
  adList: Array<AdRequestInput>;
  /** Ad Group dates updated */
  datesUpdated?: InputMaybe<Scalars['Boolean']>;
  /** Ad Group End Date */
  endDate?: InputMaybe<Scalars['String']>;
  /** Ad Group status */
  isPaused?: InputMaybe<Scalars['Boolean']>;
  /** Test */
  isUpdated: Scalars['Boolean'];
  /** Ad Group Start Date */
  startDate?: InputMaybe<Scalars['String']>;
}

/** Ad Group Targeting Inputs */
export interface AdGroupTargetingInput {
  /** Targeting locations */
  bookingPathList?: InputMaybe<Array<TargetingInput>>;
  /** Locations updated */
  bookingPathsUpdated?: InputMaybe<Scalars['Boolean']>;
  /** Targeting list */
  deviceList?: InputMaybe<Array<TargetingInput>>;
  /** Targeting updated */
  devicesUpdated?: InputMaybe<Scalars['Boolean']>;
  /** Targeting locations */
  locationList: Array<TargetingInput>;
  /** Locations updated */
  locationsUpdated: Scalars['Boolean'];
  /** Targeting property id */
  productId: TargetingInput;
}

/** Ad group wizard bid modifier input */
export interface AdGroupWizardBidModifierInput {
  /** wizard bid modifier value */
  coefficient: Scalars['Float'];
  /** wizard bid modifier targeting criteria */
  targetingCriteria: Scalars['String'];
  /** wizard bid modifier targeting end value */
  targetingEndValue?: InputMaybe<Scalars['String']>;
  /** wizard bid modifier targeting operator */
  targetingOperator?: InputMaybe<Scalars['String']>;
  /** wizard bid modifier targeting start value */
  targetingStartValue?: InputMaybe<Scalars['String']>;
  /** wizard bid modifier targeting value */
  targetingValue: Scalars['String'];
}

/** Ad group wizard targeting */
export interface AdGroupWizardTargetingInput {
  /** Ad group booking path targeting */
  bookingPaths?: InputMaybe<Array<WizardTargetingInput>>;
  /** Ad group device targeting */
  devices?: InputMaybe<Array<WizardTargetingInput>>;
  /** Ad group location targeting */
  locations?: InputMaybe<Array<WizardTargetingInput>>;
}

/** Campaign wizard ad input */
export interface AdInput {
  /** Content image can be overridden */
  canOverrideImage: Scalars['Boolean'];
  /** Ad content */
  content: ContentInput;
  hydrated: Scalars['Boolean'];
  /** Ad id.  Includes temp if it is a new ad */
  id: Scalars['String'];
  /** Ad paused */
  isPaused: Scalars['Boolean'];
  /** Ad name */
  name: Scalars['String'];
}

/** Ad Request Input */
export interface AdRequestInput {
  /** Ad creative */
  adCopy: AdCopyInput;
  /** Ad Id */
  adId?: InputMaybe<Scalars['UUID']>;
  /** Ad Name */
  adName: Scalars['String'];
  /** Ad status */
  isPaused?: InputMaybe<Scalars['Boolean']>;
  /** Ad has been updated */
  isUpdated: Scalars['Boolean'];
}

export enum AdType {
  FLIGHT_SPONSORED_LISTING = 'FLIGHT_SPONSORED_LISTING',
  LODGING_BRAND_RESULT_LISTING = 'LODGING_BRAND_RESULT_LISTING',
  LODGING_SPONSORED_LISTING = 'LODGING_SPONSORED_LISTING',
  UNKNOWN = 'UNKNOWN',
}

/** Describes what kind of action being described. Copy for example describes the coupon code copy behavior. Authwindow shows the login/signup dialog. */
export enum AddOnRequested {
  CB1 = 'CB1',
  COB = 'COB',
  SC = 'SC',
}

/** Represents multi-participant chat experience add participant to conversation input */
export interface AddParticipantsToConversationInput {
  /** Represents the conversation id */
  conversationId: Scalars['String'];
  /** Represents the tripId */
  tripId: Scalars['String'];
}

/** Represents the additional change query params */
export interface AdditionalChangeQueryParamsInput {
  /** Represents the intended itinerary number to change */
  itineraryNumber?: InputMaybe<Scalars['String']>;
  /** Represents the virtual agent token which is used for exchange of information */
  opaqueToken?: InputMaybe<Scalars['String']>;
}

/** represents additional data for submitPayment */
export interface AdditionalDataInput {
  paymentReferenceId: Scalars['String'];
}

export interface AdditionalOnboardingContextInput {
  cmsToken?: InputMaybe<Scalars['String']>;
  isFirstAppLaunch?: InputMaybe<Scalars['Boolean']>;
  madCustomerPlacementId?: InputMaybe<Scalars['String']>;
  originUrl?: InputMaybe<Scalars['String']>;
  scenario?: InputMaybe<Scalars['String']>;
}

/** Allow to define a period of time to search for activities */
export interface AdditionalProductsInput {
  /** Represents the information of the activity products */
  activityProductInfos?: InputMaybe<Array<ActivityProductInfoInput>>;
  /** Represents the type of operation to be performed on Journey Continuation Id for all the provided Additional Products */
  additionalProductsOperationType: AdditionalProductsOperationType;
}

/** Represents the type of mutation to be performed on JCID with the additional Products */
export enum AdditionalProductsOperationType {
  ADD = 'ADD',
  REMOVE = 'REMOVE',
}

export enum AdditionalShoppedAncillaries {
  FIRST_CHECKED_BAG = 'FIRST_CHECKED_BAG',
}

export enum AdditionalShopping {
  FIRST_CHECKED_BAG = 'FIRST_CHECKED_BAG',
}

export interface AdjustmentBreakdownItemInput {
  adjustmentAmountType: Scalars['String'];
  adjustmentType: AdjustmentType;
  amount: Scalars['Float'];
  date?: InputMaybe<DateInput>;
}

export enum AdjustmentType {
  Nightly = 'Nightly',
  PerStay = 'PerStay',
  PreviouslyWithheldRefund = 'PreviouslyWithheldRefund',
}

/** Request used to create Financial Profile */
export interface AdvertiserBillingProfileCreateUpdateRequestInput {
  billingProfile?: InputMaybe<AdvertiserBillingProfileDetailInput>;
  id: Scalars['String'];
  keyMap: PartnerBillingProfileKeyMapInput;
  type: PaymentPartnerType;
}

/** used to make billing profile of the partner */
export interface AdvertiserBillingProfileDetailInput {
  paymentMethod?: InputMaybe<Scalars['String']>;
  paymentTerm?: InputMaybe<Scalars['String']>;
  walletItems: Array<AdvertiserBillingProfileWalletObjectInput>;
}

export interface AdvertiserBillingProfileWalletObjectInput {
  keyMap: WalletsMapInput;
  walletExtensions?: InputMaybe<Array<BillingProfileMapExtInput>>;
}

/** Advertiser Scope type for email */
export interface AdvertiserEmailScopeInput {
  /** Partner account ID */
  partner_account_id: Scalars['String'];
  /** Product ID */
  product_id: Scalars['String'];
}

/** Advertiser subscription type for email */
export interface AdvertiserEmailSubscriptionTypeInput {
  /** Category type */
  category: Scalars['String'];
  /** Channel type */
  channel: Scalars['String'];
  /** Opt-in status */
  optInStatus: Scalars['Boolean'];
  /** Scope type */
  scope: AdvertiserEmailScopeInput;
}

export enum AdvertiserLineType {
  DEFAULT = 'DEFAULT',
  FPAAS = 'FPAAS',
  MESO = 'MESO',
  MESO_ONBOARDING = 'MESO_ONBOARDING',
  TA = 'TA',
}

export enum AdvertiserPortalPageInput {
  ONBOARDING = 'ONBOARDING',
  STANDALONE = 'STANDALONE',
}

export enum AdvertiserPortalResponseStatus {
  FAILURE = 'FAILURE',
  SUCCESS = 'SUCCESS',
}

export enum AdvertiserReportingContext {
  FLIGHTS = 'FLIGHTS',
  LODGING_SPONSORED_LISTINGS = 'LODGING_SPONSORED_LISTINGS',
}

export enum AdvertiserReportingGroupBy {
  AD = 'AD',
  AD_GROUP = 'AD_GROUP',
  CAMPAIGN = 'CAMPAIGN',
  COUNTRY_CODE = 'COUNTRY_CODE',
  PERIOD = 'PERIOD',
  PRODUCT_ID = 'PRODUCT_ID',
}

export enum AdvertiserReportingLevel {
  AD = 'AD',
  AD_GROUP = 'AD_GROUP',
  CAMPAIGN = 'CAMPAIGN',
  CAMPAIGN_AND_AD_GROUP = 'CAMPAIGN_AND_AD_GROUP',
}

export interface AdvertiserReportingOptionsInput {
  adGroupIds?: InputMaybe<Array<Scalars['UUID']>>;
  adIds?: InputMaybe<Array<Scalars['UUID']>>;
  campaignIds?: InputMaybe<Array<Scalars['UUID']>>;
  countryCodePOS?: InputMaybe<Array<Scalars['String']>>;
  endDate: DateInput;
  groupBy?: InputMaybe<Array<AdvertiserReportingGroupBy>>;
  pageAfter?: InputMaybe<Scalars['Int']>;
  period?: InputMaybe<Scalars['String']>;
  productIds?: InputMaybe<Array<Scalars['String']>>;
  reportLevel?: InputMaybe<AdvertiserReportingLevel>;
  sortBy?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<Scalars['String']>;
  startDate: DateInput;
}

export interface AdvertiserTaxInfoInput {
  key: Scalars['String'];
  value: Scalars['String'];
}

/** Configuration for Adyen(FOP) */
export interface AdyenPaymentConfigInput {
  redirectResult?: InputMaybe<Scalars['String']>;
}

/** Represents the addOrRemoveAffiliatesCollectionItem mutation request */
export interface AffiliatesAddOrRemoveCollectionItemRequestInput {
  /** Represents the list of collectionIds to which the item needs to be added */
  collectionIdsForAdd: Array<Scalars['String']>;
  /** Represents the list of collection items from which the item needs to be removed */
  collectionItemsForRemove: Array<AffiliatesCollectionItemIdentifierInput>;
  itemRequest: AffiliatesCollectionItemRequestInput;
}

export interface AffiliatesAutoSaveCouponRequestInput {
  inputs?: InputMaybe<Array<GraphQLPairInput>>;
  partnerIdentifier: Scalars['String'];
}

export enum AffiliatesChannelType {
  ANDROID = 'ANDROID',
  IOS = 'IOS',
  WEB = 'WEB',
}

export enum AffiliatesCheckFailureType {
  PARTNER_NOT_LINKED = 'PARTNER_NOT_LINKED',
  STATUS_NOT_APPROVED = 'STATUS_NOT_APPROVED',
  TOOL_DISABLED = 'TOOL_DISABLED',
}

/** Represents client input to decide if and how the stripe toolbar will be displayed on the traveller sites */
export interface AffiliatesClientContextInput {
  deviceContext?: InputMaybe<AffiliatesDeviceContextInput>;
  lineOfBusiness: LineOfBusinessDomain;
  pageId?: InputMaybe<Scalars['String']>;
  pageLocation: PageLocation;
  partnerContext?: InputMaybe<AffiliatesPartnerContextInput>;
}

/** Represents the affiliatesCreatorTooling.collectionDetails query request */
export interface AffiliatesCollectionDetailsRequestInput {
  /** Use if collectionId is empty string */
  collectionHandle?: InputMaybe<Scalars['String']>;
  collectionId: Scalars['String'];
  /** Use to validate access - Optional as this would only be needed for web where url is visible on browser */
  creatorHandle?: InputMaybe<Scalars['String']>;
}

/** Represents an affiliate collection item for removal */
export interface AffiliatesCollectionItemIdentifierInput {
  collectionId: Scalars['String'];
  itemId: Scalars['String'];
}

/** Represents the input for requests that contain collection item association */
export interface AffiliatesCollectionItemRequestInput {
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  productImageReference?: InputMaybe<Scalars['String']>;
  propertyContext?: InputMaybe<AffiliatesPropertyContextInput>;
  targetUrl?: InputMaybe<Scalars['String']>;
}

/** Represents the createAffiliateTag mutation request */
export interface AffiliatesCreateAffiliateTagRequestInput {
  journeyContext?: InputMaybe<AffiliatesJourneyContextInput>;
  userText: Scalars['String'];
}

/** Represents the createAffiliatesCollection mutation request */
export interface AffiliatesCreateCollectionRequestInput {
  description?: InputMaybe<Scalars['String']>;
  /** Auto-create item and add to the newly created collection */
  itemRequest?: InputMaybe<AffiliatesCollectionItemRequestInput>;
  name: Scalars['String'];
  visibilityType: Scalars['String'];
}

/** Represents the createAffiliateCustomLink mutation request. Returns AffiliatesCreateCustomLinkResponse */
export interface AffiliatesCreateCustomLinkRequestInput {
  journeyContext?: InputMaybe<AffiliatesJourneyContextInput>;
  propertyContext?: InputMaybe<AffiliatesPropertyContextInput>;
  targetUrl: Scalars['String'];
  userText?: InputMaybe<Scalars['String']>;
}

/** Represents the createAffiliateLink mutation request and response types */
export interface AffiliatesCreateLinkRequestInput {
  journeyContext?: InputMaybe<AffiliatesJourneyContextInput>;
  propertyContext?: InputMaybe<AffiliatesPropertyContextInput>;
  targetUrl: Scalars['String'];
}

/** Represents the createAffiliateVanityLink mutation request */
export interface AffiliatesCreateVanityLinkRequestInput {
  propertyContext?: InputMaybe<AffiliatesPropertyContextInput>;
  targetUrl: Scalars['String'];
  userText: Scalars['String'];
}

export enum AffiliatesCuratedTripItineraryItemType {
  ACTIVITY = 'ACTIVITY',
  LODGING = 'LODGING',
  POI = 'POI',
  RESTAURANT = 'RESTAURANT',
}

export interface AffiliatesCuratedTripRequestInput {
  creatorHandle: Scalars['String'];
  curatedTripHandle: Scalars['String'];
}

/** Represents the deleteAffiliatesCollection mutation request */
export interface AffiliatesDeleteCollectionRequestInput {
  collectionId: Scalars['String'];
}

export enum AffiliatesDestinationType {
  CITY = 'CITY',
  COUNTRY = 'COUNTRY',
  NEIGHBORHOOD = 'NEIGHBORHOOD',
  PROVINCE = 'PROVINCE',
}

/** Represents client input to inform of device information from which the request was sent */
export interface AffiliatesDeviceContextInput {
  appVersion?: InputMaybe<Scalars['String']>;
  channelType?: InputMaybe<AffiliatesChannelType>;
}

/** Represents the editAffiliatesCollectionItem mutation request */
export interface AffiliatesEditCollectionItemRequestInput {
  collectionId: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  itemId: Scalars['String'];
  productImageReference?: InputMaybe<Scalars['String']>;
}

/** Represents the editAffiliatesCollection mutation request */
export interface AffiliatesEditCollectionRequestInput {
  collectionId: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  visibilityType?: InputMaybe<Scalars['String']>;
}

export interface AffiliatesEnrollEnterpriseCampaignRequestInput {
  /** Represents the unique identifier associates with the user's claim status for the given campaign. */
  campaignEnrollmentIdentifier?: InputMaybe<Scalars['String']>;
  /** Represents the unique identifier for the campaign */
  campaignIdentifier: Scalars['String'];
  partnerIdentifier: Scalars['String'];
}

/** Represents the generateAffiliatesVideoUploadUrl mutation request */
export interface AffiliatesGenerateVideoUploadUrlRequestInput {
  contentType: Scalars['String'];
  fileName: Scalars['String'];
  thumbnailContentType?: InputMaybe<Scalars['String']>;
}

export interface AffiliatesGetCampaignAndUserClaimStatusRequestInput {
  additionalAttributes?: InputMaybe<Array<GraphQLPairInput>>;
  /** Represents the unique identifier associates with the user's claim status for the given campaign. */
  campaignEnrollmentIdentifier?: InputMaybe<Scalars['String']>;
  /** Represents the unique identifier for the campaign */
  campaignIdentifier: Scalars['String'];
  partnerIdentifier: Scalars['String'];
}

/** Represents the affiliatesCreatorTooling.getCollectionForm query request */
export interface AffiliatesGetCollectionFormRequestInput {
  creatorHandle: Scalars['String'];
}

export enum AffiliatesIconPlacement {
  LEADING = 'LEADING',
  TRAILING = 'TRAILING',
}

/** Represents the affiliatesCreatorTooling.initiateAddOrRemoveCollectionItem query request */
export interface AffiliatesInitiateAddOrRemoveCollectionItemRequestInput {
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  propertyContext?: InputMaybe<AffiliatesPropertyContextInput>;
}

/** Represents the affiliatesCreatorTooling.initiateCollectionItem query request */
export interface AffiliatesInitiateCollectionItemRequestInput {
  collectionId?: InputMaybe<Scalars['String']>;
  itemId?: InputMaybe<Scalars['String']>;
  propertyContext?: InputMaybe<AffiliatesPropertyContextInput>;
}

/** Represents information related to journey details */
export interface AffiliatesJourneyContextInput {
  /** Represents user selected date range */
  inputDateRange: DateRangeInput;
}

export interface AffiliatesPartnerContextInput {
  /** Optional token containing Affiliates partnerId to simultaneously verify Identity and Affiliate accounts */
  token?: InputMaybe<Scalars['String']>;
}

/** Represents the pinAffiliatesCollectionItem mutation request */
export interface AffiliatesPinCollectionItemRequestInput {
  collectionId: Scalars['String'];
  pinnedItemId: Scalars['String'];
}

/** Represents the affiliatesCreatorTooling.previewCollection query request */
export interface AffiliatesPreviewCollectionRequestInput {
  collectionId: Scalars['String'];
}

/** Represents information used to identify contextual property */
export interface AffiliatesPropertyContextInput {
  /** Represents either property's ID in Expedia URL, or 'expediaPropertyId' query param in Hotels URL */
  egPropertyId?: InputMaybe<Scalars['String']>;
  /** Represents property's ID in Hotels URL */
  hotelsPropertyId?: InputMaybe<Scalars['String']>;
}

/** Represents the affiliatesStats query request */
export interface AffiliatesStatsRequestInput {
  propertyContext?: InputMaybe<AffiliatesPropertyContextInput>;
}

/** Represents the submitAffiliatesVideo mutation request */
export interface AffiliatesSubmitVideoRequestInput {
  consentForTravelVideoProgram?: InputMaybe<Scalars['Boolean']>;
  externalVideoUrl?: InputMaybe<Scalars['String']>;
  productId: Scalars['String'];
  thumbnailUploadReference?: InputMaybe<Scalars['String']>;
  uploadReference: Scalars['String'];
}

/** Represents the affiliatesToolboxMenu query request */
export interface AffiliatesToolboxMenuRequestInput {
  propertyContext?: InputMaybe<AffiliatesPropertyContextInput>;
}

/** Represents the affiliatesTravelerCollectionDetails query request */
export interface AffiliatesTravelerCollectionDetailsRequestInput {
  collectionHandle: Scalars['String'];
  creatorHandle: Scalars['String'];
}

/** Represents the affiliatesTravelerShopDetails query request */
export interface AffiliatesTravelerShopDetailsRequestInput {
  creatorHandle: Scalars['String'];
}

/** Represents the updateAffiliatesCollectionVisibility mutation request */
export interface AffiliatesUpdateCollectionVisibilityRequestInput {
  collectionId: Scalars['String'];
  visibilityType: Scalars['String'];
}

/** Represents the initiateAddOrRemoveCollectionItemValidation mutation request */
export interface AffiliatesValidateTextFieldRequestInput {
  /** Represents the description field to validate */
  description?: InputMaybe<Scalars['String']>;
}

/** Represents the affiliatesVideoUploadPropertyInfo query request when a user selects a property from the typeahead */
export interface AffiliatesVideoUploadPropertyInfoRequestInput {
  propertyId: Scalars['String'];
}

/** Represents the affiliatesVideoUploadForm query request */
export interface AffiliatesVideoUploadRequestInput {
  productId: Scalars['String'];
}

export enum AgencyBusinessModel {
  EXPEDIA_COLLECT = 'EXPEDIA_COLLECT',
  HOTEL_COLLECT = 'HOTEL_COLLECT',
}

export interface AgencyQuoteBuilderPropertyRateCardInput {
  businessModelType?: InputMaybe<BusinessModelType>;
  checkIn: DateInput;
  checkOut: DateInput;
  inventoryType: InventoryType;
  packageRate: Scalars['Boolean'];
  pricePerNight: Scalars['String'];
  priceTotal: Scalars['String'];
  propertyDestination: Scalars['String'];
  propertyId: Scalars['String'];
  propertyName: Scalars['String'];
  propertyType: Scalars['String'];
  ratePlanId: Scalars['String'];
  refundabilityType?: InputMaybe<RefundableType>;
  roomTypeDescription: Scalars['String'];
  roomTypeId: Scalars['String'];
  rooms: Array<PropertyRoomInput>;
  starRating?: InputMaybe<Scalars['Float']>;
}

export interface AgencyQuoteBuilderRateCardInput {
  propertyInput: AgencyQuoteBuilderPropertyRateCardInput;
}

export interface AgencyQuoteBuilderRemoveInput {
  all: Scalars['Boolean'];
  index?: InputMaybe<Scalars['Int']>;
}

/** Input for deleting quotes */
export interface AgencyQuoteDeleteInput {
  /** List of quote ids to delete */
  quoteIds: Array<Scalars['String']>;
}

/** Status of quotes delete */
export interface AgencyQuoteDeleteStatusInput {
  deletedCount: Scalars['Int'];
  isSuccessful: Scalars['Boolean'];
}

export interface AgencyQuoteListInput {
  /** Status and number of quotes deleted. */
  deleteStatus?: InputMaybe<AgencyQuoteDeleteStatusInput>;
  /** Page index */
  paginationIndex?: InputMaybe<Scalars['Int']>;
  /** Search string if we want to filter the agency quote list records */
  searchCriteria?: InputMaybe<Scalars['String']>;
  /** Information of the tab */
  selectedTab?: InputMaybe<Scalars['String']>;
  /** Field Id for sort */
  sortContentId?: InputMaybe<Scalars['String']>;
  /** Sort direction (ascending, descending) */
  sortType?: InputMaybe<AgencyQuoteListSortType>;
}

/** Parameters for header cells for the records to be sorted in ascending, descending or to be unsorted manner */
export enum AgencyQuoteListSortType {
  ASCENDING = 'ASCENDING',
  DESCENDING = 'DESCENDING',
  NOT_SORTED = 'NOT_SORTED',
}

export interface AgencyQuoteNaturalKeyInput {
  lodgingType: Scalars['String'];
  packageRates?: InputMaybe<Scalars['Boolean']>;
  propertyDestination: Scalars['String'];
  propertyNaturalKeys: Array<PropertyNaturalKeyInput>;
}

export interface AgencyQuoteSaveAgencyDetailInput {
  /** Address of the agency, line 1 */
  address1?: InputMaybe<Scalars['String']>;
  /** Address of the agency line 2 */
  address2?: InputMaybe<Scalars['String']>;
  /** Email of the agent */
  email: Scalars['String'];
  /** Name of the Agency */
  name?: InputMaybe<Scalars['String']>;
  /** Phone number associated with the agency */
  phone: Scalars['String'];
}

export interface AgencyQuoteSaveCardInput {
  /** Service charge for the agency */
  agencyServiceCharge?: InputMaybe<AgencyServiceChargeInput>;
  /** Destination of the travel */
  destination: Scalars['String'];
  /** Indicates state for hiding cancellation policy */
  hideCancellationState: Scalars['Boolean'];
  /** Indicates state for hiding price details */
  hidePriceState: Scalars['Boolean'];
  /** Expedia's line of businesses */
  lob: ExpLineOfBusiness;
  /** Natural key for input validation */
  naturalKey: AgencyQuoteNaturalKeyInput;
  /** Total price for the quote */
  totalPrice?: InputMaybe<Scalars['String']>;
}

export interface AgencyQuoteSaveInput {
  /** Agency details pulled from database */
  agencyInfo: AgencyQuoteSaveAgencyDetailInput;
  /** Message from the agent, to be added by the agent */
  agentMessage?: InputMaybe<Scalars['String']>;
  /** Details of the trip on quote, pulled from database */
  quoteCards: Array<AgencyQuoteSaveCardInput>;
  /** Autogenerated Unique Identifier for each quote. Could be Null for saving a quote after Update */
  quoteId?: InputMaybe<Scalars['String']>;
  /** Name of the quote, to be added by the agent */
  quoteName: Scalars['String'];
  /** Name of the Traveler, to be added by the agent */
  travelerName: Scalars['String'];
}

/** AgencyServiceChargeInput is used to specify the service charge details */
export interface AgencyServiceChargeInput {
  /** The base amount of the service charge */
  baseAmount: Scalars['Float'];
  /** The percentage amount of the service charge */
  percentageAmount: Scalars['Float'];
  /** The tax amount of the service charge */
  taxAmount?: InputMaybe<Scalars['Float']>;
}

/** The type of message line */
export enum AgencyServiceChargeMessageLineType {
  ERROR = 'ERROR',
  WARNING = 'WARNING',
}

export interface AgentQuoteNaturalKeyInput {
  packageRates?: InputMaybe<Scalars['Boolean']>;
  propertyDestination: Scalars['String'];
  propertyNaturalKeys: Array<PropertyNaturalKeyInput>;
}

export interface AgentStateInput {
  agentPresenceUri: Scalars['String'];
  localizedText?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  type: AgentStateType;
}

export enum AgentStateType {
  NotReady = 'NotReady',
  Offline = 'Offline',
  Ready = 'Ready',
}

export enum AgentToolsChannelType {
  CHAT = 'CHAT',
  EMAIL = 'EMAIL',
  SMS = 'SMS',
  VOICE = 'VOICE',
}

export interface AgentToolsExtraBedOptionsInput {
  extraAdultBedCount: Scalars['Int'];
  extraChildBedCount: Scalars['Int'];
  extraCribCount: Scalars['Int'];
}

export interface AgentToolsLodgingActionInput {
  payload?: InputMaybe<AgentToolsLodgingChangeActionPayloadInput>;
  type: AgentToolsLodgingActionType;
}

export enum AgentToolsLodgingActionType {
  Cancel = 'Cancel',
  DateChange = 'DateChange',
  DateOccupancyChange = 'DateOccupancyChange',
  OccupancyChange = 'OccupancyChange',
  RoomTypeChange = 'RoomTypeChange',
}

export interface AgentToolsLodgingChangeActionPayloadInput {
  checkInDate?: InputMaybe<DateInput>;
  checkOutDate?: InputMaybe<DateInput>;
  extraBedOptions?: InputMaybe<AgentToolsExtraBedOptionsInput>;
  homeCountryCode?: InputMaybe<Scalars['String']>;
  inventoryType: InventoryType;
  isMember?: InputMaybe<Scalars['Boolean']>;
  memberTiers?: InputMaybe<Array<Scalars['Int']>>;
  membershipLevel?: InputMaybe<Scalars['String']>;
  ratePlanId?: InputMaybe<Scalars['String']>;
  ratePlanType?: InputMaybe<Scalars['String']>;
  roomOccupancy?: InputMaybe<AgentToolsRoomOccupancyInput>;
  roomOptions?: InputMaybe<AgentToolsRoomOptionsInput>;
  roomTypeID?: InputMaybe<Scalars['String']>;
  shoppingPath?: InputMaybe<ShoppingPathType>;
}

export enum AgentToolsPaymentFlow {
  PAYMENT_ASSIST = 'PAYMENT_ASSIST',
  PAYMENT_VERIFICATION = 'PAYMENT_VERIFICATION',
}

export interface AgentToolsPenaltyWaiverInput {
  amount?: InputMaybe<Scalars['Float']>;
  waivingSource?: InputMaybe<WaivingSource>;
}

export interface AgentToolsRoomOccupancyInput {
  adultCount: Scalars['Int'];
  childAgeList: Array<Scalars['Int']>;
}

export interface AgentToolsRoomOptionsInput {
  accessibilityOptions?: InputMaybe<Array<Scalars['String']>>;
  bedSelected?: InputMaybe<Scalars['Int']>;
  bedSelectedInfo?: InputMaybe<BedSelectedInfoInput>;
  smokingTypeSelected?: InputMaybe<SmokingTypeSelectedInput>;
  specialRequest?: InputMaybe<Scalars['String']>;
}

export enum AgentToolsSummaryCardComponentType {
  FLIGHT_CANCEL = 'FLIGHT_CANCEL',
  LODGING_CANCEL = 'LODGING_CANCEL',
  LODGING_CHANGE = 'LODGING_CHANGE',
}

export interface AgentToolsTravellerContactInformationInput {
  email?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
}

/** Represents the entry point context that will be used to drive customization */
export interface AiAgentEntryPointContextInput {
  /** Represents the conversation type this entry point will trigger */
  conversationType: ConversationType;
  /** Represents the current page the entry points will be displayed on */
  pageName: Scalars['String'];
}

export interface AirTopRoutesTestContextInput {
  airline?: InputMaybe<AirTopRoutesTestDataInput>;
  destination?: InputMaybe<AirTopRoutesTestDataInput>;
  isDomesticOnly?: InputMaybe<Scalars['Boolean']>;
  origin?: InputMaybe<AirTopRoutesTestDataInput>;
}

export interface AirTopRoutesTestDataInput {
  type: AirTopRoutesTestType;
  value: Scalars['String'];
}

export enum AirTopRoutesTestType {
  AIRPORT = 'AIRPORT',
  METRO = 'METRO',
}

/** Airport location type chosen in flight search. */
export enum AirportLocationType {
  AIRPORT = 'AIRPORT',
  METROCODE = 'METROCODE',
  UNSPECIFIED = 'UNSPECIFIED',
}

export enum Alignment {
  BASELINE = 'BASELINE',
  CENTER = 'CENTER',
  LEADING = 'LEADING',
  LEFT = 'LEFT',
  RIGHT = 'RIGHT',
  TRAILING = 'TRAILING',
}

/** Represents payment method config */
export interface AllowedPaymentMethodConfigInput {
  disableStoredPaymentInstruments: Scalars['Boolean'];
}

/** Represents allowed payment method */
export interface AllowedPaymentMethodInput {
  paymentMethod: Scalars['String'];
  paymentMethodConfig: AllowedPaymentMethodConfigInput;
  paymentSubMethod: Scalars['String'];
}

/** Specifies the behavior of ALTER, which is used to run Abacus experiments on localization messages. */
export enum AlterMode {
  /** Localization messages will be replaced with their namespace and loc key. */
  DEBUG = 'DEBUG',
  /** None of the ALTER experiments will be used when resolving localization messages. */
  NONE = 'NONE',
  /** Both released and draft ALTER experiments will be used when resolving localization messages. */
  PREVIEW = 'PREVIEW',
  /** This is the default. Only released ALTER experiments will be used when resolving localization messages. */
  RELEASED = 'RELEASED',
}

/** List of all the managed link type. */
export enum AlternativeLinkType {
  ALTERNATIVE_ACCOMMODATION = 'ALTERNATIVE_ACCOMMODATION',
  ALTERNATIVE_LOBS = 'ALTERNATIVE_LOBS',
}

export enum AmenityCategory {
  ACCESSIBLE_ROLL_IN_SHOWER = 'ACCESSIBLE_ROLL_IN_SHOWER',
  AIR_CONDITIONING = 'AIR_CONDITIONING',
  ALL_INCLUSIVE = 'ALL_INCLUSIVE',
  ARCADE = 'ARCADE',
  BABYSITTING = 'BABYSITTING',
  BAR = 'BAR',
  BARBECUE = 'BARBECUE',
  BOWLING = 'BOWLING',
  BREAKFAST_AVAILABLE = 'BREAKFAST_AVAILABLE',
  BREAKFAST_INCLUDED = 'BREAKFAST_INCLUDED',
  BREAKFAST_NOT_AVAILABLE = 'BREAKFAST_NOT_AVAILABLE',
  BUSINESS_SERVICES = 'BUSINESS_SERVICES',
  CHILDREN_CLUB = 'CHILDREN_CLUB',
  DAILY_HOUSEKEEPING = 'DAILY_HOUSEKEEPING',
  EXTRA_BED = 'EXTRA_BED',
  FIRE_PLACE = 'FIRE_PLACE',
  FITNESS_EQUIPMENT = 'FITNESS_EQUIPMENT',
  FREE_AIRPORT_TRANSPORTATION = 'FREE_AIRPORT_TRANSPORTATION',
  FREE_BREAKFAST = 'FREE_BREAKFAST',
  FREE_CANCEL = 'FREE_CANCEL',
  FREE_PARKING = 'FREE_PARKING',
  FREE_WELCOME_DRINK = 'FREE_WELCOME_DRINK',
  FREE_WIRED_INTERNET = 'FREE_WIRED_INTERNET',
  FRONT_DESK_24_HOURS = 'FRONT_DESK_24_HOURS',
  GROCERY = 'GROCERY',
  HIGH_SPEED_INTERNET = 'HIGH_SPEED_INTERNET',
  HOT_TUB = 'HOT_TUB',
  INTERNET_NOT_AVAILABLE = 'INTERNET_NOT_AVAILABLE',
  IN_ROOM_INTERNET = 'IN_ROOM_INTERNET',
  KIDS_POOL = 'KIDS_POOL',
  KITCHEN = 'KITCHEN',
  LAUNDRY = 'LAUNDRY',
  LIVING_AREA = 'LIVING_AREA',
  MICROWAVE = 'MICROWAVE',
  MINI_GOLF = 'MINI_GOLF',
  NON_REFUNDABLE = 'NON_REFUNDABLE',
  ON_PRIVATE_BEACH = 'ON_PRIVATE_BEACH',
  ON_THE_BEACH = 'ON_THE_BEACH',
  OUTDOOR_SPACE = 'OUTDOOR_SPACE',
  PARKING = 'PARKING',
  PARTIAL_REFUND = 'PARTIAL_REFUND',
  PETS_ALLOWED = 'PETS_ALLOWED',
  PLAYGROUND = 'PLAYGROUND',
  POOL = 'POOL',
  RESERVE_NOW_PAY_DEPOSIT = 'RESERVE_NOW_PAY_DEPOSIT',
  RESERVE_NOW_PAY_LATER = 'RESERVE_NOW_PAY_LATER',
  RESTAURANT_IN_HOTEL = 'RESTAURANT_IN_HOTEL',
  ROOM_SERVICE = 'ROOM_SERVICE',
  SMOKE_FREE = 'SMOKE_FREE',
  SOUNDPROOF_ROOM = 'SOUNDPROOF_ROOM',
  SPA_SERVICES_ON_SITE = 'SPA_SERVICES_ON_SITE',
  SPECIAL_DEAL = 'SPECIAL_DEAL',
  TENNIS_COURT = 'TENNIS_COURT',
  TOYS = 'TOYS',
  WASHER = 'WASHER',
  WATERSLIDE = 'WATERSLIDE',
  WIFI_SURCHARGE = 'WIFI_SURCHARGE',
  WIRED_INTERNET_SURCHARGE = 'WIRED_INTERNET_SURCHARGE',
}

export enum AmenityFilter {
  CARRY_ON_BAG = 'CARRY_ON_BAG',
  INVALID = 'INVALID',
  NO_CANCEL_FEE = 'NO_CANCEL_FEE',
  NO_CHANGE_FEE = 'NO_CHANGE_FEE',
  SEAT_CHOICE = 'SEAT_CHOICE',
}

export interface AmountPaidInput {
  actionType?: InputMaybe<Scalars['String']>;
  orderLineGuid?: InputMaybe<Scalars['String']>;
  orderNumber: Scalars['String'];
}

export enum AnalyticsKey {
  /** Represents the analytics key for number of bags per traveller */
  NUMBER_OF_BAGS = 'NUMBER_OF_BAGS',
  /** Represents the analytics key for piece or weight selling model criteria analytics per traveller */
  PIECE_OR_WEIGHT_CONCEPT = 'PIECE_OR_WEIGHT_CONCEPT',
  /** Represents the analytics key for quantity of bags per traveller (NONE/SOME/ALL) */
  QUANTITY_OF_BAGS = 'QUANTITY_OF_BAGS',
}

/** Address type with minimal data required */
export interface AncillaryContentInput {
  ancillaryToken: Scalars['String'];
}

/** Represents per journey ancillary selection */
export interface AncillaryJourneySelectionsInput {
  /** Represents the journey index for which the selection is applicable */
  journeyIndex: Scalars['Int'];
  /** Represents flight journey status */
  journeyStatus?: InputMaybe<FlightJourneyStatus>;
  /** Represents the list of per traveller selection */
  travellerAncillarySelections: Array<TravellerAncillarySelectionInput>;
}

/** Represents path plus page for where ancillaries will be shopped. */
export enum AncillaryShoppingPath {
  PACKAGE_INFOSITE = 'PACKAGE_INFOSITE',
  PACKAGE_TRIPS = 'PACKAGE_TRIPS',
  STANDALONE_INFOSITE = 'STANDALONE_INFOSITE',
  STANDALONE_SEARCH = 'STANDALONE_SEARCH',
  STANDALONE_TRIPS = 'STANDALONE_TRIPS',
}

export enum AnnualSummaryCardId {
  END_TRANSITION = 'END_TRANSITION',
  INTRO_TRENDS_1 = 'INTRO_TRENDS_1',
  INTRO_TRENDS_2 = 'INTRO_TRENDS_2',
  INTRO_TRENDS_3 = 'INTRO_TRENDS_3',
  INTRO_TRENDS_4 = 'INTRO_TRENDS_4',
  INTRO_TRENDS_5 = 'INTRO_TRENDS_5',
  LOOK_FORWARD_DEST1 = 'LOOK_FORWARD_DEST1',
  LOOK_FORWARD_DEST2 = 'LOOK_FORWARD_DEST2',
  LOOK_FORWARD_DEST3 = 'LOOK_FORWARD_DEST3',
  LOOK_FORWARD_LANDING = 'LOOK_FORWARD_LANDING',
  LOOK_FORWARD_TRANSITION = 'LOOK_FORWARD_TRANSITION',
  PLAYBACK_FLIGHTS = 'PLAYBACK_FLIGHTS',
  PLAYBACK_MAPS = 'PLAYBACK_MAPS',
  PLAYBACK_MONTH = 'PLAYBACK_MONTH',
  PLAYBACK_PERCENTILE_FLIGHTS = 'PLAYBACK_PERCENTILE_FLIGHTS',
  PLAYBACK_PERCENTILE_STAYS = 'PLAYBACK_PERCENTILE_STAYS',
  PLAYBACK_SHARE = 'PLAYBACK_SHARE',
  PLAYBACK_SINGLE_TRIP_COVER = 'PLAYBACK_SINGLE_TRIP_COVER',
  PLAYBACK_SINGLE_TRIP_DESTINATION = 'PLAYBACK_SINGLE_TRIP_DESTINATION',
  PLAYBACK_STAYS = 'PLAYBACK_STAYS',
  PLAYBACK_TRANSITION = 'PLAYBACK_TRANSITION',
  RECS_1 = 'RECS_1',
  RECS_2 = 'RECS_2',
  RECS_3 = 'RECS_3',
  RECS_TRANSITION = 'RECS_TRANSITION',
}

export enum AnnualSummaryPageType {
  HOME_PAGE = 'HOME_PAGE',
  PROFILE_PAGE = 'PROFILE_PAGE',
}

export enum AnnualSummaryPlayBackSummaryType {
  MULTIPLE_TRIPS = 'MULTIPLE_TRIPS',
  ONE_TRIP = 'ONE_TRIP',
}

/** Represents a section type in the annual summary */
export enum AnnualSummarySectionType {
  END = 'END',
  INTRO_TRENDS = 'INTRO_TRENDS',
  LOOK_FORWARD = 'LOOK_FORWARD',
  PLAYBACK = 'PLAYBACK',
  RECS = 'RECS',
}

export enum AppGrowthBorderShape {
  ROUNDED = 'ROUNDED',
  SQUARE = 'SQUARE',
}

export enum AppGrowthBorderStyle {
  BOLD = 'BOLD',
  DEFAULT = 'DEFAULT',
  NONE = 'NONE',
}

export enum AppGrowthLineOfBusiness {
  ACTIVITIES = 'ACTIVITIES',
  CAR = 'CAR',
  CRUISES = 'CRUISES',
  DEFAULT = 'DEFAULT',
  FLIGHT = 'FLIGHT',
  GROUNDTRANSFERS = 'GROUNDTRANSFERS',
  HOTEL = 'HOTEL',
  PACKAGES = 'PACKAGES',
  RAILS = 'RAILS',
  UNCLASSIFIED = 'UNCLASSIFIED',
}

export enum AppGrowthToolbarIcon {
  BACK = 'BACK',
  CLOSE = 'CLOSE',
}

export enum AppGrowthToolbarStyle {
  TRANSPARENT_ACTION_OVERLAY = 'TRANSPARENT_ACTION_OVERLAY',
}

/** type of action being performed */
export enum AppGrowthUIActionName {
  /** accept - used for notification prompt */
  ACCEPT = 'ACCEPT',
  /** should perform a deeplink action */
  DEEPLINK = 'DEEPLINK',
  /** deny - used for notification prompt */
  DENY = 'DENY',
  /** exit travel trivia to app home */
  EXIT_TO_APP_HOME = 'EXIT_TO_APP_HOME',
  /** go to dashboard action */
  GOTO_DASHBOARD = 'GOTO_DASHBOARD',
  /** login and signup */
  LOGIN_AND_SIGNUP = 'LOGIN_AND_SIGNUP',
  /** no action to perform - used then object sometimes has an action and other times doesn't */
  NONE = 'NONE',
  /** ok action */
  OK = 'OK',
  /** share action */
  SHARE = 'SHARE',
  /** signup for travel trivia campaign */
  SIGNUP = 'SIGNUP',
  /** submit trivia answer */
  TRIVIA_ANSWER = 'TRIVIA_ANSWER',
  /** finish the trivia */
  TRIVIA_END = 'TRIVIA_END',
  /** go to trivia how to play */
  TRIVIA_HOW_TO = 'TRIVIA_HOW_TO',
  /** move to next trivia question */
  TRIVIA_NEXT = 'TRIVIA_NEXT',
  /** go to trivia start */
  TRIVIA_START = 'TRIVIA_START',
}

/** Input for applyOpportunity mutation */
export interface ApplyOpportunityInput {
  /** Operations for apply opportunities */
  operations: Array<ApplyOpportunityOperationInput>;
}

/** Operation for applyOpportunity mutation */
export interface ApplyOpportunityOperationInput {
  /** Campaign id */
  campaignId: Scalars['String'];
  /** Campaign name */
  campaignName: Scalars['String'];
  /** Recommendation id */
  recommendationId: Scalars['String'];
  /** Updated bidding strategy */
  updatedBiddingStrategy?: InputMaybe<Scalars['String']>;
  /** Updated budget */
  updatedBudget?: InputMaybe<Scalars['Float']>;
}

export interface ApplyPaymentMethodRequestInput {
  checkoutSessionMode?: InputMaybe<CheckoutSessionMode>;
  paymentMethod: PaymentMethodInput;
  sessionId: Scalars['String'];
  sessionToken: Scalars['String'];
}

export enum ApprovalStatusType {
  APPROVED = 'APPROVED',
  DENIED = 'DENIED',
  PENDING = 'PENDING',
  UNKNOWN = 'UNKNOWN',
}

export interface ApproverInput {
  contact: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  title: Scalars['String'];
}

export interface ArithmeticOperationsCriteriaInput {
  /** Represents the input numbers to be operated upon */
  inputNumbers: Array<Scalars['Float']>;
  /** The operation to be performed */
  operation: Operation;
}

export enum ArticleSearchType {
  CONTEXTUAL_FOLLOW_UP = 'CONTEXTUAL_FOLLOW_UP',
  GENERIC = 'GENERIC',
  /** @deprecated LLM search is deprecated and replaced with Intelligent Search */
  LLM = 'LLM',
}

/** Possible aspect ratios of EGDS images */
export enum AspectRatio {
  /** Aspect ratio 4:1 */
  FOUR_ONE = 'FOUR_ONE',
  /** Aspect ratio 4:3 */
  FOUR_THREE = 'FOUR_THREE',
  /** Aspect ratio 1:1 */
  ONE_ONE = 'ONE_ONE',
  /** Aspect ratio 16:9 */
  SIXTEEN_NINE = 'SIXTEEN_NINE',
  /** Aspect ratio 3:4 */
  THREE_FOUR = 'THREE_FOUR',
  /** Aspect ratio 3:2 */
  THREE_TWO = 'THREE_TWO',
  /** Aspect ratio 21:9 */
  TWENTY_ONE_NINE = 'TWENTY_ONE_NINE',
}

/** Input to update the associated products with the partner account */
export interface AssociatedAdvertiserPortalProductUpdateInput {
  /** Partner account ID */
  partnerAccountId: Scalars['String'];
  /** List of product IDs */
  productsIds: Array<Scalars['String']>;
}

export enum AtoChallengePlacement {
  DirectFeedbackSubmitFormAction = 'DirectFeedbackSubmitFormAction',
}

export interface AtoChallengeValidationInput {
  captchaToken?: InputMaybe<Scalars['String']>;
}

/** Enum defining the event categories for attach analytics. */
export enum AttachAnalyticEventType {
  IMPRESSION = 'IMPRESSION',
  INTERACTION = 'INTERACTION',
}

/** Enum defining the UI types for attach components. */
export enum AttachUIType {
  /** UI containing header, booked CTAs, and product CTAs */
  ATTACH_UI_1 = 'ATTACH_UI_1',
  /** UI containing only product CTAs */
  ATTACH_UI_2 = 'ATTACH_UI_2',
}

/** Attachment file */
export interface AttachmentFileInput {
  /** File Name */
  fileName: Scalars['String'];
  /** File Data Chunk */
  url: Scalars['String'];
}

export enum AuthStepIdentifier {
  ACCOUNT_MERGE = 'ACCOUNT_MERGE',
  ADD_PHONE = 'ADD_PHONE',
  CREATE_PASSWORD = 'CREATE_PASSWORD',
  MARKETING_CONSENT = 'MARKETING_CONSENT',
  ONE_KEY = 'ONE_KEY',
  ORIGIN = 'ORIGIN',
  PROFILE_DETAILS = 'PROFILE_DETAILS',
  UPSERT_PASSWORD = 'UPSERT_PASSWORD',
}

export interface AuthenticateUsingSocialSDKRequestInput {
  atoInputs?: InputMaybe<Array<IdentityAccountTakeOverInput>>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  loginEntryPoint?: InputMaybe<LoginEntryPoint>;
  nonce?: InputMaybe<Scalars['String']>;
  socialType?: InputMaybe<IdentitySocialType>;
  token?: InputMaybe<Scalars['String']>;
  tokenType?: InputMaybe<IdentitySocialTokenType>;
}

/** Represents authentication configuration */
export interface AuthenticationConfigInput {
  /** Represents a JWT token retrieved from the IAM Token API */
  authToken?: InputMaybe<Scalars['String']>;
  /** Represents a unique channel origin id per chat experience */
  channelOriginId?: InputMaybe<Scalars['String']>;
}

export enum AuthenticationFlowVariant {
  /** DEFAULT will be used when we want AuthenticationFlowVariant to be server driven */
  DEFAULT = 'DEFAULT',
  EMAIL_OTP_DEFAULT = 'EMAIL_OTP_DEFAULT',
  EMAIL_OTP_WITH_PHONE_AUTH = 'EMAIL_OTP_WITH_PHONE_AUTH',
  PASSWORD_DEFAULT = 'PASSWORD_DEFAULT',
  PASSWORD_WITH_PHONE_AUTH = 'PASSWORD_WITH_PHONE_AUTH',
  SMS_OTP_DEFAULT = 'SMS_OTP_DEFAULT',
}

export enum AuthenticationState {
  ANONYMOUS = 'ANONYMOUS',
  AUTHENTICATED = 'AUTHENTICATED',
  IDENTIFIED = 'IDENTIFIED',
}

/** supported sizes of avatars */
export enum AvatarSize {
  LARGE = 'LARGE',
  MEDIUM = 'MEDIUM',
  SMALL = 'SMALL',
  XLARGE = 'XLARGE',
}

export interface BabyQuipCarouselRequestInput {
  encodedTripItemId?: InputMaybe<Scalars['String']>;
  tripId: Scalars['String'];
  tripsScreen: TripsScreen;
}

/** Background styles for the cards */
export enum BackgroundType {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
}

export enum BadgeIcon {
  ACCESS_TIME = 'ACCESS_TIME',
  ADD = 'ADD',
  BUNDLED_SAVINGS_PLUS = 'BUNDLED_SAVINGS_PLUS',
  EXP29639_ORB = 'EXP29639_ORB',
  FAMILY_FRIENDLY = 'FAMILY_FRIENDLY',
  INFO_OUTLINE = 'INFO_OUTLINE',
  LOB_DEALS = 'LOB_DEALS',
  LOCAL_OFFER = 'LOCAL_OFFER',
  MOD = 'MOD',
  SMARTPHONE = 'SMARTPHONE',
}

/** Possible aspect ratios of EGDS images */
export enum BaggageType {
  /** Baggage type for carry bag */
  CARRY_BAG = 'CARRY_BAG',
  /** Baggage type for checked bag */
  CHECKED_BAG = 'CHECKED_BAG',
  /** Baggage type for Personal item */
  PERSONAL_ITEM = 'PERSONAL_ITEM',
  /** Default value for baggage type */
  UNKNOWN = 'UNKNOWN',
}

/** Represents the quantity of bags to be sent in analytics none/some/all */
export enum BagsSelectionType {
  ALL = 'ALL',
  NONE = 'NONE',
  SOME = 'SOME',
}

/** BankAccountType */
export enum BankAccountType {
  CHECKING = 'CHECKING',
  SAVINGS = 'SAVINGS',
}

export enum BannerActivity {
  DISMISSED = 'DISMISSED',
}

/** Context for fetching banners */
export interface BannerContextInput {
  /** Page ID where the banner is displayed */
  pageId: Scalars['String'];
  /** Product context for the banner */
  productContext: ProductContext;
}

export enum BannerDisplayType {
  ERROR = 'ERROR',
  INFO = 'INFO',
  NO_BANNER = 'NO_BANNER',
  WARN = 'WARN',
}

export enum BannerLocation {
  HOME = 'HOME',
  TRIP_CONFIRMATION = 'TRIP_CONFIRMATION',
  TRIP_LIST = 'TRIP_LIST',
}

export enum BannerTag {
  AD = 'AD',
  AD_GROUP = 'AD_GROUP',
  CAMPAIGN = 'CAMPAIGN',
}

export enum BannerTheme {
  BRAND_PROMO_PRIMARY = 'BRAND_PROMO_PRIMARY',
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
}

export enum BannerThemes {
  CRITICAL = 'CRITICAL',
  ERROR = 'ERROR',
}

export enum BannerType {
  ERROR = 'ERROR',
  INFO = 'INFO',
}

export interface BedSelectedInfoInput {
  bedSelectedId: Scalars['String'];
  name: Scalars['String'];
}

/** Bid Modifier Input */
export interface BidModifierInput {
  /** Bid Modifier Id */
  bidModifierId?: InputMaybe<Scalars['UUID']>;
  /** Bid Modifier Coefficient */
  coefficient: Scalars['Float'];
  /** Bid Modifier Targeting Criteria */
  targetingCriteria: Scalars['String'];
  /** Bid Modifier Targeting Operator */
  targetingOperator?: InputMaybe<Scalars['String']>;
  /** Bid Modifier Targeting Value */
  targetingValue: Scalars['String'];
}

/** Bidding structure for campaigns */
export interface BiddingStructureInput {
  /** Campaign base bid amount */
  baseBidAmount?: InputMaybe<MoneyBidAmountStructureInput>;
  /** Campaign market goal */
  marketGoal?: InputMaybe<MarketGoal>;
  /** Campaign maximize units */
  maximizeUnits?: InputMaybe<Scalars['Boolean']>;
  /** Campaign target roas */
  targetRoas?: InputMaybe<Scalars['Int']>;
}

export interface BillingProfileByProductIdQueryParamsInput {
  pageSize?: InputMaybe<Scalars['Int']>;
  pageToken?: InputMaybe<Scalars['Int']>;
  productId?: InputMaybe<Scalars['String']>;
  resourceId?: InputMaybe<Scalars['String']>;
}

/** used to make billing profile of the partner */
export interface BillingProfileDetailInput {
  paymentMethod?: InputMaybe<Scalars['String']>;
  paymentTerm?: InputMaybe<Scalars['String']>;
  walletItems: Array<BillingProfileWalletObjectInput>;
}

export interface BillingProfileFormRequestInput {
  billingProfileQueryParams: BillingProfileByProductIdQueryParamsInput;
  paymentPartner: PaymentPartnerInput;
}

export interface BillingProfileMapExtInput {
  attributeName: Scalars['String'];
  attributeValue: Scalars['String'];
}

export interface BillingProfileWalletObjectInput {
  keyMap: WalletMapInput;
  walletExtensions?: InputMaybe<Array<BillingProfileMapExtInput>>;
}

export interface BinDetailsConfigurationInput {
  clientDetails: ClientDetailsInput;
  fopItems: Array<OneCPMFOPItemInput>;
  paymentSessionId: Scalars['String'];
}

export interface BookingChangeFlightInput {
  /** Represents the air record locator for the flight that needs to be changed */
  airRecordLocator?: InputMaybe<Scalars['String']>;
  /** Represents the virtual agent domain or Web domain */
  client?: InputMaybe<BookingServicingClient>;
  /** ConversationId for virtual agent */
  conversationId?: InputMaybe<Scalars['String']>;
  /** Represents the new flight search criteria */
  flightSearchCriteria?: InputMaybe<FlightSearchCriteriaInput>;
  /** opaqueId for virtual agent */
  opaqueId?: InputMaybe<Scalars['String']>;
  /** Represents the old flight and traveler selection that needs to be changed */
  selectedChanges?: InputMaybe<Array<BookingServicingChangeSelectionInput>>;
  /** Represents the tripId for the flight that needs to be changed */
  tripId: Scalars['String'];
  /** Represents the trip item id for the flight that needs to be changed */
  tripItemId?: InputMaybe<Scalars['String']>;
  /** Represents the trip view id for the flight that needs to be changed */
  tripViewId?: InputMaybe<Scalars['String']>;
}

export interface BookingDetailsInput {
  /** Reservation ID */
  reservationId?: InputMaybe<Scalars['String']>;
  /** Trip ID */
  tripId?: InputMaybe<Scalars['String']>;
}

export interface BookingOptionsInput {
  checkInTime?: InputMaybe<Scalars['String']>;
  checkOutTime?: InputMaybe<Scalars['String']>;
  maxLengthOfStay?: InputMaybe<Scalars['Int']>;
  maxMonthsBeforeBooking?: InputMaybe<Scalars['Int']>;
  minDaysBeforeBooking?: InputMaybe<Scalars['Int']>;
  minNights?: InputMaybe<Scalars['Int']>;
}

/** Inputs for BookingServicing queries that contains flight change or cancellation information */
export interface BookingServicingAcceptFlightInput {
  /** Represents the air record locator for the BookingServicing query input */
  airRecordLocator: Scalars['String'];
  /** Represents the obid for the accept query input */
  obid?: InputMaybe<Scalars['String']>;
  /** Represents the tripId for the query input */
  tripId: Scalars['String'];
  /** Represents the tripItemId for the query input */
  tripItemId?: InputMaybe<Scalars['String']>;
  /** Represents the tripViewId for the query input */
  tripViewId?: InputMaybe<Scalars['String']>;
}

/** Represents the views that the accept path supports */
export enum BookingServicingAcceptViews {
  CONFIRMATION = 'CONFIRMATION',
  HEADS_UP = 'HEADS_UP',
  REVIEW = 'REVIEW',
}

/** Represents the flights input for the additional information query */
export interface BookingServicingAdditionalInformationFlightsInput {
  /** Represents the air record locator for the additional information query input */
  airRecordLocator?: InputMaybe<Scalars['String']>;
  /** Represents the obid for the additional information query input */
  obid?: InputMaybe<Scalars['String']>;
  /** Represents the tripId for the additional information query input */
  tripId?: InputMaybe<Scalars['String']>;
  /** Represents the tripItemId for the additional information query input */
  tripItemId?: InputMaybe<Scalars['String']>;
  /** Represents the tripViewId for the additional information query input */
  tripViewId?: InputMaybe<Scalars['String']>;
}

/** Represents the input for the additional information query */
export interface BookingServicingAdditionalInformationInput {
  flightInputs?: InputMaybe<BookingServicingAdditionalInformationFlightsInput>;
}

export enum BookingServicingButtonModifier {
  /** The button renders disabled while the action is being loaded from a parent component. */
  ACTION_LAZY_LOADED = 'ACTION_LAZY_LOADED',
}

/** Represents criteria input containing info about trip for cancel query */
export interface BookingServicingCancelCriteriaInput {
  /** Represents the cancel query input */
  flightsCriteriaInput: BookingServicingCancelFlightInput;
}

/** Represents info about trip for cancel query input */
export interface BookingServicingCancelFlightInput {
  /** Represents the air record locator for the cancel query input */
  airRecordLocator?: InputMaybe<Scalars['String']>;
  /** Represents the type of cancellation being performed by the traveler */
  cancelType: BookingServicingCancelType;
  /** Represents the obid for the cancel query input */
  obid?: InputMaybe<Scalars['String']>;
  /** Represents the tripId for the cancel query input */
  tripId: Scalars['String'];
  /** Represents the tripItemId for the cancel query input */
  tripItemId?: InputMaybe<Scalars['String']>;
  /** Represents the tripViewId for the cancel query input */
  tripViewId?: InputMaybe<Scalars['String']>;
  /** Represents the state of cache being used on web client */
  useCache?: InputMaybe<Scalars['Boolean']>;
}

/** The path for cancellation that will be performed by the traveler */
export enum BookingServicingCancelType {
  /** Represents the type for Involuntary/ASC Cancel */
  INVOLUNTARY = 'INVOLUNTARY',
  /** Represents the type for Voluntary Cancel */
  VOLUNTARY = 'VOLUNTARY',
}

/** Represents the views that the cancellation path supports */
export enum BookingServicingCancelViews {
  CONFIRMATION = 'CONFIRMATION',
  HEADS_UP = 'HEADS_UP',
  REVIEW = 'REVIEW',
}

export enum BookingServicingCardTheme {
  /** Represents negative theme for the BookingServicingCard */
  NEGATIVE = 'NEGATIVE',
}

/** Represents the information about the flight and traveler selections that need to be changed */
export interface BookingServicingChangeCriteriaInput {
  /** Represents the information about the flight  and traveler selections that need to be changed */
  flightsInput?: InputMaybe<BookingChangeFlightInput>;
}

/** Renamed to BookingServicingChangeLodgingErrorInput for naming consistency - will delete after loding error page migration */
export interface BookingServicingChangeErrorInput {
  /** adults count for virtual agent */
  adults?: InputMaybe<Scalars['String']>;
  /** URL for the back button navigation */
  backNavigation?: InputMaybe<Scalars['String']>;
  /** Lodging change page the error occurred on */
  changeType?: InputMaybe<Scalars['String']>;
  /** ISO format date */
  checkInDate?: InputMaybe<Scalars['String']>;
  /** ISO format date */
  checkOutDate?: InputMaybe<Scalars['String']>;
  /** children count for virtual agent */
  children?: InputMaybe<Scalars['String']>;
  /** Error description for Uis Prime analytics */
  errorMessage?: InputMaybe<Scalars['String']>;
  errorType?: InputMaybe<Scalars['String']>;
  /** itinerary number for virtual agent */
  itineraryNumber?: InputMaybe<Scalars['String']>;
}

export interface BookingServicingChangeLodgingErrorInput {
  /** adults count for virtual agent */
  adults?: InputMaybe<Scalars['String']>;
  /** URL for the back button navigation */
  backNavigation?: InputMaybe<Scalars['String']>;
  /** Lodging change page the error occurred on */
  changeType?: InputMaybe<Scalars['String']>;
  /** ISO format date */
  checkInDate?: InputMaybe<Scalars['String']>;
  /** ISO format date */
  checkOutDate?: InputMaybe<Scalars['String']>;
  /** children count for virtual agent */
  children?: InputMaybe<Scalars['String']>;
  /** children ages for search button */
  childrenAges?: InputMaybe<Array<Scalars['String']>>;
  /** Error description for Uis Prime analytics */
  errorMessage?: InputMaybe<Scalars['String']>;
  errorType?: InputMaybe<Scalars['String']>;
  /** itinerary number for virtual agent */
  itineraryNumber?: InputMaybe<Scalars['String']>;
  /** region id for search button */
  regionId?: InputMaybe<Scalars['String']>;
}

/** Input for various Booking Servicing Change queries */
export interface BookingServicingChangeLodgingInput {
  orderLineGuid: Scalars['String'];
  orderNumber: Scalars['String'];
  tripId: Scalars['String'];
}

/** Represents the views the change lodging path supports */
export enum BookingServicingChangeLodgingViews {
  TRAVELER_DETAILS = 'TRAVELER_DETAILS',
}

/** Represents the information about the booking and traveler selections that need to be modified */
export interface BookingServicingChangeSelectionCriteriaInput {
  /** Represents the information about the flight booking and traveler selections that need to be modified */
  flightInputs?: InputMaybe<BookingServicingFlightChangeSelectionInput>;
  /** Represents the information about the lodging booking and traveler selections that need to be modified */
  lodgingInputs?: InputMaybe<BookingServicingLodgingChangeSelectionInput>;
}

export interface BookingServicingChangeSelectionInput {
  name: Scalars['String'];
  value: Scalars['String'];
}

/** Represents the views that the change path supports */
export enum BookingServicingChangeViews {
  CHANGE_FORM = 'CHANGE_FORM',
}

export enum BookingServicingClient {
  /** Represents virtual agent domain */
  VIRTUAL_AGENT = 'VIRTUAL_AGENT',
  /** Represents VNEXT domain */
  VNEXT = 'VNEXT',
  /** Represents web domain */
  WEB = 'WEB',
}

export interface BookingServicingConfirmationInput {
  flightConfirmationInput?: InputMaybe<BookingServicingFlightInput>;
  lodgingConfirmationInput?: InputMaybe<BookingServicingLodgingConfirmationInput>;
}

/** Represents info about trip for details query input */
export interface BookingServicingDetailsFlightInput {
  /** Represents the air record locator for the details query input */
  airRecordLocator?: InputMaybe<Scalars['String']>;
  /** Represents the encoded OBID for the flight booking */
  obid?: InputMaybe<Scalars['String']>;
  /** Represents the tripId for the details query input */
  tripId: Scalars['String'];
  /** Represents the tripItemId for the details query input */
  tripItemId?: InputMaybe<Scalars['String']>;
  /** Represents the tripViewId for the details query input */
  tripViewId?: InputMaybe<Scalars['String']>;
}

/** Represents criteria input containing info about trip for details query */
export interface BookingServicingDetailsInput {
  /** Represents the details query input */
  flightsCriteriaInput?: InputMaybe<BookingServicingDetailsFlightInput>;
}

/** Represents the requirement to decide the view for the details query input */
export enum BookingServicingDetailsStrategy {
  /** Represents the booking details view when we need the details collapsed in an expando */
  BOOKING_COLLAPSED_DETAILS = 'BOOKING_COLLAPSED_DETAILS',
  /** Represents the booking details view for the details query input */
  BOOKING_DETAILS = 'BOOKING_DETAILS',
  /** Represents the booking and price details view for the details query input */
  BOOKING_PRICE_DETAILS = 'BOOKING_PRICE_DETAILS',
}

/** Represents the different types of dialog behaviors */
export enum BookingServicingDialogActionType {
  CLOSE = 'CLOSE',
  OPEN = 'OPEN',
  TOGGLE = 'TOGGLE',
}

/** Represents the type of validation to be performed */
export enum BookingServicingDynamicConditionValidation {
  /** Represents if we need to validate a equal to validation */
  EQUAL = 'EQUAL',
}

/** Represents the input state */
export enum BookingServicingDynamicState {
  /** The input is hidden */
  HIDDEN = 'HIDDEN',
  /** The input is rendered */
  VISIBLE = 'VISIBLE',
}

export enum BookingServicingExternalComponents {
  ADDITIONAL_INFORMATION = 'ADDITIONAL_INFORMATION',
  CURRENT_FLIGHT_DETAILS = 'CURRENT_FLIGHT_DETAILS',
  FLIGHT_FARE_INFORMATION = 'FLIGHT_FARE_INFORMATION',
  FLIGHT_PRICE_SUMMARY = 'FLIGHT_PRICE_SUMMARY',
  NEW_FLIGHT_DETAILS = 'NEW_FLIGHT_DETAILS',
  PARTNER_LOYALTY_EARN_MESSAGE = 'PARTNER_LOYALTY_EARN_MESSAGE',
  TRAVELERS_PLAYBACK = 'TRAVELERS_PLAYBACK',
}

/** Response context for the direct word survey params */
export interface BookingServicingFeedbackInput {
  eid?: InputMaybe<Scalars['String']>;
  itineraryNumber?: InputMaybe<Scalars['String']>;
  pagename?: InputMaybe<Scalars['String']>;
  tripId?: InputMaybe<Scalars['String']>;
  tuid?: InputMaybe<Scalars['String']>;
}

export interface BookingServicingFlightChangeSelectionInput {
  /** Represents the journey input for the change selection input */
  journeyCriteriaInput?: InputMaybe<Array<FlightsJourneyCriteriaInput>>;
  /** Represent the original booking id */
  obid: Scalars['String'];
  /** Represent the selected leg for change selection */
  selectedLeg?: InputMaybe<Array<Scalars['Int']>>;
}

/** Represents the criteria input for a flight heads up page */
export interface BookingServicingFlightHeadsUpCriteriaInput {
  /** Represents the air record locator for the heads up query input */
  airRecordLocator?: InputMaybe<Scalars['String']>;
  /** Represents the obid for the heads up query input */
  obid?: InputMaybe<Scalars['String']>;
  /** Represents the tripId for the heads up query input */
  tripId?: InputMaybe<Scalars['String']>;
  /** Represents the tripItemId for the heads up query input */
  tripItemId?: InputMaybe<Scalars['String']>;
  /** Represents the tripViewId for the heads up query input */
  tripViewId?: InputMaybe<Scalars['String']>;
}

/** Represents the input for a flight page */
export interface BookingServicingFlightInput {
  airRecordLocator?: InputMaybe<Scalars['String']>;
  obid?: InputMaybe<Scalars['String']>;
  tripId?: InputMaybe<Scalars['String']>;
  tripItemId?: InputMaybe<Scalars['String']>;
  tripViewId?: InputMaybe<Scalars['String']>;
  useCache?: InputMaybe<Scalars['Boolean']>;
}

/** Represents the criteria input for playback section */
export interface BookingServicingFlightPlaybackSectionCriteriaInput {
  /** Represents the JCID of the current search */
  jcid?: InputMaybe<Scalars['String']>;
  /** Represents the OBID playback section query input */
  obid?: InputMaybe<Scalars['String']>;
}

export interface BookingServicingFlightSearchCriteriaInput {
  /** Represents the jcid for the search query input */
  jcid?: InputMaybe<Scalars['String']>;
  /** Represents the journey input for the search query input */
  journeyCriteriaInput?: InputMaybe<Array<FlightsJourneyCriteriaInput>>;
  /** Represents the obid for the search query input */
  obid: Scalars['String'];
}

/** Represents the criteria input for a flight search */
export interface BookingServicingFlightSearchInput {
  /** Represents the jcid for the search query input */
  jcid?: InputMaybe<Scalars['String']>;
  /** Represents the journey input for the search query input */
  journeyCriteriaInput?: InputMaybe<Array<FlightsJourneyCriteriaInput>>;
  /** Represents the obid for the search query input */
  obid: Scalars['String'];
}

/** Represents the supported flows in booking servicing */
export enum BookingServicingFlow {
  INVOLUNTARY = 'INVOLUNTARY',
  VOLUNTARY = 'VOLUNTARY',
}

/** Represents the direction of the input fields when rendering multiple fields */
export enum BookingServicingFormInputFieldsDirection {
  /** All fields align horizontally */
  HORIZONTAL = 'HORIZONTAL',
  /** All fields align vertically */
  VERTICAL = 'VERTICAL',
}

/** Criteria Input for Reshop heads up */
export interface BookingServicingHeadsUpCriteriaInput {
  flightCriteriaInput?: InputMaybe<BookingServicingFlightHeadsUpCriteriaInput>;
  lodgingCriteriaInput?: InputMaybe<BookingServicingLodgingHeadsUpCriteriaInput>;
}

/** Represents the supported intents in booking servicing */
export enum BookingServicingIntent {
  ACCEPT = 'ACCEPT',
  CANCEL = 'CANCEL',
  CHANGE = 'CHANGE',
}

/** Target of the Link when clicked */
export enum BookingServicingLinkTarget {
  /** Link will be opened in an external view e.g. new tab or browser window */
  EXTERNAL = 'EXTERNAL',
  /** Link will be opened in the same view where the user is currently e.g. same tab or webview inside an app */
  INTERNAL = 'INTERNAL',
}

export interface BookingServicingLodgingChangeSelectionInput {
  searchInput?: InputMaybe<BookingServicingLodgingSearchInput>;
}

export interface BookingServicingLodgingConfirmationInput {
  eligibility?: InputMaybe<Scalars['String']>;
  orderId?: InputMaybe<Scalars['String']>;
  orderLineIds?: InputMaybe<Array<Scalars['String']>>;
  orderNumber?: InputMaybe<Scalars['String']>;
  sessionId?: InputMaybe<Scalars['String']>;
  tripId?: InputMaybe<Scalars['String']>;
}

/** Represents the criteria input for a lodging heads up page */
export interface BookingServicingLodgingHeadsUpCriteriaInput {
  /** Represents the orderline GUID for the heads up query input */
  orderLineGuid: Scalars['String'];
  /** Represents the orderNumber for the heads up query input */
  orderNumber: Scalars['String'];
  /** Represents the tripId for the heads up query input */
  tripId: Scalars['String'];
  /** Represents the tripItemId for the heads up query input */
  tripItemId?: InputMaybe<Scalars['String']>;
  /** Represents the tripViewId for the heads up query input */
  tripViewId?: InputMaybe<Scalars['String']>;
}

/** Represents the input for a lodging review page */
export interface BookingServicingLodgingReviewInput {
  orderId?: InputMaybe<Scalars['String']>;
  orderLineIds?: InputMaybe<Array<Scalars['String']>>;
  orderNumber?: InputMaybe<Scalars['String']>;
  tripId?: InputMaybe<Scalars['String']>;
}

/** Represents the criteria input for a lodging search */
export interface BookingServicingLodgingSearchInput {
  changeType?: InputMaybe<Scalars['String']>;
  orderLineId?: InputMaybe<Scalars['String']>;
  orderNumber?: InputMaybe<Scalars['String']>;
  /** Represents the new criteria */
  searchCriteria: PropertySearchCriteriaInput;
  tripId: Scalars['String'];
}

/** Flight input for the bookingServicingManage query */
export interface BookingServicingManageFlightInput {
  tripItemId?: InputMaybe<Scalars['String']>;
  tripViewId?: InputMaybe<Scalars['String']>;
}

/** Main input for the bookingServicingManage query */
export interface BookingServicingManageInput {
  flightInput?: InputMaybe<BookingServicingManageFlightInput>;
  lodgingInput?: InputMaybe<BookingServicingManageLodgingInput>;
}

/** Lodging input for the bookingServicingManage query */
export interface BookingServicingManageLodgingInput {
  confirmedChangeTypes?: InputMaybe<Array<Scalars['String']>>;
  orderLineId?: InputMaybe<Scalars['String']>;
  tripId: Scalars['String'];
}

export enum BookingServicingNavigateDirection {
  BACK = 'BACK',
  FORWARD = 'FORWARD',
  RELOAD = 'RELOAD',
}

export enum BookingServicingPath {
  /** @deprecated Use BookingServicingIntent.ACCEPT instead */
  ACCEPT = 'ACCEPT',
  /** @deprecated Use BookingServicingIntent.CANCEL instead */
  CANCEL = 'CANCEL',
  /** @deprecated Use BookingServicingIntent.CHANGE instead */
  CHANGE = 'CHANGE',
}

/** Criteria Input for playback section */
export interface BookingServicingPlaybackSectionInput {
  flightCriteriaInput?: InputMaybe<BookingServicingFlightPlaybackSectionCriteriaInput>;
}

/** Product type for booking servicing */
export enum BookingServicingProductType {
  /** The product type is insurance */
  INSURANCE = 'INSURANCE',
  /** The product type is lodging */
  LODGING = 'LODGING',
}

/** Represents the context from the clients starting this request */
export interface BookingServicingRedirectContextInput {
  /** Represents the client id starting this request */
  client: Scalars['String'];
  /** Represents more information needed for specific clients */
  clientSpecifics?: InputMaybe<Scalars['String']>;
}

/** The input type for submitting a request application */
export interface BookingServicingRequestInput {
  ryanairCheckRefundStatus?: InputMaybe<BookingServicingRyanAirRefundCheckStatusInput>;
  ryanairRefundApplication?: InputMaybe<BookingServicingRyanAirRefundApplicationInput>;
}

export interface BookingServicingReviewInput {
  flightReviewInput?: InputMaybe<BookingServicingFlightInput>;
  lodgingReviewInput?: InputMaybe<BookingServicingLodgingReviewInput>;
}

export enum BookingServicingRyanAirRefundApplicationFormIds {
  CREATE_REQUEST = 'CREATE_REQUEST',
  SEACH_REQUEST = 'SEACH_REQUEST',
}

export interface BookingServicingRyanAirRefundApplicationInput {
  airlineCode?: InputMaybe<Scalars['String']>;
  confirmationNumber?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<DateInput>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  flightNumber?: InputMaybe<Scalars['String']>;
  itineraryNumber?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  newFlightNumber?: InputMaybe<Scalars['String']>;
  reason: BookingServicingRyanAirRefundReason;
  tripType?: InputMaybe<FlightsTripType>;
}

export interface BookingServicingRyanAirRefundCheckStatusInput {
  confirmationNumber?: InputMaybe<Scalars['String']>;
  itineraryNumber?: InputMaybe<Scalars['String']>;
  reason: BookingServicingRyanAirRefundReason;
}

export enum BookingServicingRyanAirRefundReason {
  ANCILLARY = 'ANCILLARY',
  BEREAVEMENT = 'BEREAVEMENT',
  DISRUPTION = 'DISRUPTION',
  GOVTAX = 'GOVTAX',
}

/** Criteria Input for Reshop search */
export interface BookingServicingSearchCriteriaInput {
  flightCriteriaInput?: InputMaybe<BookingServicingFlightSearchCriteriaInput>;
  flightInput?: InputMaybe<BookingServicingFlightSearchInput>;
  lodgingInput?: InputMaybe<BookingServicingLodgingSearchInput>;
}

/** Input for the single click cancel mutation */
export interface BookingServicingSingleClickCancelInput {
  actionId?: InputMaybe<Scalars['String']>;
  orderLineId: Scalars['String'];
  orderNumber: Scalars['String'];
  productLine: BookingServicingProductType;
  tripId: Scalars['String'];
}

/** Change lodging soft change (details) page mutation input */
export interface BookingServicingSoftChangesMutationInput {
  accessibility?: InputMaybe<Array<Scalars['String']>>;
  bedTypeId?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  message?: InputMaybe<Scalars['String']>;
  smoking?: InputMaybe<Scalars['String']>;
}

export enum BookingServicingStepperState {
  COMPLETE = 'COMPLETE',
  CURRENT = 'CURRENT',
  INCOMPLETE = 'INCOMPLETE',
}

/** Represents the strategy for a booking servicing query */
export interface BookingServicingStrategyInput {
  /** Represents the type of flow */
  flow: BookingServicingFlow;
  /** Represents the type of intent */
  intent?: InputMaybe<BookingServicingIntent>;
}

/** Booking servicing toolbar navigation type */
export enum BookingServicingToolbarNavigationType {
  /** Represents the toolbar with a back button */
  BACK = 'BACK',
  /** Represents the toolbar with a back button that triggers a dialog */
  BACK_DIALOG = 'BACK_DIALOG',
  /** Represents the toolbar with a close button */
  CLOSE = 'CLOSE',
  /** Represents the toolbar with a expand less button */
  EXPAND_LESS = 'EXPAND_LESS',
  /** Represents the toolbar with a expand up button */
  EXPAND_UP = 'EXPAND_UP',
}

/** Booking servicing toolbar type */
export enum BookingServicingToolbarType {
  /** Represents the standard type */
  STANDARD = 'STANDARD',
  /** Represents the transparent type */
  TRANSPARENT = 'TRANSPARENT',
}

export enum BookingServicingTrackPosition {
  END = 'END',
  STANDARD = 'STANDARD',
  START = 'START',
}

/** Represents the traveler details input */
export interface BookingServicingTravelerDetailsInput {
  accessibility?: InputMaybe<Array<Scalars['String']>>;
  bedTypeId?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  message?: InputMaybe<Scalars['String']>;
  smoking?: InputMaybe<Scalars['String']>;
}

export enum BookingServicingTravelerType {
  ADULT = 'ADULT',
  CHILD = 'CHILD',
  INFANT = 'INFANT',
}

/** The type of input validation that will be performed on the traveler input */
export enum BookingServicingTravelerValidationType {
  /** Represents the type of validation when a child is traveling alone without an adult */
  CHILD_TRAVELING_ALONE = 'CHILD_TRAVELING_ALONE',
}

export enum BooleanEnum {
  FALSE = 'FALSE',
  TRUE = 'TRUE',
}

/** Type used during a product search to specify a given boolean value like the fact customer would prefer to search for direct flights only. */
export interface BooleanValueInput {
  id: Scalars['String'];
  value: Scalars['Boolean'];
}

/** Represents the flight branded deal product */
export interface BrandedDealFlightProductInput {
  naturalKey: FlightNaturalKeyInput;
  price: BrandedDealProductPriceInput;
  subjectToGovernmentApproval: Scalars['Boolean'];
}

/** Represents the base product price */
export interface BrandedDealProductPriceInput {
  base: MoneyInput;
  taxesAndFees: MoneyInput;
}

/** Represents the branded deal cross sell products */
export interface BrandedDealProductsInput {
  flights?: InputMaybe<Array<BrandedDealFlightProductInput>>;
}

export interface BudgetInsightForecastedMetricsInput {
  additionalClicks: MetricRangeInput;
  additionalRevenue: MetricRangeInput;
  additionalRoomNights: MetricRangeInput;
  additionalSpend: MetricRangeInput;
}

export interface BulkAddInventoryInput {
  dates: Array<DateInput>;
  increment: Scalars['Int'];
  roomTypeIDs: Array<Scalars['String']>;
}

export enum BulkEditResponseType {
  ERROR = 'ERROR',
  SUCCESS = 'SUCCESS',
}

export enum BulletStyle {
  DEFAULT = 'DEFAULT',
  ICON_ALTERNATE = 'ICON_ALTERNATE',
  ICON_STANDARD = 'ICON_STANDARD',
  NO_BULLET = 'NO_BULLET',
  UNRECOGNIZED = 'UNRECOGNIZED',
}

/** Indicate the business model type of a given offer */
export enum BusinessModelType {
  EXPEDIA_COLLECT = 'EXPEDIA_COLLECT',
  HOTEL_COLLECT = 'HOTEL_COLLECT',
}

export enum ButtonSourceType {
  SCRIPT = 'SCRIPT',
  URL = 'URL',
}

/** Supported EGDSButton types */
export enum ButtonType {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
  TERTIARY = 'TERTIARY',
}

export interface CabinInput {
  /** The cabin code/type */
  type: Scalars['String'];
}

/** optional data to calculate loyalty awards for one key cash */
export interface CalculateAwardInput {
  /** Represents the booking fees */
  siteFees: Scalars['String'];
  /** Represents the booking price */
  sitePrice: Scalars['String'];
  /** Represents the booking taxes */
  siteTaxes: Scalars['String'];
  /** Represents the booking transaction currency */
  transactionCurrency: Scalars['String'];
  /** Represents the booking end date */
  tripEndDate: Scalars['String'];
  /** Represents the booking start date */
  tripStartDate: Scalars['String'];
}

export enum CalendarConflictStatus {
  BOOKING_REQUEST_NO_CONFLICT = 'BOOKING_REQUEST_NO_CONFLICT',
  /** @deprecated Use conflict statuses that are more granular */
  BOOKING_REQUEST_POTENTIAL_CONFLICT = 'BOOKING_REQUEST_POTENTIAL_CONFLICT',
  BOOKING_REQUEST_POTENTIAL_CONFLICT_BLOCK = 'BOOKING_REQUEST_POTENTIAL_CONFLICT_BLOCK',
  BOOKING_REQUEST_POTENTIAL_CONFLICT_IMPORT_CALENDAR = 'BOOKING_REQUEST_POTENTIAL_CONFLICT_IMPORT_CALENDAR',
  BOOKING_REQUEST_POTENTIAL_CONFLICT_MULTIPLE = 'BOOKING_REQUEST_POTENTIAL_CONFLICT_MULTIPLE',
  BOOKING_REQUEST_POTENTIAL_CONFLICT_PREAPPROVAL = 'BOOKING_REQUEST_POTENTIAL_CONFLICT_PREAPPROVAL',
}

/** Enum of types of Calendar Availability template */
export enum CalendarTemplateType {
  WITHOUT_AVAILABILITY = 'WITHOUT_AVAILABILITY',
  WITH_AVAILABILITY = 'WITH_AVAILABILITY',
}

/** Represents the leading text */
export enum CalloutSubtextLeading {
  CALLOUT = 'CALLOUT',
  SUBTEXT = 'SUBTEXT',
}

/** Represents the starting  position (stack or row) */
export enum CalloutSubtextPosition {
  ROW = 'ROW',
  STACK = 'STACK',
}

export interface CampaignCreativeDataInput {
  adGroupId?: InputMaybe<Scalars['String']>;
  adId?: InputMaybe<Scalars['String']>;
  campaignId?: InputMaybe<Scalars['String']>;
  contentId?: InputMaybe<Scalars['String']>;
}

/** Campaign wizard campaign input */
export interface CampaignInput {
  /** Campaign ad groups */
  adGroups: Array<AdGroupInput>;
  /** Campaign bidding structure */
  biddingStructure?: InputMaybe<BiddingStructureInput>;
  /** Campaign budget */
  budget?: InputMaybe<Scalars['Float']>;
  /** Campaign budget currency */
  budgetCurrency?: InputMaybe<Scalars['String']>;
  /** Campaign budget changed */
  defaultBudgetChanged?: InputMaybe<Scalars['Boolean']>;
  /** Campaign end date */
  endDate?: InputMaybe<Scalars['String']>;
  /** Campaign goal */
  goal?: InputMaybe<MarketGoal>;
  hydrated: Scalars['Boolean'];
  /** Campaign id.  Includes temp if it is a new campaign */
  id: Scalars['String'];
  /** Campaign paused */
  isPaused: Scalars['Boolean'];
  /** Campaign name */
  name: Scalars['String'];
  /** Selected payment profile */
  paymentProfileId?: InputMaybe<Scalars['String']>;
  /** Product id */
  productId: Scalars['String'];
  /** Product name */
  productName: Scalars['String'];
  /** Campaign start date */
  startDate: Scalars['String'];
}

/** Input for migrationStep */
export interface CampaignMigrationContextInput {
  /** Payment profile id */
  paymentProfileId?: InputMaybe<Scalars['String']>;
  /** Selected payment profile id */
  selectedPaymentProfileId?: InputMaybe<Scalars['String']>;
  /** Selected pre-fill billing address id */
  selectedPrefillBillingAddressId?: InputMaybe<Scalars['Int']>;
  /** Selected campaigns */
  selectedProperties?: InputMaybe<Array<Scalars['String']>>;
  /** User email address */
  userEmailAddress: Scalars['String'];
}

export enum CampaignOfferBadgeType {
  DEFAULT = 'DEFAULT',
  DISCOUNT = 'DISCOUNT',
}

/** Overview Sorting */
export interface CampaignOverviewTableSortingInput {
  page?: InputMaybe<Scalars['Int']>;
  resultsPerPage?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<Scalars['String']>;
}

export interface CampaignParametersInput {
  campaignId: Scalars['String'];
  contentPagination?: InputMaybe<ContentPaginationInput>;
  propertyParameters?: InputMaybe<CampaignPropertyParametersInput>;
}

export enum CampaignProductType {
  ACTIVITY = 'ACTIVITY',
  FLIGHT = 'FLIGHT',
  HOTEL = 'HOTEL',
  PACKAGE = 'PACKAGE',
}

export interface CampaignPropertyParametersInput {
  guestRating?: InputMaybe<Scalars['Float']>;
  propertyId: Scalars['String'];
  starRating?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<PropertyDetailsPropertyType>;
}

/** Campaign Request Inputs */
export interface CampaignRequestInput {
  /** Campaign ad group list */
  adGroupList: Array<AdGroupRequestInput>;
  /** Campaign bidding structure */
  biddingStructure?: InputMaybe<BiddingStructureInput>;
  /** Budget amount */
  budgetAmount: Scalars['Float'];
  /** Campaign Id */
  campaignId?: InputMaybe<Scalars['UUID']>;
  /** Campaign name */
  campaignName: Scalars['String'];
  /** Campaign Targeting List */
  campaignTargeting: CampaignTargetingInput;
  /** Campaign Update status */
  isCampaignUpdated: Scalars['Boolean'];
  /** Campaign status */
  isPaused?: InputMaybe<Scalars['Boolean']>;
  /** Market goal */
  marketGoal: MarketGoal;
  /** Payment profile Id */
  paymentProfileId?: InputMaybe<Scalars['String']>;
}

export enum CampaignSearchFilters {
  CAMPAIGN_ID = 'CAMPAIGN_ID',
  CAMPAIGN_NAME = 'CAMPAIGN_NAME',
  PARTNER_ACCOUNT_ID = 'PARTNER_ACCOUNT_ID',
  PAYMENT_PROFILE_ID = 'PAYMENT_PROFILE_ID',
  PROPERTY_ID = 'PROPERTY_ID',
}

export interface CampaignSearchOptionsInput {
  endDate: DateInput;
  searchFilter: CampaignSearchFilters;
  searchInput: Scalars['String'];
  startDate: DateInput;
}

/** Campaign Targeting Inputs */
export interface CampaignTargetingInput {
  /** End Date */
  endDate?: InputMaybe<TargetingInput>;
  /** Start Date */
  startDate: TargetingInput;
}

export interface CancellationWaiverDeclineRequestContext {
  bookingItemId: Scalars['String'];
  message?: InputMaybe<Scalars['String']>;
  reason: Scalars['String'];
  serviceRequestId: Scalars['String'];
}

export enum CarAccessorySelectionState {
  NOT_SELECTED = 'NOT_SELECTED',
  SELECTED = 'SELECTED',
}

export enum CarActionType {
  /** Apply loyalty points to offer */
  APPLY_LOYALTY_POINTS = 'APPLY_LOYALTY_POINTS',
  /** Click map marker */
  CAR_MAP_MARKER = 'CAR_MAP_MARKER',
  /** Change Search */
  CHANGE_SEARCH = 'CHANGE_SEARCH',
  /** Dismisses a dialog */
  DISMISS = 'DISMISS',
  /** Click to filter car sales */
  FILTER_SALE_OFFER = 'FILTER_SALE_OFFER',
  /** Submit content to server */
  FORM_SUBMISSION = 'FORM_SUBMISSION',
  /** Go back to search page to see all cars */
  GO_BACK_TO_SEARCH = 'GO_BACK_TO_SEARCH',
  /** Open cancellation policy link */
  GO_TO_CANCELLATION_POLICY = 'GO_TO_CANCELLATION_POLICY',
  /** Continues to the standalone details page */
  GO_TO_CHECKOUT = 'GO_TO_CHECKOUT',
  /** Open dialog to see cleaning and safety practices */
  GO_TO_CLEANLINESS_DIALOG = 'GO_TO_CLEANLINESS_DIALOG',
  /** Open Delta Campaign page */
  GO_TO_DELTA_CAMPAIGN_LINK = 'GO_TO_DELTA_CAMPAIGN_LINK',
  /** Continues to the standalone details page */
  GO_TO_DETAILS = 'GO_TO_DETAILS',
  /** Continues to the packages path */
  GO_TO_PACKAGES = 'GO_TO_PACKAGES',
  /** Open recommended sort FAQ page */
  GO_TO_RECOMMENDED_SORT_FAQ = 'GO_TO_RECOMMENDED_SORT_FAQ',
  /** Continues to the user sign in page */
  GO_TO_SIGNIN = 'GO_TO_SIGNIN',
  /** Continues to the user sign up page */
  GO_TO_SIGNUP = 'GO_TO_SIGNUP',
  /** Click to sign in and unlock car sales */
  GO_TO_SIGN_IN_AND_UNLOCK_CAR_SALES = 'GO_TO_SIGN_IN_AND_UNLOCK_CAR_SALES',
  /** Open Walmart plus member trial page */
  GO_TO_WPLUS_MEMBER_TRIAL_LINK = 'GO_TO_WPLUS_MEMBER_TRIAL_LINK',
  /** Load more results to search page */
  LOAD_MORE = 'LOAD_MORE',
  /** Change Search */
  OFF_AIRPORT_CHANGE_SEARCH = 'OFF_AIRPORT_CHANGE_SEARCH',
  /** Opens a dialog */
  OPEN_DIALOG = 'OPEN_DIALOG',
  /** Open merchant rules in iframe */
  OPEN_DOC = 'OPEN_DOC',
  /** Open ground transfers page */
  OPEN_GROUND_TRANSFERS = 'OPEN_GROUND_TRANSFERS',
  /** Opens the inline time wizard */
  OPEN_INLINE_TIME_WIZARD = 'OPEN_INLINE_TIME_WIZARD',
  /** Opens the inline search wizard */
  OPEN_INLINE_WIZARD = 'OPEN_INLINE_WIZARD',
  /** Opens a new tab */
  OPEN_NEW_TAB = 'OPEN_NEW_TAB',
  /** Opens on current tab */
  OPEN_ON_CURRENT_TAB = 'OPEN_ON_CURRENT_TAB',
  /** Open Partner Messaging Link */
  OPEN_PARTNER_MESSAGING_LINK = 'OPEN_PARTNER_MESSAGING_LINK',
  /** Open vendor rules from domain rules */
  OPEN_RULE = 'OPEN_RULE',
  /** Used to open Telephone Link */
  OPEN_TEL = 'OPEN_TEL',
  /** Refreshes the current page */
  REFRESH = 'REFRESH',
  /** Remove loyalty points to offer */
  REMOVE_LOYALTY_POINTS = 'REMOVE_LOYALTY_POINTS',
  /** Click see cars on map marker item card */
  SEE_CARS_AT_MAP_MARKER = 'SEE_CARS_AT_MAP_MARKER',
  /** Open share feedback form */
  SHARE_FEEDBACK = 'SHARE_FEEDBACK',
  /** Show offers with AARP Exclusive benefits */
  SHOW_AARP_EXCLUSIVE_OFFERS = 'SHOW_AARP_EXCLUSIVE_OFFERS',
  /** Show offers with free cancellations */
  SHOW_FREE_CANCELLATION_OFFERS = 'SHOW_FREE_CANCELLATION_OFFERS',
  /** Click to unlock car sales */
  UNLOCK_CAR_SALES = 'UNLOCK_CAR_SALES',
}

export interface CarDetailContextInput {
  carOfferToken: Scalars['String'];
  /** Encoded string having certain offer information shown on search page. Eg. priceShown, avg category price */
  continuationContextualId?: InputMaybe<Scalars['String']>;
  optionAction?: InputMaybe<CarAccessorySelectionState>;
  optionToken?: InputMaybe<Scalars['String']>;
  /** Original parameters of the url resulting in this request */
  originalDeeplink?: InputMaybe<Scalars['String']>;
  principalToken?: InputMaybe<Scalars['String']>;
  rewardPointsSelection?: InputMaybe<RewardsPointSelectionEnum>;
  selectedAccessories?: InputMaybe<Array<Scalars['String']>>;
}

export enum CarDetailsMapMarkerType {
  CarMarker = 'CarMarker',
  PlaceMarker = 'PlaceMarker',
}

export enum CarFormatStyle {
  IFRAME = 'IFRAME',
  LIST = 'LIST',
}

export enum CarMapMarkerType {
  CarMarker = 'CarMarker',
  PlaceMarker = 'PlaceMarker',
}

/** Minimum set of data used to retrieve details about a car product */
export interface CarNaturalKeyInput {
  offerToken: Scalars['String'];
  specialEquipments?: InputMaybe<Array<SpecialEquipment>>;
}

/** Car offer input criteria to fetch car offer details */
export interface CarOfferCriteriaInput {
  primary: PrimaryCarOfferCriteriaInput;
  secondary?: InputMaybe<ShoppingSearchCriteriaInput>;
}

export enum CarOfferOptionAction {
  SELECT = 'SELECT',
  UNSELECT = 'UNSELECT',
}

export interface CarOfferOptionInput {
  /** Action to represent if the option is selected or unselected */
  optionAction: CarOfferOptionAction;
  /** The option token */
  optionToken: Scalars['String'];
}

/** Provides the car rental location information */
export interface CarRentalLocationInput {
  airportCode?: InputMaybe<Scalars['String']>;
  coordinates?: InputMaybe<CoordinatesInput>;
  isExactLocationSearch?: InputMaybe<Scalars['Boolean']>;
  /** List of coordinates of the map's bounding box. */
  mapBounds?: InputMaybe<Array<CoordinatesInput>>;
  regionId?: InputMaybe<Scalars['String']>;
  searchTerm?: InputMaybe<Scalars['String']>;
}

export enum CarRouteType {
  ONEWAY = 'ONEWAY',
  ROUNDTRIP = 'ROUNDTRIP',
}

export interface CarRulesAndRestrictionsCriteriaInput {
  carOfferToken?: InputMaybe<Scalars['String']>;
  orderId?: InputMaybe<Scalars['String']>;
  useEgtpPath?: InputMaybe<Scalars['Boolean']>;
}

/** Car criteria needed to perform a car search */
export interface CarSearchCriteriaInput {
  primary: PrimaryCarCriteriaInput;
  secondary?: InputMaybe<ShoppingSearchCriteriaInput>;
}

/** Represents name and code for each car brand. */
export enum CarSearchFormPreferredBrand {
  AC = 'AC',
  AD = 'AD',
  AL = 'AL',
  EP = 'EP',
  ET = 'ET',
  EY = 'EY',
  FX = 'FX',
  GI = 'GI',
  MW = 'MW',
  NU = 'NU',
  RO = 'RO',
  SC = 'SC',
  SV = 'SV',
  SX = 'SX',
  ZA = 'ZA',
  ZD = 'ZD',
  ZE = 'ZE',
  ZI = 'ZI',
  ZL = 'ZL',
  ZR = 'ZR',
  ZT = 'ZT',
}

export enum CardActions {
  DISMISS = 'DISMISS',
}

export enum CardSize {
  LARGE = 'LARGE',
  MEDIUM = 'MEDIUM',
  SMALL = 'SMALL',
}

/** Business model for a product */
export enum CardStatus {
  NOT_UPGRADED = 'NOT_UPGRADED',
  REFUNDABLE = 'REFUNDABLE',
  UPDATED = 'UPDATED',
  UPGRADED = 'UPGRADED',
}

export enum CardTheme {
  GLOBAL_LOYALTY_EXTRAHIGH = 'GLOBAL_LOYALTY_EXTRAHIGH',
  GLOBAL_LOYALTY_HIGH = 'GLOBAL_LOYALTY_HIGH',
  GLOBAL_LOYALTY_LOW = 'GLOBAL_LOYALTY_LOW',
  GLOBAL_LOYALTY_MIDDLE = 'GLOBAL_LOYALTY_MIDDLE',
  GLOBAL_LOYALTY_STANDARD = 'GLOBAL_LOYALTY_STANDARD',
  HIGHLIGHT = 'HIGHLIGHT',
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
}

export enum CarouselScrimType {
  /** Scrim should contain UitkPaginationDot and be inset */
  INSET_PAGINATION_DOT = 'INSET_PAGINATION_DOT',
  /** Scrim should contain UitkPaginationDot and be offset */
  OFFSET_PAGINATION_DOT = 'OFFSET_PAGINATION_DOT',
}

export enum CarryOnBagType {
  CARRY_ON_BAG = 'CARRY_ON_BAG',
}

export enum CarsDialogType {
  LIMITED_RESULTS = 'LIMITED_RESULTS',
  LIMITED_RESULTS_WITHOUT_TURO = 'LIMITED_RESULTS_WITHOUT_TURO',
  LIMITED_RESULTS_WITH_TURO = 'LIMITED_RESULTS_WITH_TURO',
}

export interface CarsDomainRequestContextInput {
  partnerContext: PartnerContextInput;
  principalJWT: Scalars['String'];
}

export enum CarsMessagingCardLinkPosition {
  BOTTOM = 'BOTTOM',
  RIGHT = 'RIGHT',
}

export enum CarsRichTextStyle {
  BOLD = 'BOLD',
  BULLET = 'BULLET',
  ITALICIZE = 'ITALICIZE',
}

/** Options for the session cart being created */
export interface CartOptionsInput {
  ttl: CartTtl;
}

export interface CartPropertySearchContextInput {
  /** The checking date for the property rental */
  checkIn: DateInput;
  /** The checkOut date for the property rental */
  checkOut: DateInput;
  /** The id of the region where the hotel is located - from lodging domain */
  regionId: Scalars['String'];
  /** The list of rooms that user searched for */
  rooms: Array<PropertyRoomInput>;
}

export enum CartTtl {
  FIVE_MINUTES = 'FIVE_MINUTES',
  SEVEN_DAYS = 'SEVEN_DAYS',
  TWELVE_HOURS = 'TWELVE_HOURS',
}

export enum CellHighlightType {
  ALTERNATE_HIGHLIGHT = 'ALTERNATE_HIGHLIGHT',
  HIGHLIGHT = 'HIGHLIGHT',
}

export enum ChannelType {
  VIRTUAL_AGENT = 'VIRTUAL_AGENT',
}

/** Indicates the type of intent. */
export enum ChatBotIntentType {
  CANCEL = 'CANCEL',
  CHANGE = 'CHANGE',
  VIEW_BOOKING = 'VIEW_BOOKING',
}

/** Indicates the type of product. */
export enum ChatBotProductType {
  FLIGHT = 'FLIGHT',
}

/** Indicates the waiver redemption state. */
export enum ChatBotWaiverRedemptionState {
  CREDIT_REDEMPTION = 'CREDIT_REDEMPTION',
}

/** Represents Chatgpt experience get conversation input data */
export interface ChatGPTExperienceGetConversationInput {
  /** Represents conversationType which will be used while fetching the active conversation */
  conversationType?: InputMaybe<ConversationType>;
  /** Represents trip Id which will be used while fetching the active conversation */
  tripId: Scalars['String'];
}

/** Represents Chatgpt experience update trip input */
export interface ChatGPTUpdateTripInput {
  /** Represents the trip Id */
  tripId: Scalars['String'];
}

/** Hold status of chat input for particular message on the basis of flags received form message */
export enum ChatInputStatus {
  DISABLE = 'DISABLE',
  ENABLE = 'ENABLE',
}

/** Supported capabilities of chatbot VAC. */
export enum ChatbotCapabilities {
  CLICKSTREAM = 'CLICKSTREAM',
  GLASSBOX = 'GLASSBOX',
}

/** Device identifiers for use cases like push notification */
export interface ChatbotDeviceIdentifiersInput {
  /** Push token generated by client to uniquely identify a device */
  deviceToken?: InputMaybe<Scalars['String']>;
  /** Sailthru device id https://docs.mobile.sailthru.com/reference/devices-erase */
  sailthruDeviceID?: InputMaybe<Scalars['String']>;
}

/** Key-Value pair of intent attributes for chatbot initialization example itineraryNumber, orderLineId */
export interface ChatbotIntentValueInput {
  /** Key to define intent attributes for chatbot initialization example itineraryNumber, orderLineId */
  id: Scalars['String'];
  /** Value for intent attributes for chatbot initialization example of attributes itineraryNumber, orderLineId */
  value: Scalars['String'];
}

/** Supported versions of chatbot. */
export enum ChatbotVersionId {
  V1 = 'V1',
  V2 = 'V2',
}

export enum CheckinValidityWithReason {
  /** the associated date is not valid for checkin due to an unknown reason */
  INVALID = 'INVALID',
  /** the associated date is not valid for checkin due to being in the past */
  INVALID_DUE_TO_BEING_IN_PAST = 'INVALID_DUE_TO_BEING_IN_PAST',
  /** the associated date is not valid for checkin because checkin was prohibited on that specific date */
  INVALID_DUE_TO_CHANGEOVER_EXCLUSION = 'INVALID_DUE_TO_CHANGEOVER_EXCLUSION',
  /** the associated date is not valid for checkin because it is too far in the future */
  INVALID_DUE_TO_MAX_FUTURE_BOOKING = 'INVALID_DUE_TO_MAX_FUTURE_BOOKING',
  /** the associated date is not valid for checkin because checking in on this date would not meet the owner's minimum prior notification requirements */
  INVALID_DUE_TO_MIN_PRIOR_NOTIFICATION = 'INVALID_DUE_TO_MIN_PRIOR_NOTIFICATION',
  /** the associated date is not valid for checkin because checking in on this date does not satisfy the minimum stay duration */
  INVALID_DUE_TO_MIN_STAY_NOT_ACHIEVABLE = 'INVALID_DUE_TO_MIN_STAY_NOT_ACHIEVABLE',
  /** the associated date is not valid for checkin because it falls on a day of the week that checkin is prohibited */
  INVALID_DUE_TO_NON_CHANGEOVER_DAY_OF_WEEK = 'INVALID_DUE_TO_NON_CHANGEOVER_DAY_OF_WEEK',
  /** the associated date is not valid for checkin because it is not available (ie. the date is already reserved) */
  INVALID_DUE_TO_NOT_AVAILABLE = 'INVALID_DUE_TO_NOT_AVAILABLE',
  /** the associated date is not valid for checkin because there is not an associated checkout date that would allow the stay to satisfy stay constraints */
  INVALID_DUE_TO_NO_VALID_CHECKOUT_WITHIN_CONSTRAINTS = 'INVALID_DUE_TO_NO_VALID_CHECKOUT_WITHIN_CONSTRAINTS',
  /** the associated date is valid for checkin */
  VALID = 'VALID',
}

export interface CheckoutDomainInfoInput {
  name: Scalars['String'];
  refId: Scalars['String'];
}

/** Checkout option and its value to apply on the checkoutUrl */
export interface CheckoutOptionInput {
  type: CheckoutOptionType;
  value: Scalars['String'];
}

/** Supported Features on prepareCheckout */
export enum CheckoutOptionType {
  CROSS_SELL = 'CROSS_SELL',
  DESTINATION_ID = 'DESTINATION_ID',
  FENCING_ATTRIBUTES = 'FENCING_ATTRIBUTES',
  GUEST_CHOICE = 'GUEST_CHOICE',
  /** @deprecated Use PropertyNaturalKeyInput.businessModelType instead */
  HOTEL_BUSINESS_MODEL = 'HOTEL_BUSINESS_MODEL',
  HOTEL_MARKETING_CHANNEL = 'HOTEL_MARKETING_CHANNEL',
  INSTANT_BOOK = 'INSTANT_BOOK',
  LEGACY_CHECKOUT_URL = 'LEGACY_CHECKOUT_URL',
  LOYALTY_REWARDS_ID = 'LOYALTY_REWARDS_ID',
  META_DEEPLINK = 'META_DEEPLINK',
  NATIVE = 'NATIVE',
  PRICE_TOKEN = 'PRICE_TOKEN',
  PROPERTY_UPSELL_AMOUNT = 'PROPERTY_UPSELL_AMOUNT',
  RATE_UPGRADE_ELIGIBLE = 'RATE_UPGRADE_ELIGIBLE',
  RATE_UPSELL = 'RATE_UPSELL',
  RATE_UPSELL_AMOUNT = 'RATE_UPSELL_AMOUNT',
  REFERRER_ID = 'REFERRER_ID',
  REFUNDABLE_DAMAGE_DEPOSIT_REQUIRED = 'REFUNDABLE_DAMAGE_DEPOSIT_REQUIRED',
  ROOM_UPGRADE_ELIGIBLE = 'ROOM_UPGRADE_ELIGIBLE',
  ROOM_UPSELL = 'ROOM_UPSELL',
  SEARCH_ID = 'SEARCH_ID',
  SHOPPING_DEAL_BADGE_PERCENTAGE = 'SHOPPING_DEAL_BADGE_PERCENTAGE',
  SHOP_WITH_POINTS = 'SHOP_WITH_POINTS',
  TAAP_PACKAGE_RATES = 'TAAP_PACKAGE_RATES',
}

export interface CheckoutRedirectInput {
  /** Cabin number which will be populated for users redirecting from the Checkout page */
  cabinNumber: Scalars['String'];
  /** Deck number which will be populated for users redirecting from the Checkout page */
  deck: Scalars['String'];
  /** Optional Offer token which will be used to select the previous rate for users redirecting from the Checkout page */
  offerToken?: InputMaybe<Scalars['String']>;
}

export interface CheckoutSessionIdentifierInput {
  sessionId?: InputMaybe<Scalars['String']>;
}

export interface CheckoutSessionInfoInput {
  sessionId: Scalars['UUID'];
  sessionToken: Scalars['UUID'];
}

export enum CheckoutSessionMode {
  CHECKOUT_SESSION_MODE_EXPRESS = 'CHECKOUT_SESSION_MODE_EXPRESS',
  CHECKOUT_SESSION_MODE_REGULAR = 'CHECKOUT_SESSION_MODE_REGULAR',
}

export enum CheckoutValidityWithReason {
  /** the associated date's is not valid for checkout for an unknown reason */
  INVALID = 'INVALID',
  /** the associated date is not valid for checkout because checkout was prohibited on that specific date */
  INVALID_DUE_TO_CHANGEOVER_EXCLUSION = 'INVALID_DUE_TO_CHANGEOVER_EXCLUSION',
  /** the associated date is not valid for checkout because it falls on a day of the week that checkout is prohibited */
  INVALID_DUE_TO_NON_CHANGEOVER_DAY_OF_WEEK = 'INVALID_DUE_TO_NON_CHANGEOVER_DAY_OF_WEEK',
  /** the associated date is valid for checkout */
  VALID = 'VALID',
}

/** A guest over the age of 2 */
export interface ChildInput {
  /** The child's age in years */
  age: Scalars['Int'];
}

export enum ChronoUnit {
  CENTURIES = 'CENTURIES',
  DAYS = 'DAYS',
  DECADES = 'DECADES',
  ERAS = 'ERAS',
  FOREVER = 'FOREVER',
  HALFDAYS = 'HALFDAYS',
  HOURS = 'HOURS',
  MICROS = 'MICROS',
  MILLENNIA = 'MILLENNIA',
  MILLIS = 'MILLIS',
  MINUTES = 'MINUTES',
  MONTHS = 'MONTHS',
  NANOS = 'NANOS',
  SECONDS = 'SECONDS',
  WEEKS = 'WEEKS',
  YEARS = 'YEARS',
}

export enum CleaningAndSafetyPractice {
  ENHANCED_CLEANING = 'ENHANCED_CLEANING',
}

/** Represents context about the requesting client */
export interface ClientContextInput {
  /** The time zone identifier in the IANA Time Zone Database */
  timeZoneId: Scalars['String'];
}

/** Represents client details information */
export interface ClientDetailsInput {
  clientId: Scalars['String'];
  clientName: Scalars['String'];
}

export enum ClientIdentifier {
  ANDROID_APP = 'ANDROID_APP',
  IOS_APP = 'IOS_APP',
  WEB = 'WEB',
}

/** Describe which application is invoking bex api */
export interface ClientInfoInput {
  /** Name of the application */
  name: Scalars['String'];
  /** Version of the application eg:18.10 or 5fbc9958 */
  version?: InputMaybe<Scalars['String']>;
}

/** Input argument for Request Context */
export interface ClientRequestInput {
  /** Headers of HTTP Request */
  headers: Array<HttpHeaderInput>;
  /** Remote address of HTTP Request */
  remoteAddress: Scalars['String'];
  /** URL of HTTP Request */
  url: Scalars['String'];
}

export enum ClientSideIllustrationAsset {
  FlightHotelIncludedSet = 'FlightHotelIncludedSet',
}

/** The closed bounding type of the date period. (Boundaries are always included) */
export enum ClosedPeriodBounding {
  LOWER = 'LOWER',
  UPPER = 'UPPER',
}

export enum CoachingTipsView {
  IN_CONTEXT_COACHING_CAROUSEL = 'IN_CONTEXT_COACHING_CAROUSEL',
  OPPY_HUB = 'OPPY_HUB',
  STANDALONE_MINIMAL = 'STANDALONE_MINIMAL',
  STANDALONE_SUGGESTED = 'STANDALONE_SUGGESTED',
}

/** CollectionItemClickthrough is an optional parameter that specifies the URL linked to each card in the carousel, determining where the user is directed upon clicking a card. */
export enum CollectionItemClickthrough {
  PDP = 'PDP',
  PINNED_SRP = 'PINNED_SRP',
}

/** Context of pagination and max number of elements. If not defined, the default set of elements are provided. */
export interface CollectionPaginationContextInput {
  /** Indicates the maximum number of items to be shown in the module. */
  maxPageSize?: InputMaybe<Scalars['Int']>;
  /** Indicates the pagination offset. */
  offset?: InputMaybe<Scalars['Int']>;
  /** Indicates the initial number of items to be shown in the module and how many more items will be fetched by pagination. */
  pageSize?: InputMaybe<Scalars['Int']>;
}

/** The type of the collection */
export enum CollectionType {
  FLIGHT = 'FLIGHT',
  GEOGRAPHY = 'GEOGRAPHY',
  LODGING = 'LODGING',
  PACKAGE = 'PACKAGE',
}

export enum CommissionTier {
  BASIC = 'BASIC',
  BASIC_PLUS = 'BASIC_PLUS',
  PREMIUM = 'PREMIUM',
  PREMIUM_PLUS = 'PREMIUM_PLUS',
}

/** Represents the state of a conversation thread */
export enum CommunicationCenterConversationState {
  /** Represents read state */
  READ = 'READ',
  /** Represents invalid state */
  UNKNOWN = 'UNKNOWN',
  /** Represents unread state - initial state of conversation thread */
  UNREAD = 'UNREAD',
}

export enum CommunicationCenterConversationType {
  SUPPLIER = 'SUPPLIER',
  TRIP_COLLABORATION = 'TRIP_COLLABORATION',
}

/** Represents left or right alignment of a specific messages in the conversation View */
export enum CommunicationCenterMessageAlignment {
  /** Represents center Alignment */
  CENTER = 'CENTER',
  /** Represents a card that is not aligned to either left or right */
  FULL = 'FULL',
  /** Represents left Alignment */
  LEFT = 'LEFT',
  /** Represents Right Alignment */
  RIGHT = 'RIGHT',
}

/** Represents the state of message preview */
export enum CommunicationCenterMessagePreviewState {
  /** Represents read state */
  READ = 'READ',
  /** Represents unread state */
  UNREAD = 'UNREAD',
}

/** The display type of the Customer notification message */
export enum CommunicationCenterNotificationMessageDisplayType {
  /** Display the message for the form */
  FORM = 'FORM',
  /** Dislay message on the page level, eg: fly-in message on the page */
  PAGE = 'PAGE',
}

/** The level type of the Customer notification message */
export enum CommunicationCenterNotificationMessageLevel {
  /** Type of error for the message */
  ERROR = 'ERROR',
  /** Type of info for the message */
  INFO = 'INFO',
  /** Type of success for the message */
  SUCCESS = 'SUCCESS',
  /** Type of warning for the message */
  WARNING = 'WARNING',
}

/** Represents the state of notification or message */
export enum CommunicationCenterNotificationState {
  /** Represents read state */
  READ = 'READ',
  /** Represents seen state - equivalents as unread */
  SEEN = 'SEEN',
  /** Represents invalid state */
  UNKNOWN = 'UNKNOWN',
  /** Represents unseen state - initial state of notification */
  UNSEEN = 'UNSEEN',
}

/** Represents the type of the notification */
export enum CommunicationCenterNotificationType {
  /** Represents coupon notification */
  COUPON_CAMPAIGN = 'COUPON_CAMPAIGN',
  /** Represents default type of notification */
  DEFAULT = 'DEFAULT',
}

/** Represents the type of user actions of the notification. */
export enum CommunicationCenterNotificationUserActionType {
  /** Represents the action of deleting a notification */
  DELETE = 'DELETE',
  /** Represents the action of marking a notification as read */
  MARK_AS_READ = 'MARK_AS_READ',
  /** Represents the action of marking a notification as unread */
  MARK_AS_UNREAD = 'MARK_AS_UNREAD',
  /** Represents the action of turning off price alerts */
  PRICE_TRACKING_UNSUBSCRIBE = 'PRICE_TRACKING_UNSUBSCRIBE',
}

/** Represents the status of query/mutation response */
export enum CommunicationCenterOperationStatus {
  /** Represents the status of failure response for generic or unknown reasons */
  GENERIC_FAILURE = 'GENERIC_FAILURE',
  /** Represents the status of failure response for invalid input */
  INVALID_INPUT = 'INVALID_INPUT',
  /** Represents the status of failure response for service errors */
  SERVICE_ERROR = 'SERVICE_ERROR',
  /** Represents the status of successful response */
  SUCCESS = 'SUCCESS',
}

export enum CommunicationChannel {
  EMAIL = 'EMAIL',
  PUSH = 'PUSH',
  SMS = 'SMS',
}

/** BRANDS/PROGRAMS that can be subscribed to */
export enum CommunicationPreferencesCategory {
  EXPEDIA = 'EXPEDIA',
  HOTELS = 'HOTELS',
  ONE_KEY = 'ONE_KEY',
  VRBO = 'VRBO',
}

export interface CommunicationPreferencesConsentConfirmationRequestInput {
  checksum: Scalars['String'];
  date: Scalars['String'];
  egAccountId: Scalars['String'];
}

export enum CommunicationPreferencesOptionsType {
  ACCOUNT_SUPPORT = 'ACCOUNT_SUPPORT',
  COMMUNICATION_PREFERENCES_EXPEDIA = 'COMMUNICATION_PREFERENCES_EXPEDIA',
  COMMUNICATION_PREFERENCES_HOTELS = 'COMMUNICATION_PREFERENCES_HOTELS',
  COMMUNICATION_PREFERENCES_VRBO = 'COMMUNICATION_PREFERENCES_VRBO',
  COMMUNICATION_PREFERENCES_WOTIF = 'COMMUNICATION_PREFERENCES_WOTIF',
  CONFIRMATION_AND_CRITICAL_UPDATES = 'CONFIRMATION_AND_CRITICAL_UPDATES',
  DEFAULT = 'DEFAULT',
  MANAGE_EMAIL_PREFERENCE = 'MANAGE_EMAIL_PREFERENCE',
  OFFERS_AND_INSPIRATION = 'OFFERS_AND_INSPIRATION',
  ONE_KEY = 'ONE_KEY',
  ONE_KEY_MONTHLY_STATEMENTS = 'ONE_KEY_MONTHLY_STATEMENTS',
  PARTNERS_OFFERS_WITH_US = 'PARTNERS_OFFERS_WITH_US',
  PERSONALIZED_TRIP_RECOMMENDATIONS = 'PERSONALIZED_TRIP_RECOMMENDATIONS',
  PRIVACY_STATEMENT = 'PRIVACY_STATEMENT',
  REVIEWS = 'REVIEWS',
  SURVEYS = 'SURVEYS',
  THE_TRAVEL_EDIT = 'THE_TRAVEL_EDIT',
  TRIP_BOARD_ACTIVITY = 'TRIP_BOARD_ACTIVITY',
  TRIP_PLANNING_ASSISTANCE = 'TRIP_PLANNING_ASSISTANCE',
  UNSUB_ALL = 'UNSUB_ALL',
  UNSUB_OTHER_EMAILS = 'UNSUB_OTHER_EMAILS',
}

export interface CompetitiveInsightsDateRangeInput {
  endDate: Scalars['String'];
  startDate: Scalars['String'];
}

export interface CompleteBookingRequestInput {
  domainInfoList?: InputMaybe<Array<CheckoutDomainInfoInput>>;
  isAbandonBooking?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<SmartFormType>;
  updatePaymentMethodRequest: UpdatePaymentMethodMutationRequestInput;
  updateSmartFormRequest: SmartFormDataInput;
}

/** A rough measure of the percentage of properties that are sold out in the destination region as calculated by the Urgency Service. */
export enum CompressionLevel {
  CAP = 'CAP',
  HIGH = 'HIGH',
  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
  NA = 'NA',
}

export enum ConfigTag {
  H1 = 'H1',
  H2 = 'H2',
  H3 = 'H3',
  H4 = 'H4',
  H5 = 'H5',
  H6 = 'H6',
}

export interface ConfirmationDialogInput {
  /** Can be used as a placeholder for property name or lob */
  elementName?: InputMaybe<Scalars['String']>;
  /** Describes whether to delete quotes on QL or Clear rates on QB */
  elementType: DialogElementType;
  /** Number of quotes to be deleted */
  numberOfElements?: InputMaybe<Scalars['Int']>;
}

export interface ConfirmationSummaryParamsInput {
  domainUrl?: InputMaybe<Scalars['String']>;
  orderId?: InputMaybe<Scalars['String']>;
  orderNumber?: InputMaybe<Scalars['String']>;
  orderStatus: OrderStatus;
  sessionId?: InputMaybe<Scalars['String']>;
}

export enum ConnectivityPartnerPortalAPIAccountType {
  PRODUCTION = 'PRODUCTION',
  SANDBOX = 'SANDBOX',
}

export enum ConnectivityPartnerPortalAPIAdoptionPhaseBadgeStatus {
  COMPLETED = 'COMPLETED',
  FUTURE = 'FUTURE',
  IN_PROGRESS = 'IN_PROGRESS',
}

export enum ConnectivityPartnerPortalAPIEventPayloadContentType {
  GRAPHQL = 'GRAPHQL',
  JSON = 'JSON',
  XML = 'XML',
}

export enum ConnectivityPartnerPortalBrand {
  EXPEDIA = 'EXPEDIA',
  VRBO = 'VRBO',
}

export enum ConnectivityPartnerPortalButtonVariant {
  DEFAULT = 'DEFAULT',
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
}

export enum ConnectivityPartnerPortalNavigationItemSeparatorType {
  HORIZONTAL_BAR = 'HORIZONTAL_BAR',
}

export enum ConnectivityPartnerPortalNavigationItemTextBadgeVariant {
  EXPEDIA = 'EXPEDIA',
  VRBO = 'VRBO',
}

export enum ConnectivityPartnerPortalSwitchButtonSide {
  LEFT = 'LEFT',
  RIGHT = 'RIGHT',
}

export enum ConnectivitySettingsButtonType {
  BACK = 'BACK',
  CANCEL = 'CANCEL',
  CHANGE = 'CHANGE',
  CONFIRM = 'CONFIRM',
  CONNECT = 'CONNECT',
  DISCONNECT = 'DISCONNECT',
  DOWNLOAD = 'DOWNLOAD',
  NEXT = 'NEXT',
}

export enum ConnectivitySettingsTabName {
  BY_PROVIDER = 'BY_PROVIDER',
  BY_SERVICE = 'BY_SERVICE',
}

/** Request used to create Financial Profile */
export interface ConsoleBillingProfileCreateUpdateRequestInput {
  billingProfile?: InputMaybe<BillingProfileDetailInput>;
  id: Scalars['String'];
  keyMap: PartnerBillingProfileKeyMapInput;
  type: PaymentPartnerType;
}

export enum ContactHostCTALocation {
  BOTTOM_RAIL = 'BOTTOM_RAIL',
  RIGHT_RAIL = 'RIGHT_RAIL',
}

export interface ContactUsFormContentInput {
  /** Customer Selected category from dropdown */
  category: Scalars['String'];
  /** Customer selected intent from dropdown */
  intent: Scalars['String'];
  /** Customer Entered Itinerary Number */
  itineraryNumber: Scalars['String'];
  /** Customer Entered Phone Number */
  phoneNumber: Scalars['String'];
}

export enum ContactUsOptionType {
  CALL_BACK_WITH_AGENT = 'CALL_BACK_WITH_AGENT',
  CALL_TO_AGENT = 'CALL_TO_AGENT',
  CHAT_BACK_WITH_AGENT = 'CHAT_BACK_WITH_AGENT',
  CHAT_WITH_AGENT = 'CHAT_WITH_AGENT',
  SEND_EMAIL_AGENT = 'SEND_EMAIL_AGENT',
}

export interface ContactUsPayloadInput {
  intentSelected?: InputMaybe<Scalars['String']>;
  productSelected?: InputMaybe<Scalars['String']>;
  viewType: ContactUsViewType;
}

/** Represents ContactUs Email Form */
export interface ContactUsSendEmailFormRequestInput {
  /** Email of customer */
  customerEmail: Scalars['String'];
  /** Name of customer */
  customerName: Scalars['String'];
  /** details of the email */
  details: Scalars['String'];
  /** intent */
  intent: Scalars['String'];
  /** product */
  product: Scalars['String'];
}

/** Represents Email Us Sheet Request */
export interface ContactUsSendEmailRequestInput {
  /** Email of customer */
  customerEmail: Scalars['String'];
  /** Name of customer */
  customerName: Scalars['String'];
  /** Message of email */
  message: Scalars['String'];
  /** subject of email */
  subject: Scalars['String'];
}

export enum ContactUsViewType {
  /** Blank page view, used for cases where no content is available or to reset the view */
  BLANK_PAGE = 'BLANK_PAGE',
  /** The view to display the contact options for chat */
  CHAT_OPTIONS = 'CHAT_OPTIONS',
  /** The view to display the contact options based on product and intent */
  CONTACT_OPTIONS = 'CONTACT_OPTIONS',
  /** The view to display the landing page for contact us */
  LANDING_PAGE = 'LANDING_PAGE',
  /** The view to display virtual agent */
  VIRTUAL_AGENT = 'VIRTUAL_AGENT',
  /** The view to display the contact options for voice */
  VOICE_OPTIONS = 'VOICE_OPTIONS',
}

/** UI Theme to be applied to a `UISectionContainer` or a `TripsSectionContainer`. */
export enum ContainerTheme {
  DEFAULT = 'DEFAULT',
  IMPORTANT = 'IMPORTANT',
}

export interface ContentActionPanelInput {
  coachingParameters?: InputMaybe<SupplyCoachingParameters>;
  type: Scalars['String'];
}

/** Ad content input */
export interface ContentInput {
  /** Ad type */
  ad_type: Scalars['String'];
  /** Ad content approval status */
  approvalStatus?: InputMaybe<ApprovalStatusType>;
  /** Ad creative for FSL */
  creativeFSL?: InputMaybe<FSLCreativeInput>;
  /** Ad creative LSL */
  creativeLSL?: InputMaybe<LSLCreativeInput>;
  /** Content id */
  id: Scalars['String'];
  /** Content locale */
  locale: Scalars['String'];
}

/** Represents the request for contentLikeInteractionMutation */
export interface ContentLikeInteractionRequestInput {
  action: LikeUnlikeSocialInteractionAction;
  postId: Scalars['String'];
  postType: SocialInteractionPostType;
  postUrl: Scalars['String'];
}

export interface ContentPaginationInput {
  pageNumber: Scalars['Int'];
  pageSize?: InputMaybe<Scalars['Int']>;
}

export interface ContentScoreInput {
  cardType?: InputMaybe<Scalars['String']>;
  previousScore?: InputMaybe<Scalars['String']>;
  skipForNow?: InputMaybe<Scalars['String']>;
  source: Scalars['String'];
}

/** Represents the request for contentShareInteractionMutation */
export interface ContentShareInteractionRequestInput {
  postId: Scalars['String'];
  postType: SocialInteractionPostType;
  postUrl: Scalars['String'];
}

export enum ContentSource {
  DESTINATION_API = 'DESTINATION_API',
  EM = 'EM',
}

/** The input BEX context used for identifying users, sites and other platform functions. See the platform-expsite docs for more info: https://docweb.prod.expedia.com/expsite */
export interface ContextInput {
  /** Information regarding the application which triggered the query */
  clientInfo?: InputMaybe<ClientInfoInput>;
  /** Currency as Alphabetic ISO 4217 code e.g. 'USD'. Use if default currency for Locale needs to be overwritten. */
  currency?: InputMaybe<Scalars['String']>;
  /** Debugging context, such as Abacus overrides */
  debugContext?: InputMaybe<DebugContextInput>;
  /** Client/user Device information */
  device: DeviceInput;
  /** The Expedia Affiliate Partner ID */
  eapid?: InputMaybe<Scalars['Int']>;
  /**
   * Optional Client/user information. Used for input only. Please send the DUIAD header instead.
   * We no longer rely on identity for user determination.
   * User determination is now based upon passed headers. Soon this will be made nullable and later removed.
   * Will be replaced by JWTs when available.
   */
  identity?: InputMaybe<IdentityInput>;
  /** The context locale, e.g. en_US */
  locale: Scalars['Locale'];
  /** User preference for tracking which is only required in POSs that require tracking opt in */
  privacyTrackingState?: InputMaybe<PrivacyTrackingState>;
  /** The context Site ID, e.g. (70201 for Orbitz) */
  siteId: Scalars['Int'];
  /** The legacy TravelProductID */
  tpid?: InputMaybe<Scalars['Int']>;
}

/** Represents any relevant attributes of a conversation */
export interface ConversationAttributesInput {
  /** Represents the URL of the page where the current conversation is taking place */
  currentPageUrl?: InputMaybe<Scalars['String']>;
  /** Represents conversation type */
  type?: InputMaybe<ConversationType>;
}

/** Conversation Authentication Request */
export interface ConversationAuthenticationRequestInput {
  /** Conversation Id */
  conversationId?: InputMaybe<Scalars['String']>;
  /** Traveler Participant Id */
  travelerParticipantId?: InputMaybe<Scalars['String']>;
}

/** Represents the context of a conversation */
export interface ConversationContextInput {
  /** Represents any relevant attributes of a conversation, such as the current pages's URL */
  attributes?: InputMaybe<ConversationAttributesInput>;
  /** Represents any relevant attributes of a conversation history, such as the offset, limit, identifier etc */
  conversationHistoryAttributes?: InputMaybe<Array<GraphQLPairInput>>;
  /** Represents the conversation ID, used to route messages */
  conversationId?: InputMaybe<Scalars['String']>;
  /** Represents conversationType of the chat instance */
  conversationType?: InputMaybe<ConversationType>;
  /** Represents the participant ID, used to identify the author of a message or the actor of an event */
  participantId?: InputMaybe<Scalars['String']>;
  /** Represents the span of messages to be fetch after websocket re-connect */
  sentAfterOffset?: InputMaybe<Scalars['Int']>;
}

/** Represents any relevant configs of a conversation */
export interface ConversationInitializationConfigsInput {
  /** Represents input data related to a conversation */
  conversation?: InputMaybe<ConversationInput>;
  /** Represents any relevant attributes of a conversation, such as the current page URL, conversationType */
  conversationAttributes?: InputMaybe<Array<VirtualAgentControlAttributeInput>>;
  /** Represents conversationType of the chat instance */
  conversationType?: InputMaybe<ConversationType>;
  /** Represents config to create a new conversation */
  forceNewConversation?: InputMaybe<Scalars['Boolean']>;
  /** Represents the intent data payload that is passed via an external Intent based message */
  intentData?: InputMaybe<VirtualAgentControlMessageInput>;
  /** Represents the intent data payload that is passed via an external Intent based message */
  intentPayload?: InputMaybe<Array<ChatbotIntentValueInput>>;
  /** Represents mode of conversation - create, join, resume, etc. */
  mode: ConversationMode;
  /** Represents input data related to a participant */
  participant?: InputMaybe<ParticipantInput>;
}

/** Represents input data related to a conversation */
export interface ConversationInput {
  /** Represents conversationId that needs to be resumed/join/observed. */
  conversationId: Scalars['String'];
}

export enum ConversationMessageType {
  DYNAMIC_CARD = 'DYNAMIC_CARD',
  GENERIC = 'GENERIC',
  IN_CHAT_NOTIFICATION = 'IN_CHAT_NOTIFICATION',
  WELCOME = 'WELCOME',
}

export enum ConversationMode {
  CREATE_CONVERSATION = 'CREATE_CONVERSATION',
  JOIN_CONVERSATION = 'JOIN_CONVERSATION',
  RESUME_CONVERSATION = 'RESUME_CONVERSATION',
}

export enum ConversationParticipantType {
  HumanAgent = 'HumanAgent',
  HumanAgentVA = 'HumanAgentVA',
  Supplier = 'Supplier',
  SupplierVA = 'SupplierVA',
  Traveler = 'Traveler',
  TravelerVA = 'TravelerVA',
}

export enum ConversationType {
  AI_CONCIERGE = 'AI_CONCIERGE',
  CHATGPT = 'CHATGPT',
  FLIGHT_COMPANION = 'FLIGHT_COMPANION',
  GOOGLE_ITINERARY = 'GOOGLE_ITINERARY',
  LODGING_COMPANION = 'LODGING_COMPANION',
  MAIN = 'MAIN',
  PROPERTY_COMPARE = 'PROPERTY_COMPARE',
  ROMIE_V1 = 'ROMIE_V1',
  ROMIE_V1_VARIANT = 'ROMIE_V1_VARIANT',
  SUPPLIER = 'SUPPLIER',
  TRIP_COLLABORATION = 'TRIP_COLLABORATION',
}

/** A latitude/longitude pair */
export interface CoordinatesInput {
  /** The latitude of the point in degrees */
  latitude: Scalars['Float'];
  /** The longitude of the point in degrees */
  longitude: Scalars['Float'];
}

/** Traveler Input Section to insert params to get the estimates for */
export interface CostEstimatorInput {
  /** Destination Region Id */
  destinationRegionId?: InputMaybe<Scalars['String']>;
  /** Monthly Flight Insights Data */
  flightInsights?: InputMaybe<Array<CostInsightCollectionInput>>;
  /** Food Insight Data */
  foodInsight?: InputMaybe<CostInsightDataInput>;
  /** Trigger Call to Downstream if the destination is New */
  isNewDestinationIdentified: Scalars['Boolean'];
  /** Month To compute the estimates for */
  month?: InputMaybe<Scalars['String']>;
  /** Number of Days to calculate estimate for */
  numDays: Scalars['Int'];
  /** Number of rooms to calculate estimate for */
  numRooms: Scalars['Int'];
  /** Number of travelers to calculate estimate for */
  numTravelers: Scalars['Int'];
  /** Source Region Id */
  sourceRegionId?: InputMaybe<Scalars['String']>;
  /** Monthly Stays Insights Data */
  stayInsights?: InputMaybe<Array<CostInsightCollectionInput>>;
}

export interface CostInsightCollectionInput {
  /** Month to which the estimates belong to */
  key: Scalars['String'];
  /** Cost insight info for the month */
  value: CostInsightDataInput;
}

/** Cost Insights to be used for later  */
export interface CostInsightDataInput {
  /** Avg Cost Insight */
  avgCost?: InputMaybe<Scalars['Float']>;
  /** Max Cost Insight */
  maxCost?: InputMaybe<Scalars['Float']>;
  /** Min Cost Insight */
  minCost?: InputMaybe<Scalars['Float']>;
}

/** Coupon campaign status */
export enum CouponCampaignStatus {
  ACTIVE = 'ACTIVE',
  EXPIRED = 'EXPIRED',
  INACTIVE = 'INACTIVE',
  NOT_STARTED = 'NOT_STARTED',
}

export interface CouponIdentifierInput {
  type: CouponIdentifierType;
  value: Scalars['String'];
}

export enum CouponIdentifierType {
  CODE = 'CODE',
  INSTANCE_ID = 'INSTANCE_ID',
}

export interface CreateReviewFormRequestInput {
  campaignId: Scalars['String'];
  clickSource?: InputMaybe<Scalars['String']>;
  hotelVipStatus?: InputMaybe<Scalars['String']>;
  orderNumber: Scalars['String'];
  overallRating: Scalars['Int'];
  productId: Scalars['String'];
  userMemberType?: InputMaybe<Scalars['String']>;
}

export enum CreditCardAccountPlacementSourcePage {
  GLOBAL_NAV = 'GLOBAL_NAV',
  REWARDS = 'REWARDS',
  UNIVERSAL_PROFILE = 'UNIVERSAL_PROFILE',
}

export enum CreditCardAccountPlacementVariant {
  /** The variant with medium heading, subheading, and bottom label */
  MEDIUM = 'MEDIUM',
  /** The variant with small heading and subheading */
  SMALL = 'SMALL',
}

export interface CreditCardApplicationConfirmIdentityScreenInput {
  cardType: CreditCardType;
  phoneNumber: Scalars['String'];
}

export interface CreditCardApplicationDeclineOfferInput {
  applicationId: Scalars['String'];
  applicationToken: Scalars['String'];
}

/** This enum follows the [bash comparison operators](https://tldp.org/LDP/abs/html/comparison-ops.html) convention */
export enum CreditCardApplicationFormOperation {
  EQ = 'EQ',
  GE = 'GE',
  GT = 'GT',
  LE = 'LE',
  LT = 'LT',
  NE = 'NE',
  NREX = 'NREX',
  REX = 'REX',
}

export interface CreditCardApplicationFormQueryInput {
  landingUrl?: InputMaybe<Scalars['String']>;
  sourcePage: CreditCardSourcePage;
}

export interface CreditCardApplicationFormScreenQueryInput {
  acquisitionId: Scalars['String'];
  applicationFormPrefillInfo?: InputMaybe<Array<GraphQLPairInput>>;
  cardType: CreditCardType;
  sourcePage: CreditCardSourcePage;
}

/** Credit card application update mutation input object; */
export interface CreditCardApplicationFormUpdateInput {
  /** Application ID of the Credit Card application process */
  applicationId: Scalars['String'];
  /** Application token of the Credit Card application process */
  applicationToken: Scalars['String'];
  fields: CreditCardApplicationFormValuesInput;
}

/** Input object containing the application form field values */
export interface CreditCardApplicationFormValuesInput {
  fieldValues: Array<GraphQLPairInput>;
}

export enum CreditCardApplicationHeadingSize {
  LARGE = 'LARGE',
  SMALL = 'SMALL',
}

export interface CreditCardApplicationOfferInput {
  applicationId: Scalars['String'];
  applicationToken: Scalars['String'];
  secureConsent: CreditCardApplicationSecureConsentInput;
}

export interface CreditCardApplicationPrefillQueryInput {
  landingUrl?: InputMaybe<Scalars['String']>;
  sourcePage: CreditCardSourcePage;
}

export enum CreditCardApplicationSSAConsent {
  /** Missing/Suppressed */
  M = 'M',
  /** Customer NOT agreed */
  N = 'N',
  /** Not applicable/ITIN entered */
  X = 'X',
  /** Customer agreed */
  Y = 'Y',
}

export interface CreditCardApplicationSecureConsentInput {
  creditConsent?: InputMaybe<Scalars['Boolean']>;
  disclosureCreatedDatetime?: InputMaybe<Scalars['String']>;
  eSignConsent?: InputMaybe<Scalars['Boolean']>;
  mobileInformationConsent?: InputMaybe<Scalars['Boolean']>;
  phoneConsent?: InputMaybe<Scalars['Boolean']>;
  ssaConsent?: InputMaybe<Scalars['Boolean']>;
  termsAgreementConsent?: InputMaybe<Scalars['Boolean']>;
  wellsFargoPrivacyPolicyConsent?: InputMaybe<Scalars['Boolean']>;
}

export interface CreditCardApplicationSubmissionInput {
  applicationId: Scalars['String'];
  applicationToken: Scalars['String'];
  authorizedUserFields?: InputMaybe<Array<GraphQLPairInput>>;
  cardType: CreditCardType;
  ssaConsent: CreditCardApplicationSSAConsent;
}

export interface CreditCardApplicationThankYouInput {
  /** First name of the applicant for the Credit Card */
  applicantFirstName: Scalars['String'];
  applicationID: Scalars['String'];
  applicationToken: Scalars['String'];
  /** Credit Card type the traveler applied for */
  cardType: CreditCardType;
  /** Enum to request either the `Thank You, Pending/Approved` screen. */
  screenType: CreditCardThankYouScreenType;
}

export interface CreditCardBenefitsInput {
  landingUrl?: InputMaybe<Scalars['String']>;
}

export interface CreditCardCheckPrequalificationInput {
  acquisitionId: Scalars['String'];
  fields: CreditCardApplicationFormValuesInput;
}

/** The request of the mutation. */
export interface CreditCardCheckoutSessionValidateRequestInput {
  /** The checkout session ID coming from the Checkout context */
  sessionId: Scalars['String'];
}

/** See https://github.expedia.biz/eg-business-domains/travel-api-common/blob/main/travel-api-taxonomy/src/main/resources/taxonomy/taxonomycheckoutsignaltype-concept-mapping.csv */
export enum CreditCardCheckoutSignalType {
  OFFER_CHANGED = 'OFFER_CHANGED',
  PRICE_ADJUSTED = 'PRICE_ADJUSTED',
  PRICE_CHANGED = 'PRICE_CHANGED',
  USER_TIER_UPGRADED = 'USER_TIER_UPGRADED',
}

export interface CreditCardComparisonHeaderInput {
  landingUrl?: InputMaybe<Scalars['String']>;
}

export interface CreditCardComparisonTableInput {
  landingUrl?: InputMaybe<Scalars['String']>;
}

export interface CreditCardConfirmIdentityRequestCodeInput {
  acquisitionId: Scalars['String'];
}

export interface CreditCardConfirmIdentitySendCodeInput {
  /** The 'creditCardAcquisitionId' returned by the Credit Card Application start API. */
  acquisitionId: Scalars['String'];
  securityCode: Scalars['String'];
}

export enum CreditCardContentFormat {
  HTML = 'HTML',
  PDF = 'PDF',
}

export enum CreditCardContentSource {
  TERMS_AND_CONDITIONS = 'TERMS_AND_CONDITIONS',
}

export enum CreditCardDialogType {
  EARLY_EXIT = 'EARLY_EXIT',
}

export interface CreditCardEncodedContentInput {
  applicationId: Scalars['String'];
  applicationToken: Scalars['String'];
  /** The Credit Card type the traveler is applying for */
  cardType: CreditCardType;
  /** The requested format of the downloadable content. */
  contentFormat: CreditCardContentFormat;
  /** The declared source of the downloadable content */
  contentSource: CreditCardContentSource;
}

export enum CreditCardEncodingType {
  Base64 = 'Base64',
}

export interface CreditCardErrorScreenInput {
  /** To get the correct banner, if any */
  cardType?: InputMaybe<CreditCardType>;
  /** To have the possible secondary button */
  sourcePage: CreditCardSourcePage;
}

export enum CreditCardFraudOTPError {
  EXPIRED_CODE = 'EXPIRED_CODE',
  INVALID_CODE = 'INVALID_CODE',
}

export interface CreditCardFraudOTPGenerateInput {
  applicationToken: Scalars['String'];
  passcodeInstructionId: Scalars['String'];
  phoneNumberLastFour: Scalars['String'];
}

export interface CreditCardFraudOTPInput {
  applicationToken: Scalars['String'];
  passcode?: InputMaybe<Scalars['String']>;
  passcodeInstructionId: Scalars['String'];
  phoneNumberLastFour?: InputMaybe<Scalars['String']>;
  screenType: CreditCardFraudOTPScreenType;
}

export enum CreditCardFraudOTPScreenType {
  GENERATE_CODE = 'GENERATE_CODE',
  VERIFY_CODE = 'VERIFY_CODE',
}

export interface CreditCardFraudOTPVerifyInput {
  applicationToken: Scalars['String'];
  passcode: Scalars['String'];
  passcodeInstructionId: Scalars['String'];
}

export interface CreditCardMojoContextInput {
  pageName: Scalars['String'];
  placementId: Scalars['String'];
}

export interface CreditCardPrefillSendTextInput {
  acquisitionId: Scalars['String'];
  phoneNumber: Scalars['String'];
  ssnLastFour: Scalars['String'];
}

export enum CreditCardRecaptureReason {
  CONTACT_ISSUING_BANK = 'CONTACT_ISSUING_BANK',
  GUEST_NAME_CARD_NAME_MISMATCH = 'GUEST_NAME_CARD_NAME_MISMATCH',
  INSUFFICIENT_FUNDS = 'INSUFFICIENT_FUNDS',
  INVALID_ACCOUNT = 'INVALID_ACCOUNT',
  INVALID_CREDIT_CARD_NUMBER = 'INVALID_CREDIT_CARD_NUMBER',
  INVALID_EXPIRATION_DATE = 'INVALID_EXPIRATION_DATE',
  INVALID_SECURITY_CODE = 'INVALID_SECURITY_CODE',
  NETWORK_ERROR = 'NETWORK_ERROR',
  OTHER = 'OTHER',
}

export interface CreditCardRemoteValidationInput {
  acquisitionId: Scalars['String'];
  value: Scalars['String'];
}

/** Represents the value to map to the related mutation */
export enum CreditCardRemoteValidationType {
  SSN_ITIN = 'SSN_ITIN',
}

export enum CreditCardScreen {
  APPLICATION_FORM = 'APPLICATION_FORM',
  ERROR = 'ERROR',
  FRAUD_OTP_GENERATE = 'FRAUD_OTP_GENERATE',
  FRAUD_OTP_VERIFY = 'FRAUD_OTP_VERIFY',
  OFFER = 'OFFER',
  /** the travellers will be redirected to the screen where they started from (Pillar/Checkout) */
  ORIGIN = 'ORIGIN',
  PREFILL_CONFIRM_YOUR_IDENTITY = 'PREFILL_CONFIRM_YOUR_IDENTITY',
  TERMS_AND_CONDITIONS = 'TERMS_AND_CONDITIONS',
  THANK_YOU_APPROVED = 'THANK_YOU_APPROVED',
  THANK_YOU_PENDING = 'THANK_YOU_PENDING',
}

/** Page where application for Credit Card was started */
export enum CreditCardSourcePage {
  /** Application/Pillar Page */
  APPLICATION = 'APPLICATION',
  /** Checkout */
  CHECKOUT = 'CHECKOUT',
}

export enum CreditCardThankYouScreenType {
  APPROVED = 'APPROVED',
  PENDING = 'PENDING',
}

export enum CreditCardType {
  FEE = 'FEE',
  NO_FEE = 'NO_FEE',
}

export enum CreditEligibleFilterType {
  CREDIT_ELIGIBLE = 'CREDIT_ELIGIBLE',
}

export interface CrossLinksParameterInput {
  name: Scalars['String'];
  value: Scalars['String'];
}

export enum CrossSellProductType {
  ACTIVITY = 'ACTIVITY',
  CAR = 'CAR',
  FLIGHT = 'FLIGHT',
  GROUND_TRANSFER = 'GROUND_TRANSFER',
  HOTEL = 'HOTEL',
}

/** Represent the current location of the User so we can propose an origin for the flights */
export interface CrossSellUserLocationInput {
  /** The city of User's current location. ex: SANJOSE */
  city: Scalars['String'];
  /** The continent code of User's current location. ex: NA */
  continent: Scalars['String'];
  /** The country code of User's current location. ex: US */
  country: Scalars['String'];
  /** The region or state code of User's current location. ex: CA */
  region: Scalars['String'];
}

/** Amenities on a sailing */
export interface CruiseAmenitiesListInput {
  /** Amenities items to display. */
  amenities: Array<CruiseAmenityInfoInput>;
  /** Heading for the amenities */
  heading?: InputMaybe<Scalars['String']>;
}

/** Amenity on a sailing */
export interface CruiseAmenityInfoInput {
  /** Category of amenity */
  a11yCategory?: InputMaybe<Scalars['String']>;
  /** Amenity description */
  a11yDescription: Scalars['String'];
  /** Category of amenity */
  category?: InputMaybe<Scalars['String']>;
  /** Amenity description */
  description: Scalars['String'];
  /** Icon of amenity */
  icon: CruiseOrderSummaryRatesPromotionIconInfoInput;
}

export enum CruiseBadgeTheme {
  DEAL_GENERIC = 'DEAL_GENERIC',
  DEAL_MEMBER = 'DEAL_MEMBER',
  GLOBAL_LOYALTY_EXTRAHIGH_TIER = 'GLOBAL_LOYALTY_EXTRAHIGH_TIER',
  GLOBAL_LOYALTY_HIGH_TIER = 'GLOBAL_LOYALTY_HIGH_TIER',
  GLOBAL_LOYALTY_LOW_TIER = 'GLOBAL_LOYALTY_LOW_TIER',
  GLOBAL_LOYALTY_MID_TIER = 'GLOBAL_LOYALTY_MID_TIER',
  VIP = 'VIP',
}

/** A guest over the age of 2 */
export interface CruiseChildInput {
  /** The child's age in years */
  age: Scalars['Int'];
}

/** Users' inputs */
export interface CruiseConsultationFormInput {
  /** Adults (18+) */
  adultCount: Scalars['Int'];
  /** Children (0-17) */
  childCount: Scalars['Int'];
  /** Country/Territory */
  country: Scalars['String'];
  /** Dates Flexible */
  datesFlexible?: InputMaybe<Scalars['String']>;
  /** Email Address */
  emailAddress: Scalars['String'];
  /** Ever Cruised */
  everCruised?: InputMaybe<Scalars['String']>;
  /** First Name */
  firstName: Scalars['String'];
  /** Last Name */
  lastName: Scalars['String'];
  /** Passengers Over 55 */
  passengersOver55?: InputMaybe<Scalars['String']>;
  /** Phone Number */
  phoneNumber: Scalars['String'];
  /** Questions */
  questions?: InputMaybe<Scalars['String']>;
  /** Room Type Preference */
  roomTypePreference: Scalars['String'];
  /** ZIP Code */
  zipCode: Scalars['String'];
}

/** Duration of cruise to perform a cruise search */
export interface CruiseDurationRangeInput {
  max: Scalars['Int'];
  min: Scalars['Int'];
}

export enum CruiseFeature {
  CRUISE_WLT = 'CRUISE_WLT',
  LIVE_SHOPPING_USING_MSC_ADAPTER = 'LIVE_SHOPPING_USING_MSC_ADAPTER',
  MEMBER_DEALS = 'MEMBER_DEALS',
  MEMBER_DEALS_FOR_NON_MEMBERS = 'MEMBER_DEALS_FOR_NON_MEMBERS',
}

export enum CruiseFilterType {
  /** cabin experience - eg. Suite  */
  CABIN = 'CABIN',
  /** departure port */
  DEPARTURE = 'DEPARTURE',
  /** use for filtering by the destination */
  DESTINATION = 'DESTINATION',
  /** length of cruise nights 1-2, 3-5, 6-9 , 10-14, 15+ */
  LENGTH = 'LENGTH',
  /** use for filtering by the cruise line name */
  NAME = 'NAME',
  /** default not set value */
  NOT_SET = 'NOT_SET',
  /** ship type */
  SHIP = 'SHIP',
  /** use for ocean cruise */
  THEME_OCEAN = 'THEME_OCEAN',
  /** use for river cruise */
  THEME_RIVER = 'THEME_RIVER',
}

/** Cruise line policy */
export interface CruiseLinePolicyInput {
  /** Link to the policy page */
  link?: InputMaybe<Scalars['String']>;
}

/** Represents the promotion details */
export interface CruiseOrderSummaryPromotionDetailsInput {
  /** Amenity associated with a promotion */
  amenityInfo: CruiseAmenityInfoInput;
  /** Cruise line cancellation policy */
  cancellationPolicy?: InputMaybe<CruiseLinePolicyInput>;
  /** Instructions with a promotion */
  cruiseOrderSummaryPromotionInstruction?: InputMaybe<CruiseOrderSummaryPromotionInstructionInput>;
  /** Policies with a promotion */
  cruiseOrderSummaryPromotionPolicy?: InputMaybe<CruiseOrderSummaryPromotionPolicyInput>;
}

/** Expando showing already included amenities */
export interface CruiseOrderSummaryPromotionExpandoInput {
  /** Represents amenities included with the room as well as sailing */
  combinedAmenities?: InputMaybe<Array<CruiseAmenitiesListInput>>;
}

/** Represents the promotion instruction */
export interface CruiseOrderSummaryPromotionInstructionInput {
  /** Code of the promotion */
  promotionCode: Scalars['String'];
  /** Name of the promotion */
  promotionName?: InputMaybe<Scalars['String']>;
  /** Details about the promotion instruction */
  text: Scalars['String'];
  /** Title of the promotion instruction */
  title: Scalars['String'];
}

/** Represents the promotion policy */
export interface CruiseOrderSummaryPromotionPolicyInput {
  /** Description of the promotion policy */
  text: Scalars['String'];
  /** Title of the promotion policy */
  title: Scalars['String'];
}

/** Promotion details side sheet in the Order Summary page */
export interface CruiseOrderSummaryPromotionSideSheetInput {
  /** List of promotion details */
  cruiseOrderSummaryPromotionDetails: Array<CruiseOrderSummaryPromotionDetailsInput>;
  /** Already included amenities expando */
  expando: CruiseOrderSummaryPromotionExpandoInput;
  /** Terms and conditions link */
  termsAndConditions?: InputMaybe<CruiseOrderSummaryPromotionTermsAndConditionsInput>;
  /** Description of the promotions */
  text?: InputMaybe<Array<Scalars['String']>>;
}

/** Promotion details side sheet in the Order Summary page */
export interface CruiseOrderSummaryPromotionTermsAndConditionsInput {
  /** Terms and conditions link */
  link?: InputMaybe<CruiseOrderSummaryRatesUILinkActionInfoInput>;
}

export interface CruiseOrderSummaryRatesInfoInput {
  /** Offer token */
  offerToken: Scalars['String'];
  /** Price Info */
  price: CruiseOrderSummaryRatesPriceInput;
  /** Promotion details side sheet */
  promotionDetails?: InputMaybe<CruiseOrderSummaryPromotionSideSheetInput>;
  /** Promotions Info */
  promotions: Array<CruiseOrderSummaryRatesPromotionInfoInput>;
  /** Update info */
  updateInfo?: InputMaybe<CruiseOrderSummaryRatesUpdateInfoInput>;
}

export interface CruiseOrderSummaryRatesInput {
  /** Number of adults - Default is 2 */
  adultCount: Scalars['Int'];
  /** Cabin experience */
  cabinExperience: Scalars['String'];
  /** Cabin type */
  cabinType: Scalars['String'];
  /** Optional information populated for users redirecting from the Checkout page */
  checkoutRedirectInput?: InputMaybe<CheckoutRedirectInput>;
  /** children ages */
  childAges?: InputMaybe<Array<CruiseChildInput>>;
  /** Number of children - Default is 0 */
  childCount: Scalars['Int'];
  /** Collection of cabins with the base cabin included */
  groupedCabins?: InputMaybe<Array<CabinInput>>;
  /** Lead in price shown to the user in infosite sidesheet */
  leadInPrice?: InputMaybe<Scalars['Float']>;
  /** Sailing token */
  sailingToken: Scalars['String'];
}

export interface CruiseOrderSummaryRatesPageDataInput {
  /** Info about rates displayed on the page. */
  ratesInfo: Array<CruiseOrderSummaryRatesInfoInput>;
  /** Index of the rate selected by the user */
  selectedRateIndex: Scalars['Int'];
}

export interface CruiseOrderSummaryRatesPriceChangeMessageInput {
  /** Price */
  price: Scalars['String'];
  /** Type of change, increase/decrease */
  type: Scalars['String'];
}

export interface CruiseOrderSummaryRatesPriceInput {
  /** Base fare Info */
  baseFare?: InputMaybe<CurrencyTypeInput>;
  /** Cabin category title */
  cabinCategoryTitle: Scalars['String'];
  /** Cruise line code */
  cruiseLineCode?: InputMaybe<Scalars['String']>;
  /** Price Info for the price displayed during initial page load */
  initialPrice?: InputMaybe<CurrencyAmountTypeInput>;
  /** Sold out rate flag */
  isSoldOut: Scalars['Boolean'];
  /** Member pricing Info */
  memberPricing: MemberPricingInput;
  /** Price Info for the price currently displayed to the user */
  price?: InputMaybe<CurrencyAmountTypeInput>;
  /** Rate category Info */
  rateCategory: RateCategoryInput;
  /** Strike out price info */
  strikeoutPrice?: InputMaybe<CurrencyAmountTypeInput>;
}

export interface CruiseOrderSummaryRatesPromotionIconInfoInput {
  /** Description of the Icon */
  description: Scalars['String'];
  /** Id of the Icon */
  id: Scalars['String'];
  /** Token of the Icon */
  token: Scalars['String'];
}

export interface CruiseOrderSummaryRatesPromotionInfoInput {
  /** Full Name of the promotion */
  fullName: Scalars['String'];
  /** Icon of the promotion */
  icon: CruiseOrderSummaryRatesPromotionIconInfoInput;
}

export interface CruiseOrderSummaryRatesUILinkActionInfoInput {
  /** Url link */
  url: Scalars['String'];
}

export interface CruiseOrderSummaryRatesUpdateInfoInput {
  /** Price change message to display on the rate */
  priceChangeMessage?: InputMaybe<CruiseOrderSummaryRatesPriceChangeMessageInput>;
}

export interface CruiseRequestContextInput {
  /** Cruise features enum to be passed down to cruise supply services as a header value */
  cruiseFeatures?: InputMaybe<Array<CruiseFeature>>;
  /** Default current to be used. If not set, cruise api will fall back to USD */
  defaultCurrency?: InputMaybe<Scalars['String']>;
  /** Inventory is striped by an optional franchise model key. More info here: https://confluence.expedia.biz/display/EWECruise/Design%3A+Franchise+Model+Key+Management */
  franchiseModelKey?: InputMaybe<Scalars['String']>;
  /** Flag that is set when the user is shopping as an agent from Partner Central */
  isAgent?: InputMaybe<Scalars['Boolean']>;
}

export interface CruiseSailingCabinCategoriesInput {
  /** Number of adults - Default is 2 */
  adultCount: Scalars['Int'];
  /** Cabin experience */
  cabinExperience: Scalars['String'];
  /** children ages */
  childAges?: InputMaybe<Array<CruiseChildInput>>;
  /** Number of children - Default is 0 */
  childCount: Scalars['Int'];
}

/** Represents the cruise sailing details input needed for Cruise PDP */
export interface CruiseSailingDetailsCriteriaInput {
  primary: PrimaryCruiseSailingDetailsCriteriaInput;
  secondary?: InputMaybe<ShoppingSearchCriteriaInput>;
}

/** Property criteria needed to perform a cruise search */
export interface CruiseSearchCriteriaInput {
  primary: PrimaryCruiseCriteriaInput;
  secondary?: InputMaybe<ShoppingSearchCriteriaInput>;
}

export interface CruiseSearchFiltersInput {
  /** 1 or more cruise line codes separated by ',' delimiter  */
  cruiseLines?: InputMaybe<Scalars['String']>;
  /** 1 or more port codes separated by ',' delimiter  */
  departureLocations?: InputMaybe<Scalars['String']>;
  /** 1 or more deeplink destination names separated by ',' delimiter  */
  destinationNames?: InputMaybe<Scalars['String']>;
  /** Earliest departure date */
  earliestDeptDate?: InputMaybe<Scalars['String']>;
  /** CruiseFilterType enum name to describe the primary function of the SearchFilter */
  filterType: CruiseFilterType;
  /** Latest departure date */
  latestDeptDate?: InputMaybe<Scalars['String']>;
  /** Max length of sailing */
  maxLength?: InputMaybe<Scalars['String']>;
  /** Return sailings with member only offer */
  memberOnlyOffer?: InputMaybe<Scalars['Boolean']>;
  /** Min length of sailing */
  minLength?: InputMaybe<Scalars['String']>;
  /** 1 or more promotion codes separated by ',' delimiter  */
  promotionCode?: InputMaybe<Scalars['String']>;
  /** ocean or river */
  sailingVarieties?: InputMaybe<Scalars['String']>;
  /** 1 or more ship codes separated by ',' delimiter  */
  ships?: InputMaybe<Scalars['String']>;
  /** Cabin type filter. One of the ANY, INSIDE, OCEAN_VIEW, BALCONY or SUITE */
  superCategoryCode?: InputMaybe<Scalars['String']>;
}

/**
 * Values : popularity - sorts by Popularity
 * price - sorts by the offer price within all sailings returned
 * length - sorts by the sailing itinerary length, in days
 * departureDate - sorts by sailing departure/embarkation date
 * cruiseLine - sorts by cruise line name
 */
export interface CruiseSearchOptionsInput {
  /** Number of adults - Default is 2 */
  adultCount: Scalars['Int'];
  /** Number of children - Default is 0 */
  childCount: Scalars['Int'];
  /** Limit of how many results will be returned. - Default is 20 */
  limit: Scalars['Int'];
  /** Limit of how many results will be skipped. - Default is 0 */
  offset?: InputMaybe<Scalars['Int']>;
  /** Field to sort results by - Default is departure-date */
  sortBy?: InputMaybe<Scalars['String']>;
}

export interface CurrencyAmountTypeInput {
  /** Amount in the currency. */
  amount?: InputMaybe<Scalars['Float']>;
  /** Currency code. */
  currencyCode?: InputMaybe<Scalars['String']>;
}

export interface CurrencyTypeInput {
  /** Default currency amount info */
  defaultCurrencyAmount?: InputMaybe<CurrencyAmountTypeInput>;
  /** Supply currency amount info */
  supplyCurrencyAmount?: InputMaybe<CurrencyAmountTypeInput>;
}

/** Gender of the customer */
export enum CustomerGender {
  FEMALE = 'FEMALE',
  MALE = 'MALE',
  UNKNOWN = 'UNKNOWN',
}

/** The button type of the Customer notification submit button */
export enum CustomerNotificationFormButtonType {
  /** Type of floating action button */
  FLOATING_ACTION_BUTTON = 'FLOATING_ACTION_BUTTON',
  /** Type of primary button */
  PRIMARY_BUTTON = 'PRIMARY_BUTTON',
  /** Type of secondary button */
  SECONDARY_BUTTON = 'SECONDARY_BUTTON',
  /** Type of tertiary button */
  TERTIARY_BUTTON = 'TERTIARY_BUTTON',
}

/** Represents the target of the link */
export enum CustomerNotificationLinkTarget {
  NEW_TAB = 'NEW_TAB',
  SAME_TAB = 'SAME_TAB',
}

/** Represents the link type */
export enum CustomerNotificationLinkType {
  ANCHOR = 'ANCHOR',
  APP_DOWNLOAD_LINK = 'APP_DOWNLOAD_LINK',
  BUTTON = 'BUTTON',
  FLOATING_ACTION_BUTTON = 'FLOATING_ACTION_BUTTON',
  PRIMARY_BUTTON = 'PRIMARY_BUTTON',
  SECONDARY_BUTTON = 'SECONDARY_BUTTON',
  TERTIARY_BUTTON = 'TERTIARY_BUTTON',
}

/** The display type of the Customer notification message */
export enum CustomerNotificationMessageDisplayType {
  /** Display the message for the form */
  FORM = 'FORM',
  /** Dislay message on the page level, eg: fly-in message on the page */
  PAGE = 'PAGE',
}

/** The level type of the Customer notification message */
export enum CustomerNotificationMessageLevel {
  /** Type of error for the message */
  ERROR = 'ERROR',
  /** Type of success for the message */
  SUCCESS = 'SUCCESS',
  /** Type of warning for the message */
  WARNING = 'WARNING',
}

export enum CustomerNotificationMessageType {
  /** INVALID_INPUT message */
  INVALID_INPUT = 'INVALID_INPUT',
  /** SERVICE_ERROR message */
  SERVICE_ERROR = 'SERVICE_ERROR',
  /** SUCCESS message */
  SUCCESS = 'SUCCESS',
}

/** Represents the attributes on a notification that could be changed after an interaction */
export interface CustomerNotificationModifiableAttributesInput {
  /** Set to true when notification is dismissed */
  dismiss?: InputMaybe<Scalars['Boolean']>;
  /** Notification id */
  id?: InputMaybe<Scalars['String']>;
  /** Set to true when notification is read */
  read?: InputMaybe<Scalars['Boolean']>;
  /** Set to true when notification is seen */
  seen?: InputMaybe<Scalars['Boolean']>;
  /** Set to true when notification is starred */
  star?: InputMaybe<Scalars['Boolean']>;
}

/** Optional information to get a better contextual customer notification */
export interface CustomerNotificationOptionalContextInput {
  /** itinerary number */
  itineraryNumber?: InputMaybe<Scalars['String']>;
  /** list of journey criteria items */
  journeyCriterias?: InputMaybe<Array<CustomerNotificationOptionalContextJourneyCriteriaInput>>;
  /** the optional URL input field to retrieve extra url information, such as deep linking url for the mobile app download notification */
  referer?: InputMaybe<Scalars['URL']>;
  /** regionId number */
  regionId?: InputMaybe<Scalars['String']>;
  /** list of GAIA regionIds */
  regionIds?: InputMaybe<Array<Scalars['String']>>;
  /** trip folder id */
  tripFolderId?: InputMaybe<Scalars['String']>;
}

/** Journey criteria such as location gaia id and travel date ranges */
export interface CustomerNotificationOptionalContextJourneyCriteriaInput {
  /** start date and end date of the trip */
  dateRange?: InputMaybe<DateRangeInput>;
  /** destination information */
  destination?: InputMaybe<CustomerNotificationOptionalContextJourneyCriteriaLocationInput>;
  /** origin information */
  origin?: InputMaybe<CustomerNotificationOptionalContextJourneyCriteriaLocationInput>;
}

/** Journey criteria such as location gaia id and travel date ranges */
export interface CustomerNotificationOptionalContextJourneyCriteriaLocationInput {
  /** airport code */
  airportTLA?: InputMaybe<Scalars['String']>;
  /** property id */
  propertyId?: InputMaybe<Scalars['String']>;
  /** regionId number */
  regionId?: InputMaybe<Scalars['String']>;
}

/** The style to apply to phrase links */
export enum CustomerNotificationPhraseLinkStyle {
  FLOATING_ACTION_BUTTON = 'FLOATING_ACTION_BUTTON',
  PRIMARY_BUTTON = 'PRIMARY_BUTTON',
  SECONDARY_BUTTON = 'SECONDARY_BUTTON',
  TERTIARY_BUTTON = 'TERTIARY_BUTTON',
}

/** The text style to apply to strings */
export enum CustomerNotificationPhrasePartStyle {
  /** Italic styling */
  EMPHASIS = 'EMPHASIS',
  /** Bold styling */
  IMPORTANT = 'IMPORTANT',
  /** Represents no style or regular text */
  STANDARD = 'STANDARD',
}

export enum CustomerNotificationType {
  APP_DOWNLOAD = 'APP_DOWNLOAD',
  APP_HERO = 'APP_HERO',
  CITI_COBRAND = 'CITI_COBRAND',
  CITI_COBRAND_VERTICAL = 'CITI_COBRAND_VERTICAL',
  CLEANLINESS = 'CLEANLINESS',
  GDPR = 'GDPR',
  GENERIC = 'GENERIC',
  HEADER = 'HEADER',
  INBOX = 'INBOX',
  MAD_MARQUEE = 'MAD_MARQUEE',
  NONE = 'NONE',
  OSANO = 'OSANO',
  TAKEOVER = 'TAKEOVER',
  TRAVEL_ADVISORY = 'TRAVEL_ADVISORY',
}

/** Represents the the user input for customer notification mutation */
export interface CustomerNotificationUserInput {
  /** Represents list of customer notification user input */
  inputs: Array<CustomerNotificationUserInputElementInput>;
}

/** Represents customer notification user input */
export interface CustomerNotificationUserInputElementInput {
  /** Represents the type of customer notification user input */
  type: Scalars['String'];
  /** Represents the value of customer notification user input */
  value: Scalars['String'];
}

export enum DamageLiability {
  COF = 'COF',
  RDD = 'RDD',
}

export enum DashboardType {
  DEFERRED_PAYMENT = 'DEFERRED_PAYMENT',
  PERFORMANCE = 'PERFORMANCE',
}

/**
 * Used to identify the downstream data source.
 * ENTITY: A stateful data service driven by the owning domain
 * CART: Cart Service
 * OFFER: Offer Service
 * ORDER: Ordering Service
 * CHECKOUT: Core Checkout Identifying Service
 */
export enum DataSourceType {
  CART = 'CART',
  CHECKOUT = 'CHECKOUT',
  ENTITY = 'ENTITY',
  OFFER = 'OFFER',
  ORDER = 'ORDER',
}

/** Represents the internally supported actions/events in the DataTable. */
export enum DataTableActionType {
  REFRESH = 'REFRESH',
  RESET = 'RESET',
  SNAPSHOT = 'SNAPSHOT',
}

/** Used for aligning elements within a DataTable. Only for use with DataTable. */
export enum DataTableAlignItems {
  CENTER = 'CENTER',
  END = 'END',
  START = 'START',
  STRETCH = 'STRETCH',
}

/** Used to specify element flow direction within a DataTable. Only for use with DataTable. */
export enum DataTableElementsFlowDirection {
  COLUMN = 'COLUMN',
  COLUMN_REVERSE = 'COLUMN_REVERSE',
  ROW = 'ROW',
  ROW_REVERSE = 'ROW_REVERSE',
}

/** Used to justify elements within a DataTable. Only for use with DataTable. */
export enum DataTableElementsJustifyContent {
  CENTER = 'CENTER',
  END = 'END',
  SPACE_AROUND = 'SPACE_AROUND',
  SPACE_BETWEEN = 'SPACE_BETWEEN',
  START = 'START',
}

/** Used to specify spacing of elements within a DataTable. Only for use with DataTable. */
export enum DataTableElementsSpace {
  FOUR = 'FOUR',
  HALF = 'HALF',
  ONE = 'ONE',
  SIX = 'SIX',
  THREE = 'THREE',
  TWELVE = 'TWELVE',
  TWO = 'TWO',
}

/** Used to specify how elements should wrap within a DataTable. Only for use with DataTable. */
export enum DataTableElementsWrap {
  NO_WRAP = 'NO_WRAP',
  WRAP = 'WRAP',
  WRAP_REVERSE = 'WRAP_REVERSE',
}

/** Represents an applied filter state as an input fed into the resolver */
export interface DataTableFilterInput {
  id: Scalars['String'];
  values: Array<Scalars['String']>;
}

/** Represents the necessary data table input information that is supplied to the resolver */
export interface DataTableInput {
  filters?: InputMaybe<Array<DataTableFilterInput>>;
  pagination?: InputMaybe<DataTablePaginationInput>;
  /** A list of the applied sort conditions on the table's data, where the order of items determines the priority of the sorting */
  sort?: InputMaybe<Array<DataTableSortInput>>;
}

/** Represents the state of the paginator as an input fed into the resolver */
export interface DataTablePaginationInput {
  cursor: Scalars['Int'];
  pageSize: Scalars['Int'];
}

/** Represents the necessary data table sort input information that is supplied to the resolver */
export interface DataTableSortInput {
  /** The column id to sort by */
  columnId: Scalars['String'];
  /** The applied order to sort by */
  sortOrder: DataTableSortOrder;
}

/** Represents the supported order directions for sorting data in the table */
export enum DataTableSortOrder {
  ASC = 'ASC',
  DESC = 'DESC',
}

/** A common date object */
export interface DateInput {
  /** The day of the month, e.g. `1` for the 1st */
  day: Scalars['Int'];
  /** The numeric month, e.g. `1` for January */
  month: Scalars['Int'];
  /** The four-digit year e.g. `1999` */
  year: Scalars['Int'];
}

/** A generic period of date, not tied to a checkin/out status. */
export interface DatePeriodInput {
  /** The bounding type of period, if defined, otherwise interpreted as a degenerate interval */
  bound?: InputMaybe<ClosedPeriodBounding>;
  /** The length of period */
  length: Scalars['Int'];
  /** The unit of period */
  unit: DatePeriodUnit;
}

/** The unit of date period */
export enum DatePeriodUnit {
  DAY = 'DAY',
  MONTH = 'MONTH',
  WEEK = 'WEEK',
  WEEKEND = 'WEEKEND',
}

/** A range of dates, from a starting date to an ending date */
export interface DateRangeInput {
  /** The terminal date in this range */
  end: DateInput;
  /** The starting date in this range */
  start: DateInput;
}

/** A common date time, if you need to include timezone information, please use ZonedDateTime */
export interface DateTimeInput {
  /** The day of the month of the date */
  day: Scalars['Int'];
  /** The hour of the datetime */
  hour: Scalars['Int'];
  /** The minute of the hour */
  minute: Scalars['Int'];
  /** The numeric month of the date */
  month: Scalars['Int'];
  /** The second of the minute */
  second: Scalars['Int'];
  /** The four-digit year of the date */
  year: Scalars['Int'];
}

/** Type used during a product search to specify a given date. Usually this date would not be a core search criteria like a departure day for a flight. */
export interface DateValueInput {
  id: Scalars['String'];
  value: DateInput;
}

export enum DealType {
  AARP = 'AARP',
  POINTS_PROMOTION = 'POINTS_PROMOTION',
}

/** Enum for empty state type to deduce the empty state scenario */
export enum DealsErrorStateType {
  NDF_DEFAULT = 'NDF_DEFAULT',
  NDF_DEFAULT_WITH_FILTERS = 'NDF_DEFAULT_WITH_FILTERS',
  NDF_TOGGLE_OFF_WITHOUT_FILTERS = 'NDF_TOGGLE_OFF_WITHOUT_FILTERS',
  NDF_TOGGLE_OFF_WITH_FILTERS = 'NDF_TOGGLE_OFF_WITH_FILTERS',
  NDF_TOGGLE_ON_WITHOUT_FILTERS = 'NDF_TOGGLE_ON_WITHOUT_FILTERS',
  NDF_TOGGLE_ON_WITH_FILTERS = 'NDF_TOGGLE_ON_WITH_FILTERS',
  NDF_TOGGLE_TURNED_ON = 'NDF_TOGGLE_TURNED_ON',
  SYSTEM_ERROR = 'SYSTEM_ERROR',
}

/** Enum for error type to deduce the error scenario */
export enum DealsErrorType {
  NO_DEALS_FOUND = 'NO_DEALS_FOUND',
  SYSTEM_ERROR = 'SYSTEM_ERROR',
}

/** Enum representing the location of a button on the map */
export enum DealsMapOverlayButtonLocation {
  BOTTOM_END = 'BOTTOM_END',
  BOTTOM_START = 'BOTTOM_START',
  TOP_END = 'TOP_END',
  TOP_MIDDLE = 'TOP_MIDDLE',
  TOP_START = 'TOP_START',
}

/** Represents the input type for deals shopping experience */
export interface DealsShoppingCriteriaInput {
  primarySearchCriteria: PrimaryDealsShoppingCriteriaInput;
  secondaryCriteria?: InputMaybe<ShoppingSearchCriteriaInput>;
}

/** Context used for debugging purposes, such as overriding Abacus experiments */
export interface DebugContextInput {
  /** Abacus exposure overrides to be applied */
  abacusOverrides: Array<ExposureInput>;
  /** ALTER mode */
  alterMode?: InputMaybe<AlterMode>;
}

export enum DeeplinkType {
  HSR = 'HSR',
  PDP = 'PDP',
}

export interface DenyReasonInput {
  comments: Scalars['String'];
  compliance: Array<TextDenyReasonCompliance>;
  guidelines: Array<TextDenyReasonGuidelines>;
  language: Array<TextDenyReasonLanguage>;
}

export interface DestinationHeadingCriteriaInput {
  /** Max number of images for the given destination. */
  imageLimit?: InputMaybe<Scalars['Int']>;
  /** Id of the destination. */
  placeId: Scalars['String'];
  /** content source- Experience Manager or Destination API */
  source?: InputMaybe<ContentSource>;
}

export interface DestinationHeroMediaCriteriaInput {
  affinityURNs?: InputMaybe<Array<Scalars['String']>>;
  contentTopic?: InputMaybe<Scalars['String']>;
  destinationId: Scalars['String'];
  egPlatformURL?: InputMaybe<Scalars['String']>;
  lob?: InputMaybe<Scalars['String']>;
}

export interface DestinationImageDimensionsInput {
  height: Scalars['Int'];
  width: Scalars['Int'];
}

/** Contains detailed geographic information like the Gaia region id as well as the property ids in the region for the property destination */
export interface DestinationInput {
  /** The Geo location of the region to search */
  coordinates?: InputMaybe<CoordinatesInput>;
  /** The excluded Property Id to use for exclude property of the carousel */
  excludedPropertyIds?: InputMaybe<Array<Scalars['String']>>;
  /** List of coordinates of the map's bounding box. */
  mapBounds?: InputMaybe<Array<CoordinatesInput>>;
  /** The property ID to use for region resolution (pinned search). */
  pinnedPropertyId?: InputMaybe<Scalars['String']>;
  /** List of property IDs to return search information for. */
  propertyIds?: InputMaybe<Array<Scalars['String']>>;
  /** The Gaia region ID of the search */
  regionId?: InputMaybe<Scalars['String']>;
  /** The name of the region ID, used for fuzzy resolution */
  regionName?: InputMaybe<Scalars['String']>;
}

export enum DestinationInsightMonthTag {
  CHEAPEST = 'CHEAPEST',
}

/** Represents the input to be included with the destinationLogistics query. */
export interface DestinationLogisticsInput {
  /** Represents the line of business. Default value will be LODGING */
  lineOfBusiness?: InputMaybe<Scalars['String']>;
  /** Represents the identifier for the destination */
  placeId: Scalars['String'];
  /** Represents the strategy that this query will perform. */
  strategy: Scalars['String'];
}

/** Destination Neighborhoods Configuration Identifier */
export enum DestinationNeighborhoodsConfigurationIdentifier {
  DEFAULT = 'DEFAULT',
  SEM_TRAVEL_GUIDE = 'SEM_TRAVEL_GUIDE',
  TOP_NEIGHBORHOODS = 'TOP_NEIGHBORHOODS',
  TOP_NEIGHBORHOODS_V2 = 'TOP_NEIGHBORHOODS_V2',
}

/** Inputs for the destinationNeighborhood query */
export interface DestinationNeighborhoodsContextInput {
  /** Destination configuration identifier */
  configurationIdentifier?: InputMaybe<DestinationNeighborhoodsConfigurationIdentifier>;
  /** Date range for constructing SRP URL parameters */
  dateRange?: InputMaybe<DateRangeInput>;
  /** Destination */
  destination?: InputMaybe<DestinationNeighborhoodsDestinationInput>;
  /** Line of business on landing page */
  lineOfBusiness?: InputMaybe<Scalars['String']>;
  /** url to perform traffic test */
  url?: InputMaybe<Scalars['String']>;
}

/** Destination */
export interface DestinationNeighborhoodsDestinationInput {
  /** Destination coordinates */
  coordinates?: InputMaybe<CoordinatesInput>;
  /** Destination place */
  place?: InputMaybe<DestinationPlaceInput>;
}

/** Destination Place */
export interface DestinationPlaceInput {
  /** Destination place id */
  id?: InputMaybe<Scalars['String']>;
}

export enum DestinationRecommendationCardView {
  DEFAULT_HIDE_IMAGE = 'DEFAULT_HIDE_IMAGE',
  DEFAULT_SHOW_IMAGE = 'DEFAULT_SHOW_IMAGE',
}

/** Inputs for the destinationGroup query */
export interface DestinationRecommendationCriteriaInput {
  /** Max amount of cards to show */
  maxCards?: InputMaybe<Scalars['Int']>;
  /** Min amount of cards to show */
  minCards?: InputMaybe<Scalars['Int']>;
  /** Id of the origin destination */
  referencePlaceId: Scalars['String'];
  /** Strategy for place relationship */
  strategy: DestinationRecommendationStrategy;
  /** Type of destinations in the output */
  type: DestinationRecommendationPlaceType;
  /** url to perfom traffic test */
  url?: InputMaybe<Scalars['String']>;
}

export enum DestinationRecommendationPlaceType {
  CITY = 'CITY',
  NEIGHBORHOOD = 'NEIGHBORHOOD',
  POI = 'POI',
}

/** Strategy to select the relationship of the output destinations and the origin */
export enum DestinationRecommendationStrategy {
  NEARBY = 'NEARBY',
  SIMILAR = 'SIMILAR',
  TOP = 'TOP',
}

export interface DestinationTextConfigInput {
  /** EM Content Topic */
  contentTopic: Scalars['String'];
  /** EG platform URL */
  egPlatformURL: Scalars['String'];
}

/** Input for travelGuideRecommendation query */
export enum DestinationTravelGuidePolicy {
  PERSONALIZED = 'PERSONALIZED',
  PLACE_ID = 'PLACE_ID',
  USER_LOCATION = 'USER_LOCATION',
}

/** Device information */
export interface DeviceInput {
  type: DeviceType;
}

/** Valid device types */
export enum DeviceType {
  APP_PHONE = 'APP_PHONE',
  APP_TABLET = 'APP_TABLET',
  CHAT_APP = 'CHAT_APP',
  DESKTOP = 'DESKTOP',
  MOBILE_PHONE = 'MOBILE_PHONE',
  MOBILE_TABLET = 'MOBILE_TABLET',
  VOICE_APP = 'VOICE_APP',
}

export enum DialogButtonActionType {
  CLOSE_DIALOG = 'CLOSE_DIALOG',
  CREATE_TRACKING_MUTATION = 'CREATE_TRACKING_MUTATION',
  DISABLE_TRACKING_MUTATION = 'DISABLE_TRACKING_MUTATION',
  EMAIL_OPT_OUT = 'EMAIL_OPT_OUT',
  UPDATE_TRACKING_MUTATION = 'UPDATE_TRACKING_MUTATION',
}

export enum DialogElementType {
  CLEAR_RATES = 'CLEAR_RATES',
  DELETE_QUOTES = 'DELETE_QUOTES',
}

/** Represents the different ways a dialog sections can be aligned */
export enum DialogSectionAlignment {
  CENTER = 'CENTER',
  LEADING = 'LEADING',
}

/** Dimensions for a presentation object i.e. image or icon */
export interface DimensionsInput {
  density: Scalars['Float'];
  height: Scalars['Float'];
  width: Scalars['Float'];
}

export enum DirectFeedbackMultiSelectStyle {
  DEFAULT = 'DEFAULT',
  PILL = 'PILL',
}

export enum DirectFeedbackPageCommandOrientation {
  HORIZONTAL = 'HORIZONTAL',
  VERTICAL = 'VERTICAL',
}

export enum DirectFeedbackPageDisplayConditionType {
  BOOL = 'BOOL',
  NONE = 'NONE',
  PATTERN = 'PATTERN',
  TEXT = 'TEXT',
}

/** Represents the type of dialog containing a direct feedback prompt */
export enum DirectFeedbackSheetType {
  BOTTOM_SHEET = 'BOTTOM_SHEET',
  CENTERED_SHEET = 'CENTERED_SHEET',
  FULL_SHEET = 'FULL_SHEET',
}

export interface DirectFeedbackValuesInput {
  atoShieldValidation?: InputMaybe<AtoChallengeValidationInput>;
  context: Array<GraphQLPairInput>;
  formValues: Array<GraphQLPairInput>;
}

/** A reference place or property for which to show directions to */
export interface DirectionsReferenceInput {
  /** The id of the reference place or property. */
  id: Scalars['String'];
  /** The type of reference, e.g. place, property, etc. */
  type: EGDSMapFeatureType;
}

/** Represents the disable deals tracking mutation operation data */
export interface DisableDealsTrackingOperationDataInput {
  subscriptionId: Scalars['String'];
}

/** Input for discoveryAlternativeLinkCardGroup query */
export interface DiscoveryAlternativeLinkCardCriteriaInput {
  alternativeTripType: AlternativeLinkType;
  destinationId: Scalars['String'];
}

export enum DiscoveryCardContentSize {
  ABBREVIATED = 'ABBREVIATED',
  FOUNDATION = 'FOUNDATION',
  FOUNDATION_DETAILS_LIST = 'FOUNDATION_DETAILS_LIST',
  LANDING = 'LANDING',
  LONG_FORM = 'LONG_FORM',
  LONG_FORM_FEATURED = 'LONG_FORM_FEATURED',
  SHORT_FORM = 'SHORT_FORM',
  SMART_LANDING = 'SMART_LANDING',
  UBER_ABBREVIATED = 'UBER_ABBREVIATED',
  UBER_ABBREVIATED_PRICE = 'UBER_ABBREVIATED_PRICE',
  UBER_ABBREVIATED_RATING = 'UBER_ABBREVIATED_RATING',
}

export enum DiscoveryContainerType {
  CAROUSEL = 'CAROUSEL',
  EXPANDO = 'EXPANDO',
  GRID = 'GRID',
  LIST = 'LIST',
}

/** Represent the context for a destination (eg. information in a landing page). */
export interface DiscoveryDestinationContextInput {
  mapBounds?: InputMaybe<Array<CoordinatesInput>>;
  placeCoordinates?: InputMaybe<CoordinatesInput>;
  placeId?: InputMaybe<DiscoveryPlaceIdInput>;
}

export interface DiscoveryFlexFiltersInput {
  accommodationTypeCode?: InputMaybe<Scalars['String']>;
  affinityTypeCode?: InputMaybe<Scalars['String']>;
  hotelBrandCode?: InputMaybe<Scalars['String']>;
  /**
   * These fields are filled with values coming from Blossom landing pages
   * They should be deprecated and replaced with the new Travel API taxonomy and filters API
   */
  starRatingCode?: InputMaybe<Scalars['String']>;
}

/** Represent the context for lodging (eg. information in a PDP) */
export interface DiscoveryLodgingContextInput {
  checkin?: InputMaybe<DateInput>;
  checkout?: InputMaybe<DateInput>;
  discoveryFlexFilters?: InputMaybe<DiscoveryFlexFiltersInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  rooms?: InputMaybe<Array<DiscoveryRoomInput>>;
  searchCriteria?: InputMaybe<ShoppingSearchCriteriaInput>;
}

/** List of all the managed offering types. */
export enum DiscoveryOfferingType {
  DESTINATION = 'DESTINATION',
  PRODUCT = 'PRODUCT',
}

/**
 * Context input the client can provide to adjust the experience of the module.
 *
 * In general the personalizedModuleList query is meant to dynamically
 * generate the experience based on the contents of your trip provided as input in either
 * the tripId or orderId. The information in this context can be used to slightly adjust
 * the experience from the default one.
 */
export interface DiscoveryPersonalizedModuleListContextInput {
  dismissedCards?: InputMaybe<Array<Scalars['String']>>;
  useCaseId: Scalars['String'];
}

/** Identifier for a destination, it can contain also the type of a destination (neighborhood, city, airport, etc...) */
export interface DiscoveryPlaceIdInput {
  id: Scalars['String'];
  type?: InputMaybe<Scalars['String']>;
}

/** Strategy used to resolve pricing information. */
export enum DiscoveryPriceStrategy {
  /**
   * Get the best price in the next 30 days seen in the website per pos, input dates are ignored.
   * Products returned can be not available.
   */
  DATELESS = 'DATELESS',
  /** Call for live price, check availability of returned products. */
  LIVE = 'LIVE',
  /** Do not hydrate price. */
  NONE = 'NONE',
}

export interface DiscoveryRecentActivityContextInput {
  lodging?: InputMaybe<DiscoveryLodgingContextInput>;
  marketingChannelTypeCode?: InputMaybe<Scalars['Int']>;
  outputLineOfBusiness: LineOfBusinessDomain;
  /** The unique identifier of the page where the module is displayed. */
  pageId?: InputMaybe<Scalars['String']>;
}

/** Context values a client can/should fill as input of the recommendations. */
export interface DiscoveryRecommendationContextInput {
  /** Contains contextual information about a destination */
  destination?: InputMaybe<DiscoveryDestinationContextInput>;
  /** Image ID for an image displayed to the user. Used to select recommendation using Similar Images strategy */
  displayedImageId?: InputMaybe<Scalars['String']>;
  /** Contains contextual information about a specific lodging product or a Search for it */
  lodging?: InputMaybe<DiscoveryLodgingContextInput>;
  /** Marketing channel code identifying SEM/META traffic. Clients need to pass it if available in their context. */
  marketingChannelCode?: InputMaybe<Scalars['Int']>;
  orderId?: InputMaybe<Scalars['String']>;
  /** Define the specific line of business to be used when doing inference with an offering type PRODUCT */
  outputLineOfBusiness?: InputMaybe<LineOfBusinessDomain>;
  /** A unique identifier of the page the module will appear. */
  pageId?: InputMaybe<Scalars['String']>;
  /** Contains contextual information about the packages */
  shoppingContext?: InputMaybe<ShoppingContextInput>;
}

/** Used to select which parameters should be used to run the inference. */
export enum DiscoveryRecommendationInputContext {
  /** Uses the 'destination' section from the context object. */
  DESTINATION = 'DESTINATION',
  /** Uses the image presented to the user to generate similar images recommendations content strategy */
  DISPLAYED_IMAGE = 'DISPLAYED_IMAGE',
  /** Uses the 'orderId' section from the context object. */
  ORDER = 'ORDER',
  /** Uses the 'product' section from the context object. */
  PRODUCT = 'PRODUCT',
  /** Personalize the recommendations using the latest products a user saw. */
  RECENTLY_VIEWED_PRODUCT = 'RECENTLY_VIEWED_PRODUCT',
  /** Personalize the recommendations using the recent searches of the user. */
  RECENT_SEARCHES = 'RECENT_SEARCHES',
  /** Base the recommendations on the user location. */
  USER_LOCATION = 'USER_LOCATION',
}

/** List of all the managed recommendations strategies. */
export enum DiscoveryRecommendationStrategy {
  ALTERNATIVE = 'ALTERNATIVE',
  EG_PLACES = 'EG_PLACES',
  EG_SEARCH_NEAR_PLACE = 'EG_SEARCH_NEAR_PLACE',
  EG_SEARCH_RECOMMENDED_SELECTION = 'EG_SEARCH_RECOMMENDED_SELECTION',
  /** @deprecated replaced by EG_SEARCH_RECOMMENDED_SELECTION and EG_SEARCH_SELECTION_SORT_GUEST_RATING */
  EG_SEARCH_SELECTION = 'EG_SEARCH_SELECTION',
  EG_SEARCH_SELECTION_SORT_GUEST_RATING = 'EG_SEARCH_SELECTION_SORT_GUEST_RATING',
  LOOKUP_AND_ASSEMBLE = 'LOOKUP_AND_ASSEMBLE',
  NEARBY = 'NEARBY',
  POPULAR = 'POPULAR',
  SEM_RESULT = 'SEM_RESULT',
  SIMILAR = 'SIMILAR',
  SPONSORED = 'SPONSORED',
  THEMED_POPULAR = 'THEMED_POPULAR',
  THEMED_REFINEMENT = 'THEMED_REFINEMENT',
  TOP_BOOKING = 'TOP_BOOKING',
  TOP_CITIES = 'TOP_CITIES',
  TRENDING = 'TRENDING',
}

/** Represent a room for lodging. */
export interface DiscoveryRoomInput {
  adults: Scalars['Int'];
  children?: InputMaybe<Array<Scalars['Int']>>;
}

/** Input for dismissOpportunity mutation */
export interface DismissOpportunityInput {
  /** Dismissal reason */
  dismissalReason: Scalars['String'];
  /** Recommendation ids */
  recommendationIds: Array<Scalars['String']>;
}

/** Enum of the units of measure and their abbreviations */
export enum DistanceUnit {
  KILOMETER = 'KILOMETER',
  MILE = 'MILE',
}

export enum DividerPlacement {
  BOTTOM = 'BOTTOM',
  TOP = 'TOP',
}

export enum DividerStyle {
  NARROW = 'NARROW',
  WIDE = 'WIDE',
}

export enum DuiAnimationIteration {
  FIVE = 'FIVE',
  INFINITE = 'INFINITE',
  ONE = 'ONE',
  THREE = 'THREE',
}

export enum DuiButtonSize {
  LARGE = 'LARGE',
  MEDIUM = 'MEDIUM',
  SMALL = 'SMALL',
}

export enum DuiDividerOrientation {
  HORIZONTAL = 'HORIZONTAL',
}

export enum DuiLayoutAdvancedAlignment {
  CENTER = 'CENTER',
  END = 'END',
  SPACE_AROUND = 'SPACE_AROUND',
  SPACE_BETWEEN = 'SPACE_BETWEEN',
  SPACE_EVENLY = 'SPACE_EVENLY',
  START = 'START',
}

export enum DuiLayoutBasicAlignment {
  CENTER = 'CENTER',
  END = 'END',
  START = 'START',
}

export enum DuiLayoutCoords {
  BOTTOM_CENTER = 'BOTTOM_CENTER',
  BOTTOM_END = 'BOTTOM_END',
  /** @deprecated use isFullWidth instead */
  BOTTOM_FULL = 'BOTTOM_FULL',
  BOTTOM_START = 'BOTTOM_START',
  CENTER = 'CENTER',
  CENTER_END = 'CENTER_END',
  /** @deprecated use isFullWidth instead */
  CENTER_FULL = 'CENTER_FULL',
  CENTER_START = 'CENTER_START',
  TOP_CENTER = 'TOP_CENTER',
  TOP_END = 'TOP_END',
  /** @deprecated use isFullWidth instead */
  TOP_FULL = 'TOP_FULL',
  TOP_START = 'TOP_START',
}

export enum DuiLayoutZType {
  ABSOLUTE = 'ABSOLUTE',
  RELATIVE = 'RELATIVE',
}

export enum DuiScrimBackgroundType {
  SOLID = 'SOLID',
  VERTICAL_GRADIENT = 'VERTICAL_GRADIENT',
}

export enum DuiSize {
  EIGHT = 'EIGHT',
  FOUR = 'FOUR',
  HALF = 'HALF',
  ONE = 'ONE',
  SIX = 'SIX',
  SIXTEEN = 'SIXTEEN',
  THREE = 'THREE',
  TWELVE = 'TWELVE',
  TWO = 'TWO',
  ZERO = 'ZERO',
}

export enum DuiTextAlign {
  CENTER = 'CENTER',
  END = 'END',
  START = 'START',
}

export enum DuiTextOverflow {
  CLIP = 'CLIP',
  ELLIPSIS = 'ELLIPSIS',
}

export enum DuiThemeProvider {
  DARK = 'DARK',
  DEFAULT = 'DEFAULT',
  LIGHT = 'LIGHT',
}

export enum DuiViewport {
  EXTRA_LARGE = 'EXTRA_LARGE',
  LARGE = 'LARGE',
  MEDIUM = 'MEDIUM',
  SMALL = 'SMALL',
}

/** Different types of duration span input validations. */
export enum DurationSpanValidationType {
  /** Used to validate that a maximum input value is greater than a minimum input value. */
  MAXIMUM_GREATER_THAN_MINIMUM = 'MAXIMUM_GREATER_THAN_MINIMUM',
  /** Used to validate that the user input is less than or equal to some specified value. Example: Maximum 10 nights. */
  MAXIMUM_VALUE = 'MAXIMUM_VALUE',
  /** Used to validate that a minimum input value is less than a maximum input value. */
  MINIMUM_LESS_THAN_MAXIMUM = 'MINIMUM_LESS_THAN_MAXIMUM',
  /** Used to validate that the user input is greater than or equal to some specified value. Example: Minimum 2 nights. */
  MINIMUM_VALUE = 'MINIMUM_VALUE',
  /** Used to validate that the user input has a value. */
  REQUIRED_VALUE = 'REQUIRED_VALUE',
}

/** Represents the heading level */
export enum DynamicCardHeadingLevel {
  H1 = 'H1',
  H2 = 'H2',
  H3 = 'H3',
  H4 = 'H4',
  H5 = 'H5',
  H6 = 'H6',
}

/** Represents where within the card's cover image we want an overlay positioned, abstraction over absolute positioning, i.e. BOTTOM_LEFT is bottom: 0, left: 0 */
export enum DynamicCardOverlayPosition {
  BOTTOM_LEFT = 'BOTTOM_LEFT',
  TOP_RIGHT = 'TOP_RIGHT',
}

/** Represents supported text alignment on a card */
export enum DynamicCardTextAlignment {
  CENTER = 'CENTER',
  LEFT = 'LEFT',
  RIGHT = 'RIGHT',
}

/** Represents the supported text styles on a card. See https://pages.github.expedia.biz/egds/components-react/?path=/docs/core-egds-text--overview#use-1dl-type-styles for samples */
export enum DynamicCardTextStyle {
  DISPLAY_SMALL = 'DISPLAY_SMALL',
  HEADLINE_MEDIUM = 'HEADLINE_MEDIUM',
  HEADLINE_OVERLINE = 'HEADLINE_OVERLINE',
  HEADLINE_SMALL = 'HEADLINE_SMALL',
  PARAGRAPH_MEDIUM = 'PARAGRAPH_MEDIUM',
  PARAGRAPH_SMALL = 'PARAGRAPH_SMALL',
  TEXT_MEDIUM = 'TEXT_MEDIUM',
  TEXT_SMALL = 'TEXT_SMALL',
}

/** Represents the payload to be validated */
export interface DynamicCardValidationPayloadInput {
  /** Represents the data model to be bounded to the template. This should be a valid stringified JSON. */
  dataModel?: InputMaybe<Scalars['String']>;
  /** Represents the serialized message data. This can be a resolved template or one that contains Freemarker syntax */
  messageData: Scalars['String'];
  /** Represents the payload ID (for logging/troubleshooting purpose) */
  payloadId?: InputMaybe<Scalars['String']>;
}

export enum EGDSAnimatedMarkIterations {
  FIVE = 'FIVE',
  INFINITE = 'INFINITE',
  ONE = 'ONE',
  THREE = 'THREE',
}

/** Styles established in EGDS design docs. https://www.figma.com/file/bbPtPOgPN4sttR3BzDaTZc/Buttons */
export enum EGDSButtonStyle {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
  TERTIARY = 'TERTIARY',
}

/** Represents the background theme for the card */
export enum EGDSCardBackgroundTheme {
  GLOBAL_LOYALTY_EXTRAHIGH = 'GLOBAL_LOYALTY_EXTRAHIGH',
  GLOBAL_LOYALTY_HIGH = 'GLOBAL_LOYALTY_HIGH',
  GLOBAL_LOYALTY_LOW = 'GLOBAL_LOYALTY_LOW',
  GLOBAL_LOYALTY_MIDDLE = 'GLOBAL_LOYALTY_MIDDLE',
  GLOBAL_LOYALTY_STANDARD = 'GLOBAL_LOYALTY_STANDARD',
  HIGHLIGHT = 'HIGHLIGHT',
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
}

/**
 * Represents the variations of a card. Can be used with EGDSCard union members.
 * https://www.figma.com/file/M3udFrUojCRwrcoAiPnQ3Yaw/Card?node-id=11143%3A833&t=blroVUeSfs4Eqnoj-0
 */
export enum EGDSCardThemes {
  BORDERED = 'BORDERED',
  PADDED = 'PADDED',
}

/** Defines how checkbox state should be displayed on client. */
export enum EGDSCheckBoxState {
  CHECKED = 'CHECKED',
  INDETERMINATE = 'INDETERMINATE',
  UNCHECKED = 'UNCHECKED',
}

/** Represents the label theme for the date range result. */
export enum EGDSDateRangeResultTheme {
  LINK = 'LINK',
  POSITIVE = 'POSITIVE',
}

/** Represents short day name. */
export enum EGDSDayName {
  FRI = 'FRI',
  MON = 'MON',
  SAT = 'SAT',
  SUN = 'SUN',
  THU = 'THU',
  TUE = 'TUE',
  WED = 'WED',
}

/** Represents the type of decorative in the text element. e.g. superscript */
export enum EGDSDecorativeText {
  /** Renders with a background color to highlight the text */
  HIGHLIGHT = 'HIGHLIGHT',
  /** Renders in italic style */
  ITALIC = 'ITALIC',
  /** Renders with a line through the text */
  LINE_THROUGH = 'LINE_THROUGH',
  /** Renders as a subscript at the bottom of the text line */
  SUBSCRIPT = 'SUBSCRIPT',
  /** Renders as a superscript at the top of the text line */
  SUPERSCRIPT = 'SUPERSCRIPT',
  /** Renders with a line under the text */
  UNDERLINE = 'UNDERLINE',
}

/**
 * DO NOT USE. Mobile doesn't support these html style. Client should handle heading tags.
 *
 * https://www.figma.com/file/IHAiPyllJIlO6g4f2qdNW4zq/Typography
 */
export enum EGDSHeadingStyle {
  H1 = 'H1',
  H2 = 'H2',
  H3 = 'H3',
  H4 = 'H4',
  H5 = 'H5',
  H6 = 'H6',
  H7 = 'H7',
  H8 = 'H8',
}

/** Represents where the icon should be places in a EGDS Standard Link */
export enum EGDSIconPosition {
  LEADING = 'LEADING',
  TRAILING = 'TRAILING',
}

export enum EGDSImageAlignment {
  /** Aligns image to the left side of the container */
  LEFT = 'LEFT',
  /** Aligns image to the right side of the container */
  RIGHT = 'RIGHT',
}

/** Option for selecting an infant seat on a plane. */
export enum EGDSInfantSeat {
  IN_SEAT = 'IN_SEAT',
  ON_LAP = 'ON_LAP',
}

/** Represents the size of the text in a EGDS Standard Link */
export enum EGDSLinkSize {
  LARGE = 'LARGE',
  MEDIUM = 'MEDIUM',
  SMALL = 'SMALL',
}

/**
 * ON_DEVICE means the custom places are saved locally on the device.
 * EXTERNAL means the custom places are saved externally on the backend.
 */
export enum EGDSMapCustomPlacePersistanceType {
  EXTERNAL = 'EXTERNAL',
  ON_DEVICE = 'ON_DEVICE',
}

/** The type of feature */
export enum EGDSMapFeatureType {
  /** Any place like restaurant, point of interest, airport */
  PLACE = 'PLACE',
  /** Any product sold by EG like hotel, vacation_rental, car, cruise, activity, flight */
  PRODUCT = 'PRODUCT',
  /** @deprecated Use product */
  PROPERTY = 'PROPERTY',
}

/** The initial viewport to use for the map when markers have been pushed and just before they are rendered */
export enum EGDSMapInitialViewport {
  /** To use bounds value as initial viewport */
  BOUNDS = 'BOUNDS',
  /** To compute a bound from a set of options with a specified center */
  CENTERED_COMPUTED_BOUNDS = 'CENTERED_COMPUTED_BOUNDS',
  /** To use zoom and center values as initial viewport */
  CENTER_AND_ZOOM = 'CENTER_AND_ZOOM',
  /** To compute a bound from a set of options */
  COMPUTED_BOUNDS = 'COMPUTED_BOUNDS',
  /** Will center the map to show all markers pushed to the map */
  FIT_MARKERS = 'FIT_MARKERS',
}

/** Marker pin style based on the applied filter and inventory - AVAILABLE, FILTERED, SOLD_OUT or UNKNOWN */
export enum EGDSMapMarkerStatus {
  /** Use for products. Indicates that the product is available. */
  AVAILABLE = 'AVAILABLE',
  /** Use for products. Indicates that the product is available but filtered. */
  FILTERED = 'FILTERED',
  /** Use for products. Indicates that the product is sold out. */
  SOLD_OUT = 'SOLD_OUT',
  /** Use for products and places. Indicates that the status is unknown. */
  UNKNOWN = 'UNKNOWN',
}

/** 'zoomAndCenter' (requires zoom + center) or 'fitBounds' (map will include all rendered markers) */
export enum EGDSMapPositionMode {
  FIT_BOUNDS = 'FIT_BOUNDS',
  ZOOM_AND_CENTER = 'ZOOM_AND_CENTER',
}

/** type of maps that can be used */
export enum EGDSMapProvider {
  GOOGLE = 'GOOGLE',
  MAPBOX = 'MAPBOX',
  MAPKIT = 'MAPKIT',
}

export enum EGDSMark {
  AARP = 'AARP',
  AARP_MEMBER_BENEFITS = 'AARP_MEMBER_BENEFITS',
  ADDON = 'ADDON',
  AIR_NEW_ZEALAND = 'AIR_NEW_ZEALAND',
  APPLE = 'APPLE',
  APPLE_MAPS = 'APPLE_MAPS',
  APP_CTX = 'APP_CTX',
  APP_EBOOK = 'APP_EBOOK',
  APP_EXP = 'APP_EXP',
  APP_HOTWIRE = 'APP_HOTWIRE',
  APP_ORB = 'APP_ORB',
  APP_TVLY = 'APP_TVLY',
  APP_WOTIF = 'APP_WOTIF',
  BONUS_EBOOK = 'BONUS_EBOOK',
  COMMISSION_TIER_FOUR = 'COMMISSION_TIER_FOUR',
  COMMISSION_TIER_ONE = 'COMMISSION_TIER_ONE',
  COMMISSION_TIER_THREE = 'COMMISSION_TIER_THREE',
  COMMISSION_TIER_TWO = 'COMMISSION_TIER_TWO',
  FACEBOOK = 'FACEBOOK',
  FLAGS__AR = 'FLAGS__AR',
  FLAGS__AS = 'FLAGS__AS',
  FLAGS__AT = 'FLAGS__AT',
  FLAGS__AU = 'FLAGS__AU',
  FLAGS__BE = 'FLAGS__BE',
  FLAGS__BO = 'FLAGS__BO',
  FLAGS__BR = 'FLAGS__BR',
  FLAGS__BZ = 'FLAGS__BZ',
  FLAGS__CA = 'FLAGS__CA',
  FLAGS__CH = 'FLAGS__CH',
  FLAGS__CL = 'FLAGS__CL',
  FLAGS__CN = 'FLAGS__CN',
  FLAGS__CO = 'FLAGS__CO',
  FLAGS__CR = 'FLAGS__CR',
  FLAGS__CZ = 'FLAGS__CZ',
  FLAGS__DE = 'FLAGS__DE',
  FLAGS__DK = 'FLAGS__DK',
  FLAGS__EC = 'FLAGS__EC',
  FLAGS__EE = 'FLAGS__EE',
  FLAGS__EG = 'FLAGS__EG',
  FLAGS__ES = 'FLAGS__ES',
  FLAGS__EU = 'FLAGS__EU',
  FLAGS__FI = 'FLAGS__FI',
  FLAGS__FR = 'FLAGS__FR',
  FLAGS__GR = 'FLAGS__GR',
  FLAGS__GT = 'FLAGS__GT',
  FLAGS__GY = 'FLAGS__GY',
  FLAGS__HK = 'FLAGS__HK',
  FLAGS__HN = 'FLAGS__HN',
  FLAGS__HR = 'FLAGS__HR',
  FLAGS__HU = 'FLAGS__HU',
  FLAGS__ID = 'FLAGS__ID',
  FLAGS__IE = 'FLAGS__IE',
  FLAGS__IL = 'FLAGS__IL',
  FLAGS__IN = 'FLAGS__IN',
  FLAGS__IS = 'FLAGS__IS',
  FLAGS__IT = 'FLAGS__IT',
  FLAGS__JP = 'FLAGS__JP',
  FLAGS__KR = 'FLAGS__KR',
  FLAGS__L1 = 'FLAGS__L1',
  FLAGS__LT = 'FLAGS__LT',
  FLAGS__LV = 'FLAGS__LV',
  FLAGS__MX = 'FLAGS__MX',
  FLAGS__MY = 'FLAGS__MY',
  FLAGS__NI = 'FLAGS__NI',
  FLAGS__NL = 'FLAGS__NL',
  FLAGS__NO = 'FLAGS__NO',
  FLAGS__NZ = 'FLAGS__NZ',
  FLAGS__PA = 'FLAGS__PA',
  FLAGS__PE = 'FLAGS__PE',
  FLAGS__PH = 'FLAGS__PH',
  FLAGS__PL = 'FLAGS__PL',
  FLAGS__PT = 'FLAGS__PT',
  FLAGS__PY = 'FLAGS__PY',
  FLAGS__RU = 'FLAGS__RU',
  FLAGS__SA = 'FLAGS__SA',
  FLAGS__SE = 'FLAGS__SE',
  FLAGS__SG = 'FLAGS__SG',
  FLAGS__SK = 'FLAGS__SK',
  FLAGS__SR = 'FLAGS__SR',
  FLAGS__SV = 'FLAGS__SV',
  FLAGS__TH = 'FLAGS__TH',
  FLAGS__TR = 'FLAGS__TR',
  FLAGS__TW = 'FLAGS__TW',
  FLAGS__UA = 'FLAGS__UA',
  FLAGS__UAE = 'FLAGS__UAE',
  FLAGS__UK = 'FLAGS__UK',
  FLAGS__US = 'FLAGS__US',
  FLAGS__UY = 'FLAGS__UY',
  FLAGS__VE = 'FLAGS__VE',
  FLAGS__VN = 'FLAGS__VN',
  FLAGS__WW = 'FLAGS__WW',
  FLAGS__ZA = 'FLAGS__ZA',
  GOOGLE = 'GOOGLE',
  GOOGLE_LOGO = 'GOOGLE_LOGO',
  GOOGLE_MAP = 'GOOGLE_MAP',
  GOOGLE_TRANSLATED = 'GOOGLE_TRANSLATED',
  HAWAIIAN = 'HAWAIIAN',
  HOTWIRE_HOTRATE_CIRCLE = 'HOTWIRE_HOTRATE_CIRCLE',
  LINE = 'LINE',
  LOYALTY_HOTELS__HIGH_TIER = 'LOYALTY_HOTELS__HIGH_TIER',
  LOYALTY_HOTELS__LOW_TIER = 'LOYALTY_HOTELS__LOW_TIER',
  LOYALTY_HOTELS__MIDDLE_TIER = 'LOYALTY_HOTELS__MIDDLE_TIER',
  LOYALTY_HOTELS__REWARDS = 'LOYALTY_HOTELS__REWARDS',
  LOYALTY_HOTELS__STAMP_EMPTY = 'LOYALTY_HOTELS__STAMP_EMPTY',
  LOYALTY_HOTELS__STAMP_PENDING = 'LOYALTY_HOTELS__STAMP_PENDING',
  LOYALTY_HOTELS__STAMP_SEARCHED = 'LOYALTY_HOTELS__STAMP_SEARCHED',
  LOYALTY_TVLY = 'LOYALTY_TVLY',
  MAPBOX = 'MAPBOX',
  MIP_PRIMARY = 'MIP_PRIMARY',
  MIP_REVERSE = 'MIP_REVERSE',
  MIP_SECONDARY = 'MIP_SECONDARY',
  MOD_CTX = 'MOD_CTX',
  MOD_EBOOK = 'MOD_EBOOK',
  MOD_EXP = 'MOD_EXP',
  MOD_HOTELS = 'MOD_HOTELS',
  MOD_ORB = 'MOD_ORB',
  MOD_TVLY = 'MOD_TVLY',
  MOD_WOTIF = 'MOD_WOTIF',
  NAVER = 'NAVER',
  ONEKEY__ABRITEL = 'ONEKEY__ABRITEL',
  ONEKEY__BLUE = 'ONEKEY__BLUE',
  ONEKEY__BOOKABACH = 'ONEKEY__BOOKABACH',
  ONEKEY__CASH = 'ONEKEY__CASH',
  ONEKEY__EXPEDIA = 'ONEKEY__EXPEDIA',
  ONEKEY__FEWODIREKT = 'ONEKEY__FEWODIREKT',
  ONEKEY__GOLD = 'ONEKEY__GOLD',
  ONEKEY__HOTELS__CHINESE = 'ONEKEY__HOTELS__CHINESE',
  ONEKEY__HOTELS__ENGLISH = 'ONEKEY__HOTELS__ENGLISH',
  ONEKEY__HOTELS__PORTUGUESE = 'ONEKEY__HOTELS__PORTUGUESE',
  ONEKEY__HOTELS__SPANISH = 'ONEKEY__HOTELS__SPANISH',
  ONEKEY__KNOCKEDOUT__ALWAYS_LIGHT = 'ONEKEY__KNOCKEDOUT__ALWAYS_LIGHT',
  ONEKEY__PLATINUM = 'ONEKEY__PLATINUM',
  ONEKEY__SILVER = 'ONEKEY__SILVER',
  ONEKEY__STANDARD = 'ONEKEY__STANDARD',
  ONEKEY__STANDARD__ALWAYS_LIGHT = 'ONEKEY__STANDARD__ALWAYS_LIGHT',
  ONEKEY__STAYZ = 'ONEKEY__STAYZ',
  ONEKEY__VRBO = 'ONEKEY__VRBO',
  ONEKEY__WORDMARK = 'ONEKEY__WORDMARK',
  ONEKEY__WORDMARK__ALWAYS_LIGHT = 'ONEKEY__WORDMARK__ALWAYS_LIGHT',
  PAYMENT__7_ELEVEN = 'PAYMENT__7_ELEVEN',
  PAYMENT__AFFIRM = 'PAYMENT__AFFIRM',
  PAYMENT__AIRPLUS = 'PAYMENT__AIRPLUS',
  PAYMENT__ALIPAY = 'PAYMENT__ALIPAY',
  PAYMENT__AMEX = 'PAYMENT__AMEX',
  PAYMENT__APPLEPAY = 'PAYMENT__APPLEPAY',
  PAYMENT__CHASE = 'PAYMENT__CHASE',
  PAYMENT__CLICKTOPAY = 'PAYMENT__CLICKTOPAY',
  PAYMENT__DINERS_CLUB_INTERNATIONAL = 'PAYMENT__DINERS_CLUB_INTERNATIONAL',
  PAYMENT__DISCOVER = 'PAYMENT__DISCOVER',
  PAYMENT__GOOGLE_PAY = 'PAYMENT__GOOGLE_PAY',
  PAYMENT__IDEAL = 'PAYMENT__IDEAL',
  PAYMENT__JAPAN_CREDIT_BUREAU = 'PAYMENT__JAPAN_CREDIT_BUREAU',
  PAYMENT__KLARNA = 'PAYMENT__KLARNA',
  PAYMENT__MAESTRO = 'PAYMENT__MAESTRO',
  PAYMENT__MASTERCARD = 'PAYMENT__MASTERCARD',
  PAYMENT__MASTERPASS = 'PAYMENT__MASTERPASS',
  PAYMENT__PAYPAL = 'PAYMENT__PAYPAL',
  PAYMENT__SAMSUNG_CARD = 'PAYMENT__SAMSUNG_CARD',
  PAYMENT__UATP = 'PAYMENT__UATP',
  PAYMENT__UNION_PAY = 'PAYMENT__UNION_PAY',
  PAYMENT__VISA = 'PAYMENT__VISA',
  PLUS_CIRCLE = 'PLUS_CIRCLE',
  PLUS_CIRCLE_CTX = 'PLUS_CIRCLE_CTX',
  PLUS_CIRCLE_EBOOK = 'PLUS_CIRCLE_EBOOK',
  PLUS_CIRCLE_ORB = 'PLUS_CIRCLE_ORB',
  PLUS_CIRCLE_TVLY = 'PLUS_CIRCLE_TVLY',
  PLUS_CIRCLE_WOTIF = 'PLUS_CIRCLE_WOTIF',
  PREMIUM_TVLY = 'PREMIUM_TVLY',
  REWARDS_ORB = 'REWARDS_ORB',
  TRIPADVISOR = 'TRIPADVISOR',
  TRIVAGO = 'TRIVAGO',
  VAP_HOTELS__HIGH_TIER = 'VAP_HOTELS__HIGH_TIER',
  VAP_HOTELS__LOW_TIER = 'VAP_HOTELS__LOW_TIER',
  VAP_HOTELS__MIDDLE_TIER = 'VAP_HOTELS__MIDDLE_TIER',
  VIP_BEX = 'VIP_BEX',
  VIP_CIRCLE_BEX = 'VIP_CIRCLE_BEX',
  VIP_CIRCLE_EBOOKERS = 'VIP_CIRCLE_EBOOKERS',
  VIP_CIRCLE_HOTELS = 'VIP_CIRCLE_HOTELS',
  VIP_CIRCLE_ORBITZ = 'VIP_CIRCLE_ORBITZ',
  VIP_EBOOKERS = 'VIP_EBOOKERS',
  VIP_ORBITZ = 'VIP_ORBITZ',
  VIRGIN_AU = 'VIRGIN_AU',
  VRBO = 'VRBO',
}

/**
 * This should only be used in unique design cases where the UX changes frequently and specific product requirements must be met.
 * Most teams should just use String over EGDSParagraph or EGDSText.
 *
 * https://www.figma.com/file/IHAiPyllJIlO6g4f2qdNW4zq/Typography
 */
export enum EGDSParagraphStyle {
  P1 = 'P1',
  P2 = 'P2',
  P3 = 'P3',
}

/** The type of path for directions */
export enum EGDSPathType {
  CYCLING = 'CYCLING',
  DRIVING = 'DRIVING',
  FLYING = 'FLYING',
  TRANSIT = 'TRANSIT',
  WALKING = 'WALKING',
}

/** Possible camera movement for the photosphere image */
export enum EGDSPhotosphereCameraMovement {
  AUTO_PAN = 'AUTO_PAN',
  DISABLED = 'DISABLED',
  FULL_MOVE = 'FULL_MOVE',
}

/** Different field types of location field */
export enum EGDSSearchFormLocationFieldRegionType {
  ADDRESS = 'ADDRESS',
  AIRPORT = 'AIRPORT',
  CITY = 'CITY',
  CONTINENT = 'CONTINENT',
  COUNTRY = 'COUNTRY',
  MULTI_CITY_VICINITY = 'MULTI_CITY_VICINITY',
  NEIGHBORHOOD = 'NEIGHBORHOOD',
  POINT_OF_INTEREST = 'POINT_OF_INTEREST',
  UNKNOWN = 'UNKNOWN',
}

/** Type of EGDSSheet */
export enum EGDSSheetType {
  BOTTOM = 'BOTTOM',
  CENTERED = 'CENTERED',
  FULLSCREEN = 'FULLSCREEN',
  POPOVER = 'POPOVER',
  SIDE = 'SIDE',
}

/** ONLY USE IN EGDSSheetTypePerViewSize, represents the size of the travelers application / window */
export enum EGDSSheetTypeViewSize {
  LARGE = 'LARGE',
  MEDIUM = 'MEDIUM',
  SMALL = 'SMALL',
}

export enum EGDSTextListItemStyle {
  DEFAULT = 'DEFAULT',
  EMPHASIS = 'EMPHASIS',
  LOYALTY = 'LOYALTY',
  NEGATIVE = 'NEGATIVE',
  POSITIVE = 'POSITIVE',
}

/** https://www.figma.com/file/IHAiPyllJIlO6g4f2qdNW4zq/Typography */
export enum EGDSTextListSize {
  LIST_1 = 'LIST_1',
  LIST_2 = 'LIST_2',
  LIST_3 = 'LIST_3',
}

/**
 * This represents UI variations of EGDS List
 *        figma: https://www.figma.com/file/IHAiPyllJIlO6g4f2qdNW4zq/Typography?node-id=11931%3A11857
 */
export enum EGDSTextListType {
  BULLET = 'BULLET',
  ICON = 'ICON',
  NO_BULLET = 'NO_BULLET',
  NUMBER = 'NUMBER',
}

/**
 * Represents the possible UI theme colors.
 *
 * https://uitk.expedia.biz/en_US/components/cards#global_loyalty_card_patterns
 * https://www.figma.com/file/x9PecZwsESUjIsB1s4D676/Visual-Identity-Refinement?type=design&node-id=6873-216790&mode=design&t=zsn1QbwSKBHJ7OD5-0
 */
export enum EGDSThemeProviderColor {
  AI = 'AI',
  BRIGHT_1 = 'BRIGHT_1',
  DARK_1 = 'DARK_1',
  DARK_2 = 'DARK_2',
  GLOBAL_LOYALTY_EXTRA_HIGH = 'GLOBAL_LOYALTY_EXTRA_HIGH',
  GLOBAL_LOYALTY_EXTRA_HIGH_BRIGHT = 'GLOBAL_LOYALTY_EXTRA_HIGH_BRIGHT',
  GLOBAL_LOYALTY_HIGH = 'GLOBAL_LOYALTY_HIGH',
  GLOBAL_LOYALTY_HIGH_BRIGHT = 'GLOBAL_LOYALTY_HIGH_BRIGHT',
  GLOBAL_LOYALTY_LOW = 'GLOBAL_LOYALTY_LOW',
  GLOBAL_LOYALTY_LOW_BRIGHT = 'GLOBAL_LOYALTY_LOW_BRIGHT',
  GLOBAL_LOYALTY_MID = 'GLOBAL_LOYALTY_MID',
  GLOBAL_LOYALTY_MID_BRIGHT = 'GLOBAL_LOYALTY_MID_BRIGHT',
  GLOBAL_LOYALTY_STANDARD = 'GLOBAL_LOYALTY_STANDARD',
  LIGHT_1 = 'LIGHT_1',
  MARKETING_1 = 'MARKETING_1',
  MARKETING_2 = 'MARKETING_2',
  MARKETING_3 = 'MARKETING_3',
  NONE = 'NONE',
  STANDARD = 'STANDARD',
}

/**
 * Toolbars are built with two variants.
 * STANDARD: They have a solid background built in. This is the default variant type..
 * TRANSPARENT: They do not have a solid background.
 */
export enum EGDSToolbarStyle {
  STANDARD = 'STANDARD',
  TRANSPARENT = 'TRANSPARENT',
}

/** Travelers types used on travelers selector */
export enum EGDSTravelerType {
  ADULT = 'ADULT',
  CHILD = 'CHILD',
  INFANT = 'INFANT',
  SENIOR = 'SENIOR',
  YOUTH = 'YOUTH',
}

/** Represents different type of travelers validation. */
export enum EGDSTravelersValidationType {
  /** Used to validate child age required. */
  CHILD_AGE_REQUIRED = 'CHILD_AGE_REQUIRED',
  /** Used to validate equal number of adults separated between rooms. */
  EQUAL_ADULTS_BETWEEN_ROOMS = 'EQUAL_ADULTS_BETWEEN_ROOMS',
  /** Used to validate any error in the traveler selector at the input field level */
  GENERIC_INPUT_FIELD_ERROR = 'GENERIC_INPUT_FIELD_ERROR',
  /** Used to validate maximum number of allowed infants in seat. */
  MANY_INFANT_IN_SEAT = 'MANY_INFANT_IN_SEAT',
  /** Used to validate maximum number of allowed infants on lap. */
  MANY_INFANT_ON_LAP = 'MANY_INFANT_ON_LAP',
  /** Used to validate maximum number of allowed rooms when child is present. */
  MAX_ROOMS_WITH_CHILD = 'MAX_ROOMS_WITH_CHILD',
  /** Used to validate maximum allowed travelers for search. */
  MAX_TRAVELERS = 'MAX_TRAVELERS',
}

/** Defines how typeahead results should be displayed on client. */
export enum EGDSTypeaheadRenderType {
  ADAPTIVE = 'ADAPTIVE',
  DIALOG = 'DIALOG',
  MENU = 'MENU',
}

/**
 * Used to specify event type for an interaction.
 * See https://github.expedia.biz/Brand-Expedia/uis-prime-schemas/blob/master/schemas/micro/platform/referrer.json#L26
 */
export enum EGReferrerEventType {
  /** Used to track a click on a UI component. */
  CLICK = 'CLICK',
  /** Used to track an impression of a UI component. */
  IMPRESSION = 'IMPRESSION',
}

/** Predefined image sizes */
export enum EMImageSize {
  L = 'L',
  M = 'M',
  S = 'S',
  XL = 'XL',
  XS = 'XS',
}

/** Edit user roles for a partner account request body */
export interface EditRolesRequestInput {
  partnerAccountId: Scalars['String'];
  rolesToAdd: Array<Scalars['String']>;
  userId: Scalars['String'];
}

export interface EmailPreferencesCompletenessModuleRequestInput {
  promptDeniedDate?: InputMaybe<Scalars['String']>;
  promptDeniedTimes?: InputMaybe<Scalars['Int']>;
}

/** Indicates which url to redirect to */
export enum EmptyStateType {
  ENABLE_PUSH = 'ENABLE_PUSH',
  EXPLORE_TRIPS = 'EXPLORE_TRIPS',
  SIGN_IN = 'SIGN_IN',
}

export interface EntityAssociationContext {
  entityId: Scalars['String'];
  entityType: Scalars['String'];
}

/**
 * "The `EssentialInfoItemInput` contains essentialInfoItemId along with bookingItemID separated by -. eg. 1-4020303
 * essentialInfoItemId identifies which essential info to render and bookingItemID is used as an parameter to lodgingDemandReservationService's getVrStayEssentialInfo API
 */
export interface EssentialInfoItemInput {
  itemId: Scalars['String'];
}

/** Represents content for an event */
export interface EventContentInput {
  /** Represents a typing indicator event's content */
  typingIndicatorEventContent?: InputMaybe<TypingIndicatorEventContentInput>;
}

export enum EventType {
  CancelledTripsItemDetailViewed = 'CancelledTripsItemDetailViewed',
  DeleteTripAlertPresented = 'DeleteTripAlertPresented',
  DeleteTripDialogPresented = 'DeleteTripDialogPresented',
  DeleteTripErrorToastPresented = 'DeleteTripErrorToastPresented',
  DeleteTripFailed = 'DeleteTripFailed',
  DeleteTripSucceeded = 'DeleteTripSucceeded',
  DeleteTripSuccessToastPresented = 'DeleteTripSuccessToastPresented',
  HeroModuleCampaign = 'HeroModuleCampaign',
  HeroModuleColdStart = 'HeroModuleColdStart',
  ItinActiveCar = 'ItinActiveCar',
  ItinActiveCruise = 'ItinActiveCruise',
  ItinActiveFlight = 'ItinActiveFlight',
  ItinActiveGT = 'ItinActiveGT',
  ItinActiveHotel = 'ItinActiveHotel',
  ItinActiveLX = 'ItinActiveLX',
  ItinActivePackageFH = 'ItinActivePackageFH',
  ItinActiveRail = 'ItinActiveRail',
  ItinCancellation = 'ItinCancellation',
  MoveItemDrawerPresented = 'MoveItemDrawerPresented',
  MoveItemErrorToastPresented = 'MoveItemErrorToastPresented',
  MoveItemSubmitted = 'MoveItemSubmitted',
  MoveItemSuccessToastPresented = 'MoveItemSuccessToastPresented',
  MoveItemSuceeded = 'MoveItemSuceeded',
  MoveLinkedItemsDialogPresented = 'MoveLinkedItemsDialogPresented',
  RemoveItemDialogPresented = 'RemoveItemDialogPresented',
  TripItemMenuPresented = 'TripItemMenuPresented',
  TripSignInDialogPresented = 'TripSignInDialogPresented',
  TripsCancelledItemDetailViewed = 'TripsCancelledItemDetailViewed',
  TripsCollabInviteConfirmationViewed = 'TripsCollabInviteConfirmationViewed',
  TripsCollabInviteFailureViewed = 'TripsCollabInviteFailureViewed',
  TripsCollabInviteSucceeded = 'TripsCollabInviteSucceeded',
  TripsCollabJoinGroupFailed = 'TripsCollabJoinGroupFailed',
  TripsCollabJoinGroupSucceeded = 'TripsCollabJoinGroupSucceeded',
  TripsCollabJoinTripConfirmationViewed = 'TripsCollabJoinTripConfirmationViewed',
  TripsCollabJoinTripErrorToastPresented = 'TripsCollabJoinTripErrorToastPresented',
  TripsCollabLandingScreenRedirectToTripOverView = 'TripsCollabLandingScreenRedirectToTripOverView',
  TripsCollabLandingScreenViewed = 'TripsCollabLandingScreenViewed',
  TripsCollabManageGroupViewed = 'TripsCollabManageGroupViewed',
  TripsCollabViewPresentedActivities = 'TripsCollabViewPresentedActivities',
  TripsCollabViewPresentedCars = 'TripsCollabViewPresentedCars',
  TripsCollabViewPresentedCruise = 'TripsCollabViewPresentedCruise',
  TripsCollabViewPresentedFlight = 'TripsCollabViewPresentedFlight',
  TripsCollabViewPresentedHotel = 'TripsCollabViewPresentedHotel',
  TripsCollabViewPresentedVacationRental = 'TripsCollabViewPresentedVacationRental',
  TripsEditItemSucceeded = 'TripsEditItemSucceeded',
  TripsEditTripErrorToastPresented = 'TripsEditTripErrorToastPresented',
  TripsEditTripPresented = 'TripsEditTripPresented',
  TripsEditTripSubmitted = 'TripsEditTripSubmitted',
  TripsEditTripSuccessToastPresented = 'TripsEditTripSuccessToastPresented',
  TripsFlightScheduleChangeBannerDisplayed = 'TripsFlightScheduleChangeBannerDisplayed',
  TripsHeroModuleCurrentTrip = 'TripsHeroModuleCurrentTrip',
  TripsHeroModulePossibleActivityTrip = 'TripsHeroModulePossibleActivityTrip',
  TripsHeroModulePossibleAirTrip = 'TripsHeroModulePossibleAirTrip',
  TripsHeroModulePossibleCarTrip = 'TripsHeroModulePossibleCarTrip',
  TripsHeroModulePossibleHotelTrip = 'TripsHeroModulePossibleHotelTrip',
  TripsHeroModulePossiblePackageHFTrip = 'TripsHeroModulePossiblePackageHFTrip',
  TripsHeroModulePossibleTrip = 'TripsHeroModulePossibleTrip',
  TripsHeroModulePotentialTrip = 'TripsHeroModulePotentialTrip',
  TripsHeroModuleUpcomingTrip = 'TripsHeroModuleUpcomingTrip',
  TripsItemDetailViewed = 'TripsItemDetailViewed',
  TripsListViewed = 'TripsListViewed',
  TripsModuleDestinationGuide = 'TripsModuleDestinationGuide',
  TripsModuleRecommendedActivity = 'TripsModuleRecommendedActivity',
  TripsModuleRecommendedCar = 'TripsModuleRecommendedCar',
  TripsModuleRecommendedHotel = 'TripsModuleRecommendedHotel',
  TripsOverviewViewed = 'TripsOverviewViewed',
  TripsTravelPlannerItinNumberPresent = 'TripsTravelPlannerItinNumberPresent',
  Unknown = 'Unknown',
}

export enum EventsRecommendationIdType {
  TRIP_ID = 'TRIP_ID',
  TRIP_ITEM_ID = 'TRIP_ITEM_ID',
}

export interface EventsRecommendationRequestInput {
  primaryId: Scalars['String'];
  primaryIdType: EventsRecommendationIdType;
  secondaryId?: InputMaybe<Scalars['String']>;
  secondaryIdType?: InputMaybe<EventsRecommendationIdType>;
}

export enum ExpLineOfBusiness {
  ACTIVITIES = 'ACTIVITIES',
  CAR = 'CAR',
  CRUISES = 'CRUISES',
  FLIGHT = 'FLIGHT',
  GROUNDTRANSFERS = 'GROUNDTRANSFERS',
  HOTEL = 'HOTEL',
  PACKAGES = 'PACKAGES',
  RAILS = 'RAILS',
  UNCLASSIFIED = 'UNCLASSIFIED',
}

/** Specifies the position of the trigger icon  */
export enum ExpandoTriggerPosition {
  LEADING = 'LEADING',
  TRAILING = 'TRAILING',
}

export enum ExperimentalActionType {
  JUMPLINK = 'JUMPLINK',
  MODAL = 'MODAL',
  REDIRECT = 'REDIRECT',
}

export enum ExperimentalAspectRatio {
  FIT = 'FIT',
  FOUR_ONE = 'FOUR_ONE',
  FOUR_THREE = 'FOUR_THREE',
  NONE = 'NONE',
  ONE_ONE = 'ONE_ONE',
  SIXTEEN_NINE = 'SIXTEEN_NINE',
  THREE_FOUR = 'THREE_FOUR',
  THREE_TWO = 'THREE_TWO',
  TWENTY_ONE_NINE = 'TWENTY_ONE_NINE',
}

export enum ExperimentalContainerSize {
  EIGHTY_EIGHT = 'EIGHTY_EIGHT',
  /** @deprecated Use HUNDRED instead */
  FIVE_HUNDRED = 'FIVE_HUNDRED',
  FORTY_EIGHT = 'FORTY_EIGHT',
  /** @deprecated Use HUNDRED instead */
  FOUR_HUNDRED = 'FOUR_HUNDRED',
  HUNDRED = 'HUNDRED',
  NINETY_SIX = 'NINETY_SIX',
  /** @deprecated Use THIRTY_EIGHT instead */
  ONE_HUNDRED_EIGHTY = 'ONE_HUNDRED_EIGHTY',
  /** @deprecated Use THIRTY_EIGHT instead */
  ONE_HUNDRED_FIFTY_TWO = 'ONE_HUNDRED_FIFTY_TWO',
  /** @deprecated Use THIRTY instead */
  ONE_HUNDRED_THIRTY = 'ONE_HUNDRED_THIRTY',
  ONE_HUNDRED_TWELVE = 'ONE_HUNDRED_TWELVE',
  /** @deprecated Use THIRTY instead */
  ONE_HUNDRED_TWENTY = 'ONE_HUNDRED_TWENTY',
  SEVENTY = 'SEVENTY',
  SIXTY = 'SIXTY',
  SIXTY_FOUR = 'SIXTY_FOUR',
  THIRTY = 'THIRTY',
  THIRTY_EIGHT = 'THIRTY_EIGHT',
  THIRTY_SIX = 'THIRTY_SIX',
  /** @deprecated Use SIXTY_FOUR instead */
  THREE_HUNDRED_TWELVE = 'THREE_HUNDRED_TWELVE',
  TWELVE = 'TWELVE',
  TWENTY_FOUR = 'TWENTY_FOUR',
  /** @deprecated Use SIXTY_FOUR instead */
  TWO_HUNDRED_FIFTY_SIX = 'TWO_HUNDRED_FIFTY_SIX',
  /** @deprecated Use THIRTY_EIGHT instead */
  TWO_HUNDRED_FOUR = 'TWO_HUNDRED_FOUR',
}

export enum ExperimentalElements {
  /** EGDSStandardMessagingCard. Figma: https://www.figma.com/file/SRnOSnyVYE5dYh7wEQNIfC/Messaging-card-patterns?node-id=1551%3A1450 */
  Card = 'Card',
  /** Image / Carousel */
  Carousel = 'Carousel',
  /** Clickable container for any element */
  Clickable = 'Clickable',
  /** Experimental: Class to hold the props for a container, spacing, flex, impression, analytics */
  Container = 'Container',
  /** Expand / collapse sections. Peek and list type */
  Expando = 'Expando',
  /** Grid system */
  Grid = 'Grid',
  /** Title, subtitle and paragraphs */
  InfoSection = 'InfoSection',
  /** Intersection */
  IntersectionTracker = 'IntersectionTracker',
  /** Media - Images / Video */
  Media = 'Media',
  /** Modal - Bottom, Full, Popover, Centered, Side-sheet */
  Modal = 'Modal',
  /** Rating */
  Rating = 'Rating',
  /** Conditional container for script tags to apply to its children NOT to be consumed on client side */
  Script = 'Script',
  /** Spacing */
  Spacing = 'Spacing',
  /** Tabs */
  Tabs = 'Tabs',
  /** A list with icons and support for context menu. https://shared-ui.expedia.biz/components/web/retail/product/internal/product-text-info-section */
  TextIconTooltip = 'TextIconTooltip',
}

export enum ExperimentalFlexAlign {
  BASELINE = 'BASELINE',
  CENTER = 'CENTER',
  END = 'END',
  START = 'START',
  STRETCH = 'STRETCH',
}

export enum ExperimentalFlexDirection {
  COLUMN = 'COLUMN',
  ROW = 'ROW',
}

export enum ExperimentalFlexJustify {
  CENTER = 'CENTER',
  END = 'END',
  START = 'START',
}

export enum ExperimentalHeadingType {
  h1 = 'h1',
  h2 = 'h2',
  h3 = 'h3',
  h4 = 'h4',
  h5 = 'h5',
  h6 = 'h6',
}

export enum ExperimentalImageFit {
  CONTAIN = 'CONTAIN',
  COVER = 'COVER',
}

export enum ExperimentalImageLazyload {
  EAGER = 'EAGER',
  LAZY = 'LAZY',
  OFF = 'OFF',
}

export enum ExperimentalImageRounded {
  ALL = 'ALL',
  END_END = 'END_END',
  END_START = 'END_START',
  FALSE = 'FALSE',
  MAX = 'MAX',
  START_END = 'START_END',
  START_START = 'START_START',
  TRUE = 'TRUE',
}

export enum ExperimentalModalPosition {
  LEADING = 'LEADING',
  TRAILING = 'TRAILING',
}

export enum ExperimentalModalType {
  BOTTOM = 'BOTTOM',
  CENTERED = 'CENTERED',
  FULL = 'FULL',
  POPOVER = 'POPOVER',
  SIDE = 'SIDE',
}

export enum ExperimentalOverflow {
  TRUNCATE = 'TRUNCATE',
  TRUNCATE_FOUR_LINES = 'TRUNCATE_FOUR_LINES',
  TRUNCATE_THREE_LINES = 'TRUNCATE_THREE_LINES',
  TRUNCATE_TWO_LINES = 'TRUNCATE_TWO_LINES',
  WRAP = 'WRAP',
}

export enum ExperimentalSliderStyle {
  singleWithTicks = 'singleWithTicks',
  singleWithoutTicks = 'singleWithoutTicks',
}

export enum ExperimentalSpace {
  four = 'four',
  half = 'half',
  one = 'one',
  six = 'six',
  three = 'three',
  twelve = 'twelve',
  two = 'two',
}

export interface ExploreDestinationCriteriaInput {
  destinationId: Scalars['String'];
  exploreIds?: InputMaybe<Array<Scalars['String']>>;
}

/** An exposure to an abacus experiment */
export interface ExposureInput {
  /** The experiment bucket of the exposure */
  bucket: Scalars['Int'];
  /** The numeric Abacus ID for an experiment */
  id: Scalars['String'];
}

export interface FOPItemInput {
  id: Scalars['String'];
  paymentMethod: PaymentMethodType;
  paymentMethodConfiguration?: InputMaybe<PaymentMethodConfigurationInput>;
  state: Scalars['String'];
}

/** FSL creative input */
export interface FSLCreativeInput {
  /** Ad creative description */
  description?: InputMaybe<Scalars['String']>;
  /** Ad creative headline */
  headline?: InputMaybe<Scalars['String']>;
  /** Ad creative image URL */
  imageUrl?: InputMaybe<Scalars['String']>;
}

export enum FallBackType {
  ERROR = 'ERROR',
}

export enum FallbackOperation {
  APPLY_COUPON = 'APPLY_COUPON',
  REMOVE_COUPON = 'REMOVE_COUPON',
}

/**
 * Used to identify the downstream data source.
 * ENTITY: A stateful data service driven by the owning domain
 * CART: Cart Service
 * OFFER: Offer Service
 * ORDER: Ordering Service
 * CHECKOUT: Core Checkout Identifying Service
 */
export enum FareNameAvailable {
  AVAILABLE = 'AVAILABLE',
  NOT_AVAILABLE = 'NOT_AVAILABLE',
}

/** Represents the state of the fare */
export enum FareState {
  /** Fare is selected on meta search, but it has unselected visual state */
  META_UNSELECTED = 'META_UNSELECTED',
  /** Fare is selected */
  SELECTED = 'SELECTED',
  /** Fare is selected with PMP */
  SELECTED_PMP_SELECTED = 'SELECTED_PMP_SELECTED',
  /** Fare is unselected */
  UNSELECTED = 'UNSELECTED',
  /** Fare is unselected with PMP */
  UNSELECTED_PMP_SELECTED = 'UNSELECTED_PMP_SELECTED',
}

export enum FastTrackActionType {
  JUMPLINK = 'JUMPLINK',
  MODAL = 'MODAL',
  REDIRECT = 'REDIRECT',
}

export enum FastTrackConfigTag {
  H1 = 'H1',
  H2 = 'H2',
  H3 = 'H3',
  H4 = 'H4',
  H5 = 'H5',
  H6 = 'H6',
}

export enum FastTrackContainerSize {
  EIGHTY_EIGHT = 'EIGHTY_EIGHT',
  FIVE_HUNDRED = 'FIVE_HUNDRED',
  FORTY_EIGHT = 'FORTY_EIGHT',
  NINETY_SIX = 'NINETY_SIX',
  ONE_HUNDRED_EIGHTY = 'ONE_HUNDRED_EIGHTY',
  ONE_HUNDRED_THIRTY = 'ONE_HUNDRED_THIRTY',
  ONE_HUNDRED_TWELVE = 'ONE_HUNDRED_TWELVE',
  SEVENTY = 'SEVENTY',
  SIXTY = 'SIXTY',
  THIRTY_SIX = 'THIRTY_SIX',
  THREE_HUNDRED_TWELVE = 'THREE_HUNDRED_TWELVE',
  TWELVE = 'TWELVE',
  TWENTY_FOUR = 'TWENTY_FOUR',
  TWO_HUNDRED_FOUR = 'TWO_HUNDRED_FOUR',
}

export enum FastTrackElements {
  /** EGDSStandardMessagingCard. Figma: https://www.figma.com/file/SRnOSnyVYE5dYh7wEQNIfC/Messaging-card-patterns?node-id=1551%3A1450 */
  Card = 'Card',
  /** Image / Carousel */
  Carousel = 'Carousel',
  /** Clickable container for any element */
  Clickable = 'Clickable',
  /** Expand / collapse sections. Peek and list type */
  Expando = 'Expando',
  /** Grid system */
  Grid = 'Grid',
  /** Title, subtitle and paragraphs */
  InfoSection = 'InfoSection',
  /** Intersection */
  IntersectionTracker = 'IntersectionTracker',
  /** Media - Images / Video */
  Media = 'Media',
  /** Modal - Bottom, Full, Popover, Centered, Side-sheet */
  Modal = 'Modal',
  /** Rating */
  Rating = 'Rating',
  /** Spacing */
  Spacing = 'Spacing',
  /** Tabs */
  Tabs = 'Tabs',
  /** A list with icons and support for context menu. https://shared-ui.expedia.biz/components/web/retail/product/internal/product-text-info-section */
  TextIconTooltip = 'TextIconTooltip',
}

export enum FastTrackFlexAlign {
  BASELINE = 'BASELINE',
  CENTER = 'CENTER',
  END = 'END',
  START = 'START',
  STRETCH = 'STRETCH',
}

export enum FastTrackFlexDirection {
  COLUMN = 'COLUMN',
  ROW = 'ROW',
}

export enum FastTrackFlexJustify {
  CENTER = 'CENTER',
  END = 'END',
  START = 'START',
}

export enum FastTrackHelperConfigMap {
  And = 'And',
  CapitalizeFirst = 'CapitalizeFirst',
  DeviceTypeEvaluator = 'DeviceTypeEvaluator',
  Equals = 'Equals',
  EvaluateExperiment = 'EvaluateExperiment',
  EvaluateExperimentAndLog = 'EvaluateExperimentAndLog',
  ExperimentEvaluator = 'ExperimentEvaluator',
  FormatDoubleNumber = 'FormatDoubleNumber',
  FormatIntegerNumber = 'FormatIntegerNumber',
  GetSystemTimeInMs = 'GetSystemTimeInMs',
  GetUsableURN = 'GetUsableURN',
  Greater = 'Greater',
  GreaterAndEquals = 'GreaterAndEquals',
  HTTPLink = 'HTTPLink',
  ImpressionAnalyticsPayload = 'ImpressionAnalyticsPayload',
  IsNotNullOrEmpty = 'IsNotNullOrEmpty',
  IsQualifiedVrboProperty = 'IsQualifiedVrboProperty',
  Join = 'Join',
  Limit = 'Limit',
  Localize = 'Localize',
  Not = 'Not',
  Or = 'Or',
  Substring = 'Substring',
}

export enum FastTrackImageFit {
  CONTAIN = 'CONTAIN',
  COVER = 'COVER',
}

export enum FastTrackImageLazyload {
  EAGER = 'EAGER',
  LAZY = 'LAZY',
  OFF = 'OFF',
}

export enum FastTrackImageRounded {
  ALL = 'ALL',
  END_END = 'END_END',
  END_START = 'END_START',
  FALSE = 'FALSE',
  MAX = 'MAX',
  START_END = 'START_END',
  START_START = 'START_START',
  TRUE = 'TRUE',
}

export enum FastTrackModalNavType {
  BACK = 'BACK',
  CLOSE = 'CLOSE',
  EXPAND_DOWN = 'EXPAND_DOWN',
  EXPAND_UP = 'EXPAND_UP',
}

export enum FastTrackModalPosition {
  LEADING = 'LEADING',
  TRAILING = 'TRAILING',
}

export enum FastTrackModalSideSheetLayout {
  EIGHT = 'EIGHT',
  FOUR = 'FOUR',
  ONE = 'ONE',
  SIX = 'SIX',
  THREE = 'THREE',
  TWELVE = 'TWELVE',
  TWO = 'TWO',
}

export enum FastTrackModalType {
  BOTTOM = 'BOTTOM',
  CENTERED = 'CENTERED',
  FULL = 'FULL',
  POPOVER = 'POPOVER',
  SIDE = 'SIDE',
}

/** Handle text that would overflow out of the current line and element */
export enum FastTrackOverflow {
  TRUNCATE = 'TRUNCATE',
  TRUNCATE_FOUR_LINES = 'TRUNCATE_FOUR_LINES',
  TRUNCATE_THREE_LINES = 'TRUNCATE_THREE_LINES',
  TRUNCATE_TWO_LINES = 'TRUNCATE_TWO_LINES',
  WRAP = 'WRAP',
}

export enum FastTrackProductEntityAssetSelection {
  ACCESSIBILITY_CONTENT = 'ACCESSIBILITY_CONTENT',
  AMENITY = 'AMENITY',
  EXPERIENCE_SCORE = 'EXPERIENCE_SCORE',
  EXPERIENCE_SCORE_WITH_TOP_RATED_ATTRIBUTES = 'EXPERIENCE_SCORE_WITH_TOP_RATED_ATTRIBUTES',
  FAMILY_HIGHLIGHTS = 'FAMILY_HIGHLIGHTS',
  HEADLINE = 'HEADLINE',
  IMAGE = 'IMAGE',
  LOCATION_DESCRIPTION = 'LOCATION_DESCRIPTION',
  LUXURY_STAYS = 'LUXURY_STAYS',
  PLACE = 'PLACE',
  POLICY = 'POLICY',
  PRODUCT_ATTRIBUTE = 'PRODUCT_ATTRIBUTE',
  PRODUCT_HIGHLIGHTS = 'PRODUCT_HIGHLIGHTS',
  PRODUCT_UNIQUENESS_HIGHLIGHTS = 'PRODUCT_UNIQUENESS_HIGHLIGHTS',
  PROPERTY_AMENITY_GROUPS = 'PROPERTY_AMENITY_GROUPS',
  RELEVANT_AMENITY_DETAILS = 'RELEVANT_AMENITY_DETAILS',
  REVIEW_DETAILS = 'REVIEW_DETAILS',
  REVIEW_IMAGES = 'REVIEW_IMAGES',
  REVIEW_SUMMARY = 'REVIEW_SUMMARY',
  REVIEW_SUMMARY_HIGHLIGHTS = 'REVIEW_SUMMARY_HIGHLIGHTS',
  SUPPLY_SCORE = 'SUPPLY_SCORE',
  TOP_RATED_DETAILS = 'TOP_RATED_DETAILS',
  VIRTUAL_TOUR = 'VIRTUAL_TOUR',
}

export enum FastTrackProductEntityRefinementSelection {
  EMBARGO = 'EMBARGO',
}

export enum FastTrackSpace {
  four = 'four',
  half = 'half',
  one = 'one',
  six = 'six',
  three = 'three',
  twelve = 'twelve',
  two = 'two',
}

export enum FastTrackSpacingOptions {
  FOUR = 'FOUR',
  HALF = 'HALF',
  ONE = 'ONE',
  SIX = 'SIX',
  SIXTEEN = 'SIXTEEN',
  THREE = 'THREE',
  TWELVE = 'TWELVE',
  TWO = 'TWO',
  UNSET = 'UNSET',
}

export enum FastTrackTabType {
  EQUAL_WIDTH = 'EQUAL_WIDTH',
  NATURAL = 'NATURAL',
}

export enum FeeType {
  CARD_ON_FILE_DAMAGE_LIABILITY = 'CARD_ON_FILE_DAMAGE_LIABILITY',
  DEFAULT = 'DEFAULT',
  DEFAULT_SUPPLIER_COLLECTED = 'DEFAULT_SUPPLIER_COLLECTED',
  GROUPED_MANDATORY_FEES = 'GROUPED_MANDATORY_FEES',
  L26_TAX_BREAKOUT = 'L26_TAX_BREAKOUT',
  NORMAL = 'NORMAL',
  OTHER = 'OTHER',
  PER_PERSON_PER_NIGHT = 'PER_PERSON_PER_NIGHT',
  PROPERTY = 'PROPERTY',
  REFUNDABLE_DAMAGE_DEPOSIT = 'REFUNDABLE_DAMAGE_DEPOSIT',
  RESORT = 'RESORT',
}

/** The filter placement for the map view */
export enum FilterPlacement {
  /** Display the filters on the bottom, over the map */
  OVERLAY_BOTTOM = 'OVERLAY_BOTTOM',
  /** Display the filters on the top, over the map */
  OVERLAY_TOP = 'OVERLAY_TOP',
  /** Display the filters in the toolbar */
  TOOLBAR = 'TOOLBAR',
}

export enum FilterPolicyType {
  NO_CHANGE_FEE = 'NO_CHANGE_FEE',
}

/** Enum class to represent the type of travel and baggage */
export enum FilterTravelAndBaggageType {
  CARRY_ON_BAG = 'CARRY_ON_BAG',
  FIRST_CHECKED_BAG = 'FIRST_CHECKED_BAG',
  NO_CANCEL_FEE = 'NO_CANCEL_FEE',
  NO_CHANGE_FEE = 'NO_CHANGE_FEE',
  SEAT_CHOICE = 'SEAT_CHOICE',
}

export enum FlavorType {
  DEMO = 'DEMO',
  INT = 'INT',
  LAB = 'LAB',
  PROD = 'PROD',
  SANDBOX = 'SANDBOX',
}

/** Controls the alignment along the cross axis. */
export enum FlexAlignItems {
  CENTER = 'CENTER',
  END = 'END',
  START = 'START',
  STRETCH = 'STRETCH',
}

/** The direction children items are placed inside the flex container, it determines the direction of the main axis (and the cross axis, perpendicular to the main axis). */
export enum FlexDirection {
  ROW = 'ROW',
}

/** Controls the alignment along the main axis. */
export enum FlexJustifyContent {
  CENTER = 'CENTER',
  END = 'END',
  SPACE_AROUND = 'SPACE_AROUND',
  SPACE_BETWEEN = 'SPACE_BETWEEN',
  START = 'START',
}

/** Controls whether the flex container is single-line or multi-line, and the direction of the cross axis. */
export enum FlexWrap {
  NOWRAP = 'NOWRAP',
}

/** The core criteria needed for a flex search */
export interface FlexibleSearchCriteriaInput {
  /** The raw flexibility of the search */
  flexibility?: InputMaybe<Array<DatePeriodInput>>;
  flexibleSearchMonths?: InputMaybe<Array<Scalars['Int']>>;
  /** Search requirements to be applied for the flexible search. Example: 'INCLUDE_WEEKEND'. */
  flexibleSearchRequirement?: InputMaybe<Array<Scalars['String']>>;
  flexibleSearchTripDurationType?: InputMaybe<FlexibleSearchTripDurationType>;
  numFlexibleDays?: InputMaybe<Scalars['Int']>;
  /** The search range for the flexible search */
  searchRange?: InputMaybe<Array<DateRangeInput>>;
}

/** The trip duration type for the flex search */
export enum FlexibleSearchTripDurationType {
  MONTH = 'MONTH',
  WEEK = 'WEEK',
  WEEKEND = 'WEEKEND',
}

/** The core criteria needed for a flex search */
export interface FlightAncillaryBagSelectionInput {
  /** Represents count of options available for corresponding bag */
  availableOptionsCount?: InputMaybe<Scalars['Int']>;
  /** Represents index of the selected bag */
  selectedBagIndex: Scalars['Int'];
  /** Represents the price of selected bag */
  selectedBagPrice?: InputMaybe<Scalars['Float']>;
}

/** Represents details of air ancillary selections for a journey */
export interface FlightAncillaryJourneySelectionInput {
  /** Represents the state of `apply same ancillaries for all travellers` checkbox */
  applySameAncillaryForAllTravellers: Scalars['Boolean'];
  /** It's contains the count of included checked bag */
  checkedBagIncluded?: InputMaybe<Scalars['Int']>;
  /** Represents list of selected ancillaries for each traveller */
  flightAncillaryTravelerSelections: Array<FlightAncillaryTravelerSelectionInput>;
  /** Represents index of the journey */
  journeyIndex: Scalars['Int'];
}

/** Represents list of selected ancillaries for a traveller */
export interface FlightAncillaryTravelerSelectionInput {
  /** Represents sequence index of the combined ancillaries in cache */
  combinedAncillaryIndex?: InputMaybe<Scalars['Int']>;
  /** Represents list of selected bags */
  flightAncillaryBagSelections: Array<FlightAncillaryBagSelectionInput>;
  /** Represents index of the traveller */
  travelerIndex: Scalars['Int'];
}

/** The trip duration type for the flex search */
export enum FlightCabinClassInfo {
  ANY = 'ANY',
  BUSINESS = 'BUSINESS',
  COACH = 'COACH',
  FIRST = 'FIRST',
  PREMIUM_ECONOMY = 'PREMIUM_ECONOMY',
}

/** Flight creative input */
export interface FlightCreativeInput {
  /** Ad copy description */
  description?: InputMaybe<Scalars['String']>;
  /** Ad copy headline */
  headline?: InputMaybe<Scalars['String']>;
  /** Ad copy image url */
  imageUrl?: InputMaybe<Scalars['String']>;
}

/** Represents cross sell product types that will be displayed */
export enum FlightCrossSellProductType {
  CAR = 'CAR',
  HOTEL = 'HOTEL',
}

export enum FlightDelayBenefitSource {
  EMAIL = 'EMAIL',
  NOTIFICATION = 'NOTIFICATION',
  SMS = 'SMS',
}

export enum FlightDelayPageOrigin {
  HOME = 'HOME',
  REWARDS = 'REWARDS',
  TRIPS = 'TRIPS',
}

/** Represents the enum for flight journey status */
export enum FlightJourneyStatus {
  /** Represents that the segment status as failure */
  FAILURE = 'FAILURE',
  /** Represents that the segment status as success */
  SUCCESS = 'SUCCESS',
}

/** Minimum set of data used to retrieve details about a flight product */
export interface FlightNaturalKeyInput {
  ancillaryId?: InputMaybe<Scalars['String']>;
  journeyContinuationId?: InputMaybe<Scalars['String']>;
  offerToken: Scalars['String'];
  productTokens: Array<Scalars['String']>;
  travelers: Array<TravelerDetailsInput>;
}

export interface FlightOverviewTestContextInput {
  destination: Array<AirTopRoutesTestDataInput>;
  filters: Array<FlightOverviewTestFilterInput>;
  includeWhiteLabel?: InputMaybe<Scalars['Boolean']>;
  onewayOffersRequestedSize?: InputMaybe<Scalars['Int']>;
  origin: Array<AirTopRoutesTestDataInput>;
  roundTripOffersRequestedSize?: InputMaybe<Scalars['Int']>;
}

export interface FlightOverviewTestFilterInput {
  type: FlightOverviewTestFilterType;
  values: Array<Scalars['String']>;
}

export enum FlightOverviewTestFilterType {
  AIRLINE_INCLUDE = 'AIRLINE_INCLUDE',
  DOMESTIC_ORIGIN_ONLY = 'DOMESTIC_ORIGIN_ONLY',
  NUMBER_OF_STOPS = 'NUMBER_OF_STOPS',
}

/** Represents the different sub-pages of Flight Search where the OneKeyLoyaltyBanner can be shown */
export enum FlightPage {
  MULTIDEST_LEG_0 = 'MULTIDEST_LEG_0',
  MULTIDEST_LEG_1 = 'MULTIDEST_LEG_1',
  MULTIDEST_LEG_2 = 'MULTIDEST_LEG_2',
  MULTIDEST_LEG_3 = 'MULTIDEST_LEG_3',
  MULTIDEST_LEG_4 = 'MULTIDEST_LEG_4',
  ONE_WAY = 'ONE_WAY',
  ROUNDTRIP_IN = 'ROUNDTRIP_IN',
  ROUNDTRIP_OUT = 'ROUNDTRIP_OUT',
}

/** Trips data for flight Product */
export interface FlightProductInput {
  /** Represents list of airline codes */
  airlineCodes?: InputMaybe<Array<Scalars['String']>>;
  /** Represents list of airline names */
  airlineNames?: InputMaybe<Array<Scalars['String']>>;
  /** Represents trip type */
  flightType?: InputMaybe<FlightsTripType>;
}

/** All criteria needed to perform a flight search */
export interface FlightSearchCriteriaInput {
  primary: PrimaryFlightCriteriaInput;
  secondary?: InputMaybe<ShoppingSearchCriteriaInput>;
}

/** Represent Type for the values of FlightSelectableAncillaryOption */
export enum FlightSelectableAncillaryOptionValuesType {
  /** Represents NONE value */
  NONE = 'NONE',
  /** Represents a Valid value | eg: upto 15 kg */
  VALID = 'VALID',
}

/** Represents the theme for the duration timeline */
export enum FlightShoppingCardDurationTimelineTheme {
  /** Default timeline theme (brand accent color) */
  DEFAULT = 'DEFAULT',
  /** Represents a color indicating a muted state (gray) */
  MUTE = 'MUTE',
  /** Represents a color indicating a success state (green) */
  SUCCESS = 'SUCCESS',
}

/** trip related information */
export interface FlightTripInfoDataInput {
  /** Represents the ancillary type of the flight */
  ancillaryType?: InputMaybe<FlightsAncillaryType>;
  /** Represents the segment of the flight */
  legNumber?: InputMaybe<Scalars['String']>;
  /** Represents trip entity id along with product id of the particular flight */
  productId?: InputMaybe<Scalars['String']>;
  /** Represents the trip view id of trip */
  tripViewId?: InputMaybe<Scalars['String']>;
}

/** Describes the type of actionable button. Types reference UDS tokens for buttons. */
export enum FlightsActionDisplayType {
  /** Checkbox. Example: To add Price Match Promise */
  CHECKBOX = 'CHECKBOX',
  /** Primary action. Example: 'Add Hotel Now' button, 'Retry' button */
  PRIMARY = 'PRIMARY',
  /** Radio Button. Example: To choose seats for a particular traveler */
  RADIO_BUTTON = 'RADIO_BUTTON',
  /** Secondary action. */
  SECONDARY = 'SECONDARY',
  /** Switch toggle action. Example: price alerts subscription toggle */
  SWITCH = 'SWITCH',
  /** Tertiary action. Example: 'No Thanks' */
  TERTIARY = 'TERTIARY',
  /** Toggle action. Example: seat button in seat map */
  TOGGLE = 'TOGGLE',
}

/** Represents the position of the action in the placard */
export enum FlightsActionPosition {
  /** Represents the action to be placed at the BOTTOM of the placard */
  BOTTOM = 'BOTTOM',
  /** Represents the action to be placed at the RIGHT of the placard */
  RIGHT = 'RIGHT',
}

/** Available action types an actionable element */
export enum FlightsActionType {
  /** Add Price Match Promise to the seleted fare */
  ADD_PRICE_MATCH_PROMISE = 'ADD_PRICE_MATCH_PROMISE',
  /** User has selected seat(s) for all passengers in that leg */
  ALL_SEATS_SELECTED_FOR_A_LEG = 'ALL_SEATS_SELECTED_FOR_A_LEG',
  /** Selects the chosen fare and reloads dynamic elements */
  APPLY_FARE = 'APPLY_FARE',
  /** Highlights the fare chosen by the user */
  CHOOSE_FARE = 'CHOOSE_FARE',
  /** Dialog Box used when customer clicks the 'Next Flight' Button before selecting seats for Current Flight */
  CLICKING_NEXT_FLIGHT_BEFORE_FINISHING_CURRENT_FLIGHT_SEAT_SELECTION_DIALOG = 'CLICKING_NEXT_FLIGHT_BEFORE_FINISHING_CURRENT_FLIGHT_SEAT_SELECTION_DIALOG',
  /** Dialog Box used when customer clicks the 'Continue Booking' Button before selecting all the seats */
  CONTINUE_BOOKING_WITHOUT_SELECTING_SEATS_DIALOG = 'CONTINUE_BOOKING_WITHOUT_SELECTING_SEATS_DIALOG',
  /** Go to coupon credit page */
  COUPON_CREDIT = 'COUPON_CREDIT',
  /** Dismisses a dialog */
  DISMISS = 'DISMISS',
  /** Activates the suggested filter */
  ENABLE_SUGGESTED_FILTER = 'ENABLE_SUGGESTED_FILTER',
  /** Fetch more search listings */
  FETCH_SEARCH_LISTINGS = 'FETCH_SEARCH_LISTINGS',
  /** Open an airline policy link */
  GO_TO_AIRLINE_POLICY = 'GO_TO_AIRLINE_POLICY',
  /** Redirect used when customer clicks signin/signup page/module option from 'you might have credits module listing' */
  GO_TO_AUTH = 'GO_TO_AUTH',
  /** Go to Checkout page */
  GO_TO_CHECKOUT = 'GO_TO_CHECKOUT',
  /** Go to the confirmation page of post booking ancillary selection */
  GO_TO_CONFIRMATION = 'GO_TO_CONFIRMATION',
  /** Continues to the standalone details page */
  GO_TO_DETAILS = 'GO_TO_DETAILS',
  /** Go to the merch hub of post booking ancillary selections */
  GO_TO_MERCH_HUB = 'GO_TO_MERCH_HUB',
  /** Continues to the next set of journey results */
  GO_TO_NEXT_JOURNEY = 'GO_TO_NEXT_JOURNEY',
  /** Continues to the packages path */
  GO_TO_PACKAGES = 'GO_TO_PACKAGES',
  /** Redirects to flights search page */
  GO_TO_SEARCH = 'GO_TO_SEARCH',
  /** Redirects back to storefront */
  GO_TO_STOREFRONT = 'GO_TO_STOREFRONT',
  /** Go to the trips overview page */
  GO_TO_TRIPS = 'GO_TO_TRIPS',
  /** Opens a dialog for to display cross sell information */
  LOAD_CROSS_SELL_DIALOG = 'LOAD_CROSS_SELL_DIALOG',
  /** open amenities tray and upsell options for standard offer flight listings */
  LOAD_STANDARD_OFFER_FARE_RULE_MODULE = 'LOAD_STANDARD_OFFER_FARE_RULE_MODULE',
  /** Opens a dialog to display tax breakdown information */
  LOAD_TAX_BREAKDOWN_DIALOG = 'LOAD_TAX_BREAKDOWN_DIALOG',
  /** Opens signin pop up on clicking on checkout button on FIS */
  MEMBER_SIGNIN = 'MEMBER_SIGNIN',
  /** User has not selected seat(s) for any passengers in that leg */
  NO_SEATS_SELECTED_FOR_A_LEG = 'NO_SEATS_SELECTED_FOR_A_LEG',
  /** Opens bags selection alert dialog on clicking on checkout button on FIS */
  OPEN_BAGS_SELECTION_ALERT_DIALOG_ON_CHECKOUT = 'OPEN_BAGS_SELECTION_ALERT_DIALOG_ON_CHECKOUT',
  /** Opens sidesheet for bags selection */
  OPEN_BAGS_SELECTION_SHEET = 'OPEN_BAGS_SELECTION_SHEET',
  /** Opens a dialog to to go to Airlines Site for Booking */
  OPEN_BOOK_DIRECTLY_WITH_AIRLINES_DIALOG = 'OPEN_BOOK_DIRECTLY_WITH_AIRLINES_DIALOG',
  /** Dialog Box used when customer clicks the 'Select credit' or 'Change Credit' option from 'you might have credits module listing' */
  OPEN_CREDIT_DIALOG = 'OPEN_CREDIT_DIALOG',
  /** Open Fare Seat information when clicked on required seat button */
  OPEN_FARE_SEAT_MAP_SEAT_SHEET = 'OPEN_FARE_SEAT_MAP_SEAT_SHEET',
  /** Open Fare Seat view to preview the seat map */
  OPEN_FARE_SEAT_MAP_VIEW = 'OPEN_FARE_SEAT_MAP_VIEW',
  /** Open Fare Seat view to select the seat */
  OPEN_FARE_SEAT_SELECT_VIEW = 'OPEN_FARE_SEAT_SELECT_VIEW',
  /** Open Flight leg drop down in seat map view */
  OPEN_FLIGHT_LEG_DROP_DOWN_IN_SEAT_MAP_DIALOG = 'OPEN_FLIGHT_LEG_DROP_DOWN_IN_SEAT_MAP_DIALOG',
  /** Open Legend info sheet in bottom in case of mobile */
  OPEN_LEGEND_INFO_SHEET_MOBILE = 'OPEN_LEGEND_INFO_SHEET_MOBILE',
  /** Open price summary */
  OPEN_PRICE_SUMMARY = 'OPEN_PRICE_SUMMARY',
  /** Opens seat selection alert dialog on clicking on checkout button on FIS */
  OPEN_SEAT_SELECTION_ALERT_DIALOG_ON_CHECKOUT = 'OPEN_SEAT_SELECTION_ALERT_DIALOG_ON_CHECKOUT',
  /** Redirects to Airlines Site for Booking */
  REDIRECT_TO_AIRLINES_FOR_BOOKING = 'REDIRECT_TO_AIRLINES_FOR_BOOKING',
  /** Refreshes the current page */
  REFRESH = 'REFRESH',
  /** Actionable item to add a journey */
  SEARCH_FORM_ADD_JOURNEY = 'SEARCH_FORM_ADD_JOURNEY',
  /** Closes the expanded Search Form */
  SEARCH_FORM_CLOSE_BUTTON = 'SEARCH_FORM_CLOSE_BUTTON',
  /** Actionable item to remove a journey */
  SEARCH_FORM_REMOVE_JOURNEY = 'SEARCH_FORM_REMOVE_JOURNEY',
  /** Dialog Box used when customer clicks the 'Close' Button before selecting all the seats */
  SEAT_MAP_CLOSE_WITHOUT_SELECTING_SEATS_DIALOG = 'SEAT_MAP_CLOSE_WITHOUT_SELECTING_SEATS_DIALOG',
  /** Continues to flight details page after selecting seats for all flights */
  SEAT_MAP_CONTINUE_BOOKING = 'SEAT_MAP_CONTINUE_BOOKING',
  /** Closes the current flight seat selection page and continues for next flight */
  SEAT_MAP_GO_TO_NEXT_FLIGHT = 'SEAT_MAP_GO_TO_NEXT_FLIGHT',
  /** Go to next flight section for selecting seats */
  SEAT_MAP_NEXT_FLIGHT = 'SEAT_MAP_NEXT_FLIGHT',
  /** Saves user's seat preferences and redirects to FIS */
  SEAT_MAP_SAVE_AND_EXIT = 'SEAT_MAP_SAVE_AND_EXIT',
  /** Stays at Page displaying Seat Map when selected by user */
  SEAT_MAP_STAY_HERE = 'SEAT_MAP_STAY_HERE',
  /** Continues to stay on the current flight seat selection page */
  SEAT_MAP_STAY_ON_THIS_PAGE = 'SEAT_MAP_STAY_ON_THIS_PAGE',
  /** Allows User to Continue Booking from the Seat Selection Dialog Box */
  SEAT_SELECT_DIALOG_CONTINUE_BOOKING = 'SEAT_SELECT_DIALOG_CONTINUE_BOOKING',
  /** Displays seat map preview corresponding to each traveler */
  SEAT_SELECT_PREVIEW_FOR_TRAVELER = 'SEAT_SELECT_PREVIEW_FOR_TRAVELER',
  /** Select Flight leg in seat map drop down menu */
  SELECT_FLIGHT_LEG_IN_SEAT_MAP_DIALOG = 'SELECT_FLIGHT_LEG_IN_SEAT_MAP_DIALOG',
  /** Select the seat */
  SELECT_SEAT = 'SELECT_SEAT',
  /** Open Opinion Lab Share Feedback dialogue */
  SHARE_FEEDBACK = 'SHARE_FEEDBACK',
  /** Open a modal showing details of the free Price Match Promise product */
  SHOW_FREE_PRICE_MATCH_PROMISE_DETAILS = 'SHOW_FREE_PRICE_MATCH_PROMISE_DETAILS',
  /** Open a modal showing details of the Price Match Promise product */
  SHOW_PRICE_MATCH_PROMISE_DETAILS = 'SHOW_PRICE_MATCH_PROMISE_DETAILS',
  /** User has selected seat(s) for at least 1 passenger but not all passengers in that leg */
  SOME_SEATS_SELECTED_FOR_A_LEG = 'SOME_SEATS_SELECTED_FOR_A_LEG',
  /** Subscribe to emails */
  SUBSCRIBE_TO_EMAILS = 'SUBSCRIBE_TO_EMAILS',
  /** Subscribe/Unsubscribes from price alerts */
  TOGGLE_PRICE_ALERTS = 'TOGGLE_PRICE_ALERTS',
  /** Unselect the selected seat */
  UNSELECT_SEAT = 'UNSELECT_SEAT',
  /** Opens FIS sidesheet and highlights next fare to upgrade */
  UPGRADE_TO_NEXT_FARE = 'UPGRADE_TO_NEXT_FARE',
}

/** Represents the value associated with additional amenities filter */
export interface FlightsAdditionalAmenitiesFilterValueInput {
  additionalAmenity: Scalars['String'];
}

/** Possible advanced filter types */
export enum FlightsAdvancedFilterType {
  NONSTOP = 'NONSTOP',
  REFUNDABLE = 'REFUNDABLE',
}

/** Represents details of air ancillary selection request */
export interface FlightsAirAncillarySelectionDetailInput {
  /** Represents index of each traveler. Example: '1' */
  travelerIndex: Scalars['Int'];
  /** Represents details of flight, ancillaries in encoded form mapped to each traveler. */
  unselectedAirAncillaryProductToken: Scalars['String'];
}

/** Represents the value associated with airport filter */
export interface FlightsAirportCodeFilterValueInput {
  airportCode: Scalars['String'];
}

/** Ancillary summary criteria for the selected fare */
export interface FlightsAncillaryCriteriaInput {
  /** Represents ancillary content for selected ancillary. Ex - Ancillary content (ancillaryToken) of specific seat. */
  ancillaryContent?: InputMaybe<AncillaryContentInput>;
  /** Represents ancillaryID to signify whether ancillaries were selected, null when no ancillaries were selected. */
  ancillaryId?: InputMaybe<Scalars['String']>;
  /** Represents the list of per segment(seats)/per product(bags) selections */
  ancillaryJourneySelections?: InputMaybe<Array<AncillaryJourneySelectionsInput>>;
  /** Represents path plus page for where ancillaries will be shopped. */
  ancillaryShoppingPath?: InputMaybe<AncillaryShoppingPath>;
  /** Represents the ancillary requested in the summary */
  ancillaryType: FlightsAncillaryType;
  /** Represents details of selected ancillaries for each journey */
  flightAncillaryJourneySelections?: InputMaybe<Array<FlightAncillaryJourneySelectionInput>>;
  /** Represents criteria for flights information page */
  flightsDetailComponentsCriteria?: InputMaybe<FlightsDetailComponentsCriteriaInput>;
  /** Represents identifier of a journey for a traveler. For Standalone shopping path its decodable string whereas for post purchase its trip Id. */
  journeyContinuationId: Scalars['String'];
  /** Represents Air Offer Token of the selected flight, null for first call on page load */
  selectedOfferToken?: InputMaybe<Scalars['String']>;
}

/** Possible advanced filter types */
export enum FlightsAncillaryDisplayAction {
  NONE = 'NONE',
  PREFETCH = 'PREFETCH',
}

/** Accessibility message types to be announced post selection */
export enum FlightsAncillarySelectionAccessibilityMsgType {
  /** Ancillary Selection Failed */
  SELECTION_FAILED = 'SELECTION_FAILED',
  /** Ancillary Selection Success */
  SELECTION_SUCCESS = 'SELECTION_SUCCESS',
}

/** Error types which can occur during ancillary selection */
export enum FlightsAncillarySelectionErrorType {
  /** Baggage Details loaded call failed */
  BAGGAGE_DETAILS_LOADED_FAILED = 'BAGGAGE_DETAILS_LOADED_FAILED',
  /** Ancillary details loading failed */
  DETAILS_LOADING_FAILED = 'DETAILS_LOADING_FAILED',
  /** Ancillary Pre-Selection Unavailable */
  PRE_SELECTION_FAILED = 'PRE_SELECTION_FAILED',
  /** Ancillary Selection Failed */
  SELECTION_FAILED = 'SELECTION_FAILED',
  /** Ancillary Selection Unavailable */
  SELECTION_UNAVAILABLE = 'SELECTION_UNAVAILABLE',
}

/** Type of ancillaries supported */
export enum FlightsAncillaryType {
  BAGS = 'BAGS',
  BAGS_V2 = 'BAGS_V2',
  NONE = 'NONE',
  SEATS = 'SEATS',
}

/** Represents the theme values for a Badge */
export enum FlightsBadgeTheme {
  BRAND = 'BRAND',
  DEAL_BUNDLED = 'DEAL_BUNDLED',
  DEAL_GENERIC = 'DEAL_GENERIC',
  DEAL_MEMBER = 'DEAL_MEMBER',
  FAMILY_FRIENDLY = 'FAMILY_FRIENDLY',
  NOTIFICATION = 'NOTIFICATION',
  SAVED = 'SAVED',
  SPONSORED = 'SPONSORED',
  SUPPLIER_PROMO = 'SUPPLIER_PROMO',
  VIEWED = 'VIEWED',
  VIP = 'VIP',
}

/** Represents the button width in the UI */
export enum FlightsButtonWidth {
  /** Button will take the width it needs */
  DEFAULT = 'DEFAULT',
  /** Button will take the full width of the content */
  FULL_WIDTH = 'FULL_WIDTH',
}

/** Cabin class chosen in flight */
export enum FlightsCabinClass {
  ANY = 'ANY',
  BUSINESS = 'BUSINESS',
  COACH = 'COACH',
  FIRST = 'FIRST',
  PREMIUM_ECONOMY = 'PREMIUM_ECONOMY',
}

/** Represents the value associated with preferred cabin filter */
export interface FlightsCabinClassFilterValueInput {
  cabinCode: Scalars['String'];
}

/** Cabin class chosen in flight */
export enum FlightsCardBackgroundTheme {
  HIGHLIGHT = 'HIGHLIGHT',
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
}

/** Represents the value associated with travel and baggage filter - carry on bag */
export interface FlightsCarryOnBagBasedFilterValueInput {
  carryOnBag: CarryOnBagType;
  displayToast?: InputMaybe<Scalars['Boolean']>;
}

/** Represents the type of categories */
export enum FlightsCategorizedListSectionType {
  BAG = 'BAG',
  BAG_STEPPER_EXPERIENCE = 'BAG_STEPPER_EXPERIENCE',
  SEAT = 'SEAT',
}

/** Represents the value associated with travel and baggage filter - checked bag */
export interface FlightsCheckedBagBasedFilterValueInput {
  displayToast?: InputMaybe<Scalars['Boolean']>;
  numOfCheckedBags: Scalars['Int'];
}

/** Represents the value credit eligible filter */
export interface FlightsCreditEligibleFilterValueInput {
  creditEligible: CreditEligibleFilterType;
}

/** Represents an individual cross sort parameter */
export interface FlightsCrossSortOptionInput {
  /** Enumeration of the parameter type for the accompanying weight */
  type: FlightsCrossSortType;
  /** The current weight of the individual cross sort parameter */
  weight: Scalars['Int'];
}

/** User specified parameters for cross sort */
export interface FlightsCrossSortOptionTypeInput {
  /** The array of all cross-sort parameters selected by the user */
  crossSortOption: Array<FlightsCrossSortOptionInput>;
}

/** Enum class to represent cross sort types */
export enum FlightsCrossSortType {
  CABIN_CLASS = 'CABIN_CLASS',
  CANCELLATION = 'CANCELLATION',
  CARRY_ON_BAG = 'CARRY_ON_BAG',
  CHANGE_ALLOWED = 'CHANGE_ALLOWED',
  CHECKED_BAG = 'CHECKED_BAG',
  DURATION = 'DURATION',
  NUM_OF_STOPS = 'NUM_OF_STOPS',
  PRICE = 'PRICE',
  SEAT_CHOICE = 'SEAT_CHOICE',
}

/** Represents criteria for continue booking for selecting ancillaries on flight information page */
export interface FlightsDetailAncillaryUpdateCriteriaInput {
  /** Represents details of air ancillary selection request */
  airAncillaryDetails: Array<FlightsAirAncillarySelectionDetailInput>;
  /** Represents the list of per segment(seats)/per product(bags) selections */
  ancillaryJourneySelections?: InputMaybe<Array<AncillaryJourneySelectionsInput>>;
  /** Represents path plus page for where ancillaries will be shopped. */
  ancillaryShoppingPath?: InputMaybe<AncillaryShoppingPath>;
  /** Represents the ancillary type for update */
  ancillaryType?: InputMaybe<FlightsAncillaryType>;
  /** Represents details of selected ancillaries for each journey */
  flightAncillaryJourneySelections?: InputMaybe<Array<FlightAncillaryJourneySelectionInput>>;
  /** Represents criteria for flights information page */
  flightsDetailComponentsCriteria?: InputMaybe<FlightsDetailComponentsCriteriaInput>;
  /** Represents identifier of a journey for a traveler. For Standalone shopping path its decodable string whereas for post purchase its trip Id. */
  journeyContinuationId: Scalars['String'];
  /** Represents Air Offer Token of the selected flight */
  journeyIdentifier: Scalars['String'];
}

/** Represents criteria for flights information page. */
export interface FlightsDetailComponentsCriteriaInput {
  /** Represents FlightsSearchContext of the selected flight */
  flightsSearchContext: FlightsSearchContextInput;
  /** Represents FlightsJourneyCriteria of the selected flight */
  journeyCriteria: Array<FlightsJourneyCriteriaInput>;
  /** Represents Air Offer Token of the selected flight */
  journeyIdentifier: Scalars['String'];
  /** Represents Price of the selected flight */
  originalPrice?: InputMaybe<MoneyInput>;
  /** Represents QueryParams of the selected flight */
  queryParams?: InputMaybe<Array<GraphQLPairInput>>;
  /** Represents FlightsSearchPreferences of the selected flight */
  searchPreferences?: InputMaybe<FlightsSearchPreferencesInput>;
  /** Represents FlightsTravelerDetails of the selected flight */
  travelerDetails: Array<FlightsTravelerDetailsInput>;
  /** Represents upsell offer token of the selected flight */
  upsellOfferToken?: InputMaybe<Scalars['String']>;
}

/** Represents criteria for flights information page. */
export interface FlightsDetailCriteriaInput {
  /** This will contain the list of ancillaries for which auto shopping is complete. */
  additionalShoppedAncillaries?: InputMaybe<Array<AdditionalShoppedAncillaries>>;
  /** Encoded representation of ancillaries that was selected on FIS. */
  ancillaryId?: InputMaybe<Scalars['String']>;
  /** Represents the type of the channel for example VirtualAgent */
  channelType?: InputMaybe<ChannelType>;
  /** Represents the current step for the stepper experience */
  currentStep?: InputMaybe<FlightsStep>;
  /** Represents the type of the card for One click fare upgrade. */
  flightsOneClickFareUpgradeCardType?: InputMaybe<FlightsOneClickFareUpgradeCardType>;
  /** Represent the continuation identifier for spinner to deduce all journeys selected by the user. */
  journeyContinuationId: Scalars['String'];
  /** Represents upsell offer token of the last selected fare on FIS, this is for One click fare upgrade */
  lastSelectedOfferToken?: InputMaybe<Scalars['String']>;
  /** Represents upsell offer token of the last selected fare on FIS, this is for One click fare upgrade */
  lastSelectedOfferTokensInformation?: InputMaybe<FlightsOneClickFareLastSelectedTokensInput>;
  /** Represents the identifier for the spinner to deduce which all credits have been selected by the user */
  originalBookingId?: InputMaybe<Scalars['String']>;
  /** Represents the product_offers_id used as enrichment key for Clickstream events and UIS Prime micro messages */
  productOffersId?: InputMaybe<Scalars['String']>;
  /** Represents upsell offer token of the selected flight */
  upsellOfferToken?: InputMaybe<Scalars['String']>;
}

/** Represents the information of the user device */
export interface FlightsDevicePermissionsInput {
  /** Represents the array of all the notifications enabled for the user device */
  pushNotificationsEnabled: Array<NotificationsType>;
}

/** Represents flights dialog actions */
export enum FlightsDialogAction {
  CLOSE = 'CLOSE',
  OPEN = 'OPEN',
  TOGGLE = 'TOGGLE',
}

/** Represents the type of animation the dialog will use when displayed */
export enum FlightsDialogAnimation {
  FADE = 'FADE',
  NONE = 'NONE',
}

/** Represents IDs for flights dialogs */
export enum FlightsDialogId {
  /** Represents the Airlines credit dialog */
  AIRLINE_CREDITS = 'AIRLINE_CREDITS',
  /** Represents the Close button dialog for the baggage details when complete selections have been made */
  BAGGAGE_CLOSE_COMPLETE_DIALOG = 'BAGGAGE_CLOSE_COMPLETE_DIALOG',
  /**
   * Represents the Close button dialog for the baggage details
   * @deprecated Use baggage close complete/incomplete dialogs
   */
  BAGGAGE_CLOSE_DIALOG = 'BAGGAGE_CLOSE_DIALOG',
  /** Represents the Close button dialog for the baggage details when incomplete selections have been made */
  BAGGAGE_CLOSE_INCOMPLETE_DIALOG = 'BAGGAGE_CLOSE_INCOMPLETE_DIALOG',
  /** Represents the Continue booking dialog for the baggage details */
  BAGGAGE_CONTINUE_BOOKING = 'BAGGAGE_CONTINUE_BOOKING',
  /** Represents the dialog ID for Baggage details */
  BAGGAGE_DETAILS_DIALOG = 'BAGGAGE_DETAILS_DIALOG',
  /** Represents the bags popup dialog on checkout button */
  BAGS_POPUP_ON_CHECKOUT = 'BAGS_POPUP_ON_CHECKOUT',
  /** Represents the check credits dialog for users coming from MCC and VA */
  CHECK_CREDITS_DIALOG = 'CHECK_CREDITS_DIALOG',
  /** Represents the dialog ID for disclaimer dialog related to cko reassurance banner */
  CKO_REASSURANCE_DISCLAIMER_DIALOG = 'CKO_REASSURANCE_DISCLAIMER_DIALOG',
  /** Represents the avion more info dialog */
  FLIGHTS_AVION_MORE_INFO_DIALOG = 'FLIGHTS_AVION_MORE_INFO_DIALOG',
  /** Represents the bag dimension bottom sheet */
  FLIGHTS_BAG_DIMENSION_BOTTOM_SHEET = 'FLIGHTS_BAG_DIMENSION_BOTTOM_SHEET',
  /** Represents the first journey bag dimension bottom sheet */
  FLIGHTS_BAG_DIMENSION_BOTTOM_SHEET_FIRST = 'FLIGHTS_BAG_DIMENSION_BOTTOM_SHEET_FIRST',
  /** Represents the second journey bag dimension bottom sheet */
  FLIGHTS_BAG_DIMENSION_BOTTOM_SHEET_SECOND = 'FLIGHTS_BAG_DIMENSION_BOTTOM_SHEET_SECOND',
  /** Represents the Flights Details and Fares dialog */
  FLIGHTS_DETAILS_AND_FARES = 'FLIGHTS_DETAILS_AND_FARES',
  /** Represents the Flights Details dialog */
  FLIGHTS_DETAILS_DIALOG = 'FLIGHTS_DETAILS_DIALOG',
  /** Represents the flights exit seats dialog */
  FLIGHTS_EXIT_SEAT_DIALOG = 'FLIGHTS_EXIT_SEAT_DIALOG',
  /** The Forced choice modal that appears in large breakpoints when going to FIS */
  FORCED_CHOICE_MODAL = 'FORCED_CHOICE_MODAL',
  /** Represents the ID for the expired flight deals dialog */
  FSR_EXPIRED_DEALS_DIALOG = 'FSR_EXPIRED_DEALS_DIALOG',
  /** Represents the ID for the more info on how flight deals work sheet on FSR page */
  FSR_HOW_DEALS_WORK_SHEET = 'FSR_HOW_DEALS_WORK_SHEET',
  /** Represents the ID for the disclaimer dialog related to the strikethrough price in the FSR out page */
  FSR_OUT_DISCLAIMER_DIALOG = 'FSR_OUT_DISCLAIMER_DIALOG',
  /** Represents the How Airlines Work dialog inside Select Credits */
  HOW_CREDITS_WORK = 'HOW_CREDITS_WORK',
  /** Represents the Leave This Page dialog inside Select Credits */
  LEAVE_TO_COUPONS = 'LEAVE_TO_COUPONS',
  /** Represents the sign in Dialog */
  MEMBER_SIGN_IN_DIALOG = 'MEMBER_SIGN_IN_DIALOG',
  /** Represents the dialog ID while merchandising selections are being booked */
  MERCHANDISING_SELECTIONS_BOOKING_LOADING = 'MERCHANDISING_SELECTIONS_BOOKING_LOADING',
  /** Represents the dialog ID for merchandising selections expiry dialog */
  MERCHANDISING_SELECTIONS_EXPIRY = 'MERCHANDISING_SELECTIONS_EXPIRY',
  /** Represents the ID for the Mobile Application Download Sheet */
  MOBILE_APP_DOWNLOAD_SHEET = 'MOBILE_APP_DOWNLOAD_SHEET',
  /** Represents the ID for the dialog box when for OCU we downgrade a fare and the dialog is shown for losing amenities */
  ONE_CLICK_FARE_DOWNGRADE_DIALOG = 'ONE_CLICK_FARE_DOWNGRADE_DIALOG',
  /** Represents the ID for the sheet which shows the fare split ticket banner */
  ONE_CLICK_FARE_SPLIT_TICKET_BANNER_SHEET = 'ONE_CLICK_FARE_SPLIT_TICKET_BANNER_SHEET',
  /** Represents the bags opening dialog eg:- sidesheet for desktop , fullscreendialog for mobile */
  PAID_BAGS_DIALOG = 'PAID_BAGS_DIALOG',
  /** Represents the Info dialog for Price Match Promise Selected Card */
  PMP_INFO_DIALOG = 'PMP_INFO_DIALOG',
  /** Represents the Price Match Promise One Key Web dialog */
  PMP_ONE_KEY_WEB_DIALOG = 'PMP_ONE_KEY_WEB_DIALOG',
  /** Represents the Remove dialog for Price Match Promise Selected Card */
  PMP_REMOVE_DIALOG = 'PMP_REMOVE_DIALOG',
  /** Represents the seats popup dialog on checkout button */
  SEATS_POPUP_ON_CHECKOUT = 'SEATS_POPUP_ON_CHECKOUT',
  /** Represents the dialog ID for seat cell details dialog */
  SEAT_CELL_DETAILS_DIALOG = 'SEAT_CELL_DETAILS_DIALOG',
  /** Represents the Close button dialog for the seat details */
  SEAT_CLOSE_COMPLETE_DIALOG = 'SEAT_CLOSE_COMPLETE_DIALOG',
  /** Represents the Continue booking dialog for the baggage details */
  SEAT_CONTINUE_BOOKING = 'SEAT_CONTINUE_BOOKING',
  /** Represents the dialog ID for seat legends dialog */
  SEAT_LEGEND_DIALOG = 'SEAT_LEGEND_DIALOG',
  /** Represents the seat map preview dialog on fsr */
  SEAT_MAP_PREVIEW_DIALOG = 'SEAT_MAP_PREVIEW_DIALOG',
  /** Represents the seats opening dialog eg:- sidesheet for desktop , fullscreendialog for mobile */
  SEAT_SELECTION_DIALOG = 'SEAT_SELECTION_DIALOG',
  /** Represents the skip to bags seats incomplete selection dialog */
  SKIP_TO_BAGS_SEATS_INCOMPLETE_SELECTION_DIALOG = 'SKIP_TO_BAGS_SEATS_INCOMPLETE_SELECTION_DIALOG',
  /** Represents the skip to bags seats no selection dialog */
  SKIP_TO_BAGS_SEATS_NO_SELECTION_DIALOG = 'SKIP_TO_BAGS_SEATS_NO_SELECTION_DIALOG',
  /** Represents the skip to checkout bags dialog */
  SKIP_TO_CKO_BAGS_DIALOG = 'SKIP_TO_CKO_BAGS_DIALOG',
  /** Represents the skip to checkout seats and bags dialog */
  SKIP_TO_CKO_SEATS_AND_BAGS_DIALOG = 'SKIP_TO_CKO_SEATS_AND_BAGS_DIALOG',
  /** Represents the skip to checkout seats dialog */
  SKIP_TO_CKO_SEATS_DIALOG = 'SKIP_TO_CKO_SEATS_DIALOG',
  /** Represents the dialog on traveler mismatch for credits offer */
  TRAVELER_MISMATCH_DIALOG = 'TRAVELER_MISMATCH_DIALOG',
}

/** Represents a pre action in flights dialog trigger */
export enum FlightsDialogPreAction {
  CLOSE_ALL_DIALOGS = 'CLOSE_ALL_DIALOGS',
}

/** Represents flights component */
export enum FlightsDisplayComponent {
  SMART_NFF_ALTERNATE_SUGGESTION = 'SMART_NFF_ALTERNATE_SUGGESTION',
}

/** Represents display count of a component within a session e.g How many time NFF shows consecutively   */
export interface FlightsDisplayComponentCountingValueInput {
  /** Represents display count of a flights component */
  displayCount: Scalars['Int'];
  flightsDisplayComponent: FlightsDisplayComponent;
}

/** Represents flights component display values */
export interface FlightsDisplayComponentValuesInput {
  /** Represents counting values of flights display component */
  displayCountingValues?: InputMaybe<Array<FlightsDisplayComponentCountingValueInput>>;
}

/** Represents the value associated with duration based filter */
export interface FlightsDurationBasedFilterValueInput {
  maxDuration: Scalars['Int'];
}

/** Css class names for datepicker cell content. */
export enum FlightsFareCalendarPriceTheme {
  NEGATIVE = 'NEGATIVE',
  POSITIVE = 'POSITIVE',
  UNDEFINED = 'UNDEFINED',
}

/** Represents the fares scroll direction */
export enum FlightsFaresScrollDirection {
  HORIZONTAL = 'HORIZONTAL',
  VERTICAL = 'VERTICAL',
}

/** Represent the fares needs to be present in listing results */
export enum FlightsFaresSeparationType {
  BASE_AND_UPSELL = 'BASE_AND_UPSELL',
  NONSTOP_BASE_AND_UPSELL = 'NONSTOP_BASE_AND_UPSELL',
  NONSTOP_ONLY_BASE = 'NONSTOP_ONLY_BASE',
  NONSTOP_ONLY_UPSELL = 'NONSTOP_ONLY_UPSELL',
  ONLY_BASE = 'ONLY_BASE',
  ONLY_UPSELL = 'ONLY_UPSELL',
}

/** Enum class to represent the available filter types */
export enum FlightsFilterType {
  ADDITIONAL_AMENITY = 'ADDITIONAL_AMENITY',
  ARRIVAL_AIRPORT = 'ARRIVAL_AIRPORT',
  ARRIVAL_TIME = 'ARRIVAL_TIME',
  ARRIVAL_TIME_SLIDER = 'ARRIVAL_TIME_SLIDER',
  CARRY_ON_BAG = 'CARRY_ON_BAG',
  CHECKED_BAG = 'CHECKED_BAG',
  CREDIT_ELIGIBLE = 'CREDIT_ELIGIBLE',
  DEPARTURE_AIRPORT = 'DEPARTURE_AIRPORT',
  DEPARTURE_TIME = 'DEPARTURE_TIME',
  DEPARTURE_TIME_SLIDER = 'DEPARTURE_TIME_SLIDER',
  DURATION = 'DURATION',
  FLEXIBLE_CHANGE_POLICIES = 'FLEXIBLE_CHANGE_POLICIES',
  LAYOVER_AIRPORT = 'LAYOVER_AIRPORT',
  LAYOVER_TIME_SLIDER = 'LAYOVER_TIME_SLIDER',
  NO_CANCEL_FEE = 'NO_CANCEL_FEE',
  NO_CHANGE_FEE = 'NO_CHANGE_FEE',
  NUM_OF_STOPS = 'NUM_OF_STOPS',
  POPULAR_FILTER = 'POPULAR_FILTER',
  PREFERRED_AIRLINE = 'PREFERRED_AIRLINE',
  PREFERRED_CABIN = 'PREFERRED_CABIN',
  PRICE = 'PRICE',
  SEAT_CHOICE = 'SEAT_CHOICE',
  TRAVEL_AND_BAGGAGE = 'TRAVEL_AND_BAGGAGE',
  TRAVEL_TIME_SLIDER = 'TRAVEL_TIME_SLIDER',
}

/** Represents the value associated with flexible change policies filter */
export interface FlightsFlexibleChangePolicyBasedFilterValueInput {
  policyName: FilterPolicyType;
}

/** Represents the flexible grid type */
export enum FlightsFlexibleGridType {
  /** Flex Search type shown for OW */
  FLEX_SEARCH = 'FLEX_SEARCH',
  /** Flex Search Grid type shown for RT Outbound */
  FLEX_SEARCH_GRID = 'FLEX_SEARCH_GRID',
  /** No Flex Search variant shown */
  FLEX_SEARCH_NOT_APPLICABLE = 'FLEX_SEARCH_NOT_APPLICABLE',
}

/** Represent flexible search header cell theme */
export enum FlightsFlexibleSearchHeaderCellTheme {
  /** Theme to represent an outbound or inbound departureDate header */
  DEFAULT = 'DEFAULT',
  /** Theme to represent an outbound or inbound departureDate that was searched on */
  SEARCHED_DATE_HEADER = 'SEARCHED_DATE_HEADER',
}

/** Represent flexible search legend cell theme */
export enum FlightsFlexibleSearchLegendCellTheme {
  DEFAULT = 'DEFAULT',
}

/** Represent flexible search result cell theme */
export enum FlightsFlexibleSearchResultCellTheme {
  /** Default theme */
  DEFAULT_PRICE = 'DEFAULT_PRICE',
  /** Theme to represent highest priced cells in the matrix */
  HIGHEST_PRICE = 'HIGHEST_PRICE',
  /** Theme to represent the lowest price displayed in the matrix */
  LOWEST_PRICE = 'LOWEST_PRICE',
  /** Theme to represent when no price is available, 'Search' */
  NO_PRICE = 'NO_PRICE',
  /** Theme to represent the price corresponding to the flight on the input departureDate */
  SEARCHED_DATE = 'SEARCHED_DATE',
  /** Theme to represent a cell that corresponds to the input departureDate and is also lowest price displayed in the matrix */
  SEARCHED_DATE_LOWEST_PRICE = 'SEARCHED_DATE_LOWEST_PRICE',
  /** Theme to represent a cell that corresponds to the input departureDate and is also the price is not available */
  SEARCHED_DATE_NO_PRICE = 'SEARCHED_DATE_NO_PRICE',
  /** Theme to represent a cell that corresponds to the input departureDate and flights dont fly on the given departureDate */
  SEARCHED_DATE_UNAVAILABLE_FLIGHTS = 'SEARCHED_DATE_UNAVAILABLE_FLIGHTS',
  /** Theme to represent the price is unavailable because flights don't fly for the given departureDate and route, 'No Flights' */
  UNAVAILABLE_FLIGHTS = 'UNAVAILABLE_FLIGHTS',
}

/** Enum class to represent the available heading sizes */
export enum FlightsHeadingSize {
  EIGHT = 'EIGHT',
  FIVE = 'FIVE',
  FOUR = 'FOUR',
  ONE = 'ONE',
  SEVEN = 'SEVEN',
  SIX = 'SIX',
  THREE = 'THREE',
}

/** Status associated with a composite icon in IconStatus */
export enum FlightsIconAvailabilityStatus {
  EXCLUDED = 'EXCLUDED',
  FEE = 'FEE',
  INCLUDED = 'INCLUDED',
}

/** Represents the position of the icon */
export enum FlightsIconPosition {
  /** Icon will be rendered at the beginning of the content */
  LEADING = 'LEADING',
  /** Icon will be rendered at the end of the content */
  TRAILING = 'TRAILING',
}

/** Alignment of secondary icon in IconStatus */
export enum FlightsIconStatusSecondaryAlignment {
  CENTER = 'CENTER',
  LEFT = 'LEFT',
  RIGHT = 'RIGHT',
}

/** This contains list of active experience that needs to be shown eg: StepperSeats, OCU etc */
export enum FlightsInfositeExperience {
  STEPPER_BAGS = 'STEPPER_BAGS',
  STEPPER_EXPERIENCE = 'STEPPER_EXPERIENCE',
  STEPPER_SEATS = 'STEPPER_SEATS',
}

/** The input object for flights search */
export interface FlightsJourneyCriteriaInput {
  /** Arrival date of the flight */
  arrivalDate?: InputMaybe<DateInput>;
  /** Departure date of the flight */
  departureDate: DateInput;
  /** Three letter code of the destination airport */
  destination: Scalars['String'];
  /** Location type of the destination airport */
  destinationAirportLocationType?: InputMaybe<AirportLocationType>;
  /** # Deprecated: Please use cabinClass in FlightsSearchPreferences */
  flightsCabinClass?: InputMaybe<FlightsCabinClass>;
  /** Three letter code of the origin airport */
  origin: Scalars['String'];
  /** Location type of the origin airport */
  originAirportLocationType?: InputMaybe<AirportLocationType>;
}

/** Target of the Link when clicked */
export enum FlightsLinkTarget {
  /** Link will be opened in an external view e.g. new tab or browser window */
  EXTERNAL = 'EXTERNAL',
  /** Link will be opened in the same view where the user is currently e.g. same tab or webview inside an app */
  INTERNAL = 'INTERNAL',
}

/** Represents page load type of FSR */
export enum FlightsListingsViewType {
  MIXED = 'MIXED',
  SINGLE = 'SINGLE',
}

export enum FlightsLoadedListingsStatus {
  LOW_RESULTS = 'LOW_RESULTS',
  NO_RESULTS = 'NO_RESULTS',
}

/** Metrics names */
export enum FlightsMetricName {
  DETAILS_JOURNEY_SUMMARY_SUPPLY_RESPONSE_TIME = 'DETAILS_JOURNEY_SUMMARY_SUPPLY_RESPONSE_TIME',
  DETAILS_PRICE_SUMMARY_SUPPLY_RESPONSE_TIME = 'DETAILS_PRICE_SUMMARY_SUPPLY_RESPONSE_TIME',
  LISTINGS_SUPPLY_RESPONSE_TIME = 'LISTINGS_SUPPLY_RESPONSE_TIME',
}

/** Represents the value associated with travel and baggage filter - no cancel fee */
export interface FlightsNoCancelFeeBasedFilterValueInput {
  noCancelFee: NoCancelFeeType;
}

/** Represents the value associated with travel and baggage filter - no change name */
export interface FlightsNoChangeFeeBasedFilterValueInput {
  noChangeFee: NoChangeFeeType;
}

/** Represents the last selected offer tokens information */
export interface FlightsOneClickFareLastSelectedTokensInput {
  /** Represents the currently selected fare when product token in the upsellToken is different than the last selected offer token */
  lastChangedOfferToken?: InputMaybe<Scalars['String']>;
  /** Represents the currently selected fare which client will send as lastSelectedOfferToken */
  lastSelectedOfferToken?: InputMaybe<Scalars['String']>;
}

export enum FlightsOneClickFareUpgradeCardType {
  OCU = 'OCU',
  REFUNDABILITY = 'REFUNDABILITY',
}

/** The text style to apply to strings */
export enum FlightsPhrasePartStyle {
  /** Italic styling */
  EMPHASIS = 'EMPHASIS',
  /** Bold styling */
  IMPORTANT = 'IMPORTANT',
  /** Represents no style or regular text */
  STANDARD = 'STANDARD',
}

/** Represents an object to be used to differentiate the type of Placards(Ex : Placards to be shown immediately vs those which are shown during server error */
export enum FlightsPlacardDisplayType {
  /** Represents the placard type to be shown immediately */
  IMMEDIATE = 'IMMEDIATE',
  /** Represents the placard type to be shown during server error of sort and filter action */
  SORT_FILTERS_SERVER_ERROR = 'SORT_FILTERS_SERVER_ERROR',
}

/** Represents different background themes for placard */
export enum FlightsPlacardTheme {
  HIGHLIGHT = 'HIGHLIGHT',
  LOYALTY = 'LOYALTY',
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
  STANDARD = 'STANDARD',
}

/** Represents a type of placards the client can request for */
export enum FlightsPlacardType {
  /** Represents the placard of type free cancellation */
  FREE_CANCELLATION = 'FREE_CANCELLATION',
  /** Represents the placard of type hotel attach */
  HOTEL_ATTACH = 'HOTEL_ATTACH',
  /** Represents the placard of type loyalty reward */
  LOYALTY_REWARD = 'LOYALTY_REWARD',
  /** Represents the placard of type no change fees */
  NO_CHANGE_FEES = 'NO_CHANGE_FEES',
  /** Represents the placard of type passport */
  PASSPORT = 'PASSPORT',
  /** Represents the placard of type price change */
  PRICE_CHANGE = 'PRICE_CHANGE',
  /** Represents the placard of type split ticket */
  SPLIT_TICKET = 'SPLIT_TICKET',
}

/** Represents the value associated with preferred airline filter */
export interface FlightsPreferredAirlineFilterValueInput {
  carrierCode: Scalars['String'];
}

/** Represents the display of progress bar when the results are loading */
export enum FlightsProgressBarDisplay {
  DISABLED = 'DISABLED',
  ENABLED = 'ENABLED',
}

/** Represents the state the client wants to query */
export enum FlightsQueryState {
  LOADED = 'LOADED',
  LOADING = 'LOADING',
}

/** Enum class to represent the id associated with the rewards option */
export enum FlightsRewardsOptionId {
  ALTAIR = 'ALTAIR',
  AVION = 'AVION',
  NONAVION = 'NONAVION',
}

export interface FlightsSearchComponentCriteriaInput {
  /** Parameter to recognize that traffic source is meta search */
  isMetaTraffic?: InputMaybe<Scalars['Boolean']>;
  /** Represents Air Offer Token of the selected flight */
  journeyIdentifier?: InputMaybe<Scalars['String']>;
  /** Represents Unresolved list of params for meta. Like MDPCID, etc. */
  queryParams?: InputMaybe<Array<GraphQLPairInput>>;
}

/** Context for flights search */
export interface FlightsSearchContextInput {
  /** Represents that the user is intending to redeem credits (i.e. coming from My Coupons and Credits or Virtual Agent) */
  hasCreditRedemptionIntent?: InputMaybe<Scalars['Boolean']>;
  /** Represent the continuation identifier for spinner to deduce which all journeys have been selected. Null value represents the request is for first journey. */
  journeysContinuationId?: InputMaybe<Scalars['String']>;
  /** Represents the identifier for the spinner to deduce which all credits have been selected by the user */
  originalBookingId?: InputMaybe<Scalars['String']>;
  /** Represents the flights user selected for each segment when the user proceeded to FIS.This node will be populated on the search response only if customer is returning to FSR from FIS. */
  previousFlightSelections?: InputMaybe<Array<JourneyFlightSelectionInput>>;
  /** Represents the previously selected credit's originalBookingId to correctly render the toast when credits are changed */
  previousOriginalBookingId?: InputMaybe<Scalars['String']>;
  /** Represents the mismatched search criteria between the current search and servicing need */
  searchCriteriaMismatch?: InputMaybe<Array<FlightsSearchCriteriaMismatch>>;
  /** Represents the search_id used as enrichment key for Clickstream events and UIS Prime micro messages */
  searchId?: InputMaybe<Scalars['String']>;
  /** Trip type in search */
  tripType: FlightsTripType;
}

/** Represents the mismatched criterion between the current search and servicing need */
export enum FlightsSearchCriteriaMismatch {
  TRAVELER = 'TRAVELER',
}

/** Represents enum to distinguish between flights search queries */
export enum FlightsSearchExperienceType {
  CODESHARE = 'CODESHARE',
  FLIGHT_DETAILS = 'FLIGHT_DETAILS',
  OFFER_LISTING = 'OFFER_LISTING',
}

/** Represents an element of the list which the client needs to send back to the server as part of the request. This will be part of each FilterItem so client need not apply any logic on filter selection but simply add this to the next request */
export interface FlightsSearchFilterValuesInput {
  /** Represents the value associated with additional amenities filter */
  additionalAmenityFilterValue?: InputMaybe<FlightsAdditionalAmenitiesFilterValueInput>;
  /** Represents the value associated with arrival airport filter. */
  arrivalAirportCodeFilterValue?: InputMaybe<FlightsAirportCodeFilterValueInput>;
  /** Represents the FilterValue object corresponding to the Arrival Time filter. */
  arrivalTimeFilterValue?: InputMaybe<FlightsTimeBasedFilterValueInput>;
  /** Represents the FilterValue object corresponding to the Arrival Time Slider filter. */
  arrivalTimeSliderFilterValue?: InputMaybe<FlightsSliderFilterValueInput>;
  /** Represents the value associated with travel and baggage filter - carry on bag. */
  carryOnBagBasedFilterValue?: InputMaybe<FlightsCarryOnBagBasedFilterValueInput>;
  /** Represents the value associated with travel and baggage filter - checked bag. */
  checkedBagBasedFilterValue?: InputMaybe<FlightsCheckedBagBasedFilterValueInput>;
  /** Represents the value associated with credit eligible filter */
  creditEligibleFilterValue?: InputMaybe<FlightsCreditEligibleFilterValueInput>;
  /** Represents the value associated with departure airport filter. */
  departureAirportCodeFilterValue?: InputMaybe<FlightsAirportCodeFilterValueInput>;
  /** Represents the FilterValue object corresponding to the Departure Time filter. */
  departureTimeFilterValue?: InputMaybe<FlightsTimeBasedFilterValueInput>;
  /** Represents the FilterValue object corresponding to the Departure Time Slider filter. */
  departureTimeSliderFilterValue?: InputMaybe<FlightsSliderFilterValueInput>;
  /** Represents the FilterValue object corresponding to the Duration filter. */
  durationFilterValue?: InputMaybe<FlightsDurationBasedFilterValueInput>;
  /** Represents the value associated with flexible change policies filter. */
  flexibleChangePolicyBasedFilterValue?: InputMaybe<FlightsFlexibleChangePolicyBasedFilterValueInput>;
  /** Represents the value associated with layover airport filter. */
  layoverAirportCodeFilterValue?: InputMaybe<FlightsAirportCodeFilterValueInput>;
  /** Represents the value associated with layover duration filter. */
  layoverDurationFilterValue?: InputMaybe<FlightsSliderFilterValueInput>;
  /** Represents the value associated with travel and baggage filter - no cancel fee. */
  noCancelFeeBasedFilterValue?: InputMaybe<FlightsNoCancelFeeBasedFilterValueInput>;
  /** Represents the value associated with travel and baggage filter - no change fee. */
  noChangeFeeBasedFilterValue?: InputMaybe<FlightsNoChangeFeeBasedFilterValueInput>;
  /** Represents the FilterValue object corresponding to the Number of stops filter. */
  numOfStopFilterValue?: InputMaybe<FlightsStopBasedFilterValueInput>;
  /** Represents the FilterValue object corresponding to the Preferred Airline filter. */
  preferredAirlineFilterValue?: InputMaybe<FlightsPreferredAirlineFilterValueInput>;
  /** Represents the value associated with cabin filter */
  preferredCabinFilterValue?: InputMaybe<FlightsCabinClassFilterValueInput>;
  /** Represents the FilterValue object corresponding to the Price Slider filter. */
  priceFilterValue?: InputMaybe<FlightsSliderFilterValueInput>;
  /** Represents the value associated with travel and baggage filter - seat choice. */
  seatChoiceBasedFilterValue?: InputMaybe<FlightsSeatChoiceBasedFilterValueInput>;
  /** Represents the value associated with travel and baggage filter. */
  travelAndBaggageBasedFilterValue?: InputMaybe<FlightsTravelAndBaggageBasedFilterValueInput>;
  /** Represents the value associated with travel time slider filter. */
  travelTimeSliderFilterValue?: InputMaybe<FlightsSliderFilterValueInput>;
}

export enum FlightsSearchFormErrorType {
  /** Age of child is missing */
  CHILD_AGE_MISSING = 'CHILD_AGE_MISSING',
  /** Date before previous date - Multi-dest */
  DATE_BEFORE_PREVIOUS_DATE = 'DATE_BEFORE_PREVIOUS_DATE',
  /** Date must be between a range */
  DATE_NOT_IN_VALID_RANGE = 'DATE_NOT_IN_VALID_RANGE',
  /** Dates must be greater than or equal to default date/checkin date. */
  DATE_NOT_IN_VALID_RANGE_TO_DEFAULT_DATE = 'DATE_NOT_IN_VALID_RANGE_TO_DEFAULT_DATE',
  /** Age of infant is missing */
  INFANT_AGE_MISSING = 'INFANT_AGE_MISSING',
  /** Date must be in the correct format */
  INVALID_DATE_FORMAT = 'INVALID_DATE_FORMAT',
  /** Total traveler count must be equal or lower than max */
  INVALID_TRAVELER_COUNT = 'INVALID_TRAVELER_COUNT',
  /** At least 1 traveler required in a booking */
  LESS_THAN_MINIMUM_ADULT = 'LESS_THAN_MINIMUM_ADULT',
  /** Location must not be blank */
  LOCATION_EMPTY = 'LOCATION_EMPTY',
  /** Origin and destination location must not be the same */
  LOCATION_SAME = 'LOCATION_SAME',
  /** Dates must be no more than 26 days apart */
  MAX_STAY_DURATION_ERROR = 'MAX_STAY_DURATION_ERROR',
  /** Origin and Destination city cannot be same */
  SAME_CITY = 'SAME_CITY',
  /** Special characters are not allowed */
  SPECIAL_CHARACTER_NOT_ALLOWED = 'SPECIAL_CHARACTER_NOT_ALLOWED',
  /** Enter at least 3 characters of the airport name */
  TOO_SHORT_AIRPORT_STRING = 'TOO_SHORT_AIRPORT_STRING',
  /** Number of infant in lap must be equal or lower than number of adults */
  UNATTENDED_INFANT_IN_LAP = 'UNATTENDED_INFANT_IN_LAP',
  /** There can't be more than 2 infants per traveler (age 12+) in a booking */
  UNATTENDED_INFANT_IN_SEAT = 'UNATTENDED_INFANT_IN_SEAT',
}

/** Represents a type content */
export enum FlightsSearchListingHeaderContentType {
  ONE_KEY = 'ONE_KEY',
}

/** Primary flights criteria part of the search wizard that have an impact on the first results set.It's different from the side filter part of the secondary search criteria that are filtering on top of it. The side filter should be using a server driven approach. */
export interface FlightsSearchPreferencesInput {
  /** Advanced filters like non-stop, refundable */
  advancedFilters?: InputMaybe<Array<FlightsAdvancedFilterType>>;
  airline?: InputMaybe<Scalars['String']>;
  cabinClass: FlightsCabinClass;
}

/** Represents the enum to handle different styles for the card */
export enum FlightsSeatCardStyles {
  /** Represents that the card should have border */
  BORDER = 'BORDER',
  /** Represents that the card should not have a border */
  WITHOUT_BORDER = 'WITHOUT_BORDER',
}

export enum FlightsSeatCellState {
  /** Represents the default theme for seat cell */
  DEFAULT = 'DEFAULT',
  /** Represents the theme for selected seat cell */
  HIGHLIGHTED = 'HIGHLIGHTED',
}

export enum FlightsSeatCellTheme {
  /** Represents the disabled theme for seat cell */
  DISABLED = 'DISABLED',
  /** Represents the highlighted theme for selected seat cell */
  HIGHLIGHTED = 'HIGHLIGHTED',
  /** Represents the theme for selected seat cell */
  SELECTED = 'SELECTED',
  /** Represents the standard theme for seat cell */
  STANDARD = 'STANDARD',
}

/** Primary flights criteria part of the search wizard that have an impact on the first results set.It's different from the side filter part of the secondary search criteria that are filtering on top of it. The side filter should be using a server driven approach. */
export interface FlightsSeatChoiceBasedFilterValueInput {
  displayToast?: InputMaybe<Scalars['Boolean']>;
  seatChoice: SeatChoiceType;
}

/** Error types which can occur during seat selection */
export enum FlightsSeatSelectionErrorType {
  /** Seat Selection Failed */
  SELECTION_FAILED = 'SELECTION_FAILED',
  /** Seat Selection Unavailable */
  SELECTION_UNAVAILABLE = 'SELECTION_UNAVAILABLE',
}

/** Represents the enum for handling whether new seats experience should be enabled or not */
export enum FlightsSeatsExperienceType {
  /** Represents frontend to show old seats experience */
  CURRENT_SEATS_EXPERIENCE = 'CURRENT_SEATS_EXPERIENCE',
  /** Represents frontend to show new seats experience */
  NEW_SEATS_EXPERIENCE = 'NEW_SEATS_EXPERIENCE',
  /** Represents frontend to show rich content experience */
  SEATS_RICH_CONTENT_EXPERIENCE = 'SEATS_RICH_CONTENT_EXPERIENCE',
}

/** Represents criteria for flights servicing confirmation page. */
export interface FlightsServicingConfirmationCriteriaInput {
  /** Represent the continuation identifier for spinner to deduce all journeys selected by the user. */
  journeyContinuationId?: InputMaybe<Scalars['String']>;
  /** Represents the identifier for the spinner to deduce which all credits have been selected by the user */
  originalBookingId: Scalars['String'];
  /** Represents the trip id */
  tripId?: InputMaybe<Scalars['String']>;
}

/** Represents criteria for flights servicing page. */
export interface FlightsServicingCriteriaInput {
  /** Encoded representation of ancillaries that was selected on FIS. */
  ancillaryId?: InputMaybe<Scalars['String']>;
  /** Represents the identifier to deduce change order flow */
  isResumeChange?: InputMaybe<Scalars['Boolean']>;
  /** Represent the continuation identifier for spinner to deduce all journeys selected by the user. */
  journeyContinuationId: Scalars['String'];
  /** Represents the identifier for the spinner to deduce which all credits have been selected by the user */
  originalBookingId?: InputMaybe<Scalars['String']>;
  /** Represents the trip id */
  tripId?: InputMaybe<Scalars['String']>;
  /** Represents upsell offer token of the selected flight */
  upsellOfferToken?: InputMaybe<Scalars['String']>;
}

/** Represents the min and max values associated with slider filters, like DepartureTime or ArrivalTime slider filter */
export interface FlightsSliderFilterValueInput {
  max: Scalars['Int'];
  min: Scalars['Int'];
}

/** Represents the combination of SortType and SortOrder ex. Price Increasing */
export interface FlightsSortOptionTypeInput {
  /** The array of all cross-sort parameters selected by the user */
  crossSortOptionList?: InputMaybe<Array<FlightsCrossSortOptionInput>>;
  crossSortOptionType?: InputMaybe<FlightsCrossSortOptionTypeInput>;
  sortOrder: FlightsSortOrder;
  sortType: FlightsSortType;
}

/** Enum which lists the sort orders */
export enum FlightsSortOrder {
  DECREASING = 'DECREASING',
  INCREASING = 'INCREASING',
}

/** Enum class which lists all the supported sorting criteria */
export enum FlightsSortType {
  ARRIVAL = 'ARRIVAL',
  BEST_BETS = 'BEST_BETS',
  BEST_SORT = 'BEST_SORT',
  CROSS_SORT = 'CROSS_SORT',
  DEPARTURE = 'DEPARTURE',
  DURATION = 'DURATION',
  NONSTOP = 'NONSTOP',
  PRICE = 'PRICE',
  RECOMMENDED = 'RECOMMENDED',
}

/** Represent the step label interface */
export enum FlightsStep {
  BAGS = 'BAGS',
  CHECKOUT = 'CHECKOUT',
  FLIGHT_DETAILS = 'FLIGHT_DETAILS',
  SEATS = 'SEATS',
}

/** Represents loading state of Price Summary for an offer */
export enum FlightsStepperErrorMessagesKey {
  PREFETCH_BAGS = 'PREFETCH_BAGS',
  PREFETCH_SEATS = 'PREFETCH_SEATS',
  SUPPLY_SIDE_BAGS = 'SUPPLY_SIDE_BAGS',
  SUPPLY_SIDE_SEATS = 'SUPPLY_SIDE_SEATS',
}

/** Represents the value associated with number of stops based filter */
export interface FlightsStopBasedFilterValueInput {
  stopInfo: FlightsStopInfoInput;
}

/** Enum class to represent the operation associated with num of stops */
export enum FlightsStopFilterOperation {
  EQUAL = 'EQUAL',
  GREATER_THAN_EQUAL = 'GREATER_THAN_EQUAL',
  LESS_THAN_EQUAL = 'LESS_THAN_EQUAL',
}

/** Represents the stop related info for each number of stops based filter value. Combination of the number of stops and an operation.Ex. 2+ would be represented by {2,MORE_THAN} , 2 by {2,EQUAL} and <2 by {2,LESS_THAN} */
export interface FlightsStopInfoInput {
  numberOfStops: Scalars['Int'];
  stopFilterOperation: FlightsStopFilterOperation;
}

/** Represents enums for selection state of the tab */
export enum FlightsTabSelectionState {
  CURRENT = 'CURRENT',
  SELECTED = 'SELECTED',
  UNSELECTED = 'UNSELECTED',
}

/** This represents a decorator that can be applied to a section */
export enum FlightsTextSectionDecorator {
  /** This represents a separator that renders after the text section */
  BOTTOMSEPARATOR = 'BOTTOMSEPARATOR',
  /** This represents a separator that renders above the text section */
  TOPSEPARATOR = 'TOPSEPARATOR',
}

/** Represents the value associated with any time based filter, like DepartureTime or ArrivalTime based filter */
export interface FlightsTimeBasedFilterValueInput {
  timeOfDay: FlightsTimeOfDay;
}

/** Enum representing the various time slots in a day  */
export enum FlightsTimeOfDay {
  AFTERNOON = 'AFTERNOON',
  EARLY_MORNING = 'EARLY_MORNING',
  EVENING = 'EVENING',
  MORNING = 'MORNING',
}

export enum FlightsTimePeriodOfDay {
  AFTERNOON = 'AFTERNOON',
  EARLY_MORNING = 'EARLY_MORNING',
  EVENING = 'EVENING',
  MORNING = 'MORNING',
}

/** class to represent a requested toast */
export interface FlightsToastContextInput {
  type?: InputMaybe<FlightsFilterType>;
}

/** Represents the value associated with travel and baggage filter */
export interface FlightsTravelAndBaggageBasedFilterValueInput {
  travelAndBaggageName: FilterTravelAndBaggageType;
}

/** Traveler details for flights search */
export interface FlightsTravelerDetailsInput {
  /** Age for each traveler */
  ages?: InputMaybe<Array<Scalars['Int']>>;
  /** Traveler count */
  count: Scalars['Int'];
  /** Traveler type */
  travelerType: FlightsTravelerType;
}

/** Represent all the possible traveler types */
export enum FlightsTravelerType {
  ADULT = 'ADULT',
  CHILD = 'CHILD',
  INFANT_IN_LAP = 'INFANT_IN_LAP',
  INFANT_IN_SEAT = 'INFANT_IN_SEAT',
}

/** Trip type chosen in flight search */
export enum FlightsTripType {
  MULTI_DESTINATION = 'MULTI_DESTINATION',
  ONE_WAY = 'ONE_WAY',
  ROUND_TRIP = 'ROUND_TRIP',
}

export enum FloatingButtonType {
  CENTER_FULL_WIDTH = 'CENTER_FULL_WIDTH',
  RIGHT_CIRCLE = 'RIGHT_CIRCLE',
}

export enum FlowEntrypointIdentifier {
  PROFILE = 'PROFILE',
  SETTINGS = 'SETTINGS',
}

export enum FollowUpActionLabels {
  ACCOUNT_INFO = 'ACCOUNT_INFO',
  AGENT_CONNECT_REQUEST = 'AGENT_CONNECT_REQUEST',
  CANCEL = 'CANCEL',
  CHANGE = 'CHANGE',
  CHANGE_TRAVELER_DETAILS = 'CHANGE_TRAVELER_DETAILS',
  RECONFIRMATION = 'RECONFIRMATION',
  REFUND_STATUS = 'REFUND_STATUS',
  SPEAK_TO_AGENT = 'SPEAK_TO_AGENT',
  TECHNICAL_ERROR = 'TECHNICAL_ERROR',
  UNKNOWN = 'UNKNOWN',
  VIEW_BOOKING = 'VIEW_BOOKING',
  VIRTUAL_AGENT = 'VIRTUAL_AGENT',
}

export enum FooterButtonType {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
  TERTIARY = 'TERTIARY',
}

export enum FooterSeparatorType {
  HORIZONTAL_RULE = 'HORIZONTAL_RULE',
}

export enum FormInput {
  AD_GROUP = 'AD_GROUP',
  CAMPAIGN = 'CAMPAIGN',
}

/** Trip type chosen in flight search */
export enum FreeCancellationApplicability {
  ALL_JOURNEYS = 'ALL_JOURNEYS',
  CURRENT_JOUNRNEY = 'CURRENT_JOUNRNEY',
  NOT_APPLICABLE = 'NOT_APPLICABLE',
}

export enum FunnelLocation {
  CHECKOUT = 'CHECKOUT',
  CHECKOUT_ERROR = 'CHECKOUT_ERROR',
  CONFIRMATION = 'CONFIRMATION',
  DETAILS = 'DETAILS',
  ENTRY = 'ENTRY',
  FEATURES = 'FEATURES',
  PAYMENT_ERROR = 'PAYMENT_ERROR',
  POST_BOOKING = 'POST_BOOKING',
  SEARCH_RESULTS = 'SEARCH_RESULTS',
  SYSTEM = 'SYSTEM',
  USER = 'USER',
}

/** Possible direction types for ground transfers */
export enum GeoType {
  AIRPORT = 'AIRPORT',
  DESTINATION = 'DESTINATION',
  PROPERTY = 'PROPERTY',
}

export interface GetCapBudgetForecastMetricsResponseInput {
  forecastedMetrics: BudgetInsightForecastedMetricsInput;
}

export interface GetReviewQuestionsRequestInput {
  campaignId?: InputMaybe<Scalars['String']>;
  htid?: InputMaybe<Scalars['String']>;
  itin?: InputMaybe<Scalars['String']>;
  orderId?: InputMaybe<Scalars['String']>;
  orderLineId?: InputMaybe<Scalars['String']>;
  reviewId?: InputMaybe<Scalars['String']>;
  tuid?: InputMaybe<Scalars['String']>;
}

export interface GetStoredPaymentInstrumentTokenConfigurationInput {
  clientDetails: ClientDetailsInput;
  paymentSessionId: Scalars['String'];
  storedPaymentInstrumentId: Scalars['String'];
}

export enum GetUAPCampaignIdErrorType {
  EMPTY_ADBOOK_ID = 'EMPTY_ADBOOK_ID',
  NOT_FOUND = 'NOT_FOUND',
  UNKNOWN = 'UNKNOWN',
}

export interface GiftCardRequestInput {
  sessionId: Scalars['String'];
}

/** Line of business that is querying the global navigation elements. */
export enum GlobalNavigationLineOfBusiness {
  ACTIVITY = 'ACTIVITY',
  CAR = 'CAR',
  CRUISE = 'CRUISE',
  FLIGHT = 'FLIGHT',
  HOTEL = 'HOTEL',
  PACKAGE = 'PACKAGE',
  UNKNOWN = 'UNKNOWN',
}

export interface GooglePayAssuranceDetailsInput {
  accountVerified?: InputMaybe<Scalars['Boolean']>;
  cardHolderAuthenticated?: InputMaybe<Scalars['Boolean']>;
}

export interface GooglePayAuthConfigurationInput {
  authChallengeResult?: InputMaybe<Scalars['String']>;
  encodedBrowserMetadata?: InputMaybe<Scalars['String']>;
  googlePayAssuranceDetails?: InputMaybe<GooglePayAssuranceDetailsInput>;
}

export interface GooglePayBillingDetailsInput {
  countryCode?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
}

export interface GooglePayPaymentDataInput {
  brandName?: InputMaybe<Scalars['String']>;
  instrumentDescription?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
}

/**
 * An object with simple key/value combination. This can be used to represent generic input where you do not know all the values that can be provided.
 *
 * It should be avoided in favor of a strict type with set fields, but can be useful in specific situations.
 */
export interface GraphQLPairInput {
  key: Scalars['String'];
  value: Scalars['String'];
}

/** Possible direction types for ground transfers */
export enum GroundTransfersDirection {
  FROM_AIRPORT = 'FROM_AIRPORT',
  ROUNDTRIP = 'ROUNDTRIP',
  TO_AIRPORT = 'TO_AIRPORT',
}

/** Provides the ground transfers criteria for each part of the journey. For instance, round-trip journey will comprise 2 parts, airport(origin) to hotel(destination) and hotel(origin) to airport(destination). */
export interface GroundTransfersJourneyCriteriaInput {
  dateTime: DateTimeInput;
  destination: GroundTransfersLocationInput;
  origin: GroundTransfersLocationInput;
}

/** Provides the ground transfers location information for destination, airport and hotel */
export interface GroundTransfersLocationInput {
  coordinates?: InputMaybe<CoordinatesInput>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  type: GeoType;
}

/** The ground transfers natural key that contains an offer token */
export interface GroundTransfersNaturalKeyInput {
  offerToken: Scalars['String'];
}

/** Represents the traveler details */
export interface GroundTransfersTravelerDetailsInput {
  count: Scalars['Int'];
  type: GroundTransfersTravelerDetailsType;
}

/** Possible traveler details types */
export enum GroundTransfersTravelerDetailsType {
  ADULT = 'ADULT',
  CHILD = 'CHILD',
  INFANT = 'INFANT',
}

export enum GuestImageScrimType {
  FADE_BOTTOM = 'FADE_BOTTOM',
  OVERLAY = 'OVERLAY',
}

/** Header section alignment of elements to either the start or end of the section container. */
export enum HeaderAlignment {
  END = 'END',
  START = 'START',
}

/** Determines the type of button to display.  Primary or tertiary. */
export enum HeaderButtonType {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
  TERTIARY = 'TERTIARY',
}

/** Used to position the header menu dropdown as well as icons in links and buttons.  Options are LEFT or RIGHT. */
export enum HeaderItemPosition {
  LEFT = 'LEFT',
  RIGHT = 'RIGHT',
}

/** Header layout. */
export enum HeaderLayout {
  DEFAULT = 'DEFAULT',
  MINIMAL = 'MINIMAL',
  SIMPLIFIED = 'SIMPLIFIED',
}

/** Used to pass certain marketing details to the header for google ad awareness */
export interface HeaderMarketingInput {
  googleClickIdentifier?: InputMaybe<Scalars['String']>;
  metaDistributionPartnersDetails?: InputMaybe<Scalars['String']>;
}

/** Inserts a separator in header menus. */
export enum HeaderSeparatorType {
  HORIZONTAL_RULE = 'HORIZONTAL_RULE',
}

/** Heading text size. Small or large. */
export enum HeaderTextSize {
  LARGE = 'LARGE',
  SMALL = 'SMALL',
}

/** Type of text.  Heading or subheading. */
export enum HeaderTextType {
  HEADING = 'HEADING',
  SUBHEADING = 'SUBHEADING',
}

/** Different viewport sizes to display the header. */
export enum HeaderViewSize {
  EXTRA_LARGE = 'EXTRA_LARGE',
  LARGE = 'LARGE',
  MEDIUM = 'MEDIUM',
  SMALL = 'SMALL',
}

/** Type of outline for Heart Icon */
export enum HeartOutlineType {
  NORMAL_OUTLINED = 'NORMAL_OUTLINED',
  RED_OUTLINED = 'RED_OUTLINED',
}

export enum HelpAndFeedbackHelpCenterOptionsType {
  OWNER = 'OWNER',
  PROPERTY_MANAGER = 'PROPERTY_MANAGER',
  TRAVELER = 'TRAVELER',
  TRUST_AND_SAFETY = 'TRUST_AND_SAFETY',
}

export enum HelpAndFeedbackOptionsType {
  BRAND_CALL = 'BRAND_CALL',
  CHAT_NOW = 'CHAT_NOW',
  CREDIT_CARD = 'CREDIT_CARD',
  RATE_OUR_APP = 'RATE_OUR_APP',
  SHARE_YOUR_FEEDBACK = 'SHARE_YOUR_FEEDBACK',
  VISIT_HELP_CENTER = 'VISIT_HELP_CENTER',
}

/** Browse request to get articles */
export interface HelpArticlesSearchRequestInput {
  /** Specify specific category from product to retrieve articles */
  category?: InputMaybe<Scalars['String']>;
  /** Specify article id to get article data */
  helpArticleId?: InputMaybe<Scalars['String']>;
  /** Specify search term to get articles suggestions */
  helpArticlesSearchTerm?: InputMaybe<Scalars['String']>;
  /** Specify specific product from homepage to retrieve articles */
  product?: InputMaybe<Scalars['String']>;
  /** Specify specific product id from homepage to retrieve articles */
  productId?: InputMaybe<Scalars['String']>;
}

export enum HelperConfigMap {
  And = 'And',
  CapitalizeFirst = 'CapitalizeFirst',
  DeviceTypeEvaluator = 'DeviceTypeEvaluator',
  Equals = 'Equals',
  EvaluateExperiment = 'EvaluateExperiment',
  EvaluateExperimentAndLog = 'EvaluateExperimentAndLog',
  ExperimentEvaluator = 'ExperimentEvaluator',
  FormatDoubleNumber = 'FormatDoubleNumber',
  FormatIntegerNumber = 'FormatIntegerNumber',
  GetSystemTimeInMs = 'GetSystemTimeInMs',
  GetUsableURN = 'GetUsableURN',
  Greater = 'Greater',
  GreaterAndEquals = 'GreaterAndEquals',
  HTTPLink = 'HTTPLink',
  ImpressionAnalyticsPayload = 'ImpressionAnalyticsPayload',
  IsNotNullOrEmpty = 'IsNotNullOrEmpty',
  IsQualifiedVrboProperty = 'IsQualifiedVrboProperty',
  Join = 'Join',
  Limit = 'Limit',
  Localize = 'Localize',
  Not = 'Not',
  Or = 'Or',
  Substring = 'Substring',
}

export enum HistoryType {
  ACTIVITY_DETAIL = 'ACTIVITY_DETAIL',
  ACTIVITY_SEARCH = 'ACTIVITY_SEARCH',
  CAR_DETAIL = 'CAR_DETAIL',
  CAR_SEARCH = 'CAR_SEARCH',
  CRUISE_SEARCH = 'CRUISE_SEARCH',
  FLIGHT_DETAIL = 'FLIGHT_DETAIL',
  FLIGHT_SEARCH = 'FLIGHT_SEARCH',
  PACKAGE_SEARCH = 'PACKAGE_SEARCH',
  PROPERTY_DETAIL = 'PROPERTY_DETAIL',
  PROPERTY_SEARCH = 'PROPERTY_SEARCH',
}

export interface HomeMojoContextInput {
  debugParameters?: InputMaybe<MojoDebugParametersInput>;
  pageName: Scalars['String'];
  placementId: Scalars['String'];
  protocolVersion?: InputMaybe<Scalars['String']>;
}

export interface HttpHeaderInput {
  name: Scalars['String'];
  values: Array<Scalars['String']>;
}

export enum HttpStatus {
  ACCEPTED = 'ACCEPTED',
  ALREADY_REPORTED = 'ALREADY_REPORTED',
  BAD_GATEWAY = 'BAD_GATEWAY',
  BAD_REQUEST = 'BAD_REQUEST',
  BANDWIDTH_LIMIT_EXCEEDED = 'BANDWIDTH_LIMIT_EXCEEDED',
  CHECKPOINT = 'CHECKPOINT',
  CONFLICT = 'CONFLICT',
  CONTINUE = 'CONTINUE',
  CREATED = 'CREATED',
  DESTINATION_LOCKED = 'DESTINATION_LOCKED',
  EXPECTATION_FAILED = 'EXPECTATION_FAILED',
  FAILED_DEPENDENCY = 'FAILED_DEPENDENCY',
  FORBIDDEN = 'FORBIDDEN',
  FOUND = 'FOUND',
  GATEWAY_TIMEOUT = 'GATEWAY_TIMEOUT',
  GONE = 'GONE',
  HTTP_VERSION_NOT_SUPPORTED = 'HTTP_VERSION_NOT_SUPPORTED',
  IM_USED = 'IM_USED',
  INSUFFICIENT_SPACE_ON_RESOURCE = 'INSUFFICIENT_SPACE_ON_RESOURCE',
  INSUFFICIENT_STORAGE = 'INSUFFICIENT_STORAGE',
  INTERNAL_SERVER_ERROR = 'INTERNAL_SERVER_ERROR',
  I_AM_A_TEAPOT = 'I_AM_A_TEAPOT',
  LENGTH_REQUIRED = 'LENGTH_REQUIRED',
  LOCKED = 'LOCKED',
  LOOP_DETECTED = 'LOOP_DETECTED',
  METHOD_FAILURE = 'METHOD_FAILURE',
  METHOD_NOT_ALLOWED = 'METHOD_NOT_ALLOWED',
  MOVED_PERMANENTLY = 'MOVED_PERMANENTLY',
  MOVED_TEMPORARILY = 'MOVED_TEMPORARILY',
  MULTIPLE_CHOICES = 'MULTIPLE_CHOICES',
  MULTI_STATUS = 'MULTI_STATUS',
  NETWORK_AUTHENTICATION_REQUIRED = 'NETWORK_AUTHENTICATION_REQUIRED',
  NON_AUTHORITATIVE_INFORMATION = 'NON_AUTHORITATIVE_INFORMATION',
  NOT_ACCEPTABLE = 'NOT_ACCEPTABLE',
  NOT_EXTENDED = 'NOT_EXTENDED',
  NOT_FOUND = 'NOT_FOUND',
  NOT_IMPLEMENTED = 'NOT_IMPLEMENTED',
  NOT_MODIFIED = 'NOT_MODIFIED',
  NO_CONTENT = 'NO_CONTENT',
  OK = 'OK',
  PARTIAL_CONTENT = 'PARTIAL_CONTENT',
  PAYLOAD_TOO_LARGE = 'PAYLOAD_TOO_LARGE',
  PAYMENT_REQUIRED = 'PAYMENT_REQUIRED',
  PERMANENT_REDIRECT = 'PERMANENT_REDIRECT',
  PRECONDITION_FAILED = 'PRECONDITION_FAILED',
  PRECONDITION_REQUIRED = 'PRECONDITION_REQUIRED',
  PROCESSING = 'PROCESSING',
  PROXY_AUTHENTICATION_REQUIRED = 'PROXY_AUTHENTICATION_REQUIRED',
  REQUESTED_RANGE_NOT_SATISFIABLE = 'REQUESTED_RANGE_NOT_SATISFIABLE',
  REQUEST_ENTITY_TOO_LARGE = 'REQUEST_ENTITY_TOO_LARGE',
  REQUEST_HEADER_FIELDS_TOO_LARGE = 'REQUEST_HEADER_FIELDS_TOO_LARGE',
  REQUEST_TIMEOUT = 'REQUEST_TIMEOUT',
  REQUEST_URI_TOO_LONG = 'REQUEST_URI_TOO_LONG',
  RESET_CONTENT = 'RESET_CONTENT',
  SEE_OTHER = 'SEE_OTHER',
  SERVICE_UNAVAILABLE = 'SERVICE_UNAVAILABLE',
  SWITCHING_PROTOCOLS = 'SWITCHING_PROTOCOLS',
  TEMPORARY_REDIRECT = 'TEMPORARY_REDIRECT',
  TOO_EARLY = 'TOO_EARLY',
  TOO_MANY_REQUESTS = 'TOO_MANY_REQUESTS',
  UNAUTHORIZED = 'UNAUTHORIZED',
  UNAVAILABLE_FOR_LEGAL_REASONS = 'UNAVAILABLE_FOR_LEGAL_REASONS',
  UNPROCESSABLE_ENTITY = 'UNPROCESSABLE_ENTITY',
  UNSUPPORTED_MEDIA_TYPE = 'UNSUPPORTED_MEDIA_TYPE',
  UPGRADE_REQUIRED = 'UPGRADE_REQUIRED',
  URI_TOO_LONG = 'URI_TOO_LONG',
  USE_PROXY = 'USE_PROXY',
  VARIANT_ALSO_NEGOTIATES = 'VARIANT_ALSO_NEGOTIATES',
}

export interface ISRequestPayloadInput {
  orderItemUuid?: InputMaybe<Scalars['String']>;
  previousIntent?: InputMaybe<FollowUpActionLabels>;
  previousSearchTerm?: InputMaybe<Scalars['String']>;
  searchTerm: Scalars['String'];
  servicePayload?: InputMaybe<Scalars['String']>;
  viewType: ISViewType;
}

export enum ISViewType {
  /** The view to display when the traveller confirms booking */
  BOOKING_CONFIRM = 'BOOKING_CONFIRM',
  /** The view to display when the traveller skips booking selection */
  BOOKING_SKIP = 'BOOKING_SKIP',
  /** Default view for search bar */
  DEFAULT = 'DEFAULT',
  /** The view that displays the search results */
  SEARCH = 'SEARCH',
}

/** supported sizes of icons */
export enum IconSize {
  EXTRA_SMALL = 'EXTRA_SMALL',
  LARGE = 'LARGE',
  MEDIUM = 'MEDIUM',
  /** @deprecated LARGE icon size changed from 48px to 32px. Use LARGE instead of MEDIUM_LARGE */
  MEDIUM_LARGE = 'MEDIUM_LARGE',
  SMALL = 'SMALL',
  XLARGE = 'XLARGE',
}

/** Supported themes of spotlights. See the prop definitions here: https://www.figma.com/file/Cq6XtgvVIEriWmWmVIMPzNOE/Icons?node-id=6402%3A115 */
export enum IconSpotLight {
  INFO = 'INFO',
  POSITIVE = 'POSITIVE',
  STANDARD = 'STANDARD',
  WARNING = 'WARNING',
}

/** Supported themes of icons. See the prop definitions here: http://uitk-react.tools.expedia.com/expedia/en_US/components/icons */
export enum IconTheme {
  default = 'default',
  emphasis = 'emphasis',
  inverse = 'inverse',
  negative = 'negative',
  positive = 'positive',
  secondary = 'secondary',
}

/** To define  type of status icon  */
export enum IconType {
  DONE = 'DONE',
  ERROR = 'ERROR',
}

/** Enum to specify the type for InputId */
export enum IdentifierType {
  ACTIVITY_ID = 'ACTIVITY_ID',
  /** @deprecated Use CHECKOUT_SESSION_ID instead */
  CART_ID = 'CART_ID',
  CAR_OFFER_TOKEN = 'CAR_OFFER_TOKEN',
  CHECKOUT_SESSION_ID = 'CHECKOUT_SESSION_ID',
  /** @deprecated This has been deprecated */
  ENTITY_ID = 'ENTITY_ID',
  LEGACY_ORDER_ID = 'LEGACY_ORDER_ID',
  /** @deprecated Use CHECKOUT_SESSION_ID instead */
  OFFER_ID = 'OFFER_ID',
  ORDER_ID = 'ORDER_ID',
  PROPERTY_ID = 'PROPERTY_ID',
  SAILING_TOKEN = 'SAILING_TOKEN',
}

export enum IdentityAccountCreationState {
  INVALID = 'INVALID',
  NOT_UPGRADED = 'NOT_UPGRADED',
  UPGRADED = 'UPGRADED',
}

export enum IdentityAccountCreationType {
  INVALID = 'INVALID',
  REGISTERED = 'REGISTERED',
  UNREGISTERED = 'UNREGISTERED',
}

export interface IdentityAccountTakeOverDeviceInput {
  payload: Scalars['String'];
  type: IdentityAccountTakeOverDeviceType;
}

export enum IdentityAccountTakeOverDeviceType {
  TRUST_WIDGET = 'TRUST_WIDGET',
}

/** EG Universal Login AccountTakeOver input from client */
export interface IdentityAccountTakeOverInput {
  inputs: Array<GraphQLPairInput>;
  type: Scalars['String'];
}

export interface IdentityAccountTakeOverShieldInput {
  accountTakeOverTokens?: InputMaybe<Array<IdentityAccountTakeOverTokenInput>>;
  crossSiteRequestForgeryData: IdentityCrossSiteRequestForgeryInput;
  devices?: InputMaybe<Array<IdentityAccountTakeOverDeviceInput>>;
  placement?: InputMaybe<Scalars['String']>;
}

export interface IdentityAccountTakeOverTokenInput {
  name: Scalars['String'];
  value: Scalars['String'];
}

export enum IdentityAccountTakeOverType {
  CAPTCHA_ARKOSE_MOBILE_APP = 'CAPTCHA_ARKOSE_MOBILE_APP',
  CAPTCHA_SAFETYNET_ANDROID = 'CAPTCHA_SAFETYNET_ANDROID',
  CAPTCHA_WEB = 'CAPTCHA_WEB',
  CSRF = 'CSRF',
  DEVICE_CHECK = 'DEVICE_CHECK',
  TRUST_WIDGET = 'TRUST_WIDGET',
}

export interface IdentityAddIdentifierByOTPFormRequestInput {
  /** Custom context to maintain the user state in experience api. This will be ciphered string which will be used to */
  verifyOTPFormContext?: InputMaybe<Scalars['String']>;
}

/** Represents the IdentityAddPhoneForm query request */
export interface IdentityAddPhoneFormRequestInput {
  flowType?: InputMaybe<IdentityFlowType>;
  loginType?: InputMaybe<IdentityLoginType>;
  optionalClientContext?: InputMaybe<Scalars['String']>;
  pageName?: InputMaybe<IdentityPageName>;
}

/** EG Universal Login Mutation Request for resend code operation when adding phone number */
export interface IdentityAddPhoneResendOTPSubmitRequestInput {
  atoInputs: Array<IdentityAccountTakeOverInput>;
  /** Custom context to maintain the user state in experience api. This will be ciphered string. */
  resendOTPContext?: InputMaybe<Scalars['String']>;
}

/** EG Universal Login Mutation Request for send code operation when adding phone number */
export interface IdentityAddPhoneSendOTPSubmitRequestInput {
  atoInputs: Array<IdentityAccountTakeOverInput>;
  phoneNumber: Scalars['String'];
  /** Custom context to maintain the user state in experience api. This will be ciphered string. */
  sendOTPContext?: InputMaybe<Scalars['String']>;
}

/** EG Universal Login Mutation Request for verify code operation when adding phone number */
export interface IdentityAddPhoneVerifyOTPSubmitRequestInput {
  atoInputs: Array<IdentityAccountTakeOverInput>;
  oneTimePasscode: Scalars['String'];
  /** Custom context to maintain the user state in experience api. This will be ciphered string. */
  verifyOTPContext?: InputMaybe<Scalars['String']>;
}

export enum IdentityAnalyticsPayloadType {
  EG_CLICK_STREAM = 'EG_CLICK_STREAM',
  UIS_PRIME = 'UIS_PRIME',
}

export interface IdentityAuthenticateByOTPFormRequestInput {
  authenticationFlowVariant?: InputMaybe<AuthenticationFlowVariant>;
  emailInput?: InputMaybe<Scalars['String']>;
  identitySocialType?: InputMaybe<IdentitySocialType>;
  loginReferenceId?: InputMaybe<Scalars['String']>;
  verifyOTPFormContext?: InputMaybe<Scalars['String']>;
}

export interface IdentityAuthenticateByPasswordFormRequestInput {
  authenticationFlowVariant?: InputMaybe<AuthenticationFlowVariant>;
  emailInput?: InputMaybe<Scalars['String']>;
  loadPasswordFormContext?: InputMaybe<Scalars['String']>;
}

export enum IdentityAuthenticationScenario {
  CHECKOUT_SIGNIN = 'CHECKOUT_SIGNIN',
  CHECKOUT_SIGNUP = 'CHECKOUT_SIGNUP',
  PROFILE = 'PROFILE',
  SIGNIN = 'SIGNIN',
  SIGNUP = 'SIGNUP',
}

export enum IdentityChannelType {
  ANDROID = 'ANDROID',
  DESKTOP = 'DESKTOP',
  IOS = 'IOS',
}

export interface IdentityClientContext {
  clientIdentifier?: InputMaybe<ClientIdentifier>;
  pageLocation?: InputMaybe<PageLocation>;
}

/** EG Universal Login input for IdentityClientContext query and mutation */
export interface IdentityClientContextInput {
  clientIdentifier?: InputMaybe<ClientIdentifier>;
  pageLocation?: InputMaybe<PageLocation>;
}

/** EG Universal Login input for IdentityClientInfo query and mutation */
export interface IdentityClientInfoInput {
  appName: Scalars['String'];
  appVersion: Scalars['String'];
  channelType: IdentityChannelType;
  deviceOS: Scalars['String'];
  deviceType: DeviceType;
  pageLocation?: InputMaybe<PageLocation>;
}

/** EG Identity Creation Account Request */
export interface IdentityCreateAccountRequestInput {
  accountTakeOverShield: IdentityAccountTakeOverShieldInput;
  channelType?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  password: Scalars['String'];
  phoneDetails?: InputMaybe<IdentityPhoneDetailsInput>;
  rememberMe?: InputMaybe<Scalars['Boolean']>;
}

export interface IdentityCrossSiteRequestForgeryInput {
  token: Scalars['String'];
}

export enum IdentityCustomValidationTheme {
  ERROR = 'ERROR',
  INFO = 'INFO',
  WARNING = 'WARNING',
}

export enum IdentityFlowType {
  ADD = 'ADD',
  RE_AUTHENTICATE = 'RE_AUTHENTICATE',
  UPDATE = 'UPDATE',
  VERIFY = 'VERIFY',
}

/** Identity information for a specific user or device */
export interface IdentityInput {
  /** The Expedia user authenticated state */
  authState?: InputMaybe<AuthenticationState>;
  /** The device ID (DUAID) */
  duaid: Scalars['UUID'];
  /** The Expedia User ID */
  expUserId?: InputMaybe<Scalars['String']>;
  /** The user TUID */
  tuid?: InputMaybe<Scalars['String']>;
}

export enum IdentityLayout {
  APP_ONBOARDING = 'APP_ONBOARDING',
  FORGOT_PASSWORD = 'FORGOT_PASSWORD',
  GET_RESENT_OTP_ATO = 'GET_RESENT_OTP_ATO',
  GET_SEND_OTP_ATO = 'GET_SEND_OTP_ATO',
  GET_SET_PASSWORD_ATO = 'GET_SET_PASSWORD_ATO',
  GET_SIGN_IN_ATO = 'GET_SIGN_IN_ATO',
  GET_SIGN_IN_VERIFY_OTP_ATO = 'GET_SIGN_IN_VERIFY_OTP_ATO',
  GET_SIGN_UP_VERIFY_OTP_ATO = 'GET_SIGN_UP_VERIFY_OTP_ATO',
  GET_SOCIAL_LOGIN_APPLE_ATO = 'GET_SOCIAL_LOGIN_APPLE_ATO',
  GET_SOCIAL_LOGIN_FACEBOOK_ATO = 'GET_SOCIAL_LOGIN_FACEBOOK_ATO',
  GET_SOCIAL_LOGIN_GOOGLE_ATO = 'GET_SOCIAL_LOGIN_GOOGLE_ATO',
  GET_USER_DETAILS_ATO = 'GET_USER_DETAILS_ATO',
  HYBRID_LOGIN = 'HYBRID_LOGIN',
  LAUNCH_ONE_IDENTITY = 'LAUNCH_ONE_IDENTITY',
  RESET_PASSWORD = 'RESET_PASSWORD',
  SIGNIN = 'SIGNIN',
  SIGNUP = 'SIGNUP',
}

export enum IdentityLoginScenario {
  SIGN_IN = 'SIGN_IN',
  SIGN_UP = 'SIGN_UP',
}

export enum IdentityLoginType {
  MANAGE = 'MANAGE',
  /** @deprecated Use Manage as LoginType and PageName+FlowType instead */
  PROFILE = 'PROFILE',
  /** @deprecated Use Manage as LoginType and PageName+FlowType instead */
  SETTINGS = 'SETTINGS',
  SIGN_IN = 'SIGN_IN',
  SIGN_UP = 'SIGN_UP',
  /** @deprecated Use Manage as LoginType and PageName+FlowType instead */
  UPDATE = 'UPDATE',
}

export enum IdentityPageName {
  PROFILE = 'PROFILE',
  SETTINGS = 'SETTINGS',
}

export interface IdentityPhoneDetailsInput {
  countryCode: Scalars['String'];
  locale: Scalars['String'];
  phoneNumber: Scalars['String'];
}

export interface IdentityRedirectionContextInput {
  cmsToken?: InputMaybe<Scalars['String']>;
  flowIdentifier?: InputMaybe<Scalars['String']>;
  flowScenario?: InputMaybe<Scenario>;
  flowVariant?: InputMaybe<Scalars['String']>;
  referrerURL?: InputMaybe<Scalars['String']>;
}

export interface IdentityResendOTPAuthenticationRequestInput {
  atoInputs: Array<IdentityAccountTakeOverInput>;
  emailInput?: InputMaybe<Scalars['String']>;
  identitySocialType?: InputMaybe<IdentitySocialType>;
  loginReferenceId?: InputMaybe<Scalars['String']>;
  resendOTPContext?: InputMaybe<Scalars['String']>;
}

export interface IdentitySendOTPAuthenticationRequestInput {
  atoInputs: Array<IdentityAccountTakeOverInput>;
  emailInput?: InputMaybe<Scalars['String']>;
  identitySocialType?: InputMaybe<IdentitySocialType>;
  loginReferenceId?: InputMaybe<Scalars['String']>;
  sendOTPContext?: InputMaybe<Scalars['String']>;
}

export enum IdentitySocialButtonType {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
}

export interface IdentitySocialInput {
  nonce: Scalars['String'];
  socialType: IdentitySocialType;
  token: Scalars['String'];
  tokenType: IdentitySocialTokenType;
}

export enum IdentitySocialTokenType {
  Access = 'Access',
  AuthCode = 'AuthCode',
  ID = 'ID',
}

export enum IdentitySocialType {
  APPLE = 'APPLE',
  FACEBOOK = 'FACEBOOK',
  GOOGLE = 'GOOGLE',
  NAVER = 'NAVER',
}

/** EG Universal Login spacing definition */
export enum IdentitySpaceSize {
  S0X = 'S0X',
  S0XH = 'S0XH',
  S1X = 'S1X',
  S2X = 'S2X',
  S3X = 'S3X',
  S4X = 'S4X',
  S5X = 'S5X',
  S6X = 'S6X',
  S8X = 'S8X',
  S10X = 'S10X',
  S11X = 'S11X',
  S12X = 'S12X',
  S14X = 'S14X',
  S15X = 'S15X',
  S16X = 'S16X',
  S18X = 'S18X',
  S150X = 'S150X',
}

/** EG Universal Login input for IdentityFormSubmit mutation */
export interface IdentitySubmitRequestInput {
  atoInputs: Array<IdentityAccountTakeOverInput>;
  context: Scalars['String'];
  input: Array<GraphQLPairInput>;
  migrationContextInput?: InputMaybe<Scalars['String']>;
  socialInput?: InputMaybe<IdentitySocialInput>;
}

export enum IdentitySuccessType {
  ONE_KEY_ONBOARDING = 'ONE_KEY_ONBOARDING',
  ORIGIN = 'ORIGIN',
}

export interface IdentityUserAuthenticatorsListRequestInput {
  emailAddress?: InputMaybe<Scalars['String']>;
  optionalClientContext?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
}

export interface IdentityUserDetailsFormRequestInput {
  authenticationMethod?: InputMaybe<Scalars['String']>;
  cmsToken?: InputMaybe<Scalars['String']>;
  flowVariant?: InputMaybe<Scalars['String']>;
  scenario?: InputMaybe<Scenario>;
}

export interface IdentityVerifyOTPAuthenticationRequestInput {
  atoInputs: Array<IdentityAccountTakeOverInput>;
  emailInput?: InputMaybe<Scalars['String']>;
  emailMarketingConsent?: InputMaybe<Scalars['Boolean']>;
  flowScenario?: InputMaybe<Scenario>;
  identitySocialType?: InputMaybe<IdentitySocialType>;
  loginReferenceId?: InputMaybe<Scalars['String']>;
  oneTimePasscode: Scalars['String'];
  referenceId?: InputMaybe<Scalars['String']>;
  referrerURL?: InputMaybe<Scalars['String']>;
  rememberMe?: InputMaybe<Scalars['Boolean']>;
  verifyOTPContext?: InputMaybe<Scalars['String']>;
}

export interface IdentityVerifyPasswordPAuthenticationRequestInput {
  atoInputs: Array<IdentityAccountTakeOverInput>;
  emailInput?: InputMaybe<Scalars['String']>;
  flowScenario?: InputMaybe<Scenario>;
  password: Scalars['String'];
  referrerURL?: InputMaybe<Scalars['String']>;
  rememberMe?: InputMaybe<Scalars['Boolean']>;
  verifyPasswordContext?: InputMaybe<Scalars['String']>;
}

export interface ImageDimensionsInput {
  height?: InputMaybe<Scalars['Int']>;
  width?: InputMaybe<Scalars['Int']>;
}

/** Represents supported areas to place an image within a card. TOP should be the default value */
export enum ImagePosition {
  LEFT = 'LEFT',
  TOP = 'TOP',
}

export enum ImmersiveViewNavigationType {
  SWIPE_HORIZONTAL = 'SWIPE_HORIZONTAL',
  SWIPE_VERTICAL = 'SWIPE_VERTICAL',
}

/** Optional information to get customer incentive */
export interface IncentiveContextInput {
  /** Represents the customer placement id */
  customerPlacementId: Scalars['String'];
  /** Represents the customer login scenario, either signin or signup */
  loginScenario?: InputMaybe<IdentityLoginScenario>;
}

export interface InitialAuthFormRequestInput {
  atoInputs?: InputMaybe<Array<IdentityAccountTakeOverInput>>;
  emailInput?: InputMaybe<Scalars['String']>;
  loginEntryPoint?: InputMaybe<LoginEntryPoint>;
  referrerURL?: InputMaybe<Scalars['String']>;
}

/** Represents where in to justify elements along the horizontal axis of a row. Terminology is the same as Flexbox - see https://developer.mozilla.org/en-US/docs/Web/CSS/justify-content */
export enum InlineJustify {
  END = 'END',
  SPACE = 'SPACE',
  START = 'START',
}

/** Input type for fetching the Inquiry form. */
export interface InquiryFormInput {
  petsIncluded?: InputMaybe<Scalars['Boolean']>;
  primaryPropertyCriteriaInput?: InputMaybe<PrimaryPropertyCriteriaInput>;
}

export enum InquiryProminence {
  HIGH = 'HIGH',
  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
}

/** Input type for submitting a new Inquiry request. */
export interface InquiryRequestInput {
  inquirerPhoneCountryCode?: InputMaybe<Scalars['String']>;
  inquirerPhoneNumber?: InputMaybe<Scalars['String']>;
  message: Scalars['String'];
  optInForMarketing?: InputMaybe<Scalars['Boolean']>;
  petsIncluded?: InputMaybe<Scalars['Boolean']>;
  primaryPropertyCriteriaInput: PrimaryPropertyCriteriaInput;
}

/** A location can be represented by a region id or an airport code. */
export interface InsightsLocationInput {
  /** Three letter IATA code associated with am airport near the location */
  airportCode?: InputMaybe<Scalars['String']>;
  /** Gaia region id of the location */
  regionId?: InputMaybe<Scalars['String']>;
}

/** Represent the type of tracking cards */
export enum InsightsTrackingCardType {
  DEALS_TRACKING = 'DEALS_TRACKING',
  PRICE_TRACKING = 'PRICE_TRACKING',
}

/** Placement context data fields that helps render the insurtech component correctly */
export interface InsurTechComponentPlacementContextInput {
  /** client page name eg. CHECKOUT, CONFIRMATION, ..etc */
  clientPageName?: InputMaybe<InsurTechPageLocation>;
  /** LOB eg. flights, cars, ..etc */
  lob: LineOfBusinessDomain;
  /** package type in case lob is packages */
  packageType?: InputMaybe<PackageType>;
  /** DEPRECATED: Use InsurTechPageLocation instead */
  path: PageLocation;
  /** placement inside the path eg. fare_card, listing, .. etc */
  placement?: InputMaybe<InsurTechPagePlacementType>;
}

/** Used to indicate the insurtech component placement */
export interface InsurTechComponentPlacementInput {
  placementContext: InsurTechComponentPlacementContextInput;
  /** custom position for the card, like raw specific number. */
  position?: InputMaybe<Scalars['Int']>;
  /** Insurance product type */
  productType?: InputMaybe<Scalars['String']>;
}

/** Represents insurance dialog action types */
export enum InsurTechDialogActionType {
  CLOSE = 'CLOSE',
  OPEN = 'OPEN',
  OPEN_QUERY = 'OPEN_QUERY',
}

/** Represents insurance dialog trigger types link or button */
export enum InsurTechExperienceDialogTriggerType {
  BUTTON = 'BUTTON',
  LINK = 'LINK',
}

/** Indicates the path in user journey where insurance/assurance products are offered */
export enum InsurTechPageLocation {
  /** Cancel For Any Reason assurance details page that comes after LOB details pages */
  CFAR_DETAILS = 'CFAR_DETAILS',
  /** All checkout related pages */
  CHECKOUT = 'CHECKOUT',
  /** Order confirmation pages for all LOBs */
  CONFIRMATION = 'CONFIRMATION',
  /** All product detail pages are identified as DETAILS */
  DETAILS = 'DETAILS',
  /** Insurance details page that comes after LOB details pages */
  INSURANCE_DETAILS = 'INSURANCE_DETAILS',
  /** Post booking pages including itin, trip summary, trip details, customer service etc */
  POST_BOOKING = 'POST_BOOKING',
  /** Vrbo post booking pages including confirmation, trip care and confirmation email */
  VAS_CART = 'VAS_CART',
  /** Interstitial page shown immediately after property booking on Vrbo */
  VAS_INTERSTITIAL = 'VAS_INTERSTITIAL',
}

/** Placement of the component inside the page */
export enum InsurTechPagePlacementType {
  LISTING = 'LISTING',
  LISTING_ONE_WAY = 'LISTING_ONE_WAY',
}

/** GraphQL request for benefit details */
export interface InsuranceBenefitDetailsQueryRequestInput {
  /** Benefit Id for which the details are requested */
  benefitId: Scalars['String'];
  /** email src to collect analytics when it's true  */
  isEmailSrc?: InputMaybe<Scalars['Boolean']>;
  /** LOB of the booking */
  lob?: InputMaybe<Scalars['String']>;
  /** Order Id of the booking */
  orderNumber?: InputMaybe<Scalars['String']>;
  /** Trip Id of the booking */
  tripId?: InputMaybe<Scalars['String']>;
}

export interface InsuranceBookingCancellationRequestInput {
  orderId: Scalars['String'];
  orderLineId: Scalars['String'];
}

export interface InsuranceBookingOverviewRequestInput {
  /** LOB of the booking */
  lob?: InputMaybe<Scalars['String']>;
  /** Order Id of the booking */
  orderNumber?: InputMaybe<Scalars['String']>;
  /** Trip Id of the booking */
  tripId?: InputMaybe<Scalars['String']>;
}

/** GraphQL request for Insurance Claim Details */
export interface InsuranceClaimDetailsRequestInput {
  /** Order Id of the booking */
  orderNumber?: InputMaybe<Scalars['String']>;
}

/** Numbers that also need to be formatted */
export interface InsuranceCriteriaInput {
  /** Represents free price match promise marketing placement */
  freePmpCustomerPlacement?: InputMaybe<Scalars['String']>;
  /** Insurance continuation token that represents insurance offer and its related data */
  insuranceContinuationToken?: InputMaybe<Scalars['String']>;
  /** offer token for insurance product */
  insuranceOfferToken?: InputMaybe<Scalars['String']>;
  /** Represents PMP up-funnel selection */
  selectedProductId?: InputMaybe<Scalars['String']>;
}

export interface InsuranceDetailPrimingForCarInput {
  /** Identifier token for car inventory */
  carOfferToken: Scalars['String'];
  /** Encoded string having certain offer information shown on search page. Eg. priceShown, avg category price */
  continuationContextualId?: InputMaybe<Scalars['String']>;
  /** Drop-off location for car */
  dropOffLocation?: InputMaybe<InsuranceLocationInput>;
  /** Pick-up location for car */
  pickUpLocation: InsuranceLocationInput;
  /** Reward point selection on  Car offer */
  rewardPointsSelection?: InputMaybe<InsuranceRewardsPointSelectionEnum>;
  /** List of accessories added with Car */
  selectedAccessories?: InputMaybe<Array<Scalars['String']>>;
}

export interface InsuranceDetailPrimingRequestInput {
  /** Car request for insurance priming */
  carRequest: InsuranceDetailPrimingForCarInput;
}

export interface InsuranceFileAClaimRequestInput {
  benefitId: Scalars['String'];
  /** email src to collect analytics when it's true  */
  isEmailSrc?: InputMaybe<Scalars['Boolean']>;
  /** LOB of the booking */
  lob?: InputMaybe<Scalars['String']>;
  orderNumber?: InputMaybe<Scalars['String']>;
  tripId?: InputMaybe<Scalars['String']>;
}

export interface InsuranceLocationInput {
  /** Region id */
  regionId: Scalars['String'];
  /** Search term */
  searchTerm: Scalars['String'];
}

export enum InsuranceMessageType {
  ERROR = 'ERROR',
  INFO = 'INFO',
  WARNING = 'WARNING',
}

export enum InsuranceRewardsPointSelectionEnum {
  APPLY_REWARD_POINTS = 'APPLY_REWARD_POINTS',
  DO_NOT_APPLY_REWARD_POINTS = 'DO_NOT_APPLY_REWARD_POINTS',
}

/** Add insurtech offer to trip mutation request */
export interface InsurtechAddTripRequestInput {
  /** Offer token to be added */
  offerId: Scalars['String'];
  /** Price information */
  price: Scalars['String'];
  /** Response Identifier */
  responseId: Scalars['String'];
  tripId: Scalars['String'];
}

export enum InsurtechAlertTheme {
  INFO = 'INFO',
  SUCCESS = 'SUCCESS',
  WARNING = 'WARNING',
}

/** Insurance Booking Request */
export interface InsurtechBookingRequestInput {
  /** Edge token */
  edgeToken?: InputMaybe<Scalars['String']>;
  /** Insurance Record ID */
  insuranceRecordId?: InputMaybe<Scalars['String']>;
  /** Unique identifier for the insurance product */
  productId?: InputMaybe<Scalars['String']>;
}

/** Client Id Possibilities */
export enum InsurtechClientId {
  CAR_INFO_SITE = 'CAR_INFO_SITE',
  EG_CHECKOUT = 'EG_CHECKOUT',
  FCR_CHECKOUT = 'FCR_CHECKOUT',
}

/** extra client meta data */
export interface InsurtechClientMetaDataInput {
  /** time zone of the client */
  timeZone?: InputMaybe<Scalars['String']>;
}

/** Insurtech Page Level Error Type */
export enum InsurtechCommonErrorType {
  ABACUS_DISABLED_FOR_USER = 'ABACUS_DISABLED_FOR_USER',
  ANONYMOUS_TRIP_USER = 'ANONYMOUS_TRIP_USER',
  BOOKING_CANCELLED = 'BOOKING_CANCELLED',
  CHANGE_RESIDENCY_FAILURE = 'CHANGE_RESIDENCY_FAILURE',
  ERROR_CARD_LIMIT = 'ERROR_CARD_LIMIT',
  ERROR_MAPPING_PAYMENT_INSTRUMENT_DETAILS = 'ERROR_MAPPING_PAYMENT_INSTRUMENT_DETAILS',
  ERROR_OMS_RECOVERABLE = 'ERROR_OMS_RECOVERABLE',
  FAILURE_SELECT_INSURANCE_PRODUCT = 'FAILURE_SELECT_INSURANCE_PRODUCT',
  INSURANCE_ADD_FAILURE = 'INSURANCE_ADD_FAILURE',
  INSURANCE_ALREADY_PURCHASED = 'INSURANCE_ALREADY_PURCHASED',
  INSURANCE_OFFER_EXPIRED = 'INSURANCE_OFFER_EXPIRED',
  INVALID_ACCOUNT_NUMBER = 'INVALID_ACCOUNT_NUMBER',
  INVALID_EDGE_TOKEN = 'INVALID_EDGE_TOKEN',
  INVALID_EXPIRATION_DATE = 'INVALID_EXPIRATION_DATE',
  INVALID_FORM = 'INVALID_FORM',
  NO_PRODUCT_FOUND = 'NO_PRODUCT_FOUND',
  PAYMENT_CARD_ISSUE = 'PAYMENT_CARD_ISSUE',
  PAYMENT_SESSION_SERVICE_ERROR = 'PAYMENT_SESSION_SERVICE_ERROR',
  RESPONSE_ID_NOT_FOUND_IN_RECORD = 'RESPONSE_ID_NOT_FOUND_IN_RECORD',
  TEMPLATE_RESOLVER_ERROR = 'TEMPLATE_RESOLVER_ERROR',
  UNKNOWN_ERROR = 'UNKNOWN_ERROR',
  USER_ACCOUNT_MISMATCH = 'USER_ACCOUNT_MISMATCH',
  USER_BUCKETED_FOR_LEGACY_PAGE = 'USER_BUCKETED_FOR_LEGACY_PAGE',
}

/** Position context data fields that helps render the insurtech component correctly */
export interface InsurtechComponentPositionContextInput {
  /** LOB eg. flights, cars, ..etc */
  lob?: InputMaybe<LineOfBusinessDomain>;
  /** package type in case lob is in a package */
  packageType?: InputMaybe<PackageType>;
  /** path will display the card in eg. search_results, details, ..etc */
  path?: InputMaybe<PageLocation>;
  /** placement inside the path eg. fare_card, listing, .. etc */
  placement?: InputMaybe<InsurTechPagePlacementType>;
}

/** Used to indicate the insurtech component position */
export interface InsurtechComponentPositionInput {
  positionContext?: InputMaybe<InsurtechComponentPositionContextInput>;
}

export enum InsurtechCustomErrorType {
  CACHED_PRODUCT_UNAVAILABLE = 'CACHED_PRODUCT_UNAVAILABLE',
  GENERIC_ERROR = 'GENERIC_ERROR',
  INVALID_USER = 'INVALID_USER',
  USER_BUCKETED_FOR_LEGACY_PAGE = 'USER_BUCKETED_FOR_LEGACY_PAGE',
}

/** Insurtech Fallback Type */
export enum InsurtechFallbackOperationType {
  LEGACY = 'LEGACY',
}

/** Enum having action type details available to execute */
export enum InsurtechGenericActionType {
  REDIRECT_CHECKOUT_URL = 'REDIRECT_CHECKOUT_URL',
  RELOAD_PAGE = 'RELOAD_PAGE',
}

/** Insurtech Link Type */
export enum InsurtechLinkType {
  EXTERNAL_LINK = 'EXTERNAL_LINK',
  MORE_INFO = 'MORE_INFO',
  STANDARD_LINK = 'STANDARD_LINK',
}

/** Themes for insurtech list items */
export enum InsurtechListItemTheme {
  HEADED_LIST_ITEM = 'HEADED_LIST_ITEM',
  LIST_ITEM = 'LIST_ITEM',
}

/** It is expandable to NUMBER_LIST based on other templates. */
export enum InsurtechListType {
  BULLET_LIST = 'BULLET_LIST',
  GRAPHIC_LIST = 'GRAPHIC_LIST',
}

/** Represents Generic Meta data */
export interface InsurtechMetadataInput {
  /** field to hold product details */
  insurtechProductMetadata?: InputMaybe<Array<InsurtechProductMetadataInput>>;
  /** field required to hold parent line of business */
  lineOfBusiness?: InputMaybe<LineOfBusinessDomain>;
  /** field to determine the page location eg. CONFIRMATION, POST_BOOKING, ..etc */
  path?: InputMaybe<PageLocation>;
  /** field required to hold source of the referred user */
  referredSource?: InputMaybe<Scalars['String']>;
  /** field required to hold user details */
  userDetails?: InputMaybe<InsurtechUserDetailsInput>;
}

export enum InsurtechModuleHeadingViewType {
  /** Theme indicating heading and badge inlined */
  INLINE_BADGE = 'INLINE_BADGE',
  /** Theme indicating badge followed by heading and graphic inlined in a new line */
  PRIMARY = 'PRIMARY',
}

/** Status Possibilities */
export enum InsurtechMutationStatus {
  FAILED = 'FAILED',
  SUCCESS = 'SUCCESS',
}

/** Insurtech Nudge Theme */
export enum InsurtechNudgeTheme {
  ACCEPTANCE_LEGACY_THEME = 'ACCEPTANCE_LEGACY_THEME',
  REJECTION_LEGACY_THEME = 'REJECTION_LEGACY_THEME',
}

/** Insurtech search details inputs that will be using for contextual search */
export interface InsurtechOfferSearchCriteriaInput {
  checkInDate: Scalars['String'];
  checkOutDate: Scalars['String'];
  travellers?: InputMaybe<Array<TravelerDetailsInput>>;
}

/** State represents teh status whether offer is already added, not added or some different offer is added */
export enum InsurtechOfferState {
  CHANGED_OFFER = 'CHANGED_OFFER',
  NOT_SELECTED = 'NOT_SELECTED',
  UNCHANGED_OFFER = 'UNCHANGED_OFFER',
}

/** Insurtech Shopping Criteria */
export interface InsurtechPostBookCriteriaInput {
  /** Identifier required for the trip */
  identifier: InsurtechPostBookIdentifierInput;
  /** Residency Details for the Insurance Module */
  residencyDetails?: InputMaybe<ResidencyDetailsInput>;
}

/** Insurance Module Shopping Identifier */
export interface InsurtechPostBookIdentifierInput {
  /** Identifier type required for the trip */
  type: InsurtechPostBookIdentifierType;
  /** Value corresponding to identifier type required for the trip */
  value: Scalars['String'];
}

/** Enum having criteria type details available for trip */
export enum InsurtechPostBookIdentifierType {
  TRIP_ID = 'TRIP_ID',
}

export interface InsurtechPrimingCardRequestInput {
  /** Identifier offer for car inventory */
  offer: OfferIdentityInput;
}

export enum InsurtechPrimingCardViewType {
  BASIC_PRIMING_CARD = 'BASIC_PRIMING_CARD',
}

/** Insurtech property details cancellation policy inputs will be using for legacy shopping */
export interface InsurtechProductCancellationPolicyPeriodInput {
  date: Scalars['String'];
  refundPercent: Scalars['Int'];
}

/** Represents Product Meta data */
export interface InsurtechProductMetadataInput {
  /** field to hold Id of the product */
  productId?: InputMaybe<Scalars['Int']>;
}

/** Enum having Insurtech product types */
export enum InsurtechProductTypeInput {
  /** Trip assurance Cancel For Any Reason product type */
  CANCEL_FOR_ANY_REASON = 'CANCEL_FOR_ANY_REASON',
  /** Trip insurance product type */
  INSURANCE = 'INSURANCE',
  /** Trip assurance Price Drop Protection product type */
  PRICE_DROP_PROTECTION = 'PRICE_DROP_PROTECTION',
}

/** Insurtech property details inputs will be using for legacy shopping */
export interface InsurtechPropertyDetailsInput {
  cancellationPolicy?: InputMaybe<Array<InsurtechProductCancellationPolicyPeriodInput>>;
  checkInTime: Scalars['String'];
  checkOutTime: Scalars['String'];
  city?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  currencyCode: Scalars['String'];
  geoLocation?: InputMaybe<CoordinatesInput>;
  isInstantBooking?: InputMaybe<Scalars['Boolean']>;
  isRefundable?: InputMaybe<Scalars['Boolean']>;
  numberOfRooms?: InputMaybe<Scalars['Int']>;
  price: Scalars['String'];
  propertyId: Scalars['String'];
  propertyManagementType?: InputMaybe<Scalars['String']>;
  propertyName: Scalars['String'];
  timeZone?: InputMaybe<Scalars['String']>;
}

/** Status Possibilities */
export enum InsurtechQueryStatus {
  FAILED = 'FAILED',
  SUCCESS = 'SUCCESS',
}

/** Alignment for radio icon */
export enum InsurtechRadioIconAlignment {
  LEFT = 'LEFT',
  RIGHT = 'RIGHT',
}

/** Remove insurtech offer from trip mutation request */
export interface InsurtechRemoveTripRequestInput {
  /** Offer token to be removed */
  offerId: Scalars['String'];
  /** Price information */
  price: Scalars['String'];
  /** Response Identifier */
  responseId?: InputMaybe<Scalars['String']>;
  tripId: Scalars['String'];
}

/** Search criteria for Insurtech priming, including lob specific details. */
export interface InsurtechSearchCriteriaInput {
  /** Flight search criteria input. */
  flightSearchCriteria?: InputMaybe<FlightSearchCriteriaInput>;
}

export enum InsurtechSectionViewType {
  HORIZONTAL = 'HORIZONTAL',
  VERTICAL = 'VERTICAL',
}

/** Insurtech Shopping Criteria */
export interface InsurtechShoppingCriteriaInput {
  /** Identifier required for the trip */
  identifier: InsurtechShoppingIdentifierInput;
  /** Insurance Continuation Token */
  insuranceContinuationToken?: InputMaybe<Scalars['String']>;
  /** Requested product type for the Insurance Module, should not be null */
  productType?: InputMaybe<InsurtechProductTypeInput>;
  /** Residency Details for the Insurance Module */
  residencyDetails?: InputMaybe<ResidencyDetailsInput>;
}

/** Insurance Module Shopping Identifier */
export interface InsurtechShoppingIdentifierInput {
  /** Identifier type required for the trip */
  type: InsurtechShoppingIdentifierType;
  /** Value corresponding to identifier type required for the trip */
  value: Scalars['String'];
}

/** Enum having criteria type details available for trip */
export enum InsurtechShoppingIdentifierType {
  CHECKOUT_SESSION_ID = 'CHECKOUT_SESSION_ID',
  JCID = 'JCID',
  OFFER_TOKEN = 'OFFER_TOKEN',
  RESERVATION_ID = 'RESERVATION_ID',
  RESPONSE_ID = 'RESPONSE_ID',
  TRIP_ID = 'TRIP_ID',
}

/** Enum having shopping view type details */
export enum InsurtechShoppingViewType {
  CHECKOUT_SHOPPING = 'CHECKOUT_SHOPPING',
  DETAILS_SHOPPING = 'DETAILS_SHOPPING',
  EXPWEB_CHECKOUT_SHOPPING = 'EXPWEB_CHECKOUT_SHOPPING',
  POST_PURCHASE = 'POST_PURCHASE',
  SUMMARY = 'SUMMARY',
  VAS_CART = 'VAS_CART',
  VAS_INTERSTITIAL = 'VAS_INTERSTITIAL',
}

/** Insurtech Testimonial Type */
export enum InsurtechTestimonialType {
  MOTIVATOR = 'MOTIVATOR',
  TESTIMONIAL = 'TESTIMONIAL',
  TESTIMONIAL_WITH_SOCIAL_PROOF = 'TESTIMONIAL_WITH_SOCIAL_PROOF',
}

/** Insurtech Shopping Criteria */
export interface InsurtechTransactionCriteriaInput {
  /** Identifier required for the trip */
  identifier?: InputMaybe<InsurtechTransactionIdentifierInput>;
  /** Residency Details for the Insurance Module */
  residencyDetails?: InputMaybe<ResidencyDetailsInput>;
}

/** Insurance Module Transaction Identifier */
export interface InsurtechTransactionIdentifierInput {
  /** Identifier type required for the trip */
  type?: InputMaybe<InsurtechTransactionIdentifierType>;
  /** Value corresponding to identifier type required for the trip */
  value?: InputMaybe<Scalars['String']>;
}

/** Enum having criteria type details available for trip */
export enum InsurtechTransactionIdentifierType {
  RESPONSE_ID = 'RESPONSE_ID',
  TRIP_ID = 'TRIP_ID',
}

/** Enum having operation type details */
export enum InsurtechUpdateOperationType {
  ADD = 'ADD',
  MODAL = 'MODAL',
  REMOVE = 'REMOVE',
}

/** Update insurtech product */
export interface InsurtechUpdateProductSelectionRequestInput {
  /** Operation type, either add or remove */
  operationType: InsurtechUpdateOperationType;
  /** Product Identifier */
  productId: Scalars['String'];
  /** Product type, should match with the product type in the response, should not be null */
  productType?: InputMaybe<InsurtechProductTypeInput>;
  /** Response Identifier */
  responseId: Scalars['String'];
}

/** User Details */
export interface InsurtechUserDetailsInput {
  /** first name of the user */
  firstName?: InputMaybe<Scalars['String']>;
  /** last name of the user */
  lastName?: InputMaybe<Scalars['String']>;
  /** middle name of the user */
  middleName?: InputMaybe<Scalars['String']>;
}

/** view Id Possibilities */
export enum InsurtechView {
  COMPACT_ACCEPTANCE_VIEW = 'COMPACT_ACCEPTANCE_VIEW',
  COMPACT_REJECTED_COLLAPSED_VIEW = 'COMPACT_REJECTED_COLLAPSED_VIEW',
  COMPACT_REJECTED_VIEW = 'COMPACT_REJECTED_VIEW',
  DEFAULT_VIEW = 'DEFAULT_VIEW',
  HYBRID_INTERACTION_PARITY_VIEW = 'HYBRID_INTERACTION_PARITY_VIEW',
  HYBRID_INTERACTION_VIEW = 'HYBRID_INTERACTION_VIEW',
  NUDGE_ACCEPTANCE_VIEW = 'NUDGE_ACCEPTANCE_VIEW',
  NUDGE_REJECTED_VIEW = 'NUDGE_REJECTED_VIEW',
  TEMPLATIZED_DEFAULT_VIEW = 'TEMPLATIZED_DEFAULT_VIEW',
  VRBO_PDP_ACCEPTANCE_VIEW = 'VRBO_PDP_ACCEPTANCE_VIEW',
  VRBO_RDD_ACCEPTANCE_VIEW = 'VRBO_RDD_ACCEPTANCE_VIEW',
}

/** Interaction to publish an event for */
export enum InteractionEventName {
  BOOK = 'BOOK',
  CHECKOUT_CLIENT_SIDE_LOAD_ATTEMPT = 'CHECKOUT_CLIENT_SIDE_LOAD_ATTEMPT',
  CHECKOUT_CLIENT_SIDE_LOAD_OUTCOME = 'CHECKOUT_CLIENT_SIDE_LOAD_OUTCOME',
  CHECKOUT_PAGE_LOAD = 'CHECKOUT_PAGE_LOAD',
  CONFIRMATION_PAGE_LOAD = 'CONFIRMATION_PAGE_LOAD',
}

/** InteractionMode will hold status of input for the session  */
export enum InteractionMode {
  FREE = 'FREE',
  RESTRICTED = 'RESTRICTED',
}

export enum InteractionTemplateSubmitAction {
  CREATE = 'CREATE',
  UPDATE = 'UPDATE',
}

export enum InteractionTemplateType {
  CUSTOM = 'CUSTOM',
  PRESET = 'PRESET',
}

export enum InteractionTemplatesFilters {
  ALL = 'ALL',
  NOT_SCHEDULED = 'NOT_SCHEDULED',
  SCHEDULED = 'SCHEDULED',
}

/** Represents the type of action that can be performed on a banner */
export enum InteractionType {
  CLICK = 'CLICK',
  DISMISS = 'DISMISS',
  VIEW = 'VIEW',
}

/** Provides the interest of a Customer for a particular search */
export interface InterestInput {
  /** SEM id of interest */
  desmetId?: InputMaybe<Scalars['String']>;
  /** Name of interest */
  name?: InputMaybe<Scalars['String']>;
}

/** Indicate the inventory type of a given offer */
export enum InventoryType {
  AICTRAVELGROUP = 'AICTRAVELGROUP',
  AMOMA = 'AMOMA',
  ANA = 'ANA',
  BESTBUYHOTEL = 'BESTBUYHOTEL',
  BONOTEL = 'BONOTEL',
  CNTRAVEL = 'CNTRAVEL',
  /** @deprecated Replaced by TRIPCOM */
  CTRIP = 'CTRIP',
  DESPEGAR = 'DESPEGAR',
  DIDATRAVEL = 'DIDATRAVEL',
  DIRECT_AGENCY = 'DIRECT_AGENCY',
  EUROPLAYAS = 'EUROPLAYAS',
  EXCITEHOLIDAYS = 'EXCITEHOLIDAYS',
  EZZEGO_1 = 'EZZEGO_1',
  GETAROOM = 'GETAROOM',
  HOME_AWAY = 'HOME_AWAY',
  HOTELDOBESTDAYTRAVEL = 'HOTELDOBESTDAYTRAVEL',
  HOTEL_BEDS = 'HOTEL_BEDS',
  /** @deprecated Replaced by THOMASCOOK_EUR */
  HRS = 'HRS',
  JAC_TRAVEL = 'JAC_TRAVEL',
  JAL = 'JAL',
  JALAN = 'JALAN',
  JTB = 'JTB',
  JUMBOTOURS = 'JUMBOTOURS',
  MAGICROOMS = 'MAGICROOMS',
  MERCHANT = 'MERCHANT',
  MGBEDBANK = 'MGBEDBANK',
  MIKI = 'MIKI',
  MTS = 'MTS',
  NTA = 'NTA',
  NUITEE = 'NUITEE',
  OPAQUE = 'OPAQUE',
  OSTROVOK = 'OSTROVOK',
  PEGASUS = 'PEGASUS',
  RAKUTEN = 'RAKUTEN',
  RESTEL = 'RESTEL',
  ROOMER = 'ROOMER',
  SMYROOMS = 'SMYROOMS',
  SUNHOTELS = 'SUNHOTELS',
  THOMASCOOK_EUR = 'THOMASCOOK_EUR',
  THOMASCOOK_UK = 'THOMASCOOK_UK',
  TOURICO = 'TOURICO',
  TRAVELLANDA = 'TRAVELLANDA',
  TRAVELREPUBLIC = 'TRAVELREPUBLIC',
  TRIPCOM = 'TRIPCOM',
  VENERE = 'VENERE',
  VRBO = 'VRBO',
  VRBO_MUVR = 'VRBO_MUVR',
  WELCOME_BEDS = 'WELCOME_BEDS',
  WOORI = 'WOORI',
  WORLDHOTELLINK = 'WORLDHOTELLINK',
  WORLDSPAN = 'WORLDSPAN',
  WOTIF = 'WOTIF',
  YOUTRAVEL = 'YOUTRAVEL',
  ZUMATA = 'ZUMATA',
}

/** Edit user roles for a partner account request body */
export interface InvitePartnerUserRequestInput {
  emails: Array<Scalars['String']>;
  partnerAccountId: Scalars['String'];
  roleIds: Array<Scalars['String']>;
}

/** Possible direction types for ground transfers */
export enum JourneyExperience {
  NEW_JOURNEY_PLAYBACK = 'NEW_JOURNEY_PLAYBACK',
  OLD_JOURNEY_PLAYBACK = 'OLD_JOURNEY_PLAYBACK',
}

/** Provides the interest of a Customer for a particular search */
export interface JourneyFlightSelectionInput {
  /** Represents the segment index. */
  journeyIndex: Scalars['Int'];
  /** Represents the flight combination the customer previously selected for the indexed segment. This will be used to highlight the previously selected offer for pinned listing. */
  offerIdentifier: Scalars['String'];
}

export interface KCPConfigurationInput {
  domainURL?: InputMaybe<Scalars['String']>;
  encodedData?: InputMaybe<Scalars['String']>;
  encodedInfo?: InputMaybe<Scalars['String']>;
  resultCode?: InputMaybe<Scalars['String']>;
  resultMessage?: InputMaybe<Scalars['String']>;
  transactionCode?: InputMaybe<Scalars['String']>;
}

/** Configuration for NaverPay(KCP) */
export interface KCPPaymentConfigInput {
  encodedData?: InputMaybe<Scalars['String']>;
  encodedInfo?: InputMaybe<Scalars['String']>;
  resultCode?: InputMaybe<Scalars['String']>;
  resultMessage?: InputMaybe<Scalars['String']>;
  transactionCode?: InputMaybe<Scalars['String']>;
}

export interface KnowYourCustomerAddressInput {
  city: Scalars['String'];
  country: Scalars['String'];
  postalCode: Scalars['String'];
  state: Scalars['String'];
  street: Scalars['String'];
  street2?: InputMaybe<Scalars['String']>;
}

export interface KnowYourCustomerAttestationInput {
  acceptanceTimestamp: Scalars['String'];
  acceptedBy: Scalars['String'];
  attestationReference: Scalars['String'];
  attestationVersion: Scalars['String'];
  ipAddress: Scalars['String'];
}

export interface KnowYourCustomerBusinessInfoInput {
  businessType?: InputMaybe<Scalars['String']>;
  businessWebsite?: InputMaybe<Scalars['String']>;
  confirmTaxId?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  dBA?: InputMaybe<Scalars['String']>;
  registrationNumber?: InputMaybe<Scalars['String']>;
  taxId?: InputMaybe<Scalars['String']>;
  taxIdType?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
  yearsOfFormation?: InputMaybe<Scalars['String']>;
}

export interface KnowYourCustomerDataInput {
  attestations?: InputMaybe<Array<KnowYourCustomerAttestationInput>>;
  businessAddress?: InputMaybe<KnowYourCustomerAddressInput>;
  businessInfo?: InputMaybe<KnowYourCustomerBusinessInfoInput>;
  confirmInfoAccuracy?: InputMaybe<Scalars['Boolean']>;
  confirmSanctions?: InputMaybe<Scalars['Boolean']>;
  keyPeople?: InputMaybe<Array<KnowYourCustomerKeyPersonInput>>;
  onboardingInfo?: InputMaybe<KnowYourCustomerOnboardingInfoInput>;
  stockInfo?: InputMaybe<KnowYourCustomerStockInfoInput>;
  supportingDocuments?: InputMaybe<Array<KnowYourCustomerSupportingDocInput>>;
  taxId?: InputMaybe<KnowYourCustomerTaxIdInput>;
  trustPayload?: InputMaybe<Scalars['String']>;
}

export interface KnowYourCustomerKeyPersonInput {
  city: Scalars['String'];
  country: Scalars['String'];
  countryCode: Scalars['String'];
  dateOfBirth: Scalars['String'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  personalDocuments?: InputMaybe<Array<KnowYourCustomerSupportingDocInput>>;
  phoneNumber: Scalars['String'];
  phoneType: Scalars['String'];
  postalCode: Scalars['String'];
  providerDetails?: InputMaybe<Array<KnowYourCustomerKeyPersonProviderDetailsInput>>;
  role: Array<Scalars['String']>;
  state: Scalars['String'];
  street: Scalars['String'];
  street2?: InputMaybe<Scalars['String']>;
  taxId: Scalars['String'];
  taxIdType: Scalars['String'];
  title: Scalars['String'];
}

export interface KnowYourCustomerKeyPersonProviderDetailsInput {
  name: Scalars['String'];
  providerId: Scalars['String'];
  status?: InputMaybe<Scalars['String']>;
}

export interface KnowYourCustomerOnboardingInfoInput {
  address: KnowYourCustomerAddressInput;
  dateOfBirth?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  legalBusinessName?: InputMaybe<Scalars['String']>;
  phone: KnowYourCustomerPhoneInput;
}

export interface KnowYourCustomerPhoneInput {
  countryCode?: InputMaybe<Scalars['String']>;
  phoneNumber: Scalars['String'];
  phoneType?: InputMaybe<Scalars['String']>;
}

export interface KnowYourCustomerStockInfoInput {
  marketIdentifier: Scalars['String'];
  stockNumber: Scalars['String'];
  tickerSymbol: Scalars['String'];
}

export interface KnowYourCustomerSupportingDocInput {
  documentCreationTimestamp: Scalars['String'];
  documentFileFormat: Scalars['String'];
  documentId: Scalars['String'];
  documentType: Scalars['String'];
  documentUri: Scalars['String'];
}

export interface KnowYourCustomerTaxIdInput {
  type: Scalars['String'];
  value: Scalars['String'];
}

/** LSL creative input */
export interface LSLCreativeInput {
  /** Ad creative description */
  description?: InputMaybe<Scalars['String']>;
  /** Ad creative headline */
  headline?: InputMaybe<Scalars['String']>;
  /** Ad creative image ID */
  imageId?: InputMaybe<Scalars['String']>;
  /** Ad creative image URL */
  imageUrl?: InputMaybe<Scalars['String']>;
}

export interface LandingAlternativeAirportsInput {
  maxNumberOfCard?: InputMaybe<Scalars['Int']>;
}

export interface LandingDestinationPageContextInput {
  egPlatformUrl?: InputMaybe<Scalars['String']>;
  uriContext?: InputMaybe<UriContextInput>;
  url: Scalars['URL'];
}

export interface LandingDiscoveryContextInput {
  configurationId: Scalars['String'];
  destination?: InputMaybe<LandingDiscoveryDestinationContextInput>;
  lodging?: InputMaybe<LandingDiscoveryLodgingContextInput>;
  pageId: Scalars['String'];
  url?: InputMaybe<Scalars['String']>;
}

export interface LandingDiscoveryDestinationContextInput {
  placeCoordinates?: InputMaybe<CoordinatesInput>;
  placeId?: InputMaybe<DiscoveryPlaceIdInput>;
}

export interface LandingDiscoveryLodgingContextInput {
  dateRange?: InputMaybe<DateRangeInput>;
  discoveryFlexFilters?: InputMaybe<DiscoveryFlexFiltersInput>;
  propertyId?: InputMaybe<Scalars['String']>;
}

/** A custom context to retrieve targeted flex content, to be used if URIContext is empty. */
export interface LandingFeaturedSuppliersCustomPageContextInput {
  /** Identifiers are the subcomponents that uniquely identify a URI */
  identifiers?: InputMaybe<LandingFeaturedSuppliersCustomUriIdentifiersInput>;
  placementId?: InputMaybe<Scalars['String']>;
}

export interface LandingFeaturedSuppliersCustomUriIdentifiersInput {
  funnelLocation?: InputMaybe<Scalars['String']>;
  lineOfBusiness?: InputMaybe<Scalars['String']>;
}

export interface LandingFeaturedSuppliersFlightSearchCriteriaInput {
  /** Number of days from today, which results in the departure date. */
  departureDateOffsetInDays?: InputMaybe<Scalars['Int']>;
  /** Number of days from today, which results in the return departure date. Must be greater than departureDateOffsetInDays. */
  returnDepartureDateOffsetInDays?: InputMaybe<Scalars['Int']>;
}

/** Search criteria inputs for landingFeaturedSuppliers query. */
export interface LandingFeaturedSuppliersSearchCriteriaInput {
  flight?: InputMaybe<LandingFeaturedSuppliersFlightSearchCriteriaInput>;
}

export interface LandingLinksToSearchResultsInput {
  strategy?: InputMaybe<Scalars['String']>;
}

export enum LandingUIButtonType {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
  TERTIARY = 'TERTIARY',
}

export enum LayoutPosition {
  BOTTOM = 'BOTTOM',
  CENTER = 'CENTER',
  LEFT = 'LEFT',
  TOP = 'TOP',
}

/** Controls the type of layout theme */
export enum LayoutTheme {
  ADAPTIVE = 'ADAPTIVE',
  DEFAULT = 'DEFAULT',
}

export interface LegacyPropertySearchCriteriaInput {
  /** Maps to PropertyFilterAmenity */
  amenities?: InputMaybe<Array<Scalars['String']>>;
  /** Maps to ReviewScoreRange */
  guestRating?: InputMaybe<Scalars['String']>;
  /** Maps to PaymentType enum to account for legacy URL values */
  paymentType?: InputMaybe<Array<Scalars['String']>>;
  /** List of the price buckets to use. Starts from 0 index e.g. `[0,1,2]` */
  priceBuckets?: InputMaybe<Array<Scalars['Int']>>;
  /** User preference for tracking which is only required in POSs that require tracking opt in */
  privacyTrackingState?: InputMaybe<PrivacyTrackingState>;
  /** Maps to PropertySort */
  sort?: InputMaybe<Scalars['String']>;
  /** Maps to starList */
  stars?: InputMaybe<Scalars['String']>;
  /** Maps to StructureType */
  structureTypes?: InputMaybe<Array<Scalars['String']>>;
}

export enum LegalConcept {
  LEGAL_CONCEPT_COOKIES = 'LEGAL_CONCEPT_COOKIES',
  LEGAL_CONCEPT_INVALID = 'LEGAL_CONCEPT_INVALID',
  LEGAL_CONCEPT_PRIVACY = 'LEGAL_CONCEPT_PRIVACY',
  LEGAL_CONCEPT_SORT_AND_FILTER = 'LEGAL_CONCEPT_SORT_AND_FILTER',
  LEGAL_CONCEPT_TERMS_AND_CONDITIONS = 'LEGAL_CONCEPT_TERMS_AND_CONDITIONS',
}

export enum LegalSheetType {
  LEGAL_SHEET = 'LEGAL_SHEET',
}

export enum LegalStepperState {
  COMPLETE = 'COMPLETE',
  CURRENT = 'CURRENT',
  INCOMPLETE = 'INCOMPLETE',
}

/** Used to display one track of the steps. */
export enum LegalTrackPosition {
  END = 'END',
  STANDARD = 'STANDARD',
  START = 'START',
}

export enum LikeUnlikeSocialInteractionAction {
  LIKE = 'LIKE',
  UNLIKE = 'UNLIKE',
}

export enum LimitToCertainTravelersOptions {
  HOTWIRE_USERS_ONLY = 'HOTWIRE_USERS_ONLY',
  MEMBERS_ONLY = 'MEMBERS_ONLY',
  MOBILE_AND_TABLET_USERS_ONLY = 'MOBILE_AND_TABLET_USERS_ONLY',
  TRAVELERS_IN_CERTAIN_LOCATIONS = 'TRAVELERS_IN_CERTAIN_LOCATIONS',
}

/** Line of business */
export enum LineOfBusinessDomain {
  ACTIVITIES = 'ACTIVITIES',
  CAR = 'CAR',
  CRUISES = 'CRUISES',
  FLIGHT = 'FLIGHT',
  GROUNDTRANSFERS = 'GROUNDTRANSFERS',
  LODGING = 'LODGING',
  PACKAGES = 'PACKAGES',
  RAILS = 'RAILS',
  UNCLASSIFIED = 'UNCLASSIFIED',
}

export enum LineOfBusinessType {
  ACTIVITY = 'ACTIVITY',
  AIR = 'AIR',
  CAR = 'CAR',
  CRUISE = 'CRUISE',
  FEE = 'FEE',
  INSURANCE = 'INSURANCE',
  ITINERARY = 'ITINERARY',
  LODGING = 'LODGING',
  TRAIN = 'TRAIN',
}

export enum Listings {
  /** Only return travelAds */
  ADS_ONLY = 'ADS_ONLY',
}

export enum LiveAnnouncePoliteness {
  ASSERTIVE = 'ASSERTIVE',
  OFF = 'OFF',
  POLITE = 'POLITE',
}

export enum LoaderSize {
  LARGE = 'LARGE',
  MEDIUM = 'MEDIUM',
  SMALL = 'SMALL',
}

export enum Location {
  BELOW_CHECKOUT_BOOK_BUTTON = 'BELOW_CHECKOUT_BOOK_BUTTON',
  CHECKOUT_ABOVE_CPM = 'CHECKOUT_ABOVE_CPM',
  CHECKOUT_AFTER_HEADER = 'CHECKOUT_AFTER_HEADER',
  CHECKOUT_AFTER_IMPORTANT_INFORMATION = 'CHECKOUT_AFTER_IMPORTANT_INFORMATION',
  CHECKOUT_AFTER_PRICE_TOTAL = 'CHECKOUT_AFTER_PRICE_TOTAL',
  CHECKOUT_BEFORE_LEGAL = 'CHECKOUT_BEFORE_LEGAL',
  CHECKOUT_BEFORE_SMARTFORM = 'CHECKOUT_BEFORE_SMARTFORM',
  CHECKOUT_ON_TOP_OF_CPM = 'CHECKOUT_ON_TOP_OF_CPM',
  /** @deprecated Please use CHECKOUT_ABOVE_CPM instead CHECKOUT_REDIRECT */
  CHECKOUT_REDIRECT = 'CHECKOUT_REDIRECT',
  CHECKOUT_RIGHT_SIDE_PAGE = 'CHECKOUT_RIGHT_SIDE_PAGE',
  CHECKOUT_RIGHT_SIDE_PAGE_AFTER_PRICE_DETAILS = 'CHECKOUT_RIGHT_SIDE_PAGE_AFTER_PRICE_DETAILS',
  CHECKOUT_TOP_OF_PAGE = 'CHECKOUT_TOP_OF_PAGE',
  CHECKOUT_TOP_OF_PAGE_AFTER_SECURE_HEADLINE = 'CHECKOUT_TOP_OF_PAGE_AFTER_SECURE_HEADLINE',
  CHECKOUT_TOP_OF_PAGE_NATIVE = 'CHECKOUT_TOP_OF_PAGE_NATIVE',
  CONFIRMATION_SUMMARY_IN_MODULE = 'CONFIRMATION_SUMMARY_IN_MODULE',
  COUPON_IN_MODULE = 'COUPON_IN_MODULE',
  CPM_IN_MODULE = 'CPM_IN_MODULE',
  CPM_NOTIFICATION_IN_MODULE = 'CPM_NOTIFICATION_IN_MODULE',
  ERROR_PAGE_AFTER_HEADER = 'ERROR_PAGE_AFTER_HEADER',
  GIFTCARD_IN_MODULE = 'GIFTCARD_IN_MODULE',
  /** @deprecated Please use CPM_IN_MODULE instead PAYMENT_IN_MODULE */
  PAYMENT_IN_MODULE = 'PAYMENT_IN_MODULE',
}

/** Represents location scout request data */
export interface LocationScoutOverlayRequestInput {
  /** Represents the creator handle for travel shop */
  creatorHandle?: InputMaybe<Scalars['String']>;
  /** Represents postId which will be used while fetching the corresponding post */
  postId: Scalars['String'];
  /** Represents postType which will be used while fetching the corresponding post */
  postType: Scalars['String'];
  /** Represents productId which will be used to determine the interaction tray icons in the response */
  productId: LocationScoutProductId;
  /** Represents propertyId which can be used to fetch property details */
  propertyId?: InputMaybe<Scalars['String']>;
  /** Represents rating for the particular property */
  ratingScore?: InputMaybe<Scalars['Float']>;
  /** Represents screenId which will be used to determine the interaction icons in the response */
  screenId: Scalars['String'];
}

/** Represents the entry point for the location scout experience queries */
export enum LocationScoutProductId {
  SRP = 'SRP',
  TRAVEL_SHOP = 'TRAVEL_SHOP',
}

export enum LodgingBookingPlaybackType {
  /** Playback type for both original and new booking playback */
  COMBINED = 'COMBINED',
  /** Playback type for new booking playback */
  NEW = 'NEW',
  /** Playback type for original booking playback */
  ORIGINAL = 'ORIGINAL',
}

export interface LodgingCancelMutationInput {
  approver?: InputMaybe<ApproverInput>;
  isRefundWithheld?: InputMaybe<Scalars['Boolean']>;
  reasonCodes?: InputMaybe<ReasonCodesMutationInput>;
  waiverAmount?: InputMaybe<Scalars['Float']>;
  waivingSource?: InputMaybe<WaivingSource>;
}

export enum LodgingCancelStatus {
  Failure = 'Failure',
  Success = 'Success',
}

export interface LodgingChangeMutationInput {
  approver?: InputMaybe<ApproverInput>;
  deferredPaymentDate?: InputMaybe<Scalars['String']>;
  expectedNewBookingPrice?: InputMaybe<Scalars['Float']>;
  expectedPenaltyAmount?: InputMaybe<Scalars['Float']>;
  paymentAssistSessionId?: InputMaybe<Scalars['String']>;
  reasonCodes?: InputMaybe<ReasonCodesMutationInput>;
  waiverAmount?: InputMaybe<Scalars['Float']>;
  waivingSource?: InputMaybe<WaivingSource>;
}

export enum LodgingChangeStatus {
  Failure = 'Failure',
  Pending = 'Pending',
  Success = 'Success',
}

export enum LodgingCompareRowSection {
  BODY = 'BODY',
  FOOTER = 'FOOTER',
  HEADER = 'HEADER',
}

export enum LodgingCompareRowTheme {
  COMBINE_NEXT = 'COMBINE_NEXT',
  SPOTLIGHT = 'SPOTLIGHT',
  STANDARD = 'STANDARD',
}

/** Ad Copy Request */
export interface LodgingCreativeInput {
  /** Can use ML to override ad image */
  canOverrideImage: Scalars['Boolean'];
  /** Ad copy description */
  description?: InputMaybe<Scalars['String']>;
  /** Ad copy headline */
  headline?: InputMaybe<Scalars['String']>;
  /** Ad copy image id */
  imageId?: InputMaybe<Scalars['String']>;
  /** Ad copy url */
  imageUrl?: InputMaybe<Scalars['String']>;
}

/** Describes the type of product (line of business) that is being sold */
export enum LodgingCrossSellProductType {
  CAR = 'CAR',
}

export enum LodgingFormMethod {
  GET = 'GET',
  POST = 'POST',
}

export enum LodgingInputType {
  EMAIL = 'EMAIL',
  HIDDEN = 'HIDDEN',
  PASSWORD = 'PASSWORD',
  TEL = 'TEL',
  TEXT = 'TEXT',
  URL = 'URL',
}

/** Theme information for a message. */
export enum LodgingMessageTheme {
  /** To be used for warnings/errors; typically red. */
  AGGRESSIVE = 'AGGRESSIVE',
  /** To be used for emphasis; typically both bold and larger font. */
  EMPHASIS = 'EMPHASIS',
  /** To be used for success/perks; typically green. */
  HIGHLIGHT = 'HIGHLIGHT',
  /** To be used for emphasis; typically bold. */
  STRONG = 'STRONG',
}

/** Lodging input for prepareChangeCheckout mutation */
export interface LodgingPrepareChangeCheckoutInput {
  orderLineGuid: Scalars['String'];
  orderNumber: Scalars['String'];
  propertyNaturalKey: PropertyNaturalKeyInput;
}

/** Different set of label and icon combo will be displayed based on the type */
export enum LodgingPriceInsightTrackingActionType {
  /** When user is not subscribed, ui will display subscribe action text and icon */
  SUBSCRIBE_ACTION = 'SUBSCRIBE_ACTION',
  /** When user is subscribed, ui will display unsubscribe action text and icon */
  UNSUBSCRIBE_ACTION = 'UNSUBSCRIBE_ACTION',
}

/** Different types of toast messages */
export enum LodgingPriceInsightTrackingToastType {
  /** Mutation is unsuccessful */
  ERROR = 'ERROR',
  /** Mutation is successful */
  SUCCESS = 'SUCCESS',
}

export enum LodgingPriceTrackingMutationType {
  /** opt in - create subscription based on search criteria */
  CREATE_SUBSCRIPTION = 'CREATE_SUBSCRIPTION',
  /** opt out - inactivate subscription based on subscription id */
  DELETE_SUBSCRIPTION = 'DELETE_SUBSCRIPTION',
  /** triggered by onscroll - update last seen price */
  UPDATE_PRICE = 'UPDATE_PRICE',
}

export enum LodgingStepperState {
  COMPLETE = 'COMPLETE',
  CURRENT = 'CURRENT',
  INCOMPLETE = 'INCOMPLETE',
}

export enum LodgingSubscriptionStatusType {
  SUBSCRIBED = 'SUBSCRIBED',
  UNKNOWN = 'UNKNOWN',
  UNSUBSCRIBED = 'UNSUBSCRIBED',
}

export enum LodgingSupplierRemittanceType {
  GROSS = 'GROSS',
  INVALID = 'INVALID',
  NET = 'NET',
}

export enum LodgingTrackPosition {
  END = 'END',
  STANDARD = 'STANDARD',
  START = 'START',
}

export enum LoginEntryPoint {
  INITIAL_AUTH = 'INITIAL_AUTH',
  ODPS = 'ODPS',
  ONBOARDING_FULL_SCREEN = 'ONBOARDING_FULL_SCREEN',
}

export enum LogoLockupOrientation {
  /** Horizontal orientation */
  HORIZONTAL = 'HORIZONTAL',
  /** Vertical orientation */
  VERTICAL = 'VERTICAL',
}

export enum LogoutStatus {
  FAILURE = 'FAILURE',
  SUCCESS = 'SUCCESS',
}

/** Represents different ways to align text content */
export enum LoyaltyAlignment {
  CENTER = 'CENTER',
  LEFT = 'LEFT',
  RIGHT = 'RIGHT',
}

export enum LoyaltyCelebrationOperationStatus {
  FAILED = 'FAILED',
  SUCCEEDED = 'SUCCEEDED',
  UNKNOWN_OPERATION = 'UNKNOWN_OPERATION',
}

/** Represents the different ways an image can be positioned in a LoyaltyDialogSection */
export enum LoyaltyDialogSectionImagePosition {
  BOTTOM = 'BOTTOM',
  TOP = 'TOP',
}

export enum LoyaltyExperienceStrategy {
  HIDE_TRAVELER_INFO_AND_REWARDS_LINK = 'HIDE_TRAVELER_INFO_AND_REWARDS_LINK',
  SHOW_TRAVELER_INFO_AND_REWARDS_LINK = 'SHOW_TRAVELER_INFO_AND_REWARDS_LINK',
}

export enum LoyaltyProgram {
  BEX_REWARDS = 'BEX_REWARDS',
  HCOM_REWARDS = 'HCOM_REWARDS',
  ONE_KEY = 'ONE_KEY',
  REDIRECT_CARD = 'REDIRECT_CARD',
}

export enum LoyaltyTierFieldType {
  /** loyalty tier badge */
  BADGE = 'BADGE',
  /** range of trip elements for the loyalty tier */
  RANGE = 'RANGE',
}

/** Enumeration for 2fa/mfa verification method */
export enum MFAVerificationMethod {
  CALL = 'CALL',
  SMS = 'SMS',
}

export enum MMLocation {
  BELOW_CHECKOUT_BOOK_BUTTON = 'BELOW_CHECKOUT_BOOK_BUTTON',
  CHECKOUT_ABOVE_CPM = 'CHECKOUT_ABOVE_CPM',
  CHECKOUT_AFTER_HEADER = 'CHECKOUT_AFTER_HEADER',
  CHECKOUT_AFTER_HEADER_NATIVE = 'CHECKOUT_AFTER_HEADER_NATIVE',
  CHECKOUT_AFTER_IMPORTANT_INFORMATION = 'CHECKOUT_AFTER_IMPORTANT_INFORMATION',
  CHECKOUT_AFTER_PRICE_TOTAL = 'CHECKOUT_AFTER_PRICE_TOTAL',
  CHECKOUT_BEFORE_LEGAL = 'CHECKOUT_BEFORE_LEGAL',
  CHECKOUT_BEFORE_SMARTFORM = 'CHECKOUT_BEFORE_SMARTFORM',
  CHECKOUT_ON_TOP_OF_CPM = 'CHECKOUT_ON_TOP_OF_CPM',
  /** @deprecated Please use CHECKOUT_ABOVE_CPM instead CHECKOUT_REDIRECT */
  CHECKOUT_REDIRECT = 'CHECKOUT_REDIRECT',
  CHECKOUT_REDIRECT_BANNER_NATIVE = 'CHECKOUT_REDIRECT_BANNER_NATIVE',
  CHECKOUT_RIGHT_SIDE_PAGE = 'CHECKOUT_RIGHT_SIDE_PAGE',
  CHECKOUT_RIGHT_SIDE_PAGE_AFTER_PRICE_DETAILS = 'CHECKOUT_RIGHT_SIDE_PAGE_AFTER_PRICE_DETAILS',
  CHECKOUT_RIGHT_SIDE_PAGE_NATIVE = 'CHECKOUT_RIGHT_SIDE_PAGE_NATIVE',
  CHECKOUT_TOP_OF_PAGE = 'CHECKOUT_TOP_OF_PAGE',
  CHECKOUT_TOP_OF_PAGE_AFTER_SECURE_HEADLINE = 'CHECKOUT_TOP_OF_PAGE_AFTER_SECURE_HEADLINE',
  CHECKOUT_TOP_OF_PAGE_NATIVE = 'CHECKOUT_TOP_OF_PAGE_NATIVE',
  CONFIRMATION_PAGE_DIALOG = 'CONFIRMATION_PAGE_DIALOG',
  CONFIRMATION_PAGE_DIALOG_NATIVE = 'CONFIRMATION_PAGE_DIALOG_NATIVE',
  CONFIRMATION_SUMMARY_IN_MODULE = 'CONFIRMATION_SUMMARY_IN_MODULE',
  COUPON_IN_MODULE = 'COUPON_IN_MODULE',
  CPM_IN_MODULE = 'CPM_IN_MODULE',
  CPM_NOTIFICATION_IN_MODULE = 'CPM_NOTIFICATION_IN_MODULE',
  CPM_NOTIFICATION_IN_MODULE_NATIVE = 'CPM_NOTIFICATION_IN_MODULE_NATIVE',
  ERROR_PAGE_AFTER_HEADER = 'ERROR_PAGE_AFTER_HEADER',
  ERROR_PAGE_AFTER_HEADER_NATIVE = 'ERROR_PAGE_AFTER_HEADER_NATIVE',
  GIFTCARD_IN_MODULE = 'GIFTCARD_IN_MODULE',
  /** @deprecated Please use CPM_IN_MODULE instead PAYMENT_IN_MODULE */
  PAYMENT_IN_MODULE = 'PAYMENT_IN_MODULE',
  PRICE_DETAILS_IN_MODULE = 'PRICE_DETAILS_IN_MODULE',
  PRICE_DETAILS_IN_MODULE_NATIVE = 'PRICE_DETAILS_IN_MODULE_NATIVE',
}

export enum MODERATION_RULE {
  ADVISE = 'ADVISE',
  BLOCK = 'BLOCK',
}

export enum MODERATION_TYPE {
  CHARACTER = 'CHARACTER',
  WORD = 'WORD',
}

export enum ManagedBannerContentBgTheme {
  CRITICAL = 'CRITICAL',
  ERROR = 'ERROR',
  GLOBAL_LOYALTY_EXTRAHIGH = 'GLOBAL_LOYALTY_EXTRAHIGH',
  GLOBAL_LOYALTY_HIGH = 'GLOBAL_LOYALTY_HIGH',
  GLOBAL_LOYALTY_LOW = 'GLOBAL_LOYALTY_LOW',
  GLOBAL_LOYALTY_MIDDLE = 'GLOBAL_LOYALTY_MIDDLE',
  GLOBAL_LOYALTY_STANDARD = 'GLOBAL_LOYALTY_STANDARD',
  HIGHLIGHT = 'HIGHLIGHT',
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
}

/** Optional information to create custom context for EM powered banner */
export interface ManagedBannerCustomContextInput {
  oneKeyCash?: InputMaybe<OneKeyCashContextInput>;
  propertyOffers?: InputMaybe<PropertyOffersContextInput>;
}

/** The UDS icon used for the map marker */
export enum MapIconType {
  AIRPORT = 'AIRPORT',
  CIRCLE = 'CIRCLE',
  GROCERY = 'GROCERY',
  HOTEL = 'HOTEL',
  LANDMARK = 'LANDMARK',
  METRO = 'METRO',
  RESTAURANT = 'RESTAURANT',
  SOLD_OUT = 'SOLD_OUT',
  TRAIN = 'TRAIN',
  VACATION_RENTAL = 'VACATION_RENTAL',
}

/** Toolbar action type */
export enum MapToolbarActionsType {
  /** Show filters button in the toolbar */
  FILTERS = 'FILTERS',
}

/** Placement of loyalty mark in the member wallet details item */
export enum MarkItemPosition {
  LEFT = 'LEFT',
  RIGHT = 'RIGHT',
}

/** The type of map marker */
export enum MarkerType {
  HOTEL = 'HOTEL',
  POI = 'POI',
}

export enum MarketGoal {
  LEADER = 'LEADER',
  PLAYER = 'PLAYER',
  TRACKER = 'TRACKER',
  UNKNOWN = 'UNKNOWN',
}

export enum MarketingChannel {
  DIRECT = 'DIRECT',
  NON_DIRECT = 'NON_DIRECT',
}

export enum MarketingFeedCardStatus {
  ACTIVE = 'ACTIVE',
  DELETED = 'DELETED',
  INACTIVE = 'INACTIVE',
}

/** Used to pass certain marketing details for google ad awareness */
export interface MarketingInfoInput {
  /** Represents identifier generated after Google Ad click */
  googleClickIdentifier?: InputMaybe<Scalars['String']>;
  /** Represents information coming from meta channel */
  metaDistributionPartnersChannelIdentifier?: InputMaybe<Scalars['String']>;
  /** Represents marketing channel identifier */
  metaDistributionPartnersDetails?: InputMaybe<Scalars['String']>;
}

export enum MarketplaceDesignRankingMetricsBadgeThemes {
  DEFAULT = 'DEFAULT',
  FEATURED = 'FEATURED',
  INFO = 'INFO',
  POSITIVE = 'POSITIVE',
  WARNING = 'WARNING',
}

/** Used to indicate what type of markup a field contains */
export enum MarkupTextType {
  /** Hypertext markup language */
  HTML = 'HTML',
}

export enum MarqueeCardType {
  CENTER_STAGE = 'CENTER_STAGE',
  COLLECTION = 'COLLECTION',
  FULL_BLEED = 'FULL_BLEED',
}

export enum MealPlanFilterAmenity {
  ALL_INCLUSIVE = 'ALL_INCLUSIVE',
  FREE_BREAKFAST = 'FREE_BREAKFAST',
  FULL_BOARD = 'FULL_BOARD',
  HALF_BOARD = 'HALF_BOARD',
}

export enum MediaContentType {
  IMAGE = 'IMAGE',
  VIDEO = 'VIDEO',
}

export enum MediaType {
  IMAGE = 'IMAGE',
  VIDEO = 'VIDEO',
}

export interface MediaUploadInput {
  altText?: InputMaybe<Scalars['String']>;
  fileName?: InputMaybe<Scalars['String']>;
  hash: Scalars['String'];
}

export interface MemberPricingInput {
  /** Discount percentage */
  discountPercentage?: InputMaybe<Scalars['Int']>;
  /** Is lead in offer MOD */
  leadInMemberOffer?: InputMaybe<Scalars['Boolean']>;
  /** Is any offer MOD */
  memberOfferAvailable?: InputMaybe<Scalars['Boolean']>;
}

export enum MemberWalletBadgeTheme {
  LOYALTY_HIGH_TIER = 'LOYALTY_HIGH_TIER',
  LOYALTY_LOW_TIER = 'LOYALTY_LOW_TIER',
  LOYALTY_MIDDLE_TIER = 'LOYALTY_MIDDLE_TIER',
}

/** Represents path where merchandising details card component to be use. */
export enum MerchandisingDetailsCardPath {
  CHECKOUT = 'CHECKOUT',
  CONFIRMATION = 'CONFIRMATION',
}

/** Represents the message files object on communication center */
export interface MessageAttachmentsInput {
  /** Represents message attachment id list that will be used in communication center */
  attachmentIds?: InputMaybe<Array<Scalars['String']>>;
}

/** Enum for MessageContent banner theme */
export enum MessageContentTheme {
  CRITICAL = 'CRITICAL',
  ERROR = 'ERROR',
}

/** Represents the status of message history */
export enum MessageSource {
  HISTORY = 'HISTORY',
  LIVE = 'LIVE',
}

/** The search criteria for message templates */
export interface MessageTemplateCriteriaInput {
  /** Represents the value of an identifier */
  identifier: Scalars['String'];
  /** Represents the identifier type */
  identifierType: MessageTemplateIdentifierType;
}

export enum MessageTemplateIdentifierType {
  CODE = 'CODE',
  RESOURCE_ID = 'RESOURCE_ID',
}

/** Unique identifier for a message if one needs to identify the reason for the message creation */
export enum MessageType {
  ADDON = 'ADDON',
  BRANDED_THEME_ACCENT = 'BRANDED_THEME_ACCENT',
  BRANDED_THEME_DARK = 'BRANDED_THEME_DARK',
  BRANDED_THEME_LIGHT = 'BRANDED_THEME_LIGHT',
  COMPRESSION = 'COMPRESSION',
  COUPON = 'COUPON',
  DOUBLE_POINTS = 'DOUBLE_POINTS',
  FREE_CANCELLATION = 'FREE_CANCELLATION',
  FREE_LX = 'FREE_LX',
  HOTRATE = 'HOTRATE',
  LEGAL = 'LEGAL',
  LOGIN = 'LOGIN',
  LOYALTY = 'LOYALTY',
  NO_CC = 'NO_CC',
  OVERFILTERED = 'OVERFILTERED',
  PARTNER_LINKOFF = 'PARTNER_LINKOFF',
  VACATION_RENTALS = 'VACATION_RENTALS',
}

export enum MessagingCardTheme {
  HIGHLIGHT = 'HIGHLIGHT',
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
}

/** Object to inquire for meta data of jobs */
export interface MetaDataRequestInput {
  category: Scalars['String'];
  filename?: InputMaybe<Scalars['String']>;
}

export interface MetricRangeInput {
  lowerBound: Scalars['Float'];
  midpoint: Scalars['Float'];
  upperBound: Scalars['Float'];
}

export enum MigrationFlightsQueryState {
  LOADED = 'LOADED',
  LOADING = 'LOADING',
}

export enum MigrationFlowIdentifier {
  EMAIL_OTP = 'EMAIL_OTP',
  NONE = 'NONE',
  PASSWORD = 'PASSWORD',
  PRE_OI_SIGNIN = 'PRE_OI_SIGNIN',
  PROFILE_DETAIL = 'PROFILE_DETAIL',
}

export enum MigrationPackageType {
  FLIGHT_CAR = 'FLIGHT_CAR',
  FLIGHT_HOTEL = 'FLIGHT_HOTEL',
  FLIGHT_HOTEL_CAR = 'FLIGHT_HOTEL_CAR',
  HOTEL_ACTIVITY = 'HOTEL_ACTIVITY',
  HOTEL_CAR = 'HOTEL_CAR',
}

export enum MigrationStepName {
  BILLING_REVIEW = 'BILLING_REVIEW',
  CAMPAIGN_TRANSFER = 'CAMPAIGN_TRANSFER',
  PAYMENT_METHOD = 'PAYMENT_METHOD',
  PAYMENT_PROFILE = 'PAYMENT_PROFILE',
  TAX_PROFILE = 'TAX_PROFILE',
}

/** Product natural keys required for session recovery */
export interface MishopRecoveryNaturalKeysInput {
  flightNaturalKeys: Array<FlightNaturalKeyInput>;
  propertyNaturalKeys: Array<PropertyNaturalKeyInput>;
}

/** Contains necessary data for fetching car content */
export interface MishopUICarContentPrimerInput {
  naturalKey: CarNaturalKeyInput;
  relativeChangeCarLink?: InputMaybe<Scalars['String']>;
}

/** Change Package Search Form Primer */
export interface MishopUIChangePackageFormPrimerInput {
  multiItemSessionId: Scalars['String'];
}

/** The type of button to display */
export enum MishopUIDialogButtonType {
  PRIMARY = 'PRIMARY',
  TERTIARY = 'TERTIARY',
}

/** Contains the necessary data for calling packageSummaryContent query */
export interface MishopUIPackageSummaryContentPrimerInput {
  native?: InputMaybe<Scalars['Boolean']>;
  naturalKey: PackageNaturalKeyInput;
}

/** Contains the necessary data for rendering to the customer a placard describing announcements relevant to their trip */
export interface MishopUIPlacardNotificationInput {
  multiItemPriceToken?: InputMaybe<Scalars['String']>;
  placardType: MishopUIPlacardType;
  priceDetailsOptions?: InputMaybe<PriceDetailsOptionsInput>;
  shoppedProducts: Array<ShoppedProductInput>;
}

export enum MishopUIPlacardType {
  PRICE_CHANGE = 'PRICE_CHANGE',
}

export enum MishopUIProductType {
  ACTIVITY = 'ACTIVITY',
  CAR = 'CAR',
  FLIGHT = 'FLIGHT',
  GROUND_TRANSFER = 'GROUND_TRANSFER',
  PROPERTY = 'PROPERTY',
}

/** Contains necessary data for fetching property content */
export interface MishopUIPropertyContentPrimerInput {
  changePropertyAction: PropertySearchMultiItemShoppingActionInput;
  changeRoomAction: PropertyDetailsMultiItemShoppingActionInput;
  meta?: InputMaybe<Scalars['Boolean']>;
  naturalKey: PropertyNaturalKeyInput;
  relativeChangePropertyLink: Scalars['String'];
  relativeChangeRoomLink: Scalars['String'];
}

export interface MobileNumberCompletenessModuleRequestInput {
  promptDeniedDate?: InputMaybe<Scalars['String']>;
  promptDeniedTimes?: InputMaybe<Scalars['Int']>;
}

export enum ModalNavType {
  BACK = 'BACK',
  CLOSE = 'CLOSE',
  EXPAND_DOWN = 'EXPAND_DOWN',
  EXPAND_UP = 'EXPAND_UP',
}

export enum ModalSideSheetLayout {
  EIGHT = 'EIGHT',
  FOUR = 'FOUR',
  ONE = 'ONE',
  SIX = 'SIX',
  THREE = 'THREE',
  TWELVE = 'TWELVE',
  TWO = 'TWO',
}

export enum ModuleName {
  COUPON_MODULE = 'COUPON_MODULE',
}

export enum ModuleNames {
  DISCOVER = 'DISCOVER',
  HOME = 'HOME',
}

export interface MojoContextInput {
  pageName: Scalars['String'];
  placementId: Scalars['String'];
}

export interface MojoDebugParametersInput {
  requestDate?: InputMaybe<Scalars['String']>;
}

/** Represents the runtime context of a Landing page. */
export interface MojoLandingPageContextInput {
  /** EG Platform URL, contains URL level informations. */
  egPlatformUrl?: InputMaybe<Scalars['String']>;
  /** Blacksmith UriContext, supported because of legacy integrations (blossom-pwa). */
  uriContext?: InputMaybe<UriContextInput>;
}

export interface MojoLoyaltyContextInput {
  pageName: Scalars['String'];
  placementId: Scalars['String'];
}

export interface MojoLoyaltyExperienceContextInput {
  pageName: Scalars['String'];
  placementId: Scalars['String'];
}

export interface MojoMutationContextInput {
  debugParameters?: InputMaybe<MojoDebugParametersInput>;
  mutationId: Scalars['String'];
  pageName: Scalars['String'];
  payload: Scalars['String'];
}

export interface MojoRewardsContextInput {
  pageName: Scalars['String'];
  placementId: Scalars['String'];
}

/** Money bid amount structure */
export interface MoneyBidAmountStructureInput {
  /** Bid amount */
  amount?: InputMaybe<Scalars['Float']>;
  /** Bid amount currency */
  currencyCode?: InputMaybe<Scalars['String']>;
  /** Bid amount decimal places */
  decimalPlaces?: InputMaybe<Scalars['Int']>;
}

/** Pricing information */
export interface MoneyInput {
  /** Use platform formatters and return localized strings instead. Numeric portion of the price */
  amount: Scalars['Float'];
  /** DEPRECATED: The currency should be specified from the context instead. The ISO 4217 3-letter code for this currency eg: USD EUR GBP ... */
  currency?: InputMaybe<Scalars['String']>;
}

/** ID used to identify a month for queries that bucket data by month */
export enum MonthId {
  APRIL = 'APRIL',
  AUGUST = 'AUGUST',
  DECEMBER = 'DECEMBER',
  FEBRUARY = 'FEBRUARY',
  JANUARY = 'JANUARY',
  JULY = 'JULY',
  JUNE = 'JUNE',
  MARCH = 'MARCH',
  MAY = 'MAY',
  NOVEMBER = 'NOVEMBER',
  OCTOBER = 'OCTOBER',
  SEPTEMBER = 'SEPTEMBER',
}

/** The multi-item context used for package searches, contains information needed for package searches and retrieving package sessions */
export interface MultiItemContextInput {
  /** The multi-item session id used to retrieve the customers package search criteria and selected products */
  id: Scalars['String'];
  /** The package type for this search */
  packageType: PackageType;
  /** The multi-item price token is used to retrieve deal marker information when being not in the session id */
  priceToken?: InputMaybe<Scalars['String']>;
}

/** All natural keys for the products that the customer has already selected on the shopping path */
export interface MultiItemProductsInput {
  activities?: InputMaybe<Array<ActivityNaturalKeyInput>>;
  cars?: InputMaybe<Array<CarNaturalKeyInput>>;
  flights?: InputMaybe<Array<FlightNaturalKeyInput>>;
  groundTransfers?: InputMaybe<Array<GroundTransfersNaturalKeyInput>>;
  packages?: InputMaybe<Array<PackageNaturalKeyInput>>;
  properties?: InputMaybe<Array<PropertyNaturalKeyInput>>;
}

/** All criteria needed for a multi-item search */
export interface MultiItemSearchContextInput {
  cars?: InputMaybe<Array<CarSearchCriteriaInput>>;
  flights?: InputMaybe<Array<FlightSearchCriteriaInput>>;
  properties?: InputMaybe<Array<PropertySearchCriteriaInput>>;
  /** Filter and sort for package level */
  secondary?: InputMaybe<ShoppingSearchCriteriaInput>;
}

/** Input to update the product in the session */
export enum MultiItemShoppingActionType {
  CAR_SEARCH = 'CAR_SEARCH',
  FLIGHT_SEARCH = 'FLIGHT_SEARCH',
  PROPERTY_SEARCH = 'PROPERTY_SEARCH',
}

/** NavigationType provides collapse/expanded state of toolbar, specific to bottom sheet */
export enum NavigationType {
  COLLAPSE = 'COLLAPSE',
  EXPAND = 'EXPAND',
}

export interface NightlyRateInput {
  dayOfWeek: SupplyDayOfWeek;
  rate: Scalars['Float'];
}

/** Line of business */
export enum NoCancelFeeType {
  NO_CANCEL_FEE = 'NO_CANCEL_FEE',
}

/** Enum class to represent the type of no change fee */
export enum NoChangeFeeType {
  NO_CHANGE_FEE = 'NO_CHANGE_FEE',
}

export enum NotificationAnimationType {
  CONFETTI = 'CONFETTI',
  NONE = 'NONE',
}

/** The button type of the Customer notification submit button */
export enum NotificationFormButtonType {
  /** Type of floating action button */
  FLOATING_ACTION_BUTTON = 'FLOATING_ACTION_BUTTON',
  /** Type of primary button */
  PRIMARY_BUTTON = 'PRIMARY_BUTTON',
  /** Type of secondary button */
  SECONDARY_BUTTON = 'SECONDARY_BUTTON',
  /** Type of tertiary button */
  TERTIARY_BUTTON = 'TERTIARY_BUTTON',
}

/** Type encapsulating the data needed for in module notifications */
export interface NotificationInModuleMessageInput {
  /** Represents the name of the module that displays the message */
  moduleName?: InputMaybe<NotificationInModuleModuleName>;
  /** Represents the name of the message */
  name: NotificationInModuleMessageName;
}

export enum NotificationInModuleMessageName {
  COUPON_REMOVAL_FAILED_MESSAGE = 'COUPON_REMOVAL_FAILED_MESSAGE',
  CPM_CC_ON_FILE_MESSAGE = 'CPM_CC_ON_FILE_MESSAGE',
  CPM_CC_ON_FILE_MESSAGE_CAR = 'CPM_CC_ON_FILE_MESSAGE_CAR',
  CPM_CC_ON_FILE_ONLY_INSURANCE_PAYMENT_MESSAGE = 'CPM_CC_ON_FILE_ONLY_INSURANCE_PAYMENT_MESSAGE',
  CPM_CC_ON_FILE_UPDATED_MESSAGE = 'CPM_CC_ON_FILE_UPDATED_MESSAGE',
  CPM_NO_PAYMENT_DUE_MESSAGE = 'CPM_NO_PAYMENT_DUE_MESSAGE',
  CPM_NO_PAYMENT_DUE_MESSAGE_CAR = 'CPM_NO_PAYMENT_DUE_MESSAGE_CAR',
  CPM_NO_PAYMENT_DUE_UPDATED_MESSAGE = 'CPM_NO_PAYMENT_DUE_UPDATED_MESSAGE',
  CPM_ONLY_INSURANCE_PAYMENT_DUE_MESSAGE = 'CPM_ONLY_INSURANCE_PAYMENT_DUE_MESSAGE',
  CPM_ONLY_INSURANCE_PAYMENT_DUE_UPDATED_MESSAGE = 'CPM_ONLY_INSURANCE_PAYMENT_DUE_UPDATED_MESSAGE',
  OKC_ADD_FAILED_MESSAGE = 'OKC_ADD_FAILED_MESSAGE',
  OKC_REMOVAL_FAILED_MESSAGE = 'OKC_REMOVAL_FAILED_MESSAGE',
  PAY_NOW_CC_ON_FILE_GIFT_CARD_COUPON_TOTAL_AMOUNT = 'PAY_NOW_CC_ON_FILE_GIFT_CARD_COUPON_TOTAL_AMOUNT',
  PAY_NOW_CC_ON_FILE_GIFT_CARD_TOTAL_AMOUNT = 'PAY_NOW_CC_ON_FILE_GIFT_CARD_TOTAL_AMOUNT',
  PAY_NOW_CC_ON_FILE_OKC_COUPON_TOTAL_AMOUNT = 'PAY_NOW_CC_ON_FILE_OKC_COUPON_TOTAL_AMOUNT',
  PAY_NOW_CC_ON_FILE_OKC_GIFT_CARD_COUPON_TOTAL_AMOUNT = 'PAY_NOW_CC_ON_FILE_OKC_GIFT_CARD_COUPON_TOTAL_AMOUNT',
  PAY_NOW_CC_ON_FILE_OKC_GIFT_CARD_TOTAL_AMOUNT = 'PAY_NOW_CC_ON_FILE_OKC_GIFT_CARD_TOTAL_AMOUNT',
  PAY_NOW_CC_ON_FILE_OKC_TOTAL_AMOUNT = 'PAY_NOW_CC_ON_FILE_OKC_TOTAL_AMOUNT',
  PAY_NOW_GIFT_CARD_COUPON_TOTAL_AMOUNT = 'PAY_NOW_GIFT_CARD_COUPON_TOTAL_AMOUNT',
  PAY_NOW_GIFT_CARD_TOTAL_AMOUNT = 'PAY_NOW_GIFT_CARD_TOTAL_AMOUNT',
  PAY_NOW_OKC_COUPON_TOTAL_AMOUNT = 'PAY_NOW_OKC_COUPON_TOTAL_AMOUNT',
  PAY_NOW_OKC_GIFT_CARD_COUPON_TOTAL_AMOUNT = 'PAY_NOW_OKC_GIFT_CARD_COUPON_TOTAL_AMOUNT',
  PAY_NOW_OKC_GIFT_CARD_TOTAL_AMOUNT = 'PAY_NOW_OKC_GIFT_CARD_TOTAL_AMOUNT',
  PAY_NOW_OKC_TOTAL_AMOUNT = 'PAY_NOW_OKC_TOTAL_AMOUNT',
  PROMOTION_CHANGED_MESSAGE = 'PROMOTION_CHANGED_MESSAGE',
  REDIRECT_TO_LEGACY_CHECKOUT_NATIVE_VRBO_V3 = 'REDIRECT_TO_LEGACY_CHECKOUT_NATIVE_VRBO_V3',
}

export enum NotificationInModuleModuleName {
  COMMON_PAYMENT_MODULE = 'COMMON_PAYMENT_MODULE',
  COUPON_MODULE = 'COUPON_MODULE',
  LOYALTY_BURN_MODULE = 'LOYALTY_BURN_MODULE',
  PROMOTION_CHANGED_MODULE = 'PROMOTION_CHANGED_MODULE',
}

/** Represents the target of the link */
export enum NotificationLinkTarget {
  NEW_TAB = 'NEW_TAB',
  SAME_TAB = 'SAME_TAB',
}

/** Represents the link type */
export enum NotificationLinkType {
  ANCHOR = 'ANCHOR',
  APP_DOWNLOAD_LINK = 'APP_DOWNLOAD_LINK',
  BUTTON = 'BUTTON',
  FLOATING_ACTION_BUTTON = 'FLOATING_ACTION_BUTTON',
  PRIMARY_BUTTON = 'PRIMARY_BUTTON',
  SECONDARY_BUTTON = 'SECONDARY_BUTTON',
  TERTIARY_BUTTON = 'TERTIARY_BUTTON',
}

export enum NotificationLocation {
  AFTER_HEADER = 'AFTER_HEADER',
  AFTER_WIZARD = 'AFTER_WIZARD',
  FOOTER = 'FOOTER',
  IN_PAGE = 'IN_PAGE',
  IN_PAGE_AD = 'IN_PAGE_AD',
  LEGAL = 'LEGAL',
  POPUP = 'POPUP',
  PRE_HEADER = 'PRE_HEADER',
}

export enum NotificationLocationOnPage {
  AFTER_HEADER = 'AFTER_HEADER',
  AFTER_WIZARD = 'AFTER_WIZARD',
  ERROR = 'ERROR',
  FOOTER = 'FOOTER',
  FULL_PAGE = 'FULL_PAGE',
  IN_MODAL = 'IN_MODAL',
  IN_MODULE = 'IN_MODULE',
  IN_PAGE = 'IN_PAGE',
  IN_PAGE_AD = 'IN_PAGE_AD',
  LEGAL = 'LEGAL',
  POPUP = 'POPUP',
  PRE_HEADER = 'PRE_HEADER',
}

/** Enumeration of possible layout types */
export enum NotificationMessageCardLayout {
  ICON_ON_SIDE = 'ICON_ON_SIDE',
  ICON_ON_TOP = 'ICON_ON_TOP',
  WITH_BORDER = 'WITH_BORDER',
}

/** The display type of the Customer notification message */
export enum NotificationMessageDisplayType {
  /** Display the message for the form */
  FORM = 'FORM',
  /** Dislay message on the page level, eg: fly-in message on the page */
  PAGE = 'PAGE',
}

/** The level type of the Customer notification message */
export enum NotificationMessageLevel {
  /** Type of error for the message */
  ERROR = 'ERROR',
  /** Type of info for the message */
  INFO = 'INFO',
  /** Type of success for the message */
  SUCCESS = 'SUCCESS',
  /** Type of warning for the message */
  WARNING = 'WARNING',
}

export enum NotificationMessageType {
  /** INVALID_INPUT message */
  INVALID_INPUT = 'INVALID_INPUT',
  /** SERVICE_ERROR message */
  SERVICE_ERROR = 'SERVICE_ERROR',
  /** SUCCESS message */
  SUCCESS = 'SUCCESS',
}

/** Optional information to get a better contextual customer notification */
export interface NotificationOptionalContextInput {
  /** the optional field containing a link to an additional contextual resource */
  additionalLink?: InputMaybe<Scalars['String']>;
  /** optional data to calculate loyalty awards for one key cash */
  calculateAward?: InputMaybe<CalculateAwardInput>;
  /** the optional field containing an error token, triggering the retrieval of an error message */
  errorToken?: InputMaybe<Scalars['String']>;
  /** the optional field containing data to display messages inside a module */
  inModuleMessage?: InputMaybe<NotificationInModuleMessageInput>;
  /** itinerary number */
  itineraryNumber?: InputMaybe<Scalars['String']>;
  /** list of journey criteria items */
  journeyCriterias?: InputMaybe<Array<NotificationOptionalContextJourneyCriteriaInput>>;
  /** refer a friend program's data */
  rafInfo?: InputMaybe<NotificationRafInfoInput>;
  /** the optional URL input field to retrieve extra url information, such as deep linking url for the mobile app download notification */
  referer?: InputMaybe<Scalars['URL']>;
  /** the optional field containing the checkout session id to be able to measure key metrics */
  sessionId?: InputMaybe<Scalars['String']>;
  /** the optional field containing the token to retrieve the travel information */
  travelApiId?: InputMaybe<Scalars['String']>;
  /** trip folder id */
  tripFolderId?: InputMaybe<Scalars['String']>;
  /** trip item id */
  tripItemId?: InputMaybe<Scalars['String']>;
  /** optional email field used to query user information when there is no session token available */
  userEmail?: InputMaybe<Scalars['String']>;
}

/** Journey criteria such as location gaia id and travel date ranges */
export interface NotificationOptionalContextJourneyCriteriaFiltersInput {
  /** airport code */
  airlinesFilter?: InputMaybe<Array<Scalars['String']>>;
  /** flight amenities */
  amenitiesFilter?: InputMaybe<Array<AmenityFilter>>;
  /** arrival time */
  arrivalTimeFilter?: InputMaybe<Array<FlightsTimePeriodOfDay>>;
  /** departure time */
  departureTimeFilter?: InputMaybe<Array<FlightsTimePeriodOfDay>>;
  /** number of stops */
  numberOfStopsFilter?: InputMaybe<Array<Scalars['Int']>>;
}

/** Journey criteria such as location gaia id and travel date ranges */
export interface NotificationOptionalContextJourneyCriteriaInput {
  /** cabin class */
  cabinClass?: InputMaybe<FlightsCabinClass>;
  /** start date and end date of the trip */
  dateRange?: InputMaybe<DateRangeInput>;
  /** destination information */
  destination?: InputMaybe<NotificationOptionalContextJourneyCriteriaLocationInput>;
  /** trip filters */
  filter?: InputMaybe<Array<NotificationOptionalContextJourneyCriteriaFiltersInput>>;
  /** origin information */
  origin?: InputMaybe<NotificationOptionalContextJourneyCriteriaLocationInput>;
  /** trip schedule changes status */
  scheduleChangeStatus?: InputMaybe<TripScheduleChangeStatus>;
  /** traveler details */
  travelerDetail?: InputMaybe<Array<TravelerDetailsInput>>;
  /** trip type */
  tripType?: InputMaybe<FlightsTripType>;
  /** trips data */
  tripsData?: InputMaybe<TripsDataInput>;
}

/** Journey criteria such as location gaia id and travel date ranges */
export interface NotificationOptionalContextJourneyCriteriaLocationInput {
  /** airport code */
  airportTLA?: InputMaybe<Scalars['String']>;
  /** property id */
  propertyId?: InputMaybe<Scalars['String']>;
  /** regionId number */
  regionId?: InputMaybe<Scalars['String']>;
}

/** The style to apply to phrase links */
export enum NotificationPhraseLinkStyle {
  FLOATING_ACTION_BUTTON = 'FLOATING_ACTION_BUTTON',
  PRIMARY_BUTTON = 'PRIMARY_BUTTON',
  SECONDARY_BUTTON = 'SECONDARY_BUTTON',
  TERTIARY_BUTTON = 'TERTIARY_BUTTON',
}

/** The theme to apply to phrase links */
export enum NotificationPhraseLinkTheme {
  DEFAULT = 'DEFAULT',
  INVERSE = 'INVERSE',
}

/** The text style to apply to strings */
export enum NotificationPhrasePartStyle {
  /** Italic styling */
  EMPHASIS = 'EMPHASIS',
  /** Bold styling */
  IMPORTANT = 'IMPORTANT',
  /** Medium styling */
  MEDIUM = 'MEDIUM',
  /** Represents no style or regular text */
  STANDARD = 'STANDARD',
}

/** Represent notification preference */
export enum NotificationPreferenceType {
  EMAIL = 'EMAIL',
  PUSH = 'PUSH',
}

/** Type encapsulating the data needed for raf program */
export interface NotificationRafInfoInput {
  /** Represents the type of the login if its signin or signup */
  rafLoginScenario?: InputMaybe<IdentityLoginScenario>;
  /** Represents the raf customerPlacementId value in app download link */
  rafPlacementId?: InputMaybe<Scalars['String']>;
  /** Represents the friend's referral code */
  refcode: Scalars['String'];
}

/** Represents the attributes on a notification that could be changed after an interaction */
export interface NotificationSpecificationsInput {
  /** Set to true when notification is dismissed */
  dismiss?: InputMaybe<Scalars['Boolean']>;
  /** Notification id */
  id?: InputMaybe<Scalars['String']>;
  /** Set to true when notification is read */
  read?: InputMaybe<Scalars['Boolean']>;
  /** Set to true when notification is seen */
  seen?: InputMaybe<Scalars['Boolean']>;
}

export enum NotificationState {
  READ = 'READ',
  SEEN = 'SEEN',
  UNKNOWN = 'UNKNOWN',
  UNSEEN = 'UNSEEN',
}

export enum NotificationSubType {
  COUPON_CAMPAIGN = 'COUPON_CAMPAIGN',
  DEFAULT = 'DEFAULT',
}

export enum NotificationType {
  ALERT = 'ALERT',
  APP_DOWNLOAD = 'APP_DOWNLOAD',
  APP_HERO = 'APP_HERO',
  BOTTOM_SHEET = 'BOTTOM_SHEET',
  BOTTOM_SHEET_COBRAND = 'BOTTOM_SHEET_COBRAND',
  CENTERED_SHEET = 'CENTERED_SHEET',
  CITI_COBRAND = 'CITI_COBRAND',
  CITI_COBRAND_VERTICAL = 'CITI_COBRAND_VERTICAL',
  CLEANLINESS = 'CLEANLINESS',
  CONFIGURABLE = 'CONFIGURABLE',
  ERROR = 'ERROR',
  FULL_PAGE = 'FULL_PAGE',
  FULL_SHEET = 'FULL_SHEET',
  FULL_SHEET_MEDIA = 'FULL_SHEET_MEDIA',
  GENERIC = 'GENERIC',
  HEADER = 'HEADER',
  INBOX = 'INBOX',
  MAD_MARQUEE = 'MAD_MARQUEE',
  NONE = 'NONE',
  ONETRUST = 'ONETRUST',
  ONE_KEY = 'ONE_KEY',
  OSANO = 'OSANO',
  POPOVER = 'POPOVER',
  RAF_BANNER = 'RAF_BANNER',
  TAKEOVER = 'TAKEOVER',
  TRAVEL_ADVISORY = 'TRAVEL_ADVISORY',
  TRUST_MSG_BANNER = 'TRUST_MSG_BANNER',
  UNRECOVERABLE_ERROR = 'UNRECOVERABLE_ERROR',
}

export enum NotificationUserActionType {
  DELETE = 'DELETE',
  MARK_AS_READ = 'MARK_AS_READ',
  MARK_AS_UNREAD = 'MARK_AS_UNREAD',
  UNKNOWN = 'UNKNOWN',
}

/** Represents the the user input for customer notification mutation */
export interface NotificationUserInput {
  /** Represents list of customer notification user input */
  inputs: Array<NotificationUserInputElementInput>;
}

/** Represents customer notification user input */
export interface NotificationUserInputElementInput {
  /** Represents the type of customer notification user input */
  type: Scalars['String'];
  /** Represents the value of customer notification user input */
  value: Scalars['String'];
}

/** This enum scope is to communicate to client if the banner should be render as a CAROUSEL or GRID */
export enum NotificationView {
  CAROUSEL = 'CAROUSEL',
  COLLAPSIBLE = 'COLLAPSIBLE',
  GRID = 'GRID',
  GRID_EXTENDED_PADDING = 'GRID_EXTENDED_PADDING',
}

export enum NotificationsType {
  ALL = 'ALL',
}

/** Type used during a product search to specify a given numeric value like the number of stars for a hotel. */
export interface NumberValueInput {
  id: Scalars['String'];
  value: Scalars['Int'];
}

export enum OfferAttributeType {
  FREE_BREAKFAST = 'FREE_BREAKFAST',
  FREE_CANCELLATION = 'FREE_CANCELLATION',
  NO_CC_REQUIRED = 'NO_CC_REQUIRED',
  PAYMENT_CHOICE = 'PAYMENT_CHOICE',
  VIP = 'VIP',
}

export interface OfferIdentityInput {
  /** Type of the offer details whether token or id */
  type: OfferIdentityType;
  /** The value of the identifier */
  value: Scalars['String'];
}

/** The identity to get or update insurtech offers could be both */
export enum OfferIdentityType {
  EG_OFFER_ID = 'EG_OFFER_ID',
  EG_OFFER_TOKEN = 'EG_OFFER_TOKEN',
}

/**
 * Represents EG Travel Platform API, consists of a productLine enumeration and a token.
 * https://confluence.expedia.biz/display/RPT/RFC-62-EG+-+OfferToken+-+guidelines+for+Product+Line+SPIs
 */
export interface OfferTokenInput {
  /** ProductLine associated with an Offer Token */
  lineOfBusiness: LineOfBusinessDomain;
  /** Encoded offer token string used to identify a specific product offer for purchase */
  token: Scalars['String'];
}

/** Input type for fetching the Inquiry form */
export interface OffersInquiryFormInput {
  petsIncluded?: InputMaybe<Scalars['Boolean']>;
  primaryPropertyCriteriaInput?: InputMaybe<PrimaryPropertyCriteriaInput>;
}

export enum OffersInquiryProminence {
  HIGH = 'HIGH',
  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
}

export interface OffersRecommendationAvailabilityFilterInput {
  dates?: InputMaybe<OptionalDateTimeRangeInput>;
  destination?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<Scalars['String']>;
  travelMemberGroups?: InputMaybe<Array<TravelMemberGroupInput>>;
}

export enum OffersRecommendationContainerType {
  CAROUSEL = 'CAROUSEL',
  GRID = 'GRID',
}

export interface OffersRecommendationProductIdentifierInput {
  lineOfBusiness: LineOfBusinessDomain;
  productId: Scalars['String'];
}

export enum OffersRecommendationStrategy {
  ALTERNATE = 'ALTERNATE',
  ATTACH = 'ATTACH',
  CO_CLICK = 'CO_CLICK',
  NEARBY = 'NEARBY',
  POPULAR = 'POPULAR',
  TRENDING = 'TRENDING',
}

export interface OffsetInput {
  pitId: Scalars['String'];
  pitKeepAlive: Scalars['String'];
}

export interface OnDevicePasswordStorageRequestInput {
  atoInputs?: InputMaybe<Array<IdentityAccountTakeOverInput>>;
  emailInput: Scalars['String'];
  password: Scalars['String'];
}

export enum OnboardStep {
  CURRENCY = 'CURRENCY',
  LANDING = 'LANDING',
  PARTNER = 'PARTNER',
  PAYMENT = 'PAYMENT',
  PAYMENT_ACCOUNT = 'PAYMENT_ACCOUNT',
  PAYMENT_PROFILE = 'PAYMENT_PROFILE',
  PRODUCT = 'PRODUCT',
  REVIEW = 'REVIEW',
  TAX = 'TAX',
}

export interface OnboardingContext {
  onboardingSource: Scalars['String'];
}

/** Input for onboarding a partner */
export interface OnboardingInput {
  /** Current step */
  currentStep?: InputMaybe<Scalars['Int']>;
  /** Last payment country */
  lastPaymentCountry?: InputMaybe<Scalars['String']>;
  /** New partner flag */
  newPartner: Scalars['Boolean'];
  /** Partner account id */
  partnerAccountId: Scalars['String'];
  /** Payment account id */
  paymentAccountId: Scalars['String'];
  /** Payment profile id */
  paymentProfileId: Scalars['String'];
  /** Product ids to onboard */
  productIdsToOnboard: Array<Scalars['String']>;
  /** Selected currency for the partner account */
  selectedCurrency?: InputMaybe<Scalars['String']>;
  /** Tax profile id */
  taxProfileId?: InputMaybe<Scalars['String']>;
  /** Tax step flag */
  taxStep?: InputMaybe<Scalars['Boolean']>;
}

export interface OneCPMFOPItemInput {
  id: Scalars['String'];
  paymentMethod: PaymentMethodType;
  paymentMethodConfiguration?: InputMaybe<OneCPMPaymentMethodConfigurationInput>;
  state: Scalars['String'];
}

export interface OneCPMPaymentCreditCardConfigurationInput {
  bin?: InputMaybe<Scalars['String']>;
  challenge3DsResult?: InputMaybe<Scalars['String']>;
  encodedBrowserMetadata?: InputMaybe<Scalars['String']>;
  etzToken?: InputMaybe<Scalars['String']>;
  storageAuthorized?: InputMaybe<Scalars['Boolean']>;
  storedPaymentInstrumentId?: InputMaybe<Scalars['String']>;
  subMethodUrn?: InputMaybe<Scalars['String']>;
}

export interface OneCPMPaymentMethodConfigurationInput {
  creditCardConfiguration: OneCPMPaymentCreditCardConfigurationInput;
}

/** EG One Identity On-boarding actions for clients */
export enum OneIdentityOnboardingClientAction {
  IDENTITY_MERGE = 'IDENTITY_MERGE',
  LOGOUT = 'LOGOUT',
  NONE = 'NONE',
  NONE_JOURNEY_IS_COMPLETE = 'NONE_JOURNEY_IS_COMPLETE',
}

/** Represents the runtime information provided by clients for creating OKC context in EM call */
export interface OneKeyCashContextInput {
  okcApplicable: Scalars['Boolean'];
  /** Represents the condition based on which OKC should be retrieved - user | property | booking */
  okcCriteria: Scalars['String'];
  siteFees?: InputMaybe<Scalars['String']>;
  sitePrice?: InputMaybe<Scalars['String']>;
  siteTaxes?: InputMaybe<Scalars['String']>;
  transactionCurrency?: InputMaybe<Scalars['String']>;
  tripEndDate?: InputMaybe<Scalars['String']>;
  tripStartDate?: InputMaybe<Scalars['String']>;
  userEmail?: InputMaybe<Scalars['String']>;
}

/** Used to pass oneKeyCash and its currency code */
export interface OneKeyCashLoginCardDataInput {
  /** Represents oneKeyCash value */
  oneKeyCash: Scalars['String'];
}

export enum OneKeyUniversalOnboardingOperationStatus {
  FAILED = 'FAILED',
  FAILED_BLOCKING = 'FAILED_BLOCKING',
  SUCCEEDED = 'SUCCEEDED',
  UNKNOWN_OPERATION = 'UNKNOWN_OPERATION',
}

export interface OpenIdConnectInput {
  authorizationCode?: InputMaybe<Scalars['String']>;
  clientId?: InputMaybe<Scalars['String']>;
  codeVerifier?: InputMaybe<Scalars['String']>;
  redirectUri?: InputMaybe<Scalars['String']>;
}

export enum Operation {
  ADDITION = 'ADDITION',
  MULTIPLICATION = 'MULTIPLICATION',
}

export enum OperationStatus {
  FAILURE = 'FAILURE',
  INVALID_INPUT = 'INVALID_INPUT',
  SUCCESS = 'SUCCESS',
}

export enum OperationType {
  SMART_FORM_LOAD = 'SMART_FORM_LOAD',
  SMART_FORM_SUBMIT = 'SMART_FORM_SUBMIT',
}

/** In order to pass any additional parameters */
export interface OptionalContextInput {
  /** Indicates if user is on desktop dropdown view */
  dropdownView?: InputMaybe<Scalars['Boolean']>;
  /** Indicates if client is in dark mode */
  isDarkMode?: InputMaybe<Scalars['Boolean']>;
  /** Indicates if message count is enabled or not for entry point */
  messageCountEnabled?: InputMaybe<Scalars['Boolean']>;
  /** If app user has enabled push notification in the device */
  pushEnabled?: InputMaybe<Scalars['Boolean']>;
  /** Indicates trip related info that needs to be passed */
  tripInfo?: InputMaybe<TripInfoContextInput>;
}

/** A range of dates & times, without timezone support, from a starting date & time to an ending date & time */
export interface OptionalDateTimeRangeInput {
  /** Optional terminal date & time in this range */
  end?: InputMaybe<DateTimeInput>;
  /** Optional starting date & time in this range */
  start?: InputMaybe<DateTimeInput>;
}

export interface OrderInfoInput {
  orderId: Scalars['String'];
  orderLine?: InputMaybe<Scalars['String']>;
}

export enum OrderStatus {
  FAILED = 'FAILED',
  INVALID = 'INVALID',
  PENDING = 'PENDING',
  SUCCESS = 'SUCCESS',
}

/** Possible values for UITK mark's orientation prop */
export enum Orientation {
  /** Landscape orientation */
  LANDSCAPE = 'LANDSCAPE',
  /** Portrait orientation */
  PORTRAIT = 'PORTRAIT',
}

/** Supported EGDSText Overflow types */
export enum Overflow {
  TRUNCATE = 'TRUNCATE',
  TRUNCATE_TWO_LINES = 'TRUNCATE_TWO_LINES',
}

export interface PackageDestinationContextInput {
  placeCoordinates?: InputMaybe<CoordinatesInput>;
  placeId: DiscoveryPlaceIdInput;
}

export interface PackageFiltersInput {
  flightClass?: InputMaybe<Scalars['String']>;
  starRating?: InputMaybe<Scalars['String']>;
  tripLengthInNights?: InputMaybe<Scalars['String']>;
}

/** Package location */
export interface PackageLocationInput {
  airportCode: Scalars['String'];
  /** The Geo location of the region to search */
  coordinates?: InputMaybe<CoordinatesInput>;
  regionId?: InputMaybe<Scalars['String']>;
  /** The name of the region */
  regionName?: InputMaybe<Scalars['String']>;
}

/** Minimum set of data used to retrieve content about a package */
export interface PackageNaturalKeyInput {
  offerToken: Scalars['String'];
}

export enum PackageOfferingType {
  FLIGHT_CAR = 'FLIGHT_CAR',
  FLIGHT_HOTEL = 'FLIGHT_HOTEL',
  FLIGHT_HOTEL_CAR = 'FLIGHT_HOTEL_CAR',
  HOTEL_CAR = 'HOTEL_CAR',
}

/** Represents the search criteria with which customers searched for packages */
export interface PackageSearchCriteriaInput {
  primary: PrimaryPackageSearchCriteriaInput;
  secondary?: InputMaybe<ShoppingSearchCriteriaInput>;
}

export enum PackageSort {
  PRICE_HIGH_TO_LOW = 'PRICE_HIGH_TO_LOW',
  PRICE_LOW_TO_HIGH = 'PRICE_LOW_TO_HIGH',
  RECOMMENDED = 'RECOMMENDED',
}

export enum PackageType {
  FLIGHT_CAR = 'FLIGHT_CAR',
  FLIGHT_HOTEL = 'FLIGHT_HOTEL',
  FLIGHT_HOTEL_CAR = 'FLIGHT_HOTEL_CAR',
  HOTEL_ACTIVITY = 'HOTEL_ACTIVITY',
  HOTEL_CAR = 'HOTEL_CAR',
}

export interface PackageUIActivityHeaderPrimerInput {
  productType: MishopUIProductType;
}

export interface PackageUICarHeaderPrimerInput {
  productType: MishopUIProductType;
}

export interface PackageUIFlightHeaderPrimerInput {
  productType: MishopUIProductType;
}

export interface PackageUIGroundTransferHeaderPrimerInput {
  productType: MishopUIProductType;
}

/** The inputs required for the messaging cards */
export interface PackageUIMessagingCardInputsInput {
  destinationTla?: InputMaybe<Scalars['String']>;
  hotelId?: InputMaybe<Scalars['String']>;
}

/** The enum for types of MishopUIMessagingCards. Eg: Jumplink card. */
export enum PackageUIMessagingCardType {
  GT_JUMP_LINK = 'GT_JUMP_LINK',
  INVALID = 'INVALID',
}

/** Contains the necessary data to render banner for a changed product */
export interface PackageUIProductChangedBannerPrimerInput {
  currentPackageOfferId: PackageNaturalKeyInput;
  previousOffers: MultiItemProductsInput;
  previousPackageOfferId: PackageNaturalKeyInput;
}

/** Contains necessary data for loading product content */
export interface PackageUIProductContentInput {
  carContentPrimer?: InputMaybe<MishopUICarContentPrimerInput>;
  propertyContentPrimer?: InputMaybe<MishopUIPropertyContentPrimerInput>;
}

/** Information needed to render the prebundle package product header */
export interface PackageUIProductHeaderPrimerInput {
  activityHeaderPrimer?: InputMaybe<PackageUIActivityHeaderPrimerInput>;
  carHeaderPrimer?: InputMaybe<PackageUICarHeaderPrimerInput>;
  flightHeaderPrimer?: InputMaybe<PackageUIFlightHeaderPrimerInput>;
  groundTransferHeaderPrimer?: InputMaybe<PackageUIGroundTransferHeaderPrimerInput>;
  propertyHeaderPrimer?: InputMaybe<PackageUIPropertyHeaderPrimerInput>;
}

export interface PackageUIPropertyHeaderPrimerInput {
  productType: MishopUIProductType;
}

/** Inputs for the destinationGroup query */
export interface PackagesInputCriteriaInput {
  /** Strategy for place relationship */
  inputContext: PackagesListingInputContextInput;
}

export interface PackagesListingInputContextInput {
  configurationId: Scalars['String'];
  destination: PackageDestinationContextInput;
  packageFilters?: InputMaybe<PackageFiltersInput>;
  packageType: PackageOfferingType;
  pageId: Scalars['String'];
  strategy?: InputMaybe<Strategy>;
}

export enum Page {
  ACTIVITY_SEARCH = 'ACTIVITY_SEARCH',
  APP_LAUNCHSCREEN = 'APP_LAUNCHSCREEN',
  CAR_INFOSITE = 'CAR_INFOSITE',
  CAR_SEARCH = 'CAR_SEARCH',
  CONFIRMATION = 'CONFIRMATION',
  FLIGHT_SEARCH = 'FLIGHT_SEARCH',
  HOME_PAGE = 'HOME_PAGE',
  HOTEL_INFOSITE = 'HOTEL_INFOSITE',
  HOTEL_SEARCH = 'HOTEL_SEARCH',
  INVITE_LANDING_PAGE = 'INVITE_LANDING_PAGE',
  LANDING_PAGE = 'LANDING_PAGE',
  PRODUCT_DETAILS_PAGE = 'PRODUCT_DETAILS_PAGE',
  PUBLIC_TRIP_BOARD = 'PUBLIC_TRIP_BOARD',
  STOREFRONT = 'STOREFRONT',
  TRIPS = 'TRIPS',
  TRIPS_FILTERED = 'TRIPS_FILTERED',
  TRIP_FIND_ITINERARY = 'TRIP_FIND_ITINERARY',
  TRIP_FIND_ITINERARY_RESULT = 'TRIP_FIND_ITINERARY_RESULT',
  TRIP_ITEM_DETAILS = 'TRIP_ITEM_DETAILS',
  TRIP_ITEM_DETAILS_CANCELLED = 'TRIP_ITEM_DETAILS_CANCELLED',
  TRIP_ITEM_ESSENTIAL_INFO = 'TRIP_ITEM_ESSENTIAL_INFO',
  TRIP_ITEM_ITINERARY = 'TRIP_ITEM_ITINERARY',
  TRIP_ITEM_MANAGE_BOOKING = 'TRIP_ITEM_MANAGE_BOOKING',
  TRIP_ITEM_PRICING_REWARDS = 'TRIP_ITEM_PRICING_REWARDS',
  TRIP_ITEM_RECEIPT = 'TRIP_ITEM_RECEIPT',
  TRIP_ITEM_VOUCHER = 'TRIP_ITEM_VOUCHER',
  TRIP_ITEM_VOUCHER_PRINT = 'TRIP_ITEM_VOUCHER_PRINT',
  TRIP_MANAGE_GUESTS = 'TRIP_MANAGE_GUESTS',
  TRIP_OVERVIEW = 'TRIP_OVERVIEW',
  TRIP_OVERVIEW_ITINERARY = 'TRIP_OVERVIEW_ITINERARY',
  TRIP_SEARCH_BOOKING = 'TRIP_SEARCH_BOOKING',
  TRIP_SEARCH_BOOKING_RESULT = 'TRIP_SEARCH_BOOKING_RESULT',
  UDP = 'UDP',
}

/** Optional custom context information about the page where the query results will eventually be rendered */
export interface PageContextInput {
  collectionItemClickthrough?: InputMaybe<CollectionItemClickthrough>;
  componentName?: InputMaybe<Scalars['String']>;
  propertySearch?: InputMaybe<PropertySearchCriteriaInput>;
}

/** Page identity */
export enum PageLocation {
  /** Cancel For Any Reason assurance details page that comes after LOB details pages */
  CFAR_DETAILS = 'CFAR_DETAILS',
  /** All checkout related pages */
  CHECKOUT = 'CHECKOUT',
  /** Checkout error pages for all LOBs */
  CHECKOUT_ERROR = 'CHECKOUT_ERROR',
  /** Order confirmation pages for all LOBs */
  CONFIRMATION = 'CONFIRMATION',
  /** All product detail pages are identified as DETAILS */
  DETAILS = 'DETAILS',
  /** All landing, launch, published and any other page that will lead a user down to a search or detail page regardless of LOB */
  ENTRY = 'ENTRY',
  /** Pages that are not in the main shopping flow or that show up all across the flow such as Ads, Recommendation, Urgency, Scratchpad, etc. */
  FEATURES = 'FEATURES',
  /** Insurance details page that comes after LOB details pages */
  INSURANCE_DETAILS = 'INSURANCE_DETAILS',
  /** The Itinerary page provides information about booked, saved, and unsaved trips, as well as recommendations for activities based on ChatGPT. */
  ITINERARY = 'ITINERARY',
  /** Payment error pages for all LOBs */
  PAYMENT_ERROR = 'PAYMENT_ERROR',
  /** Post booking pages including itin, trip summary, trip details, customer service etc */
  POST_BOOKING = 'POST_BOOKING',
  /** All LOB search result pages are identified as SEARCH_RESULTS */
  SEARCH_RESULTS = 'SEARCH_RESULTS',
  /** All pages that are not customer facing, that are for internal system or monitoring such as isWorking, health check, dev tools page, etc */
  SYSTEM = 'SYSTEM',
  /** User pages including sign-in, my account and rewards */
  USER = 'USER',
}

/** Used to pass the page context for the OneKeyLoyaltyBanner query */
export interface PageLocationContextInput {
  flightPage?: InputMaybe<FlightPage>;
}

export interface PageMetadataInput {
  offsetMetadata: OffsetInput;
  offsetValue: Scalars['String'];
}

/** Input for travelGuidePageContextInput pageType parameter */
export enum PageType {
  DISCOVER_TAB = 'DISCOVER_TAB',
  HOME_PAGE = 'HOME_PAGE',
  TRAVEL_GUIDE = 'TRAVEL_GUIDE',
  TRIP_OVERVIEW = 'TRIP_OVERVIEW',
  WISH_LIST = 'WISH_LIST',
}

/** Represents the Message Pagination */
export interface PaginationDetailsInput {
  /** Represents preview page pagination next index */
  next?: InputMaybe<Scalars['Int']>;
  /** Represents preview page size */
  pageSize?: InputMaybe<Scalars['Int']>;
  /** Represents preview page pagination previous index */
  previous?: InputMaybe<Scalars['Int']>;
}

/** Separate a large list of results into multiple sublists */
export interface PaginationInput {
  /** Number of results to get past the starting index */
  size?: InputMaybe<Scalars['Int']>;
  /** The inclusive 0-based starting index of the results. Defaults to 0 */
  startingIndex?: InputMaybe<Scalars['Int']>;
}

/** Type of pagination options */
export enum PaginationType {
  CTA_BUTTON = 'CTA_BUTTON',
  INFINITE_SCROLL = 'INFINITE_SCROLL',
}

/** Represents input data related to a participant */
export interface ParticipantInput {
  deviceToken?: InputMaybe<Scalars['String']>;
  participantId?: InputMaybe<Scalars['String']>;
  /** Represents subscriptionId received from experience-api-conversation, it will be passed in conversation attributes to publish messages. */
  subscriptionId?: InputMaybe<Scalars['String']>;
}

export enum ParticipantState {
  EXPIRED = 'EXPIRED',
  INVITED = 'INVITED',
  JOINED = 'JOINED',
  LEFT = 'LEFT',
}

export interface PartnerAddressQueryParamsInput {
  addressLine1: Scalars['String'];
}

/** used to define financial profile kep map configurations */
export interface PartnerBillingProfileKeyMapInput {
  productId: Scalars['String'];
  resourceId: Scalars['String'];
}

export interface PartnerContactQueryParamsInput {
  firstName: Scalars['String'];
}

export interface PartnerContextInput {
  detailsSiteConfiguration?: InputMaybe<TravelStoreV1CarDetailsInput>;
  partnerAccountId: Scalars['String'];
  searchSiteConfiguration?: InputMaybe<TravelStoreV1CarSearchInput>;
}

export enum PartnerErrorType {
  BAD_REQUEST = 'BAD_REQUEST',
  BAD_USER_INPUT = 'BAD_USER_INPUT',
  ENTITY_NOT_FOUND = 'ENTITY_NOT_FOUND',
  FORBIDDEN = 'FORBIDDEN',
  INTERNAL_SERVER_ERROR = 'INTERNAL_SERVER_ERROR',
  UNAUTHORIZED = 'UNAUTHORIZED',
  UNKNOWN = 'UNKNOWN',
}

export enum PartnerPaymentTextType {
  WIRE_CHECK_CURRENCY = 'WIRE_CHECK_CURRENCY',
}

/** PartnerPayments common values */
export interface PartnerPaymentsCommonInput {
  pagination: PaginationInput;
}

/** Type of partner summary card */
export enum PartnerSummaryCardType {
  PAYMENT_PROFILES = 'PAYMENT_PROFILES',
  PRODUCTS = 'PRODUCTS',
}

export enum PasswordWithStrengthMeterInputStrength {
  STRONG = 'STRONG',
  VERY_STRONG = 'VERY_STRONG',
  WEAK = 'WEAK',
}

export enum PasswordWithStrengthMeterProgressBarTheme {
  MUTED = 'MUTED',
  POSITIVE = 'POSITIVE',
}

export interface PayButtonConfigurationInput {
  clientDetails: ClientDetailsInput;
  sessionDetails: SessionDetailsInput;
}

export enum PayButtonSourceType {
  SCRIPT = 'SCRIPT',
  URL = 'URL',
}

/** Represents payable amount information */
export interface PayableAmountInput {
  amount: Scalars['Int'];
  currency: PaymentCurrencyInput;
  decimalPlaces: Scalars['Int'];
  formattedAmount?: InputMaybe<Scalars['String']>;
}

export enum PaymentAccountAvatarSize {
  LARGE = 'LARGE',
  MEDIUM = 'MEDIUM',
}

/** PaymentAccountRequest */
export interface PaymentAccountRequestInput {
  accountName?: InputMaybe<Scalars['String']>;
  accountNumber?: InputMaybe<Scalars['String']>;
  bankAccountType?: InputMaybe<BankAccountType>;
  branchNumber?: InputMaybe<Scalars['String']>;
  countryRegion?: InputMaybe<Scalars['String']>;
  currency: Scalars['String'];
  fullName?: InputMaybe<Scalars['String']>;
  isDirectDebit?: InputMaybe<Scalars['Boolean']>;
  nickname?: InputMaybe<Scalars['String']>;
  paymentAccountType: PaymentAccountType;
  paymentProfileId: Scalars['String'];
  routingNumber?: InputMaybe<Scalars['String']>;
}

export enum PaymentAccountType {
  BANK_ACCOUNT = 'BANK_ACCOUNT',
  WIRE_CHECK = 'WIRE_CHECK',
}

export interface PaymentAdyenConfigurationInput {
  domainUrl?: InputMaybe<Scalars['String']>;
  onScreenPopupResult?: InputMaybe<Scalars['String']>;
  stateData?: InputMaybe<Scalars['String']>;
}

export interface PaymentAffirmConfigurationInput {
  checkoutId?: InputMaybe<Scalars['String']>;
  failureReason?: InputMaybe<Scalars['String']>;
  providerConfirmationStatus?: InputMaybe<Scalars['String']>;
}

export interface PaymentAfterpayConfigurationInput {
  authToken?: InputMaybe<Scalars['String']>;
  edgeToken?: InputMaybe<Scalars['String']>;
  errorCode?: InputMaybe<Scalars['String']>;
  errorStatusCode?: InputMaybe<Scalars['String']>;
  orderToken?: InputMaybe<Scalars['String']>;
  providerConfirmationStatus?: InputMaybe<Scalars['String']>;
}

export interface PaymentApplePayAuthorisationInput {
  token: PaymentApplePayTokenDataInput;
}

export interface PaymentApplePayConfigurationInput {
  merchantValidation?: InputMaybe<PaymentApplePayMerchantValidationInput>;
  paymentAuthorisation?: InputMaybe<PaymentApplePayAuthorisationInput>;
}

export interface PaymentApplePayMerchantValidationInput {
  initiativeContext: Scalars['String'];
  validationUrl: Scalars['String'];
}

export interface PaymentApplePayMethodInput {
  displayName: Scalars['String'];
}

export interface PaymentApplePayTokenDataInput {
  paymentData: Scalars['String'];
  paymentMethod: PaymentApplePayMethodInput;
}

export interface PaymentAssistBookingInput {
  agentEmailAddress?: InputMaybe<Scalars['String']>;
  amount: Scalars['Float'];
  conversationId?: InputMaybe<Scalars['String']>;
  conversationPartnerId?: InputMaybe<Scalars['String']>;
  currencyCode: Scalars['String'];
  existingPaymentInstrumentId?: InputMaybe<Scalars['String']>;
  expUserId?: InputMaybe<Scalars['String']>;
  inventoryType: Scalars['String'];
  languageId?: InputMaybe<Scalars['String']>;
  lineOfBusinessType: LineOfBusinessType;
  paymentAssistTransactionType: PaymentAssistTransactionTypeInput;
  paymentType: AgencyBusinessModel;
  supplierId?: InputMaybe<Scalars['String']>;
  transactionId?: InputMaybe<Scalars['String']>;
  tuid?: InputMaybe<Scalars['String']>;
}

export enum PaymentAssistCardTypeInput {
  NEW = 'NEW',
  ORIGINAL = 'ORIGINAL',
  SAVED = 'SAVED',
}

export enum PaymentAssistChatMessageType {
  CHALLENGE_FORM = 'CHALLENGE_FORM',
  HOW_TO_PAY = 'HOW_TO_PAY',
  PAYMENT_DETAILS_SUBMITTED = 'PAYMENT_DETAILS_SUBMITTED',
  PAYMENT_FORM = 'PAYMENT_FORM',
}

export enum PaymentAssistTransactionTypeInput {
  CHARGE = 'CHARGE',
  REFUND = 'REFUND',
}

export enum PaymentAssistTransactionTypeOutput {
  CHARGE = 'CHARGE',
  REFUND = 'REFUND',
}

export interface PaymentBraintreeConfigurationInput {
  nonce?: InputMaybe<Scalars['String']>;
}

export interface PaymentCheckoutIdentifierInput {
  sessionId?: InputMaybe<Scalars['String']>;
  sessionToken?: InputMaybe<Scalars['String']>;
}

export interface PaymentConfigurationItemInput {
  entryUrn: PaymentEntryURN;
  key: Scalars['String'];
  value: Scalars['String'];
}

export interface PaymentContextualInfoInput {
  bin?: InputMaybe<Scalars['String']>;
  encodedBrowserMetadata?: InputMaybe<Scalars['String']>;
  etzToken?: InputMaybe<Scalars['String']>;
  providerConfirmationStatus?: InputMaybe<Scalars['String']>;
}

/** Represents payment currency information */
export interface PaymentCurrencyInput {
  currencyCode: Scalars['String'];
}

export enum PaymentDeviceType {
  APP_PHONE = 'APP_PHONE',
  APP_TABLET = 'APP_TABLET',
  DESKTOP = 'DESKTOP',
  DEVICE_TYPE_INVALID = 'DEVICE_TYPE_INVALID',
  MOBILE_PHONE = 'MOBILE_PHONE',
  MOBILE_TABLET = 'MOBILE_TABLET',
}

export enum PaymentEntryURN {
  PAYMENT_APPLE_PAY_COUNTRY_CODE = 'PAYMENT_APPLE_PAY_COUNTRY_CODE',
  PAYMENT_APPLE_PAY_EMAIL_ADDRESS = 'PAYMENT_APPLE_PAY_EMAIL_ADDRESS',
  PAYMENT_APPLE_PAY_FIRST_NAME = 'PAYMENT_APPLE_PAY_FIRST_NAME',
  PAYMENT_APPLE_PAY_LAST_NAME = 'PAYMENT_APPLE_PAY_LAST_NAME',
  PAYMENT_APPLE_PAY_PHONE_NUMBER = 'PAYMENT_APPLE_PAY_PHONE_NUMBER',
  PAYMENT_APPLE_PAY_POSTAL_CODE = 'PAYMENT_APPLE_PAY_POSTAL_CODE',
  PAYMENT_BILLING_ZIPCODE = 'PAYMENT_BILLING_ZIPCODE',
  PAYMENT_CONTACT_EMAIL = 'PAYMENT_CONTACT_EMAIL',
  PAYMENT_CONTACT_PHONE = 'PAYMENT_CONTACT_PHONE',
  UNKNOWN = 'UNKNOWN',
}

export interface PaymentGooglePayConfigurationInput {
  authConfiguration?: InputMaybe<GooglePayAuthConfigurationInput>;
  billingDetails?: InputMaybe<GooglePayBillingDetailsInput>;
  paymentData?: InputMaybe<GooglePayPaymentDataInput>;
}

export interface PaymentKlarnaConfigurationInput {
  authorization_token?: InputMaybe<Scalars['String']>;
}

/** Key value pairs for additional attributes. For keys, ex) CARD_NUMBER, PIN  */
export interface PaymentMethodAttributeInput {
  key: Scalars['String'];
  value: Scalars['String'];
}

/** Configuration for payment method */
export interface PaymentMethodConfigInput {
  adyenConfiguration?: InputMaybe<AdyenPaymentConfigInput>;
  kcpPaymentConfig?: InputMaybe<KCPPaymentConfigInput>;
  paymentMethod?: InputMaybe<Scalars['String']>;
  paymentSubMethod?: InputMaybe<Scalars['String']>;
  paypalConfiguration?: InputMaybe<PaypalPaymentConfigInput>;
}

export interface PaymentMethodConfigurationInput {
  adyenConfiguration?: InputMaybe<PaymentAdyenConfigurationInput>;
  affirmConfiguration?: InputMaybe<PaymentAffirmConfigurationInput>;
  afterpayConfiguration?: InputMaybe<PaymentAfterpayConfigurationInput>;
  applePayConfiguration?: InputMaybe<PaymentApplePayConfigurationInput>;
  bin?: InputMaybe<Scalars['String']>;
  braintreeConfiguration?: InputMaybe<PaymentBraintreeConfigurationInput>;
  challenge3DsResult?: InputMaybe<Scalars['String']>;
  encodedBrowserMetadata?: InputMaybe<Scalars['String']>;
  etzToken?: InputMaybe<Scalars['String']>;
  googlePayConfiguration?: InputMaybe<PaymentGooglePayConfigurationInput>;
  kcpConfiguration?: InputMaybe<KCPConfigurationInput>;
  klarnaConfiguration?: InputMaybe<PaymentKlarnaConfigurationInput>;
  paypalConfiguration?: InputMaybe<PaymentPayPalConfigurationInput>;
  providerConfirmationStatus?: InputMaybe<Scalars['String']>;
  storedCardInstrument?: InputMaybe<StoredCardInstrumentInput>;
  subMethodUrn?: InputMaybe<Scalars['String']>;
}

/** PaymentMethod input for mutation */
export interface PaymentMethodInput {
  data?: InputMaybe<Array<PaymentMethodAttributeInput>>;
  paymentMethodType: PaymentMethodType;
}

export enum PaymentMethodMode {
  CREATE = 'CREATE',
  EDIT = 'EDIT',
}

export enum PaymentMethodType {
  ADYEN = 'ADYEN',
  AFFIRM = 'AFFIRM',
  AFTERPAY = 'AFTERPAY',
  APPLE_PAY = 'APPLE_PAY',
  BRAINTREE = 'BRAINTREE',
  CREDIT_CARD = 'CREDIT_CARD',
  GIFT_CARD = 'GIFT_CARD',
  GOOGLE_PAY = 'GOOGLE_PAY',
  INVALID = 'INVALID',
  KLARNA = 'KLARNA',
  LOYALTY = 'LOYALTY',
  NAVER_PAY = 'NAVER_PAY',
  PAYPAL = 'PAYPAL',
  UNRECOGNIZED = 'UNRECOGNIZED',
}

export interface PaymentModuleConfigurationInput {
  clientDetails: ClientDetailsInput;
  metaData: PaymentModuleMetadataConfigurationInput;
  payableAmount?: InputMaybe<PayableAmountInput>;
  sessionDetails: SessionDetailsInput;
}

export interface PaymentModuleMetadataConfigurationInput {
  countryCode: Scalars['String'];
  locale: Scalars['String'];
}

/** PaymentPartner ID could be PartnerID or PartnerAccountId */
export interface PaymentPartnerInput {
  id: Scalars['String'];
  type: PaymentPartnerType;
}

export enum PaymentPartnerType {
  ACCOUNT_ID = 'ACCOUNT_ID',
  PARTNER_ID = 'PARTNER_ID',
}

export interface PaymentPayPalConfigurationInput {
  domain?: InputMaybe<Scalars['String']>;
}

export enum PaymentPayType {
  PAY_LATER = 'PAY_LATER',
  PAY_NOW = 'PAY_NOW',
}

export interface PaymentProcessorDataInput {
  paymentProcessorId: Scalars['String'];
}

export enum PaymentProfileMode {
  CREATE = 'CREATE',
  EDIT = 'EDIT',
}

/** PaymentProfileRequest */
export interface PaymentProfileRequestInput {
  additionalEmails?: InputMaybe<Array<Scalars['String']>>;
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  businessName?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  countryRegion?: InputMaybe<Scalars['String']>;
  dateOfBirth?: InputMaybe<Scalars['String']>;
  emailAddress?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  partnerNotes?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  stateOrProvince?: InputMaybe<Scalars['String']>;
  type: PaymentProfileType;
}

export enum PaymentProfileType {
  BUSINESS = 'BUSINESS',
  INDIVIDUAL = 'INDIVIDUAL',
}

export enum PaymentState {
  STATE_CANCELLED = 'STATE_CANCELLED',
  STATE_DISABLED = 'STATE_DISABLED',
  STATE_INVALID = 'STATE_INVALID',
  STATE_REMOVED = 'STATE_REMOVED',
  STATE_SELECTED = 'STATE_SELECTED',
  STATE_UNSELECTED = 'STATE_UNSELECTED',
  UNRECOGNIZED = 'UNRECOGNIZED',
}

export enum PaymentStatus {
  COMPLETED = 'COMPLETED',
  FAILURE = 'FAILURE',
}

/** represents SubmissionInfo for submit Payment */
export interface PaymentSubmissionInfoInput {
  additionalData: AdditionalDataInput;
  payableAmount?: InputMaybe<PayableAmountInput>;
}

export interface PaymentTokenRequestInput {
  cardExpirationMonth?: InputMaybe<Scalars['Int']>;
  cardExpirationYear?: InputMaybe<Scalars['Int']>;
  sessionId: Scalars['String'];
  storedPaymentInstrumentId: Scalars['String'];
}

export enum PaymentType {
  COUPON_ELIGIBLE = 'COUPON_ELIGIBLE',
  FREE_CANCELLATION = 'FREE_CANCELLATION',
  GIFT_CARD = 'GIFT_CARD',
  PAY_LATER = 'PAY_LATER',
  PAY_LATER_WITH_DEPOSIT = 'PAY_LATER_WITH_DEPOSIT',
  PAY_WITHOUT_CREDITCARD = 'PAY_WITHOUT_CREDITCARD',
  PAY_WITH_AFFIRM = 'PAY_WITH_AFFIRM',
  PAY_WITH_AFTERPAY = 'PAY_WITH_AFTERPAY',
  PAY_WITH_KLARNA = 'PAY_WITH_KLARNA',
}

/** Represents the logo size used by the client to render */
export enum PaymentTypeLogoSize {
  EXTRA_SMALL = 'EXTRA_SMALL',
  LARGE = 'LARGE',
  SMALL = 'SMALL',
}

export interface PaypalPaymentConfigInput {
  status?: InputMaybe<Scalars['String']>;
}

export interface PerformanceDateRangeInput {
  endDate: Scalars['String'];
  startDate: Scalars['String'];
}

/** This enum scope is to communicate to client if is a different card theme defined by CardTheme enum is needed.see https://uitk.expedia.biz/expedia/en_US/components/utils#theme_provide */
export enum PersonalizedTheme {
  BRIGHT_1 = 'BRIGHT_1',
  DARK_1 = 'DARK_1',
  GLOBAL_LOYALTY_EXTRA_HIGH = 'GLOBAL_LOYALTY_EXTRA_HIGH',
  GLOBAL_LOYALTY_HIGH = 'GLOBAL_LOYALTY_HIGH',
  GLOBAL_LOYALTY_LOW = 'GLOBAL_LOYALTY_LOW',
  GLOBAL_LOYALTY_MID = 'GLOBAL_LOYALTY_MID',
  LIGHT_1 = 'LIGHT_1',
}

export enum PickerTriggerDisplayType {
  GLOBAL_NAV_BUTTON = 'GLOBAL_NAV_BUTTON',
  GLOBAL_NAV_LINK = 'GLOBAL_NAV_LINK',
}

export enum PickerTriggerPlacementType {
  MENU_ITEM = 'MENU_ITEM',
  NAV_LINK = 'NAV_LINK',
}

export enum Placement {
  /** Horizontal Orientation of Images in the List */
  Horizontal = 'Horizontal',
  /** Vertical Orientation of Images in the List */
  Vertical = 'Vertical',
}

export interface PlacementInput {
  name: Scalars['String'];
  protectionSetId: Scalars['String'];
}

export enum PlatformType {
  ANDROID = 'ANDROID',
  IOS = 'IOS',
  WEB = 'WEB',
}

/**
 * Languages vary in how they handle plurals of nouns or unit expressions ("hour" vs "hours", and so on).
 * Some languages have two forms, like English; some languages have only a single form; and some languages have multiple forms. CLDR uses short, mnemonic tags for these plural categories.
 * http://cldr.unicode.org/index/cldr-spec/plural-rules
 */
export enum PluralCategory {
  FEW = 'FEW',
  MANY = 'MANY',
  ONE = 'ONE',
  OTHER = 'OTHER',
  TWO = 'TWO',
  ZERO = 'ZERO',
}

export enum Points {
  /** Don't use loyalty points to calculate the strikeout price. */
  SHOP_WITHOUT_POINTS = 'SHOP_WITHOUT_POINTS',
  /** Use loyalty points to calculate the strikeout price. aka `swpApplied=true` */
  SHOP_WITH_POINTS = 'SHOP_WITH_POINTS',
}

export interface PolicyFetchParamsInput {
  cartId?: InputMaybe<Scalars['String']>;
  offerToken?: InputMaybe<OfferTokenInput>;
  orderInfo?: InputMaybe<OrderInfoInput>;
  sessionId?: InputMaybe<Scalars['String']>;
}

/** Represents request for post content overlay */
export interface PostContentOverlayQueryRequestInput {
  /** Represents the content creator id if it is travel shop */
  creatorId?: InputMaybe<Scalars['String']>;
  /** Represents the destination id of the destination in the post */
  destinationId?: InputMaybe<Scalars['String']>;
  /** Represents the current post id */
  postId: Scalars['String'];
  /** Represents the property id of the property in the post */
  propertyId?: InputMaybe<Scalars['String']>;
  /** Represents the current screen id */
  screenId: Scalars['String'];
}

export interface PostPaymentNotifyConfigurationInput {
  clientDetails: ClientDetailsInput;
  paymentSessionId: Scalars['String'];
  paymentStatus?: InputMaybe<PaymentStatus>;
}

export interface PrepareChangeCheckoutOptionInput {
  type: Scalars['String'];
  value: Scalars['String'];
}

/** Options that alter behavior of mutation - for backward compatibility */
export enum PrepareCheckoutResponseOption {
  ALTERNATIVE_ACTION_ON_FAILURE = 'ALTERNATIVE_ACTION_ON_FAILURE',
}

export enum PrequalificationStatus {
  APPROVED = 'APPROVED',
  DECLINED = 'DECLINED',
}

export interface PriceDetailsOptionsInput {
  loyaltyRewardsId?: InputMaybe<Scalars['String']>;
  metaDeeplink: Scalars['Boolean'];
  native?: InputMaybe<Scalars['Boolean']>;
  pathEntry?: InputMaybe<Scalars['String']>;
}

/** Possible values for UITK mark's orientation prop */
export enum PriceElementAlignment {
  CENTER = 'CENTER',
  LEFT = 'LEFT',
  RIGHT = 'RIGHT',
}

export interface PriceInsightsCreateMutationDataInput {
  lowestPredictedPrice?: InputMaybe<Scalars['Float']>;
  lowestPredictedPriceDate?: InputMaybe<Scalars['String']>;
  priceTrend?: InputMaybe<Scalars['String']>;
  timeSeriesTierShown: Scalars['Int'];
}

/** Represents a query parameter in the deep link. */
export interface PriceInsightsDeepLinkQueryParamInput {
  key: Scalars['String'];
  value: Scalars['String'];
}

export interface PriceInsightsDisableMutationDataInput {
  lowestPredictedPrice?: InputMaybe<Scalars['Float']>;
  lowestPredictedPriceDate?: InputMaybe<Scalars['String']>;
  priceTrend?: InputMaybe<Scalars['String']>;
  timeSeriesTierShown: Scalars['Int'];
}

/** Represent search context for all product lines */
export interface PriceInsightsSearchContextInput {
  carSearchCriteria?: InputMaybe<CarSearchCriteriaInput>;
  flightSearchCriteria?: InputMaybe<FlightSearchCriteriaInput>;
  propertySearchCriteria?: InputMaybe<PropertySearchCriteriaInput>;
}

export interface PriceInsightsUpdateMutationDataInput {
  lowestPredictedPrice?: InputMaybe<Scalars['Float']>;
  lowestPredictedPriceDate?: InputMaybe<Scalars['String']>;
  priceTrend?: InputMaybe<Scalars['String']>;
  timeSeriesTierShown: Scalars['Int'];
}

export enum PriceMatchPromiseChartType {
  BAR = 'BAR',
  LINE = 'LINE',
}

export enum PriceMatchPromiseScaleType {
  DATE = 'DATE',
  LABEL = 'LABEL',
  TIME = 'TIME',
}

/** Represents the state for the PMP module */
export enum PriceMatchPromiseState {
  /** Represents when the PMP module is removable */
  REMOVABLE = 'REMOVABLE',
  /** Represents when the PMP module is selectable */
  SELECTABLE = 'SELECTABLE',
  /** Represents when the PMP module is static */
  STATIC = 'STATIC',
  /** Represents when the PMP module is toggleable */
  TOGGLEABLE = 'TOGGLEABLE',
}

export interface PriceRangeInput {
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
}

export enum PricingSchemeType {
  DAILY_RATE = 'DAILY_RATE',
  TOTAL_RATE = 'TOTAL_RATE',
}

export enum PricingType {
  OccupancyBasedPricing = 'OccupancyBasedPricing',
  PerDayPricing = 'PerDayPricing',
}

/** Core criteria needed for an activities search */
export interface PrimaryActivitySearchCriteriaInput {
  dateRange?: InputMaybe<ActivitySearchCriteriaDateRangeInput>;
  destination?: InputMaybe<ActivitySearchCriteriaLocationInput>;
}

/** The core criteria needed for a car search */
export interface PrimaryCarCriteriaInput {
  dropOffDateTime: DateTimeInput;
  dropOffLocation?: InputMaybe<CarRentalLocationInput>;
  pickUpDateTime: DateTimeInput;
  pickUpLocation: CarRentalLocationInput;
}

export interface PrimaryCarOfferCriteriaInput {
  /** Car Offer options selected or unselected */
  options: Array<CarOfferOptionInput>;
}

/** The core criteria needed for a cruise search */
export interface PrimaryCruiseCriteriaInput {
  adultCount?: InputMaybe<Scalars['Int']>;
  childCount?: InputMaybe<Scalars['Int']>;
  children?: InputMaybe<Array<CruiseChildInput>>;
  departureDateRange?: InputMaybe<DateRangeInput>;
  destinations?: InputMaybe<Array<Scalars['String']>>;
  durationRange?: InputMaybe<CruiseDurationRangeInput>;
}

/** The primary criteria needed for cruise PDP */
export interface PrimaryCruiseSailingDetailsCriteriaInput {
  adultCount: Scalars['Int'];
  cabinExperience?: InputMaybe<Scalars['String']>;
  cabinType?: InputMaybe<Scalars['String']>;
  childCount: Scalars['Int'];
  children?: InputMaybe<Array<CruiseChildInput>>;
  sailingToken: Scalars['String'];
}

/** Wrapper to house all the LoB specific primary input criteria used for deals shopping. */
export interface PrimaryDealsShoppingCriteriaInput {
  destination?: InputMaybe<DestinationInput>;
  flight?: InputMaybe<PrimaryFlightDealsCriteriaInput>;
  /** Represents the timestamp(UTC) when the request was triggerred - formatted as yyyy-MM-dd'T'HH:mm:ss.SSS */
  timestamp?: InputMaybe<Scalars['String']>;
}

/** Represents the core criteria needed for a flight search */
export interface PrimaryFlightCriteriaInput {
  journeyCriterias: Array<FlightsJourneyCriteriaInput>;
  searchPreferences?: InputMaybe<FlightsSearchPreferencesInput>;
  travelers: Array<TravelerDetailsInput>;
  tripType: FlightsTripType;
}

/** Represents the core criteria needed for a flight deals search */
export interface PrimaryFlightDealsCriteriaInput {
  /** gaiaID for the destination */
  destinationCode?: InputMaybe<Scalars['String']>;
  /** Three letter code of the origin airport */
  originAirportCode?: InputMaybe<Scalars['String']>;
  /** Represents the traveler details - type of the traveler and age */
  travelers: Array<TravelerDetailsInput>;
}

/** The core criteria needed for a ground transfers or air transportation search */
export interface PrimaryGroundTransfersCriteriaInput {
  dateRange: OptionalDateTimeRangeInput;
  direction: GroundTransfersDirection;
  journeyCriteria?: InputMaybe<Array<GroundTransfersJourneyCriteriaInput>>;
  locations: Array<GroundTransfersLocationInput>;
  pinnedOffers?: InputMaybe<Array<GroundTransfersNaturalKeyInput>>;
  pinnedProductIds?: InputMaybe<Array<Scalars['String']>>;
  selectedOffers?: InputMaybe<Array<GroundTransfersNaturalKeyInput>>;
  shoppingPath?: InputMaybe<ShoppingPathType>;
  travelerDetails: Array<GroundTransfersTravelerDetailsInput>;
}

export interface PrimaryPackageSearchCriteriaInput {
  /** Cabin class chosen for flight */
  cabinClass?: InputMaybe<FlightsCabinClass>;
  /** If not provided, packages returned will be for different duration and popular advance purchase window based on the themes */
  dateRange?: InputMaybe<DateRangeInput>;
  /** If not provided, packages returned will be for different popular destinations based on the themes */
  destination?: InputMaybe<PackageLocationInput>;
  /** If not provided, it will be resolved using user profile or ip sniffing */
  origin?: InputMaybe<PackageLocationInput>;
  /** If not provided, partial stay will be null and no partial stay will be shown */
  partialStayDateRange?: InputMaybe<DateRangeInput>;
  /** If not provided, it will be defaulted to 1 occupancy unit for 2 adults */
  travelerOccupancyGroups?: InputMaybe<Array<TravelerOccupancyGroupInput>>;
}

/** This is a wrapper which houses all the LoB specific primary input criteria.  This is used for unified shopping. */
export interface PrimaryProductShoppingCriteriaInput {
  car?: InputMaybe<PrimaryCarCriteriaInput>;
  cruise?: InputMaybe<PrimaryCruiseCriteriaInput>;
  flight?: InputMaybe<PrimaryFlightCriteriaInput>;
  groundTransportation?: InputMaybe<PrimaryGroundTransfersCriteriaInput>;
  property?: InputMaybe<PrimaryPropertyCriteriaInput>;
}

/** The core criteria needed for a property search */
export interface PrimaryPropertyCriteriaInput {
  dateRange?: InputMaybe<PropertyDateRangeInput>;
  destination: DestinationInput;
  flexSearchCriteria?: InputMaybe<FlexibleSearchCriteriaInput>;
  rooms: Array<RoomInput>;
}

/** User preference for data sharing with third parties which users may update */
export enum PrivacySellState {
  CAN_NOT_SELL = 'CAN_NOT_SELL',
  CAN_SELL = 'CAN_SELL',
}

/** Privacy tracking user preference. We can retrieve info on if the site allows tracking from Site Info and null can also be used to represent a selection or not */
export enum PrivacyTrackingState {
  CAN_NOT_TRACK = 'CAN_NOT_TRACK',
  CAN_TRACK = 'CAN_TRACK',
}

export enum ProductAssociationOperation {
  ADD_PREFERRED_PRODUCTS = 'ADD_PREFERRED_PRODUCTS',
  UPDATE_ALL_PREFERRED_PRODUCTS = 'UPDATE_ALL_PREFERRED_PRODUCTS',
}

export enum ProductContext {
  BRAND_RESULT_LISTING = 'BRAND_RESULT_LISTING',
  FLIGHT_SPONSORED_LISTING = 'FLIGHT_SPONSORED_LISTING',
  LODGING_SPONSORED_LISTING = 'LODGING_SPONSORED_LISTING',
}

export enum ProductEntityAssetSelection {
  ABOUT_PROPERTY = 'ABOUT_PROPERTY',
  ACCESSIBILITY_CONTENT = 'ACCESSIBILITY_CONTENT',
  AMENITY = 'AMENITY',
  AMENITY_SPOTLIGHT = 'AMENITY_SPOTLIGHT',
  AT_A_GLANCE_AMENITIES = 'AT_A_GLANCE_AMENITIES',
  EXPERIENCE_SCORE = 'EXPERIENCE_SCORE',
  EXPERIENCE_SCORE_WITH_TOP_RATED_ATTRIBUTES = 'EXPERIENCE_SCORE_WITH_TOP_RATED_ATTRIBUTES',
  FAMILY_HIGHLIGHTS = 'FAMILY_HIGHLIGHTS',
  GUEST_CHOICE = 'GUEST_CHOICE',
  HEADLINE = 'HEADLINE',
  HOST_TEXTS = 'HOST_TEXTS',
  IMAGE = 'IMAGE',
  IMAGE_RICH_AMENITY = 'IMAGE_RICH_AMENITY',
  LOCATION_DESCRIPTION = 'LOCATION_DESCRIPTION',
  LUXURY_STAYS = 'LUXURY_STAYS',
  PLACE = 'PLACE',
  POLICY = 'POLICY',
  PRODUCT_ATTRIBUTE = 'PRODUCT_ATTRIBUTE',
  PRODUCT_HIGHLIGHTS = 'PRODUCT_HIGHLIGHTS',
  PRODUCT_UNIQUENESS_HIGHLIGHTS = 'PRODUCT_UNIQUENESS_HIGHLIGHTS',
  PROPERTY_AMENITY_GROUPS = 'PROPERTY_AMENITY_GROUPS',
  PROPERTY_DESCRIPTION = 'PROPERTY_DESCRIPTION',
  RELEVANT_AMENITY_DETAILS = 'RELEVANT_AMENITY_DETAILS',
  REVIEW_DETAILS = 'REVIEW_DETAILS',
  REVIEW_IMAGES = 'REVIEW_IMAGES',
  REVIEW_SUMMARY = 'REVIEW_SUMMARY',
  REVIEW_SUMMARY_HIGHLIGHTS = 'REVIEW_SUMMARY_HIGHLIGHTS',
  REVIEW_SUMMARY_WITH_UGC_CONTENT = 'REVIEW_SUMMARY_WITH_UGC_CONTENT',
  SUPPLY_SCORE = 'SUPPLY_SCORE',
  TOP_RATED_DETAILS = 'TOP_RATED_DETAILS',
  VIBE_TAGLINE = 'VIBE_TAGLINE',
  VIRTUAL_TOUR = 'VIRTUAL_TOUR',
}

export enum ProductEntityRefinementSelection {
  EMBARGO = 'EMBARGO',
}

/** Input for productGroup query */
export interface ProductGroupContextInput {
  affinityURNs?: InputMaybe<Array<Scalars['String']>>;
  configurationIdentifier?: InputMaybe<Scalars['String']>;
  destinationId?: InputMaybe<Scalars['String']>;
  lineOfBusinessDomain?: InputMaybe<LineOfBusinessDomain>;
  marketingChannelTypeCode?: InputMaybe<Scalars['Int']>;
  userLocation?: InputMaybe<CoordinatesInput>;
}

/** This is a wrapper which houses all the LoB specific primary input criteria. This is used for unified shopping. */
export interface ProductIdentifierInput {
  /** Id */
  id: Scalars['String'];
  /** product line */
  productLine?: InputMaybe<ProductLine>;
  /** DEPRECATED: Please do not use. Use 'travelSearchCriteria.property.secondary.selections' */
  searchCriteriaSelections?: InputMaybe<Array<SearchCriteriaSelectionsInput>>;
  /** shopping context */
  shoppingContext?: InputMaybe<ShoppingContextInput>;
  /** search context */
  travelSearchCriteria?: InputMaybe<TravelSearchCriteriaInput>;
  /** Identifier Type of Input */
  type: IdentifierType;
}

/** Enum to specify image width for product image */
export enum ProductImageFitment {
  CONTAIN = 'CONTAIN',
  COVER = 'COVER',
}

/** Enum to specify image width for product image */
export enum ProductImageWidth {
  FULL_WIDTH = 'FULL_WIDTH',
  HALF_WIDTH = 'HALF_WIDTH',
  QUARTER_WIDTH = 'QUARTER_WIDTH',
  THIRD_WIDTH = 'THIRD_WIDTH',
}

/** Product line. This should not be used outside of ProductIdentifier class. */
export enum ProductLine {
  ACTIVITY = 'ACTIVITY',
  CAR = 'CAR',
  CRUISE = 'CRUISE',
  FLIGHT = 'FLIGHT',
  GROUND_TRANSFER = 'GROUND_TRANSFER',
  INSURANCE = 'INSURANCE',
  LODGING = 'LODGING',
  PACKAGE = 'PACKAGE',
  PRODUCT_LINE_INVALID = 'PRODUCT_LINE_INVALID',
  RAIL = 'RAIL',
  UNRECOGNIZED = 'UNRECOGNIZED',
}

export enum ProductLineType {
  DEFAULT = 'DEFAULT',
  FPAAS = 'FPAAS',
  IPMMOR_ONBOARDING = 'IPMMOR_ONBOARDING',
  MESO = 'MESO',
  MESO_ONBOARDING = 'MESO_ONBOARDING',
  TA = 'TA',
  VRBO = 'VRBO',
}

export enum ProductMediaEncoding {
  AV1 = 'AV1',
  H264 = 'H264',
}

export enum ProductMediaQuality {
  HIGH = 'HIGH',
  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
}

/** Input type for the unified shopping experience. */
export interface ProductShoppingCriteriaInput {
  primarySearchCriteria: PrimaryProductShoppingCriteriaInput;
  secondaryCriteria?: InputMaybe<ShoppingSearchCriteriaInput>;
}

export enum ProductStepperState {
  COMPLETE = 'COMPLETE',
  CURRENT = 'CURRENT',
  INCOMPLETE = 'INCOMPLETE',
}

/** Input to productSummary Query */
export interface ProductSummaryInput {
  /** Identifier String of Input */
  id: Scalars['String'];
  /** Identifier Type of Input */
  idType: IdentifierType;
  /** Selections to pass. Eg searchId */
  selections?: InputMaybe<Array<SelectedValueInput>>;
}

export enum ProductTrackPosition {
  END = 'END',
  STANDARD = 'STANDARD',
  START = 'START',
}

export enum ProductVideoActionType {
  ENTER_FULLSCREEN = 'ENTER_FULLSCREEN',
  EXIT_FULLSCREEN = 'EXIT_FULLSCREEN',
  MUTE = 'MUTE',
  PAUSE = 'PAUSE',
  PLAY = 'PLAY',
  UNMUTE = 'UNMUTE',
}

export enum ProductVideoType {
  BASIC = 'BASIC',
  EMBED = 'EMBED',
}

/** Represents layout of buttons. */
export enum ProfileButtonLayout {
  /** Horizontally stacked buttons. */
  INLINE = 'INLINE',
  /** Vertically stacked buttons. */
  STACKED = 'STACKED',
}

/** Specifies whether to open the link in the same user interface context or in a different context */
export enum ProfileLinkTarget {
  EXTERNAL = 'EXTERNAL',
  INTERNAL = 'INTERNAL',
}

export enum ProfileUseType {
  BILLING = 'BILLING',
  BILLING_AND_PAYOUT = 'BILLING_AND_PAYOUT',
  PAYOUT = 'PAYOUT',
}

/** Represents where a wizard will be displayed */
export interface ProfileWizardContextInput {
  lineOfBusiness: LineOfBusinessDomain;
  pageLocation: PageLocation;
}

/** enum of actions where the button click can take the user to. This can be used in UI to decide the action for button click. */
export enum ProgressionBarAction {
  PDP = 'PDP',
  REVIEWS = 'REVIEWS',
  TRAVEL_GUIDE = 'TRAVEL_GUIDE',
}

export enum PropertyActivitiesCrossSellActionType {
  DISMISS = 'DISMISS',
  EDIT = 'EDIT',
  OPEN = 'OPEN',
  REMOVE = 'REMOVE',
}

/** Type that represents the amenity category icons for the property */
export enum PropertyAmenityCategoryType {
  ACCESSIBLE_ROLL_IN_SHOWER = 'ACCESSIBLE_ROLL_IN_SHOWER',
  AIR_CONDITIONING = 'AIR_CONDITIONING',
  ALL_INCLUSIVE = 'ALL_INCLUSIVE',
  ARCADE = 'ARCADE',
  BABYSITTING = 'BABYSITTING',
  BAR = 'BAR',
  BOWLING = 'BOWLING',
  BREAKFAST_AVAILABLE = 'BREAKFAST_AVAILABLE',
  BUSINESS_SERVICES = 'BUSINESS_SERVICES',
  CHILDREN_CLUB = 'CHILDREN_CLUB',
  DAILY_HOUSEKEEPING = 'DAILY_HOUSEKEEPING',
  EXTRA_BED = 'EXTRA_BED',
  FITNESS_EQUIPMENT = 'FITNESS_EQUIPMENT',
  FREE_AIRPORT_TRANSPORTATION = 'FREE_AIRPORT_TRANSPORTATION',
  FREE_BREAKFAST = 'FREE_BREAKFAST',
  FREE_PARKING = 'FREE_PARKING',
  FREE_WELCOME_DRINK = 'FREE_WELCOME_DRINK',
  FRONT_DESK_24_HOURS = 'FRONT_DESK_24_HOURS',
  GROCERY = 'GROCERY',
  HIGH_SPEED_INTERNET = 'HIGH_SPEED_INTERNET',
  HOT_TUB = 'HOT_TUB',
  IN_ROOM_INTERNET = 'IN_ROOM_INTERNET',
  KIDS_POOL = 'KIDS_POOL',
  KITCHEN = 'KITCHEN',
  LAUNDRY = 'LAUNDRY',
  LIVING_AREA = 'LIVING_AREA',
  MICROWAVE = 'MICROWAVE',
  MINI_GOLF = 'MINI_GOLF',
  PARKING = 'PARKING',
  PETS_ALLOWED = 'PETS_ALLOWED',
  PLAYGROUND = 'PLAYGROUND',
  POOL = 'POOL',
  RESTAURANT_IN_HOTEL = 'RESTAURANT_IN_HOTEL',
  ROOM_SERVICE = 'ROOM_SERVICE',
  SMOKE_FREE = 'SMOKE_FREE',
  SOUNDPROOF_ROOM = 'SOUNDPROOF_ROOM',
  SPA_SERVICES_ON_SITE = 'SPA_SERVICES_ON_SITE',
  SPECIAL_DEAL = 'SPECIAL_DEAL',
  TENNIS_COURT = 'TENNIS_COURT',
  TOYS = 'TOYS',
  WATERSLIDE = 'WATERSLIDE',
}

export enum PropertyAmenityType {
  ACCESSIBILITY = 'ACCESSIBILITY',
  BATHROOM = 'BATHROOM',
  BEDROOM = 'BEDROOM',
  BUSINESS_SERVICES = 'BUSINESS_SERVICES',
  CONVENIENCES = 'CONVENIENCES',
  ENTERTAINMENT = 'ENTERTAINMENT',
  FAMILY_FRIENDLY = 'FAMILY_FRIENDLY',
  FOOD_DRINK = 'FOOD_DRINK',
  GUEST_SERVICES = 'GUEST_SERVICES',
  INTERNET = 'INTERNET',
  MORE = 'MORE',
  OUTDOOR = 'OUTDOOR',
  OUTDOOR_SPACE = 'OUTDOOR_SPACE',
  PARKING = 'PARKING',
  PROPERTY = 'PROPERTY',
  ROOM = 'ROOM',
  SPA = 'SPA',
  THINGS_TO_DO = 'THINGS_TO_DO',
}

export enum PropertyCalendarPriceTrend {
  /** Negative price trend */
  NEGATIVE = 'NEGATIVE',
  /** Positive price trend */
  POSITIVE = 'POSITIVE',
}

export enum PropertyCancellationPolicyType {
  NON_REFUNDABLE = 'NON_REFUNDABLE',
  REFUNDABLE_WITH_NO_PENALTY = 'REFUNDABLE_WITH_NO_PENALTY',
  REFUNDABLE_WITH_PENALTY = 'REFUNDABLE_WITH_PENALTY',
}

export enum PropertyContentSectionRef {
  AVAILABILITY_CALENDAR_START_DATE = 'AVAILABILITY_CALENDAR_START_DATE',
  PRICE_DISPLAY_SERVICE_RESPONSE = 'PRICE_DISPLAY_SERVICE_RESPONSE',
  RECOMMENDED_OFFER = 'RECOMMENDED_OFFER',
  ROOMS_AND_RATES = 'ROOMS_AND_RATES',
}

export enum PropertyContentType {
  /** Card view that appears on the page */
  CARD = 'CARD',
  /** Detailed view that appears in expanded modal. */
  DETAILED = 'DETAILED',
  /** Simplified view that appears flat on page. */
  SUMMARY = 'SUMMARY',
}

export interface PropertyContext {
  propertyId: Scalars['String'];
}

/** Property context for fetching propertyId */
export interface PropertyContextInput {
  propertyId: Scalars['String'];
}

export interface PropertyDateRangeInput {
  checkInDate: DateInput;
  checkOutDate: DateInput;
}

export interface PropertyDetailsMultiItemShoppingActionInput {
  shoppingContext: ShoppingContextInput;
}

export enum PropertyDetailsPropertyType {
  HOTEL = 'HOTEL',
  VACATION_RENTAL = 'VACATION_RENTAL',
}

export enum PropertyFilterAccessibility {
  ACCESSIBLE_BATHROOM = 'ACCESSIBLE_BATHROOM',
  ACCESSIBLE_PARKING = 'ACCESSIBLE_PARKING',
  ELEVATOR = 'ELEVATOR',
  IN_ROOM_ACCESSIBLE = 'IN_ROOM_ACCESSIBLE',
  ROLL_IN_SHOWER = 'ROLL_IN_SHOWER',
  SERVICE_ANIMAL = 'SERVICE_ANIMAL',
  SIGN_LANGUAGE_INTERPRETER = 'SIGN_LANGUAGE_INTERPRETER',
  STAIR_FREE_PATH = 'STAIR_FREE_PATH',
}

export enum PropertyFilterAmenity {
  AIR_CONDITIONING = 'AIR_CONDITIONING',
  ALL_INCLUSIVE = 'ALL_INCLUSIVE',
  BALCONY_OR_TERRACE = 'BALCONY_OR_TERRACE',
  BAR = 'BAR',
  /** Deprecated: TnL 37054 - AFFINITY_FILTERS_APPLIED_ON_HSR */
  BEACH = 'BEACH',
  BEACH_FRONT = 'BEACH_FRONT',
  BED_LINENS = 'BED_LINENS',
  CASINO = 'CASINO',
  CRIB = 'CRIB',
  DISHWASHER = 'DISHWASHER',
  DRYER = 'DRYER',
  ELECTRIC_CAR = 'ELECTRIC_CAR',
  FIREPLACE = 'FIREPLACE',
  FREE_AIRPORT_TRANSPORTATION = 'FREE_AIRPORT_TRANSPORTATION',
  FREE_BREAKFAST = 'FREE_BREAKFAST',
  FREE_PARKING = 'FREE_PARKING',
  /** Deprecated: TnL 37054 - AFFINITY_FILTERS_APPLIED_ON_HSR */
  GOLF = 'GOLF',
  GOLF_COURSE = 'GOLF_COURSE',
  GYM = 'GYM',
  HOT_SPRING = 'HOT_SPRING',
  HOT_TUB = 'HOT_TUB',
  KITCHEN_KITCHEN = 'KITCHEN_KITCHEN',
  KITCHEN_KITCHENETTE = 'KITCHEN_KITCHENETTE',
  OCEAN_VIEW = 'OCEAN_VIEW',
  PARKING = 'PARKING',
  PETS = 'PETS',
  POOL = 'POOL',
  RESTAURANT_IN_HOTEL = 'RESTAURANT_IN_HOTEL',
  SPA_ON_SITE = 'SPA_ON_SITE',
  TELEVISION = 'TELEVISION',
  WASHER = 'WASHER',
  WASHER_DRYER = 'WASHER_DRYER',
  WATER_PARK = 'WATER_PARK',
  WIFI = 'WIFI',
}

/** Options that are not filters. Refer @code { SearchOptions } */
export enum PropertyInfoOptions {
  /** Use loyalty points to calculate the strikeout price. aka `swpApplied=true` */
  SHOP_WITH_POINTS = 'SHOP_WITH_POINTS',
}

/** Container of all the marketing data */
export interface PropertyMarketingInfoInput {
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta affcid channel code */
  affcid?: InputMaybe<Scalars['String']>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta afflid channel code */
  afflid?: InputMaybe<Scalars['String']>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta afmcid channel code */
  afmcid?: InputMaybe<Scalars['String']>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta brandcid channel code */
  brandcid?: InputMaybe<Scalars['String']>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta emlcid channel code */
  emlcid?: InputMaybe<Scalars['String']>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta emldtl channel code */
  emldtl?: InputMaybe<Scalars['String']>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta gclid channel code */
  gclid?: InputMaybe<Scalars['String']>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta icmcid channel code */
  icmcid?: InputMaybe<Scalars['String']>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta icmdtl channel code */
  icmdtl?: InputMaybe<Scalars['String']>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta k_user_id channel code */
  k_user_id?: InputMaybe<Scalars['String']>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta kword channel code */
  kword?: InputMaybe<Scalars['String']>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta lnkloc channel code */
  lnkloc?: InputMaybe<Scalars['String']>;
  /**
   * A consolidated list of marketing channels in key/value pairs.
   * Example: [{"key": "mctc", "value": "2"}, {"key": "icmdtl", "value": "some values"}]
   */
  marketingChannels?: InputMaybe<Array<PropertyMarketingTagInput>>;
  /**
   * A consolidated list of marketing prices in key/value pairs.
   * Example: [{"key": "exp_dp", "value": "100"}, {"key": "exp_tx", "value": "10"}]
   */
  marketingPrices?: InputMaybe<Array<PropertyMarketingTagInput>>;
  /** Deprecated: Don't get/set value from this field , ReplaceWith("marketingChannels") ,Marketing Channel Type Code: Indicates traffic type, i.e. 5 for Trivago */
  mctc?: InputMaybe<Scalars['Int']>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta mdpcid channel code */
  mdpcid?: InputMaybe<Scalars['String']>;
  /** Deprecated: Don't get/set value from this field,ReplaceWith("marketingChannels"),  Meta mdpdtl channel code */
  mdpdtl?: InputMaybe<Scalars['String']>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta olacid channel code */
  olacid?: InputMaybe<Scalars['String']>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta oladtl channel code */
  oladtl?: InputMaybe<Scalars['String']>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta semcid channel code */
  semcid?: InputMaybe<Scalars['String']>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta semdtl channel code */
  semdtl?: InputMaybe<Scalars['String']>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta seocid channel code */
  seocid?: InputMaybe<Scalars['String']>;
}

export interface PropertyMarketingTagInput {
  key: Scalars['String'];
  value: Scalars['String'];
}

/** Minimum set of data used to retrieve details about a property product */
export interface PropertyNaturalKeyInput {
  businessModelType?: InputMaybe<BusinessModelType>;
  checkIn: DateInput;
  checkOut: DateInput;
  homeCountryCode?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  inventoryType: InventoryType;
  isMember?: InputMaybe<Scalars['Boolean']>;
  memberTiers?: InputMaybe<Array<Scalars['Int']>>;
  membershipLevel?: InputMaybe<Scalars['String']>;
  noCreditCard?: InputMaybe<Scalars['Boolean']>;
  /** Pet permissibility & inclusion at property. Necessary when pets are used in primary search criteria */
  petsIncluded?: InputMaybe<Scalars['Boolean']>;
  ratePlanId: Scalars['String'];
  ratePlanType?: InputMaybe<Scalars['String']>;
  roomTypeId: Scalars['String'];
  rooms: Array<PropertyRoomInput>;
  shoppingPath?: InputMaybe<ShoppingPathType>;
}

/** Minimum set of data used to retrieve details about a property product */
export interface PropertyOfferInput {
  /** Sometimes, 1 room's offer needs to be represented by more than 1 Property Natural Key, e.g: Mixed Rate Plan */
  naturalKeys: Array<PropertyNaturalKeyInput>;
  /** The index of the room user is adding */
  offerIndex: Scalars['Int'];
}

/** Represents the runtime information provided by clients for creating Property Offers context in EM call */
export interface PropertyOffersContextInput {
  amountSpent?: InputMaybe<Scalars['String']>;
  earnPercent?: InputMaybe<Scalars['String']>;
  hasMemberOnlyDeal?: InputMaybe<Scalars['Boolean']>;
  isDifferentSupplyCurrencyHotel?: InputMaybe<Scalars['Boolean']>;
  isPayAtProperty?: InputMaybe<Scalars['Boolean']>;
  isTSFApplicable?: InputMaybe<Scalars['Boolean']>;
  tsfAmount?: InputMaybe<Scalars['String']>;
}

export enum PropertyPaymentFlags {
  ARTIFICIALLY_FENCED_RATE = 'ARTIFICIALLY_FENCED_RATE',
  MIXED_RATE_PLAN = 'MIXED_RATE_PLAN',
  NO_CREDIT_CARD = 'NO_CREDIT_CARD',
}

export enum PropertyPaymentModel {
  PAY_LATER = 'PAY_LATER',
  PAY_LATER_WITH_DEPOSIT = 'PAY_LATER_WITH_DEPOSIT',
  PAY_NOW = 'PAY_NOW',
}

/** Indicate what are the payment options for a given offer */
export enum PropertyPaymentType {
  PAY_LATER = 'PAY_LATER',
  PAY_LATER_WITH_DEPOSIT = 'PAY_LATER_WITH_DEPOSIT',
  PAY_NOW = 'PAY_NOW',
}

export enum PropertyRecommendationStrategy {
  NEARBY_PROPERTIES = 'NEARBY_PROPERTIES',
  SIMILAR_PROPERTIES = 'SIMILAR_PROPERTIES',
}

/** Filters review results by category type */
export enum PropertyReviewCategory {
  BUSINESS_TRAVELERS = 'BUSINESS_TRAVELERS',
  COUPLES = 'COUPLES',
  EVERYONE = 'EVERYONE',
  FAMILIES = 'FAMILIES',
  GETAWAY_WITH_FRIENDS = 'GETAWAY_WITH_FRIENDS',
  GOLF = 'GOLF',
  OTHER = 'OTHER',
  OVERNIGHT_STAY = 'OVERNIGHT_STAY',
  PERSONAL_EVENT = 'PERSONAL_EVENT',
  SHOPPING = 'SHOPPING',
  SPA = 'SPA',
  STUDENTS = 'STUDENTS',
}

export interface PropertyReviewFiltersInput {
  /** Filter review results by category */
  category?: InputMaybe<PropertyReviewCategory>;
  /** Include or disclude reviews that only have ratings */
  includeRatingsOnlyReviews?: InputMaybe<Scalars['Boolean']>;
  /** Get reviews immediately when true (without 90 days syndication) */
  includeRecentReviews?: InputMaybe<Scalars['Boolean']>;
  /** Filter reviews by specified languages by receiving lang code e.g. 'en' */
  language?: InputMaybe<Scalars['String']>;
  /** Filter review results by reviewers' locale. Example: ko_KR returns reviews made by users on Korea POSa */
  locale?: InputMaybe<Scalars['Locale']>;
  /** Filter review results by popular mentioned keyword */
  popularMention?: InputMaybe<Scalars['String']>;
  /** Filter review results by a list of review ratings */
  ratings?: InputMaybe<Array<Scalars['Float']>>;
  /** Filter review results by review type: POSITIVE or CRITICAL */
  reviewType?: InputMaybe<PropertyReviewType>;
  /** Filter review results by room type */
  roomTypeId?: InputMaybe<Scalars['Int']>;
  /** Filter review results by user provided keyword */
  searchTerm?: InputMaybe<Scalars['String']>;
  /** Sort reviews by Recency, high-to-low rating and low-to-high rating */
  sortRating?: InputMaybe<Array<Scalars['String']>>;
  /** DEPRECATED - Replaced by travelerType param. Filter review results by travel companions */
  travelCompanion?: InputMaybe<Array<Scalars['String']>>;
  /** Filter reviews by tripReason and travelerCompanion depending on this list */
  travelerType?: InputMaybe<Array<Scalars['String']>>;
  /** DEPRECATED - Replaced by travelerType param. Filter review results by trip reasons */
  tripReason?: InputMaybe<Array<Scalars['String']>>;
}

export enum PropertyReviewSort {
  HIGHEST_TO_LOWEST_RATED = 'HIGHEST_TO_LOWEST_RATED',
  LOWEST_TO_HIGHEST_RATED = 'LOWEST_TO_HIGHEST_RATED',
  NEWEST_TO_OLDEST = 'NEWEST_TO_OLDEST',
  NEWEST_TO_OLDEST_BY_LANGUAGE = 'NEWEST_TO_OLDEST_BY_LANGUAGE',
  NEWEST_TO_OLDEST_BY_RELEVANCY = 'NEWEST_TO_OLDEST_BY_RELEVANCY',
}

export enum PropertyReviewType {
  /** filter reviews by rating <= 2 */
  CRITICAL = 'CRITICAL',
  /** filter reviews by rating >= 3 */
  POSITIVE = 'POSITIVE',
  /** filter reviews by latest date */
  RECENT = 'RECENT',
}

/** Indicates how many rooms will be occupied and by whom */
export interface PropertyRoomInput {
  childAges: Array<Scalars['Int']>;
  numberOfAdults: Scalars['Int'];
  pets?: InputMaybe<Scalars['Boolean']>;
}

/** Property criteria needed to perform a property search */
export interface PropertySearchCriteriaInput {
  primary: PrimaryPropertyCriteriaInput;
  secondary?: InputMaybe<ShoppingSearchCriteriaInput>;
}

export interface PropertySearchFiltersInput {
  accessibility?: InputMaybe<Array<PropertyFilterAccessibility>>;
  agencyBusinessModels?: InputMaybe<Array<AgencyBusinessModel>>;
  amenities?: InputMaybe<Array<PropertyFilterAmenity>>;
  bedroomFilter?: InputMaybe<Array<Scalars['Int']>>;
  chain?: InputMaybe<Scalars['String']>;
  cleaningAndSafetyPractices?: InputMaybe<Array<CleaningAndSafetyPractice>>;
  commissionTiers?: InputMaybe<Array<CommissionTier>>;
  deals?: InputMaybe<Array<DealType>>;
  mealPlan?: InputMaybe<Array<MealPlanFilterAmenity>>;
  neighborhood?: InputMaybe<Scalars['String']>;
  paymentType?: InputMaybe<Array<PaymentType>>;
  poi?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<PriceRangeInput>;
  priceBuckets?: InputMaybe<Array<Scalars['Int']>>;
  propertyName?: InputMaybe<Scalars['String']>;
  propertyStyles?: InputMaybe<Array<PropertyStyle>>;
  reviewScore?: InputMaybe<ReviewScoreRangeInput>;
  rewards?: InputMaybe<Array<Scalars['String']>>;
  showAvailableOnly?: InputMaybe<Scalars['Boolean']>;
  starList?: InputMaybe<Array<Scalars['Float']>>;
  stars?: InputMaybe<StarRangeInput>;
  stayTypes?: InputMaybe<Array<StayType>>;
  structureTypes?: InputMaybe<Array<StructureType>>;
  theme?: InputMaybe<Scalars['String']>;
  travelerType?: InputMaybe<Array<TravelerType>>;
  unmappedFilters?: InputMaybe<Array<UnmappedFilterInput>>;
  vipOnly?: InputMaybe<Scalars['Boolean']>;
}

export interface PropertySearchMultiItemShoppingActionInput {
  shoppingContext: ShoppingContextInput;
}

export enum PropertySearchOptions {
  /** Deprecated: Use PropertyShopOptions.listings */
  ADS_ONLY = 'ADS_ONLY',
  /** Deprecated: Use PropertyShopOptions.points */
  SHOP_WITH_POINTS = 'SHOP_WITH_POINTS',
}

export enum PropertySectionRef {
  /** @deprecated Replace with PropertyContentSectionRef.AVAILABILITY_CALENDAR_START_DATE */
  AVAILABILITY_CALENDAR_START_DATE = 'AVAILABILITY_CALENDAR_START_DATE',
  /** @deprecated Replace with PropertyContentSectionRef.PRICE_DISPLAY_SERVICE_RESPONSE */
  PRICE_DISPLAY_SERVICE_RESPONSE = 'PRICE_DISPLAY_SERVICE_RESPONSE',
  /** @deprecated Replace with PropertyContentSectionRef.RECOMMENDED_OFFER */
  RECOMMENDED_OFFER = 'RECOMMENDED_OFFER',
  /** @deprecated Replace with PropertyContentSectionRef.ROOMS_AND_RATES */
  ROOMS_AND_RATES = 'ROOMS_AND_RATES',
}

/** Property shop options; If this field is not supplied, a server default will be chosen */
export interface PropertyShopOptionsInput {
  /** Ads related property search option */
  listings?: InputMaybe<Listings>;
  /** Paandi redirection to white label */
  paandiRedirection?: InputMaybe<Scalars['String']>;
  /** Points related property search option */
  points?: InputMaybe<Points>;
  /** DEPRECATED. regionType only used for EG-Typeahead url params */
  typeaheadRegionType?: InputMaybe<Scalars['Int']>;
}

/** Hotel sort types */
export enum PropertySort {
  AARP_MEMBER_DISCOUNT = 'AARP_MEMBER_DISCOUNT',
  BEST = 'BEST',
  BEST_DEAL = 'BEST_DEAL',
  BUDGET = 'BUDGET',
  DEPARTURE_EARLY_TO_LATE = 'DEPARTURE_EARLY_TO_LATE',
  DEPARTURE_LATE_TO_EARLY = 'DEPARTURE_LATE_TO_EARLY',
  DISTANCE = 'DISTANCE',
  DURATION_LONG_TO_SHORT = 'DURATION_LONG_TO_SHORT',
  DURATION_SHORT_TO_LONG = 'DURATION_SHORT_TO_LONG',
  LUXURY = 'LUXURY',
  /** Deprecated: Hackathon 2022-07 */
  MAXIMUM_SAVINGS = 'MAXIMUM_SAVINGS',
  /** Deprecated: Hackathon 2022-07 */
  MAXIMUM_SAVINGS_PERCENT = 'MAXIMUM_SAVINGS_PERCENT',
  MEMBER_PRICING = 'MEMBER_PRICING',
  PACKAGE_SAVINGS = 'PACKAGE_SAVINGS',
  PRICE_HIGH_TO_LOW = 'PRICE_HIGH_TO_LOW',
  PRICE_LOW_TO_HIGH = 'PRICE_LOW_TO_HIGH',
  PRICE_RELEVANT = 'PRICE_RELEVANT',
  PROPERTY_CLASS = 'PROPERTY_CLASS',
  PROPERTY_NAME = 'PROPERTY_NAME',
  RECOMMENDED = 'RECOMMENDED',
  REVIEW = 'REVIEW',
  REVIEW_COUNT = 'REVIEW_COUNT',
  /** tnl 49730 reverted to control */
  REVIEW_PRICE = 'REVIEW_PRICE',
  REVIEW_RELEVANT = 'REVIEW_RELEVANT',
  VACATION_RENTAL = 'VACATION_RENTAL',
}

export enum PropertyStyle {
  /** Deprecated: TnL 37054 - AFFINITY_FILTERS_APPLIED_ON_HSR */
  BOUTIQUE = 'BOUTIQUE',
  HOMES = 'HOMES',
  HOTELS = 'HOTELS',
  /** Deprecated: TnL 37054 - AFFINITY_FILTERS_APPLIED_ON_HSR */
  LGBT = 'LGBT',
  LUXURY = 'LUXURY',
  OUTDOOR = 'OUTDOOR',
  UNIQUE = 'UNIQUE',
}

/** Data used for travelAd click tracking */
export interface PropertyTravelAdTrackingInfoInput {
  beaconIssued?: InputMaybe<Scalars['String']>;
  candidateHmGuid?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['String']>;
  rank?: InputMaybe<Scalars['String']>;
  slots?: InputMaybe<Scalars['String']>;
  testVersionOverride?: InputMaybe<Scalars['String']>;
  trackingData: Scalars['String'];
}

export interface PropertyTypesCarouselLodgingContextInput {
  dateRange?: InputMaybe<DateRangeInput>;
}

export enum PropertyTypesOffersView {
  FULL_BLEED = 'FULL_BLEED',
  IMAGE_GALLERY = 'IMAGE_GALLERY',
}

export interface PushNotificationPreferencesCompletenessModuleRequestInput {
  isPushDeviceSettingsEnabled?: InputMaybe<Scalars['Boolean']>;
  promptDeniedDate?: InputMaybe<Scalars['String']>;
  promptDeniedTimes?: InputMaybe<Scalars['Int']>;
}

export enum QuoteBuilderType {
  BOTTOM = 'BOTTOM',
  RIGHT_SIDE = 'RIGHT_SIDE',
  SIDE = 'SIDE',
}

/** RAFStrategyInput is used to identify the type of sheet to be displayed. */
export enum RAFStrategyInput {
  ADVOCATE = 'ADVOCATE',
  REFERRAL_ENTRYPOINT = 'REFERRAL_ENTRYPOINT',
  REFERRAL_SUCCESS = 'REFERRAL_SUCCESS',
}

export enum RadialProgressionBarType {
  FULL = 'FULL',
  SEGMENTED = 'SEGMENTED',
}

export enum RangeIndicatorSegmentStyle {
  EMPHASIS = 'EMPHASIS',
}

export enum RangeIndicatorSegmentTheme {
  NEGATIVE = 'NEGATIVE',
  NEUTRAL = 'NEUTRAL',
  POSITIVE = 'POSITIVE',
  VERY_POSITIVE = 'VERY_POSITIVE',
}

/** Type used during a product search to specify a given numeric range like the price of a hotel should be between 100 and 200 (USD). */
export interface RangeValueInput {
  id: Scalars['String'];
  max: Scalars['Int'];
  min: Scalars['Int'];
}

export enum RateAdjustmentType {
  Amount = 'Amount',
  Percent = 'Percent',
}

export interface RateCategoryInput {
  /** Is this a group rate offer */
  groupRate?: InputMaybe<Scalars['Boolean']>;
}

export enum RateDiscountType {
  MEMBER_DEAL = 'MEMBER_DEAL',
  MOBILE_EXCLUSIVE = 'MOBILE_EXCLUSIVE',
  REGULAR = 'REGULAR',
  TONIGHT_ONLY = 'TONIGHT_ONLY',
}

export interface RatePlanInfo {
  /** This is the localized name of the child rate plan, will be displayed in partial success result. */
  childRatePlanDisplayName: Scalars['String'];
  childRatePlanID?: InputMaybe<Scalars['String']>;
  parentRatePlanID: Scalars['String'];
  /** This is the name of the rate plan in DB, used to determine the child rate plan name. */
  parentRatePlanName: Scalars['String'];
}

export enum RatePlanType {
  CORPORATE = 'CORPORATE',
  PACKAGE = 'PACKAGE',
  STANDALONE = 'STANDALONE',
  WHOLESALE = 'WHOLESALE',
  WHOLESALE_PACKAGE = 'WHOLESALE_PACKAGE',
}

export enum ReasonCategory {
  ACCOUNT_UPDATE = 'ACCOUNT_UPDATE',
  CANCEL = 'CANCEL',
  CANCEL_OPAQUE = 'CANCEL_OPAQUE',
  CHANGE = 'CHANGE',
  CHARGE = 'CHARGE',
  FINANCIAL_ADJUSTMENT = 'FINANCIAL_ADJUSTMENT',
  POINTS_ADJUSTMENT = 'POINTS_ADJUSTMENT',
  PRICE_MATCH = 'PRICE_MATCH',
}

export interface ReasonCodesInput {
  isOutsidePenalty: Scalars['Boolean'];
  isOverRefund?: InputMaybe<Scalars['Boolean']>;
  lineOfBusinessType: LineOfBusinessType;
  reasonCategory: ReasonCategory;
  tripStage: TripStage;
  waivingSource: WaivingSource;
}

export interface ReasonCodesMutationInput {
  agentId?: InputMaybe<Scalars['String']>;
  agentNotes?: InputMaybe<Scalars['String']>;
  primaryReason: Scalars['String'];
  secondaryReason: Scalars['String'];
}

export enum RecaptureSheetType {
  REASON_SHEET = 'REASON_SHEET',
  SUCCESS_SHEET = 'SUCCESS_SHEET',
}

export enum RecentActivityType {
  BROWSING_HISTORY = 'BROWSING_HISTORY',
  RECENT_SEARCHES = 'RECENT_SEARCHES',
  VIEWED_OFFERS = 'VIEWED_OFFERS',
  VIEWED_PRODUCTS = 'VIEWED_PRODUCTS',
}

export enum RecommendedType {
  BESPOKE = 'BESPOKE',
  DESTINATIONS = 'DESTINATIONS',
  OFFERS = 'OFFERS',
}

/** Input type for recording banner interaction */
export interface RecordBannerInteractionInput {
  /** Represents the banner id where the interaction occurred */
  bannerId: Scalars['String'];
  /** Represents the purpose of banner */
  bannerType: SurfaceBannerType;
  /** Represents the action performed on the banner */
  interactionType: InteractionType;
}

export enum RefreshAction {
  LOGOUT = 'LOGOUT',
  NONE = 'NONE',
}

/** represents configuration for render Payment */
export interface RefreshPaymentModuleConfigurationInput {
  clientDetails: ClientDetailsInput;
  paymentSessionId: Scalars['String'];
}

export interface RefundFormMutationInput {
  additionalRefundInput?: InputMaybe<Scalars['String']>;
  adjustmentBreakdown?: InputMaybe<Array<AdjustmentBreakdownItemInput>>;
  approverContact?: InputMaybe<Scalars['String']>;
  approverFirstName?: InputMaybe<Scalars['String']>;
  approverLastName?: InputMaybe<Scalars['String']>;
  approverTitle?: InputMaybe<Scalars['String']>;
  expediaPortionRefund?: InputMaybe<Scalars['Float']>;
  paymentAssistSessionId?: InputMaybe<Scalars['String']>;
  reasonCodes?: InputMaybe<ReasonCodesMutationInput>;
  reasonCodesAdditional?: InputMaybe<ReasonCodesMutationInput>;
  supplierPortionRefund?: InputMaybe<Scalars['Float']>;
  waivingSource?: InputMaybe<WaivingSource>;
}

export enum RefundStatus {
  Failure = 'Failure',
  Success = 'Success',
}

export enum RefundableType {
  FULLY = 'FULLY',
  NON = 'NON',
  PARTIALLY = 'PARTIALLY',
  UNKNOWN = 'UNKNOWN',
}

/** Enumerated Gaia geographic region types */
export enum RegionType {
  ADDRESS = 'ADDRESS',
  AIRPORT = 'AIRPORT',
  CITY = 'CITY',
  CONTINENT = 'CONTINENT',
  COUNTRY = 'COUNTRY',
  HIGH_LEVEL_REGION = 'HIGH_LEVEL_REGION',
  METRO_STATION = 'METRO_STATION',
  MULTI_CITY_VICINITY = 'MULTI_CITY_VICINITY',
  NEIGHBORHOOD = 'NEIGHBORHOOD',
  POINT_OF_INTEREST = 'POINT_OF_INTEREST',
  PREMISE = 'PREMISE',
  PROVINCE_STATE = 'PROVINCE_STATE',
  TRAIN_STATION = 'TRAIN_STATION',
  UNKNOWN = 'UNKNOWN',
}

export interface RemovePartnerAccountUserRequestInput {
  partnerAccountId: Scalars['String'];
  userId: Scalars['String'];
}

export interface RemovePaymentMethodRequestInput {
  checkoutSessionMode?: InputMaybe<CheckoutSessionMode>;
  paymentMethod: PaymentMethodInput;
  sessionId: Scalars['String'];
  sessionToken: Scalars['String'];
}

export enum RequestSourceInput {
  IMPROVE_VISIBILITY_OPPORTUNITY_CARD = 'IMPROVE_VISIBILITY_OPPORTUNITY_CARD',
}

export interface ReservationContext {
  conversationId?: InputMaybe<Scalars['String']>;
  isManualBookingVr?: InputMaybe<Scalars['Boolean']>;
  reservationId?: InputMaybe<Scalars['String']>;
}

export enum ReservationModifiersCancellationFeeOptionType {
  CUSTOM_FEE = 'CUSTOM_FEE',
  FULL_FEE = 'FULL_FEE',
  NO_FEE = 'NO_FEE',
}

export enum ReservationModifiersRefundAmountOptionType {
  CUSTOM_AMOUNT = 'CUSTOM_AMOUNT',
  PERCENTAGE_AMOUNT = 'PERCENTAGE_AMOUNT',
}

export enum ReservationModifiersScreenType {
  CONFIRM_DETAILS = 'CONFIRM_DETAILS',
  EMPATHY = 'EMPATHY',
  LINK_TO_LEGACY = 'LINK_TO_LEGACY',
  MENU = 'MENU',
  REVIEW_CHANGES = 'REVIEW_CHANGES',
  REVIEW_DETAILS_CHANGES = 'REVIEW_DETAILS_CHANGES',
  REVIEW_TERMS = 'REVIEW_TERMS',
  SET_CANCELLATION_FEE = 'SET_CANCELLATION_FEE',
  SET_CANCELLATION_REASON = 'SET_CANCELLATION_REASON',
  SET_MESSAGE_TO_GUEST = 'SET_MESSAGE_TO_GUEST',
  SET_REFUND_AMOUNT = 'SET_REFUND_AMOUNT',
  SET_REFUND_REASON = 'SET_REFUND_REASON',
  SET_RESERVATION_DETAILS = 'SET_RESERVATION_DETAILS',
  SET_STAY_DATES = 'SET_STAY_DATES',
  SUCCESS = 'SUCCESS',
  VR_SET_REFUND_AMOUNT = 'VR_SET_REFUND_AMOUNT',
}

export enum ReservationModifiersType {
  CANCEL = 'CANCEL',
  CHANGE_DATES = 'CHANGE_DATES',
  GUEST_SATISFACTION_REFUND = 'GUEST_SATISFACTION_REFUND',
  NO_SHOW = 'NO_SHOW',
  UPDATE_DETAILS = 'UPDATE_DETAILS',
}

export enum ReservationModifiersVRCancelRefundLevel {
  FULL = 'FULL',
  HALF = 'HALF',
  ZERO = 'ZERO',
}

export interface ResidencyDetailsInput {
  /** Country code Selection */
  countryCode?: InputMaybe<Scalars['String']>;
  /** Region code Selection */
  regionCode?: InputMaybe<Scalars['String']>;
  userProvided?: InputMaybe<Scalars['Boolean']>;
}

export enum ResidencyState {
  APPLIED = 'APPLIED',
  AVAILABLE = 'AVAILABLE',
}

export enum ResponseStatus {
  ERROR = 'ERROR',
  SUCCESS = 'SUCCESS',
}

export enum ResponseTagType {
  CACHE_SOURCE_AIRBLAZE = 'CACHE_SOURCE_AIRBLAZE',
  CACHE_SOURCE_BYOT_AIRBLAZE = 'CACHE_SOURCE_BYOT_AIRBLAZE',
  EXPERIENCE_SEARCH_CACHE_HYDRATOR = 'EXPERIENCE_SEARCH_CACHE_HYDRATOR',
  LISTINGS_PAGINATED_SLICED = 'LISTINGS_PAGINATED_SLICED',
  LISTING_CACHE_SOURCE = 'LISTING_CACHE_SOURCE',
  LISTING_DOWNLEVEL_SOURCE = 'LISTING_DOWNLEVEL_SOURCE',
  MAIN_SEARCH_STACK = 'MAIN_SEARCH_STACK',
  RESPONSE_SUMMARY_CACHED_CONFIG = 'RESPONSE_SUMMARY_CACHED_CONFIG',
  RESPONSE_SUMMARY_CACHED_ML = 'RESPONSE_SUMMARY_CACHED_ML',
  RESPONSE_SUMMARY_HYBRID = 'RESPONSE_SUMMARY_HYBRID',
  RESPONSE_SUMMARY_LIVE = 'RESPONSE_SUMMARY_LIVE',
  RESPONSE_SUMMARY_REFINEMENTS_CACHE_LIVE = 'RESPONSE_SUMMARY_REFINEMENTS_CACHE_LIVE',
  RESPONSE_SUMMARY_REFINEMENTS_CACHE_REDIS = 'RESPONSE_SUMMARY_REFINEMENTS_CACHE_REDIS',
  RESPONSE_SUMMARY_REFINEMENTS_USER_CACHE = 'RESPONSE_SUMMARY_REFINEMENTS_USER_CACHE',
  TEST_SEARCH_STACK = 'TEST_SEARCH_STACK',
  UNRECOGNIZED = 'UNRECOGNIZED',
}

/** represents configuration for submit Payment */
export interface ResumePaymentConfigurationInput {
  actions: Array<Action>;
  clientDetails: ClientDetailsInput;
  fopItems: Array<OneCPMFOPItemInput>;
  paymentProcessingData: PaymentProcessorDataInput;
  paymentSessionId: Scalars['String'];
}

/** Input object for the loyalty rewards module */
export interface RetailTravelAgentRewardsInput {
  /** Intent to enroll in the program */
  intentToEnroll?: InputMaybe<Scalars['Boolean']>;
  /** Loading type for loyalty points */
  loyaltyPointsLoadingType?: InputMaybe<RetailTravelAgentRewardsLoadingType>;
}

/** Type of loading for the loyalty points module */
export enum RetailTravelAgentRewardsLoadingType {
  EAGER = 'EAGER',
  LAZY = 'LAZY',
  OFF = 'OFF',
}

/** Type of the message */
export enum RetailTravelAgentRewardsMessageType {
  CRITICAL = 'CRITICAL',
  ERROR = 'ERROR',
}

export interface ReviewAnswerInput {
  answer?: InputMaybe<ReviewsFormRatingValueInput>;
  questionUrn: Scalars['String'];
}

export enum ReviewFormInteractionType {
  EXTERNAL = 'EXTERNAL',
  GRAPHQL = 'GRAPHQL',
  TRANSITION = 'TRANSITION',
}

/** Enum of types of review interactions */
export enum ReviewInteractionType {
  HELPFUL_REVIEW = 'HELPFUL_REVIEW',
  REVIEW_COLLAPSE_LABEL = 'REVIEW_COLLAPSE_LABEL',
  REVIEW_EXPAND_LABEL = 'REVIEW_EXPAND_LABEL',
  REVIEW_REPORT_FLAG = 'REVIEW_REPORT_FLAG',
}

export interface ReviewScoreRangeInput {
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
}

export enum ReviewSource {
  EXTERNAL_REVIEWS = 'EXTERNAL_REVIEWS',
  INTERNAL_REVIEWS = 'INTERNAL_REVIEWS',
}

export enum ReviewsCarouselCTALocation {
  ERROR_PAGE = 'ERROR_PAGE',
  REVIEW_PAGE = 'REVIEW_PAGE',
  THANK_YOU_PAGE = 'THANK_YOU_PAGE',
  TRIPS_PAGE = 'TRIPS_PAGE',
  UNKNOWN = 'UNKNOWN',
}

export interface ReviewsFormRatingValueInput {
  boolValue?: InputMaybe<Scalars['Boolean']>;
  numberValue?: InputMaybe<Scalars['Int']>;
  stringValue?: InputMaybe<Scalars['String']>;
  tagValue?: InputMaybe<ReviewsFormTagValueInput>;
}

export interface ReviewsFormTagValueInput {
  actionType?: InputMaybe<Scalars['String']>;
  customValue?: InputMaybe<Scalars['String']>;
  tagUrns: Array<Scalars['String']>;
}

export enum RewardsOption {
  ALTAIR = 'ALTAIR',
  AVION = 'AVION',
  NONAVION = 'NONAVION',
}

export enum RewardsPointSelectionEnum {
  APPLY_REWARD_POINTS = 'APPLY_REWARD_POINTS',
  DO_NOT_APPLY_REWARD_POINTS = 'DO_NOT_APPLY_REWARD_POINTS',
}

/** Possible user's state regarding the loyalty program */
export enum RewardsProgramState {
  ENROLLED = 'ENROLLED',
  NOT_ENROLLED = 'NOT_ENROLLED',
}

/** Represents the placement where the widget is displayed */
export enum RewardsSummaryWidgetPlacement {
  GLOBAL_NAV = 'GLOBAL_NAV',
  UNIVERSAL_PROFILE = 'UNIVERSAL_PROFILE',
}

export interface RoleGroupsInput {
  productIds: Array<Scalars['String']>;
}

/** A single hotel room configuration */
export interface RoomInput {
  /** The number of adult in the room */
  adults: Scalars['Int'];
  /** The number of children in the room */
  children?: InputMaybe<Array<ChildInput>>;
}

/** Create Salesforce Case Request Input */
export interface SalesforceCaseInputModelInput {
  /** Attachment Files */
  attachments?: InputMaybe<Array<AttachmentFileInput>>;
  /** cc Email */
  ccEmail: Scalars['String'];
  /** Description */
  description: Scalars['String'];
  /** EG User Id */
  egUserId: Scalars['String'];
  /** Partner Account Id */
  partnerAccountId: Scalars['String'];
  /** Partner Account Name */
  partnerAccountName?: InputMaybe<Scalars['String']>;
  /** Help and Support Sub-Subtype */
  subSubtype?: InputMaybe<Scalars['String']>;
  /** Help and Support Sub-Type */
  subType?: InputMaybe<Scalars['String']>;
  /** Subject */
  subject: Scalars['String'];
  /** Supplied Email */
  suppliedEmail: Scalars['String'];
  /** Supplied First Name */
  suppliedFirstName: Scalars['String'];
  /** Supplied Last Name */
  suppliedLastName: Scalars['String'];
  /** Help and Support Type */
  type?: InputMaybe<Scalars['String']>;
}

export interface SaveBrandResultListingCreativeInput {
  bwLogo?: InputMaybe<MediaUploadInput>;
  campaignCreativeData?: InputMaybe<CampaignCreativeDataInput>;
  clickThroughURL?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  headline?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<MediaUploadInput>;
  logo?: InputMaybe<MediaUploadInput>;
  logoDimensions?: InputMaybe<ImageDimensionsInput>;
  sponsoredLabel?: InputMaybe<Scalars['String']>;
}

export interface SaveCreativeInput {
  adCreativeType?: InputMaybe<Array<AdCreativeType>>;
  adName?: InputMaybe<Scalars['String']>;
  airlineName?: InputMaybe<Scalars['String']>;
  bwLogo?: InputMaybe<MediaUploadInput>;
  campaignCreativeData?: InputMaybe<CampaignCreativeDataInput>;
  clickThroughUrl?: InputMaybe<Scalars['String']>;
  clickThroughUrlLabel?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  featuredImages?: InputMaybe<Array<TileInputSectionInput>>;
  headline?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<MediaUploadInput>;
  locales?: InputMaybe<Array<Scalars['String']>>;
  logo?: InputMaybe<MediaUploadInput>;
  logoDimensions?: InputMaybe<ImageDimensionsInput>;
}

export interface SavePrefRequestInput {
  canSell: Scalars['Boolean'];
}

export interface SaveReviewAnswersRequestInput {
  orderId?: InputMaybe<Scalars['String']>;
  orderLineId?: InputMaybe<Scalars['String']>;
  reviewAnswers?: InputMaybe<Array<ReviewAnswerInput>>;
  reviewId?: InputMaybe<Scalars['String']>;
}

export enum Scenario {
  AUTHENTICATED = 'AUTHENTICATED',
  CHANGE_EMAIL = 'CHANGE_EMAIL',
  CHANGE_PASSWORD = 'CHANGE_PASSWORD',
  CHECKOUT_SIGNIN = 'CHECKOUT_SIGNIN',
  CHECKOUT_SIGNUP = 'CHECKOUT_SIGNUP',
  PROFILE = 'PROFILE',
  SIGNIN = 'SIGNIN',
  SIGNUP = 'SIGNUP',
}

export enum ScheduleTemplateSendStatus {
  FAILED = 'FAILED',
  NOT_SCHEDULED = 'NOT_SCHEDULED',
  PENDING = 'PENDING',
  SENT = 'SENT',
  SKIPPED = 'SKIPPED',
}

/** Used to pass search criteria for a product */
export interface SearchContextInput {
  /** Represents the dates for a search */
  dateRange?: InputMaybe<DateRangeInput>;
  /** Geographic information about search being performed */
  destination?: InputMaybe<DestinationInput>;
}

/** SearchCriteriaSelections */
export interface SearchCriteriaSelectionsInput {
  /** Id */
  id: Scalars['String'];
  /** value */
  value: Scalars['String'];
}

export interface SearchFormPriceInsightsDailyInput {
  checkInDate: DateInput;
  checkOutDate: DateInput;
  gaiaId: Scalars['String'];
}

/** Search form Product Selector Type */
export enum SearchFormProductSelectorType {
  /** Use condensed with pictograms, available in APP */
  CONDENSED_PICTOGRAMS = 'CONDENSED_PICTOGRAMS',
  /** Use condensed with pictograms and using tabs, available in APP and WEB */
  CONDENSED_PICTOGRAMS_TABS = 'CONDENSED_PICTOGRAMS_TABS',
  /** Use condensed with tabs, available in WEB */
  CONDENSED_TABS = 'CONDENSED_TABS',
  /** Use grid with icons, available in APP */
  GRID_ICONS = 'GRID_ICONS',
  /** Use grid with pictograms, available in APP */
  GRID_PICTOGRAMS = 'GRID_PICTOGRAMS',
}

/** Search form product types */
export enum SearchFormProductType {
  ACTIVITIES = 'ACTIVITIES',
  ALL_INCLUSIVE = 'ALL_INCLUSIVE',
  CARS = 'CARS',
  CRUISES = 'CRUISES',
  EVENTS = 'EVENTS',
  FLIGHTS = 'FLIGHTS',
  LODGING = 'LODGING',
  PACKAGES = 'PACKAGES',
}

/** Search history grouping day range. */
export enum SearchHistoryDayRange {
  /** Grouping using searches made 7 days from most recent search in same region */
  SEVEN_DAYS = 'SEVEN_DAYS',
  /** Grouping using searches made 3 days from most recent search in same region */
  THREE_DAYS = 'THREE_DAYS',
}

/** Search history grouping destination type. */
export enum SearchHistoryDestinationType {
  /** Grouping using multi_city_vicinity destination type for searches. */
  METRO_CITY = 'METRO_CITY',
}

/** Filter criteria details for the searchHistory query. */
export interface SearchHistoryFilterCriteriaInput {
  /** Search item end date in yyyy-MM-dd format. */
  endDate: Scalars['String'];
  /** Search item regionId. */
  regionId: Scalars['String'];
  /** Search item region type. */
  regionType?: InputMaybe<Scalars['String']>;
  /** Search item start date in yyyy-MM-dd format. */
  startDate: Scalars['String'];
}

/** Criteria based on search history groups are created. */
export interface SearchHistoryGroupingCriteriaInput {
  /** Search history grouping based on specified day range. */
  dayRange?: InputMaybe<SearchHistoryDayRange>;
  /** Search history grouping based on specified destination type. */
  destinationType?: InputMaybe<SearchHistoryDestinationType>;
}

/** User Intent corresponding to this Search */
export interface SearchIntentInput {
  /** DEPRECATED. Use semdtl. SEM param, fetch from URL */
  semDtl?: InputMaybe<Scalars['String']>;
  /** SEM param, fetch from URL */
  semdtl?: InputMaybe<Scalars['String']>;
  /** TEMP Theme param, fetch from URL. Remove after SEM migration is complete */
  theme?: InputMaybe<Scalars['String']>;
  /** TEMP intent param, fetch from URL. Support BFF while migration to BEX API */
  userIntent?: InputMaybe<Scalars['String']>;
}

/** Used to represent the response status of the search location actions */
export enum SearchLocationActionStatus {
  FAIL = 'FAIL',
  SUCCESS = 'SUCCESS',
}

/** Used to represent the criteria required for search location query */
export interface SearchLocationCriteriaInput {
  /** Used to represent the request is for origin or destination field */
  isDestination?: InputMaybe<Scalars['Boolean']>;
  /** Used to represent if the request is for airport field of GroundTransfers */
  isGroundTransfersAirport?: InputMaybe<Scalars['Boolean']>;
  /** Used for alternate destination recommendations */
  lastSearchLatLong?: InputMaybe<CoordinatesInput>;
  /**
   * Used to represent the line of business of the request. Possible values are 'HOTELS', 'PACKAGES', 'ACTIVITIES', 'FLIGHT', 'CAR',
   * 'CRUISES' and 'GROUNDTRANSFERS' (values available on LineOfBusiness enum).
   */
  lineOfBusiness: Scalars['String'];
  /** Used to represent the flights origin airport code */
  originAirport?: InputMaybe<Scalars['String']>;
  /** Used to represent the type of package when PACKAGES lob is selected. Possible values are 'fhc', 'fh', 'fc', 'hc' */
  packageType?: InputMaybe<Scalars['String']>;
  /** Used to represent the location of the page from which the request is being called */
  pageLocation?: InputMaybe<PageLocation>;
  /** Used to represent an id tied to a user's search session */
  searchSessionId?: InputMaybe<Scalars['String']>;
  /** Used to represent the text typed by the user */
  searchTerm?: InputMaybe<Scalars['String']>;
}

/** Used to represent a single user search event for analytics and user behavior tracking */
export interface SearchLocationInteractionEventInput {
  /** Used to group related search interaction within a user's session */
  collationId?: InputMaybe<Scalars['String']>;
  /** Used to indicate when the search interaction occurred */
  timestamp?: InputMaybe<Scalars['String']>;
}

/**
 * Enum to represent the different source services of search location
 * in order to display/provide proper attribution
 */
export enum SearchLocationSource {
  EGTYPEAHEAD = 'EGTYPEAHEAD',
  GOOGLE = 'GOOGLE',
  PERSONALIZATION = 'PERSONALIZATION',
  RECOMMENDATIONS = 'RECOMMENDATIONS',
}

/** The offer details from the search results page */
export interface SearchOfferInput {
  /** Type used during a product search to specify a given selection like the airline the customer would like to fly with. */
  offerDetails?: InputMaybe<Array<SelectedValueInput>>;
  /** The price of the search results offer */
  offerPrice?: InputMaybe<SearchOfferPriceInput>;
  ratePlanId?: InputMaybe<Scalars['String']>;
  roomTypeId?: InputMaybe<Scalars['String']>;
}

/** The offer price from the search results page */
export interface SearchOfferPriceInput {
  /** The encoded multi-item price token */
  multiItemPriceToken?: InputMaybe<Scalars['String']>;
  /** The timestamp of when the SRP offer price was generated */
  offerTimestamp?: InputMaybe<Scalars['String']>;
  /** Flag indicating if points are applied to price.  This will enable proper price comparison for mismatch detection. */
  pointsApplied?: InputMaybe<Scalars['Boolean']>;
  /** The total price of the search offer */
  price?: InputMaybe<MoneyInput>;
}

/** Enum of types of review interactions */
export enum SeatChoiceType {
  SEAT_CHOICE = 'SEAT_CHOICE',
}

/** Enum representing seat action states */
export enum SeatSelectionState {
  SELECT = 'SELECT',
  UNSELECT = 'UNSELECT',
}

/** Enum class to represent the seat type variant. */
export enum SeatVariant {
  ACCESSIBLE = 'ACCESSIBLE',
  AISLE = 'AISLE',
  AVAILABLE = 'AVAILABLE',
  COLUMN = 'COLUMN',
  EXIT = 'EXIT',
  GALLEY = 'GALLEY',
  PREFERRED = 'PREFERRED',
  RESTROOM = 'RESTROOM',
  ROW = 'ROW',
  SELECTED = 'SELECTED',
  UNAVAILABLE = 'UNAVAILABLE',
}

export enum SectionType {
  ORDERED_LIST = 'ORDERED_LIST',
  PARAGRAPH = 'PARAGRAPH',
  UNORDERED_LIST = 'UNORDERED_LIST',
}

export interface SelectFopConfigurationInput {
  clientDetails: ClientDetailsInput;
  fopItems: Array<OneCPMFOPItemInput>;
  paymentSessionId: Scalars['String'];
}

export interface SelectPaymentMethodRequestInput {
  checkoutIdentifier: PaymentCheckoutIdentifierInput;
  checkoutSessionMode?: InputMaybe<CheckoutSessionMode>;
  fopItems: Array<FOPItemInput>;
}

/** Type for Selected Baggage template */
export enum SelectedAncillaryTemplateType {
  MULTIPLE = 'MULTIPLE',
  NONE = 'NONE',
  ONE = 'ONE',
}

/** Represents the input type of conversation delete mutation */
export interface SelectedConversationContextInput {
  authConfig?: InputMaybe<AuthenticationConfigInput>;
  conversationId?: InputMaybe<Scalars['String']>;
  conversationType?: InputMaybe<ConversationType>;
}

/** The saved quote data when an agent returns from PaxLounge */
export interface SelectedSavedQuoteInput {
  originalQuotedPrice: Scalars['String'];
  ratePlanId: Scalars['String'];
  roomId: Scalars['String'];
}

/** Type used during a product search to specify a given selection like the airline the customer would like to fly with. */
export interface SelectedValueInput {
  id: Scalars['String'];
  value: Scalars['String'];
}

/**
 * Defines the type of selection interaction supported by the group.
 * This is crucial for implementing the correct logic on the client and the server.
 */
export enum SelectionType {
  MULTIPLE = 'MULTIPLE',
  SINGLE = 'SINGLE',
}

export interface ServiceActionInput {
  action: ServiceActionType;
  serviceId: Scalars['String'];
}

export enum ServiceActionType {
  CONNECT = 'CONNECT',
  DISCONNECT = 'DISCONNECT',
}

export enum ServiceAutomationToolbarElevation {
  FLAT = 'FLAT',
  FLOATING = 'FLOATING',
}

export enum ServiceAutomationToolbarNavType {
  BACK = 'BACK',
  CLOSE = 'CLOSE',
  EXPAND_UP = 'EXPAND_UP',
}

/** Represents payment session attributes */
export interface SessionConfigsInput {
  allowedPaymentMethods: Array<AllowedPaymentMethodInput>;
  disablePaymentMethodSelection: Scalars['Boolean'];
}

/** Represents payment session details */
export interface SessionDetailsInput {
  configs?: InputMaybe<SessionConfigsInput>;
  id: Scalars['String'];
}

export interface ShareContextInput {
  /** Call Downstream Services */
  callToDownStreamServices?: InputMaybe<Scalars['Boolean']>;
  /** List of destinationIds */
  destinationId?: InputMaybe<Scalars['String']>;
  /** ForgeType to be resolved by Blacksmith. */
  forgeType?: InputMaybe<Scalars['String']>;
  /** Share UseCase Screenshot */
  hasScreenShot?: InputMaybe<Scalars['Boolean']>;
  /** Line Of Business */
  lineOfBusiness?: InputMaybe<AppGrowthLineOfBusiness>;
  /** Page Id to read page Type ex Hotel Infosite, Destination Travel Guides */
  pageId?: InputMaybe<Scalars['String']>;
  /** Property Id */
  propertyId?: InputMaybe<Scalars['String']>;
  /** Rffr URL for Web and mWeb Use Case */
  rffrURL?: InputMaybe<Scalars['String']>;
  /** Trip Id */
  tripId?: InputMaybe<Scalars['String']>;
  /** List of user Selected Filters */
  userSelectedFilters?: InputMaybe<Array<UserSelectedFiltersInput>>;
}

/** Used to specify the LOB specific parameters to build the share link. */
export interface ShareDestinationContextInput {
  activityId?: InputMaybe<Scalars['String']>;
  airportTLA?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<UserSelectedFiltersInput>>;
  propertyId?: InputMaybe<Scalars['String']>;
  regionId?: InputMaybe<Scalars['String']>;
  tripId?: InputMaybe<Scalars['String']>;
}

export enum ShareType {
  REGULAR = 'REGULAR',
  SCREENSHOT = 'SCREENSHOT',
}

export enum SharedUICardMode {
  CREATE = 'CREATE',
  EDIT = 'EDIT',
  READ = 'READ',
}

export enum SharedUICardType {
  PARTNER_ACCOUNT = 'PARTNER_ACCOUNT',
  PARTNER_SELECT = 'PARTNER_SELECT',
  PAYMENT_PROFILE = 'PAYMENT_PROFILE',
  TAX_PROFILE = 'TAX_PROFILE',
}

/** SheetState represent sheet state like expanded/collapsed */
export enum SheetState {
  COLLAPSED = 'COLLAPSED',
  FULL = 'FULL',
  HALF = 'HALF',
}

export interface ShopInsurtechOffersRequestInput {
  /** Optional for explicitly passing the offeritem that we possibly want to provide insurance coverage  */
  coveredOfferItemsId?: InputMaybe<Scalars['String']>;
  /** Client id that refer to the page the user reach out to the module from, e.g.: eg_checkout, car_info_site. */
  insurtechClientId: InsurtechClientId;
  /** Residency details to get details according to country and region */
  residencyDetails?: InputMaybe<ResidencyDetailsInput>;
  /** identify whether the residency already applied or available */
  residencyState?: InputMaybe<ResidencyState>;
  /** Session ID */
  sessionIdentifier?: InputMaybe<Scalars['String']>;
}

export interface ShoppedProductInput {
  products: MultiItemProductsInput;
  shoppingPath: ShoppingPathType;
}

/** An enum to represent the style of button */
export enum ShoppingButtonType {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
  TERTIARY = 'TERTIARY',
}

export enum ShoppingCoachmarkVersion {
  V2 = 'V2',
  V3 = 'V3',
}

/** The shopping context used for all search paths, contains the search contexts for the different shopping paths */
export interface ShoppingContextInput {
  multiItem?: InputMaybe<MultiItemContextInput>;
  queryTriggeredBy?: InputMaybe<Scalars['String']>;
  typeaheadCollationId?: InputMaybe<Scalars['UUID']>;
}

/** An enum to represent shopping function type */
export enum ShoppingFunctionType {
  CALLBACK = 'CALLBACK',
  SHARED_UI = 'SHARED_UI',
}

/** Used to indicate what type of markup a field contains */
export enum ShoppingMarkupTextType {
  /** Hypertext markup language */
  HTML = 'HTML',
}

export enum ShoppingPage {
  PDP = 'PDP',
  SRP = 'SRP',
}

/** Indicate the shopping path of a given offer */
export enum ShoppingPathType {
  ATTACH = 'ATTACH',
  PACKAGE = 'PACKAGE',
  STANDALONE = 'STANDALONE',
}

export enum ShoppingPlacementType {
  BOTTOM = 'BOTTOM',
  RIGHT = 'RIGHT',
}

/** Key/Value elements that describes the search criteria often displayed to the customer as filters */
export interface ShoppingSearchCriteriaInput {
  booleans?: InputMaybe<Array<BooleanValueInput>>;
  counts?: InputMaybe<Array<NumberValueInput>>;
  dates?: InputMaybe<Array<DateValueInput>>;
  ranges?: InputMaybe<Array<RangeValueInput>>;
  selections?: InputMaybe<Array<SelectedValueInput>>;
}

export enum ShoppingSelectableCardState {
  DISABLED = 'DISABLED',
  SELECTED = 'SELECTED',
  UNSELECTED = 'UNSELECTED',
}

/** Valid actions on Sort and Filter Modal */
export enum ShoppingSortAndFilterActionType {
  /** Stay on the Sort & Filter Modal but set to default state. Eg used for clear button */
  CLEAR_DATA = 'CLEAR_DATA',
  /** Close Sort & Filter Modal and apply user selected filters. Eg used for Apply/Done buttons */
  CLOSE_AND_APPLY = 'CLOSE_AND_APPLY',
  /** Close Sort & Filter Modal. Eg used for Back/Cross buttons */
  CLOSE_AND_DO_NOT_APPLY = 'CLOSE_AND_DO_NOT_APPLY',
  /**
   * Open the modal window associated with the component on which action has been performed.
   * Example: on click of Sort & Filter reveal button it should open Sort & Filter Modal and
   * on click of Input Field it should open Typeahead Modal
   */
  OPEN_MODAL = 'OPEN_MODAL',
}

/** Type of Slider on Sort and Filter Modal */
export enum ShoppingSortAndFilterSliderType {
  /** Dual Sort & Filter Slider, slider will be dual Ticked and both min & max value can be adjusted */
  DUAL = 'DUAL',
  /** Single Sort & Filter Slider, slider will be single Ticked and only max value can be adjusted */
  SINGLE = 'SINGLE',
}

export enum ShoppingTabsNavType {
  JUMPLINK = 'JUMPLINK',
  NATURAL = 'NATURAL',
}

/** ShoppingTriggerType specifies how an action should be triggered (click, hover, etc.) */
export enum ShoppingTriggerType {
  CLICK = 'CLICK',
  HOVER = 'HOVER',
  LOAD = 'LOAD',
}

/** The saved quote data when an agent returns from PaxLounge */
export interface SideSheetQueryContextInput {
  addOnRequested: Array<AddOnRequested>;
  isFirstLoad?: InputMaybe<Scalars['Boolean']>;
  journeyContinuationId: Scalars['String'];
}

export enum SideSheetType {
  ALLINCLUSIVE = 'ALLINCLUSIVE',
  BREAKFAST = 'BREAKFAST',
  CONTRACTUAL = 'CONTRACTUAL',
  FULLBOARD = 'FULLBOARD',
  HALFBOARD = 'HALFBOARD',
  NONREFUNDABLE = 'NONREFUNDABLE',
  PACKAGE = 'PACKAGE',
  REFUNDABLE = 'REFUNDABLE',
}

export enum SignalType {
  BOOKING_SUCCESS = 'BOOKING_SUCCESS',
  CONFIGURATION_ADDED = 'CONFIGURATION_ADDED',
  DUPLICATE_REQUEST = 'DUPLICATE_REQUEST',
  INVALID_EMAIL = 'INVALID_EMAIL',
  OFFER_ADDED = 'OFFER_ADDED',
  OFFER_CHANGED = 'OFFER_CHANGED',
  OFFER_REMOVED = 'OFFER_REMOVED',
  OFFER_UNAVAILABLE = 'OFFER_UNAVAILABLE',
  OPERATION_FAILED = 'OPERATION_FAILED',
  PAYMENT_ERROR = 'PAYMENT_ERROR',
  PAYMENT_METHODS_APPLIED = 'PAYMENT_METHODS_APPLIED',
  PAYMENT_METHOD_UPDATED = 'PAYMENT_METHOD_UPDATED',
  PRICE_ADJUSTED = 'PRICE_ADJUSTED',
  PRICE_CHANGED = 'PRICE_CHANGED',
  REQUEST_CONFLICT = 'REQUEST_CONFLICT',
  SESSION_EXPIRED = 'SESSION_EXPIRED',
  SESSION_TOKEN_UPDATED = 'SESSION_TOKEN_UPDATED',
  SIGNAL_TYPE_INVALID = 'SIGNAL_TYPE_INVALID',
  UNRECOGNIZED = 'UNRECOGNIZED',
  UNRECOVERABLE_FAILURE = 'UNRECOVERABLE_FAILURE',
}

export interface SimilarDestinationsCriteriaInput {
  destinationId: Scalars['String'];
  includeOrigin?: InputMaybe<Scalars['Boolean']>;
  lob?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
  useCaseId?: InputMaybe<Scalars['String']>;
}

export interface SimilarFlightsContextInput {
  offerIdentifier?: InputMaybe<Scalars['String']>;
}

/** Enum for flex alignment values */
export enum SimpleTextExplainabilityHorizontalPosition {
  CENTER = 'CENTER',
  LEFT = 'LEFT',
}

/** Input argument for Sites configurations request */
export interface SiteConfigurationsRequestInput {
  /** List of Site IDs to retrieve site information for */
  siteIds: Array<Scalars['Int']>;
}

export interface SmartFormDataInput {
  /** Timestamp at which this mutation was sent by the client. */
  timestamp: Scalars['String'];
  userInput: SmartFormUserInput;
}

export enum SmartFormHeadingSizeInput {
  EIGHT = 'EIGHT',
  FIVE = 'FIVE',
  FOUR = 'FOUR',
  ONE = 'ONE',
  SEVEN = 'SEVEN',
  SIX = 'SIX',
  THREE = 'THREE',
  TWO = 'TWO',
}

export enum SmartFormHeadingTagInput {
  H1 = 'H1',
  H2 = 'H2',
  H3 = 'H3',
  H4 = 'H4',
  H5 = 'H5',
  H6 = 'H6',
}

/** EGDS equivalent Spacing values to be used on SmartForm elements. */
export enum SmartFormSpacingSize {
  EIGHT = 'EIGHT',
  FOUR = 'FOUR',
  HALF = 'HALF',
  ONE = 'ONE',
  SIX = 'SIX',
  SIXTEEN = 'SIXTEEN',
  THREE = 'THREE',
  TWELVE = 'TWELVE',
  TWO = 'TWO',
  UNSET = 'UNSET',
}

/** To define which type of keystrokes will be considered by this input. */
export enum SmartFormTextInputVariant {
  EMAIL = 'EMAIL',
  NUMERIC = 'NUMERIC',
  TEL = 'TEL',
  TEXT = 'TEXT',
  TEXTAREA = 'TEXTAREA',
}

export enum SmartFormType {
  BILLING_ADDRESS = 'BILLING_ADDRESS',
  CONTACT_INFORMATION = 'CONTACT_INFORMATION',
  MESSAGE_TO_HOST = 'MESSAGE_TO_HOST',
  SPECIAL_REQUEST = 'SPECIAL_REQUEST',
}

/** Value collected corresponding to a field represented by inputId */
export interface SmartFormUserFieldInput {
  inputId: Scalars['String'];
  value: Array<Scalars['String']>;
}

/** Collection of the values collected corresponding to fields */
export interface SmartFormUserInput {
  userFieldInputs: Array<SmartFormUserFieldInput>;
}

export interface SmokingTypeSelectedInput {
  nonSmokingSelected: Scalars['Boolean'];
  smokingSelected: Scalars['Boolean'];
}

export interface SocialAuthContextSubmitRequestInput {
  errorCode?: InputMaybe<Scalars['String']>;
  redirectionContext?: InputMaybe<IdentityRedirectionContextInput>;
  socialType?: InputMaybe<IdentitySocialType>;
}

export interface SocialAuthSubmitRequestInput {
  atoInputs?: InputMaybe<Array<IdentityAccountTakeOverInput>>;
  socialType?: InputMaybe<IdentitySocialType>;
}

/** Represents client context input for public profile queries */
export interface SocialConnectionsClientContextInput {
  lineOfBusiness: LineOfBusinessDomain;
  pageId?: InputMaybe<Scalars['String']>;
  pageLocation: PageLocation;
}

/** Represents the manageSocialConnection mutation request */
export interface SocialConnectionsManageConnectionRequestInput {
  type: SocialConnectionsManageConnectionRequestType;
  /** The encrypted user token */
  userToken: Scalars['String'];
}

export enum SocialConnectionsManageConnectionRequestType {
  ACCEPT = 'ACCEPT',
  REJECT = 'REJECT',
  REMOVE = 'REMOVE',
  REQUEST = 'REQUEST',
}

/** Represents the Profile details request */
export interface SocialConnectionsProfileDetailsRequestInput {
  /** The encrypted user token */
  userToken?: InputMaybe<Scalars['String']>;
}

export interface SocialConnectionsProfileSettingsSectionInput {
  groupName: Scalars['String'];
  selectedValues: Array<Scalars['String']>;
}

/** Represents the savePublicProfileSettings mutation request */
export interface SocialConnectionsSaveProfileSettingsRequestInput {
  sections: Array<SocialConnectionsProfileSettingsSectionInput>;
}

export enum SocialInteractionPostType {
  VIDEO = 'VIDEO',
}

export interface SocialShareContextInput {
  /** Parameters used by each LOB to call the build the appropiate URL. */
  destinationContext?: InputMaybe<ShareDestinationContextInput>;
  /** Parameter to decide if a share link should be generated. */
  generateShareLink: Scalars['Boolean'];
  /** Line of business, used to identify use case. */
  lineOfBusiness?: InputMaybe<LineOfBusinessDomain>;
  /** Optional pageId to identify the page. This is mostly used for Native Apps as they don't forward a pageId from the request headers. */
  optionalPageId?: InputMaybe<Scalars['String']>;
  /** Referrer URL for building the share link. */
  referrerUrl?: InputMaybe<Scalars['String']>;
  /** Type of share, used to identify the share content. */
  shareType?: InputMaybe<ShareType>;
  /** Strategy used to build the share link. */
  strategy?: InputMaybe<SocialShareStrategy>;
}

export enum SocialShareStrategy {
  ACTIVITY = 'ACTIVITY',
  DESTINATION_GUIDES = 'DESTINATION_GUIDES',
  FLIGHT = 'FLIGHT',
  FLIGHT_SEARCH = 'FLIGHT_SEARCH',
  PACKAGE_DETAILS = 'PACKAGE_DETAILS',
  PROPERTY = 'PROPERTY',
  PROPERTY_SEARCH = 'PROPERTY_SEARCH',
  REFER_A_FRIEND = 'REFER_A_FRIEND',
  REQUEST_TO_JOIN_TRIP = 'REQUEST_TO_JOIN_TRIP',
  TRIP_INVITE = 'TRIP_INVITE',
}

/**
 * "
 * Type of operation to perform.
 */
export enum SortAndFilterBasicFilterPayloadType {
  /** Check selected filter option */
  OPTION = 'OPTION',
  /** Remove selected filter */
  REMOVE = 'REMOVE',
}

/** Specifies when a signal should be emitted */
export enum SortAndFilterSignalCondition {
  /** When a filter value changes from the default value to a non default value */
  DEFAULT_TO_NON_DEFAULT = 'DEFAULT_TO_NON_DEFAULT',
  /** When a filter value changes from a non default value to the default value */
  NON_DEFAULT_TO_DEFAULT = 'NON_DEFAULT_TO_DEFAULT',
  /** When a filter value changes from a non default value to a different non default value */
  NON_DEFAULT_TO_NON_DEFAULT = 'NON_DEFAULT_TO_NON_DEFAULT',
  /** When a filter state changes from unselected to selected */
  SELECTED = 'SELECTED',
  /** When a filter state changes from selected to unselected */
  UNSELECTED = 'UNSELECTED',
}

/** Contains the different views for Sort and Filters, where each of them is meant to be on a specific page section or viewport. */
export enum SortAndFiltersViewType {
  /**
   * Represent a view where it's displayed applied filters as removable pills.
   * Used for `SMALL` and `MEDIUM` viewport sizes, above the results in a Search Results Page.
   */
  APPLIED_FILTERS = 'APPLIED_FILTERS',
  /**
   * Represent a view where it's only displayed a list of filters.
   * Used for `LARGE` and `EXTRA_LARGE` viewport sizes, in the left side of the results on a Search Results Page.
   */
  FILTERS = 'FILTERS',
  /**
   * Represent a view where the list of filters are displayed as pills.
   * Used for all viewport sizes, on top of the results on a Search Results Page.
   */
  FILTERS_PILLS = 'FILTERS_PILLS',
  /**
   * Represent a view where it displays a filter bar with an All Filters button.
   * Used for all viewport sizes, above the results in the Vrbex SRP split view template.
   */
  FILTER_BAR = 'FILTER_BAR',
  /**
   * Represent a view where it displays a dialog with only `filters` sections, which are hidden and will be displayed (within a Dialog) once a trigger is clicked by the user.
   * Used for all viewport sizes, inside toolbars.
   */
  FILTER_DIALOG = 'FILTER_DIALOG',
  /**
   * Represent a view where it's only displayed a list of sort fields, it usually contains a single section with a sort field.
   * Used for `LARGE` and `EXTRA_LARGE` viewport sizes, above the results in a Search Results Page.
   */
  SORT = 'SORT',
  /**
   * Represent a view of a combined list of the `sort` and `filters` sections, which are hidden and will be displayed (within a Dialog) once a trigger is clicked by the user.
   * Used for `SMALL` and `MEDIUM` viewport sizes, above the results in a Search Results Page.
   */
  SORT_AND_FILTERS = 'SORT_AND_FILTERS',
  /**
   * Represent a view where sort options are displayed as tabs with each tab displaying the sorted results based on the selected tab.
   * Used for all viewport sizes.
   */
  SORT_TABS = 'SORT_TABS',
  /**
   * Represent a view where apply rewards is displayed as a toggle.
   * Used for `SMALL` and `MEDIUM` viewport sizes, above the results in a Search Results Page.
   */
  USE_REWARDS = 'USE_REWARDS',
}

export enum SourceType {
  ESR = 'ESR',
  GDS = 'GDS',
}

export enum Spacing {
  four = 'four',
  half = 'half',
  one = 'one',
  six = 'six',
  sixteen = 'sixteen',
  three = 'three',
  twelve = 'twelve',
  two = 'two',
  unset = 'unset',
}

export enum SpacingOptions {
  FOUR = 'FOUR',
  HALF = 'HALF',
  ONE = 'ONE',
  SIX = 'SIX',
  SIXTEEN = 'SIXTEEN',
  THREE = 'THREE',
  TWELVE = 'TWELVE',
  TWO = 'TWO',
  UNSET = 'UNSET',
}

export interface SpeakNextAvailableAgentSheetRequestInput {
  /** Customer Selected category from dropdown */
  category: Scalars['String'];
  /** Customer selected intent from dropdown */
  intent: Scalars['String'];
  /** Customer selected option */
  optionType: ContactUsOptionType;
}

/** Possible equipment requested by the customer */
export enum SpecialEquipment {
  ADDITIONAL_DRIVER = 'ADDITIONAL_DRIVER',
  BICYCLE_RACK = 'BICYCLE_RACK',
  BOOSTER_SEAT = 'BOOSTER_SEAT',
  INFANT_SEAT = 'INFANT_SEAT',
  LEFT_HAND_CONTROL = 'LEFT_HAND_CONTROL',
  LUGGAGE_RACK = 'LUGGAGE_RACK',
  NAV_SYSTEM = 'NAV_SYSTEM',
  RIGHT_HAND_CONTROL = 'RIGHT_HAND_CONTROL',
  ROAD_CONGESTION_PAYMENT_SCHEME = 'ROAD_CONGESTION_PAYMENT_SCHEME',
  SATELLITE_RADIO = 'SATELLITE_RADIO',
  SKI_RACK = 'SKI_RACK',
  SNOW_CHAINS = 'SNOW_CHAINS',
  SNOW_TIRES = 'SNOW_TIRES',
  TODDLER_SEAT = 'TODDLER_SEAT',
  TOLL_PAYMENT_TAG_PASS = 'TOLL_PAYMENT_TAG_PASS',
  TRAILER_HITCH = 'TRAILER_HITCH',
  WIFI_ACCESS = 'WIFI_ACCESS',
  WINTER_PACKAGE = 'WINTER_PACKAGE',
}

/** Context needed to request sponsored content */
export interface SponsoredContentContextInput {
  /** Page name Eg. page.Hotels.Infosite.Information */
  pageName: Scalars['String'];
  /** Unique identifier for sponsored content placements */
  sponsoredContentId: Scalars['String'];
  /** Model for ad targeting input */
  targeting?: InputMaybe<SponsoredContentTargetingInput>;
  /** Target variant. Eg. pwa */
  variant?: InputMaybe<Scalars['String']>;
}

/** Location resolution by type */
export enum SponsoredContentLocationResolver {
  /** Gaia regionId. Ex. 178248 (Chicago (and vicinity)) */
  GAIA = 'GAIA',
  /** Airport code. Ex. ORD (TLA code for Chicago O'Hare Airport) */
  TLA = 'TLA',
}

/** Location resolution by type */
export enum SponsoredContentLocationResolverInput {
  /** Gaia regionId. Ex. 178248 (Chicago (and vicinity)) */
  GAIA = 'GAIA',
  /** Airport code. Ex. ORD (TLA code for Chicago O'Hare Airport) */
  TLA = 'TLA',
}

/** The type of the ad placement */
export enum SponsoredContentProductType {
  ALTERNATE_DESTINATIONS_CAROUSEL = 'ALTERNATE_DESTINATIONS_CAROUSEL',
  BRAND_RESULT_LISTING = 'BRAND_RESULT_LISTING',
  BRAND_RESULT_LISTING_CARS = 'BRAND_RESULT_LISTING_CARS',
  BRAND_RESULT_LISTING_CRUISES = 'BRAND_RESULT_LISTING_CRUISES',
  BRAND_RESULT_LISTING_FLIGHTS = 'BRAND_RESULT_LISTING_FLIGHTS',
  BRAND_RESULT_LISTING_LODGING = 'BRAND_RESULT_LISTING_LODGING',
  BRAND_RESULT_LISTING_LX = 'BRAND_RESULT_LISTING_LX',
  DESTINATION_EXPERIENCE = 'DESTINATION_EXPERIENCE',
  MULTI_LISTING_AD = 'MULTI_LISTING_AD',
  MULTI_LISTING_AD_CARS = 'MULTI_LISTING_AD_CARS',
  SPONSORED_PROPERTIES_CAROUSEL = 'SPONSORED_PROPERTIES_CAROUSEL',
}

/** Input model to hold targeting params for queries. */
export interface SponsoredContentTargetingInput {
  /** number of adults included in the search */
  adults?: InputMaybe<Scalars['Int']>;
  /** List of destination for Cruise with multiple destinations. */
  cruiseDest?: InputMaybe<Array<Scalars['String']>>;
  /** End date of trip. Optional for dateless searches */
  dateEnd?: InputMaybe<DateInput>;
  /** Start date of trip. Optional for dateless searches */
  dateStart?: InputMaybe<DateInput>;
  /** Destination for the trip. */
  destination?: InputMaybe<Scalars['String']>;
  /** number of kids included in the search */
  kids?: InputMaybe<Scalars['Int']>;
  /** Type of location for origin and dest. */
  locationResolver?: InputMaybe<SponsoredContentLocationResolverInput>;
  /** Origin for the trip. */
  origin?: InputMaybe<Scalars['String']>;
}

export interface StackingOptionInput {
  allowStacking?: InputMaybe<Scalars['Boolean']>;
  promotionId: Scalars['String'];
}

export interface StarRangeInput {
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
}

export enum StatusType {
  STATUS_TYPE_BOOKED = 'STATUS_TYPE_BOOKED',
  STATUS_TYPE_CANCELLED = 'STATUS_TYPE_CANCELLED',
  STATUS_TYPE_EXPIRED = 'STATUS_TYPE_EXPIRED',
  STATUS_TYPE_FAILED = 'STATUS_TYPE_FAILED',
  STATUS_TYPE_INVALID = 'STATUS_TYPE_INVALID',
  STATUS_TYPE_PENDING = 'STATUS_TYPE_PENDING',
  STATUS_TYPE_PLANNING = 'STATUS_TYPE_PLANNING',
  STATUS_TYPE_POSSIBLE = 'STATUS_TYPE_POSSIBLE',
  STATUS_TYPE_RECENTLY_VIEWED = 'STATUS_TYPE_RECENTLY_VIEWED',
  STATUS_TYPE_RECENT_SEARCHES = 'STATUS_TYPE_RECENT_SEARCHES',
  UNRECOGNIZED = 'UNRECOGNIZED',
}

export enum StayType {
  CONVENTIONAL = 'CONVENTIONAL',
  VACATION_RENTALS = 'VACATION_RENTALS',
}

export enum StepReviewInlineEditingSheetButtonType {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
}

export interface StoredCardInstrumentInput {
  authorized?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
}

export enum Strategy {
  CHEAPEST_PACKAGE_PRICE = 'CHEAPEST_PACKAGE_PRICE',
}

export enum StrikeOutType {
  ATTACH = 'ATTACH',
  INVALID = 'INVALID',
  LOYALTY = 'LOYALTY',
  PACKAGE = 'PACKAGE',
  PRICE_SURVEY = 'PRICE_SURVEY',
  STANDALONE = 'STANDALONE',
}

export enum StructureType {
  AGRITOURISM = 'AGRITOURISM',
  ALL_INCLUSIVE = 'ALL_INCLUSIVE',
  APARTMENT = 'APARTMENT',
  APART_HOTEL = 'APART_HOTEL',
  BED_AND_BREAKFAST = 'BED_AND_BREAKFAST',
  CABIN = 'CABIN',
  CAPSULE_HOTEL = 'CAPSULE_HOTEL',
  CARAVAN_PARK = 'CARAVAN_PARK',
  CASTLE = 'CASTLE',
  CHALET = 'CHALET',
  CONDO = 'CONDO',
  CONDO_RESORT = 'CONDO_RESORT',
  COTTAGE = 'COTTAGE',
  COUNTRY_HOUSE = 'COUNTRY_HOUSE',
  CRUISE = 'CRUISE',
  ECO_HOTEL = 'ECO_HOTEL',
  GUEST_HOUSE = 'GUEST_HOUSE',
  HOLIDAY_PARK = 'HOLIDAY_PARK',
  HOSTAL = 'HOSTAL',
  HOSTEL = 'HOSTEL',
  HOTEL = 'HOTEL',
  HOTEL_RESORT = 'HOTEL_RESORT',
  HOUSE_BOAT = 'HOUSE_BOAT',
  INN = 'INN',
  LODGE = 'LODGE',
  LONGHOUSE = 'LONGHOUSE',
  MOBILE_HOME = 'MOBILE_HOME',
  MOTEL = 'MOTEL',
  OVERWATER = 'OVERWATER',
  PALACE = 'PALACE',
  PENSION = 'PENSION',
  POUSADA_BRAZIL = 'POUSADA_BRAZIL',
  POUSADA_PORTUGAL = 'POUSADA_PORTUGAL',
  RANCH = 'RANCH',
  RESIDENCE = 'RESIDENCE',
  RIAD = 'RIAD',
  RYOKAN = 'RYOKAN',
  SAFARI = 'SAFARI',
  SERVICED_APARTMENT = 'SERVICED_APARTMENT',
  TOWNHOUSE = 'TOWNHOUSE',
  TRADITIONAL_BUILDING = 'TRADITIONAL_BUILDING',
  TREE_HOUSE = 'TREE_HOUSE',
  UNKNOWN = 'UNKNOWN',
  VACATION_HOME = 'VACATION_HOME',
  VACATION_RENTAL = 'VACATION_RENTAL',
  VACATION_RENTALS = 'VACATION_RENTALS',
  VILLA = 'VILLA',
  VIP = 'VIP',
}

/** represents configuration for submit Payment */
export interface SubmitPaymentConfigurationInput {
  clientDetails: ClientDetailsInput;
  paymentSessionId: Scalars['String'];
  paymentSubmissionInfo?: InputMaybe<PaymentSubmissionInfoInput>;
}

export interface SuggestedReplyInput {
  /** ConversationId or InteractionId associated with the conversation thread */
  conversationId: Scalars['String'];
  /** Array of latest traveler messages, in chronological order (oldest first) */
  latestTravelerMessages: Array<TravelerMessage>;
}

export interface SupplierMessageTemplateScheduleInput {
  lastMinuteBookingEnabled?: InputMaybe<Scalars['Boolean']>;
  scheduleDay?: InputMaybe<Scalars['String']>;
  scheduleEvent?: InputMaybe<Scalars['String']>;
  scheduleTime?: InputMaybe<Scalars['String']>;
}

export interface SupplyAmenitiesGroupInput {
  amenityIds?: InputMaybe<Array<Scalars['String']>>;
  groupId: Scalars['String'];
  prefilledRoomId?: InputMaybe<Scalars['String']>;
  roomTypeId?: InputMaybe<Scalars['String']>;
  spaceId?: InputMaybe<Scalars['String']>;
}

export interface SupplyAmenitiesUpdateInput {
  amenities: Array<SupplyAmenityInput>;
  amenityIds?: InputMaybe<Array<Scalars['String']>>;
  groupId: Scalars['String'];
  roomTypeId?: InputMaybe<Scalars['String']>;
}

export interface SupplyAmenityAccuracyCoachingData {
  id: Scalars['String'];
  reviewCount: Scalars['String'];
}

export interface SupplyAmenityCoachingActionPanelContext {
  amenityCoachingParameters?: InputMaybe<SupplyAmenityCoachingParameters>;
  type: Scalars['String'];
  view: Scalars['String'];
}

export interface SupplyAmenityCoachingParameters {
  amenityAccuracyCoachingData: Array<SupplyAmenityAccuracyCoachingData>;
  coachingTipId: Scalars['String'];
  coachingTipSourceId: Scalars['String'];
  proofPointStr: Scalars['String'];
}

export interface SupplyAmenityInput {
  elementId: Scalars['String'];
  supplierDescription?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
}

export interface SupplyAmenityNegativeReviewAmenityInput {
  amenityId?: InputMaybe<Scalars['String']>;
  uuid: Scalars['String'];
}

export interface SupplyAmenityNegativeReviewInput {
  amenities: Array<SupplyAmenityNegativeReviewAmenityInput>;
  id: Scalars['String'];
  negativeReviewIds?: InputMaybe<Array<Scalars['String']>>;
  reviewCount: Scalars['Int'];
}

export enum SupplyArchiveOperation {
  ARCHIVE = 'ARCHIVE',
  NONE = 'NONE',
  UNARCHIVE = 'UNARCHIVE',
}

export interface SupplyAttributeInput {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  value: Scalars['String'];
}

export interface SupplyAttributesAdminExperienceInput {
  ratePlanId?: InputMaybe<Scalars['String']>;
  roomTypeId?: InputMaybe<Scalars['String']>;
  spaceId?: InputMaybe<Scalars['String']>;
}

export interface SupplyAttributesUpdateInput {
  attributes: Array<SupplyAttributeInput>;
  ratePlanId?: InputMaybe<Scalars['String']>;
  roomTypeId?: InputMaybe<Scalars['String']>;
  spaceId?: InputMaybe<Scalars['String']>;
}

export enum SupplyAuthExchangeStatus {
  FAILURE = 'FAILURE',
  SUCCESS = 'SUCCESS',
}

export enum SupplyCalendarAnalyticsEvent {
  CALENDAR_DATES_SELECTED = 'CALENDAR_DATES_SELECTED',
  CALENDAR_DATE_SET_AVAILABLE_SELECTED = 'CALENDAR_DATE_SET_AVAILABLE_SELECTED',
  CALENDAR_DATE_SET_BLOCKED_SELECTED = 'CALENDAR_DATE_SET_BLOCKED_SELECTED',
  CALENDAR_END_DATE_SELECTED = 'CALENDAR_END_DATE_SELECTED',
  CALENDAR_ERROR_PRESENTED = 'CALENDAR_ERROR_PRESENTED',
  CALENDAR_LEGEND_ERROR_PRESENTED = 'CALENDAR_LEGEND_ERROR_PRESENTED',
  CALENDAR_LEGEND_PRESENTED = 'CALENDAR_LEGEND_PRESENTED',
  CALENDAR_LEGEND_SELECTED = 'CALENDAR_LEGEND_SELECTED',
  CALENDAR_NETWORK_ERROR_PRESENTED = 'CALENDAR_NETWORK_ERROR_PRESENTED',
  CALENDAR_NEXT_MONTH_SELECTED = 'CALENDAR_NEXT_MONTH_SELECTED',
  CALENDAR_PREVIOUS_MONTH_SELECTED = 'CALENDAR_PREVIOUS_MONTH_SELECTED',
  CALENDAR_REFRESH_SELECTED = 'CALENDAR_REFRESH_SELECTED',
  CALENDAR_SETTINGS_ITEM_SELECTED = 'CALENDAR_SETTINGS_ITEM_SELECTED',
  CALENDAR_START_DATE_SELECTED = 'CALENDAR_START_DATE_SELECTED',
  CALENDAR_VIEWED = 'CALENDAR_VIEWED',
  CALENDAR_YEAR_DROPDOWN_OPENED = 'CALENDAR_YEAR_DROPDOWN_OPENED',
  CALENDAR_YEAR_SELECTED = 'CALENDAR_YEAR_SELECTED',
  EDIT_DISCOUNT_PRICE_BREAKDOWN_SELECTED = 'EDIT_DISCOUNT_PRICE_BREAKDOWN_SELECTED',
  EDIT_DISCOUNT_SCREEN_PRESENTED = 'EDIT_DISCOUNT_SCREEN_PRESENTED',
  EDIT_DISCOUNT_UPDATE_FAILED = 'EDIT_DISCOUNT_UPDATE_FAILED',
  EDIT_DISCOUNT_UPDATE_SELECTED = 'EDIT_DISCOUNT_UPDATE_SELECTED',
  EDIT_DISCOUNT_UPDATE_SUCCEEDED = 'EDIT_DISCOUNT_UPDATE_SUCCEEDED',
  EDIT_RATE_SCREEN_PRESENTED = 'EDIT_RATE_SCREEN_PRESENTED',
  EDIT_RATE_TOGGLE_SELECTED = 'EDIT_RATE_TOGGLE_SELECTED',
  EDIT_RATE_UPDATE_FAILED = 'EDIT_RATE_UPDATE_FAILED',
  EDIT_RATE_UPDATE_SELECTED = 'EDIT_RATE_UPDATE_SELECTED',
  EDIT_RATE_UPDATE_SUCCEEDED = 'EDIT_RATE_UPDATE_SUCCEEDED',
  MAXIMUM_NIGHTS_SCREEN_PRESENTED = 'MAXIMUM_NIGHTS_SCREEN_PRESENTED',
  MAXIMUM_NIGHTS_UPDATE_FAILED = 'MAXIMUM_NIGHTS_UPDATE_FAILED',
  MAXIMUM_NIGHTS_UPDATE_SELECTED = 'MAXIMUM_NIGHTS_UPDATE_SELECTED',
  MAXIMUM_NIGHTS_UPDATE_SUCCEEDED = 'MAXIMUM_NIGHTS_UPDATE_SUCCEEDED',
  MINIMUM_NIGHTS_SCREEN_PRESENTED = 'MINIMUM_NIGHTS_SCREEN_PRESENTED',
  MINIMUM_NIGHTS_UPDATE_FAILED = 'MINIMUM_NIGHTS_UPDATE_FAILED',
  MINIMUM_NIGHTS_UPDATE_SELECTED = 'MINIMUM_NIGHTS_UPDATE_SELECTED',
  MINIMUM_NIGHTS_UPDATE_SUCCEEDED = 'MINIMUM_NIGHTS_UPDATE_SUCCEEDED',
  SETTINGS_SELECTED = 'SETTINGS_SELECTED',
}

export interface SupplyCalendarBaseRateInput {
  friday?: InputMaybe<Scalars['Float']>;
  monday?: InputMaybe<Scalars['Float']>;
  saturday?: InputMaybe<Scalars['Float']>;
  singleBaseRate?: InputMaybe<Scalars['Float']>;
  sunday?: InputMaybe<Scalars['Float']>;
  thursday?: InputMaybe<Scalars['Float']>;
  tuesday?: InputMaybe<Scalars['Float']>;
  wednesday?: InputMaybe<Scalars['Float']>;
}

export interface SupplyCalendarClientInput {
  /** Timezone provided from the user */
  timezone: Scalars['String'];
}

export interface SupplyCalendarDiscountInput {
  discountValue?: InputMaybe<Scalars['Float']>;
  rateModificationType?: InputMaybe<SupplyCalendarRateModificationType>;
}

export enum SupplyCalendarEventType {
  AVAILABLE = 'AVAILABLE',
  BLOCKED = 'BLOCKED',
  CONFLICT = 'CONFLICT',
  ICALENDAR = 'ICALENDAR',
  RESERVATION = 'RESERVATION',
  TENTATIVE = 'TENTATIVE',
  UNBOOKABLE = 'UNBOOKABLE',
}

export enum SupplyCalendarPriceLineItemType {
  CURRENCY = 'CURRENCY',
  TOTAL = 'TOTAL',
}

export enum SupplyCalendarRateModificationType {
  DOLLAR = 'DOLLAR',
  PERCENTAGE = 'PERCENTAGE',
}

export enum SupplyCalendarReservationAvailabilityStatus {
  HOLD = 'HOLD',
  RESERVE = 'RESERVE',
  UNAVAILABLE = 'UNAVAILABLE',
}

export interface SupplyCalendarSearchInput {
  endDate: Scalars['String'];
  startDate: Scalars['String'];
}

export enum SupplyCalendarSegmentEdge {
  COMPLETE = 'COMPLETE',
  HEAD = 'HEAD',
  NO_EDGE = 'NO_EDGE',
  TAIL = 'TAIL',
}

export interface SupplyCancellationWaiverApprovalRequestContext {
  bookingItemId: Scalars['String'];
  message?: InputMaybe<Scalars['String']>;
}

export interface SupplyCancellationWaiverReservationContext {
  bookingItemId: Scalars['String'];
}

export interface SupplyCheetahDynamicViewParameter {
  name: Scalars['String'];
  value: Scalars['String'];
}

export interface SupplyCheetahDynamicViewResourceContext {
  resourceId: Scalars['String'];
  resourceVersion?: InputMaybe<Scalars['String']>;
}

export interface SupplyCoachingParameters {
  coachingTipId?: InputMaybe<Scalars['String']>;
  coachingTipSourceId?: InputMaybe<Scalars['String']>;
  proofPointStr?: InputMaybe<Scalars['String']>;
}

export interface SupplyCoachingTipBlockTabsAnalyticsContext {
  pageName?: InputMaybe<Scalars['String']>;
}

export interface SupplyCoachingTipsResultDetailParameters {
  coachingTipId?: InputMaybe<Scalars['String']>;
  coachingTipSourceId?: InputMaybe<Scalars['String']>;
}

export enum SupplyConnectivityOnboardingButtonType {
  BACK = 'BACK',
  DONE = 'DONE',
  LINK = 'LINK',
  NEXT = 'NEXT',
  SKIP = 'SKIP',
}

export enum SupplyConnectivityOnboardingStepState {
  ACTIVE = 'ACTIVE',
  COMPLETE = 'COMPLETE',
  TODO = 'TODO',
}

export interface SupplyContentAdditionalInfoUpdateInput {
  bathrooms?: InputMaybe<Scalars['String']>;
  bedrooms?: InputMaybe<Scalars['String']>;
  property?: InputMaybe<Scalars['String']>;
}

export interface SupplyContentAmenityInput {
  uuid: Scalars['String'];
  value: Scalars['String'];
}

export interface SupplyContentCoachingParameters {
  coachingTipId?: InputMaybe<Scalars['String']>;
  coachingTipSourceId?: InputMaybe<Scalars['String']>;
  proofPointStr?: InputMaybe<Scalars['String']>;
}

export enum SupplyContentDescriptionSectionName {
  ABOUT_YOU = 'ABOUT_YOU',
  BATHROOMS_ADDITIONAL_INFO = 'BATHROOMS_ADDITIONAL_INFO',
  BEDROOMS_ADDITIONAL_INFO = 'BEDROOMS_ADDITIONAL_INFO',
  DESCRIPTION = 'DESCRIPTION',
  HEADLINE = 'HEADLINE',
  INTERIOR_SIZE = 'INTERIOR_SIZE',
  MANUAL_TRANSLATION = 'MANUAL_TRANSLATION',
  PROPERTY_ADDITIONAL_INFO = 'PROPERTY_ADDITIONAL_INFO',
  PROPERTY_NAME = 'PROPERTY_NAME',
  PROPERTY_TYPE = 'PROPERTY_TYPE',
  SUITABILITY_AMENITY = 'SUITABILITY_AMENITY',
  UNIQUE_BENEFITS = 'UNIQUE_BENEFITS',
  WHY_THIS_PROPERTY = 'WHY_THIS_PROPERTY',
}

export interface SupplyContentHeadlineDescriptionUpdateInput {
  description?: InputMaybe<Scalars['String']>;
  headline?: InputMaybe<Scalars['String']>;
  propertyName?: InputMaybe<Scalars['String']>;
}

export enum SupplyContentManualTranslationOperation {
  ADD = 'ADD',
  DELETE = 'DELETE',
  UPDATE = 'UPDATE',
}

export interface SupplyContentManualTranslationUpdateInput {
  description?: InputMaybe<Scalars['String']>;
  headline?: InputMaybe<Scalars['String']>;
  locale: Scalars['String'];
  operation: SupplyContentManualTranslationOperation;
  optOutAutoTranslation: Scalars['Boolean'];
}

export interface SupplyContentUpdateLocationInput {
  showExactLocation: Scalars['Boolean'];
}

export interface SupplyContentYourPropertyUpdateInput {
  amenities?: InputMaybe<Array<SupplyContentAmenityInput>>;
  propertyName?: InputMaybe<Scalars['String']>;
  propertyTypeId?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['String']>;
  unit?: InputMaybe<Scalars['String']>;
}

export interface SupplyContentYourStoryUpdateInput {
  aboutYou?: InputMaybe<Scalars['String']>;
  uniqueBenefits?: InputMaybe<Scalars['String']>;
  whyThisProperty?: InputMaybe<Scalars['String']>;
}

export enum SupplyContractingBannerTheme {
  CRITICAL = 'CRITICAL',
  ERROR = 'ERROR',
}

export interface SupplyContractingOffersAcceptanceInput {
  offerIds: Array<Scalars['String']>;
  program: Scalars['String'];
  salesForceCaseId?: InputMaybe<Scalars['String']>;
}

export enum SupplyContractingResponseStatus {
  FAIL = 'FAIL',
  SUCCESS = 'SUCCESS',
}

export enum SupplyContractingSheetType {
  FENCED_BOOKING_DISCOUNTS_OPT_OUT = 'FENCED_BOOKING_DISCOUNTS_OPT_OUT',
}

export interface SupplyContractingSideSheetInput {
  navType: SupplyContractingToolbarNavType;
  sheetType: SupplyContractingSheetType;
}

export enum SupplyContractingToolbarNavType {
  BACK = 'BACK',
  CLOSE = 'CLOSE',
}

export interface SupplyCurrentPageContext {
  /** The current relative path for the page */
  path?: InputMaybe<Scalars['String']>;
  /** specifies any query params the current page has like htid */
  search?: InputMaybe<Scalars['String']>;
  /** field for native , defining the current native view- like reservations/inbox */
  view?: InputMaybe<Scalars['String']>;
}

export enum SupplyDashboardType {
  DASHBOARD = 'DASHBOARD',
  LEGACY = 'LEGACY',
}

/** Options for configuring the data insights hub metric card */
export interface SupplyDataInsightsHubMetricCardOptions {
  /** EPIC Metrics: pageView, revenue, averageDailyRate, netRoomNight, averageBookingWindow, averageLengthOfStay, oneKeyMemberShare, ... */
  metric: Scalars['String'];
  /** Stringified metric additional information, ex: { comparison: 'market', dateRange: 'last28Days', ... } */
  metricContext?: InputMaybe<Scalars['String']>;
}

export enum SupplyDayOfWeek {
  FRIDAY = 'FRIDAY',
  MONDAY = 'MONDAY',
  SATURDAY = 'SATURDAY',
  SUNDAY = 'SUNDAY',
  THURSDAY = 'THURSDAY',
  TUESDAY = 'TUESDAY',
  WEDNESDAY = 'WEDNESDAY',
}

export interface SupplyDismissibleCardInput {
  /** Represents the number of days as value that it will be sent to User Preferences API (90 days by default) */
  dismissDurationDays?: InputMaybe<Scalars['Int']>;
  /** Unique key to identidy/retrieve the specific preference (dismissal) for each user */
  key: Scalars['String'];
  /** Represents the preference group that it will be sent to User Preferences API (application name can be used) */
  preferenceGroup: Scalars['String'];
}

export enum SupplyEditAvailabilityTag {
  BLOCK = 'BLOCK',
  OPEN = 'OPEN',
}

export interface SupplyEpicGenAIInsightsOptions {
  /** supported insights types: PARTNER_PERFORMANCE */
  insightsType?: InputMaybe<Scalars['String']>;
  /** generative AI insights session id, used to retrieve the insights asynchronously */
  sessionId?: InputMaybe<Scalars['String']>;
  /** step context for the Generative AI insights request, used to determine the flow of the insights */
  step?: InputMaybe<Scalars['String']>;
}

export interface SupplyEpicMetricCardOptions {
  /** EPIC Metrics: pageView, revenue, averageDailyRate, netRoomNight, averageBookingWindow, averageLengthOfStay, oneKeyMemberShare, ... */
  metric: Scalars['String'];
  /** Stringified metric additional information, ex: { comparison: 'market', dateRange: 'last28Days', ... } */
  metricContext?: InputMaybe<Scalars['String']>;
}

export interface SupplyEpicMetricWidgetOptions {
  comparison?: InputMaybe<Scalars['String']>;
  dateRange?: InputMaybe<Scalars['String']>;
  dateType?: InputMaybe<Scalars['String']>;
  metric?: InputMaybe<Scalars['String']>;
  metricContext?: InputMaybe<Scalars['String']>;
}

export interface SupplyEpicMetricWidgetPreferencesInput {
  selectedChartsVisibility?: InputMaybe<Scalars['Boolean']>;
  selectedComparison?: InputMaybe<Scalars['String']>;
  selectedDateRange?: InputMaybe<Scalars['String']>;
  selectedDateType?: InputMaybe<Scalars['String']>;
  selectedMetrics?: InputMaybe<Array<Scalars['String']>>;
  sortedMetrics?: InputMaybe<Array<Scalars['String']>>;
}

export interface SupplyEpicPlaybackPerformanceActionContext {
  opportunityId?: InputMaybe<Scalars['String']>;
}

export enum SupplyEpicPlaybackPerformanceResultTrend {
  HIGHER = 'HIGHER',
  LOWER = 'LOWER',
  NO_CHANGE = 'NO_CHANGE',
}

export enum SupplyEpicPlaybackPerformanceResultUnavailableCardType {
  CAPTURING_DATA = 'CAPTURING_DATA',
  ERROR = 'ERROR',
  NO_COMPSET = 'NO_COMPSET',
}

export enum SupplyEpicPlaybackPerformanceStage {
  ACTIVE = 'ACTIVE',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
}

export interface SupplyFeeFilterInput {
  includedFees?: InputMaybe<Array<Scalars['String']>>;
}

export interface SupplyFeesInput {
  amount: Scalars['Float'];
  productCode: Scalars['String'];
  type: Scalars['String'];
}

export interface SupplyFinanceReportDownloadInput {
  fileType: Scalars['String'];
  invoiceId: Scalars['String'];
}

export interface SupplyIndirectTaxInput {
  taxDetails: Array<SupplyIndirectTaxInputDetail>;
}

export interface SupplyIndirectTaxInputDetail {
  legalName: Scalars['String'];
  registrationStatus: Scalars['String'];
  taxId: Scalars['String'];
  taxJurisdictionName: Scalars['String'];
  taxJurisdictionType: Scalars['String'];
  taxationCountry: Scalars['String'];
}

export enum SupplyLoyaltyActionId {
  VIP_APPLICATION_REVIEW_SHEET = 'VIP_APPLICATION_REVIEW_SHEET',
  VIP_BENEFITS_SHEET = 'VIP_BENEFITS_SHEET',
  VIP_CONTACTS_SHEET = 'VIP_CONTACTS_SHEET',
  VIP_CONTRACT_SHEET = 'VIP_CONTRACT_SHEET',
  VIP_CONTRACT_VIEW_SHEET = 'VIP_CONTRACT_VIEW_SHEET',
  VIP_MEMBERS_ONLY_DISCOUNT_SHEET = 'VIP_MEMBERS_ONLY_DISCOUNT_SHEET',
  VIP_ONBOARDING_ACTIVATION_SUBMIT = 'VIP_ONBOARDING_ACTIVATION_SUBMIT',
  VIP_PROGRAM_PROGRESS_SHEET = 'VIP_PROGRAM_PROGRESS_SHEET',
  VIP_PROGRAM_SUBMIT = 'VIP_PROGRAM_SUBMIT',
  VIP_VALUE_ADD_SHEET = 'VIP_VALUE_ADD_SHEET',
}

export enum SupplyLoyaltyCallToActionCardVariants {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
}

export enum SupplyLoyaltyCardVariants {
  VIP_ACCESS_BENEFIT = 'VIP_ACCESS_BENEFIT',
  VIP_HOW_IT_WORKS_REQUIREMENT = 'VIP_HOW_IT_WORKS_REQUIREMENT',
  VIP_MESSAGE_HORIZONTAL = 'VIP_MESSAGE_HORIZONTAL',
  VIP_TRAINING = 'VIP_TRAINING',
}

export interface SupplyLoyaltyContactInput {
  countryCode?: InputMaybe<Scalars['String']>;
  countryNameAndPrefix?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
}

export interface SupplyLoyaltyMembersOnlyDiscountInput {
  blueTierDiscountValue?: InputMaybe<Scalars['String']>;
  goldTierDiscountValue?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  silverTierDiscountValue?: InputMaybe<Scalars['String']>;
}

export enum SupplyLoyaltyResponseStatus {
  FAIL = 'FAIL',
  SUCCESS = 'SUCCESS',
}

export enum SupplyLoyaltySectionVariant {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
}

export interface SupplyLoyaltyValueAddInput {
  amenityId?: InputMaybe<Scalars['Int']>;
  creditValue?: InputMaybe<Scalars['String']>;
  discountValue?: InputMaybe<Scalars['String']>;
  frequency: Scalars['String'];
  numberOfGuests?: InputMaybe<Scalars['String']>;
  offerId: Scalars['String'];
  offerTypeId: Scalars['String'];
}

export enum SupplyLoyaltyVipProgramApprovalDecisionInput {
  APPROVE = 'APPROVE',
  REJECT = 'REJECT',
}

export interface SupplyMarketplaceFeedActionInput {
  actionType: Scalars['String'];
  actionUrl: Scalars['String'];
  iconType: Scalars['String'];
  label: Scalars['String'];
}

export interface SupplyMarketplaceFeedInput {
  feedItemActionType: Scalars['String'];
  feedItemId: Scalars['String'];
}

export interface SupplyMarketplaceFeedItemInput {
  body?: InputMaybe<Scalars['String']>;
  feedItemId: Scalars['String'];
  feedItemType?: InputMaybe<Scalars['String']>;
  iconType: Scalars['String'];
  imageUrl: Scalars['String'];
  platform?: InputMaybe<Array<DeviceType>>;
  primaryAction: SupplyMarketplaceFeedActionInput;
  segmentations?: InputMaybe<SupplyMarketplaceFeedSegmentationsInput>;
  site?: InputMaybe<Array<Scalars['String']>>;
  status?: InputMaybe<MarketingFeedCardStatus>;
  timeToComplete: Scalars['Int'];
  title: Scalars['String'];
}

export interface SupplyMarketplaceFeedSegmentationsInput {
  cityList?: InputMaybe<Array<Scalars['String']>>;
  countryList?: InputMaybe<Array<Scalars['String']>>;
  localeList: Array<Scalars['String']>;
  partnerTypeList: Array<Scalars['String']>;
  propertyIdList: Array<Scalars['String']>;
  stateList?: InputMaybe<Array<Scalars['String']>>;
  userIdList?: InputMaybe<Array<Scalars['String']>>;
}

/** Input for generating mfa code */
export interface SupplyMultiFactorCodeGenerationInput {
  /** Optional challenge ticket in case use tries to request for a new code via `send me a new code` operation */
  challengeTicket?: InputMaybe<Scalars['String']>;
  /** Country code for the phone number */
  countryCode: Scalars['String'];
  /** Phone number of the user */
  phoneNumber: Scalars['String'];
  /** MFA Verification type */
  verifyMethod: MFAVerificationMethod;
}

/** Input for verifying mfa code */
export interface SupplyMultiFactorCodeVerificationInput {
  /** Challenge ticket associated with the mfa flow */
  challengeTicket: Scalars['String'];
  /** 6 digit Code sent to user */
  code: Scalars['String'];
  /** Country code for the phone number */
  countryCode: Scalars['String'];
  /** Phone number of the user */
  phoneNumber: Scalars['String'];
  /** MFA verification method */
  verifyMethod: MFAVerificationMethod;
}

export interface SupplyNavigationContext {
  fallbackUrls?: InputMaybe<SupplyNavigationContextFallbackUrls>;
  showSidebarTrigger: Scalars['Boolean'];
  temporaryPartnerContextOverride?: InputMaybe<Scalars['Boolean']>;
}

export interface SupplyNavigationContextFallbackUrls {
  helpAndSupportUrl?: InputMaybe<Scalars['String']>;
  signInUrl?: InputMaybe<Scalars['String']>;
  termsOfUseUrl?: InputMaybe<Scalars['String']>;
}

export enum SupplyNavigationHeaderMenuType {
  NOTIFICATIONS = 'NOTIFICATIONS',
  PORTFOLIO_PROPERTY_FILTER = 'PORTFOLIO_PROPERTY_FILTER',
  PROPERTY_DETAILS = 'PROPERTY_DETAILS',
  PROPERTY_FILTER = 'PROPERTY_FILTER',
  SEARCH = 'SEARCH',
}

export interface SupplyNavigationNotificationActivityInput {
  activityType: Scalars['String'];
  channel: Scalars['String'];
  notificationIds: Array<Scalars['String']>;
}

export interface SupplyNewListingOfferEnrollmentInput {
  enrolled: Scalars['Boolean'];
}

export enum SupplyNotificationPreferencesChannelType {
  EMAIL = 'EMAIL',
  PUSH = 'PUSH',
  SMS = 'SMS',
}

export interface SupplyNotificationPreferencesInput {
  category: Scalars['String'];
  channel: SupplyNotificationPreferencesChannelType;
  optInStatus: Scalars['Boolean'];
}

export enum SupplyOnboardingAvailabilityType {
  BLOCK = 'BLOCK',
  OPEN = 'OPEN',
}

export enum SupplyOnboardingButtonType {
  BACK = 'BACK',
  DONE = 'DONE',
  LINK = 'LINK',
  NEXT = 'NEXT',
  SKIP = 'SKIP',
}

export interface SupplyOnboardingPartnerAttestationInput {
  attestation: Scalars['Boolean'];
}

export interface SupplyOnboardingPartnerBillingAddressInput {
  city: Scalars['String'];
  country: Scalars['String'];
  /** Flag for removing or adding address */
  isAddingAddress: Scalars['Boolean'];
  postalCode: Scalars['String'];
  stateProvince: Scalars['String'];
  streetAddress: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
}

export interface SupplyOnboardingPartnerBusinessNameInput {
  businessName: Scalars['String'];
}

export interface SupplyOnboardingPartnerLegalNameInput {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
}

export enum SupplyOnboardingTipCardId {
  AMENITIES = 'AMENITIES',
  DESCRIPTION = 'DESCRIPTION',
  HEADLINE = 'HEADLINE',
  PHOTOS = 'PHOTOS',
  REGULATORY = 'REGULATORY',
}

export interface SupplyOptimizeEpicRateInsightsTableConfigurationOptions {
  adultCount?: InputMaybe<Scalars['Int']>;
  countryCode?: InputMaybe<Scalars['String']>;
  isBreakfastIncluded?: InputMaybe<Scalars['Boolean']>;
  isFullyRefundable?: InputMaybe<Scalars['Boolean']>;
  isMobile?: InputMaybe<Scalars['Boolean']>;
  lengthOfStay?: InputMaybe<Scalars['Int']>;
  loyaltyMemberTiers: Array<Scalars['String']>;
  travelProductId?: InputMaybe<Scalars['Int']>;
}

export interface SupplyOptimizeEpicRateInsightsTableSectionOptions {
  beginDate?: InputMaybe<Scalars['String']>;
  configuration?: InputMaybe<SupplyOptimizeEpicRateInsightsTableConfigurationOptions>;
  endDate?: InputMaybe<Scalars['String']>;
}

export interface SupplyOptimizeRateInsightsNotificationCardOptions {
  propertyId?: InputMaybe<Scalars['String']>;
  stayDate?: InputMaybe<Scalars['String']>;
}

export interface SupplyPCRoomManagementWorkflowInput {
  copyRoomTypeId?: InputMaybe<Scalars['String']>;
  isAddPath?: InputMaybe<Scalars['Boolean']>;
  pageName: SupplyPCRoomManagementWorkflowPageName;
  roomTypeId?: InputMaybe<Scalars['String']>;
  workflowType: SupplyPCRoomManagementWorkflowType;
}

export enum SupplyPCRoomManagementWorkflowPageName {
  COPY_RATE_PLAN = 'COPY_RATE_PLAN',
  RATE_PLAN = 'RATE_PLAN',
  ROOM_INFO = 'ROOM_INFO',
  ROOM_NAME = 'ROOM_NAME',
}

export enum SupplyPCRoomManagementWorkflowType {
  ADD = 'ADD',
  COPY = 'COPY',
  EDIT = 'EDIT',
}

export interface SupplyPageLevelBannerActivityInput {
  bannerActivityType: BannerActivity;
  bannerId: Scalars['String'];
  pageUrl: Scalars['String'];
}

export enum SupplyPartnerLifeCycleStage {
  LIFE_CYCLE_STAGE_ALL_GROWN_UP = 'LIFE_CYCLE_STAGE_ALL_GROWN_UP',
  LIFE_CYCLE_STAGE_BABY = 'LIFE_CYCLE_STAGE_BABY',
  LIFE_CYCLE_STAGE_KID = 'LIFE_CYCLE_STAGE_KID',
  LIFE_CYCLE_STAGE_TEENAGER = 'LIFE_CYCLE_STAGE_TEENAGER',
  LIFE_CYCLE_STAGE_YOUNG_ADULT = 'LIFE_CYCLE_STAGE_YOUNG_ADULT',
  UNRECOGNIZED = 'UNRECOGNIZED',
}

export interface SupplyPartnerPayoutDeferredAccountInput {
  bankingCountry: Scalars['String'];
  beneficiaryCountry?: InputMaybe<Scalars['String']>;
  beneficiaryState?: InputMaybe<Scalars['String']>;
  currency: Scalars['String'];
}

export interface SupplyPartnerSignUpEstimateResultsInput {
  bathroomNum: Scalars['Float'];
  bedroomNum: Scalars['Int'];
  lat?: InputMaybe<Scalars['Float']>;
  lng?: InputMaybe<Scalars['Float']>;
}

export enum SupplyPaymentDetailsExpandoPositioning {
  LEADING = 'LEADING',
  TRAILING = 'TRAILING',
}

export enum SupplyPaymentDisplayToolbarIcon {
  BACK = 'BACK',
  CLOSE = 'CLOSE',
}

export enum SupplyPhotoToastType {
  ASSIGN_PHOTOS_TO_ROOM = 'ASSIGN_PHOTOS_TO_ROOM',
  ASSIGN_ROOMS_TO_PHOTO = 'ASSIGN_ROOMS_TO_PHOTO',
  DELETE = 'DELETE',
  REJECT = 'REJECT',
  UNASSIGN = 'UNASSIGN',
  UPLOAD = 'UPLOAD',
}

export enum SupplyPhotosActionType {
  CARD_BUTTON = 'CARD_BUTTON',
  ICON_BUTTON = 'ICON_BUTTON',
  LINK = 'LINK',
  LINK_BUTTON = 'LINK_BUTTON',
  PRIMARY_BUTTON = 'PRIMARY_BUTTON',
  SECONDARY_BUTTON = 'SECONDARY_BUTTON',
  TERTIARY_BUTTON = 'TERTIARY_BUTTON',
  TOOL_BAR_BUTTON = 'TOOL_BAR_BUTTON',
}

export interface SupplyPhotosAddPhotoInput {
  fileName: Scalars['String'];
  fileUrl: Scalars['String'];
  md5?: InputMaybe<Scalars['String']>;
  rank?: InputMaybe<Scalars['Int']>;
  roomIds: Array<Scalars['String']>;
  spaceIds: Array<Scalars['String']>;
}

/** The experience varies by the view (UFO, PE, EPC, VMC, VMC_COMPLETENESS) & photo category */
export interface SupplyPhotosExperienceContext {
  category?: InputMaybe<Scalars['String']>;
  roomIds?: InputMaybe<Array<Scalars['String']>>;
  spaceId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<SupplyPhotosExperienceMutationType>;
  urns?: InputMaybe<Array<Scalars['String']>>;
  view: Scalars['String'];
}

export enum SupplyPhotosExperienceMutationType {
  ASSIGN_PHOTOS_TO_ROOM = 'ASSIGN_PHOTOS_TO_ROOM',
  ASSIGN_ROOMS_TO_PHOTO = 'ASSIGN_ROOMS_TO_PHOTO',
}

export enum SupplyPhotosInlineBannerTheme {
  ERROR = 'ERROR',
  INFO = 'INFO',
}

export enum SupplyPhotosPhotoStatus {
  ACTIVE = 'ACTIVE',
  PROCESSING = 'PROCESSING',
  REJECTED = 'REJECTED',
}

export enum SupplyPremierHostDownloadType {
  BOOKING_DETAILS = 'BOOKING_DETAILS',
  LISTINGS_SUMMARY = 'LISTINGS_SUMMARY',
}

export interface SupplyProductCreationAgeCategoryInput {
  minAge: Scalars['Int'];
  name: Scalars['String'];
}

export enum SupplyProductCreationBannerTheme {
  ERROR = 'ERROR',
  INFO = 'INFO',
  SUCCESS = 'SUCCESS',
  WARNING = 'WARNING',
}

export interface SupplyProductCreationBaseRateManagementInput {
  additionalOccupantCharge?: InputMaybe<Scalars['Float']>;
  baseRate?: InputMaybe<Scalars['Float']>;
  childAdditionalOccupantCharge?: InputMaybe<Scalars['Float']>;
  copyRoomTypeKey?: InputMaybe<Scalars['String']>;
  peopleIncludedInBaseRate?: InputMaybe<Scalars['Int']>;
  prefilledRoomId?: InputMaybe<Scalars['String']>;
  priceType: PricingType;
  ratePlanID?: InputMaybe<Scalars['String']>;
  roomMaxOccupancy?: InputMaybe<Scalars['Int']>;
  roomTypeKey?: InputMaybe<Scalars['String']>;
}

export interface SupplyProductCreationBed {
  quantity: Scalars['Int'];
  size: Scalars['String'];
  type: Scalars['String'];
}

export interface SupplyProductCreationBedGroup {
  beds?: InputMaybe<Array<SupplyProductCreationBed>>;
}

export interface SupplyProductCreationBedTypeConfiguration {
  bedGroups?: InputMaybe<Array<SupplyProductCreationBedGroup>>;
}

export interface SupplyProductCreationChildRateManagementInput {
  /** checkedRatePlans is to be deprecated in the future */
  checkedRatePlans?: InputMaybe<Array<RatePlanInfo>>;
  discount: Scalars['Float'];
  discountChanged: Scalars['Boolean'];
  rateType: SideSheetType;
  roomTypeKey: Scalars['String'];
  /** uncheckedRatePlans is to be deprecated in the future */
  uncheckedRatePlans?: InputMaybe<Array<InputMaybe<RatePlanInfo>>>;
}

export enum SupplyProductCreationContractStatus {
  INVALID = 'INVALID',
  NOT_FOUND = 'NOT_FOUND',
  VALID = 'VALID',
}

export interface SupplyProductCreationCopyRatePlanExperienceInput {
  copyRoomTypeId: Scalars['String'];
  roomTypeId?: InputMaybe<Scalars['String']>;
}

export interface SupplyProductCreationCopyRatePlanInfoInput {
  autoCreated?: InputMaybe<Scalars['Boolean']>;
  parentRatePlanId?: InputMaybe<Scalars['String']>;
  ratePlanId: Scalars['String'];
  ratePlanType: RatePlanType;
}

export interface SupplyProductCreationCopyRatePlanInput {
  contractStatus: SupplyProductCreationContractStatus;
  isAddWorkflow?: InputMaybe<Scalars['Boolean']>;
  ratePlans: Array<SupplyProductCreationCopyRatePlanInfoInput>;
  roomTypeId: Scalars['String'];
}

export interface SupplyProductCreationDeleteRatePlansInput {
  ratePlanIDs?: InputMaybe<Array<Scalars['String']>>;
  roomTypeKey?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<SideSheetType>;
}

export interface SupplyProductCreationDeleteRoomInput {
  roomTypeId: Scalars['String'];
}

export interface SupplyProductCreationExperienceInputParam {
  copyRoomTypeKey?: InputMaybe<Scalars['String']>;
  isAddPath?: InputMaybe<Scalars['Boolean']>;
  prefilledRoomId?: InputMaybe<Scalars['String']>;
  roomTypeKey?: InputMaybe<Scalars['String']>;
  showPricingModel?: InputMaybe<Scalars['Boolean']>;
  step: Scalars['String'];
  workflowType?: InputMaybe<Scalars['String']>;
}

export interface SupplyProductCreationExtraBedChargeInput {
  amount: Scalars['Int'];
  chargeType: SupplyProductCreationExtraBedChargeType;
}

export enum SupplyProductCreationExtraBedChargeType {
  PER_DAY = 'PER_DAY',
  PER_NIGHT = 'PER_NIGHT',
  PER_STAY = 'PER_STAY',
  PER_WEEK = 'PER_WEEK',
}

export interface SupplyProductCreationExtraBedInput {
  charge?: InputMaybe<SupplyProductCreationExtraBedChargeInput>;
  quantity: Scalars['Int'];
  size: Scalars['String'];
  type: Scalars['String'];
}

export interface SupplyProductCreationIndependentRateManagementInput {
  attributeType?: InputMaybe<Scalars['String']>;
  attributeTypeChanged?: InputMaybe<Scalars['Boolean']>;
  baseRatePlanId: Scalars['String'];
  /** breakfastType is mandatory, to be deprecated */
  breakfastType?: InputMaybe<Scalars['String']>;
  /** breakfastTypeChanged is mandatory, to be deprecated */
  breakfastTypeChanged?: InputMaybe<Scalars['Boolean']>;
  rateIncrease?: InputMaybe<SupplyProductCreationRateIncrease>;
  rateIncreaseChanged?: InputMaybe<Scalars['Boolean']>;
  ratePlanId?: InputMaybe<Scalars['String']>;
  roomTypeKey: Scalars['String'];
  type?: InputMaybe<SideSheetType>;
}

export enum SupplyProductCreationNavigationType {
  BACK = 'BACK',
  DONE = 'DONE',
  NEXT = 'NEXT',
}

export enum SupplyProductCreationPopularRateType {
  ALLINCLUSIVE = 'ALLINCLUSIVE',
  BREAKFAST = 'BREAKFAST',
  CONTRACTUAL = 'CONTRACTUAL',
  FULLBOARD = 'FULLBOARD',
  HALFBOARD = 'HALFBOARD',
  MOD = 'MOD',
  NONREFUNDABLE = 'NONREFUNDABLE',
  PACKAGE = 'PACKAGE',
  REFUNDABLE = 'REFUNDABLE',
}

export interface SupplyProductCreationPreviewBedConfigurationInput {
  inRoomAlternateBeds?: InputMaybe<Array<SupplyProductCreationBed>>;
  inRoomBeds: Array<SupplyProductCreationBed>;
  uponRequestBeds?: InputMaybe<Array<SupplyProductCreationBed>>;
}

export interface SupplyProductCreationRateIncrease {
  rateIncrease: Scalars['Float'];
  rateIncreaseType: RateAdjustmentType;
}

export interface SupplyProductCreationRatePlanSideSheetInput {
  roomTypeKey: Scalars['String'];
  type: SideSheetType;
}

export interface SupplyProductCreationRoomInfoInput {
  copyRoomTypeKey?: InputMaybe<Scalars['String']>;
  prefilledRoomId?: InputMaybe<Scalars['String']>;
  roomTypeKey?: InputMaybe<Scalars['String']>;
  /** "New added field PC/PCO, optional default to PCO in exp-api" */
  source?: InputMaybe<Scalars['String']>;
  workflowType?: InputMaybe<Scalars['String']>;
}

export interface SupplyProductCreationRoomInfoManagementInput {
  adultOccupancy?: InputMaybe<Scalars['Int']>;
  ageCategories?: InputMaybe<Array<SupplyProductCreationAgeCategoryInput>>;
  ariEnabled?: InputMaybe<Scalars['Boolean']>;
  childOccupancy?: InputMaybe<Scalars['Int']>;
  extraBeds?: InputMaybe<Array<SupplyProductCreationExtraBedInput>>;
  legacyBedIds?: InputMaybe<Array<Scalars['String']>>;
  maxOccupancy: Scalars['Int'];
  numberOfBedrooms?: InputMaybe<Scalars['Int']>;
  numberOfLivingRooms?: InputMaybe<Scalars['Int']>;
  numberOfRooms?: InputMaybe<Scalars['Int']>;
  roomClass?: InputMaybe<Scalars['String']>;
  roomCode?: InputMaybe<Scalars['String']>;
  roomType: Scalars['String'];
  roomTypeKey?: InputMaybe<Scalars['String']>;
  smokingPolicy: Scalars['String'];
  spaces: Array<SupplyProductCreationSpace>;
  taxes?: InputMaybe<Array<SupplyProductCreationRoomTax>>;
}

export enum SupplyProductCreationRoomNameAttributeCategoryName {
  ACCESSIBILITY = 'ACCESSIBILITY',
  AREA = 'AREA',
  BEDROOM_DETAILS = 'BEDROOM_DETAILS',
  FEATURE_AMENITY = 'FEATURE_AMENITY',
  OTHER_BEDROOM_DETAILS = 'OTHER_BEDROOM_DETAILS',
  OUTDOOR_SPACE = 'OUTDOOR_SPACE',
  ROOM_CLASS = 'ROOM_CLASS',
  ROOM_TYPE = 'ROOM_TYPE',
  SMOKING_POLICY = 'SMOKING_POLICY',
  VIEW = 'VIEW',
}

export interface SupplyProductCreationRoomNameAttributeInput {
  attributeId: Scalars['String'];
  sectionId: Scalars['String'];
  value?: InputMaybe<Scalars['String']>;
}

export interface SupplyProductCreationRoomNameAttributesInput {
  attributes: Array<SupplyProductCreationRoomNameAttributeInput>;
  customLabel?: InputMaybe<Scalars['String']>;
  overrideNames?: InputMaybe<Array<SupplyProductCreationRoomNameOverride>>;
  roomTypeKey?: InputMaybe<Scalars['String']>;
}

export interface SupplyProductCreationRoomNameInput {
  isAddPath?: InputMaybe<Scalars['Boolean']>;
  roomTypeKey: Scalars['String'];
  /** "New added field PC/PCO, optional default to PCO in exp-api" */
  source?: InputMaybe<Scalars['String']>;
  workflowType?: InputMaybe<SupplyPCRoomManagementWorkflowType>;
}

export interface SupplyProductCreationRoomNameOverride {
  language: Scalars['Int'];
  override?: InputMaybe<Scalars['Boolean']>;
  value: Scalars['String'];
}

export interface SupplyProductCreationRoomNameUpdateInput {
  roomTypeId: Scalars['String'];
}

export interface SupplyProductCreationRoomOverviewInput {
  successRoomTypeKey?: InputMaybe<Scalars['String']>;
}

export enum SupplyProductCreationRoomOverviewTabName {
  FINISHED_ROOMS = 'FINISHED_ROOMS',
  UNFINISHED_ROOMS = 'UNFINISHED_ROOMS',
}

export interface SupplyProductCreationRoomTax {
  amount: Scalars['Float'];
  endDate?: InputMaybe<Scalars['String']>;
  startDate: Scalars['String'];
}

export interface SupplyProductCreationSpace {
  bedTypeConfiguration?: InputMaybe<SupplyProductCreationBedTypeConfiguration>;
  id?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
  typeNumber?: InputMaybe<Scalars['Int']>;
}

export interface SupplyProductCreationTipCardInput {
  cardName: Scalars['String'];
}

export interface SupplyProductCreationUpdateStepStatusInput {
  stepName?: InputMaybe<Scalars['String']>;
  type: SupplyProductCreationNavigationType;
}

export enum SupplyProgramsAlignment {
  CENTER = 'CENTER',
  LEFT = 'LEFT',
}

export interface SupplyProgramsCopyRatePlanInput {
  ratePlanIds: Array<Scalars['String']>;
}

export enum SupplyProgramsEnrollmentStatus {
  ACCEPTED_TERMS = 'ACCEPTED_TERMS',
  ACTIVE_ENROLLMENT = 'ACTIVE_ENROLLMENT',
  ELIGIBLE_TO_ENROLL = 'ELIGIBLE_TO_ENROLL',
  NOT_ELIGIBLE = 'NOT_ELIGIBLE',
}

export interface SupplyProgramsOffersAcceptanceInput {
  offerIds: Array<Scalars['String']>;
  program: Scalars['String'];
}

export enum SupplyProgramsResponseStatus {
  FAILURE = 'FAILURE',
  SUCCESS = 'SUCCESS',
}

export enum SupplyProgramsSheetType {
  ENROLLMENT = 'ENROLLMENT',
  HOW_IT_WORKS_POPOVER = 'HOW_IT_WORKS_POPOVER',
  VIEW_TERMS_AND_CONDITIONS = 'VIEW_TERMS_AND_CONDITIONS',
  VIEW_TERMS_AND_CONDITIONS_ONLY = 'VIEW_TERMS_AND_CONDITIONS_ONLY',
}

export interface SupplyProgramsSideSheetInput {
  navType: SupplyProgramsToolbarNavType;
  program: Scalars['String'];
  sheetType: SupplyProgramsSheetType;
}

export enum SupplyProgramsToolbarNavType {
  BACK = 'BACK',
  CLOSE = 'CLOSE',
}

export interface SupplyPromotionCreateMembersOnlyDealsTiersInput {
  blockoutDates?: InputMaybe<Array<SupplyPromotionDateRangeInput>>;
  bookingDates?: InputMaybe<SupplyPromotionDateRangeInput>;
  bookingLimit?: InputMaybe<Scalars['Int']>;
  canStackToOtherPromotions?: InputMaybe<Scalars['Boolean']>;
  isManaged?: InputMaybe<Scalars['Boolean']>;
  isNegotiated?: InputMaybe<Scalars['Boolean']>;
  memberTiersDiscounts: SupplyPromotionMemberTiersDiscountsInput;
  name: Scalars['String'];
  promotionRunDates?: InputMaybe<SupplyPromotionDateRangeInput>;
  ratePlanIds?: InputMaybe<Array<Scalars['String']>>;
  restrictions?: InputMaybe<SupplyPromotionRestrictionsInput>;
  stayDates?: InputMaybe<SupplyPromotionDateRangeInput>;
}

export interface SupplyPromotionDateRangeInput {
  endDate?: InputMaybe<DateInput>;
  startDate: DateInput;
}

export interface SupplyPromotionMemberTiersDiscountsInput {
  baseMemberDiscount: Scalars['Int'];
  middleMemberDiscount?: InputMaybe<Scalars['Int']>;
  topMemberDiscount?: InputMaybe<Scalars['Int']>;
}

export enum SupplyPromotionNotificationType {
  ERROR = 'ERROR',
  SUCCESS = 'SUCCESS',
}

export interface SupplyPromotionNumberRangeInput {
  max: Scalars['Int'];
  min: Scalars['Int'];
}

export interface SupplyPromotionPairInput {
  /** The name of promotion restriction for mutation */
  name: Scalars['String'];
  /** The value of promotion restriction for mutation */
  value?: InputMaybe<Array<Scalars['String']>>;
}

export enum SupplyPromotionReservationMode {
  ADVANCED = 'ADVANCED',
  STANDARD = 'STANDARD',
}

export enum SupplyPromotionResponseStatus {
  FAIL = 'FAIL',
  SUCCESS = 'SUCCESS',
}

export interface SupplyPromotionRestrictionsInput {
  earlyBooking?: InputMaybe<SupplyPromotionNumberRangeInput>;
  lengthOfStay?: InputMaybe<SupplyPromotionNumberRangeInput>;
}

export enum SupplyPromotionStatus {
  ACTIVE = 'ACTIVE',
  EXPIRED = 'EXPIRED',
  INACTIVE = 'INACTIVE',
}

export interface SupplyPromotionUpdateMembersOnlyDealsTiersInput {
  blockoutDates?: InputMaybe<Array<SupplyPromotionDateRangeInput>>;
  bookingDates?: InputMaybe<SupplyPromotionDateRangeInput>;
  bookingLimit?: InputMaybe<Scalars['Int']>;
  canStackToOtherPromotions?: InputMaybe<Scalars['Boolean']>;
  isManaged?: InputMaybe<Scalars['Boolean']>;
  isNegotiated?: InputMaybe<Scalars['Boolean']>;
  memberTiersDiscounts: SupplyPromotionMemberTiersDiscountsInput;
  name: Scalars['String'];
  promotionRunDates?: InputMaybe<SupplyPromotionDateRangeInput>;
  ratePlanIds?: InputMaybe<Array<Scalars['String']>>;
  restrictions?: InputMaybe<SupplyPromotionRestrictionsInput>;
  stayDates?: InputMaybe<SupplyPromotionDateRangeInput>;
}

export interface SupplyPropertyRateInput {
  baseRate: Scalars['Float'];
  currencyCode: Scalars['String'];
  language: Scalars['String'];
}

export enum SupplyPropertyVideosActionType {
  CARD_BUTTON = 'CARD_BUTTON',
  LINK = 'LINK',
  LINK_BUTTON = 'LINK_BUTTON',
  PRIMARY_BUTTON = 'PRIMARY_BUTTON',
  SECONDARY_BUTTON = 'SECONDARY_BUTTON',
  TERTIARY_BUTTON = 'TERTIARY_BUTTON',
  TOOL_BAR_BUTTON = 'TOOL_BAR_BUTTON',
}

export interface SupplyPropertyVideosAddVideoInput {
  fileName: Scalars['String'];
  md5: Scalars['String'];
}

/** The experience varies by the view (PE, PC) */
export interface SupplyPropertyVideosExperienceContext {
  view: Scalars['String'];
}

export enum SupplyPropertyVideosVideoType {
  BASIC = 'BASIC',
  EMBED = 'EMBED',
}

export enum SupplyQuickActionComparisonType {
  GREATER_THAN = 'GREATER_THAN',
  LESSER_THAN = 'LESSER_THAN',
}

/** Allowed operations on subscribe event */
export enum SupplyQuickActionElementVisibility {
  HIDE_SELF = 'HIDE_SELF',
  SHOW_SELF = 'SHOW_SELF',
}

/** Allowed operations on subscribe event */
export enum SupplyQuickActionFieldProcessorOperation {
  PERCENT_CALC_AND_REPLACE = 'PERCENT_CALC_AND_REPLACE',
  PLAIN_REPLACE = 'PLAIN_REPLACE',
  SUBTRACT_AND_REPLACE = 'SUBTRACT_AND_REPLACE',
}

export enum SupplyQuickActionFieldSetDirection {
  HORIZONTAL = 'HORIZONTAL',
  VERTICAL = 'VERTICAL',
}

export interface SupplyQuickActionFormContextInput {
  key: Scalars['String'];
  values: Array<Scalars['String']>;
}

/**
 * SupplyQuickActionSpacingSize
 * Note: only 0X_HALF, 1X, 2X, 3X, 4X, 6X, 12X, 16X are supported for desktop.
 * Using other sizes may render differently different on mobile and desktop
 */
export enum SupplyQuickActionSpacingSize {
  SPACING__0X__HALF = 'SPACING__0X__HALF',
  SPACING__1X = 'SPACING__1X',
  SPACING__2X = 'SPACING__2X',
  SPACING__3X = 'SPACING__3X',
  SPACING__4X = 'SPACING__4X',
  SPACING__5X = 'SPACING__5X',
  SPACING__6X = 'SPACING__6X',
  SPACING__8X = 'SPACING__8X',
  SPACING__10X = 'SPACING__10X',
  SPACING__11X = 'SPACING__11X',
  SPACING__12X = 'SPACING__12X',
  SPACING__14X = 'SPACING__14X',
  SPACING__16X = 'SPACING__16X',
}

export enum SupplyQuickActionTableAlignment {
  CENTER = 'CENTER',
  LEADING = 'LEADING',
  TRAILING = 'TRAILING',
}

export enum SupplyQuickActionTableItemCellType {
  NORMAL = 'NORMAL',
  STRIKETHROUGH = 'STRIKETHROUGH',
}

export interface SupplyRateAutomationInput {
  currency: Scalars['String'];
  maxRate: Scalars['Float'];
  minRate: Scalars['Float'];
}

export enum SupplyRateAvailabilityObservationSpacingSize {
  SPACING__0X__HALF = 'SPACING__0X__HALF',
  SPACING__1X = 'SPACING__1X',
  SPACING__2X = 'SPACING__2X',
  SPACING__3X = 'SPACING__3X',
  SPACING__4X = 'SPACING__4X',
  SPACING__5X = 'SPACING__5X',
  SPACING__6X = 'SPACING__6X',
  SPACING__8X = 'SPACING__8X',
}

export interface SupplyRateAvailabilityObservationsFilter {
  key: Scalars['String'];
  value: Array<Scalars['String']>;
}

export interface SupplyRateAvailabilityObservationsOptions {
  filters: Array<SupplyRateAvailabilityObservationsFilter>;
}

export interface SupplyRatePlanBaseRateInput {
  additionalOccupants?: InputMaybe<Scalars['String']>;
  baseRate: Scalars['String'];
  maxOccupants?: InputMaybe<Scalars['String']>;
  occupants: Scalars['String'];
  pricingModel: Scalars['String'];
}

export enum SupplyRatePlanBusinessModels {
  EXPEDIA_COLLECT = 'EXPEDIA_COLLECT',
  EXPEDIA_TRAVELER_PREFERENCE = 'EXPEDIA_TRAVELER_PREFERENCE',
  HOTEL_COLLECT = 'HOTEL_COLLECT',
  UNSPECIFIED = 'UNSPECIFIED',
}

export enum SupplyRatePlanButtonType {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
}

export enum SupplyRatePlanCheckboxType {
  ADVANCE_AND_LAST_MINUTE_BOOKING = 'ADVANCE_AND_LAST_MINUTE_BOOKING',
  LENGTH_OF_STAY = 'LENGTH_OF_STAY',
  LIMIT_TO_CERTAIN_TRAVELERS = 'LIMIT_TO_CERTAIN_TRAVELERS',
  /** @deprecated Use 'ONLY_CERTAIN_STAY_DATES_AND_BOOKING_DATES' instead */
  ONLY_CERTAIN_BOOKING_DATES = 'ONLY_CERTAIN_BOOKING_DATES',
  /** @deprecated Use 'ONLY_CERTAIN_STAY_DATES_AND_BOOKING_DATES' instead */
  ONLY_CERTAIN_STAY_DATES = 'ONLY_CERTAIN_STAY_DATES',
  ONLY_CERTAIN_STAY_DATES_AND_BOOKING_DATES = 'ONLY_CERTAIN_STAY_DATES_AND_BOOKING_DATES',
}

export interface SupplyRatePlanCompensationInput {
  ruleId: Scalars['String'];
  type: Scalars['String'];
}

export enum SupplyRatePlanCopyOption {
  B2B_DISTRIBUTION_CUSTOM = 'B2B_DISTRIBUTION_CUSTOM',
  BUSINESS_CUSTOM = 'BUSINESS_CUSTOM',
  STANDARD_CUSTOM = 'STANDARD_CUSTOM',
}

export enum SupplyRatePlanCreationOption {
  B2B_DISTRIBUTION_CUSTOM = 'B2B_DISTRIBUTION_CUSTOM',
  BUSINESS_CUSTOM = 'BUSINESS_CUSTOM',
  STANDARD_CUSTOM = 'STANDARD_CUSTOM',
}

export interface SupplyRatePlanDateRangeInput {
  endDate: Scalars['String'];
  startDate: Scalars['String'];
}

export enum SupplyRatePlanEditOption {
  REACTIVATE = 'REACTIVATE',
}

export interface SupplyRatePlanFeeInput {
  type: Scalars['String'];
}

export interface SupplyRatePlanForRoomTypesQueryInput {
  copyOption?: InputMaybe<SupplyRatePlanCopyOption>;
  createOption?: InputMaybe<SupplyRatePlanCreationOption>;
  operationType?: InputMaybe<SupplyRatePlanOperationType>;
  ratePlanId?: InputMaybe<Scalars['String']>;
}

export enum SupplyRatePlanIconPosition {
  LEADING = 'LEADING',
  TRAILING = 'TRAILING',
}

export interface SupplyRatePlanInput {
  baseRate?: InputMaybe<SupplyRatePlanBaseRateInput>;
  businessModel: Array<SupplyRatePlanBusinessModels>;
  cancellationPolicy: Scalars['String'];
  compensation: SupplyRatePlanCompensationInput;
  expediaCollectCompensation?: InputMaybe<SupplyRatePlanCompensationInput>;
  feeType: SupplyRatePlanFeeInput;
  hotelCollectCompensation?: InputMaybe<SupplyRatePlanCompensationInput>;
  internalOnly?: InputMaybe<Scalars['Boolean']>;
  /** Used to verify if the package rate plan will be created by RPDS or not. */
  isEnrolledToFencedDiscount?: InputMaybe<Scalars['Boolean']>;
  losPricing?: InputMaybe<SupplyRatePlanLOSPricingInput>;
  nonRefundable?: InputMaybe<SupplyRatePlanNonRefundableInput>;
  ratePlanName: Scalars['String'];
  ratePlanNotificationCode?: InputMaybe<SupplyRatePlanNotificationCodeInput>;
  ratePlanRoomTypes: Array<SupplyRatePlanRoomTypesInput>;
  ratePlanType: SupplyRatePlanTypeInput;
  restrictions: SupplyRatePlanRestrictionsInput;
  status?: InputMaybe<SupplyRatePlanStatus>;
  taxInclusive?: InputMaybe<Scalars['Boolean']>;
  valueAdds: Array<SupplyRatePlanValueAddInput>;
}

export interface SupplyRatePlanLOSPricingInput {
  enabled: Scalars['Boolean'];
  pricingValues?: InputMaybe<Array<SupplyRatePlanLOSPricingValueInput>>;
}

export interface SupplyRatePlanLOSPricingValueInput {
  baseRate?: InputMaybe<Scalars['String']>;
  occupants?: InputMaybe<Scalars['String']>;
  range?: InputMaybe<Scalars['String']>;
}

export interface SupplyRatePlanNonRefundableInput {
  discount: Scalars['String'];
}

export interface SupplyRatePlanNotificationCodeInput {
  agencyRatePlanCode?: InputMaybe<Scalars['String']>;
  merchantRatePlanCode?: InputMaybe<Scalars['String']>;
}

export enum SupplyRatePlanOperationType {
  COPY = 'COPY',
  CREATE = 'CREATE',
  EDIT = 'EDIT',
}

export enum SupplyRatePlanPreviewOfferType {
  BREAKFAST_INCLUDED = 'BREAKFAST_INCLUDED',
  NON_REFUNDABLE = 'NON_REFUNDABLE',
  PACKAGE = 'PACKAGE',
}

export interface SupplyRatePlanQueryInput {
  copyOption?: InputMaybe<SupplyRatePlanCopyOption>;
  createOption?: InputMaybe<SupplyRatePlanCreationOption>;
  editOption?: InputMaybe<SupplyRatePlanEditOption>;
  inBREnrollmentFlow?: InputMaybe<Scalars['Boolean']>;
  operationType?: InputMaybe<SupplyRatePlanOperationType>;
  ratePlanId?: InputMaybe<Scalars['String']>;
  roomTypeId?: InputMaybe<Scalars['String']>;
}

export interface SupplyRatePlanRangeInput {
  max: Scalars['Int'];
  min: Scalars['Int'];
}

export enum SupplyRatePlanRegionInclusionType {
  EXCLUDE = 'EXCLUDE',
  INCLUDE = 'INCLUDE',
}

export interface SupplyRatePlanRegionRestrictionsInput {
  channelIds?: InputMaybe<Array<Scalars['String']>>;
  inclusivity: SupplyRatePlanRegionInclusionType;
  regionIds?: InputMaybe<Array<Scalars['String']>>;
}

export enum SupplyRatePlanResponseStatus {
  FAIL = 'FAIL',
  SUCCESS = 'SUCCESS',
}

export interface SupplyRatePlanRestrictionsInput {
  advanceAndLastMinuteBooking?: InputMaybe<SupplyRatePlanRangeInput>;
  bookingDates?: InputMaybe<Array<SupplyRatePlanDateRangeInput>>;
  lengthOfStay?: InputMaybe<SupplyRatePlanRangeInput>;
  regionRestrictions?: InputMaybe<SupplyRatePlanRegionRestrictionsInput>;
  stayDates?: InputMaybe<Array<SupplyRatePlanDateRangeInput>>;
  travelerRestrictions?: InputMaybe<Array<SupplyRatePlanTravelerRestrictionsInput>>;
}

export interface SupplyRatePlanRightRailInput {
  isInactiveRoom?: InputMaybe<Scalars['Boolean']>;
  ratePlanId?: InputMaybe<Scalars['String']>;
  roomTypeId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<SupplyRatePlanRightRailType>;
}

export enum SupplyRatePlanRightRailType {
  ADD_RATE_PLAN = 'ADD_RATE_PLAN',
  COPY_RATE_PLAN = 'COPY_RATE_PLAN',
  COPY_ROOM = 'COPY_ROOM',
}

export interface SupplyRatePlanRoomTypesInput {
  roomTypeId: Scalars['String'];
  roomTypeName: Scalars['String'];
}

export enum SupplyRatePlanStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  UNSPECIFIED = 'UNSPECIFIED',
}

export interface SupplyRatePlanTravelerRestrictionsInput {
  checked: Scalars['Boolean'];
  value: Scalars['String'];
}

export interface SupplyRatePlanTypeInput {
  discount: Scalars['String'];
  values: Array<SupplyRatePlanTypes>;
}

export enum SupplyRatePlanTypes {
  CORPORATE = 'CORPORATE',
  PACKAGE = 'PACKAGE',
  STANDALONE = 'STANDALONE',
  UNSPECIFIED = 'UNSPECIFIED',
  WHOLESALE = 'WHOLESALE',
  WHOLESALE_PACKAGE = 'WHOLESALE_PACKAGE',
}

export interface SupplyRatePlanValueAddInput {
  name: Scalars['String'];
  value: Scalars['String'];
}

export enum SupplyRatesEditorSettingAction {
  CANCELLATION_POLICY = 'CANCELLATION_POLICY',
  MIN_NIGHT_STAY = 'MIN_NIGHT_STAY',
  PROMOTIONS = 'PROMOTIONS',
  RESTRICTED_CHECK_IN = 'RESTRICTED_CHECK_IN',
  RESTRICTED_CHECK_OUT = 'RESTRICTED_CHECK_OUT',
}

export enum SupplyRatesSettingsDrawerAction {
  DATES = 'DATES',
  NOTES = 'NOTES',
  RATE = 'RATE',
  SETTINGS = 'SETTINGS',
}

export interface SupplyRegulatoryFlowThirdPartyValidationInput {
  /** The field to validate */
  field: Scalars['String'];
  /** other possible parameters for the Third party validation */
  options: Array<SupplyRegulatoryFlowThirdPartyValidationOption>;
  /** The Third party validation rule */
  rule: Scalars['String'];
  /** The field value to validate */
  value: Scalars['String'];
}

export interface SupplyRegulatoryFlowThirdPartyValidationOption {
  name: Scalars['String'];
  value: Scalars['String'];
}

export interface SupplyRegulatoryNavigateStepInput {
  /** navType can be back, next, skip */
  navType: Scalars['String'];
  regulatoryType: Scalars['String'];
}

export interface SupplyRegulatorySettingInput {
  name: Scalars['String'];
  value?: InputMaybe<Scalars['String']>;
}

export enum SupplyRegulatorySpacing {
  eight = 'eight',
  four = 'four',
  half = 'half',
  one = 'one',
  six = 'six',
  sixteen = 'sixteen',
  three = 'three',
  twelve = 'twelve',
  two = 'two',
  unset = 'unset',
}

export enum SupplyRegulatoryStatus {
  COMPLIANT = 'COMPLIANT',
  NONE = 'NONE',
  NOT_COMPLIANT = 'NOT_COMPLIANT',
}

export enum SupplyReservationDetailsComponentType {
  ACCESS_INSTRUCTIONS = 'ACCESS_INSTRUCTIONS',
  AUTOMATED_PAYOUT_STATUSES = 'AUTOMATED_PAYOUT_STATUSES',
  CANCELLATION_POLICY = 'CANCELLATION_POLICY',
  DAMAGE_DEPOSIT = 'DAMAGE_DEPOSIT',
  INVOICE_STATUSES = 'INVOICE_STATUSES',
  MINI_AVAILABILITY_CALENDAR = 'MINI_AVAILABILITY_CALENDAR',
  PARTNER_NOTES = 'PARTNER_NOTES',
  PAYMENT_DETAILS = 'PAYMENT_DETAILS',
  PAYMENT_REQUEST_STATUSES = 'PAYMENT_REQUEST_STATUSES',
  PAYMENT_SCHEDULE = 'PAYMENT_SCHEDULE',
  PAYMENT_SUMMARY = 'PAYMENT_SUMMARY',
  RENTAL_AGREEMENT = 'RENTAL_AGREEMENT',
  STAY_DETAILS = 'STAY_DETAILS',
  TRAVELER_INFO = 'TRAVELER_INFO',
}

export enum SupplyReservationStatusType {
  ARRIVING_TODAY = 'ARRIVING_TODAY',
  BOOKED = 'BOOKED',
  BOOKING_REQUEST = 'BOOKING_REQUEST',
  BOOKING_REQUEST_DECLINED = 'BOOKING_REQUEST_DECLINED',
  BOOKING_REQUEST_EXPIRED = 'BOOKING_REQUEST_EXPIRED',
  CANCELED = 'CANCELED',
  CANCELLATION_REQUEST = 'CANCELLATION_REQUEST',
  CURRENT_STAY = 'CURRENT_STAY',
  INQUIRY = 'INQUIRY',
  POST_STAY = 'POST_STAY',
  PRE_APPROVAL_EXPIRED = 'PRE_APPROVAL_EXPIRED',
  PRE_APPROVED = 'PRE_APPROVED',
  REQUEST_WITHDRAWN = 'REQUEST_WITHDRAWN',
  UNKNOWN = 'UNKNOWN',
}

export interface SupplyReservationsAccessIdentifierInput {
  id: Scalars['String'];
  idType: Scalars['String'];
}

export interface SupplyReservationsAccessInstructionPhotoInput {
  imageId: Scalars['UUID'];
  photoUrl: Scalars['String'];
  title?: InputMaybe<Scalars['String']>;
}

export interface SupplyReservationsAccessInstructionsInput {
  accessCode?: InputMaybe<Scalars['String']>;
  accessType: SupplyReservationsAccessTypes;
  gallery?: InputMaybe<Array<InputMaybe<SupplyReservationsAccessInstructionPhotoInput>>>;
  instructions: Scalars['String'];
}

export enum SupplyReservationsAccessTypes {
  DOORMAN = 'DOORMAN',
  KEYPAD = 'KEYPAD',
  LOCKBOX = 'LOCKBOX',
  OTHER = 'OTHER',
  PICKUP = 'PICKUP',
  SMART_LOCK = 'SMART_LOCK',
}

export enum SupplyReservationsActionType {
  ACCESS_INSTRUCTIONS_ADD = 'ACCESS_INSTRUCTIONS_ADD',
  ACCESS_INSTRUCTIONS_EDIT = 'ACCESS_INSTRUCTIONS_EDIT',
  AUTOMATED_PAYOUT_STATUS_ACTION = 'AUTOMATED_PAYOUT_STATUS_ACTION',
  AUTO_CANCEL_WAIVERS_CANCEL_CHANGES = 'AUTO_CANCEL_WAIVERS_CANCEL_CHANGES',
  AUTO_CANCEL_WAIVERS_SAVE_CHANGES = 'AUTO_CANCEL_WAIVERS_SAVE_CHANGES',
  CREDIT_CARD_RECAPTURE_CLOSE = 'CREDIT_CARD_RECAPTURE_CLOSE',
  CREDIT_CARD_RECAPTURE_REQUEST_UPDATED_CARD = 'CREDIT_CARD_RECAPTURE_REQUEST_UPDATED_CARD',
  DAMAGE_PROTECTION_REFUND_DEPOSIT = 'DAMAGE_PROTECTION_REFUND_DEPOSIT',
  DAMAGE_PROTECTION_REPORT_DAMAGE = 'DAMAGE_PROTECTION_REPORT_DAMAGE',
  DAMAGE_PROTECTION_REPORT_DAMAGE_EXTERNAL = 'DAMAGE_PROTECTION_REPORT_DAMAGE_EXTERNAL',
  DAMAGE_PROTECTION_SEE_DAMAGE_REPORT = 'DAMAGE_PROTECTION_SEE_DAMAGE_REPORT',
  DAMAGE_PROTECTION_SEE_POLICY = 'DAMAGE_PROTECTION_SEE_POLICY',
  EVC_MANAGE_CARD_MORE_INFO = 'EVC_MANAGE_CARD_MORE_INFO',
  EVC_MANAGE_CARD_SEARCH = 'EVC_MANAGE_CARD_SEARCH',
  EVC_MANAGE_FEEDBACK = 'EVC_MANAGE_FEEDBACK',
  EVC_MANAGE_RESERVATION_DETAILS = 'EVC_MANAGE_RESERVATION_DETAILS',
  GUEST_INFO_EMAIL = 'GUEST_INFO_EMAIL',
  GUEST_INFO_PHONE = 'GUEST_INFO_PHONE',
  GUEST_INFO_VIEW_PROFILE = 'GUEST_INFO_VIEW_PROFILE',
  HEADER_ARCHIVE = 'HEADER_ARCHIVE',
  HEADER_DETAILS = 'HEADER_DETAILS',
  HEADER_FEEDBACK = 'HEADER_FEEDBACK',
  HEADER_HELP_CENTER = 'HEADER_HELP_CENTER',
  HEADER_MARK_AS_READ = 'HEADER_MARK_AS_READ',
  HEADER_MARK_AS_SPAM = 'HEADER_MARK_AS_SPAM',
  HEADER_MARK_AS_UNREAD = 'HEADER_MARK_AS_UNREAD',
  HEADER_PRINT = 'HEADER_PRINT',
  HEADER_SHARE = 'HEADER_SHARE',
  HEADER_UNARCHIVE = 'HEADER_UNARCHIVE',
  INVOICE_STATUS_ACTION = 'INVOICE_STATUS_ACTION',
  NOTES_ADD = 'NOTES_ADD',
  NOTES_CANCEL = 'NOTES_CANCEL',
  NOTES_EDIT = 'NOTES_EDIT',
  NOTES_SAVE = 'NOTES_SAVE',
  PAYMENT_REQUEST_STATUS_ACTION = 'PAYMENT_REQUEST_STATUS_ACTION',
  PAYMENT_SCHEDULE_ADD_EXTRA_CHARGE = 'PAYMENT_SCHEDULE_ADD_EXTRA_CHARGE',
  PAYMENT_SCHEDULE_CANCEL_PAYMENT_REQUEST = 'PAYMENT_SCHEDULE_CANCEL_PAYMENT_REQUEST',
  PAYMENT_SCHEDULE_EDIT_PAYMENT_SCHEDULE = 'PAYMENT_SCHEDULE_EDIT_PAYMENT_SCHEDULE',
  PAYMENT_SCHEDULE_MARK_PAID = 'PAYMENT_SCHEDULE_MARK_PAID',
  PAYMENT_SCHEDULE_RESEND_REQUEST = 'PAYMENT_SCHEDULE_RESEND_REQUEST',
  PAYMENT_SCHEDULE_SEND_A_REFUND = 'PAYMENT_SCHEDULE_SEND_A_REFUND',
  PAYMENT_SUMMARY_VIEW = 'PAYMENT_SUMMARY_VIEW',
  RENTAL_AGREEMENT_VIEW = 'RENTAL_AGREEMENT_VIEW',
  RESERVATION_MODIFIERS_BACK = 'RESERVATION_MODIFIERS_BACK',
  RESERVATION_MODIFIERS_CLOSE = 'RESERVATION_MODIFIERS_CLOSE',
  RESERVATION_MODIFIERS_NEXT = 'RESERVATION_MODIFIERS_NEXT',
  RESERVATION_MODIFIERS_SAVE_CANCEL = 'RESERVATION_MODIFIERS_SAVE_CANCEL',
  RESERVATION_MODIFIERS_SAVE_CHANGE_DATES = 'RESERVATION_MODIFIERS_SAVE_CHANGE_DATES',
  RESERVATION_MODIFIERS_SAVE_GUEST_SATISFACTION_REFUND = 'RESERVATION_MODIFIERS_SAVE_GUEST_SATISFACTION_REFUND',
  RESERVATION_MODIFIERS_SAVE_NO_SHOW = 'RESERVATION_MODIFIERS_SAVE_NO_SHOW',
  STAY_DETAILS_ACCEPT = 'STAY_DETAILS_ACCEPT',
  STAY_DETAILS_ADD_REMOVE_GUESTS = 'STAY_DETAILS_ADD_REMOVE_GUESTS',
  STAY_DETAILS_CANCEL_PRE_APPROVAL = 'STAY_DETAILS_CANCEL_PRE_APPROVAL',
  STAY_DETAILS_CANCEL_RESERVATION = 'STAY_DETAILS_CANCEL_RESERVATION',
  STAY_DETAILS_CHANGE_DATES = 'STAY_DETAILS_CHANGE_DATES',
  STAY_DETAILS_CHANGE_TIME = 'STAY_DETAILS_CHANGE_TIME',
  STAY_DETAILS_CONFIRM_CANCELLATION = 'STAY_DETAILS_CONFIRM_CANCELLATION',
  STAY_DETAILS_DECLINE = 'STAY_DETAILS_DECLINE',
  STAY_DETAILS_EDIT_DATES = 'STAY_DETAILS_EDIT_DATES',
  STAY_DETAILS_EDIT_QUOTE = 'STAY_DETAILS_EDIT_QUOTE',
  STAY_DETAILS_EDIT_RESERVATION = 'STAY_DETAILS_EDIT_RESERVATION',
  STAY_DETAILS_SEND_PRE_APPROVAL = 'STAY_DETAILS_SEND_PRE_APPROVAL',
  VIEW_IN_CALENDAR = 'VIEW_IN_CALENDAR',
}

export enum SupplyReservationsBookingRequestErrorType {
  /** The request has already been completed */
  COMPLETED = 'COMPLETED',
  /** The booking request is in a state that cannot be accepted that is not completed or processing */
  NOT_ACCEPTABLE = 'NOT_ACCEPTABLE',
  /** The request is already being processed */
  PROCESSING = 'PROCESSING',
  /** The request timed out */
  TIMEOUT = 'TIMEOUT',
  /** Unspecified error, default */
  UNKNOWN = 'UNKNOWN',
}

export enum SupplyReservationsDeclineOption {
  BLOCK_DATES = 'BLOCK_DATES',
  LEAVE_DATES = 'LEAVE_DATES',
}

export enum SupplyReservationsDeclineStep {
  /**
   * Move to the panel to confirm decline decision
   * @deprecated Confirm panel is being replaced with TERMS panel.
   */
  CONFIRM = 'CONFIRM',
  /** Move to the panel to send a message to the traveler */
  MESSAGE = 'MESSAGE',
  /** Move to the panel to pick a decline reason */
  REASON = 'REASON',
  /**
   * Move to the panel to pick a decline reason
   * @deprecated Reason and message are now separate steps.
   */
  REASON_AND_MESSAGE = 'REASON_AND_MESSAGE',
  /** Move to the panel to review the terms of the decline */
  TERMS = 'TERMS',
}

export enum SupplyReservationsEvcManagerTabType {
  EVC_LOOKUP = 'EVC_LOOKUP',
  EVC_MANAGE = 'EVC_MANAGE',
}

export enum SupplyReservationsEvcManagerTableType {
  EVC_CARDS_TO_CHARGE = 'EVC_CARDS_TO_CHARGE',
  EVC_CARDS_TO_REFUND = 'EVC_CARDS_TO_REFUND',
}

export interface SupplyReservationsEvcSearchInput {
  checkInDate: Scalars['String'];
  inputType: SupplyReservationsEvcSearchInputType;
  textInput: Scalars['String'];
}

export enum SupplyReservationsEvcSearchInputType {
  EVC_NUMBER = 'EVC_NUMBER',
  RESERVATION_ID = 'RESERVATION_ID',
}

export interface SupplyReservationsEvcSearchPageInput {
  currPageIdentifier?: InputMaybe<SupplyReservationsEvcTablePaginationPageInfo>;
  pageNumber?: InputMaybe<Scalars['Int']>;
  pageRequestedIdentifier?: InputMaybe<SupplyReservationsEvcTablePaginationPageInfo>;
  pageSize?: InputMaybe<Scalars['Int']>;
  prevPageIdentifiers?: InputMaybe<Array<InputMaybe<SupplyReservationsEvcTablePaginationPageInfo>>>;
}

export interface SupplyReservationsEvcTablePaginationPageInfo {
  pageIdentifier?: InputMaybe<Scalars['String']>;
  pageNum?: InputMaybe<Scalars['Int']>;
}

export enum SupplyReservationsInteractionActionType {
  ACCEPT_BOOKING_REQUEST = 'ACCEPT_BOOKING_REQUEST',
  CONFIRM_CANCELLATION = 'CONFIRM_CANCELLATION',
  DECLINE_BOOKING_REQUEST = 'DECLINE_BOOKING_REQUEST',
  EDIT_QUOTE = 'EDIT_QUOTE',
  PRE_APPROVE = 'PRE_APPROVE',
}

export interface SupplyReservationsInteractionAddChatMessageRequest {
  attachmentIds?: InputMaybe<Array<Scalars['String']>>;
  interactionId: Scalars['String'];
  reply?: InputMaybe<Scalars['String']>;
}

export enum SupplyReservationsInteractionBannerTheme {
  CRITICAL = 'CRITICAL',
  ERROR = 'ERROR',
}

export enum SupplyReservationsInteractionChatImageSize {
  LARGE = 'LARGE',
  SMALL = 'SMALL',
}

export enum SupplyReservationsInteractionListActionDialogFooterActionType {
  PRIMARY = 'PRIMARY',
  TERTIARY = 'TERTIARY',
}

export enum SupplyReservationsInteractionListColumnHorizontalAlign {
  CENTER = 'CENTER',
  END = 'END',
  JUSTIFY = 'JUSTIFY',
  JUSTIFY_ALL = 'JUSTIFY_ALL',
  LEFT = 'LEFT',
  MATCH_PARENT = 'MATCH_PARENT',
  RIGHT = 'RIGHT',
  START = 'START',
}

export enum SupplyReservationsInteractionListColumnVerticalAlign {
  BASELINE = 'BASELINE',
  BOTTOM = 'BOTTOM',
  MIDDLE = 'MIDDLE',
  SUB = 'SUB',
  SUPER = 'SUPER',
  TEXT_BOTTOM = 'TEXT_BOTTOM',
  TEXT_TOP = 'TEXT_TOP',
  TOP = 'TOP',
}

export enum SupplyReservationsInteractionListItemAction {
  ARCHIVE = 'ARCHIVE',
  READ = 'READ',
  SPAM = 'SPAM',
  UNARCHIVE = 'UNARCHIVE',
  UNREAD = 'UNREAD',
}

export enum SupplyReservationsInteractionListSwipeActionEdge {
  LEADING = 'LEADING',
  TRAILING = 'TRAILING',
}

export enum SupplyReservationsInteractionMessageGroupFooterState {
  /** Represents default footer for server returned message, showing the timestamp */
  DEFAULT = 'DEFAULT',
  /** Represents the state that the message failed to deliver */
  ERROR = 'ERROR',
  /** Represents the state of sending a message */
  SENDING = 'SENDING',
  /** Represents the state that the message was just sent */
  SENT = 'SENT',
}

export enum SupplyReservationsInteractionMessageMode {
  INCOMING = 'INCOMING',
  OUTGOING = 'OUTGOING',
}

export interface SupplyReservationsInteractionMessagesClientData {
  /** Timezone provided from the user */
  timeZone: Scalars['String'];
}

export enum SupplyReservationsInteractionMessagesDetailsLinkType {
  CHARGEBACKS = 'CHARGEBACKS',
  SEE_DAMAGE_REPORT = 'SEE_DAMAGE_REPORT',
  VIEW_CSA_CLAIM = 'VIEW_CSA_CLAIM',
}

export enum SupplyReservationsInteractionMessagesDialogFooterActionType {
  PRIMARY = 'PRIMARY',
  TERTIARY = 'TERTIARY',
}

export enum SupplyReservationsInteractionMessagesReplyAttachmentsLayout {
  GRID = 'GRID',
  LIST = 'LIST',
}

/** UUID of the attachment which we want to add (do we need to send everything back to the service or is UUID enough?) */
export interface SupplyReservationsInteractionTemplateAttachmentInput {
  uuid?: InputMaybe<Scalars['String']>;
}

/** Same as the equivalent `type` */
export interface SupplyReservationsInteractionTemplateEntryInput {
  attachments?: InputMaybe<Array<SupplyReservationsInteractionTemplateAttachmentInput>>;
  body?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  propertyIds?: InputMaybe<Array<Scalars['String']>>;
  schedule?: InputMaybe<SupplierMessageTemplateScheduleInput>;
  type?: InputMaybe<InteractionTemplateType>;
}

export enum SupplyReservationsInteractionTemplateSubmitStatus {
  FAILED = 'FAILED',
  SUCCESSFUL = 'SUCCESSFUL',
}

export enum SupplyReservationsInteractionViewType {
  CAROUSEL_VIEW = 'CAROUSEL_VIEW',
  LIST_VIEW = 'LIST_VIEW',
}

export interface SupplyReservationsInteractionsClientDataInput {
  /** Timezone provided from the user */
  timezone: Scalars['String'];
}

export interface SupplyReservationsInteractionsClientInput {
  /** Timezone provided from the user */
  timezone: Scalars['String'];
}

export interface SupplyReservationsInteractionsFilterInput {
  endDate?: InputMaybe<Scalars['String']>;
  /**
   * List of selected filters
   * Should be the value of "options.name"
   * Examples:
   *     "message.unread"
   *     "guest.requests.inquiry"
   */
  filters?: InputMaybe<Array<Scalars['String']>>;
  /** Dates used to filter by stay date */
  startDate?: InputMaybe<Scalars['String']>;
}

export interface SupplyReservationsInteractionsPageInput {
  /** Optional, defaults to 1 if not provided */
  pageNumber?: InputMaybe<Scalars['Int']>;
  /** Optional, defaults to 10 if not provided */
  pageSize?: InputMaybe<Scalars['Int']>;
}

export enum SupplyReservationsInteractionsSort {
  CHECKIN_DATE_ASC = 'CHECKIN_DATE_ASC',
  CHECKIN_DATE_DESC = 'CHECKIN_DATE_DESC',
  GUEST_ASC = 'GUEST_ASC',
  GUEST_DESC = 'GUEST_DESC',
  RECEIVED_ON_ASC = 'RECEIVED_ON_ASC',
  RECEIVED_ON_DESC = 'RECEIVED_ON_DESC',
}

export enum SupplyReservationsPayment {
  OFFLINE = 'OFFLINE',
  ONLINE = 'ONLINE',
}

export enum SupplyReservationsPaymentDetailsExpandoPositioning {
  LEADING = 'LEADING',
  TRAILING = 'TRAILING',
}

export enum SupplyReservationsPaymentDisplayToolbarIcon {
  BACK = 'BACK',
  CLOSE = 'CLOSE',
}

export enum SupplyReservationsRenderHint {
  /** Used for dropdown or bottom drawer/sheets */
  COLLAPSED = 'COLLAPSED',
  /** Used to display options as a list of buttons/links */
  LIST = 'LIST',
}

export enum SupplyReservationsStayDetailsMessageTimerType {
  COUNT_DOWN = 'COUNT_DOWN',
  COUNT_UP = 'COUNT_UP',
}

export enum SupplyReservationsTimerBadgeType {
  COUNT_DOWN = 'COUNT_DOWN',
  COUNT_UP = 'COUNT_UP',
}

export enum SupplyReservationsToolbarElevation {
  DEFAULT = 'DEFAULT',
  FLOATING = 'FLOATING',
}

export enum SupplyReservationsToolbarNavigationType {
  BACK = 'BACK',
  CLOSE = 'CLOSE',
}

export enum SupplyReviewsActionId {
  REVIEWS_DOWNLOAD_SHEET = 'REVIEWS_DOWNLOAD_SHEET',
  REVIEWS_FILTERS_SHEET = 'REVIEWS_FILTERS_SHEET',
  REVIEWS_RATING_GUEST_SHEET = 'REVIEWS_RATING_GUEST_SHEET',
  REVIEWS_REQUEST_REVIEW_SHEET = 'REVIEWS_REQUEST_REVIEW_SHEET',
  REVIEWS_RESPOND_SHEET = 'REVIEWS_RESPOND_SHEET',
  REVIEWS_SHARE_SHEET = 'REVIEWS_SHARE_SHEET',
}

export interface SupplyReviewsFeedbackInput {
  emails: Scalars['String'];
  message?: InputMaybe<Scalars['String']>;
}

export interface SupplyReviewsGuestRatingInput {
  cleanliness?: InputMaybe<Scalars['String']>;
  communication?: InputMaybe<Scalars['String']>;
  houseRules?: InputMaybe<Scalars['String']>;
  overallExperience: Scalars['String'];
  rentAgain?: InputMaybe<Scalars['Boolean']>;
}

export enum SupplyReviewsResponseStatus {
  FAIL = 'FAIL',
  SUCCESS = 'SUCCESS',
}

export interface SupplyRoomTypeMappingActionContext {
  /**
   * Each mapping is a String with the following information
   * - EG room type ID
   * - Competitor room Type ID
   * - Competitor name, eg. Booking or Agoda etc.
   * - Competitor property ID
   */
  mappings: Array<Scalars['String']>;
}

export enum SupplyRoomTypeMappingCompetitorPropertyInputType {
  PropertyID = 'PropertyID',
  PropertyURL = 'PropertyURL',
}

export interface SupplyRoomTypeMappingPropertyInput {
  id: Scalars['String'];
  inputType?: InputMaybe<SupplyRoomTypeMappingCompetitorPropertyInputType>;
  name: Scalars['String'];
  url?: InputMaybe<Scalars['String']>;
}

export interface SupplyRoomTypeMappingPropertyValidationInput {
  action: SupplyRoomTypeMappingUserAction;
  associatedId?: InputMaybe<Scalars['String']>;
  competitorProperty: SupplyRoomTypeMappingPropertyInput;
}

export enum SupplyRoomTypeMappingSpacingSize {
  SPACING__0X__HALF = 'SPACING__0X__HALF',
  SPACING__1X = 'SPACING__1X',
  SPACING__2X = 'SPACING__2X',
  SPACING__3X = 'SPACING__3X',
  SPACING__4X = 'SPACING__4X',
  SPACING__5X = 'SPACING__5X',
  SPACING__6X = 'SPACING__6X',
  SPACING__8X = 'SPACING__8X',
}

export enum SupplyRoomTypeMappingUserAction {
  CONFIRM = 'CONFIRM',
  REJECT = 'REJECT',
}

/** View option to set the starting view and view type */
export interface SupplyRoomTypeMappingViewOption {
  competitorName?: InputMaybe<Scalars['String']>;
  startingFrom?: InputMaybe<SupplyRoomTypeMappingViewPhase>;
  type?: InputMaybe<SupplyRoomTypeMappingViewType>;
}

export enum SupplyRoomTypeMappingViewPhase {
  VIEW_PROPERTY_MAPPING = 'VIEW_PROPERTY_MAPPING',
  VIEW_PROPERTY_MAPPING_INPUT = 'VIEW_PROPERTY_MAPPING_INPUT',
  VIEW_ROOM_TYPE_MAPPING = 'VIEW_ROOM_TYPE_MAPPING',
}

export enum SupplyRoomTypeMappingViewType {
  DIALOG = 'DIALOG',
}

export enum SupplyScoreBenefitsLadderSpacingSize {
  SPACING__0X__HALF = 'SPACING__0X__HALF',
  SPACING__1X = 'SPACING__1X',
  SPACING__2X = 'SPACING__2X',
  SPACING__3X = 'SPACING__3X',
  SPACING__4X = 'SPACING__4X',
  SPACING__5X = 'SPACING__5X',
  SPACING__6X = 'SPACING__6X',
  SPACING__8X = 'SPACING__8X',
}

export enum SupplyScoreFactorBmlAuditItemObervationType {
  AVAILABILITY = 'AVAILABILITY',
  PROMOTIONS = 'PROMOTIONS',
  PROPERTY = 'PROPERTY',
  RATE = 'RATE',
  ROOMTYPERATEPLANS = 'ROOMTYPERATEPLANS',
}

export enum SupplyScoreFactorNotificationType {
  DOING_GREAT = 'DOING_GREAT',
  NEEDS_ATTENTION = 'NEEDS_ATTENTION',
  NEXT_BEST_FACTOR = 'NEXT_BEST_FACTOR',
}

/** Description of a SupplyScoreMessaging's card */
export enum SupplyScoreMessagingTheme {
  INFO = 'INFO',
  MESSAGE = 'MESSAGE',
  WARNING = 'WARNING',
}

export interface SupplyTaxesAmountInput {
  age: Scalars['Int'];
  amount: Scalars['Float'];
}

export interface SupplyTaxesInput {
  taxesAmount?: InputMaybe<SupplyTaxesAmountInput>;
  taxesPercent?: InputMaybe<SupplyTaxesPercentInput>;
  type: SupplyTaxesType;
}

export interface SupplyTaxesPercentInput {
  percent: Scalars['Float'];
}

export enum SupplyTaxesType {
  AMOUNT = 'AMOUNT',
  NOT_INCLUDED = 'NOT_INCLUDED',
  PERCENT = 'PERCENT',
}

export interface SupplyUserProfileBasicInfoUpdateRequest {
  name?: InputMaybe<SupplyUserProfileNameInput>;
}

export interface SupplyUserProfileContactUpdateRequest {
  phoneNumber?: InputMaybe<SupplyUserProfilePhoneNumberInput>;
}

export interface SupplyUserProfileNameInput {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
}

export interface SupplyUserProfilePhoneNumberInput {
  countryCode: Scalars['String'];
  phoneNumber: Scalars['String'];
  regionCode?: InputMaybe<Scalars['String']>;
}

export interface SupplyVideosExperienceContext {
  view: Scalars['String'];
}

/** Represents the type of banner */
export enum SurfaceBannerType {
  APP_DOWNLOAD = 'APP_DOWNLOAD',
  TRAVEL_ADVISORY = 'TRAVEL_ADVISORY',
}

/** Type of suspension operation to perform */
export enum SuspensionOperationType {
  CREATE = 'CREATE',
  REMOVE = 'REMOVE',
  UPDATE = 'UPDATE',
}

/** Represents the selection status of a tab */
export enum TabStatus {
  /** Represents the status of not being selected */
  NOT_SELECTED = 'NOT_SELECTED',
  /** Represents the status of being selected */
  SELECTED = 'SELECTED',
}

export enum TabType {
  EQUAL_WIDTH = 'EQUAL_WIDTH',
  NATURAL = 'NATURAL',
}

export enum TableInput {
  AD = 'AD',
  AD_GROUP = 'AD_GROUP',
  CAMPAIGN = 'CAMPAIGN',
}

/** Targeting Inputs */
export interface TargetingInput {
  /** Targeting criteria */
  targetingCriteria?: InputMaybe<Scalars['String']>;
  /** Targeting id */
  targetingId?: InputMaybe<Scalars['UUID']>;
  /** Targeting operator */
  targetingOperator?: InputMaybe<Scalars['String']>;
  /** Targeting value */
  targetingValue: Scalars['String'];
}

export enum TargetingType {
  BOOKING_PATH = 'BOOKING_PATH',
  CHECK_IN_DAY = 'CHECK_IN_DAY',
  CHECK_IN_WINDOW = 'CHECK_IN_WINDOW',
  DEVICES = 'DEVICES',
  LENGTH_OF_STAY = 'LENGTH_OF_STAY',
  LOCATIONS = 'LOCATIONS',
}

export interface TaxAndRegulatoryAttributeDataInput {
  expiresOn?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  type: Scalars['String'];
  value: Scalars['String'];
}

export interface TaxAndRegulatoryLocationInput {
  coordinates?: InputMaybe<CoordinatesInput>;
  egPlaceId?: InputMaybe<Scalars['String']>;
  egPropertyId?: InputMaybe<Scalars['String']>;
}

export interface TaxInfoInput {
  key: Scalars['String'];
  value: Scalars['String'];
}

export enum TaxProfileMode {
  CREATE = 'CREATE',
  EDIT = 'EDIT',
}

/** Selector style for payment methods. The 3 selector styles could be: dropdown, bigtile or radio */
export interface TemplateConfigInput {
  selectorStyle?: InputMaybe<Scalars['String']>;
}

export enum TextDenyReasonCompliance {
  COMPETITIVE_COMPARATIVE_FALSE_CLAIMS = 'COMPETITIVE_COMPARATIVE_FALSE_CLAIMS',
  EXPIRED_OFFER = 'EXPIRED_OFFER',
  ROOM_RATES_OFFERS_DISCOUNTS = 'ROOM_RATES_OFFERS_DISCOUNTS',
  TEST_AD_NOT_ALLOWED = 'TEST_AD_NOT_ALLOWED',
  UNKNOWN = 'UNKNOWN',
}

export enum TextDenyReasonGuidelines {
  CAPITALIZATION = 'CAPITALIZATION',
  EXCLAMATION_POINTS = 'EXCLAMATION_POINTS',
  PUNCTUATION_SYMBOLS_HASHTAGS = 'PUNCTUATION_SYMBOLS_HASHTAGS',
  SPACING = 'SPACING',
  UNKNOWN = 'UNKNOWN',
}

export enum TextDenyReasonLanguage {
  GRAMMAR = 'GRAMMAR',
  INCORRECT_LANGUAGE_OR_TRANSLATION = 'INCORRECT_LANGUAGE_OR_TRANSLATION',
  SPELLING = 'SPELLING',
  UNCLEAR_MEANING = 'UNCLEAR_MEANING',
  UNKNOWN = 'UNKNOWN',
}

/** The text direction of the locale e.g. ltr or rtl */
export enum TextDirection {
  LTR = 'LTR',
  RTL = 'RTL',
}

/** Used to highlight or convey information. For example, positive messaging like free cancellation may be green. */
export enum TextTheme {
  EMPHASIS = 'EMPHASIS',
  INVERSE = 'INVERSE',
  LOYALTY = 'LOYALTY',
  NEGATIVE = 'NEGATIVE',
  POSITIVE = 'POSITIVE',
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
}

/** Used to highlight or convey information. For example, Payable amount in the price summary module of the checkout page. */
export enum TextWeight {
  BOLD = 'BOLD',
  MEDIUM = 'MEDIUM',
  REGULAR = 'REGULAR',
}

export enum Theme {
  BRAND = 'BRAND',
  BRANDED_DEAL = 'BRANDED_DEAL',
  DEAL_ADD_ON = 'DEAL_ADD_ON',
  DEAL_BUNDLED = 'DEAL_BUNDLED',
  DEAL_GENERIC = 'DEAL_GENERIC',
  DEAL_MEMBER = 'DEAL_MEMBER',
  EMPHASIS = 'EMPHASIS',
  FAMILY_FRIENDLY = 'FAMILY_FRIENDLY',
  INFO = 'INFO',
  LINK = 'LINK',
  LOYALTY = 'LOYALTY',
  LOYALTY_EXTRA_HIGH_TIER = 'LOYALTY_EXTRA_HIGH_TIER',
  LOYALTY_GLOBAL_EXTRA_HIGH_TIER = 'LOYALTY_GLOBAL_EXTRA_HIGH_TIER',
  LOYALTY_GLOBAL_HIGH_TIER = 'LOYALTY_GLOBAL_HIGH_TIER',
  LOYALTY_GLOBAL_LOW_TIER = 'LOYALTY_GLOBAL_LOW_TIER',
  LOYALTY_GLOBAL_MIDDLE_TIER = 'LOYALTY_GLOBAL_MIDDLE_TIER',
  LOYALTY_HIGH_TIER = 'LOYALTY_HIGH_TIER',
  LOYALTY_LOW_TIER = 'LOYALTY_LOW_TIER',
  LOYALTY_MIDDLE_TIER = 'LOYALTY_MIDDLE_TIER',
  NOTIFICATION = 'NOTIFICATION',
  PROMOTED = 'PROMOTED',
  SAVED = 'SAVED',
  SPONSORED = 'SPONSORED',
  STANDARD = 'STANDARD',
  SUCCESS = 'SUCCESS',
  SUCCESS_MEDIUM = 'SUCCESS_MEDIUM',
  SUPPLIER_PROMO = 'SUPPLIER_PROMO',
  URGENT = 'URGENT',
  VIEWED = 'VIEWED',
  VIP = 'VIP',
  VIP_ACCESS = 'VIP_ACCESS',
}

export interface ThirdPartyCouponReferenceInput {
  code?: InputMaybe<Scalars['String']>;
  promotionId?: InputMaybe<Scalars['String']>;
  type: ThirdPartyCouponType;
}

export enum ThirdPartyCouponType {
  UNIQODO = 'UNIQODO',
}

export interface TileInputSectionInput {
  callToAction?: InputMaybe<Scalars['String']>;
  headline?: InputMaybe<Scalars['String']>;
  media?: InputMaybe<MediaUploadInput>;
}

/** Toast auto dismiss duration */
export enum ToastDismissDuration {
  INDEFINITE = 'INDEFINITE',
  LONG = 'LONG',
  SHORT = 'SHORT',
}

export enum ToolbarNavType {
  CLOSE = 'CLOSE',
  EXPAND_DOWN = 'EXPAND_DOWN',
  EXPAND_UP = 'EXPAND_UP',
}

export interface TopTaskAction {
  cardAction?: InputMaybe<CardActions>;
  taskId: Scalars['String'];
  taskType?: InputMaybe<Scalars['String']>;
  userCardAction?: InputMaybe<Scalars['String']>;
}

export interface TopTaskCardAction {
  cardAction: CardActions;
  taskId: Scalars['String'];
  taskType?: InputMaybe<Scalars['String']>;
  /** This field will be deprecated instead use taskType */
  topTaskType: TopTaskTypes;
}

export enum TopTaskTypes {
  ACCELERATOR_OPPORTUNITY = 'ACCELERATOR_OPPORTUNITY',
  ADD_AMENITIES = 'ADD_AMENITIES',
  ADD_CHECK_OUT_INSTRUCTIONS_VRBO = 'ADD_CHECK_OUT_INSTRUCTIONS_VRBO',
  ADD_MINIMUM_STAY = 'ADD_MINIMUM_STAY',
  ADD_PHOTOS = 'ADD_PHOTOS',
  ADD_SAFETY_DEVICES_AMENITIES = 'ADD_SAFETY_DEVICES_AMENITIES',
  ARRIVING = 'ARRIVING',
  AUTORATEMATCH_OPPORTUNITY = 'AUTORATEMATCH_OPPORTUNITY',
  BANK_DETAILS = 'BANK_DETAILS',
  BOOKING_REQUEST = 'BOOKING_REQUEST',
  BOOKING_SMS_OPT_IN = 'BOOKING_SMS_OPT_IN',
  CANCELLATION = 'CANCELLATION',
  CANCELLATION_REQUEST = 'CANCELLATION_REQUEST',
  CONFIRM_CONTACT = 'CONFIRM_CONTACT',
  CONFIRM_IDENTITY = 'CONFIRM_IDENTITY',
  CURRENT_STAY = 'CURRENT_STAY',
  DIRECT_DEBIT = 'DIRECT_DEBIT',
  EARLYBOOKING_OPPORTUNITY = 'EARLYBOOKING_OPPORTUNITY',
  INQUIRY = 'INQUIRY',
  LASTMINUTEBOOKING_OPPORTUNITY = 'LASTMINUTEBOOKING_OPPORTUNITY',
  LOWER_FEES = 'LOWER_FEES',
  MINIMUMINVENTORY_OPPORTUNITY = 'MINIMUMINVENTORY_OPPORTUNITY',
  MINIMUMNIGHTSTAY_OPPORTUNITY = 'MINIMUMNIGHTSTAY_OPPORTUNITY',
  MOBILEDRR_OPPORTUNITY = 'MOBILEDRR_OPPORTUNITY',
  OPPORTUNITY = 'OPPORTUNITY',
  RATE_TRAVELER = 'RATE_TRAVELER',
  REVIEW_OCCUPANCY = 'REVIEW_OCCUPANCY',
  TAX_FORM = 'TAX_FORM',
  TMODDRR_OPPORTUNITY = 'TMODDRR_OPPORTUNITY',
  UNKNOWN = 'UNKNOWN',
  UNKNOWN__ = 'UNKNOWN__',
  UPDATE_CALENDAR = 'UPDATE_CALENDAR',
  UPDATE_TAX_INFORMATION = 'UPDATE_TAX_INFORMATION',
  VRPAYMENTS_TIP = 'VRPAYMENTS_TIP',
}

/** Optional inputs for custom flex content */
export interface TravelContentAttributesInput {
  /** content Id */
  contentId: Scalars['String'];
  /** preview */
  preview: Scalars['Boolean'];
}

/** URI context to get flex content. */
export interface TravelContentUriContextInput {
  /** The attribute categorises groups of similar URIs */
  attributes: UriContextAttributesInput;
  /** Identifiers are the subcomponents that uniquely identify a URI */
  identifiers: UriContextIdentifiersInput;
}

export interface TravelGuidePageContextInput {
  pageType: PageType;
  placeId?: InputMaybe<Scalars['String']>;
}

export interface TravelMemberGroupInput {
  adults: Scalars['Int'];
  childrenAges?: InputMaybe<Array<Scalars['Int']>>;
}

/** Search criteria for different product line */
export interface TravelSearchCriteriaInput {
  /** Search Criteria for activities */
  activity?: InputMaybe<ActivitiySearchCriteriaInput>;
  /** Search Criteria for car */
  car?: InputMaybe<CarOfferCriteriaInput>;
  /** Search Criteria for cruise */
  cruise?: InputMaybe<CruiseSailingDetailsCriteriaInput>;
  /** Search Criteria for property */
  property?: InputMaybe<PropertySearchCriteriaInput>;
}

export enum TravelShopType {
  COLLECTIONS = 'COLLECTIONS',
  SHOPS = 'SHOPS',
}

export interface TravelStoreV1CarDetailsInput {
  cleaningSafetyInformation: Scalars['Boolean'];
  periodPricing: Scalars['Boolean'];
  showAds: Scalars['Boolean'];
}

export interface TravelStoreV1CarSearchInput {
  cleaningSafetyInformation: Scalars['Boolean'];
  defaultSortOption: Scalars['String'];
  filterOptions: Array<Scalars['String']>;
  messagingOptions: Array<Scalars['String']>;
  periodPricing: Scalars['Boolean'];
  showAds: Scalars['Boolean'];
  sortOptions: Array<Scalars['String']>;
}

/** Represents the traveler details */
export interface TravelerDetailsInput {
  age?: InputMaybe<Scalars['Int']>;
  type: TravelerDetailsType;
}

/** Possible traveler details types */
export enum TravelerDetailsType {
  ADULT = 'ADULT',
  CHILD = 'CHILD',
  INFANT_IN_LAP = 'INFANT_IN_LAP',
  INFANT_IN_SEAT = 'INFANT_IN_SEAT',
}

export interface TravelerMessage {
  /** Message text in traveller message */
  content: Scalars['String'];
  /** Timestamp of message sent, in ISO 8601 format eg 2023-10-05T14:48:00.000Z */
  insertedTime: Scalars['String'];
  /** Unique identifier for the traveler message */
  messageId: Scalars['String'];
}

/** Package traveler occupancy group */
export interface TravelerOccupancyGroupInput {
  travelers: Array<TravelerDetailsInput>;
}

export enum TravelerType {
  ADULTS_ONLY = 'ADULTS_ONLY',
  BUSINESS = 'BUSINESS',
  ECO_CERTIFIED = 'ECO_CERTIFIED',
  FAMILY = 'FAMILY',
  LGBT = 'LGBT',
  /** Deprecated: TnL 37054 - AFFINITY_FILTERS_APPLIED_ON_HSR */
  ROMANTIC = 'ROMANTIC',
}

/** Context needed to request sponsored content */
export interface TravellerAncillarySelectionInput {
  /** Represents the list of encoded AncillaryToken for each selection made */
  ancillaryTokens: Array<Scalars['String']>;
  /** Represents the traveler index for which the selection is applicable */
  travelerIndex: Scalars['Int'];
}

export enum TripAssistGoalType {
  BOOK = 'BOOK',
  PLAN = 'PLAN',
}

export enum TripCareButtonAction {
  BACK = 'BACK',
  CANCEL_POLICY = 'CANCEL_POLICY',
  DISMISS_POPUP = 'DISMISS_POPUP',
  POPUP = 'POPUP',
  RELOAD = 'RELOAD',
}

export enum TripCareButtonState {
  DISABLED = 'DISABLED',
  ENABLED = 'ENABLED',
}

export enum TripCareLayoutStyle {
  CARD_BORDER_TOP = 'CARD_BORDER_TOP',
}

export enum TripCareListType {
  BULLET = 'BULLET',
  NO_BULLET = 'NO_BULLET',
  NUMBERED = 'NUMBERED',
}

export enum TripCarePhraseStyle {
  BOLD = 'BOLD',
  HR_DIVIDER_BOTTOM = 'HR_DIVIDER_BOTTOM',
  HR_DIVIDER_TOP = 'HR_DIVIDER_TOP',
  SIZE_100 = 'SIZE_100',
  SIZE_200 = 'SIZE_200',
  SIZE_300 = 'SIZE_300',
  SIZE_400 = 'SIZE_400',
  SIZE_500 = 'SIZE_500',
  SIZE_600 = 'SIZE_600',
  SIZE_700 = 'SIZE_700',
  SIZE_800 = 'SIZE_800',
  SIZE_900 = 'SIZE_900',
  SMALL = 'SMALL',
  SPACING_FOUR = 'SPACING_FOUR',
  SPACING_HALF = 'SPACING_HALF',
  SPACING_ONE = 'SPACING_ONE',
  SPACING_SIX = 'SPACING_SIX',
  SPACING_THREE = 'SPACING_THREE',
  SPACING_TWO = 'SPACING_TWO',
  THEME_EMPHASIS = 'THEME_EMPHASIS',
  THEME_NEGATIVE = 'THEME_NEGATIVE',
  THEME_POSITIVE = 'THEME_POSITIVE',
  WEIGHT_BOLD = 'WEIGHT_BOLD',
  WEIGHT_MEDIUM = 'WEIGHT_MEDIUM',
  WEIGHT_REGULAR = 'WEIGHT_REGULAR',
}

export enum TripCarePhraseType {
  BUTTON = 'BUTTON',
  LINK = 'LINK',
  TEXT = 'TEXT',
}

/** Represents chat entry point request data */
export interface TripCollaborationChatEntryPointButtonRequestInput {
  /** Represents conversationType which will be used while fetching the conversations */
  conversationType: ConversationType;
  /** Represents tripId which will be used while fetching the conversations */
  tripId: Scalars['String'];
}

/** Represents chat entry point request data */
export interface TripCollaborationChatEntryPointRequestInput {
  /** Represents conversationType which will be used while fetching the conversations */
  conversationType: Scalars['String'];
  /** Represents tripId which will be used while fetching the conversations */
  tripId: Scalars['String'];
}

/** Represents chat header request data */
export interface TripCollaborationChatHeaderRequestInput {
  /** Represents tripId which will be used to fetch the trip details */
  tripId: Scalars['String'];
}

export enum TripCreationEntryPoint {
  HOTEL_SEARCH_RESULTS = 'HOTEL_SEARCH_RESULTS',
  TRIPS_LIST = 'TRIPS_LIST',
  TRIP_OVERVIEW = 'TRIP_OVERVIEW',
}

/** Metadata which can be provided when creating a new trip. */
export interface TripCreationMetadataInput {
  entryPoint?: InputMaybe<TripCreationEntryPoint>;
  itemId?: InputMaybe<Scalars['String']>;
  /** An input provided when creating a new trip as part of moving an item to a trip */
  moveItemInput?: InputMaybe<TripItemInput>;
  /** Trip planning inputs provided when creating a new trip as part of saving an item to a trip */
  saveItemInput?: InputMaybe<TripsPlanInput>;
}

export interface TripDetailsSupportRequestsInput {
  buttonStyle: EGDSButtonStyle;
  itineraryNumber: Scalars['String'];
  lineOfBusiness: Scalars['String'];
  orderLineId: Scalars['String'];
}

/** Input type containing trip item and view identifiers */
export interface TripDetailsUIInput {
  tripItemId: Scalars['String'];
  tripViewId?: InputMaybe<Scalars['String']>;
}

/** Input type containing trip item and view identifiers */
export interface TripDetailsUIItemInput {
  tripItemId: Scalars['String'];
  tripViewId: Scalars['String'];
}

/** Input to the tripsItemPricingAndRewards query. */
export interface TripDetailsUIItemPricingAndRewardsInput {
  tripsInput: TripDetailsUIInput;
}

export interface TripDetailsUILocationDetailsInput {
  tripItemId: Scalars['String'];
  tripViewId: Scalars['String'];
}

export interface TripDetailsUIPageHeaderInput {
  tripId: Scalars['String'];
  tripItemId: Scalars['String'];
}

/** Input type containing tripViewId and tripItemId for tripItem */
export interface TripDetailsUIPropertyGuideInput {
  tripsInput?: InputMaybe<TripDetailsUIItemInput>;
}

export interface TripDetailsUIRoomDetailsInput {
  tripItemId: Scalars['String'];
  tripViewId?: InputMaybe<Scalars['String']>;
}

/** Input type for sign in query */
export interface TripDetailsUISignInQueryInput {
  tripsInput: TripDetailsUIItemInput;
}

/** The TripEntity defines a list of supported items which can be can be saved to a trip. */
export enum TripEntity {
  ACTIVITY_PRODUCT = 'ACTIVITY_PRODUCT',
  CAR_PRODUCT = 'CAR_PRODUCT',
  FLIGHT_SEARCH = 'FLIGHT_SEARCH',
  LODGING_PRODUCT = 'LODGING_PRODUCT',
  PACKAGE_PRODUCT = 'PACKAGE_PRODUCT',
}

/** In order to pass any additional trip related info */
export interface TripInfoContextInput {
  /** booking item id */
  bookingItemId?: InputMaybe<Scalars['String']>;
  /** itinerary url link */
  itineraryLink?: InputMaybe<Scalars['String']>;
  /** booking info order line id */
  orderLineId?: InputMaybe<Scalars['String']>;
  /** booking info order number */
  orderNumber?: InputMaybe<Scalars['String']>;
  /** lodging property id */
  propertyId?: InputMaybe<Scalars['String']>;
  /** lodging property name */
  propertyName?: InputMaybe<Scalars['String']>;
  /** booking info trip end date */
  tripEndDate?: InputMaybe<Scalars['String']>;
  /** booking info trip start date */
  tripStartDate?: InputMaybe<Scalars['String']>;
}

export enum TripIntentPersonType {
  ADULT = 'ADULT',
  CHILD = 'CHILD',
}

/**
 * The `TripInviteInput` complex type contains a `inviteId` known by the Trip Domain.
 * The inviteId is invitation identifier to be opened from trips overview screen or redirected to by invite deep link.
 * The server will construct all the necessary information based on invite that has back reference to trip with all needed information to populate view
 * It also provides context to the Trip Overview view for functions such as back navigation.
 */
export interface TripInviteInput {
  inviteId: Scalars['String'];
}

/**
 * "The `TripItemInput` contains a tripViewId and tripItemId known by the Trip Domain, plus an optional filter known to the Trips Graph.
 * The set of supported filters is the same as defined in `TripsFilterInput` and provides context to the Trip Item Details view for functions such as back navigation.
 */
export interface TripItemInput {
  filter?: InputMaybe<Scalars['String']>;
  segments?: InputMaybe<Array<Scalars['String']>>;
  tripEntity?: InputMaybe<TripEntity>;
  tripItemId: Scalars['String'];
  tripViewId: Scalars['String'];
  viewType?: InputMaybe<Scalars['String']>;
}

/** Input type for the Trips Items to compare */
export interface TripItemsToCompareInput {
  tripId: Scalars['String'];
  tripItemIds?: InputMaybe<Array<Scalars['String']>>;
}

/**
 * The `TripOverviewInput` complex type contains a `tripViewId` known by the Trip Domain and an optional `filter` known by the Trips Graph Service.
 * The tripViewId identifier is opaque to the client, it may be an EG Trip Identifier or an identifier used for Trip Sharing.
 * The server will determine how much of the trip and which actions to return based on the sharing rules associated with the TripViewId.
 * The set of supported filters is the same as defined in `TripsFilterInput` and provides context to the Trip Overview view for functions such as back navigation.
 */
export interface TripOverviewInput {
  filter?: InputMaybe<Scalars['String']>;
  inviteId?: InputMaybe<Scalars['String']>;
  segments?: InputMaybe<Array<Scalars['String']>>;
  tripViewId: Scalars['String'];
}

export enum TripScheduleChangeStatus {
  FLIGHT_SCHEDULE_CHANGE = 'FLIGHT_SCHEDULE_CHANGE',
  NO_CHANGE = 'NO_CHANGE',
}

export enum TripScreen {
  TRIP_ITEM_DETAILS = 'TRIP_ITEM_DETAILS',
  TRIP_OVERVIEW = 'TRIP_OVERVIEW',
}

export enum TripStage {
  MID_TRAVEL = 'MID_TRAVEL',
  POST_TRAVEL = 'POST_TRAVEL',
  PRE_TRAVEL = 'PRE_TRAVEL',
}

export enum TripType {
  ONE_WAY = 'ONE_WAY',
  ROUND_TRIP = 'ROUND_TRIP',
  UNKNOWN = 'UNKNOWN',
}

export interface TripViewIdInput {
  id: Scalars['String'];
  type: TripViewIdType;
}

export enum TripViewIdType {
  TRIP_ITEM_ID = 'TRIP_ITEM_ID',
  TRIP_VIEW_ID = 'TRIP_VIEW_ID',
}

/** Represents different avatar sizes. */
export enum TripsAvatarSize {
  EXTRA_LARGE = 'EXTRA_LARGE',
  LARGE = 'LARGE',
  MEDIUM = 'MEDIUM',
  SMALL = 'SMALL',
}

/** Supported Trips badge themes */
export enum TripsBadgeTheme {
  LOYALTY_HIGH_TIER = 'LOYALTY_HIGH_TIER',
  LOYALTY_LOW_TIER = 'LOYALTY_LOW_TIER',
  LOYALTY_MIDDLE_TIER = 'LOYALTY_MIDDLE_TIER',
  SAVED = 'SAVED',
  STATUS_NEGATIVE = 'STATUS_NEGATIVE',
  STATUS_POSITIVE = 'STATUS_POSITIVE',
  UTILITY_STANDARD = 'UTILITY_STANDARD',
  VIP = 'VIP',
}

export enum TripsBookingInfoType {
  CONFIRMATION_NUMBER = 'CONFIRMATION_NUMBER',
  ITINERARY_NUMBER = 'ITINERARY_NUMBER',
  RESERVATION_ID = 'RESERVATION_ID',
}

export enum TripsButtonWidth {
  MATCH_PARENT_CONTAINER = 'MATCH_PARENT_CONTAINER',
  WRAP_CONTENT = 'WRAP_CONTENT',
}

export enum TripsCalendarSelectionType {
  SINGLE = 'SINGLE',
  START_AND_END = 'START_AND_END',
  START_AND_END_WITH_SAME_DATE = 'START_AND_END_WITH_SAME_DATE',
}

/** Contains attributes for trip cancellation */
export interface TripsCancellationAttributesInput {
  orderLineNumbers?: InputMaybe<Array<Scalars['String']>>;
  orderNumber?: InputMaybe<Scalars['String']>;
  /** Formatted string. This is optional attribute. In case of partial refund, we are passing this value to the backend. */
  penaltyAmount?: InputMaybe<Scalars['String']>;
  /** Formatted string. This is optional attribute for displayed refund amount to user. If this value set then compare between displayed amount and actual amount from backend. */
  refundAmount?: InputMaybe<Scalars['String']>;
  /** Formatted string. This is optional attribute for displayed cash refund amount to user, we are passing this value to the backend. */
  refundInCash?: InputMaybe<Scalars['String']>;
  /** Formatted string. This is optional attribute for displayed points refund amount to user, we are passing this value to the backend. */
  refundInPoints?: InputMaybe<Scalars['String']>;
}

export enum TripsCancellationType {
  ACTIVITY = 'ACTIVITY',
  CAR = 'CAR',
  CRUISE = 'CRUISE',
  HOTEL = 'HOTEL',
  INSURANCE = 'INSURANCE',
}

/** Represents a TripsCard's selection/active state */
export enum TripsCardState {
  SELECTED = 'SELECTED',
  UNSELECTED = 'UNSELECTED',
}

/** Type of the drawer/sheet we want the client to render. CENTER is for desktop where we want to show the drawer as a center sheet/dialogBOTTOM is for app and mweb where the drawer comes from the bottom of the screenSIDE is for desktop where the sheet comes from the right of the screen. eg. plan, moveFULL is equivalent to sidesheet on mweb where the sheet will cover the whole page */
export enum TripsComposableDrawerType {
  BOTTOM = 'BOTTOM',
  CENTER = 'CENTER',
  FULL = 'FULL',
  SIDE = 'SIDE',
}

/** Display theme for trips content */
export enum TripsContentTheme {
  /** The Unordered List should be displayed with bullets */
  BULLETS = 'BULLETS',
  /** The Unordered List should be displayed with no bullets */
  NO_BULLETS = 'NO_BULLETS',
  /** The ordered list should always be displayed with numbers */
  ORDERED = 'ORDERED',
  /** Paragraph type list */
  PARAGRAPH = 'PARAGRAPH',
}

export enum TripsContentType {
  PDF = 'PDF',
}

export enum TripsContentUnorderedListTheme {
  /** The Unordered List should be displayed with bullets */
  BULLETS = 'BULLETS',
  /** The Unordered List should be displayed with no bullets */
  NO_BULLETS = 'NO_BULLETS',
}

export enum TripsCustomerNotificationTripScheduleChangeStatus {
  FLIGHT_SCHEDULE_CHANGE = 'FLIGHT_SCHEDULE_CHANGE',
  NO_CHANGE = 'NO_CHANGE',
}

/** Represents Trip data */
export interface TripsDataInput {
  /** Trips data for flight Product */
  flightProduct?: InputMaybe<FlightProductInput>;
}

/** Represents layout of buttons on a modal dialog */
export enum TripsDialogButtonLayout {
  /** Dialog with horizontally stacked buttons */
  INLINE = 'INLINE',
  /** Dialog with vertically stacked buttons */
  STACKED = 'STACKED',
}

export enum TripsDisplayMode {
  DEFAULT = 'DEFAULT',
  MODAL = 'MODAL',
  NEW_TAB = 'NEW_TAB',
}

/** Controls the width of the divider */
export enum TripsDivider {
  NARROW = 'NARROW',
  WIDE = 'WIDE',
}

/**
 * The `TripsFilterInput` contains a filter identifier.
 * The set of supported filter identifiers is defined by the Trips Graph Service and may represent a simple filter like Upcoming or Past or an arbitrarily complex filter defined by an ML algorithm.
 * See the Trips Graph team for a list of reserved values.
 */
export interface TripsFilterInput {
  filter: Scalars['String'];
}

export enum TripsFindItineraryNumberView {
  FIND_ITINERARY_OTHER_EMAIL = 'FIND_ITINERARY_OTHER_EMAIL',
  FIND_ITINERARY_USER_EMAIL = 'FIND_ITINERARY_USER_EMAIL',
  RESULT = 'RESULT',
}

/** This enum is to indicate what type of image is being placed into TripsFittedImageCard. UitkLayoutGrid would apply onto BARCODE */
export enum TripsFittedImageType {
  BARCODE = 'BARCODE',
  E_FRANKING_STAMP = 'E_FRANKING_STAMP',
  QR_CODE = 'QR_CODE',
}

/** This enum is to indicate whether the form container should have padding or it should fit right inside the parent component */
export enum TripsFormContainerTheme {
  MATCH_PARENT = 'MATCH_PARENT',
  WRAP_CONTENT = 'WRAP_CONTENT',
}

export enum TripsFormType {
  CREATE_NEW_TRIP_FROM_ITEM = 'CREATE_NEW_TRIP_FROM_ITEM',
  FIND_ITINERARY_NUMBER = 'FIND_ITINERARY_NUMBER',
  INVITE = 'INVITE',
  SAVE_NEW_TRIP = 'SAVE_NEW_TRIP',
  SEARCH_BOOKING = 'SEARCH_BOOKING',
  SEND_ITINERARY_EMAIL = 'SEND_ITINERARY_EMAIL',
  UPDATE_TRIP = 'UPDATE_TRIP',
}

/** Enum to represent the number of lines that the text field supports. Defaulted to one line (single) if no changes are made. */
export enum TripsInputType {
  MULTIPLE = 'MULTIPLE',
  SINGLE = 'SINGLE',
}

export interface TripsItemsGroupFilterInput {
  type: Scalars['String'];
  value: Scalars['String'];
}

/** Contains filters and sort fields to control how the items appear in groups. */
export interface TripsItemsGroupInput {
  filters: Array<TripsItemsGroupFilterInput>;
  sort?: InputMaybe<Scalars['String']>;
}

export enum TripsLinkTarget {
  EXTERNAL = 'EXTERNAL',
  INTERNAL = 'INTERNAL',
}

/** Criteria for typeahead search of locations in the Trips API. */
export interface TripsLocationTypeaheadCriteriaInput {
  searchTerm: Scalars['String'];
}

/** The type of map marker */
export enum TripsMarkerType {
  ActivityEventMarker = 'ActivityEventMarker',
  ActivityGuestPickupMarker = 'ActivityGuestPickupMarker',
  ActivityLocationMarker = 'ActivityLocationMarker',
  ActivityRedemptionMarker = 'ActivityRedemptionMarker',
  AirportMarker = 'AirportMarker',
  CarMarker = 'CarMarker',
  CruiseMarker = 'CruiseMarker',
  HotelMarker = 'HotelMarker',
  PlaceMarker = 'PlaceMarker',
}

export interface TripsNotAuthorizedInput {
  filter?: InputMaybe<Scalars['String']>;
  inviteId?: InputMaybe<Scalars['String']>;
  requestToJoinId?: InputMaybe<Scalars['String']>;
  screen?: InputMaybe<TripsScreen>;
  tripItemId?: InputMaybe<Scalars['String']>;
  tripViewId?: InputMaybe<Scalars['String']>;
}

/** Input to the trips.plan query. */
export interface TripsPlanInput {
  /** Additional LOB-agnostic optional attributes of the item being saved */
  additionalAttributes?: InputMaybe<Array<GraphQLPairInput>>;
  /** Provides LOB specific search context */
  attributes?: InputMaybe<TripsSaveItemAttributesInput>;
  /** The id of the item being saved, e.g property id */
  itemId: Scalars['String'];
  /** Provides an entrypoint location from which an item can be saved to a trip */
  pageLocation?: InputMaybe<PageLocation>;
  /** Composes PropertySearch and FlightSearch inputs */
  productSearchCriteria?: InputMaybe<TripsProductSearchCriteriaInput>;
  source?: InputMaybe<TripsPlanSourceType>;
  /** Attributes needed to create or update trip items subscription data */
  subscriptionAttributes?: InputMaybe<TripsSubscriptionAttributesInput>;
  /** A handle to one of the domain tripItems that stores the item identified by the domain */
  tripItem?: InputMaybe<TripItemInput>;
}

/** The `TripsPlanSourceType` defines a list of supported pages or views from which an item can be saved to a trip. */
export enum TripsPlanSourceType {
  ACTIVITY_DETAILS = 'ACTIVITY_DETAILS',
  ACTIVITY_SEARCH = 'ACTIVITY_SEARCH',
  CAR_INFOSITE = 'CAR_INFOSITE',
  CAR_INFOSITE_V2 = 'CAR_INFOSITE_V2',
  CAR_SEARCH = 'CAR_SEARCH',
  CAR_SEARCH_V2 = 'CAR_SEARCH_V2',
  /** @deprecated Use LOGING_SEARCH instead */
  HOTEL_SEARCH = 'HOTEL_SEARCH',
  LODGING_DETAILS = 'LODGING_DETAILS',
  LODGING_SEARCH = 'LODGING_SEARCH',
  PACKAGE_DETAILS = 'PACKAGE_DETAILS',
  TRIP_OVERVIEW = 'TRIP_OVERVIEW',
}

/** Input to the trips.screenshot query. */
export interface TripsProductSearchCriteriaInput {
  flightSearchCriteria?: InputMaybe<FlightSearchCriteriaInput>;
  propertySearchCriteria?: InputMaybe<PropertySearchCriteriaInput>;
  tripsFlightSearchCriteria?: InputMaybe<TripsSaveFlightSearchCriteriaInput>;
}

export enum TripsResponseStatus {
  FAIL = 'FAIL',
  SUCCESS = 'SUCCESS',
}

/** Save activity input details */
export interface TripsSaveActivityAttributesInput {
  /** Date range representing activity search, if absent the default [today, today+14d] is used */
  dateRange?: InputMaybe<DateRangeInput>;
  /** The Gaia region ID of the search */
  regionId?: InputMaybe<Scalars['String']>;
}

/** Save car input details */
export interface TripsSaveCarOfferAttributesInput {
  /** ACRISS Category code: denotes the vehicle category – based on size, cost, power and luxury factor */
  categoryCode: Scalars['String'];
  /** ACRISS Fuel/AC code: defines the fuel type (petrol / diesel / hybrid/ electric…) and whether air conditioned or not */
  fuelAcCode: Scalars['String'];
  /** EGTP Platform Offer token value for the car offer */
  offerToken: Scalars['String'];
  /** Provides search criteria for the car */
  searchCriteria: PrimaryCarCriteriaInput;
  /** ACRISS Transmission/Drive code: defines the transmission and drive – automatic / manual & 2WD / 4WD / AWD */
  transmissionDriveCode: Scalars['String'];
  /** ACRISS Type code: defines the vehicle type – chassis type (van, SUV, wagon, convertible….) */
  typeCode: Scalars['String'];
  /** The vendor code for the car. Ex: ET */
  vendorCode: Scalars['String'];
}

/** Input type representing primary and filters flight search criteria */
export interface TripsSaveFlightSearchCriteriaInput {
  flightSearchFilters: Array<FlightsSearchFilterValuesInput>;
  primary: PrimaryFlightCriteriaInput;
}

/** Type grouping all the optional additional information that's required when saving an item. */
export interface TripsSaveItemAttributesInput {
  /** Activity input details */
  activityAttributes?: InputMaybe<TripsSaveActivityAttributesInput>;
  /** Car input details */
  carAttributes?: InputMaybe<TripsSaveCarOfferAttributesInput>;
  /** Flight input details */
  flightAttributes?: InputMaybe<FlightSearchCriteriaInput>;
  /** Package input details */
  packageAttributes?: InputMaybe<TripsSavePackageAttributesInput>;
  /** Stay input details */
  stayAttributes?: InputMaybe<TripsSaveStayAttributesInput>;
}

export interface TripsSaveItemInput {
  additionalAttributes?: InputMaybe<Array<GraphQLPairInput>>;
  anchorPrice?: InputMaybe<Scalars['String']>;
  productSearchCriteria: TripsProductSearchCriteriaInput;
}

export enum TripsSaveItemVariant {
  CONTROL = 'CONTROL',
  VARIANT_B = 'VARIANT_B',
  VARIANT_C = 'VARIANT_C',
}

/** Save package input details */
export interface TripsSavePackageAttributesInput {
  /** It contains the encoded values for product natural keys including: Hotel/Flight/GT/LX */
  packageOfferId?: InputMaybe<Scalars['String']>;
  /** It contains the complete encoded session with product natural keys, if packageOfferId is null */
  sessionId: Scalars['String'];
}

/** Save stay input details */
export interface TripsSaveStayAttributesInput {
  /** The check-in date for the property */
  checkInDate?: InputMaybe<DateInput>;
  /** The check-out date for the property */
  checkoutDate?: InputMaybe<DateInput>;
  /** The Gaia region ID of the search */
  regionId?: InputMaybe<Scalars['String']>;
  /** Provides Stay traveler information */
  roomConfiguration?: InputMaybe<Array<PropertyRoomInput>>;
}

/** Stay input details */
export interface TripsSaveStayInput {
  checkInDate?: InputMaybe<DateTimeInput>;
  checkoutDate?: InputMaybe<DateTimeInput>;
  propertyId: Scalars['String'];
  regionId?: InputMaybe<Scalars['String']>;
  roomConfiguration?: InputMaybe<Array<TripsStayRoomTravelerInfoInput>>;
  sourceType?: InputMaybe<TripsPlanSourceType>;
}

export enum TripsScreen {
  INVITE_LANDING_PAGE = 'INVITE_LANDING_PAGE',
  PUBLIC_TRIP_BOARD = 'PUBLIC_TRIP_BOARD',
  TRIP_ASSIST = 'TRIP_ASSIST',
  TRIP_BOOKED_LIST = 'TRIP_BOOKED_LIST',
  TRIP_CANCELLED_LIST = 'TRIP_CANCELLED_LIST',
  TRIP_DETAIL = 'TRIP_DETAIL',
  TRIP_ITEM_DETAILS = 'TRIP_ITEM_DETAILS',
  TRIP_ITEM_ITINERARY = 'TRIP_ITEM_ITINERARY',
  TRIP_ITEM_MANAGE_BOOKING = 'TRIP_ITEM_MANAGE_BOOKING',
  TRIP_ITEM_PRICING_REWARDS = 'TRIP_ITEM_PRICING_REWARDS',
  TRIP_ITEM_RECEIPT = 'TRIP_ITEM_RECEIPT',
  TRIP_LIST = 'TRIP_LIST',
  TRIP_MANAGE_GUESTS = 'TRIP_MANAGE_GUESTS',
  TRIP_OVERVIEW = 'TRIP_OVERVIEW',
  TRIP_OVERVIEW_ITINERARY = 'TRIP_OVERVIEW_ITINERARY',
  TRIP_PAST_LIST = 'TRIP_PAST_LIST',
  TRIP_RIDE_SHARE = 'TRIP_RIDE_SHARE',
  TRIP_SAVED_LIST = 'TRIP_SAVED_LIST',
}

/** Input to the trips.screenshot query. */
export interface TripsScreenshotInput {
  /** The id of the item being saved, e.g property id */
  itemId: Scalars['String'];
  /** Provides an entrypoint location from which an item can be saved to a trip */
  pageLocation?: InputMaybe<PageLocation>;
  /** Provides LOB specific search context */
  saveItemAttributes: TripsSaveItemAttributesInput;
}

export enum TripsSearchBookingView {
  SEARCH_BY_ITINERARY_NUMBER = 'SEARCH_BY_ITINERARY_NUMBER',
  SEARCH_BY_ITINERARY_NUMBER_AND_EMAIL = 'SEARCH_BY_ITINERARY_NUMBER_AND_EMAIL',
  SEARCH_RESULT = 'SEARCH_RESULT',
}

/** This enum represents the different fields that a TripsSignalPair relates to. */
export enum TripsSignalPairKey {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
  STATUS = 'STATUS',
}

/** This enum represents the different category types of signals registered within the platform. */
export enum TripsSignalType {
  REMOVE = 'REMOVE',
  UPDATE = 'UPDATE',
}

/** Stay room traveler information */
export interface TripsStayRoomTravelerInfoInput {
  childrenAges: Array<Scalars['Int']>;
  numberOfAdults: Scalars['Int'];
  pets: Scalars['Boolean'];
}

/** Attributes needed to create or update trip items subscription data */
export interface TripsSubscriptionAttributesInput {
  anchorPrice?: InputMaybe<Scalars['String']>;
  subscriptionInputs?: InputMaybe<Array<GraphQLPairInput>>;
}

export enum TripsTimelineStates {
  CURRENT = 'CURRENT',
  FUTURE = 'FUTURE',
  PAST = 'PAST',
}

/** Represents a toggle's state. */
export enum TripsToggleStatus {
  DISABLED = 'DISABLED',
  ENABLED = 'ENABLED',
}

export enum TripsUIAttachQualificationType {
  CARMIP = 'CARMIP',
  HOTMIP = 'HOTMIP',
}

/** Input to be used for fetching based on variant type of savings */
export enum TripsUIAttachSavingsVariant {
  BANNER = 'BANNER',
  SHEET = 'SHEET',
}

export enum TripsUICardBackgroundTheme {
  GLOBAL_LOYALTY_EXTRA_HIGH = 'GLOBAL_LOYALTY_EXTRA_HIGH',
  GLOBAL_LOYALTY_HIGH = 'GLOBAL_LOYALTY_HIGH',
  GLOBAL_LOYALTY_LOW = 'GLOBAL_LOYALTY_LOW',
  GLOBAL_LOYALTY_MID = 'GLOBAL_LOYALTY_MID',
  HIGHLIGHT = 'HIGHLIGHT',
  NONE = 'NONE',
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
  STANDARD = 'STANDARD',
}

export enum TripsUICardBorder {
  SELECTED = 'SELECTED',
  SOLID = 'SOLID',
}

export enum TripsUICustomerNotificationTripScheduleChangeStatus {
  FLIGHT_SCHEDULE_CHANGE = 'FLIGHT_SCHEDULE_CHANGE',
  NO_CHANGE = 'NO_CHANGE',
}

/** Alignment for the buttons in a dialog's footer */
export enum TripsUIDialogFooterButtonLayout {
  INLINE = 'INLINE',
  STACKED = 'STACKED',
}

export enum TripsUIFullScreenMapViewState {
  COLLAPSED = 'COLLAPSED',
  EXPANDED = 'EXPANDED',
}

export enum TripsUIImageFit {
  CONTAIN = 'CONTAIN',
  COVER = 'COVER',
}

export enum TripsUIImageGalleryLayout {
  GRID = 'GRID',
  LIST = 'LIST',
}

export enum TripsUIItemCardMediaPosition {
  LEFT = 'LEFT',
  TOP = 'TOP',
}

export interface TripsUIItineraryPreferenceInput {
  text: Scalars['String'];
  urn: Scalars['String'];
}

export interface TripsUIItineraryPreferencesInput {
  additionalPreferencesText?: InputMaybe<Scalars['String']>;
  selectedPreferences?: InputMaybe<Array<TripsUIItineraryPreferenceInput>>;
}

export enum TripsUIManageExternalItemsCheckboxCardActionType {
  TOGGLE_ADD_LIST = 'TOGGLE_ADD_LIST',
  TOGGLE_REMOVE_LIST = 'TOGGLE_REMOVE_LIST',
}

export enum TripsUIMessagingBannerCardTheme {
  CRITICAL = 'CRITICAL',
  DEFAULT = 'DEFAULT',
  ERROR = 'ERROR',
}

export enum TripsUIResponseStatus {
  FAIL = 'FAIL',
  SUCCESS = 'SUCCESS',
}

/** Device related information */
export interface TripsUIRideShareDeviceInfoInput {
  carrierMCC?: InputMaybe<Scalars['String']>;
  carrierMNC?: InputMaybe<Scalars['String']>;
  carrierName?: InputMaybe<Scalars['String']>;
  isEmulator?: InputMaybe<Scalars['Boolean']>;
  isRooted?: InputMaybe<Scalars['Boolean']>;
  timezone: Scalars['String'];
}

/** Ride share location input having either location id or coordinates */
export interface TripsUIRideShareLocationInput {
  coordinates?: InputMaybe<CoordinatesInput>;
  id?: InputMaybe<Scalars['String']>;
}

export interface TripsUISaveActivityCriteriaInput {
  products?: InputMaybe<Array<TripsUISaveActivityProductCriteriaInput>>;
}

export interface TripsUISaveActivityProductCriteriaInput {
  dateRange?: InputMaybe<DateRangeInput>;
  itemId: Scalars['String'];
  regionId?: InputMaybe<Scalars['String']>;
}

export interface TripsUISaveGoogleLocationCriteriaInput {
  googleId: Scalars['String'];
  location: CoordinatesInput;
  name?: InputMaybe<Scalars['String']>;
}

export interface TripsUISaveLodgingCriteriaInput {
  products?: InputMaybe<Array<TripsUISaveLodgingProductCriteriaInput>>;
}

export interface TripsUISaveLodgingProductCriteriaInput {
  dateRange?: InputMaybe<DateRangeInput>;
  itemId: Scalars['String'];
  regionId?: InputMaybe<Scalars['String']>;
}

/** Should be used for EG points of interest with gaia regionIds */
export interface TripsUISavePointOfInterestCriteriaInput {
  location?: InputMaybe<CoordinatesInput>;
  name?: InputMaybe<Scalars['String']>;
  propertyId?: InputMaybe<Scalars['String']>;
  regionId: Scalars['String'];
}

/** Input criteria to save one or more trip items. */
export interface TripsUISaveTripItemsCriteriaInput {
  activity?: InputMaybe<TripsUISaveActivityCriteriaInput>;
  googleLocations?: InputMaybe<Array<TripsUISaveGoogleLocationCriteriaInput>>;
  lodging?: InputMaybe<TripsUISaveLodgingCriteriaInput>;
  pointsOfInterest?: InputMaybe<Array<TripsUISavePointOfInterestCriteriaInput>>;
}

export interface TripsUISearchSuggestionInput {
  tripId?: InputMaybe<Scalars['String']>;
}

export enum TripsUISingleDateSelectorFieldType {
  END_DATE = 'END_DATE',
  START_DATE = 'START_DATE',
}

export enum TripsUIStepState {
  COMPLETE = 'COMPLETE',
  CURRENT = 'CURRENT',
  INCOMPLETE = 'INCOMPLETE',
}

export enum TripsUITimelineStepTrackPosition {
  END = 'END',
  STANDARD = 'STANDARD',
  START = 'START',
}

export interface TripsUITripContextInput {
  fromTripId: Scalars['String'];
  toTripId?: InputMaybe<Scalars['String']>;
}

/** Context needed for planning a trip */
export interface TripsUITripItemContextInput {
  itemId: Scalars['String'];
  /** Defines the planning operation type: move, copy or remove */
  operationType: Scalars['String'];
  tripId: Scalars['String'];
}

export interface TripsUITripListPaginationInput {
  maxCount: Scalars['Int'];
  startIndex: Scalars['Int'];
}

export enum TripsViewType {
  ACTIVITIES_SEARCH_RESULTS = 'ACTIVITIES_SEARCH_RESULTS',
  ASC_ACCEPT = 'ASC_ACCEPT',
  ASC_CANCEL = 'ASC_CANCEL',
  BOOKING_FLIGHT_CANCEL = 'BOOKING_FLIGHT_CANCEL',
  BOOKING_FLIGHT_CHANGE = 'BOOKING_FLIGHT_CHANGE',
  BOOKING_LODGING_CHANGE = 'BOOKING_LODGING_CHANGE',
  BOOKING_SERVICING_HEADS_UP = 'BOOKING_SERVICING_HEADS_UP',
  CAMPAIGNS = 'CAMPAIGNS',
  CARS_SEARCH_RESULTS = 'CARS_SEARCH_RESULTS',
  CHECKOUT_VAS_CART = 'CHECKOUT_VAS_CART',
  FILTERED = 'FILTERED',
  FIND_ITINERARY_BY_OTHER_EMAIL = 'FIND_ITINERARY_BY_OTHER_EMAIL',
  FIND_ITINERARY_BY_USER_EMAIL = 'FIND_ITINERARY_BY_USER_EMAIL',
  FLIGHTS_SEARCH_RESULTS = 'FLIGHTS_SEARCH_RESULTS',
  ITEM_DETAILS = 'ITEM_DETAILS',
  ITEM_ESSENTIAL_INFO = 'ITEM_ESSENTIAL_INFO',
  ITEM_PRICING_AND_REWARDS = 'ITEM_PRICING_AND_REWARDS',
  ITEM_VOUCHER = 'ITEM_VOUCHER',
  ITINERARY = 'ITINERARY',
  LOB_SELECTION_VIEW = 'LOB_SELECTION_VIEW',
  LODGING_SEARCH_RESULTS = 'LODGING_SEARCH_RESULTS',
  LOGIN_PROMPT = 'LOGIN_PROMPT',
  MANAGE_BOOKING = 'MANAGE_BOOKING',
  MANAGE_GUESTS = 'MANAGE_GUESTS',
  OVERVIEW = 'OVERVIEW',
  PACKAGES_FC_SEARCH_RESULTS = 'PACKAGES_FC_SEARCH_RESULTS',
  PACKAGES_FHC_SEARCH_RESULTS = 'PACKAGES_FHC_SEARCH_RESULTS',
  PACKAGES_HC_SEARCH_RESULTS = 'PACKAGES_HC_SEARCH_RESULTS',
  PACKAGES_HF_SEARCH_RESULTS = 'PACKAGES_HF_SEARCH_RESULTS',
  PENDING_INVITE = 'PENDING_INVITE',
  SEARCH_BY_ITINERARY_NUMBER = 'SEARCH_BY_ITINERARY_NUMBER',
  SEARCH_BY_ITINERARY_NUMBER_AND_EMAIL = 'SEARCH_BY_ITINERARY_NUMBER_AND_EMAIL',
  TRIPS_LIST = 'TRIPS_LIST',
  TRIP_ASSIST = 'TRIP_ASSIST',
}

/**
 * Contains fields that will be used to build the correct trips view URL. For the most accurate result,
 *     supply as many of the fields as possible. If input is not supplied, the Url will navigate to /trips"
 */
export interface TripsWebViewInput {
  filter?: InputMaybe<Scalars['String']>;
  inviteId?: InputMaybe<Scalars['String']>;
  screen?: InputMaybe<TripsScreen>;
  tripItemId?: InputMaybe<Scalars['String']>;
  tripViewId?: InputMaybe<Scalars['String']>;
}

export interface TriviaAnswerSubmitInput {
  /** id of the answer */
  answerId: Scalars['String'];
  /** id of the question */
  questionId: Scalars['String'];
}

export interface TriviaStartRequestInput {
  /** campaign id to reference for start */
  campaignId: Scalars['String'];
  /** trivia id to reference for start */
  triviaId: Scalars['String'];
}

export interface TriviaSubmitRequestInput {
  /** id of the campaign */
  campaignId: Scalars['String'];
  /** List of questionId to answerId relation */
  results: Array<TriviaAnswerSubmitInput>;
  /** id of the trivia */
  triviaId: Scalars['String'];
}

/** Represents a typing indicator event's content */
export interface TypingIndicatorEventContentInput {
  /** Represents if the user is typing or not */
  start: Scalars['Boolean'];
}

export enum UIActionName {
  MODULE_REFRESH = 'MODULE_REFRESH',
  REDIRECT_TO_CONFIRMATION_PAGE = 'REDIRECT_TO_CONFIRMATION_PAGE',
  REDIRECT_TO_UNRECOVERABLE_ERROR_PAGE = 'REDIRECT_TO_UNRECOVERABLE_ERROR_PAGE',
  TRIGGER_RENDER_QUERY = 'TRIGGER_RENDER_QUERY',
}

/** Specifies whether to open the link in the same user interface context or in a different context */
export enum UILinkTarget {
  EXTERNAL = 'EXTERNAL',
  INTERNAL = 'INTERNAL',
}

export enum UISignal {
  ABANDON_BOOKING = 'ABANDON_BOOKING',
  ABANDON_BOOKING_SUCCESS = 'ABANDON_BOOKING_SUCCESS',
  BOOKING_ALREADY_BOOKED = 'BOOKING_ALREADY_BOOKED',
  BOOKING_ERROR = 'BOOKING_ERROR',
  BOOKING_SUCCESS = 'BOOKING_SUCCESS',
  BOOKING_SUSPENDED = 'BOOKING_SUSPENDED',
  CONFIGURATION_ADDED = 'CONFIGURATION_ADDED',
  CONTINUE_BOOKING = 'CONTINUE_BOOKING',
  DUPLICATE_REQUEST = 'DUPLICATE_REQUEST',
  GENERIC_DOWNSTREAM_ERROR = 'GENERIC_DOWNSTREAM_ERROR',
  GENERIC_TECHNICAL_ERROR = 'GENERIC_TECHNICAL_ERROR',
  INSURANCE_UNAVAILABLE = 'INSURANCE_UNAVAILABLE',
  INVALID_EMAIL = 'INVALID_EMAIL',
  OFFER_ADDED = 'OFFER_ADDED',
  OFFER_CHANGED = 'OFFER_CHANGED',
  OFFER_REMOVED = 'OFFER_REMOVED',
  OFFER_UNAVAILABLE = 'OFFER_UNAVAILABLE',
  OPERATION_FAILED = 'OPERATION_FAILED',
  PAYMENT_ERROR = 'PAYMENT_ERROR',
  PAYMENT_METHODS_APPLIED = 'PAYMENT_METHODS_APPLIED',
  PAYMENT_METHOD_UPDATED = 'PAYMENT_METHOD_UPDATED',
  PENDING_CONFIRMATION = 'PENDING_CONFIRMATION',
  PRICE_ADJUSTED = 'PRICE_ADJUSTED',
  PRICE_CHANGED = 'PRICE_CHANGED',
  PROMOTION_CHANGED = 'PROMOTION_CHANGED',
  REQUEST_CONFLICT = 'REQUEST_CONFLICT',
  SESSION_EXPIRED = 'SESSION_EXPIRED',
  SESSION_TOKEN_UPDATED = 'SESSION_TOKEN_UPDATED',
  UNKNOWN = 'UNKNOWN',
  UNRECOVERABLE_FAILURE = 'UNRECOVERABLE_FAILURE',
  USER_STATE_UPDATED = 'USER_STATE_UPDATED',
}

/** Represents the common structure of a UI Signal Additional Details Input Type */
export interface UISignalAdditionalDetailsInput {
  /** Link Additional Detail of the signal */
  linkSignalAdditionalDetail?: InputMaybe<UISignalLinkDetailsInput>;
  /** Additional String Details of the signal */
  stringSignalAdditionalDetail?: InputMaybe<Scalars['String']>;
  /** Urn of the signal additional detail */
  urn: Scalars['String'];
}

export interface UISignalDetailsInput {
  /** Represents the optional description of the message banner */
  description?: InputMaybe<Scalars['String']>;
  /** Represents the reasonUrn of the message banner */
  reasonUrn: Scalars['String'];
  /** Represents the optional summary of the message banner */
  summary?: InputMaybe<Scalars['String']>;
}

/** Represents the common structure of LinkDetail input type of SignalAdditionalDetail */
export interface UISignalLinkDetailsInput {
  title: Scalars['String'];
  url: Scalars['String'];
  urn: Scalars['String'];
}

export interface UISignalPayloadInput {
  /** Represents the name of the publisher module */
  publisherModule: Scalars['String'];
  /** Represents the list of signal details */
  signalDetails?: InputMaybe<Array<UISignalDetailsInput>>;
  /** Represents the urn of the signal */
  signalUrn: Scalars['String'];
}

/** Represents the common structure of a UI Signal Payload shared input type */
export interface UISignalPayloadSharedInput {
  /** metadata corresponding to signalUrn of signal */
  metadata?: InputMaybe<Array<GraphQLPairInput>>;
  /** Represents the name of the publisher module */
  publisherModule: Scalars['String'];
  /** Represents the list of signal details */
  signalDetails?: InputMaybe<Array<UISignalSummaryInput>>;
  /** Represents the urn of the signal */
  signalUrn: Scalars['String'];
}

/** Represents the common structure of a signalSummary input type */
export interface UISignalSummaryInput {
  /** Represents the optional description of signal */
  description?: InputMaybe<Scalars['String']>;
  /** Represents the reasonUrn of signal */
  reasonUrn: Scalars['String'];
  /** Represents the additional details of signal */
  signalAdditionalDetails?: InputMaybe<Array<UISignalAdditionalDetailsInput>>;
  /** Represents the optional summary of signal */
  summary?: InputMaybe<Scalars['String']>;
}

export enum UniversalProfileAccountManagementOptionType {
  TRAVELER_ARRANGER = 'TRAVELER_ARRANGER',
}

export interface UniversalProfileAccountTakeOverWidgetRequestInput {
  content?: InputMaybe<Scalars['String']>;
  type: UniversalProfileAccountTakeOverWidgetTypeRequest;
}

export enum UniversalProfileAccountTakeOverWidgetTypeRequest {
  CAPTCHA = 'CAPTCHA',
  CSRF = 'CSRF',
}

export interface UniversalProfileAdditionalTravelerContextInput {
  accountTakeOverWidgets?: InputMaybe<Array<UniversalProfileAccountTakeOverWidgetRequestInput>>;
  additionalTravelerIdentifier?: InputMaybe<Scalars['String']>;
  experienceType?: InputMaybe<UniversalProfileExperienceType>;
  informationFormType?: InputMaybe<UniversalProfileInformationFormType>;
}

export interface UniversalProfileAddressInput {
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  stateCode?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
}

export enum UniversalProfileAnalyticsEventSubType {
  BLURRED = 'BLURRED',
  FOCUSED = 'FOCUSED',
  INPUTTED = 'INPUTTED',
  SUCCEEDED = 'SUCCEEDED',
}

export enum UniversalProfileAvatarUploadRequestType {
  ADD_IMAGE = 'ADD_IMAGE',
  CHANGE_IMAGE = 'CHANGE_IMAGE',
}

export interface UniversalProfileBasicInformationDateOfBirthInput {
  day?: InputMaybe<Scalars['Int']>;
  month?: InputMaybe<Scalars['Int']>;
  year?: InputMaybe<Scalars['Int']>;
}

export interface UniversalProfileBasicInformationNameInput {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  middleName?: InputMaybe<Scalars['String']>;
}

export interface UniversalProfileBasicInformationRequestInput {
  accessibilityNeeds?: InputMaybe<Scalars['String']>;
  bio?: InputMaybe<Scalars['String']>;
  dateOfBirth: UniversalProfileBasicInformationDateOfBirthInput;
  gender?: InputMaybe<Scalars['String']>;
  name: UniversalProfileBasicInformationNameInput;
}

export enum UniversalProfileCategorySwitchOperator {
  OFF = 'OFF',
  ON = 'ON',
}

export interface UniversalProfileChangeEmailRequestInput {
  cmsToken: Scalars['String'];
  email: Scalars['String'];
}

export enum UniversalProfileCheckboxAnalyticsEventSubType {
  DESELECTED = 'DESELECTED',
  SELECTED = 'SELECTED',
}

/** EG Universal profile input for accessing client type */
export interface UniversalProfileClientInfoInput {
  appVersion?: InputMaybe<Scalars['String']>;
  channelType: UniversalProfileClientType;
}

export enum UniversalProfileClientType {
  ANDROID = 'ANDROID',
  IOS = 'IOS',
  WEB = 'WEB',
}

export interface UniversalProfileCloseSessionRequestInput {
  closeAllSessions?: InputMaybe<Scalars['Boolean']>;
  csrfToken?: InputMaybe<Scalars['String']>;
  currentSession?: InputMaybe<Scalars['Boolean']>;
  internalId?: InputMaybe<Scalars['String']>;
}

export interface UniversalProfileCommunicationPreferenceEmailRequestInput {
  categoryConsent: Array<UniversalProfileEmailCommunicationPreferenceUpdateInput>;
  unsubscribeFromAll: Scalars['Boolean'];
}

export interface UniversalProfileCommunicationPreferenceRequestInput {
  updates: Array<UniversalProfileCommunicationPreferenceUpdateInput>;
}

export interface UniversalProfileCommunicationPreferenceUnsubRequestInput {
  channel: CommunicationChannel;
  checksum: Scalars['String'];
  egAccountId: Scalars['String'];
  emlCid?: InputMaybe<Scalars['String']>;
  emlDtl?: InputMaybe<Scalars['String']>;
}

export interface UniversalProfileCommunicationPreferenceUnsubscribeCategoriesRequestInput {
  categoryTypes: Array<UniversalProfileCommunicationPreferencesCategoryType>;
  channel: CommunicationChannel;
  checksum: Scalars['String'];
  egAccountId: Scalars['String'];
  emailUnsubscribeAll?: InputMaybe<Scalars['Boolean']>;
  emlCid?: InputMaybe<Scalars['String']>;
  emlDtl?: InputMaybe<Scalars['String']>;
  isStrict: Scalars['Boolean'];
}

export interface UniversalProfileCommunicationPreferenceUnsubscribePreferenceRequestInput {
  categoryType: UniversalProfileCommunicationPreferencesCategoryType;
  channel: CommunicationChannel;
  checksum: Scalars['String'];
  egAccountId: Scalars['String'];
  emlCid?: InputMaybe<Scalars['String']>;
  emlDtl?: InputMaybe<Scalars['String']>;
}

export interface UniversalProfileCommunicationPreferenceUpdateInput {
  category: UniversalProfileCommunicationPreferencesCategoryType;
  selectedChannels?: InputMaybe<Array<CommunicationChannel>>;
}

export enum UniversalProfileCommunicationPreferencesCategoryType {
  ACCOUNT_SUPPORT = 'ACCOUNT_SUPPORT',
  CONFIRMATION_AND_CRITICAL_UPDATES = 'CONFIRMATION_AND_CRITICAL_UPDATES',
  OFFERS_AND_INSPIRATION = 'OFFERS_AND_INSPIRATION',
  ONE_KEY = 'ONE_KEY',
  ONE_KEY_MONTHLY_STATEMENTS = 'ONE_KEY_MONTHLY_STATEMENTS',
  ONE_KEY_REWARD_ACCOUNT_UPDATES = 'ONE_KEY_REWARD_ACCOUNT_UPDATES',
  PARTNERS_OFFERS_WITH_US = 'PARTNERS_OFFERS_WITH_US',
  PERSONALIZED_TRIP_RECOMMENDATIONS = 'PERSONALIZED_TRIP_RECOMMENDATIONS',
  REVIEWS = 'REVIEWS',
  SURVEYS = 'SURVEYS',
  THE_TRAVEL_EDIT = 'THE_TRAVEL_EDIT',
  TRIP_BOARD_ACTIVITY = 'TRIP_BOARD_ACTIVITY',
  TRIP_PLANNING_ASSISTANCE = 'TRIP_PLANNING_ASSISTANCE',
}

/** Input for communication preferences query */
export interface UniversalProfileCommunicationPreferencesContextInput {
  /** Brand or program to get the communication preferences for */
  category?: InputMaybe<CommunicationPreferencesCategory>;
  /** Channel to get the communication preferences for */
  channel?: InputMaybe<CommunicationChannel>;
}

export enum UniversalProfileCommunicationPreferencesFormType {
  COMMUNICATION_PREFERENCE_CATEGORY_FORM = 'COMMUNICATION_PREFERENCE_CATEGORY_FORM',
  COMMUNICATION_PREFERENCE_COMPLETENESS_MODULE = 'COMMUNICATION_PREFERENCE_COMPLETENESS_MODULE',
  COMMUNICATION_PREFERENCE_MANAGE_EMAIL_FORM = 'COMMUNICATION_PREFERENCE_MANAGE_EMAIL_FORM',
  COMMUNICATION_PREFERENCE_UNSUBSCRIBE_CATEGORY_FORM = 'COMMUNICATION_PREFERENCE_UNSUBSCRIBE_CATEGORY_FORM',
  COMMUNICATION_PREFERENCE_UNSUBSCRIBE_STRICT_FORM = 'COMMUNICATION_PREFERENCE_UNSUBSCRIBE_STRICT_FORM',
}

export interface UniversalProfileCompletenessModuleContextInput {
  completenessModuleRequest?: InputMaybe<UniversalProfileCompletenessModuleRequestInput>;
  experienceType?: InputMaybe<UniversalProfileExperienceType>;
  informationFormType?: InputMaybe<UniversalProfileInformationFormType>;
}

export enum UniversalProfileCompletenessModulePromptType {
  ADD_MOBILE_NUMBER = 'ADD_MOBILE_NUMBER',
  CONFIRM_MOBILE_NUMBER = 'CONFIRM_MOBILE_NUMBER',
  EMAIL_PREFERENCES = 'EMAIL_PREFERENCES',
  ONE_KEY_CREDIT_CARD = 'ONE_KEY_CREDIT_CARD',
  PUSH_NOTIFICATION_PREFERENCES = 'PUSH_NOTIFICATION_PREFERENCES',
}

export interface UniversalProfileCompletenessModuleRequestInput {
  emailPreferences?: InputMaybe<EmailPreferencesCompletenessModuleRequestInput>;
  mobileNumber?: InputMaybe<MobileNumberCompletenessModuleRequestInput>;
  pageId?: InputMaybe<Scalars['String']>;
  pushNotificationPreferences?: InputMaybe<PushNotificationPreferencesCompletenessModuleRequestInput>;
}

export interface UniversalProfileConfirmAvatarUploadRequestInput {
  uploadRequestType: UniversalProfileAvatarUploadRequestType;
}

export interface UniversalProfileContactInformationRequestInput {
  address: UniversalProfileAddressInput;
  emergencyContact: UniversalProfileEmergencyContactInput;
  phone: UniversalProfilePhoneInput;
}

export interface UniversalProfileContextInput {
  accountTakeOverWidgets?: InputMaybe<Array<UniversalProfileAccountTakeOverWidgetRequestInput>>;
  additionalTravelerIdentifier?: InputMaybe<Scalars['String']>;
  cmsToken?: InputMaybe<Scalars['String']>;
  communicationPreferencesCategoryType?: InputMaybe<UniversalProfileCommunicationPreferencesCategoryType>;
  communicationPreferencesFormType?: InputMaybe<UniversalProfileCommunicationPreferencesFormType>;
  communicationPreferencesUnsubscribeContext?: InputMaybe<UniversalProfileCommunicationPreferenceUnsubRequestInput>;
  completenessModulePromptType?: InputMaybe<UniversalProfileCompletenessModulePromptType>;
  experienceType?: InputMaybe<UniversalProfileExperienceType>;
  informationFormType?: InputMaybe<UniversalProfileInformationFormType>;
  isPushDeviceSettingsEnabled?: InputMaybe<Scalars['Boolean']>;
  pageId?: InputMaybe<Scalars['String']>;
  settingsFormType?: InputMaybe<UniversalProfileSettingsFormType>;
  subExperienceType?: InputMaybe<UniversalProfileSubExperienceType>;
}

export enum UniversalProfileDashboardOptionType {
  COMMUNICATIONS = 'COMMUNICATIONS',
  /** @deprecated No longer in use. */
  CONNECTIONS = 'CONNECTIONS',
  COUPONS = 'COUPONS',
  CREDITS = 'CREDITS',
  EG_LABS = 'EG_LABS',
  HELP = 'HELP',
  LEGAL = 'LEGAL',
  PAYMENTS = 'PAYMENTS',
  PREFERENCES = 'PREFERENCES',
  PROFILE = 'PROFILE',
  /** @deprecated No longer in use. */
  PUBLIC_PROFILE = 'PUBLIC_PROFILE',
  REVIEWS = 'REVIEWS',
  SETTINGS = 'SETTINGS',
}

export interface UniversalProfileDeletePaymentRequestInput {
  storedPaymentInstrumentId: Scalars['String'];
}

export interface UniversalProfileDeleteVerifiedPhoneRequestInput {
  flowEntrypointIdentifier?: InputMaybe<FlowEntrypointIdentifier>;
  intent?: InputMaybe<UniversalProfileVerifiedPhoneIntent>;
}

export enum UniversalProfileDependsOnFieldIdentificationCriteriaOperator {
  EXCLUDES = 'EXCLUDES',
  INCLUDES = 'INCLUDES',
}

export interface UniversalProfileEmailCommunicationPreferenceUpdateInput {
  category: UniversalProfileCommunicationPreferencesCategoryType;
  emailOptIn: Scalars['Boolean'];
}

export interface UniversalProfileEmergencyContactInput {
  contactName?: InputMaybe<Scalars['String']>;
  phone: UniversalProfilePhoneInput;
}

export enum UniversalProfileExperienceType {
  ADDITIONAL_TRAVELER = 'ADDITIONAL_TRAVELER',
  COMMUNICATION_PREFERENCES = 'COMMUNICATION_PREFERENCES',
  HELP = 'HELP',
  LEGAL = 'LEGAL',
  PREFERENCES = 'PREFERENCES',
  PROFILE = 'PROFILE',
  SESSION_MANAGEMENT = 'SESSION_MANAGEMENT',
  SETTINGS = 'SETTINGS',
  TRAVELER_DOCUMENTS = 'TRAVELER_DOCUMENTS',
}

export interface UniversalProfileGenerateAvatarUploadUrlRequestInput {
  /** base64 of the MD5 hash of the image to be uploaded */
  md5Hash: Scalars['String'];
}

export enum UniversalProfileImageUploadCategory {
  PROFILE_AVATAR = 'PROFILE_AVATAR',
}

export enum UniversalProfileInformationFormType {
  COMMUNICATION_PREFERENCE_DOUBLE_OPT_IN = 'COMMUNICATION_PREFERENCE_DOUBLE_OPT_IN',
  COMMUNICATION_PREFERENCE_UNSUB = 'COMMUNICATION_PREFERENCE_UNSUB',
  COMPLETENESS_MODULE = 'COMPLETENESS_MODULE',
  CONFIRM_AVATAR_UPLOAD = 'CONFIRM_AVATAR_UPLOAD',
  DELETE_SAVED_CARD = 'DELETE_SAVED_CARD',
  DELETE_VERIFIED_PHONE_NUMBER = 'DELETE_VERIFIED_PHONE_NUMBER',
  GENERATE_AVATAR_UPLOAD_URL = 'GENERATE_AVATAR_UPLOAD_URL',
  SESSION_MANAGEMENT = 'SESSION_MANAGEMENT',
  UPDATE_ADDITIONAL_TRAVELER_INFO = 'UPDATE_ADDITIONAL_TRAVELER_INFO',
  UPDATE_BASIC_INFORMATION = 'UPDATE_BASIC_INFORMATION',
  UPDATE_COMMUNICATION_PREFERENCE = 'UPDATE_COMMUNICATION_PREFERENCE',
  UPDATE_CONTACT_INFORMATION = 'UPDATE_CONTACT_INFORMATION',
  UPDATE_CONTACT_INFORMATION_EMAIL = 'UPDATE_CONTACT_INFORMATION_EMAIL',
  UPDATE_CONTACT_INFORMATION_PHONE_NUMBER = 'UPDATE_CONTACT_INFORMATION_PHONE_NUMBER',
  UPDATE_PASSPORT_INFO = 'UPDATE_PASSPORT_INFO',
  UPDATE_TRAVELER_DOCUMENT = 'UPDATE_TRAVELER_DOCUMENT',
  UPDATE_TSA_INFORMATION = 'UPDATE_TSA_INFORMATION',
}

export enum UniversalProfileLocationAndLanguageOptionType {
  COUNTY = 'COUNTY',
  CURRENCY = 'CURRENCY',
  LANGUAGE = 'LANGUAGE',
}

export enum UniversalProfileLoginInformationSettingsOptionType {
  CHANGE_PASSWORD = 'CHANGE_PASSWORD',
  CONNECTED_DEVICES = 'CONNECTED_DEVICES',
  DELETE_PHONE_NUMBER = 'DELETE_PHONE_NUMBER',
  EMAIL = 'EMAIL',
  PHONE_NUMBER = 'PHONE_NUMBER',
}

export enum UniversalProfileMoreDetailsOptionType {
  AIRPORT_SECURITY = 'AIRPORT_SECURITY',
  FLIGHT_PREFERENCES = 'FLIGHT_PREFERENCES',
  REWARD_PROGRAM = 'REWARD_PROGRAM',
  TRAVELER_DOCUMENTS = 'TRAVELER_DOCUMENTS',
}

export interface UniversalProfilePassportExpiryDateInput {
  day?: InputMaybe<Scalars['Int']>;
  month?: InputMaybe<Scalars['Int']>;
  year?: InputMaybe<Scalars['Int']>;
}

export interface UniversalProfilePassportInformationRequestInput {
  country?: InputMaybe<Scalars['String']>;
  expiryDate?: InputMaybe<UniversalProfilePassportExpiryDateInput>;
  passportNumber?: InputMaybe<Scalars['String']>;
}

export interface UniversalProfilePhoneInput {
  countryCode?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['String']>;
  smsInfo?: InputMaybe<Scalars['Boolean']>;
}

export enum UniversalProfilePreferencesOptionType {
  COUNTRY = 'COUNTRY',
  CURRENCY = 'CURRENCY',
  DISPLAY_APPEARANCE = 'DISPLAY_APPEARANCE',
  LANGUAGE = 'LANGUAGE',
}

export enum UniversalProfileSettingsFormType {
  DELETE_ACCOUNT = 'DELETE_ACCOUNT',
  UPDATE_COUNTRY = 'UPDATE_COUNTRY',
  UPDATE_EMAIL = 'UPDATE_EMAIL',
  UPDATE_LANGUAGE = 'UPDATE_LANGUAGE',
  UPDATE_PASSWORD = 'UPDATE_PASSWORD',
}

export interface UniversalProfileSmsContactInformationRequestInput {
  phone: UniversalProfilePhoneInput;
}

export enum UniversalProfileSubExperienceType {
  COMMUNICATION_PREFERENCES_EXPEDIA = 'COMMUNICATION_PREFERENCES_EXPEDIA',
  COMMUNICATION_PREFERENCES_HOTELS = 'COMMUNICATION_PREFERENCES_HOTELS',
  COMMUNICATION_PREFERENCES_VRBO = 'COMMUNICATION_PREFERENCES_VRBO',
  COMMUNICATION_PREFERENCES_WOTIF = 'COMMUNICATION_PREFERENCES_WOTIF',
  VISIT_HELP_CENTER = 'VISIT_HELP_CENTER',
}

export enum UniversalProfileToggleButtonStackedType {
  INLINE = 'INLINE',
  STACKED = 'STACKED',
}

export interface UniversalProfileTravelerCompanionContactInfoInput {
  email?: InputMaybe<Scalars['String']>;
  primaryPhone: UniversalProfilePhoneInput;
}

export interface UniversalProfileTravelerCompanionRequestInput {
  accessibilityNeeds?: InputMaybe<Scalars['String']>;
  contactInfo: UniversalProfileTravelerCompanionContactInfoInput;
  dateOfBirth: UniversalProfileBasicInformationDateOfBirthInput;
  emergencyContact: UniversalProfileEmergencyContactInput;
  gender?: InputMaybe<Scalars['String']>;
  name: UniversalProfileBasicInformationNameInput;
  travelerId?: InputMaybe<Scalars['String']>;
  tsaInfo?: InputMaybe<UniversalProfileTsaInformationRequestInput>;
}

export interface UniversalProfileTravelerDocumentsContextInput {
  accountTakeOverWidgets?: InputMaybe<Array<UniversalProfileAccountTakeOverWidgetRequestInput>>;
  experienceType?: InputMaybe<UniversalProfileExperienceType>;
  informationFormType?: InputMaybe<UniversalProfileInformationFormType>;
  travelerDocIdentifier?: InputMaybe<Scalars['String']>;
}

export enum UniversalProfileTravelerDocumentsOptionType {
  PASSPORT = 'PASSPORT',
}

export interface UniversalProfileTsaInformationRequestInput {
  knownTravelerNumber?: InputMaybe<Scalars['String']>;
  redressNumber?: InputMaybe<Scalars['String']>;
}

export enum UniversalProfileVerifiedPhoneIntent {
  DELETE = 'DELETE',
}

/** Unmapped filter option */
export interface UnmappedFilterInput {
  filterId: Scalars['String'];
  filterValue: Scalars['String'];
}

export enum UpdateAction {
  ACCEPT = 'ACCEPT',
  SHARE = 'SHARE',
}

export interface UpdateAdGroupCreativesInput {
  campaignId: Scalars['String'];
  sourceAdGroupId: Scalars['String'];
  targetAdGroupIds: Array<Scalars['String']>;
}

export interface UpdateAdGroupStatusInput {
  adGroupId: Scalars['String'];
  adGroupIsActive: Scalars['Boolean'];
  campaignId: Scalars['String'];
}

export interface UpdateAdStatusInput {
  adGroupId: Scalars['String'];
  adId?: InputMaybe<Scalars['String']>;
  campaignId: Scalars['String'];
  isApproved: Scalars['Boolean'];
}

export interface UpdateApprovalStatusInput {
  creativeId: Scalars['String'];
  isApproved: Scalars['Boolean'];
}

/** Input for updateBudgetForecastMetrics mutation */
export interface UpdateBudgetForecastMetricInput {
  /** Campaign Id */
  campaignId: Scalars['String'];
  /** Current Budget */
  currentBudget: Scalars['Float'];
  /** Target Budget */
  targetBudget: Scalars['Float'];
}

/** Represents the update deals tracking mutation operation data */
export interface UpdateDealsTrackingOperationDataInput {
  subscriptionId: Scalars['String'];
}

export interface UpdateFopConfigurationInput {
  clientDetails: ClientDetailsInput;
  fopItems: Array<OneCPMFOPItemInput>;
  paymentSessionId: Scalars['String'];
}

/** Enum for holding values with reference to page stack history */
export enum UpdateHistory {
  REMOVE = 'REMOVE',
}

export interface UpdateInsurtechOfferRequestInput {
  /** list of covered offer tokens to be added to the main offer */
  coveredOfferTokens?: InputMaybe<Array<OfferIdentityInput>>;
  /** The offer token of the offer to be updated */
  offersToAdd: Array<OfferIdentityInput>;
  /** list of Covered offer item ids to be removed from the main offer */
  offersToRemove: Array<OfferIdentityInput>;
  /** Session Id */
  sessionIdentifier?: InputMaybe<Scalars['String']>;
}

/** Save activity input details */
export interface UpdateJourneyContinuationIdRequestInput {
  /** Represents the Additional Products Information for the JCID update */
  additionalProducts?: InputMaybe<AdditionalProductsInput>;
  /** Represents the Journey Continuation Id that needs to be updated */
  journeyContinuationId: Scalars['String'];
}

export interface UpdatePaymentMethodMutationRequestInput {
  bookingParameters?: InputMaybe<Array<PaymentConfigurationItemInput>>;
  businessFlow?: InputMaybe<UpdatePaymentMutationBusinessFlow>;
  checkoutIdentifier: PaymentCheckoutIdentifierInput;
  checkoutSessionMode?: InputMaybe<CheckoutSessionMode>;
  fopItems: Array<FOPItemInput>;
}

export enum UpdatePaymentMutationBusinessFlow {
  BOOKING = 'BOOKING',
  CHECKOUT_PAYMENT_MODULE = 'CHECKOUT_PAYMENT_MODULE',
  ITINERARY = 'ITINERARY',
}

export interface UpdatePaymentSessionConfigurationInput {
  clientDetails: ClientDetailsInput;
  payableAmount?: InputMaybe<PayableAmountInput>;
  paymentSessionId: Scalars['String'];
  selectedPaymentMethod?: InputMaybe<OneCPMFOPItemInput>;
  sessionDetails: SessionDetailsInput;
}

export interface UpdateProviderServicesInput {
  providerId: Scalars['String'];
  serviceActions: Array<ServiceActionInput>;
}

export enum UploadLogoStatusType {
  FAILURE = 'FAILURE',
  PENDING = 'PENDING',
  SUCCESS = 'SUCCESS',
}

/** Represents the upsertPasswordForm query request */
export interface UpsertPasswordFormRequestInput {
  flowType?: InputMaybe<IdentityFlowType>;
  loginType?: InputMaybe<IdentityLoginType>;
}

/** Represents the upsertPasswordSubmit mutation request */
export interface UpsertPasswordSubmitRequestInput {
  atoInputs?: InputMaybe<Array<IdentityAccountTakeOverInput>>;
  flowType?: InputMaybe<IdentityFlowType>;
  loginType?: InputMaybe<IdentityLoginType>;
  password: Scalars['String'];
}

export interface UriAttributesInput {
  /**
   * Used to specify the GAIA feature TYPE
   * Example Value: Multi-City
   */
  gaiaType?: InputMaybe<Scalars['String']>;
  lodgingUrlCode?: InputMaybe<Scalars['String']>;
}

export enum UriClassification {
  CLASSIFICATION_DEALS = 'CLASSIFICATION_DEALS',
  CLASSIFICATION_INVALID = 'CLASSIFICATION_INVALID',
  CLASSIFICATION_LEGAL = 'CLASSIFICATION_LEGAL',
}

export interface UriContextAttributesInput {
  affinity?: InputMaybe<Scalars['String']>;
  airCarrierCode?: InputMaybe<Scalars['String']>;
  carClass?: InputMaybe<Scalars['String']>;
  carSupplier?: InputMaybe<Scalars['String']>;
  gaiaType?: InputMaybe<Scalars['String']>;
  lodgingUrlCode?: InputMaybe<Scalars['String']>;
  starRating?: InputMaybe<Scalars['String']>;
}

export interface UriContextIdentifiersInput {
  destination: Scalars['String'];
  /** Only for PDP pages */
  hotelId?: InputMaybe<Scalars['Int']>;
  origin?: InputMaybe<Scalars['String']>;
}

/**
 * A context that can be used to retrieve targeted flex content
 * with combination of attributes and identifiers that uniquely identify a URI.
 */
export interface UriContextInput {
  /** The attribute categorises groups of similar URIs */
  attributes?: InputMaybe<UriAttributesInput>;
  /**
   * Used to specify a deals campaign category that can encompass one or more collections
   * Example Value: beach-getaways
   */
  campaign?: InputMaybe<Scalars['String']>;
  /**
   * Specifies the labelled category of a URL
   * Example Value: CLASSIFICATION_DEALS
   * Values align with the UriContext proto definitions
   */
  classification?: InputMaybe<UriClassification>;
  /**
   * Used to specify the GAIA feature ID of destination
   * Example Value: 178279
   */
  destination?: InputMaybe<Scalars['String']>;
  /**
   * Used to specify current location of user in the conversion funnel.
   * Example Value: ENTRY
   * Values do NOT align with the UriContext proto definitions
   */
  funnelLocation?: InputMaybe<PageLocation>;
  /** Identifiers are the subcomponents that uniquely identify a URI */
  identifiers?: InputMaybe<UriIdentifiersInput>;
  /**
   * Specifies a concept within the Legal domain
   * Example Value: LEGAL_CONCEPT_COOKIES
   * Values align with the UriContext proto definitions
   */
  legalConcept?: InputMaybe<LegalConcept>;
}

/** A identifiers list that can be used to uniquely identify a URI. */
export interface UriIdentifiersInput {
  /**
   * Used to specify the accommodation type.
   * Example Value: Apartments
   */
  accommodationType?: InputMaybe<Scalars['String']>;
  /**
   * Used to specify airports city GAIA feature ID
   * Example Value: 178279
   */
  airport?: InputMaybe<Scalars['String']>;
  /**
   * Used to specify the brand.
   * Example Value: Travelodge UK
   */
  brand?: InputMaybe<Scalars['String']>;
  /**
   * Used to specify the car class.
   * Example Value: Economy
   */
  carClass?: InputMaybe<Scalars['String']>;
  /**
   * Used to specify the car supplier location ID (aka CVL ID).
   * Example Value: 12245
   */
  carSupplierLocation?: InputMaybe<Scalars['String']>;
  /**
   * Used to specify the carrier code.
   * Example Value: BA
   */
  carrierCode?: InputMaybe<Scalars['String']>;
  /**
   * Used to specify vendor ID
   * Example Value: ET
   */
  company?: InputMaybe<Scalars['String']>;
  /**
   * Used to specify the cruise line ID
   * Example Value: CV
   */
  cruiseLine?: InputMaybe<Scalars['String']>;
  /**
   * Used to specify the GAIA feature ID of destination
   * Example Value:
   */
  destination?: InputMaybe<Scalars['String']>;
  /**
   * Used to specify the discriminator for hotel landing pages
   * Example Value: ho
   */
  discriminator?: InputMaybe<Scalars['String']>;
  /**
   * Used to specify current screen feature displayed to user
   * Example Value: reviews, lodgingDiscovery, destinationDiscovery
   */
  feature?: InputMaybe<Scalars['String']>;
  /**
   * Used to specify the flight route type
   * Example Value: open / fixed
   */
  flightRoute?: InputMaybe<Scalars['String']>;
  /**
   * Used to specify current location of user in the conversion funnel
   * Example Value: entry
   */
  funnelLocation?: InputMaybe<Scalars['String']>;
  /**
   * Used to specify the hotel ID
   * Example Value: 1
   */
  hotel?: InputMaybe<Scalars['String']>;
  /**
   * Used to specify hotel PCS ID for HCOM pages
   * Example Value: 456469
   */
  id?: InputMaybe<Scalars['String']>;
  /**
   * Used to specify the line of business
   * Example Value: flight
   */
  lineOfBusiness?: InputMaybe<Scalars['String']>;
  /**
   * Used to specify the type of lodging
   * Example Value: alternative
   */
  lodgingType?: InputMaybe<Scalars['String']>;
  /**
   * Used to specify the GAIA feature ID of origin
   * Example Value: 178286
   */
  origin?: InputMaybe<Scalars['String']>;
  /**
   * Used to specify the ship code of the ship
   * Example Value: AVW
   */
  ship?: InputMaybe<Scalars['String']>;
  /**
   * Used to specify the hotel's star rating
   * Source of truth is flex-hotels-service
   * Example Value: 5
   */
  starRating?: InputMaybe<Scalars['String']>;
  /**
   * Used to specify the hotel's theme
   * Source of truth is affinity prime
   * Example Value: romantic
   */
  theme?: InputMaybe<Scalars['String']>;
  /**
   * Used to specify the url mapping path, without leading '/'
   * Example Value: lp/deals
   */
  url?: InputMaybe<Scalars['String']>;
}

/** Signal on user activity */
export enum UserActivitySignal {
  COLD = 'COLD',
  HOT = 'HOT',
  POST_TRIP = 'POST_TRIP',
  WARM = 'WARM',
}

export interface UserCommunicationConsentSectionRequestInput {
  authenticationMethod?: InputMaybe<Scalars['String']>;
  cmsToken?: InputMaybe<Scalars['String']>;
  flowVariant?: InputMaybe<Scalars['String']>;
  identityClientContext?: InputMaybe<IdentityClientContext>;
  scenario?: InputMaybe<Scenario>;
}

export interface UserConsentRequestInput {
  marketingConsentMessageKey?: InputMaybe<Scalars['String']>;
  marketingConsentStatus?: InputMaybe<Scalars['Boolean']>;
  scenario?: InputMaybe<IdentityAuthenticationScenario>;
}

export interface UserDetailsAndConsentRequestInput {
  atoInputs?: InputMaybe<Array<IdentityAccountTakeOverInput>>;
  authenticationMethod?: InputMaybe<Scalars['String']>;
  cmsToken?: InputMaybe<Scalars['String']>;
  emailMarketingConsent?: InputMaybe<Scalars['Boolean']>;
  firstName?: InputMaybe<Scalars['String']>;
  flowVariant?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  referrerURL?: InputMaybe<Scalars['String']>;
  scenario?: InputMaybe<Scenario>;
}

export interface UserLocationInput {
  userCountryCode?: InputMaybe<Scalars['String']>;
  userLatitude?: InputMaybe<Scalars['BigDecimal']>;
  userLongitude?: InputMaybe<Scalars['BigDecimal']>;
  userSelectedOrigin?: InputMaybe<Scalars['String']>;
}

/** List of filters. For e.x. Amenities, rooms, adults */
export interface UserSelectedFiltersInput {
  filterName?: InputMaybe<Scalars['String']>;
  filterValue?: InputMaybe<Scalars['String']>;
}

export enum VRCancellationReason {
  CONFLICT_WITH_HOUSE_RULES = 'CONFLICT_WITH_HOUSE_RULES',
  DATES_BOOKED_EXTERNALLY = 'DATES_BOOKED_EXTERNALLY',
  EXTENUATING_CIRCUMSTANCES = 'EXTENUATING_CIRCUMSTANCES',
  GUEST_NEEDS_TO_CANCEL = 'GUEST_NEEDS_TO_CANCEL',
  NEW_OWNERSHIP_OF_PROPERTY = 'NEW_OWNERSHIP_OF_PROPERTY',
  PAYMENT_NOT_RECEIVED = 'PAYMENT_NOT_RECEIVED',
}

/** Represents the videoExperienceCarousal query request */
export interface VideoExperienceCarousalRequestInput {
  /** Represents the creator handle for travel shop */
  creatorHandle?: InputMaybe<Scalars['String']>;
  /** Represents the video creator id if it is travel shop */
  creatorId?: InputMaybe<Scalars['String']>;
  /** Represents the destination id of the destination in the video */
  destinationId?: InputMaybe<Scalars['String']>;
  /** Represents the product id of the property in the video */
  productId: VideoExperienceProductId;
  /** Represents the current screen id */
  screenId: Scalars['String'];
  /** Represents the video id that needs to be opened in immersive view */
  videoId?: InputMaybe<Scalars['String']>;
}

/** Represents the video experience component type */
export enum VideoExperienceComponentType {
  CAROUSEL = 'CAROUSEL',
  VIDEO_PLAYER = 'VIDEO_PLAYER',
}

/** Represents the video experience interaction type */
export enum VideoExperienceInteractionType {
  BUTTON_TAP = 'BUTTON_TAP',
  CLICK = 'CLICK',
  PAUSE = 'PAUSE',
  PLAY = 'PLAY',
  SWIPE = 'SWIPE',
  VIEW = 'VIEW',
  WATCH_TIME = 'WATCH_TIME',
}

/** Represents the entry point for the video experience queries */
export enum VideoExperienceProductId {
  EG_STORIES = 'EG_STORIES',
  MESO_ADS = 'MESO_ADS',
  TRAVEL_SHOP = 'TRAVEL_SHOP',
}

/** Represents the saveVideoInteraction mutation request */
export interface VideoExperienceSaveVideoInteractionRequestInput {
  productId: Scalars['String'];
  screenId: Scalars['String'];
  videoComponentType: VideoExperienceComponentType;
  videoId: Scalars['String'];
  videoInteractionType: VideoExperienceInteractionType;
}

/** Video format of videos from content platform */
export enum VideoFormat {
  MP4 = 'MP4',
  UNSPECIFIED = 'UNSPECIFIED',
  WEBM = 'WEBM',
  YOUTUBE = 'YOUTUBE',
}

/** Represents request for video post overlay */
export interface VideoPostOverlayRequestInput {
  /** Represents the video creator id if it is travel shop */
  creatorId?: InputMaybe<Scalars['String']>;
  /** Represents the destination id of the destination in the video */
  destinationId?: InputMaybe<Scalars['String']>;
  /** Represents the property id of the property in the video */
  propertyId?: InputMaybe<Scalars['String']>;
  /** Represents the current screen id */
  screenId: Scalars['String'];
  /** Represents the current video id */
  videoId: Scalars['String'];
}

export enum VideoType {
  /** All other video types except for youtube */
  SELF_HOSTED = 'SELF_HOSTED',
  YOUTUBE = 'YOUTUBE',
}

/** Represents the status of response */
export enum VirtualAgentCheckoutStatus {
  FAILED = 'FAILED',
  SUCCESS = 'SUCCESS',
}

/** Represents the virtual agent context */
export interface VirtualAgentContextInput {
  /** Represents the intended itinerary number to change */
  itineraryNumber: Scalars['String'];
  /** Represents the token which is used in exchange of information */
  opaqueToken: Scalars['String'];
}

export enum VirtualAgentControlAnalyticEventSubType {
  BLURRED = 'BLURRED',
  FOCUSED = 'FOCUSED',
  INPUTTED = 'INPUTTED',
  SUCCEEDED = 'SUCCEEDED',
}

/** Represents a file attachment data */
export interface VirtualAgentControlAttachmentDataInput {
  /** Represents type of the file as string */
  mediaType: Scalars['String'];
  /** Represents file url returns from upload using webservice */
  mediaUrl: Scalars['String'];
  /** Represents name of the file */
  name: Scalars['String'];
  /** Represents size of file */
  size: Scalars['String'];
  /** Represents unique file attachment id */
  uniqueAttachmentId: Scalars['String'];
}

/** Represents any relevant attributes of a conversation, such as the current page URL, conversationType */
export interface VirtualAgentControlAttributeInput {
  /** Represents key of the attribute */
  key: Scalars['String'];
  /** Represents corresponding attribute value for the key */
  value: Scalars['String'];
}

/** Represents a new input type, used by the new mutation to send event data */
export interface VirtualAgentControlConversationEventInput {
  /** Represents content for an event */
  content?: InputMaybe<EventContentInput>;
  /** Represents event type, used by the mutation to send event data */
  eventType: VirtualAgentControlEventType;
}

/** Represents event type, used by the mutation to send event data */
export enum VirtualAgentControlEventType {
  /** Represents a conversation read event type */
  CONVERSATION_READ = 'CONVERSATION_READ',
  /** Represents a heartbeat event type */
  HEARTBEAT = 'HEARTBEAT',
  /** Represents a typing indicator event type */
  TYPING_INDICATOR = 'TYPING_INDICATOR',
}

/** Represents VirtualAgentControlGetSurveyData */
export interface VirtualAgentControlGetSurveyDataInput {
  /** Data type of an answers submitted by customer. */
  answers?: InputMaybe<Array<VirtualAgentControlSurveyAnswerInput>>;
  /** Name of the channel type. */
  channelType?: InputMaybe<Scalars['String']>;
  /** Unique ID for the conversation generated by the platform. */
  conversationId?: InputMaybe<Scalars['String']>;
  /** Name of the delivery channel in which survey was sent to traveler. */
  deliveryType?: InputMaybe<Scalars['String']>;
  /** Booking or Participant User Email address to which email survey was sent. */
  emailAddress?: InputMaybe<Scalars['String']>;
  /** The json payload of survey web form UI current state. */
  formState?: InputMaybe<Scalars['String']>;
  /** Date/Time when Skill started in UTC. */
  offered?: InputMaybe<Scalars['String']>;
  /** Image url configured for the Partner in Resource Manager. */
  partnerIconURL?: InputMaybe<Scalars['String']>;
  /** Unique id of the Partner from Resource Manager. */
  partnerId?: InputMaybe<Scalars['String']>;
  /** Name of the Partner for whom the survey is generated. */
  partnerName?: InputMaybe<Scalars['String']>;
  /** Survey ID for survey create/submitted by user. */
  surveyId: Scalars['String'];
  /** Flag to signify if Survey was submitted. */
  surveySubmitted: Scalars['Boolean'];
  /** Name of the Survey type shown to the user. */
  surveyType?: InputMaybe<Scalars['String']>;
  /** Optional field for survey template version. */
  templateVersion?: InputMaybe<Scalars['String']>;
  /** ISO Date/Time when Survey was updated in UTC. */
  updated?: InputMaybe<Scalars['String']>;
}

/** Represents VAC get survey input data */
export interface VirtualAgentControlGetSurveyInput {
  /** Survey ID for survey create/submitted by user. */
  surveyId: Scalars['String'];
}

/** Represents supported vertical alignment for the graphic relative to the text */
export enum VirtualAgentControlGraphicPosition {
  CENTERED = 'CENTERED',
  TOP = 'TOP',
}

/** Represents supported size of the text/graphic to be rendered */
export enum VirtualAgentControlGraphicTextSize {
  LARGE = 'LARGE',
  MEDIUM = 'MEDIUM',
  SMALL = 'SMALL',
  XLARGE = 'XLARGE',
}

/** Represents event type, used by the mutation to send event data for menuItem */
export enum VirtualAgentControlMenuItemType {
  /** Represents a conversation read event type */
  DOWNLOAD_TRANSCRIPT = 'DOWNLOAD_TRANSCRIPT',
  /** Represents a report spam event type */
  REPORT_SPAM = 'REPORT_SPAM',
  /** Represents a block conversations event type */
  TOGGLE_BLOCK_CONVERSATION = 'TOGGLE_BLOCK_CONVERSATION',
  /** Represents a toggle sound event type */
  TOGGLE_SOUND = 'TOGGLE_SOUND',
}

/** Represents VAC input message attributes */
export interface VirtualAgentControlMessageAttributesInput {
  /** Represents messageID of end chat message, send to salesforce case */
  incomingEndChatMessageId?: InputMaybe<Scalars['String']>;
  /** Represents an attribute sent to server for vnext */
  travelerEndChat?: InputMaybe<Scalars['String']>;
}

/** Represents VAC input message flags */
export interface VirtualAgentControlMessageFlagsInput {
  /** Represents actionType of end chat QR sent to server for salesforce */
  actionType?: InputMaybe<Scalars['String']>;
  /** Represents input state for vnext */
  disableUserInput?: InputMaybe<Scalars['Boolean']>;
  /** Represents messageId of end chat QR sent to server */
  sourceMessageId?: InputMaybe<Scalars['String']>;
}

/** Represents VAC input message data */
export interface VirtualAgentControlMessageInput {
  /** Represents list of file attachment data */
  attachments?: InputMaybe<Array<VirtualAgentControlAttachmentDataInput>>;
  /** Represents attributes flags needed to agent */
  attributes?: InputMaybe<VirtualAgentControlMessageAttributesInput>;
  /** Represents required flags needed to agent */
  flags?: InputMaybe<VirtualAgentControlMessageFlagsInput>;
  /** Represents intent associated with a message */
  intent?: InputMaybe<Scalars['String']>;
  /** Represents message trigger location - outside or within the chat window */
  messageTriggerLocation?: InputMaybe<VirtualAgentControlMessageTriggerLocation>;
  /** Represents type of a message - text, intent, postback, etc.  */
  messageType?: InputMaybe<VirtualAgentControlMessageType>;
  /** Represents an optional payload of message input */
  payload?: InputMaybe<Scalars['String']>;
  /** Represents the text of message input */
  text?: InputMaybe<Scalars['String']>;
  /** Represents a unique identifier on the UI */
  umid: Scalars['String'];
}

export enum VirtualAgentControlMessageTriggerLocation {
  EXTERNAL = 'EXTERNAL',
  INTERNAL = 'INTERNAL',
}

export enum VirtualAgentControlMessageType {
  FILE = 'FILE',
  INTENT = 'INTENT',
  POSTBACK = 'POSTBACK',
  TEXT = 'TEXT',
}

/** Represents the mode of user presence */
export enum VirtualAgentControlPresenceMode {
  HEARTBEAT = 'HEARTBEAT',
  NONE = 'NONE',
}

/** Represents the progress bar theme/variant */
export enum VirtualAgentControlProgressBarTheme {
  MUTED = 'MUTED',
  POSITIVE = 'POSITIVE',
  STANDARD = 'STANDARD',
}

/** Represents the supported text styles in stackedText.  */
export enum VirtualAgentControlStackedTextStyle {
  TEXT_MEDIUM = 'TEXT_MEDIUM',
  TEXT_SMALL = 'TEXT_SMALL',
}

/** Represents VAC submit survey input data */
export interface VirtualAgentControlSubmitSurveyInput {
  /** Represents the surveyData to be submitted */
  surveyData: VirtualAgentControlGetSurveyDataInput;
}

/** Represents VirtualAgentControlSurveyAnswer */
export interface VirtualAgentControlSurveyAnswerInput {
  /** Answer Submitted by customer. */
  answer?: InputMaybe<Scalars['String']>;
  /** Data type of an answer an submitted by customer. */
  answerDataType?: InputMaybe<Scalars['String']>;
  /** Order of Question. */
  order: Scalars['String'];
  /** Question to customer. */
  question: Scalars['String'];
  /** Category of Question that was answered. */
  questionCategory: Scalars['String'];
  /** SubAnswers Submitted by customer. */
  subAnswers?: InputMaybe<Array<VirtualAgentControlSurveyAnswerInput>>;
  /** Optional field for survey template version. */
  templateVersion?: InputMaybe<Scalars['String']>;
}

export interface VrboSupplyHelpLeadFormInput {
  countryCode: Scalars['String'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  helpMessage: Scalars['String'];
  lastName: Scalars['String'];
  numberOfProperties?: InputMaybe<Scalars['Int']>;
  phoneNumber: Scalars['String'];
  preferredLanguage: Scalars['String'];
  propertyManagementSoftware?: InputMaybe<Scalars['String']>;
}

export enum WaivingSource {
  COMBINED = 'COMBINED',
  EXPEDIA = 'EXPEDIA',
  NO_WAIVER = 'NO_WAIVER',
  SUPPLIER = 'SUPPLIER',
}

export enum WalletLedgerTabType {
  ONE_KEY_CASH = 'ONE_KEY_CASH',
  REFUND_CREDITS = 'REFUND_CREDITS',
}

export interface WalletMapInput {
  beneficiaryKey: Scalars['String'];
  walletKey: Scalars['String'];
}

export interface WalletsMapInput {
  beneficiaryKey: Scalars['String'];
  walletKey: Scalars['String'];
}

export enum WidgetCardType {
  GET_THERE = 'GET_THERE',
  THINGS_TO_DO = 'THINGS_TO_DO',
  VIBES = 'VIBES',
  WEATHER = 'WEATHER',
}

export enum WishlistPageType {
  DISCOVER = 'DISCOVER',
  EXPANDED_WISHLIST = 'EXPANDED_WISHLIST',
  TRIPS = 'TRIPS',
}

export enum WizardMode {
  CREATE = 'CREATE',
  EDIT = 'EDIT',
}

export enum WizardStep {
  AD = 'AD',
  AD_GROUP = 'AD_GROUP',
  CAMPAIGN = 'CAMPAIGN',
  REVIEW = 'REVIEW',
}

/** Ad group wizard targeting input */
export interface WizardTargetingInput {
  /** wizard targeting criteria */
  targetingCriteria: Scalars['String'];
  /** wizard targeting operator */
  targetingOperator?: InputMaybe<Scalars['String']>;
  /** wizard targeting value */
  targetingValue: Scalars['String'];
}

export interface supplyReviewsContext {
  filters?: InputMaybe<Array<supplyReviewsFilterInput>>;
  page: Scalars['Int'];
}

export interface supplyReviewsDatesRange {
  endDate: Scalars['String'];
  startDate: Scalars['String'];
}

export interface supplyReviewsFilterInput {
  key: Scalars['String'];
  value: Array<Scalars['String']>;
}

export interface supplyReviewsManagementReplyInput {
  name: Scalars['String'];
  response: Scalars['String'];
}

type EGDSButton_EGDSOverlayButton_Fragment = {
  __typename: 'EGDSOverlayButton';
  primary?: string | null;
  action?: {
    __typename: 'UILinkAction';
    accessibility?: string | null;
    resource:
      | { __typename: 'BasicURI'; value: string }
      | { __typename: 'ClipboardURI'; value: string }
      | { __typename: 'FBMessengerURI'; value: string }
      | { __typename: 'GenericURI'; value: string }
      | { __typename: 'GeoURI'; value: string }
      | { __typename: 'HttpURI'; value: string }
      | { __typename: 'MailToURI'; value: string }
      | { __typename: 'MobileAppURI'; value: string }
      | { __typename: 'RelativeURI'; value: string }
      | { __typename: 'SMSToURI'; value: string }
      | { __typename: 'SelfReferencedURI'; value: string }
      | { __typename: 'TelURI'; value: string }
      | { __typename: 'Uri'; value: string }
      | { __typename: 'WhatsappURI'; value: string };
    analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
  } | null;
};

type EGDSButton_EGDSSearchFormButton_Fragment = {
  __typename: 'EGDSSearchFormButton';
  primary?: string | null;
  action?:
    | {
        __typename: 'ActivityAddOfferToTripAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ActivityCloseDialogAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ActivityMultiItemTripUpdateAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ActivityOpenDialogAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ActivityOpenOffersModalAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ActivityPaginationAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ActivityRemoveOffersFromTripAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ActivityUpdateOfferInTripAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'AgencyQuoteAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'AirCreditWebAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'BannerPlacementServiceUILinkAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'CouponAndCreditAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'CouponAndCreditChatbotAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'CouponsAndCreditsSimpleAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'CrossSellButtonAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'CrossSellLinkAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'CruiseAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'DirectFeedbackOpenFormAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'DirectFeedbackOpenNextPageAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'DirectFeedbackOpenPreviousPageAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'DirectFeedbackSubmitFormAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'EGDSOpenDatePickerAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'EGDSOpenTravelerSelectorAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'EGDSSubmitSearchFormAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'FlightsCreditSelectorOpenUIAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'FlightsDialogCloseUIAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'FlightsDialogTriggerUIAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'MemberWalletBadge';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'MemberWalletUIAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'MishopDetailsUIAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'MultiItemCrossSellUIButtonAction';
        accessibility: string;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'MultiItemCrossSellUICheckoutButtonAction';
        accessibility: string;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'MultiItemCrossSellUILinkAction';
        accessibility: string;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'OpenTypeaheadAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'PaymentDialogButtonAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'PriceInsightsCardDisclaimerToolTipAction';
        accessibility: string;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'PriceInsightsExistingDialogButtonAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'PriceInsightsRetryTrackingDialogButtonAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileAccountFormSubmitAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileAddMembershipAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileAddPassportAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileFormSubmitAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileLinkAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileReloadAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileRewardProgramFormAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileUpdateMembershipAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileUpdatePassportAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'QuoteAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ShoppingSortAndFilterAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'SupplyNavigationHeaderSearchTrigger';
        accessibility: string;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'TripsRetryOperationAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'UIFlightAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'UILinkAction';
        accessibility?: string | null;
        resource:
          | { __typename: 'BasicURI'; value: string }
          | { __typename: 'ClipboardURI'; value: string }
          | { __typename: 'FBMessengerURI'; value: string }
          | { __typename: 'GenericURI'; value: string }
          | { __typename: 'GeoURI'; value: string }
          | { __typename: 'HttpURI'; value: string }
          | { __typename: 'MailToURI'; value: string }
          | { __typename: 'MobileAppURI'; value: string }
          | { __typename: 'RelativeURI'; value: string }
          | { __typename: 'SMSToURI'; value: string }
          | { __typename: 'SelfReferencedURI'; value: string }
          | { __typename: 'TelURI'; value: string }
          | { __typename: 'Uri'; value: string }
          | { __typename: 'WhatsappURI'; value: string };
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'WizardAdditionalUserInputRequiredAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'WizardSubmitAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | null;
};

type EGDSButton_FlightsActionButton_Fragment = {
  __typename: 'FlightsActionButton';
  primary?: string | null;
  action?:
    | {
        __typename: 'ActivityAddOfferToTripAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ActivityCloseDialogAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ActivityMultiItemTripUpdateAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ActivityOpenDialogAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ActivityOpenOffersModalAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ActivityPaginationAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ActivityRemoveOffersFromTripAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ActivityUpdateOfferInTripAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'AgencyQuoteAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'AirCreditWebAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'BannerPlacementServiceUILinkAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'CouponAndCreditAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'CouponAndCreditChatbotAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'CouponsAndCreditsSimpleAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'CrossSellButtonAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'CrossSellLinkAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'CruiseAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'DirectFeedbackOpenFormAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'DirectFeedbackOpenNextPageAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'DirectFeedbackOpenPreviousPageAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'DirectFeedbackSubmitFormAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'EGDSOpenDatePickerAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'EGDSOpenTravelerSelectorAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'EGDSSubmitSearchFormAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'FlightsCreditSelectorOpenUIAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'FlightsDialogCloseUIAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'FlightsDialogTriggerUIAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'MemberWalletBadge';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'MemberWalletUIAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'MishopDetailsUIAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'MultiItemCrossSellUIButtonAction';
        accessibility: string;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'MultiItemCrossSellUICheckoutButtonAction';
        accessibility: string;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'MultiItemCrossSellUILinkAction';
        accessibility: string;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'OpenTypeaheadAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'PaymentDialogButtonAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'PriceInsightsCardDisclaimerToolTipAction';
        accessibility: string;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'PriceInsightsExistingDialogButtonAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'PriceInsightsRetryTrackingDialogButtonAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileAccountFormSubmitAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileAddMembershipAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileAddPassportAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileFormSubmitAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileLinkAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileReloadAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileRewardProgramFormAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileUpdateMembershipAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileUpdatePassportAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'QuoteAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ShoppingSortAndFilterAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'SupplyNavigationHeaderSearchTrigger';
        accessibility: string;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'TripsRetryOperationAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'UIFlightAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'UILinkAction';
        accessibility?: string | null;
        resource:
          | { __typename: 'BasicURI'; value: string }
          | { __typename: 'ClipboardURI'; value: string }
          | { __typename: 'FBMessengerURI'; value: string }
          | { __typename: 'GenericURI'; value: string }
          | { __typename: 'GeoURI'; value: string }
          | { __typename: 'HttpURI'; value: string }
          | { __typename: 'MailToURI'; value: string }
          | { __typename: 'MobileAppURI'; value: string }
          | { __typename: 'RelativeURI'; value: string }
          | { __typename: 'SMSToURI'; value: string }
          | { __typename: 'SelfReferencedURI'; value: string }
          | { __typename: 'TelURI'; value: string }
          | { __typename: 'Uri'; value: string }
          | { __typename: 'WhatsappURI'; value: string };
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'WizardAdditionalUserInputRequiredAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'WizardSubmitAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | null;
};

type EGDSButton_FlightsDialogTrigger_Fragment = {
  __typename: 'FlightsDialogTrigger';
  primary?: string | null;
  action?:
    | {
        __typename: 'ActivityAddOfferToTripAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ActivityCloseDialogAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ActivityMultiItemTripUpdateAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ActivityOpenDialogAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ActivityOpenOffersModalAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ActivityPaginationAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ActivityRemoveOffersFromTripAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ActivityUpdateOfferInTripAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'AgencyQuoteAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'AirCreditWebAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'BannerPlacementServiceUILinkAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'CouponAndCreditAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'CouponAndCreditChatbotAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'CouponsAndCreditsSimpleAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'CrossSellButtonAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'CrossSellLinkAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'CruiseAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'DirectFeedbackOpenFormAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'DirectFeedbackOpenNextPageAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'DirectFeedbackOpenPreviousPageAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'DirectFeedbackSubmitFormAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'EGDSOpenDatePickerAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'EGDSOpenTravelerSelectorAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'EGDSSubmitSearchFormAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'FlightsCreditSelectorOpenUIAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'FlightsDialogCloseUIAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'FlightsDialogTriggerUIAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'MemberWalletBadge';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'MemberWalletUIAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'MishopDetailsUIAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'MultiItemCrossSellUIButtonAction';
        accessibility: string;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'MultiItemCrossSellUICheckoutButtonAction';
        accessibility: string;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'MultiItemCrossSellUILinkAction';
        accessibility: string;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'OpenTypeaheadAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'PaymentDialogButtonAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'PriceInsightsCardDisclaimerToolTipAction';
        accessibility: string;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'PriceInsightsExistingDialogButtonAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'PriceInsightsRetryTrackingDialogButtonAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileAccountFormSubmitAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileAddMembershipAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileAddPassportAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileFormSubmitAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileLinkAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileReloadAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileRewardProgramFormAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileUpdateMembershipAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileUpdatePassportAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'QuoteAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ShoppingSortAndFilterAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'SupplyNavigationHeaderSearchTrigger';
        accessibility: string;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'TripsRetryOperationAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'UIFlightAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'UILinkAction';
        accessibility?: string | null;
        resource:
          | { __typename: 'BasicURI'; value: string }
          | { __typename: 'ClipboardURI'; value: string }
          | { __typename: 'FBMessengerURI'; value: string }
          | { __typename: 'GenericURI'; value: string }
          | { __typename: 'GeoURI'; value: string }
          | { __typename: 'HttpURI'; value: string }
          | { __typename: 'MailToURI'; value: string }
          | { __typename: 'MobileAppURI'; value: string }
          | { __typename: 'RelativeURI'; value: string }
          | { __typename: 'SMSToURI'; value: string }
          | { __typename: 'SelfReferencedURI'; value: string }
          | { __typename: 'TelURI'; value: string }
          | { __typename: 'Uri'; value: string }
          | { __typename: 'WhatsappURI'; value: string };
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'WizardAdditionalUserInputRequiredAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'WizardSubmitAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | null;
};

type EGDSButton_FlightsExperienceActionButton_Fragment = {
  __typename: 'FlightsExperienceActionButton';
  primary?: string | null;
  action?:
    | {
        __typename: 'ActivityAddOfferToTripAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ActivityCloseDialogAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ActivityMultiItemTripUpdateAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ActivityOpenDialogAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ActivityOpenOffersModalAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ActivityPaginationAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ActivityRemoveOffersFromTripAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ActivityUpdateOfferInTripAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'AgencyQuoteAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'AirCreditWebAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'BannerPlacementServiceUILinkAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'CouponAndCreditAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'CouponAndCreditChatbotAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'CouponsAndCreditsSimpleAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'CrossSellButtonAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'CrossSellLinkAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'CruiseAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'DirectFeedbackOpenFormAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'DirectFeedbackOpenNextPageAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'DirectFeedbackOpenPreviousPageAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'DirectFeedbackSubmitFormAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'EGDSOpenDatePickerAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'EGDSOpenTravelerSelectorAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'EGDSSubmitSearchFormAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'FlightsCreditSelectorOpenUIAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'FlightsDialogCloseUIAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'FlightsDialogTriggerUIAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'MemberWalletBadge';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'MemberWalletUIAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'MishopDetailsUIAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'MultiItemCrossSellUIButtonAction';
        accessibility: string;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'MultiItemCrossSellUICheckoutButtonAction';
        accessibility: string;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'MultiItemCrossSellUILinkAction';
        accessibility: string;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'OpenTypeaheadAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'PaymentDialogButtonAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'PriceInsightsCardDisclaimerToolTipAction';
        accessibility: string;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'PriceInsightsExistingDialogButtonAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'PriceInsightsRetryTrackingDialogButtonAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileAccountFormSubmitAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileAddMembershipAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileAddPassportAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileFormSubmitAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileLinkAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileReloadAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileRewardProgramFormAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileUpdateMembershipAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileUpdatePassportAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'QuoteAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ShoppingSortAndFilterAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'SupplyNavigationHeaderSearchTrigger';
        accessibility: string;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'TripsRetryOperationAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'UIFlightAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'UILinkAction';
        accessibility?: string | null;
        resource:
          | { __typename: 'BasicURI'; value: string }
          | { __typename: 'ClipboardURI'; value: string }
          | { __typename: 'FBMessengerURI'; value: string }
          | { __typename: 'GenericURI'; value: string }
          | { __typename: 'GeoURI'; value: string }
          | { __typename: 'HttpURI'; value: string }
          | { __typename: 'MailToURI'; value: string }
          | { __typename: 'MobileAppURI'; value: string }
          | { __typename: 'RelativeURI'; value: string }
          | { __typename: 'SMSToURI'; value: string }
          | { __typename: 'SelfReferencedURI'; value: string }
          | { __typename: 'TelURI'; value: string }
          | { __typename: 'Uri'; value: string }
          | { __typename: 'WhatsappURI'; value: string };
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'WizardAdditionalUserInputRequiredAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'WizardSubmitAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | null;
};

type EGDSButton_InsurTechExperienceDialogTrigger_Fragment = {
  __typename: 'InsurTechExperienceDialogTrigger';
  primary?: string | null;
  action?:
    | {
        __typename: 'ActivityAddOfferToTripAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ActivityCloseDialogAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ActivityMultiItemTripUpdateAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ActivityOpenDialogAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ActivityOpenOffersModalAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ActivityPaginationAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ActivityRemoveOffersFromTripAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ActivityUpdateOfferInTripAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'AgencyQuoteAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'AirCreditWebAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'BannerPlacementServiceUILinkAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'CouponAndCreditAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'CouponAndCreditChatbotAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'CouponsAndCreditsSimpleAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'CrossSellButtonAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'CrossSellLinkAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'CruiseAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'DirectFeedbackOpenFormAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'DirectFeedbackOpenNextPageAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'DirectFeedbackOpenPreviousPageAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'DirectFeedbackSubmitFormAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'EGDSOpenDatePickerAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'EGDSOpenTravelerSelectorAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'EGDSSubmitSearchFormAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'FlightsCreditSelectorOpenUIAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'FlightsDialogCloseUIAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'FlightsDialogTriggerUIAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'MemberWalletBadge';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'MemberWalletUIAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'MishopDetailsUIAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'MultiItemCrossSellUIButtonAction';
        accessibility: string;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'MultiItemCrossSellUICheckoutButtonAction';
        accessibility: string;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'MultiItemCrossSellUILinkAction';
        accessibility: string;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'OpenTypeaheadAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'PaymentDialogButtonAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'PriceInsightsCardDisclaimerToolTipAction';
        accessibility: string;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'PriceInsightsExistingDialogButtonAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'PriceInsightsRetryTrackingDialogButtonAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileAccountFormSubmitAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileAddMembershipAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileAddPassportAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileFormSubmitAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileLinkAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileReloadAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileRewardProgramFormAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileUpdateMembershipAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileUpdatePassportAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'QuoteAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ShoppingSortAndFilterAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'SupplyNavigationHeaderSearchTrigger';
        accessibility: string;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'TripsRetryOperationAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'UIFlightAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'UILinkAction';
        accessibility?: string | null;
        resource:
          | { __typename: 'BasicURI'; value: string }
          | { __typename: 'ClipboardURI'; value: string }
          | { __typename: 'FBMessengerURI'; value: string }
          | { __typename: 'GenericURI'; value: string }
          | { __typename: 'GeoURI'; value: string }
          | { __typename: 'HttpURI'; value: string }
          | { __typename: 'MailToURI'; value: string }
          | { __typename: 'MobileAppURI'; value: string }
          | { __typename: 'RelativeURI'; value: string }
          | { __typename: 'SMSToURI'; value: string }
          | { __typename: 'SelfReferencedURI'; value: string }
          | { __typename: 'TelURI'; value: string }
          | { __typename: 'Uri'; value: string }
          | { __typename: 'WhatsappURI'; value: string };
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'WizardAdditionalUserInputRequiredAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'WizardSubmitAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | null;
};

type EGDSButton_PackageUIActionDialogFooterButton_Fragment = {
  __typename: 'PackageUIActionDialogFooterButton';
  primary?: string | null;
  action?:
    | {
        __typename: 'ActivityAddOfferToTripAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ActivityCloseDialogAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ActivityMultiItemTripUpdateAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ActivityOpenDialogAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ActivityOpenOffersModalAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ActivityPaginationAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ActivityRemoveOffersFromTripAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ActivityUpdateOfferInTripAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'AgencyQuoteAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'AirCreditWebAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'BannerPlacementServiceUILinkAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'CouponAndCreditAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'CouponAndCreditChatbotAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'CouponsAndCreditsSimpleAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'CrossSellButtonAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'CrossSellLinkAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'CruiseAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'DirectFeedbackOpenFormAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'DirectFeedbackOpenNextPageAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'DirectFeedbackOpenPreviousPageAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'DirectFeedbackSubmitFormAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'EGDSOpenDatePickerAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'EGDSOpenTravelerSelectorAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'EGDSSubmitSearchFormAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'FlightsCreditSelectorOpenUIAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'FlightsDialogCloseUIAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'FlightsDialogTriggerUIAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'MemberWalletBadge';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'MemberWalletUIAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'MishopDetailsUIAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'MultiItemCrossSellUIButtonAction';
        accessibility: string;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'MultiItemCrossSellUICheckoutButtonAction';
        accessibility: string;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'MultiItemCrossSellUILinkAction';
        accessibility: string;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'OpenTypeaheadAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'PaymentDialogButtonAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'PriceInsightsCardDisclaimerToolTipAction';
        accessibility: string;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'PriceInsightsExistingDialogButtonAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'PriceInsightsRetryTrackingDialogButtonAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileAccountFormSubmitAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileAddMembershipAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileAddPassportAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileFormSubmitAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileLinkAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileReloadAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileRewardProgramFormAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileUpdateMembershipAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileUpdatePassportAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'QuoteAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ShoppingSortAndFilterAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'SupplyNavigationHeaderSearchTrigger';
        accessibility: string;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'TripsRetryOperationAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'UIFlightAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'UILinkAction';
        accessibility?: string | null;
        resource:
          | { __typename: 'BasicURI'; value: string }
          | { __typename: 'ClipboardURI'; value: string }
          | { __typename: 'FBMessengerURI'; value: string }
          | { __typename: 'GenericURI'; value: string }
          | { __typename: 'GeoURI'; value: string }
          | { __typename: 'HttpURI'; value: string }
          | { __typename: 'MailToURI'; value: string }
          | { __typename: 'MobileAppURI'; value: string }
          | { __typename: 'RelativeURI'; value: string }
          | { __typename: 'SMSToURI'; value: string }
          | { __typename: 'SelfReferencedURI'; value: string }
          | { __typename: 'TelURI'; value: string }
          | { __typename: 'Uri'; value: string }
          | { __typename: 'WhatsappURI'; value: string };
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'WizardAdditionalUserInputRequiredAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'WizardSubmitAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | null;
};

type EGDSButton_PackageUIHideSearchFormAction_Fragment = {
  __typename: 'PackageUIHideSearchFormAction';
  primary?: string | null;
  action?:
    | {
        __typename: 'ActivityAddOfferToTripAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ActivityCloseDialogAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ActivityMultiItemTripUpdateAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ActivityOpenDialogAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ActivityOpenOffersModalAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ActivityPaginationAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ActivityRemoveOffersFromTripAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ActivityUpdateOfferInTripAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'AgencyQuoteAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'AirCreditWebAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'BannerPlacementServiceUILinkAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'CouponAndCreditAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'CouponAndCreditChatbotAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'CouponsAndCreditsSimpleAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'CrossSellButtonAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'CrossSellLinkAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'CruiseAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'DirectFeedbackOpenFormAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'DirectFeedbackOpenNextPageAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'DirectFeedbackOpenPreviousPageAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'DirectFeedbackSubmitFormAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'EGDSOpenDatePickerAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'EGDSOpenTravelerSelectorAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'EGDSSubmitSearchFormAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'FlightsCreditSelectorOpenUIAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'FlightsDialogCloseUIAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'FlightsDialogTriggerUIAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'MemberWalletBadge';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'MemberWalletUIAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'MishopDetailsUIAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'MultiItemCrossSellUIButtonAction';
        accessibility: string;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'MultiItemCrossSellUICheckoutButtonAction';
        accessibility: string;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'MultiItemCrossSellUILinkAction';
        accessibility: string;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'OpenTypeaheadAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'PaymentDialogButtonAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'PriceInsightsCardDisclaimerToolTipAction';
        accessibility: string;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'PriceInsightsExistingDialogButtonAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'PriceInsightsRetryTrackingDialogButtonAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileAccountFormSubmitAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileAddMembershipAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileAddPassportAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileFormSubmitAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileLinkAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileReloadAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileRewardProgramFormAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileUpdateMembershipAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileUpdatePassportAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'QuoteAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ShoppingSortAndFilterAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'SupplyNavigationHeaderSearchTrigger';
        accessibility: string;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'TripsRetryOperationAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'UIFlightAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'UILinkAction';
        accessibility?: string | null;
        resource:
          | { __typename: 'BasicURI'; value: string }
          | { __typename: 'ClipboardURI'; value: string }
          | { __typename: 'FBMessengerURI'; value: string }
          | { __typename: 'GenericURI'; value: string }
          | { __typename: 'GeoURI'; value: string }
          | { __typename: 'HttpURI'; value: string }
          | { __typename: 'MailToURI'; value: string }
          | { __typename: 'MobileAppURI'; value: string }
          | { __typename: 'RelativeURI'; value: string }
          | { __typename: 'SMSToURI'; value: string }
          | { __typename: 'SelfReferencedURI'; value: string }
          | { __typename: 'TelURI'; value: string }
          | { __typename: 'Uri'; value: string }
          | { __typename: 'WhatsappURI'; value: string };
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'WizardAdditionalUserInputRequiredAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'WizardSubmitAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | null;
};

type EGDSButton_PackageUITravelGuideButton_Fragment = {
  __typename: 'PackageUITravelGuideButton';
  primary?: string | null;
  action?:
    | {
        __typename: 'ActivityAddOfferToTripAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ActivityCloseDialogAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ActivityMultiItemTripUpdateAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ActivityOpenDialogAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ActivityOpenOffersModalAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ActivityPaginationAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ActivityRemoveOffersFromTripAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ActivityUpdateOfferInTripAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'AgencyQuoteAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'AirCreditWebAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'BannerPlacementServiceUILinkAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'CouponAndCreditAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'CouponAndCreditChatbotAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'CouponsAndCreditsSimpleAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'CrossSellButtonAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'CrossSellLinkAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'CruiseAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'DirectFeedbackOpenFormAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'DirectFeedbackOpenNextPageAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'DirectFeedbackOpenPreviousPageAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'DirectFeedbackSubmitFormAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'EGDSOpenDatePickerAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'EGDSOpenTravelerSelectorAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'EGDSSubmitSearchFormAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'FlightsCreditSelectorOpenUIAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'FlightsDialogCloseUIAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'FlightsDialogTriggerUIAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'MemberWalletBadge';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'MemberWalletUIAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'MishopDetailsUIAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'MultiItemCrossSellUIButtonAction';
        accessibility: string;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'MultiItemCrossSellUICheckoutButtonAction';
        accessibility: string;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'MultiItemCrossSellUILinkAction';
        accessibility: string;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'OpenTypeaheadAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'PaymentDialogButtonAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'PriceInsightsCardDisclaimerToolTipAction';
        accessibility: string;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'PriceInsightsExistingDialogButtonAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'PriceInsightsRetryTrackingDialogButtonAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileAccountFormSubmitAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileAddMembershipAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileAddPassportAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileFormSubmitAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileLinkAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileReloadAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileRewardProgramFormAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileUpdateMembershipAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileUpdatePassportAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'QuoteAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ShoppingSortAndFilterAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'SupplyNavigationHeaderSearchTrigger';
        accessibility: string;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'TripsRetryOperationAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'UIFlightAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'UILinkAction';
        accessibility?: string | null;
        resource:
          | { __typename: 'BasicURI'; value: string }
          | { __typename: 'ClipboardURI'; value: string }
          | { __typename: 'FBMessengerURI'; value: string }
          | { __typename: 'GenericURI'; value: string }
          | { __typename: 'GeoURI'; value: string }
          | { __typename: 'HttpURI'; value: string }
          | { __typename: 'MailToURI'; value: string }
          | { __typename: 'MobileAppURI'; value: string }
          | { __typename: 'RelativeURI'; value: string }
          | { __typename: 'SMSToURI'; value: string }
          | { __typename: 'SelfReferencedURI'; value: string }
          | { __typename: 'TelURI'; value: string }
          | { __typename: 'Uri'; value: string }
          | { __typename: 'WhatsappURI'; value: string };
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'WizardAdditionalUserInputRequiredAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'WizardSubmitAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | null;
};

type EGDSButton_SupplyCancelWaiverActionButton_Fragment = {
  __typename: 'SupplyCancelWaiverActionButton';
  primary: string;
  action?: {
    __typename: 'UILinkAction';
    accessibility?: string | null;
    resource:
      | { __typename: 'BasicURI'; value: string }
      | { __typename: 'ClipboardURI'; value: string }
      | { __typename: 'FBMessengerURI'; value: string }
      | { __typename: 'GenericURI'; value: string }
      | { __typename: 'GeoURI'; value: string }
      | { __typename: 'HttpURI'; value: string }
      | { __typename: 'MailToURI'; value: string }
      | { __typename: 'MobileAppURI'; value: string }
      | { __typename: 'RelativeURI'; value: string }
      | { __typename: 'SMSToURI'; value: string }
      | { __typename: 'SelfReferencedURI'; value: string }
      | { __typename: 'TelURI'; value: string }
      | { __typename: 'Uri'; value: string }
      | { __typename: 'WhatsappURI'; value: string };
    analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
  } | null;
};

type EGDSButton_SupplyContentLinkStyleButton_Fragment = {
  __typename: 'SupplyContentLinkStyleButton';
  primary?: string | null;
  action?: {
    __typename: 'UILinkAction';
    accessibility?: string | null;
    resource:
      | { __typename: 'BasicURI'; value: string }
      | { __typename: 'ClipboardURI'; value: string }
      | { __typename: 'FBMessengerURI'; value: string }
      | { __typename: 'GenericURI'; value: string }
      | { __typename: 'GeoURI'; value: string }
      | { __typename: 'HttpURI'; value: string }
      | { __typename: 'MailToURI'; value: string }
      | { __typename: 'MobileAppURI'; value: string }
      | { __typename: 'RelativeURI'; value: string }
      | { __typename: 'SMSToURI'; value: string }
      | { __typename: 'SelfReferencedURI'; value: string }
      | { __typename: 'TelURI'; value: string }
      | { __typename: 'Uri'; value: string }
      | { __typename: 'WhatsappURI'; value: string };
    analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
  } | null;
};

type EGDSButton_UIPrimaryButton_Fragment = {
  __typename: 'UIPrimaryButton';
  primary?: string | null;
  action?:
    | {
        __typename: 'ActivityAddOfferToTripAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ActivityCloseDialogAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ActivityMultiItemTripUpdateAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ActivityOpenDialogAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ActivityOpenOffersModalAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ActivityPaginationAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ActivityRemoveOffersFromTripAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ActivityUpdateOfferInTripAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'AgencyQuoteAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'AirCreditWebAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'BannerPlacementServiceUILinkAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'CouponAndCreditAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'CouponAndCreditChatbotAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'CouponsAndCreditsSimpleAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'CrossSellButtonAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'CrossSellLinkAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'CruiseAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'DirectFeedbackOpenFormAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'DirectFeedbackOpenNextPageAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'DirectFeedbackOpenPreviousPageAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'DirectFeedbackSubmitFormAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'EGDSOpenDatePickerAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'EGDSOpenTravelerSelectorAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'EGDSSubmitSearchFormAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'FlightsCreditSelectorOpenUIAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'FlightsDialogCloseUIAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'FlightsDialogTriggerUIAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'MemberWalletBadge';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'MemberWalletUIAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'MishopDetailsUIAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'MultiItemCrossSellUIButtonAction';
        accessibility: string;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'MultiItemCrossSellUICheckoutButtonAction';
        accessibility: string;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'MultiItemCrossSellUILinkAction';
        accessibility: string;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'OpenTypeaheadAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'PaymentDialogButtonAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'PriceInsightsCardDisclaimerToolTipAction';
        accessibility: string;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'PriceInsightsExistingDialogButtonAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'PriceInsightsRetryTrackingDialogButtonAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileAccountFormSubmitAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileAddMembershipAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileAddPassportAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileFormSubmitAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileLinkAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileReloadAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileRewardProgramFormAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileUpdateMembershipAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileUpdatePassportAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'QuoteAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ShoppingSortAndFilterAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'SupplyNavigationHeaderSearchTrigger';
        accessibility: string;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'TripsRetryOperationAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'UIFlightAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'UILinkAction';
        accessibility?: string | null;
        resource:
          | { __typename: 'BasicURI'; value: string }
          | { __typename: 'ClipboardURI'; value: string }
          | { __typename: 'FBMessengerURI'; value: string }
          | { __typename: 'GenericURI'; value: string }
          | { __typename: 'GeoURI'; value: string }
          | { __typename: 'HttpURI'; value: string }
          | { __typename: 'MailToURI'; value: string }
          | { __typename: 'MobileAppURI'; value: string }
          | { __typename: 'RelativeURI'; value: string }
          | { __typename: 'SMSToURI'; value: string }
          | { __typename: 'SelfReferencedURI'; value: string }
          | { __typename: 'TelURI'; value: string }
          | { __typename: 'Uri'; value: string }
          | { __typename: 'WhatsappURI'; value: string };
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'WizardAdditionalUserInputRequiredAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'WizardSubmitAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | null;
};

type EGDSButton_UISecondaryButton_Fragment = {
  __typename: 'UISecondaryButton';
  primary?: string | null;
  action?:
    | {
        __typename: 'ActivityAddOfferToTripAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ActivityCloseDialogAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ActivityMultiItemTripUpdateAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ActivityOpenDialogAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ActivityOpenOffersModalAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ActivityPaginationAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ActivityRemoveOffersFromTripAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ActivityUpdateOfferInTripAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'AgencyQuoteAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'AirCreditWebAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'BannerPlacementServiceUILinkAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'CouponAndCreditAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'CouponAndCreditChatbotAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'CouponsAndCreditsSimpleAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'CrossSellButtonAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'CrossSellLinkAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'CruiseAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'DirectFeedbackOpenFormAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'DirectFeedbackOpenNextPageAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'DirectFeedbackOpenPreviousPageAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'DirectFeedbackSubmitFormAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'EGDSOpenDatePickerAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'EGDSOpenTravelerSelectorAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'EGDSSubmitSearchFormAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'FlightsCreditSelectorOpenUIAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'FlightsDialogCloseUIAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'FlightsDialogTriggerUIAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'MemberWalletBadge';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'MemberWalletUIAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'MishopDetailsUIAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'MultiItemCrossSellUIButtonAction';
        accessibility: string;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'MultiItemCrossSellUICheckoutButtonAction';
        accessibility: string;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'MultiItemCrossSellUILinkAction';
        accessibility: string;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'OpenTypeaheadAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'PaymentDialogButtonAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'PriceInsightsCardDisclaimerToolTipAction';
        accessibility: string;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'PriceInsightsExistingDialogButtonAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'PriceInsightsRetryTrackingDialogButtonAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileAccountFormSubmitAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileAddMembershipAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileAddPassportAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileFormSubmitAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileLinkAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileReloadAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileRewardProgramFormAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileUpdateMembershipAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileUpdatePassportAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'QuoteAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ShoppingSortAndFilterAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'SupplyNavigationHeaderSearchTrigger';
        accessibility: string;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'TripsRetryOperationAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'UIFlightAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'UILinkAction';
        accessibility?: string | null;
        resource:
          | { __typename: 'BasicURI'; value: string }
          | { __typename: 'ClipboardURI'; value: string }
          | { __typename: 'FBMessengerURI'; value: string }
          | { __typename: 'GenericURI'; value: string }
          | { __typename: 'GeoURI'; value: string }
          | { __typename: 'HttpURI'; value: string }
          | { __typename: 'MailToURI'; value: string }
          | { __typename: 'MobileAppURI'; value: string }
          | { __typename: 'RelativeURI'; value: string }
          | { __typename: 'SMSToURI'; value: string }
          | { __typename: 'SelfReferencedURI'; value: string }
          | { __typename: 'TelURI'; value: string }
          | { __typename: 'Uri'; value: string }
          | { __typename: 'WhatsappURI'; value: string };
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'WizardAdditionalUserInputRequiredAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'WizardSubmitAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | null;
};

type EGDSButton_UITertiaryButton_Fragment = {
  __typename: 'UITertiaryButton';
  primary?: string | null;
  action?:
    | {
        __typename: 'ActivityAddOfferToTripAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ActivityCloseDialogAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ActivityMultiItemTripUpdateAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ActivityOpenDialogAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ActivityOpenOffersModalAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ActivityPaginationAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ActivityRemoveOffersFromTripAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ActivityUpdateOfferInTripAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'AgencyQuoteAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'AirCreditWebAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'BannerPlacementServiceUILinkAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'CouponAndCreditAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'CouponAndCreditChatbotAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'CouponsAndCreditsSimpleAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'CrossSellButtonAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'CrossSellLinkAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'CruiseAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'DirectFeedbackOpenFormAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'DirectFeedbackOpenNextPageAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'DirectFeedbackOpenPreviousPageAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'DirectFeedbackSubmitFormAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'EGDSOpenDatePickerAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'EGDSOpenTravelerSelectorAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'EGDSSubmitSearchFormAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'FlightsCreditSelectorOpenUIAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'FlightsDialogCloseUIAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'FlightsDialogTriggerUIAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'MemberWalletBadge';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'MemberWalletUIAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'MishopDetailsUIAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'MultiItemCrossSellUIButtonAction';
        accessibility: string;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'MultiItemCrossSellUICheckoutButtonAction';
        accessibility: string;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'MultiItemCrossSellUILinkAction';
        accessibility: string;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'OpenTypeaheadAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'PaymentDialogButtonAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'PriceInsightsCardDisclaimerToolTipAction';
        accessibility: string;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'PriceInsightsExistingDialogButtonAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'PriceInsightsRetryTrackingDialogButtonAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileAccountFormSubmitAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileAddMembershipAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileAddPassportAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileFormSubmitAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileLinkAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileReloadAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileRewardProgramFormAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileUpdateMembershipAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ProfileUpdatePassportAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'QuoteAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'ShoppingSortAndFilterAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'SupplyNavigationHeaderSearchTrigger';
        accessibility: string;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'TripsRetryOperationAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'UIFlightAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'UILinkAction';
        accessibility?: string | null;
        resource:
          | { __typename: 'BasicURI'; value: string }
          | { __typename: 'ClipboardURI'; value: string }
          | { __typename: 'FBMessengerURI'; value: string }
          | { __typename: 'GenericURI'; value: string }
          | { __typename: 'GeoURI'; value: string }
          | { __typename: 'HttpURI'; value: string }
          | { __typename: 'MailToURI'; value: string }
          | { __typename: 'MobileAppURI'; value: string }
          | { __typename: 'RelativeURI'; value: string }
          | { __typename: 'SMSToURI'; value: string }
          | { __typename: 'SelfReferencedURI'; value: string }
          | { __typename: 'TelURI'; value: string }
          | { __typename: 'Uri'; value: string }
          | { __typename: 'WhatsappURI'; value: string };
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'WizardAdditionalUserInputRequiredAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | {
        __typename: 'WizardSubmitAction';
        accessibility?: string | null;
        analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
      }
    | null;
};

export type EGDSButtonFragment =
  | EGDSButton_EGDSOverlayButton_Fragment
  | EGDSButton_EGDSSearchFormButton_Fragment
  | EGDSButton_FlightsActionButton_Fragment
  | EGDSButton_FlightsDialogTrigger_Fragment
  | EGDSButton_FlightsExperienceActionButton_Fragment
  | EGDSButton_InsurTechExperienceDialogTrigger_Fragment
  | EGDSButton_PackageUIActionDialogFooterButton_Fragment
  | EGDSButton_PackageUIHideSearchFormAction_Fragment
  | EGDSButton_PackageUITravelGuideButton_Fragment
  | EGDSButton_SupplyCancelWaiverActionButton_Fragment
  | EGDSButton_SupplyContentLinkStyleButton_Fragment
  | EGDSButton_UIPrimaryButton_Fragment
  | EGDSButton_UISecondaryButton_Fragment
  | EGDSButton_UITertiaryButton_Fragment;

export type EGDSIllustrationFragment = { __typename: 'Illustration'; url: any; description: string; id: string };

export type IntentConfigFieldsFragment = {
  __typename: 'HelpCenterPersonalizationData';
  intentButtonsHeading: string;
  intentButtons?: Array<{
    __typename: 'HelpCenterIntentButtons';
    skillName: string;
    name: {
      __typename: 'UIPrimaryButton';
      primary?: string | null;
      icon?: { __typename: 'Icon'; id: string; token: string; description: string } | null;
    };
  }> | null;
};

export type SignInCTAFieldsFragment = {
  __typename: 'SignInCTA';
  heading: string;
  illustration: { __typename: 'Illustration'; url: any; description: string; id: string };
  signInButton: {
    __typename: 'UIPrimaryButton';
    primary?: string | null;
    action?:
      | {
          __typename: 'ActivityAddOfferToTripAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'ActivityCloseDialogAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'ActivityMultiItemTripUpdateAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'ActivityOpenDialogAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'ActivityOpenOffersModalAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'ActivityPaginationAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'ActivityRemoveOffersFromTripAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'ActivityUpdateOfferInTripAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'AgencyQuoteAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'AirCreditWebAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'BannerPlacementServiceUILinkAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'CouponAndCreditAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'CouponAndCreditChatbotAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'CouponsAndCreditsSimpleAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'CrossSellButtonAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'CrossSellLinkAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'CruiseAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'DirectFeedbackOpenFormAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'DirectFeedbackOpenNextPageAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'DirectFeedbackOpenPreviousPageAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'DirectFeedbackSubmitFormAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'EGDSOpenDatePickerAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'EGDSOpenTravelerSelectorAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'EGDSSubmitSearchFormAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'FlightsCreditSelectorOpenUIAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'FlightsDialogCloseUIAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'FlightsDialogTriggerUIAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'MemberWalletBadge';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'MemberWalletUIAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'MishopDetailsUIAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'MultiItemCrossSellUIButtonAction';
          accessibility: string;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'MultiItemCrossSellUICheckoutButtonAction';
          accessibility: string;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'MultiItemCrossSellUILinkAction';
          accessibility: string;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'OpenTypeaheadAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'PaymentDialogButtonAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'PriceInsightsCardDisclaimerToolTipAction';
          accessibility: string;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'PriceInsightsExistingDialogButtonAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'PriceInsightsRetryTrackingDialogButtonAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'ProfileAccountFormSubmitAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'ProfileAddMembershipAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'ProfileAddPassportAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'ProfileFormSubmitAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'ProfileLinkAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'ProfileReloadAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'ProfileRewardProgramFormAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'ProfileUpdateMembershipAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'ProfileUpdatePassportAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'QuoteAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'ShoppingSortAndFilterAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'SupplyNavigationHeaderSearchTrigger';
          accessibility: string;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'TripsRetryOperationAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'UIFlightAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'UILinkAction';
          accessibility?: string | null;
          resource:
            | { __typename: 'BasicURI'; value: string }
            | { __typename: 'ClipboardURI'; value: string }
            | { __typename: 'FBMessengerURI'; value: string }
            | { __typename: 'GenericURI'; value: string }
            | { __typename: 'GeoURI'; value: string }
            | { __typename: 'HttpURI'; value: string }
            | { __typename: 'MailToURI'; value: string }
            | { __typename: 'MobileAppURI'; value: string }
            | { __typename: 'RelativeURI'; value: string }
            | { __typename: 'SMSToURI'; value: string }
            | { __typename: 'SelfReferencedURI'; value: string }
            | { __typename: 'TelURI'; value: string }
            | { __typename: 'Uri'; value: string }
            | { __typename: 'WhatsappURI'; value: string };
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'WizardAdditionalUserInputRequiredAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'WizardSubmitAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | null;
  };
  dismissButton: {
    __typename: 'UITertiaryButton';
    primary?: string | null;
    action?:
      | {
          __typename: 'ActivityAddOfferToTripAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'ActivityCloseDialogAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'ActivityMultiItemTripUpdateAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'ActivityOpenDialogAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'ActivityOpenOffersModalAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'ActivityPaginationAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'ActivityRemoveOffersFromTripAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'ActivityUpdateOfferInTripAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'AgencyQuoteAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'AirCreditWebAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'BannerPlacementServiceUILinkAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'CouponAndCreditAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'CouponAndCreditChatbotAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'CouponsAndCreditsSimpleAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'CrossSellButtonAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'CrossSellLinkAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'CruiseAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'DirectFeedbackOpenFormAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'DirectFeedbackOpenNextPageAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'DirectFeedbackOpenPreviousPageAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'DirectFeedbackSubmitFormAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'EGDSOpenDatePickerAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'EGDSOpenTravelerSelectorAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'EGDSSubmitSearchFormAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'FlightsCreditSelectorOpenUIAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'FlightsDialogCloseUIAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'FlightsDialogTriggerUIAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'MemberWalletBadge';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'MemberWalletUIAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'MishopDetailsUIAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'MultiItemCrossSellUIButtonAction';
          accessibility: string;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'MultiItemCrossSellUICheckoutButtonAction';
          accessibility: string;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'MultiItemCrossSellUILinkAction';
          accessibility: string;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'OpenTypeaheadAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'PaymentDialogButtonAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'PriceInsightsCardDisclaimerToolTipAction';
          accessibility: string;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'PriceInsightsExistingDialogButtonAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'PriceInsightsRetryTrackingDialogButtonAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'ProfileAccountFormSubmitAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'ProfileAddMembershipAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'ProfileAddPassportAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'ProfileFormSubmitAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'ProfileLinkAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'ProfileReloadAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'ProfileRewardProgramFormAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'ProfileUpdateMembershipAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'ProfileUpdatePassportAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'QuoteAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'ShoppingSortAndFilterAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'SupplyNavigationHeaderSearchTrigger';
          accessibility: string;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'TripsRetryOperationAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'UIFlightAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'UILinkAction';
          accessibility?: string | null;
          resource:
            | { __typename: 'BasicURI'; value: string }
            | { __typename: 'ClipboardURI'; value: string }
            | { __typename: 'FBMessengerURI'; value: string }
            | { __typename: 'GenericURI'; value: string }
            | { __typename: 'GeoURI'; value: string }
            | { __typename: 'HttpURI'; value: string }
            | { __typename: 'MailToURI'; value: string }
            | { __typename: 'MobileAppURI'; value: string }
            | { __typename: 'RelativeURI'; value: string }
            | { __typename: 'SMSToURI'; value: string }
            | { __typename: 'SelfReferencedURI'; value: string }
            | { __typename: 'TelURI'; value: string }
            | { __typename: 'Uri'; value: string }
            | { __typename: 'WhatsappURI'; value: string };
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'WizardAdditionalUserInputRequiredAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | {
          __typename: 'WizardSubmitAction';
          accessibility?: string | null;
          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
        }
      | null;
  };
  signInCTAClickstreamPayload: {
    __typename: 'SignInCTAClickStreamAnalytics';
    event: {
      __typename: 'EGClickstreamEvent';
      eventName: string;
      eventType: string;
      eventCategory: string;
      eventVersion: string;
      actionLocation?: string | null;
    };
    experience: {
      __typename: 'Experience';
      appName: string;
      appVersion: string;
      pageName: string;
      pageNameDetailed: string;
    };
  };
  signInCTACookiePayload: { __typename: 'SignInCTACookiePayload'; cookieName: string; cookieTTL: number };
};

export type TaapAcademyComponentFieldsFragment = {
  __typename: 'TaapAcademyComponent';
  heading: string;
  description: string;
  iconUrl: string;
  academyLink?: {
    __typename: 'EGDSInlineLink';
    text: string;
    action: {
      __typename: 'UILinkAction';
      accessibility?: string | null;
      resource:
        | { __typename: 'BasicURI'; value: string }
        | { __typename: 'ClipboardURI'; value: string }
        | { __typename: 'FBMessengerURI'; value: string }
        | { __typename: 'GenericURI'; value: string }
        | { __typename: 'GeoURI'; value: string }
        | { __typename: 'HttpURI'; value: string }
        | { __typename: 'MailToURI'; value: string }
        | { __typename: 'MobileAppURI'; value: string }
        | { __typename: 'RelativeURI'; value: string }
        | { __typename: 'SMSToURI'; value: string }
        | { __typename: 'SelfReferencedURI'; value: string }
        | { __typename: 'TelURI'; value: string }
        | { __typename: 'Uri'; value: string }
        | { __typename: 'WhatsappURI'; value: string };
    };
  } | null;
};

export type TripInfoDetailFieldsFragment = {
  __typename: 'HelpCenterTripDetailedOverview';
  header?: string | null;
  allTrips?: Array<{
    __typename: 'TripCategory';
    header: string;
    tabTitle: string;
    tripInfos?: Array<{
      __typename: 'HelpCenterTripInfo';
      backToTripButton: string;
      header?: string | null;
      tripName?: string | null;
      timePeriod?: string | null;
      numberOfBooking?: string | null;
      image?: { __typename: 'Image'; description: string; url: any } | null;
      bookingIcons?: Array<{ __typename: 'Icon'; id: string }> | null;
      tripBookings?: Array<
        | {
            __typename: 'BookingDetail';
            timePeriod: string;
            itineraryNumberText?: string | null;
            title: string;
            product: string;
            isDisable: boolean;
            icon: { __typename: 'Icon'; id: string };
            helpCenterIntentButton: {
              __typename: 'HelpCenterIntentButtons';
              skillName: string;
              vaText?: string | null;
              payload?: string | null;
              name: { __typename: 'UIPrimaryButton'; primary?: string | null };
            };
            bookingActions: Array<
              | { __typename: 'HelpCenterBookingActionButton' }
              | {
                  __typename: 'HelpCenterBookingButtons';
                  name: {
                    __typename: 'UISecondaryButton';
                    primary?: string | null;
                    action?:
                      | {
                          __typename: 'ActivityAddOfferToTripAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'ActivityCloseDialogAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'ActivityMultiItemTripUpdateAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'ActivityOpenDialogAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'ActivityOpenOffersModalAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'ActivityPaginationAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'ActivityRemoveOffersFromTripAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'ActivityUpdateOfferInTripAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'AgencyQuoteAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'AirCreditWebAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'BannerPlacementServiceUILinkAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'CouponAndCreditAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'CouponAndCreditChatbotAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'CouponsAndCreditsSimpleAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'CrossSellButtonAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'CrossSellLinkAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'CruiseAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'DirectFeedbackOpenFormAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'DirectFeedbackOpenNextPageAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'DirectFeedbackOpenPreviousPageAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'DirectFeedbackSubmitFormAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'EGDSOpenDatePickerAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'EGDSOpenTravelerSelectorAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'EGDSSubmitSearchFormAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'FlightsCreditSelectorOpenUIAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'FlightsDialogCloseUIAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'FlightsDialogTriggerUIAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'MemberWalletBadge';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'MemberWalletUIAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'MishopDetailsUIAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'MultiItemCrossSellUIButtonAction';
                          accessibility: string;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'MultiItemCrossSellUICheckoutButtonAction';
                          accessibility: string;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'MultiItemCrossSellUILinkAction';
                          accessibility: string;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'OpenTypeaheadAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'PaymentDialogButtonAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'PriceInsightsCardDisclaimerToolTipAction';
                          accessibility: string;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'PriceInsightsExistingDialogButtonAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'PriceInsightsRetryTrackingDialogButtonAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'ProfileAccountFormSubmitAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'ProfileAddMembershipAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'ProfileAddPassportAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'ProfileFormSubmitAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'ProfileLinkAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'ProfileReloadAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'ProfileRewardProgramFormAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'ProfileUpdateMembershipAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'ProfileUpdatePassportAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'QuoteAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'ShoppingSortAndFilterAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'SupplyNavigationHeaderSearchTrigger';
                          accessibility: string;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'TripsRetryOperationAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'UIFlightAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'UILinkAction';
                          accessibility?: string | null;
                          resource:
                            | { __typename: 'BasicURI'; value: string }
                            | { __typename: 'ClipboardURI'; value: string }
                            | { __typename: 'FBMessengerURI'; value: string }
                            | { __typename: 'GenericURI'; value: string }
                            | { __typename: 'GeoURI'; value: string }
                            | { __typename: 'HttpURI'; value: string }
                            | { __typename: 'MailToURI'; value: string }
                            | { __typename: 'MobileAppURI'; value: string }
                            | { __typename: 'RelativeURI'; value: string }
                            | { __typename: 'SMSToURI'; value: string }
                            | { __typename: 'SelfReferencedURI'; value: string }
                            | { __typename: 'TelURI'; value: string }
                            | { __typename: 'Uri'; value: string }
                            | { __typename: 'WhatsappURI'; value: string };
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'WizardAdditionalUserInputRequiredAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'WizardSubmitAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | null;
                  };
                }
              | {
                  __typename: 'HelpCenterIntentButtons';
                  skillName: string;
                  vaText?: string | null;
                  payload?: string | null;
                  name: { __typename: 'UIPrimaryButton'; primary?: string | null };
                  bookingActionsClickStreamAnalytics?: {
                    __typename: 'BookingActionsClickStreamAnalytics';
                    event: {
                      __typename: 'Event';
                      eventName: string;
                      eventType: string;
                      eventCategory?: string | null;
                      eventVersion?: string | null;
                      actionLocation?: string | null;
                      actionReason?: string | null;
                    };
                    tripDetail?: Array<{ __typename: 'ClickStreamTripInfo'; tripDomainId?: string | null }> | null;
                    experience: {
                      __typename: 'Experience';
                      pageName: string;
                      appName: string;
                      appVersion: string;
                      pageNameDetailed: string;
                    };
                    workFlowList?: Array<{
                      __typename: 'WorkFlow';
                      intent: string;
                      orderLineId?: string | null;
                      productLine: string;
                      subIntent?: string | null;
                      automationStatus: string;
                      automationStatusReason: string;
                      channel: string;
                    }> | null;
                  } | null;
                }
              | {
                  __typename: 'HelpCenterLinkButton';
                  name:
                    | {
                        __typename: 'EGDSOverlayButton';
                        primary?: string | null;
                        action?: {
                          __typename: 'UILinkAction';
                          resource:
                            | { __typename: 'BasicURI'; value: string }
                            | { __typename: 'ClipboardURI'; value: string }
                            | { __typename: 'FBMessengerURI'; value: string }
                            | { __typename: 'GenericURI'; value: string }
                            | { __typename: 'GeoURI'; value: string }
                            | { __typename: 'HttpURI'; value: string }
                            | { __typename: 'MailToURI'; value: string }
                            | { __typename: 'MobileAppURI'; value: string }
                            | { __typename: 'RelativeURI'; value: string }
                            | { __typename: 'SMSToURI'; value: string }
                            | { __typename: 'SelfReferencedURI'; value: string }
                            | { __typename: 'TelURI'; value: string }
                            | { __typename: 'Uri'; value: string }
                            | { __typename: 'WhatsappURI'; value: string };
                        } | null;
                      }
                    | {
                        __typename: 'EGDSSearchFormButton';
                        primary?: string | null;
                        action?:
                          | { __typename: 'ActivityAddOfferToTripAction' }
                          | { __typename: 'ActivityCloseDialogAction' }
                          | { __typename: 'ActivityMultiItemTripUpdateAction' }
                          | { __typename: 'ActivityOpenDialogAction' }
                          | { __typename: 'ActivityOpenOffersModalAction' }
                          | { __typename: 'ActivityPaginationAction' }
                          | { __typename: 'ActivityRemoveOffersFromTripAction' }
                          | { __typename: 'ActivityUpdateOfferInTripAction' }
                          | { __typename: 'AgencyQuoteAction' }
                          | { __typename: 'AirCreditWebAction' }
                          | { __typename: 'BannerPlacementServiceUILinkAction' }
                          | { __typename: 'CouponAndCreditAction' }
                          | { __typename: 'CouponAndCreditChatbotAction' }
                          | { __typename: 'CouponsAndCreditsSimpleAction' }
                          | { __typename: 'CrossSellButtonAction' }
                          | { __typename: 'CrossSellLinkAction' }
                          | { __typename: 'CruiseAction' }
                          | { __typename: 'DirectFeedbackOpenFormAction' }
                          | { __typename: 'DirectFeedbackOpenNextPageAction' }
                          | { __typename: 'DirectFeedbackOpenPreviousPageAction' }
                          | { __typename: 'DirectFeedbackSubmitFormAction' }
                          | { __typename: 'EGDSOpenDatePickerAction' }
                          | { __typename: 'EGDSOpenTravelerSelectorAction' }
                          | { __typename: 'EGDSSubmitSearchFormAction' }
                          | { __typename: 'FlightsCreditSelectorOpenUIAction' }
                          | { __typename: 'FlightsDialogCloseUIAction' }
                          | { __typename: 'FlightsDialogTriggerUIAction' }
                          | { __typename: 'MemberWalletBadge' }
                          | { __typename: 'MemberWalletUIAction' }
                          | { __typename: 'MishopDetailsUIAction' }
                          | { __typename: 'MultiItemCrossSellUIButtonAction' }
                          | { __typename: 'MultiItemCrossSellUICheckoutButtonAction' }
                          | { __typename: 'MultiItemCrossSellUILinkAction' }
                          | { __typename: 'OpenTypeaheadAction' }
                          | { __typename: 'PaymentDialogButtonAction' }
                          | { __typename: 'PriceInsightsCardDisclaimerToolTipAction' }
                          | { __typename: 'PriceInsightsExistingDialogButtonAction' }
                          | { __typename: 'PriceInsightsRetryTrackingDialogButtonAction' }
                          | { __typename: 'ProfileAccountFormSubmitAction' }
                          | { __typename: 'ProfileAddMembershipAction' }
                          | { __typename: 'ProfileAddPassportAction' }
                          | { __typename: 'ProfileFormSubmitAction' }
                          | { __typename: 'ProfileLinkAction' }
                          | { __typename: 'ProfileReloadAction' }
                          | { __typename: 'ProfileRewardProgramFormAction' }
                          | { __typename: 'ProfileUpdateMembershipAction' }
                          | { __typename: 'ProfileUpdatePassportAction' }
                          | { __typename: 'QuoteAction' }
                          | { __typename: 'ShoppingSortAndFilterAction' }
                          | { __typename: 'SupplyNavigationHeaderSearchTrigger' }
                          | { __typename: 'TripsRetryOperationAction' }
                          | { __typename: 'UIFlightAction' }
                          | {
                              __typename: 'UILinkAction';
                              resource:
                                | { __typename: 'BasicURI'; value: string }
                                | { __typename: 'ClipboardURI'; value: string }
                                | { __typename: 'FBMessengerURI'; value: string }
                                | { __typename: 'GenericURI'; value: string }
                                | { __typename: 'GeoURI'; value: string }
                                | { __typename: 'HttpURI'; value: string }
                                | { __typename: 'MailToURI'; value: string }
                                | { __typename: 'MobileAppURI'; value: string }
                                | { __typename: 'RelativeURI'; value: string }
                                | { __typename: 'SMSToURI'; value: string }
                                | { __typename: 'SelfReferencedURI'; value: string }
                                | { __typename: 'TelURI'; value: string }
                                | { __typename: 'Uri'; value: string }
                                | { __typename: 'WhatsappURI'; value: string };
                            }
                          | { __typename: 'WizardAdditionalUserInputRequiredAction' }
                          | { __typename: 'WizardSubmitAction' }
                          | null;
                      }
                    | {
                        __typename: 'FlightsActionButton';
                        primary?: string | null;
                        action?:
                          | { __typename: 'ActivityAddOfferToTripAction' }
                          | { __typename: 'ActivityCloseDialogAction' }
                          | { __typename: 'ActivityMultiItemTripUpdateAction' }
                          | { __typename: 'ActivityOpenDialogAction' }
                          | { __typename: 'ActivityOpenOffersModalAction' }
                          | { __typename: 'ActivityPaginationAction' }
                          | { __typename: 'ActivityRemoveOffersFromTripAction' }
                          | { __typename: 'ActivityUpdateOfferInTripAction' }
                          | { __typename: 'AgencyQuoteAction' }
                          | { __typename: 'AirCreditWebAction' }
                          | { __typename: 'BannerPlacementServiceUILinkAction' }
                          | { __typename: 'CouponAndCreditAction' }
                          | { __typename: 'CouponAndCreditChatbotAction' }
                          | { __typename: 'CouponsAndCreditsSimpleAction' }
                          | { __typename: 'CrossSellButtonAction' }
                          | { __typename: 'CrossSellLinkAction' }
                          | { __typename: 'CruiseAction' }
                          | { __typename: 'DirectFeedbackOpenFormAction' }
                          | { __typename: 'DirectFeedbackOpenNextPageAction' }
                          | { __typename: 'DirectFeedbackOpenPreviousPageAction' }
                          | { __typename: 'DirectFeedbackSubmitFormAction' }
                          | { __typename: 'EGDSOpenDatePickerAction' }
                          | { __typename: 'EGDSOpenTravelerSelectorAction' }
                          | { __typename: 'EGDSSubmitSearchFormAction' }
                          | { __typename: 'FlightsCreditSelectorOpenUIAction' }
                          | { __typename: 'FlightsDialogCloseUIAction' }
                          | { __typename: 'FlightsDialogTriggerUIAction' }
                          | { __typename: 'MemberWalletBadge' }
                          | { __typename: 'MemberWalletUIAction' }
                          | { __typename: 'MishopDetailsUIAction' }
                          | { __typename: 'MultiItemCrossSellUIButtonAction' }
                          | { __typename: 'MultiItemCrossSellUICheckoutButtonAction' }
                          | { __typename: 'MultiItemCrossSellUILinkAction' }
                          | { __typename: 'OpenTypeaheadAction' }
                          | { __typename: 'PaymentDialogButtonAction' }
                          | { __typename: 'PriceInsightsCardDisclaimerToolTipAction' }
                          | { __typename: 'PriceInsightsExistingDialogButtonAction' }
                          | { __typename: 'PriceInsightsRetryTrackingDialogButtonAction' }
                          | { __typename: 'ProfileAccountFormSubmitAction' }
                          | { __typename: 'ProfileAddMembershipAction' }
                          | { __typename: 'ProfileAddPassportAction' }
                          | { __typename: 'ProfileFormSubmitAction' }
                          | { __typename: 'ProfileLinkAction' }
                          | { __typename: 'ProfileReloadAction' }
                          | { __typename: 'ProfileRewardProgramFormAction' }
                          | { __typename: 'ProfileUpdateMembershipAction' }
                          | { __typename: 'ProfileUpdatePassportAction' }
                          | { __typename: 'QuoteAction' }
                          | { __typename: 'ShoppingSortAndFilterAction' }
                          | { __typename: 'SupplyNavigationHeaderSearchTrigger' }
                          | { __typename: 'TripsRetryOperationAction' }
                          | { __typename: 'UIFlightAction' }
                          | {
                              __typename: 'UILinkAction';
                              resource:
                                | { __typename: 'BasicURI'; value: string }
                                | { __typename: 'ClipboardURI'; value: string }
                                | { __typename: 'FBMessengerURI'; value: string }
                                | { __typename: 'GenericURI'; value: string }
                                | { __typename: 'GeoURI'; value: string }
                                | { __typename: 'HttpURI'; value: string }
                                | { __typename: 'MailToURI'; value: string }
                                | { __typename: 'MobileAppURI'; value: string }
                                | { __typename: 'RelativeURI'; value: string }
                                | { __typename: 'SMSToURI'; value: string }
                                | { __typename: 'SelfReferencedURI'; value: string }
                                | { __typename: 'TelURI'; value: string }
                                | { __typename: 'Uri'; value: string }
                                | { __typename: 'WhatsappURI'; value: string };
                            }
                          | { __typename: 'WizardAdditionalUserInputRequiredAction' }
                          | { __typename: 'WizardSubmitAction' }
                          | null;
                      }
                    | {
                        __typename: 'FlightsDialogTrigger';
                        primary?: string | null;
                        action?:
                          | { __typename: 'ActivityAddOfferToTripAction' }
                          | { __typename: 'ActivityCloseDialogAction' }
                          | { __typename: 'ActivityMultiItemTripUpdateAction' }
                          | { __typename: 'ActivityOpenDialogAction' }
                          | { __typename: 'ActivityOpenOffersModalAction' }
                          | { __typename: 'ActivityPaginationAction' }
                          | { __typename: 'ActivityRemoveOffersFromTripAction' }
                          | { __typename: 'ActivityUpdateOfferInTripAction' }
                          | { __typename: 'AgencyQuoteAction' }
                          | { __typename: 'AirCreditWebAction' }
                          | { __typename: 'BannerPlacementServiceUILinkAction' }
                          | { __typename: 'CouponAndCreditAction' }
                          | { __typename: 'CouponAndCreditChatbotAction' }
                          | { __typename: 'CouponsAndCreditsSimpleAction' }
                          | { __typename: 'CrossSellButtonAction' }
                          | { __typename: 'CrossSellLinkAction' }
                          | { __typename: 'CruiseAction' }
                          | { __typename: 'DirectFeedbackOpenFormAction' }
                          | { __typename: 'DirectFeedbackOpenNextPageAction' }
                          | { __typename: 'DirectFeedbackOpenPreviousPageAction' }
                          | { __typename: 'DirectFeedbackSubmitFormAction' }
                          | { __typename: 'EGDSOpenDatePickerAction' }
                          | { __typename: 'EGDSOpenTravelerSelectorAction' }
                          | { __typename: 'EGDSSubmitSearchFormAction' }
                          | { __typename: 'FlightsCreditSelectorOpenUIAction' }
                          | { __typename: 'FlightsDialogCloseUIAction' }
                          | { __typename: 'FlightsDialogTriggerUIAction' }
                          | { __typename: 'MemberWalletBadge' }
                          | { __typename: 'MemberWalletUIAction' }
                          | { __typename: 'MishopDetailsUIAction' }
                          | { __typename: 'MultiItemCrossSellUIButtonAction' }
                          | { __typename: 'MultiItemCrossSellUICheckoutButtonAction' }
                          | { __typename: 'MultiItemCrossSellUILinkAction' }
                          | { __typename: 'OpenTypeaheadAction' }
                          | { __typename: 'PaymentDialogButtonAction' }
                          | { __typename: 'PriceInsightsCardDisclaimerToolTipAction' }
                          | { __typename: 'PriceInsightsExistingDialogButtonAction' }
                          | { __typename: 'PriceInsightsRetryTrackingDialogButtonAction' }
                          | { __typename: 'ProfileAccountFormSubmitAction' }
                          | { __typename: 'ProfileAddMembershipAction' }
                          | { __typename: 'ProfileAddPassportAction' }
                          | { __typename: 'ProfileFormSubmitAction' }
                          | { __typename: 'ProfileLinkAction' }
                          | { __typename: 'ProfileReloadAction' }
                          | { __typename: 'ProfileRewardProgramFormAction' }
                          | { __typename: 'ProfileUpdateMembershipAction' }
                          | { __typename: 'ProfileUpdatePassportAction' }
                          | { __typename: 'QuoteAction' }
                          | { __typename: 'ShoppingSortAndFilterAction' }
                          | { __typename: 'SupplyNavigationHeaderSearchTrigger' }
                          | { __typename: 'TripsRetryOperationAction' }
                          | { __typename: 'UIFlightAction' }
                          | {
                              __typename: 'UILinkAction';
                              resource:
                                | { __typename: 'BasicURI'; value: string }
                                | { __typename: 'ClipboardURI'; value: string }
                                | { __typename: 'FBMessengerURI'; value: string }
                                | { __typename: 'GenericURI'; value: string }
                                | { __typename: 'GeoURI'; value: string }
                                | { __typename: 'HttpURI'; value: string }
                                | { __typename: 'MailToURI'; value: string }
                                | { __typename: 'MobileAppURI'; value: string }
                                | { __typename: 'RelativeURI'; value: string }
                                | { __typename: 'SMSToURI'; value: string }
                                | { __typename: 'SelfReferencedURI'; value: string }
                                | { __typename: 'TelURI'; value: string }
                                | { __typename: 'Uri'; value: string }
                                | { __typename: 'WhatsappURI'; value: string };
                            }
                          | { __typename: 'WizardAdditionalUserInputRequiredAction' }
                          | { __typename: 'WizardSubmitAction' }
                          | null;
                      }
                    | {
                        __typename: 'FlightsExperienceActionButton';
                        primary?: string | null;
                        action?:
                          | { __typename: 'ActivityAddOfferToTripAction' }
                          | { __typename: 'ActivityCloseDialogAction' }
                          | { __typename: 'ActivityMultiItemTripUpdateAction' }
                          | { __typename: 'ActivityOpenDialogAction' }
                          | { __typename: 'ActivityOpenOffersModalAction' }
                          | { __typename: 'ActivityPaginationAction' }
                          | { __typename: 'ActivityRemoveOffersFromTripAction' }
                          | { __typename: 'ActivityUpdateOfferInTripAction' }
                          | { __typename: 'AgencyQuoteAction' }
                          | { __typename: 'AirCreditWebAction' }
                          | { __typename: 'BannerPlacementServiceUILinkAction' }
                          | { __typename: 'CouponAndCreditAction' }
                          | { __typename: 'CouponAndCreditChatbotAction' }
                          | { __typename: 'CouponsAndCreditsSimpleAction' }
                          | { __typename: 'CrossSellButtonAction' }
                          | { __typename: 'CrossSellLinkAction' }
                          | { __typename: 'CruiseAction' }
                          | { __typename: 'DirectFeedbackOpenFormAction' }
                          | { __typename: 'DirectFeedbackOpenNextPageAction' }
                          | { __typename: 'DirectFeedbackOpenPreviousPageAction' }
                          | { __typename: 'DirectFeedbackSubmitFormAction' }
                          | { __typename: 'EGDSOpenDatePickerAction' }
                          | { __typename: 'EGDSOpenTravelerSelectorAction' }
                          | { __typename: 'EGDSSubmitSearchFormAction' }
                          | { __typename: 'FlightsCreditSelectorOpenUIAction' }
                          | { __typename: 'FlightsDialogCloseUIAction' }
                          | { __typename: 'FlightsDialogTriggerUIAction' }
                          | { __typename: 'MemberWalletBadge' }
                          | { __typename: 'MemberWalletUIAction' }
                          | { __typename: 'MishopDetailsUIAction' }
                          | { __typename: 'MultiItemCrossSellUIButtonAction' }
                          | { __typename: 'MultiItemCrossSellUICheckoutButtonAction' }
                          | { __typename: 'MultiItemCrossSellUILinkAction' }
                          | { __typename: 'OpenTypeaheadAction' }
                          | { __typename: 'PaymentDialogButtonAction' }
                          | { __typename: 'PriceInsightsCardDisclaimerToolTipAction' }
                          | { __typename: 'PriceInsightsExistingDialogButtonAction' }
                          | { __typename: 'PriceInsightsRetryTrackingDialogButtonAction' }
                          | { __typename: 'ProfileAccountFormSubmitAction' }
                          | { __typename: 'ProfileAddMembershipAction' }
                          | { __typename: 'ProfileAddPassportAction' }
                          | { __typename: 'ProfileFormSubmitAction' }
                          | { __typename: 'ProfileLinkAction' }
                          | { __typename: 'ProfileReloadAction' }
                          | { __typename: 'ProfileRewardProgramFormAction' }
                          | { __typename: 'ProfileUpdateMembershipAction' }
                          | { __typename: 'ProfileUpdatePassportAction' }
                          | { __typename: 'QuoteAction' }
                          | { __typename: 'ShoppingSortAndFilterAction' }
                          | { __typename: 'SupplyNavigationHeaderSearchTrigger' }
                          | { __typename: 'TripsRetryOperationAction' }
                          | { __typename: 'UIFlightAction' }
                          | {
                              __typename: 'UILinkAction';
                              resource:
                                | { __typename: 'BasicURI'; value: string }
                                | { __typename: 'ClipboardURI'; value: string }
                                | { __typename: 'FBMessengerURI'; value: string }
                                | { __typename: 'GenericURI'; value: string }
                                | { __typename: 'GeoURI'; value: string }
                                | { __typename: 'HttpURI'; value: string }
                                | { __typename: 'MailToURI'; value: string }
                                | { __typename: 'MobileAppURI'; value: string }
                                | { __typename: 'RelativeURI'; value: string }
                                | { __typename: 'SMSToURI'; value: string }
                                | { __typename: 'SelfReferencedURI'; value: string }
                                | { __typename: 'TelURI'; value: string }
                                | { __typename: 'Uri'; value: string }
                                | { __typename: 'WhatsappURI'; value: string };
                            }
                          | { __typename: 'WizardAdditionalUserInputRequiredAction' }
                          | { __typename: 'WizardSubmitAction' }
                          | null;
                      }
                    | {
                        __typename: 'InsurTechExperienceDialogTrigger';
                        primary?: string | null;
                        action?:
                          | { __typename: 'ActivityAddOfferToTripAction' }
                          | { __typename: 'ActivityCloseDialogAction' }
                          | { __typename: 'ActivityMultiItemTripUpdateAction' }
                          | { __typename: 'ActivityOpenDialogAction' }
                          | { __typename: 'ActivityOpenOffersModalAction' }
                          | { __typename: 'ActivityPaginationAction' }
                          | { __typename: 'ActivityRemoveOffersFromTripAction' }
                          | { __typename: 'ActivityUpdateOfferInTripAction' }
                          | { __typename: 'AgencyQuoteAction' }
                          | { __typename: 'AirCreditWebAction' }
                          | { __typename: 'BannerPlacementServiceUILinkAction' }
                          | { __typename: 'CouponAndCreditAction' }
                          | { __typename: 'CouponAndCreditChatbotAction' }
                          | { __typename: 'CouponsAndCreditsSimpleAction' }
                          | { __typename: 'CrossSellButtonAction' }
                          | { __typename: 'CrossSellLinkAction' }
                          | { __typename: 'CruiseAction' }
                          | { __typename: 'DirectFeedbackOpenFormAction' }
                          | { __typename: 'DirectFeedbackOpenNextPageAction' }
                          | { __typename: 'DirectFeedbackOpenPreviousPageAction' }
                          | { __typename: 'DirectFeedbackSubmitFormAction' }
                          | { __typename: 'EGDSOpenDatePickerAction' }
                          | { __typename: 'EGDSOpenTravelerSelectorAction' }
                          | { __typename: 'EGDSSubmitSearchFormAction' }
                          | { __typename: 'FlightsCreditSelectorOpenUIAction' }
                          | { __typename: 'FlightsDialogCloseUIAction' }
                          | { __typename: 'FlightsDialogTriggerUIAction' }
                          | { __typename: 'MemberWalletBadge' }
                          | { __typename: 'MemberWalletUIAction' }
                          | { __typename: 'MishopDetailsUIAction' }
                          | { __typename: 'MultiItemCrossSellUIButtonAction' }
                          | { __typename: 'MultiItemCrossSellUICheckoutButtonAction' }
                          | { __typename: 'MultiItemCrossSellUILinkAction' }
                          | { __typename: 'OpenTypeaheadAction' }
                          | { __typename: 'PaymentDialogButtonAction' }
                          | { __typename: 'PriceInsightsCardDisclaimerToolTipAction' }
                          | { __typename: 'PriceInsightsExistingDialogButtonAction' }
                          | { __typename: 'PriceInsightsRetryTrackingDialogButtonAction' }
                          | { __typename: 'ProfileAccountFormSubmitAction' }
                          | { __typename: 'ProfileAddMembershipAction' }
                          | { __typename: 'ProfileAddPassportAction' }
                          | { __typename: 'ProfileFormSubmitAction' }
                          | { __typename: 'ProfileLinkAction' }
                          | { __typename: 'ProfileReloadAction' }
                          | { __typename: 'ProfileRewardProgramFormAction' }
                          | { __typename: 'ProfileUpdateMembershipAction' }
                          | { __typename: 'ProfileUpdatePassportAction' }
                          | { __typename: 'QuoteAction' }
                          | { __typename: 'ShoppingSortAndFilterAction' }
                          | { __typename: 'SupplyNavigationHeaderSearchTrigger' }
                          | { __typename: 'TripsRetryOperationAction' }
                          | { __typename: 'UIFlightAction' }
                          | {
                              __typename: 'UILinkAction';
                              resource:
                                | { __typename: 'BasicURI'; value: string }
                                | { __typename: 'ClipboardURI'; value: string }
                                | { __typename: 'FBMessengerURI'; value: string }
                                | { __typename: 'GenericURI'; value: string }
                                | { __typename: 'GeoURI'; value: string }
                                | { __typename: 'HttpURI'; value: string }
                                | { __typename: 'MailToURI'; value: string }
                                | { __typename: 'MobileAppURI'; value: string }
                                | { __typename: 'RelativeURI'; value: string }
                                | { __typename: 'SMSToURI'; value: string }
                                | { __typename: 'SelfReferencedURI'; value: string }
                                | { __typename: 'TelURI'; value: string }
                                | { __typename: 'Uri'; value: string }
                                | { __typename: 'WhatsappURI'; value: string };
                            }
                          | { __typename: 'WizardAdditionalUserInputRequiredAction' }
                          | { __typename: 'WizardSubmitAction' }
                          | null;
                      }
                    | {
                        __typename: 'PackageUIActionDialogFooterButton';
                        primary?: string | null;
                        action?:
                          | { __typename: 'ActivityAddOfferToTripAction' }
                          | { __typename: 'ActivityCloseDialogAction' }
                          | { __typename: 'ActivityMultiItemTripUpdateAction' }
                          | { __typename: 'ActivityOpenDialogAction' }
                          | { __typename: 'ActivityOpenOffersModalAction' }
                          | { __typename: 'ActivityPaginationAction' }
                          | { __typename: 'ActivityRemoveOffersFromTripAction' }
                          | { __typename: 'ActivityUpdateOfferInTripAction' }
                          | { __typename: 'AgencyQuoteAction' }
                          | { __typename: 'AirCreditWebAction' }
                          | { __typename: 'BannerPlacementServiceUILinkAction' }
                          | { __typename: 'CouponAndCreditAction' }
                          | { __typename: 'CouponAndCreditChatbotAction' }
                          | { __typename: 'CouponsAndCreditsSimpleAction' }
                          | { __typename: 'CrossSellButtonAction' }
                          | { __typename: 'CrossSellLinkAction' }
                          | { __typename: 'CruiseAction' }
                          | { __typename: 'DirectFeedbackOpenFormAction' }
                          | { __typename: 'DirectFeedbackOpenNextPageAction' }
                          | { __typename: 'DirectFeedbackOpenPreviousPageAction' }
                          | { __typename: 'DirectFeedbackSubmitFormAction' }
                          | { __typename: 'EGDSOpenDatePickerAction' }
                          | { __typename: 'EGDSOpenTravelerSelectorAction' }
                          | { __typename: 'EGDSSubmitSearchFormAction' }
                          | { __typename: 'FlightsCreditSelectorOpenUIAction' }
                          | { __typename: 'FlightsDialogCloseUIAction' }
                          | { __typename: 'FlightsDialogTriggerUIAction' }
                          | { __typename: 'MemberWalletBadge' }
                          | { __typename: 'MemberWalletUIAction' }
                          | { __typename: 'MishopDetailsUIAction' }
                          | { __typename: 'MultiItemCrossSellUIButtonAction' }
                          | { __typename: 'MultiItemCrossSellUICheckoutButtonAction' }
                          | { __typename: 'MultiItemCrossSellUILinkAction' }
                          | { __typename: 'OpenTypeaheadAction' }
                          | { __typename: 'PaymentDialogButtonAction' }
                          | { __typename: 'PriceInsightsCardDisclaimerToolTipAction' }
                          | { __typename: 'PriceInsightsExistingDialogButtonAction' }
                          | { __typename: 'PriceInsightsRetryTrackingDialogButtonAction' }
                          | { __typename: 'ProfileAccountFormSubmitAction' }
                          | { __typename: 'ProfileAddMembershipAction' }
                          | { __typename: 'ProfileAddPassportAction' }
                          | { __typename: 'ProfileFormSubmitAction' }
                          | { __typename: 'ProfileLinkAction' }
                          | { __typename: 'ProfileReloadAction' }
                          | { __typename: 'ProfileRewardProgramFormAction' }
                          | { __typename: 'ProfileUpdateMembershipAction' }
                          | { __typename: 'ProfileUpdatePassportAction' }
                          | { __typename: 'QuoteAction' }
                          | { __typename: 'ShoppingSortAndFilterAction' }
                          | { __typename: 'SupplyNavigationHeaderSearchTrigger' }
                          | { __typename: 'TripsRetryOperationAction' }
                          | { __typename: 'UIFlightAction' }
                          | {
                              __typename: 'UILinkAction';
                              resource:
                                | { __typename: 'BasicURI'; value: string }
                                | { __typename: 'ClipboardURI'; value: string }
                                | { __typename: 'FBMessengerURI'; value: string }
                                | { __typename: 'GenericURI'; value: string }
                                | { __typename: 'GeoURI'; value: string }
                                | { __typename: 'HttpURI'; value: string }
                                | { __typename: 'MailToURI'; value: string }
                                | { __typename: 'MobileAppURI'; value: string }
                                | { __typename: 'RelativeURI'; value: string }
                                | { __typename: 'SMSToURI'; value: string }
                                | { __typename: 'SelfReferencedURI'; value: string }
                                | { __typename: 'TelURI'; value: string }
                                | { __typename: 'Uri'; value: string }
                                | { __typename: 'WhatsappURI'; value: string };
                            }
                          | { __typename: 'WizardAdditionalUserInputRequiredAction' }
                          | { __typename: 'WizardSubmitAction' }
                          | null;
                      }
                    | {
                        __typename: 'PackageUIHideSearchFormAction';
                        primary?: string | null;
                        action?:
                          | { __typename: 'ActivityAddOfferToTripAction' }
                          | { __typename: 'ActivityCloseDialogAction' }
                          | { __typename: 'ActivityMultiItemTripUpdateAction' }
                          | { __typename: 'ActivityOpenDialogAction' }
                          | { __typename: 'ActivityOpenOffersModalAction' }
                          | { __typename: 'ActivityPaginationAction' }
                          | { __typename: 'ActivityRemoveOffersFromTripAction' }
                          | { __typename: 'ActivityUpdateOfferInTripAction' }
                          | { __typename: 'AgencyQuoteAction' }
                          | { __typename: 'AirCreditWebAction' }
                          | { __typename: 'BannerPlacementServiceUILinkAction' }
                          | { __typename: 'CouponAndCreditAction' }
                          | { __typename: 'CouponAndCreditChatbotAction' }
                          | { __typename: 'CouponsAndCreditsSimpleAction' }
                          | { __typename: 'CrossSellButtonAction' }
                          | { __typename: 'CrossSellLinkAction' }
                          | { __typename: 'CruiseAction' }
                          | { __typename: 'DirectFeedbackOpenFormAction' }
                          | { __typename: 'DirectFeedbackOpenNextPageAction' }
                          | { __typename: 'DirectFeedbackOpenPreviousPageAction' }
                          | { __typename: 'DirectFeedbackSubmitFormAction' }
                          | { __typename: 'EGDSOpenDatePickerAction' }
                          | { __typename: 'EGDSOpenTravelerSelectorAction' }
                          | { __typename: 'EGDSSubmitSearchFormAction' }
                          | { __typename: 'FlightsCreditSelectorOpenUIAction' }
                          | { __typename: 'FlightsDialogCloseUIAction' }
                          | { __typename: 'FlightsDialogTriggerUIAction' }
                          | { __typename: 'MemberWalletBadge' }
                          | { __typename: 'MemberWalletUIAction' }
                          | { __typename: 'MishopDetailsUIAction' }
                          | { __typename: 'MultiItemCrossSellUIButtonAction' }
                          | { __typename: 'MultiItemCrossSellUICheckoutButtonAction' }
                          | { __typename: 'MultiItemCrossSellUILinkAction' }
                          | { __typename: 'OpenTypeaheadAction' }
                          | { __typename: 'PaymentDialogButtonAction' }
                          | { __typename: 'PriceInsightsCardDisclaimerToolTipAction' }
                          | { __typename: 'PriceInsightsExistingDialogButtonAction' }
                          | { __typename: 'PriceInsightsRetryTrackingDialogButtonAction' }
                          | { __typename: 'ProfileAccountFormSubmitAction' }
                          | { __typename: 'ProfileAddMembershipAction' }
                          | { __typename: 'ProfileAddPassportAction' }
                          | { __typename: 'ProfileFormSubmitAction' }
                          | { __typename: 'ProfileLinkAction' }
                          | { __typename: 'ProfileReloadAction' }
                          | { __typename: 'ProfileRewardProgramFormAction' }
                          | { __typename: 'ProfileUpdateMembershipAction' }
                          | { __typename: 'ProfileUpdatePassportAction' }
                          | { __typename: 'QuoteAction' }
                          | { __typename: 'ShoppingSortAndFilterAction' }
                          | { __typename: 'SupplyNavigationHeaderSearchTrigger' }
                          | { __typename: 'TripsRetryOperationAction' }
                          | { __typename: 'UIFlightAction' }
                          | {
                              __typename: 'UILinkAction';
                              resource:
                                | { __typename: 'BasicURI'; value: string }
                                | { __typename: 'ClipboardURI'; value: string }
                                | { __typename: 'FBMessengerURI'; value: string }
                                | { __typename: 'GenericURI'; value: string }
                                | { __typename: 'GeoURI'; value: string }
                                | { __typename: 'HttpURI'; value: string }
                                | { __typename: 'MailToURI'; value: string }
                                | { __typename: 'MobileAppURI'; value: string }
                                | { __typename: 'RelativeURI'; value: string }
                                | { __typename: 'SMSToURI'; value: string }
                                | { __typename: 'SelfReferencedURI'; value: string }
                                | { __typename: 'TelURI'; value: string }
                                | { __typename: 'Uri'; value: string }
                                | { __typename: 'WhatsappURI'; value: string };
                            }
                          | { __typename: 'WizardAdditionalUserInputRequiredAction' }
                          | { __typename: 'WizardSubmitAction' }
                          | null;
                      }
                    | {
                        __typename: 'PackageUITravelGuideButton';
                        primary?: string | null;
                        action?:
                          | { __typename: 'ActivityAddOfferToTripAction' }
                          | { __typename: 'ActivityCloseDialogAction' }
                          | { __typename: 'ActivityMultiItemTripUpdateAction' }
                          | { __typename: 'ActivityOpenDialogAction' }
                          | { __typename: 'ActivityOpenOffersModalAction' }
                          | { __typename: 'ActivityPaginationAction' }
                          | { __typename: 'ActivityRemoveOffersFromTripAction' }
                          | { __typename: 'ActivityUpdateOfferInTripAction' }
                          | { __typename: 'AgencyQuoteAction' }
                          | { __typename: 'AirCreditWebAction' }
                          | { __typename: 'BannerPlacementServiceUILinkAction' }
                          | { __typename: 'CouponAndCreditAction' }
                          | { __typename: 'CouponAndCreditChatbotAction' }
                          | { __typename: 'CouponsAndCreditsSimpleAction' }
                          | { __typename: 'CrossSellButtonAction' }
                          | { __typename: 'CrossSellLinkAction' }
                          | { __typename: 'CruiseAction' }
                          | { __typename: 'DirectFeedbackOpenFormAction' }
                          | { __typename: 'DirectFeedbackOpenNextPageAction' }
                          | { __typename: 'DirectFeedbackOpenPreviousPageAction' }
                          | { __typename: 'DirectFeedbackSubmitFormAction' }
                          | { __typename: 'EGDSOpenDatePickerAction' }
                          | { __typename: 'EGDSOpenTravelerSelectorAction' }
                          | { __typename: 'EGDSSubmitSearchFormAction' }
                          | { __typename: 'FlightsCreditSelectorOpenUIAction' }
                          | { __typename: 'FlightsDialogCloseUIAction' }
                          | { __typename: 'FlightsDialogTriggerUIAction' }
                          | { __typename: 'MemberWalletBadge' }
                          | { __typename: 'MemberWalletUIAction' }
                          | { __typename: 'MishopDetailsUIAction' }
                          | { __typename: 'MultiItemCrossSellUIButtonAction' }
                          | { __typename: 'MultiItemCrossSellUICheckoutButtonAction' }
                          | { __typename: 'MultiItemCrossSellUILinkAction' }
                          | { __typename: 'OpenTypeaheadAction' }
                          | { __typename: 'PaymentDialogButtonAction' }
                          | { __typename: 'PriceInsightsCardDisclaimerToolTipAction' }
                          | { __typename: 'PriceInsightsExistingDialogButtonAction' }
                          | { __typename: 'PriceInsightsRetryTrackingDialogButtonAction' }
                          | { __typename: 'ProfileAccountFormSubmitAction' }
                          | { __typename: 'ProfileAddMembershipAction' }
                          | { __typename: 'ProfileAddPassportAction' }
                          | { __typename: 'ProfileFormSubmitAction' }
                          | { __typename: 'ProfileLinkAction' }
                          | { __typename: 'ProfileReloadAction' }
                          | { __typename: 'ProfileRewardProgramFormAction' }
                          | { __typename: 'ProfileUpdateMembershipAction' }
                          | { __typename: 'ProfileUpdatePassportAction' }
                          | { __typename: 'QuoteAction' }
                          | { __typename: 'ShoppingSortAndFilterAction' }
                          | { __typename: 'SupplyNavigationHeaderSearchTrigger' }
                          | { __typename: 'TripsRetryOperationAction' }
                          | { __typename: 'UIFlightAction' }
                          | {
                              __typename: 'UILinkAction';
                              resource:
                                | { __typename: 'BasicURI'; value: string }
                                | { __typename: 'ClipboardURI'; value: string }
                                | { __typename: 'FBMessengerURI'; value: string }
                                | { __typename: 'GenericURI'; value: string }
                                | { __typename: 'GeoURI'; value: string }
                                | { __typename: 'HttpURI'; value: string }
                                | { __typename: 'MailToURI'; value: string }
                                | { __typename: 'MobileAppURI'; value: string }
                                | { __typename: 'RelativeURI'; value: string }
                                | { __typename: 'SMSToURI'; value: string }
                                | { __typename: 'SelfReferencedURI'; value: string }
                                | { __typename: 'TelURI'; value: string }
                                | { __typename: 'Uri'; value: string }
                                | { __typename: 'WhatsappURI'; value: string };
                            }
                          | { __typename: 'WizardAdditionalUserInputRequiredAction' }
                          | { __typename: 'WizardSubmitAction' }
                          | null;
                      }
                    | {
                        __typename: 'SupplyCancelWaiverActionButton';
                        primary: string;
                        action?: {
                          __typename: 'UILinkAction';
                          resource:
                            | { __typename: 'BasicURI'; value: string }
                            | { __typename: 'ClipboardURI'; value: string }
                            | { __typename: 'FBMessengerURI'; value: string }
                            | { __typename: 'GenericURI'; value: string }
                            | { __typename: 'GeoURI'; value: string }
                            | { __typename: 'HttpURI'; value: string }
                            | { __typename: 'MailToURI'; value: string }
                            | { __typename: 'MobileAppURI'; value: string }
                            | { __typename: 'RelativeURI'; value: string }
                            | { __typename: 'SMSToURI'; value: string }
                            | { __typename: 'SelfReferencedURI'; value: string }
                            | { __typename: 'TelURI'; value: string }
                            | { __typename: 'Uri'; value: string }
                            | { __typename: 'WhatsappURI'; value: string };
                        } | null;
                      }
                    | {
                        __typename: 'SupplyContentLinkStyleButton';
                        primary?: string | null;
                        action?: {
                          __typename: 'UILinkAction';
                          resource:
                            | { __typename: 'BasicURI'; value: string }
                            | { __typename: 'ClipboardURI'; value: string }
                            | { __typename: 'FBMessengerURI'; value: string }
                            | { __typename: 'GenericURI'; value: string }
                            | { __typename: 'GeoURI'; value: string }
                            | { __typename: 'HttpURI'; value: string }
                            | { __typename: 'MailToURI'; value: string }
                            | { __typename: 'MobileAppURI'; value: string }
                            | { __typename: 'RelativeURI'; value: string }
                            | { __typename: 'SMSToURI'; value: string }
                            | { __typename: 'SelfReferencedURI'; value: string }
                            | { __typename: 'TelURI'; value: string }
                            | { __typename: 'Uri'; value: string }
                            | { __typename: 'WhatsappURI'; value: string };
                        } | null;
                      }
                    | {
                        __typename: 'UIPrimaryButton';
                        primary?: string | null;
                        action?:
                          | { __typename: 'ActivityAddOfferToTripAction' }
                          | { __typename: 'ActivityCloseDialogAction' }
                          | { __typename: 'ActivityMultiItemTripUpdateAction' }
                          | { __typename: 'ActivityOpenDialogAction' }
                          | { __typename: 'ActivityOpenOffersModalAction' }
                          | { __typename: 'ActivityPaginationAction' }
                          | { __typename: 'ActivityRemoveOffersFromTripAction' }
                          | { __typename: 'ActivityUpdateOfferInTripAction' }
                          | { __typename: 'AgencyQuoteAction' }
                          | { __typename: 'AirCreditWebAction' }
                          | { __typename: 'BannerPlacementServiceUILinkAction' }
                          | { __typename: 'CouponAndCreditAction' }
                          | { __typename: 'CouponAndCreditChatbotAction' }
                          | { __typename: 'CouponsAndCreditsSimpleAction' }
                          | { __typename: 'CrossSellButtonAction' }
                          | { __typename: 'CrossSellLinkAction' }
                          | { __typename: 'CruiseAction' }
                          | { __typename: 'DirectFeedbackOpenFormAction' }
                          | { __typename: 'DirectFeedbackOpenNextPageAction' }
                          | { __typename: 'DirectFeedbackOpenPreviousPageAction' }
                          | { __typename: 'DirectFeedbackSubmitFormAction' }
                          | { __typename: 'EGDSOpenDatePickerAction' }
                          | { __typename: 'EGDSOpenTravelerSelectorAction' }
                          | { __typename: 'EGDSSubmitSearchFormAction' }
                          | { __typename: 'FlightsCreditSelectorOpenUIAction' }
                          | { __typename: 'FlightsDialogCloseUIAction' }
                          | { __typename: 'FlightsDialogTriggerUIAction' }
                          | { __typename: 'MemberWalletBadge' }
                          | { __typename: 'MemberWalletUIAction' }
                          | { __typename: 'MishopDetailsUIAction' }
                          | { __typename: 'MultiItemCrossSellUIButtonAction' }
                          | { __typename: 'MultiItemCrossSellUICheckoutButtonAction' }
                          | { __typename: 'MultiItemCrossSellUILinkAction' }
                          | { __typename: 'OpenTypeaheadAction' }
                          | { __typename: 'PaymentDialogButtonAction' }
                          | { __typename: 'PriceInsightsCardDisclaimerToolTipAction' }
                          | { __typename: 'PriceInsightsExistingDialogButtonAction' }
                          | { __typename: 'PriceInsightsRetryTrackingDialogButtonAction' }
                          | { __typename: 'ProfileAccountFormSubmitAction' }
                          | { __typename: 'ProfileAddMembershipAction' }
                          | { __typename: 'ProfileAddPassportAction' }
                          | { __typename: 'ProfileFormSubmitAction' }
                          | { __typename: 'ProfileLinkAction' }
                          | { __typename: 'ProfileReloadAction' }
                          | { __typename: 'ProfileRewardProgramFormAction' }
                          | { __typename: 'ProfileUpdateMembershipAction' }
                          | { __typename: 'ProfileUpdatePassportAction' }
                          | { __typename: 'QuoteAction' }
                          | { __typename: 'ShoppingSortAndFilterAction' }
                          | { __typename: 'SupplyNavigationHeaderSearchTrigger' }
                          | { __typename: 'TripsRetryOperationAction' }
                          | { __typename: 'UIFlightAction' }
                          | {
                              __typename: 'UILinkAction';
                              resource:
                                | { __typename: 'BasicURI'; value: string }
                                | { __typename: 'ClipboardURI'; value: string }
                                | { __typename: 'FBMessengerURI'; value: string }
                                | { __typename: 'GenericURI'; value: string }
                                | { __typename: 'GeoURI'; value: string }
                                | { __typename: 'HttpURI'; value: string }
                                | { __typename: 'MailToURI'; value: string }
                                | { __typename: 'MobileAppURI'; value: string }
                                | { __typename: 'RelativeURI'; value: string }
                                | { __typename: 'SMSToURI'; value: string }
                                | { __typename: 'SelfReferencedURI'; value: string }
                                | { __typename: 'TelURI'; value: string }
                                | { __typename: 'Uri'; value: string }
                                | { __typename: 'WhatsappURI'; value: string };
                            }
                          | { __typename: 'WizardAdditionalUserInputRequiredAction' }
                          | { __typename: 'WizardSubmitAction' }
                          | null;
                      }
                    | {
                        __typename: 'UISecondaryButton';
                        primary?: string | null;
                        action?:
                          | { __typename: 'ActivityAddOfferToTripAction' }
                          | { __typename: 'ActivityCloseDialogAction' }
                          | { __typename: 'ActivityMultiItemTripUpdateAction' }
                          | { __typename: 'ActivityOpenDialogAction' }
                          | { __typename: 'ActivityOpenOffersModalAction' }
                          | { __typename: 'ActivityPaginationAction' }
                          | { __typename: 'ActivityRemoveOffersFromTripAction' }
                          | { __typename: 'ActivityUpdateOfferInTripAction' }
                          | { __typename: 'AgencyQuoteAction' }
                          | { __typename: 'AirCreditWebAction' }
                          | { __typename: 'BannerPlacementServiceUILinkAction' }
                          | { __typename: 'CouponAndCreditAction' }
                          | { __typename: 'CouponAndCreditChatbotAction' }
                          | { __typename: 'CouponsAndCreditsSimpleAction' }
                          | { __typename: 'CrossSellButtonAction' }
                          | { __typename: 'CrossSellLinkAction' }
                          | { __typename: 'CruiseAction' }
                          | { __typename: 'DirectFeedbackOpenFormAction' }
                          | { __typename: 'DirectFeedbackOpenNextPageAction' }
                          | { __typename: 'DirectFeedbackOpenPreviousPageAction' }
                          | { __typename: 'DirectFeedbackSubmitFormAction' }
                          | { __typename: 'EGDSOpenDatePickerAction' }
                          | { __typename: 'EGDSOpenTravelerSelectorAction' }
                          | { __typename: 'EGDSSubmitSearchFormAction' }
                          | { __typename: 'FlightsCreditSelectorOpenUIAction' }
                          | { __typename: 'FlightsDialogCloseUIAction' }
                          | { __typename: 'FlightsDialogTriggerUIAction' }
                          | { __typename: 'MemberWalletBadge' }
                          | { __typename: 'MemberWalletUIAction' }
                          | { __typename: 'MishopDetailsUIAction' }
                          | { __typename: 'MultiItemCrossSellUIButtonAction' }
                          | { __typename: 'MultiItemCrossSellUICheckoutButtonAction' }
                          | { __typename: 'MultiItemCrossSellUILinkAction' }
                          | { __typename: 'OpenTypeaheadAction' }
                          | { __typename: 'PaymentDialogButtonAction' }
                          | { __typename: 'PriceInsightsCardDisclaimerToolTipAction' }
                          | { __typename: 'PriceInsightsExistingDialogButtonAction' }
                          | { __typename: 'PriceInsightsRetryTrackingDialogButtonAction' }
                          | { __typename: 'ProfileAccountFormSubmitAction' }
                          | { __typename: 'ProfileAddMembershipAction' }
                          | { __typename: 'ProfileAddPassportAction' }
                          | { __typename: 'ProfileFormSubmitAction' }
                          | { __typename: 'ProfileLinkAction' }
                          | { __typename: 'ProfileReloadAction' }
                          | { __typename: 'ProfileRewardProgramFormAction' }
                          | { __typename: 'ProfileUpdateMembershipAction' }
                          | { __typename: 'ProfileUpdatePassportAction' }
                          | { __typename: 'QuoteAction' }
                          | { __typename: 'ShoppingSortAndFilterAction' }
                          | { __typename: 'SupplyNavigationHeaderSearchTrigger' }
                          | { __typename: 'TripsRetryOperationAction' }
                          | { __typename: 'UIFlightAction' }
                          | {
                              __typename: 'UILinkAction';
                              resource:
                                | { __typename: 'BasicURI'; value: string }
                                | { __typename: 'ClipboardURI'; value: string }
                                | { __typename: 'FBMessengerURI'; value: string }
                                | { __typename: 'GenericURI'; value: string }
                                | { __typename: 'GeoURI'; value: string }
                                | { __typename: 'HttpURI'; value: string }
                                | { __typename: 'MailToURI'; value: string }
                                | { __typename: 'MobileAppURI'; value: string }
                                | { __typename: 'RelativeURI'; value: string }
                                | { __typename: 'SMSToURI'; value: string }
                                | { __typename: 'SelfReferencedURI'; value: string }
                                | { __typename: 'TelURI'; value: string }
                                | { __typename: 'Uri'; value: string }
                                | { __typename: 'WhatsappURI'; value: string };
                            }
                          | { __typename: 'WizardAdditionalUserInputRequiredAction' }
                          | { __typename: 'WizardSubmitAction' }
                          | null;
                      }
                    | {
                        __typename: 'UITertiaryButton';
                        primary?: string | null;
                        action?:
                          | { __typename: 'ActivityAddOfferToTripAction' }
                          | { __typename: 'ActivityCloseDialogAction' }
                          | { __typename: 'ActivityMultiItemTripUpdateAction' }
                          | { __typename: 'ActivityOpenDialogAction' }
                          | { __typename: 'ActivityOpenOffersModalAction' }
                          | { __typename: 'ActivityPaginationAction' }
                          | { __typename: 'ActivityRemoveOffersFromTripAction' }
                          | { __typename: 'ActivityUpdateOfferInTripAction' }
                          | { __typename: 'AgencyQuoteAction' }
                          | { __typename: 'AirCreditWebAction' }
                          | { __typename: 'BannerPlacementServiceUILinkAction' }
                          | { __typename: 'CouponAndCreditAction' }
                          | { __typename: 'CouponAndCreditChatbotAction' }
                          | { __typename: 'CouponsAndCreditsSimpleAction' }
                          | { __typename: 'CrossSellButtonAction' }
                          | { __typename: 'CrossSellLinkAction' }
                          | { __typename: 'CruiseAction' }
                          | { __typename: 'DirectFeedbackOpenFormAction' }
                          | { __typename: 'DirectFeedbackOpenNextPageAction' }
                          | { __typename: 'DirectFeedbackOpenPreviousPageAction' }
                          | { __typename: 'DirectFeedbackSubmitFormAction' }
                          | { __typename: 'EGDSOpenDatePickerAction' }
                          | { __typename: 'EGDSOpenTravelerSelectorAction' }
                          | { __typename: 'EGDSSubmitSearchFormAction' }
                          | { __typename: 'FlightsCreditSelectorOpenUIAction' }
                          | { __typename: 'FlightsDialogCloseUIAction' }
                          | { __typename: 'FlightsDialogTriggerUIAction' }
                          | { __typename: 'MemberWalletBadge' }
                          | { __typename: 'MemberWalletUIAction' }
                          | { __typename: 'MishopDetailsUIAction' }
                          | { __typename: 'MultiItemCrossSellUIButtonAction' }
                          | { __typename: 'MultiItemCrossSellUICheckoutButtonAction' }
                          | { __typename: 'MultiItemCrossSellUILinkAction' }
                          | { __typename: 'OpenTypeaheadAction' }
                          | { __typename: 'PaymentDialogButtonAction' }
                          | { __typename: 'PriceInsightsCardDisclaimerToolTipAction' }
                          | { __typename: 'PriceInsightsExistingDialogButtonAction' }
                          | { __typename: 'PriceInsightsRetryTrackingDialogButtonAction' }
                          | { __typename: 'ProfileAccountFormSubmitAction' }
                          | { __typename: 'ProfileAddMembershipAction' }
                          | { __typename: 'ProfileAddPassportAction' }
                          | { __typename: 'ProfileFormSubmitAction' }
                          | { __typename: 'ProfileLinkAction' }
                          | { __typename: 'ProfileReloadAction' }
                          | { __typename: 'ProfileRewardProgramFormAction' }
                          | { __typename: 'ProfileUpdateMembershipAction' }
                          | { __typename: 'ProfileUpdatePassportAction' }
                          | { __typename: 'QuoteAction' }
                          | { __typename: 'ShoppingSortAndFilterAction' }
                          | { __typename: 'SupplyNavigationHeaderSearchTrigger' }
                          | { __typename: 'TripsRetryOperationAction' }
                          | { __typename: 'UIFlightAction' }
                          | {
                              __typename: 'UILinkAction';
                              resource:
                                | { __typename: 'BasicURI'; value: string }
                                | { __typename: 'ClipboardURI'; value: string }
                                | { __typename: 'FBMessengerURI'; value: string }
                                | { __typename: 'GenericURI'; value: string }
                                | { __typename: 'GeoURI'; value: string }
                                | { __typename: 'HttpURI'; value: string }
                                | { __typename: 'MailToURI'; value: string }
                                | { __typename: 'MobileAppURI'; value: string }
                                | { __typename: 'RelativeURI'; value: string }
                                | { __typename: 'SMSToURI'; value: string }
                                | { __typename: 'SelfReferencedURI'; value: string }
                                | { __typename: 'TelURI'; value: string }
                                | { __typename: 'Uri'; value: string }
                                | { __typename: 'WhatsappURI'; value: string };
                            }
                          | { __typename: 'WizardAdditionalUserInputRequiredAction' }
                          | { __typename: 'WizardSubmitAction' }
                          | null;
                      };
                }
            >;
          }
        | {
            __typename: 'UnSupportedBooking';
            heading: string;
            description: string;
            clickstreamPayload: {
              __typename: 'BookingActionsClickStreamAnalytics';
              event: {
                __typename: 'Event';
                eventName: string;
                eventType: string;
                eventCategory?: string | null;
                eventVersion?: string | null;
                actionLocation?: string | null;
                actionReason?: string | null;
              };
              tripDetail?: Array<{ __typename: 'ClickStreamTripInfo'; tripDomainId?: string | null }> | null;
              experience: {
                __typename: 'Experience';
                pageName: string;
                appName: string;
                appVersion: string;
                pageNameDetailed: string;
              };
              workFlowList?: Array<{
                __typename: 'WorkFlow';
                intent: string;
                orderLineId?: string | null;
                productLine: string;
                subIntent?: string | null;
                automationStatus: string;
                automationStatusReason: string;
                channel: string;
              }> | null;
            };
            goToTrips?: {
              __typename: 'UISecondaryButton';
              primary?: string | null;
              icon?: { __typename: 'Icon'; id: string; description: string; token: string } | null;
              action?:
                | {
                    __typename: 'ActivityAddOfferToTripAction';
                    accessibility?: string | null;
                    analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                  }
                | {
                    __typename: 'ActivityCloseDialogAction';
                    accessibility?: string | null;
                    analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                  }
                | {
                    __typename: 'ActivityMultiItemTripUpdateAction';
                    accessibility?: string | null;
                    analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                  }
                | {
                    __typename: 'ActivityOpenDialogAction';
                    accessibility?: string | null;
                    analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                  }
                | {
                    __typename: 'ActivityOpenOffersModalAction';
                    accessibility?: string | null;
                    analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                  }
                | {
                    __typename: 'ActivityPaginationAction';
                    accessibility?: string | null;
                    analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                  }
                | {
                    __typename: 'ActivityRemoveOffersFromTripAction';
                    accessibility?: string | null;
                    analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                  }
                | {
                    __typename: 'ActivityUpdateOfferInTripAction';
                    accessibility?: string | null;
                    analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                  }
                | {
                    __typename: 'AgencyQuoteAction';
                    accessibility?: string | null;
                    analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                  }
                | {
                    __typename: 'AirCreditWebAction';
                    accessibility?: string | null;
                    analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                  }
                | {
                    __typename: 'BannerPlacementServiceUILinkAction';
                    accessibility?: string | null;
                    analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                  }
                | {
                    __typename: 'CouponAndCreditAction';
                    accessibility?: string | null;
                    analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                  }
                | {
                    __typename: 'CouponAndCreditChatbotAction';
                    accessibility?: string | null;
                    analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                  }
                | {
                    __typename: 'CouponsAndCreditsSimpleAction';
                    accessibility?: string | null;
                    analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                  }
                | {
                    __typename: 'CrossSellButtonAction';
                    accessibility?: string | null;
                    analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                  }
                | {
                    __typename: 'CrossSellLinkAction';
                    accessibility?: string | null;
                    analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                  }
                | {
                    __typename: 'CruiseAction';
                    accessibility?: string | null;
                    analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                  }
                | {
                    __typename: 'DirectFeedbackOpenFormAction';
                    accessibility?: string | null;
                    analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                  }
                | {
                    __typename: 'DirectFeedbackOpenNextPageAction';
                    accessibility?: string | null;
                    analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                  }
                | {
                    __typename: 'DirectFeedbackOpenPreviousPageAction';
                    accessibility?: string | null;
                    analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                  }
                | {
                    __typename: 'DirectFeedbackSubmitFormAction';
                    accessibility?: string | null;
                    analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                  }
                | {
                    __typename: 'EGDSOpenDatePickerAction';
                    accessibility?: string | null;
                    analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                  }
                | {
                    __typename: 'EGDSOpenTravelerSelectorAction';
                    accessibility?: string | null;
                    analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                  }
                | {
                    __typename: 'EGDSSubmitSearchFormAction';
                    accessibility?: string | null;
                    analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                  }
                | {
                    __typename: 'FlightsCreditSelectorOpenUIAction';
                    accessibility?: string | null;
                    analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                  }
                | {
                    __typename: 'FlightsDialogCloseUIAction';
                    accessibility?: string | null;
                    analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                  }
                | {
                    __typename: 'FlightsDialogTriggerUIAction';
                    accessibility?: string | null;
                    analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                  }
                | {
                    __typename: 'MemberWalletBadge';
                    accessibility?: string | null;
                    analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                  }
                | {
                    __typename: 'MemberWalletUIAction';
                    accessibility?: string | null;
                    analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                  }
                | {
                    __typename: 'MishopDetailsUIAction';
                    accessibility?: string | null;
                    analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                  }
                | {
                    __typename: 'MultiItemCrossSellUIButtonAction';
                    accessibility: string;
                    analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                  }
                | {
                    __typename: 'MultiItemCrossSellUICheckoutButtonAction';
                    accessibility: string;
                    analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                  }
                | {
                    __typename: 'MultiItemCrossSellUILinkAction';
                    accessibility: string;
                    analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                  }
                | {
                    __typename: 'OpenTypeaheadAction';
                    accessibility?: string | null;
                    analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                  }
                | {
                    __typename: 'PaymentDialogButtonAction';
                    accessibility?: string | null;
                    analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                  }
                | {
                    __typename: 'PriceInsightsCardDisclaimerToolTipAction';
                    accessibility: string;
                    analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                  }
                | {
                    __typename: 'PriceInsightsExistingDialogButtonAction';
                    accessibility?: string | null;
                    analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                  }
                | {
                    __typename: 'PriceInsightsRetryTrackingDialogButtonAction';
                    accessibility?: string | null;
                    analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                  }
                | {
                    __typename: 'ProfileAccountFormSubmitAction';
                    accessibility?: string | null;
                    analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                  }
                | {
                    __typename: 'ProfileAddMembershipAction';
                    accessibility?: string | null;
                    analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                  }
                | {
                    __typename: 'ProfileAddPassportAction';
                    accessibility?: string | null;
                    analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                  }
                | {
                    __typename: 'ProfileFormSubmitAction';
                    accessibility?: string | null;
                    analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                  }
                | {
                    __typename: 'ProfileLinkAction';
                    accessibility?: string | null;
                    analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                  }
                | {
                    __typename: 'ProfileReloadAction';
                    accessibility?: string | null;
                    analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                  }
                | {
                    __typename: 'ProfileRewardProgramFormAction';
                    accessibility?: string | null;
                    analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                  }
                | {
                    __typename: 'ProfileUpdateMembershipAction';
                    accessibility?: string | null;
                    analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                  }
                | {
                    __typename: 'ProfileUpdatePassportAction';
                    accessibility?: string | null;
                    analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                  }
                | {
                    __typename: 'QuoteAction';
                    accessibility?: string | null;
                    analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                  }
                | {
                    __typename: 'ShoppingSortAndFilterAction';
                    accessibility?: string | null;
                    analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                  }
                | {
                    __typename: 'SupplyNavigationHeaderSearchTrigger';
                    accessibility: string;
                    analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                  }
                | {
                    __typename: 'TripsRetryOperationAction';
                    accessibility?: string | null;
                    analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                  }
                | {
                    __typename: 'UIFlightAction';
                    accessibility?: string | null;
                    analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                  }
                | {
                    __typename: 'UILinkAction';
                    accessibility?: string | null;
                    resource:
                      | { __typename: 'BasicURI'; value: string }
                      | { __typename: 'ClipboardURI'; value: string }
                      | { __typename: 'FBMessengerURI'; value: string }
                      | { __typename: 'GenericURI'; value: string }
                      | { __typename: 'GeoURI'; value: string }
                      | { __typename: 'HttpURI'; value: string }
                      | { __typename: 'MailToURI'; value: string }
                      | { __typename: 'MobileAppURI'; value: string }
                      | { __typename: 'RelativeURI'; value: string }
                      | { __typename: 'SMSToURI'; value: string }
                      | { __typename: 'SelfReferencedURI'; value: string }
                      | { __typename: 'TelURI'; value: string }
                      | { __typename: 'Uri'; value: string }
                      | { __typename: 'WhatsappURI'; value: string };
                    analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                  }
                | {
                    __typename: 'WizardAdditionalUserInputRequiredAction';
                    accessibility?: string | null;
                    analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                  }
                | {
                    __typename: 'WizardSubmitAction';
                    accessibility?: string | null;
                    analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                  }
                | null;
            } | null;
          }
      > | null;
    }> | null;
  }> | null;
};

export type BookingActionsClickStreamAnalyticsFragmentFragment = {
  __typename: 'BookingActionsClickStreamAnalytics';
  event: {
    __typename: 'Event';
    eventName: string;
    eventType: string;
    eventCategory?: string | null;
    eventVersion?: string | null;
    actionLocation?: string | null;
    actionReason?: string | null;
  };
  tripDetail?: Array<{ __typename: 'ClickStreamTripInfo'; tripDomainId?: string | null }> | null;
  experience: {
    __typename: 'Experience';
    pageName: string;
    appName: string;
    appVersion: string;
    pageNameDetailed: string;
  };
  workFlowList?: Array<{
    __typename: 'WorkFlow';
    intent: string;
    orderLineId?: string | null;
    productLine: string;
    subIntent?: string | null;
    automationStatus: string;
    automationStatusReason: string;
    channel: string;
  }> | null;
};

export type BannerFieldsFragment = {
  __typename: 'HelpCenterWelcomeBanner';
  heading: string;
  subHeading?: string | null;
  heroImage?: { __typename: 'Image'; url: any; description: string } | null;
};

export type ClickstreamAnalyticsEventFragment = {
  __typename: 'EGClickstreamEvent';
  eventName: string;
  eventType: string;
  eventCategory: string;
  eventVersion: string;
  actionLocation?: string | null;
};

export type ClickstreamAnalyticsExperienceFragment = {
  __typename: 'Experience';
  appName: string;
  appVersion: string;
  pageName: string;
  pageNameDetailed: string;
};

export type UpdateUserStateAndSendMessageMutationVariables = Exact<{
  context: ContextInput;
  conversationId?: InputMaybe<Scalars['String']>;
  travelerParticipantId?: InputMaybe<Scalars['String']>;
}>;

export type UpdateUserStateAndSendMessageMutation = {
  __typename: 'Mutation';
  updateUserStateAndSendMessage: {
    __typename: 'ConversationAuthenticationView';
    updateUserStateAndSendMessageView: {
      __typename: 'ConversationAuthenticationResponse';
      success: boolean;
      conversationAuthenticationHeading:
        | { __typename: 'EGDSBasicLocalizedText'; text: string }
        | { __typename: 'EGDSCardinalLocalizedText'; text: string }
        | { __typename: 'EGDSCompositeLocalizedText'; text: string }
        | { __typename: 'EGDSGraphicText'; text: string }
        | { __typename: 'EGDSHeading'; text: string }
        | { __typename: 'EGDSIconText'; text: string }
        | { __typename: 'EGDSInlineLink'; text: string }
        | { __typename: 'EGDSLocalizedTextTemplate'; text: string }
        | { __typename: 'EGDSParagraph'; text: string }
        | { __typename: 'EGDSPlainText'; text: string }
        | { __typename: 'EGDSSpannableText'; text: string }
        | { __typename: 'EGDSStandardLink'; text: string }
        | { __typename: 'EGDSStylizedText'; text: string }
        | { __typename: 'EGDSTextIconLinkListItem'; text: string }
        | { __typename: 'EGDSTextIconListItem'; text: string }
        | { __typename: 'EGDSTextStandardListItem'; text: string }
        | { __typename: 'EGDSTextWithMarkListItem'; text: string };
      conversationAuthenticationText:
        | { __typename: 'EGDSBasicLocalizedText'; text: string }
        | { __typename: 'EGDSCardinalLocalizedText'; text: string }
        | { __typename: 'EGDSCompositeLocalizedText'; text: string }
        | { __typename: 'EGDSGraphicText'; text: string }
        | { __typename: 'EGDSHeading'; text: string }
        | { __typename: 'EGDSIconText'; text: string }
        | { __typename: 'EGDSInlineLink'; text: string }
        | { __typename: 'EGDSLocalizedTextTemplate'; text: string }
        | { __typename: 'EGDSParagraph'; text: string }
        | { __typename: 'EGDSPlainText'; text: string }
        | { __typename: 'EGDSSpannableText'; text: string }
        | { __typename: 'EGDSStandardLink'; text: string }
        | { __typename: 'EGDSStylizedText'; text: string }
        | { __typename: 'EGDSTextIconLinkListItem'; text: string }
        | { __typename: 'EGDSTextIconListItem'; text: string }
        | { __typename: 'EGDSTextStandardListItem'; text: string }
        | { __typename: 'EGDSTextWithMarkListItem'; text: string };
    };
  };
};

export type getHelpCenterConfigQueryVariables = Exact<{
  context: ContextInput;
}>;

export type getHelpCenterConfigQuery = {
  __typename: 'Query';
  helpCenterPersonalization: {
    __typename: 'HelpCenterComponentsView';
    helpCenterPersonalizedView: {
      __typename: 'HelpCenterPersonalizationData';
      vaLayoutVariant?: number | null;
      isVacEnabled?: boolean | null;
      helpArticleTitle: string;
      intentButtonsHeading: string;
      banner: {
        __typename: 'HelpCenterWelcomeBanner';
        heading: string;
        subHeading?: string | null;
        heroImage?: { __typename: 'Image'; url: any; description: string } | null;
      };
      taapAcademyComponent?: {
        __typename: 'TaapAcademyComponent';
        heading: string;
        description: string;
        iconUrl: string;
        academyLink?: {
          __typename: 'EGDSInlineLink';
          text: string;
          action: {
            __typename: 'UILinkAction';
            accessibility?: string | null;
            resource:
              | { __typename: 'BasicURI'; value: string }
              | { __typename: 'ClipboardURI'; value: string }
              | { __typename: 'FBMessengerURI'; value: string }
              | { __typename: 'GenericURI'; value: string }
              | { __typename: 'GeoURI'; value: string }
              | { __typename: 'HttpURI'; value: string }
              | { __typename: 'MailToURI'; value: string }
              | { __typename: 'MobileAppURI'; value: string }
              | { __typename: 'RelativeURI'; value: string }
              | { __typename: 'SMSToURI'; value: string }
              | { __typename: 'SelfReferencedURI'; value: string }
              | { __typename: 'TelURI'; value: string }
              | { __typename: 'Uri'; value: string }
              | { __typename: 'WhatsappURI'; value: string };
          };
        } | null;
      } | null;
      travelerTripDetailedOverview?: {
        __typename: 'HelpCenterTripDetailedOverview';
        header?: string | null;
        allTrips?: Array<{
          __typename: 'TripCategory';
          header: string;
          tabTitle: string;
          tripInfos?: Array<{
            __typename: 'HelpCenterTripInfo';
            backToTripButton: string;
            header?: string | null;
            tripName?: string | null;
            timePeriod?: string | null;
            numberOfBooking?: string | null;
            image?: { __typename: 'Image'; description: string; url: any } | null;
            bookingIcons?: Array<{ __typename: 'Icon'; id: string }> | null;
            tripBookings?: Array<
              | {
                  __typename: 'BookingDetail';
                  timePeriod: string;
                  itineraryNumberText?: string | null;
                  title: string;
                  product: string;
                  isDisable: boolean;
                  icon: { __typename: 'Icon'; id: string };
                  helpCenterIntentButton: {
                    __typename: 'HelpCenterIntentButtons';
                    skillName: string;
                    vaText?: string | null;
                    payload?: string | null;
                    name: { __typename: 'UIPrimaryButton'; primary?: string | null };
                  };
                  bookingActions: Array<
                    | { __typename: 'HelpCenterBookingActionButton' }
                    | {
                        __typename: 'HelpCenterBookingButtons';
                        name: {
                          __typename: 'UISecondaryButton';
                          primary?: string | null;
                          action?:
                            | {
                                __typename: 'ActivityAddOfferToTripAction';
                                accessibility?: string | null;
                                analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                              }
                            | {
                                __typename: 'ActivityCloseDialogAction';
                                accessibility?: string | null;
                                analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                              }
                            | {
                                __typename: 'ActivityMultiItemTripUpdateAction';
                                accessibility?: string | null;
                                analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                              }
                            | {
                                __typename: 'ActivityOpenDialogAction';
                                accessibility?: string | null;
                                analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                              }
                            | {
                                __typename: 'ActivityOpenOffersModalAction';
                                accessibility?: string | null;
                                analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                              }
                            | {
                                __typename: 'ActivityPaginationAction';
                                accessibility?: string | null;
                                analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                              }
                            | {
                                __typename: 'ActivityRemoveOffersFromTripAction';
                                accessibility?: string | null;
                                analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                              }
                            | {
                                __typename: 'ActivityUpdateOfferInTripAction';
                                accessibility?: string | null;
                                analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                              }
                            | {
                                __typename: 'AgencyQuoteAction';
                                accessibility?: string | null;
                                analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                              }
                            | {
                                __typename: 'AirCreditWebAction';
                                accessibility?: string | null;
                                analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                              }
                            | {
                                __typename: 'BannerPlacementServiceUILinkAction';
                                accessibility?: string | null;
                                analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                              }
                            | {
                                __typename: 'CouponAndCreditAction';
                                accessibility?: string | null;
                                analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                              }
                            | {
                                __typename: 'CouponAndCreditChatbotAction';
                                accessibility?: string | null;
                                analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                              }
                            | {
                                __typename: 'CouponsAndCreditsSimpleAction';
                                accessibility?: string | null;
                                analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                              }
                            | {
                                __typename: 'CrossSellButtonAction';
                                accessibility?: string | null;
                                analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                              }
                            | {
                                __typename: 'CrossSellLinkAction';
                                accessibility?: string | null;
                                analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                              }
                            | {
                                __typename: 'CruiseAction';
                                accessibility?: string | null;
                                analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                              }
                            | {
                                __typename: 'DirectFeedbackOpenFormAction';
                                accessibility?: string | null;
                                analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                              }
                            | {
                                __typename: 'DirectFeedbackOpenNextPageAction';
                                accessibility?: string | null;
                                analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                              }
                            | {
                                __typename: 'DirectFeedbackOpenPreviousPageAction';
                                accessibility?: string | null;
                                analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                              }
                            | {
                                __typename: 'DirectFeedbackSubmitFormAction';
                                accessibility?: string | null;
                                analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                              }
                            | {
                                __typename: 'EGDSOpenDatePickerAction';
                                accessibility?: string | null;
                                analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                              }
                            | {
                                __typename: 'EGDSOpenTravelerSelectorAction';
                                accessibility?: string | null;
                                analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                              }
                            | {
                                __typename: 'EGDSSubmitSearchFormAction';
                                accessibility?: string | null;
                                analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                              }
                            | {
                                __typename: 'FlightsCreditSelectorOpenUIAction';
                                accessibility?: string | null;
                                analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                              }
                            | {
                                __typename: 'FlightsDialogCloseUIAction';
                                accessibility?: string | null;
                                analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                              }
                            | {
                                __typename: 'FlightsDialogTriggerUIAction';
                                accessibility?: string | null;
                                analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                              }
                            | {
                                __typename: 'MemberWalletBadge';
                                accessibility?: string | null;
                                analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                              }
                            | {
                                __typename: 'MemberWalletUIAction';
                                accessibility?: string | null;
                                analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                              }
                            | {
                                __typename: 'MishopDetailsUIAction';
                                accessibility?: string | null;
                                analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                              }
                            | {
                                __typename: 'MultiItemCrossSellUIButtonAction';
                                accessibility: string;
                                analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                              }
                            | {
                                __typename: 'MultiItemCrossSellUICheckoutButtonAction';
                                accessibility: string;
                                analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                              }
                            | {
                                __typename: 'MultiItemCrossSellUILinkAction';
                                accessibility: string;
                                analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                              }
                            | {
                                __typename: 'OpenTypeaheadAction';
                                accessibility?: string | null;
                                analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                              }
                            | {
                                __typename: 'PaymentDialogButtonAction';
                                accessibility?: string | null;
                                analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                              }
                            | {
                                __typename: 'PriceInsightsCardDisclaimerToolTipAction';
                                accessibility: string;
                                analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                              }
                            | {
                                __typename: 'PriceInsightsExistingDialogButtonAction';
                                accessibility?: string | null;
                                analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                              }
                            | {
                                __typename: 'PriceInsightsRetryTrackingDialogButtonAction';
                                accessibility?: string | null;
                                analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                              }
                            | {
                                __typename: 'ProfileAccountFormSubmitAction';
                                accessibility?: string | null;
                                analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                              }
                            | {
                                __typename: 'ProfileAddMembershipAction';
                                accessibility?: string | null;
                                analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                              }
                            | {
                                __typename: 'ProfileAddPassportAction';
                                accessibility?: string | null;
                                analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                              }
                            | {
                                __typename: 'ProfileFormSubmitAction';
                                accessibility?: string | null;
                                analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                              }
                            | {
                                __typename: 'ProfileLinkAction';
                                accessibility?: string | null;
                                analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                              }
                            | {
                                __typename: 'ProfileReloadAction';
                                accessibility?: string | null;
                                analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                              }
                            | {
                                __typename: 'ProfileRewardProgramFormAction';
                                accessibility?: string | null;
                                analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                              }
                            | {
                                __typename: 'ProfileUpdateMembershipAction';
                                accessibility?: string | null;
                                analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                              }
                            | {
                                __typename: 'ProfileUpdatePassportAction';
                                accessibility?: string | null;
                                analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                              }
                            | {
                                __typename: 'QuoteAction';
                                accessibility?: string | null;
                                analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                              }
                            | {
                                __typename: 'ShoppingSortAndFilterAction';
                                accessibility?: string | null;
                                analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                              }
                            | {
                                __typename: 'SupplyNavigationHeaderSearchTrigger';
                                accessibility: string;
                                analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                              }
                            | {
                                __typename: 'TripsRetryOperationAction';
                                accessibility?: string | null;
                                analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                              }
                            | {
                                __typename: 'UIFlightAction';
                                accessibility?: string | null;
                                analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                              }
                            | {
                                __typename: 'UILinkAction';
                                accessibility?: string | null;
                                resource:
                                  | { __typename: 'BasicURI'; value: string }
                                  | { __typename: 'ClipboardURI'; value: string }
                                  | { __typename: 'FBMessengerURI'; value: string }
                                  | { __typename: 'GenericURI'; value: string }
                                  | { __typename: 'GeoURI'; value: string }
                                  | { __typename: 'HttpURI'; value: string }
                                  | { __typename: 'MailToURI'; value: string }
                                  | { __typename: 'MobileAppURI'; value: string }
                                  | { __typename: 'RelativeURI'; value: string }
                                  | { __typename: 'SMSToURI'; value: string }
                                  | { __typename: 'SelfReferencedURI'; value: string }
                                  | { __typename: 'TelURI'; value: string }
                                  | { __typename: 'Uri'; value: string }
                                  | { __typename: 'WhatsappURI'; value: string };
                                analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                              }
                            | {
                                __typename: 'WizardAdditionalUserInputRequiredAction';
                                accessibility?: string | null;
                                analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                              }
                            | {
                                __typename: 'WizardSubmitAction';
                                accessibility?: string | null;
                                analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                              }
                            | null;
                        };
                      }
                    | {
                        __typename: 'HelpCenterIntentButtons';
                        skillName: string;
                        vaText?: string | null;
                        payload?: string | null;
                        name: { __typename: 'UIPrimaryButton'; primary?: string | null };
                        bookingActionsClickStreamAnalytics?: {
                          __typename: 'BookingActionsClickStreamAnalytics';
                          event: {
                            __typename: 'Event';
                            eventName: string;
                            eventType: string;
                            eventCategory?: string | null;
                            eventVersion?: string | null;
                            actionLocation?: string | null;
                            actionReason?: string | null;
                          };
                          tripDetail?: Array<{
                            __typename: 'ClickStreamTripInfo';
                            tripDomainId?: string | null;
                          }> | null;
                          experience: {
                            __typename: 'Experience';
                            pageName: string;
                            appName: string;
                            appVersion: string;
                            pageNameDetailed: string;
                          };
                          workFlowList?: Array<{
                            __typename: 'WorkFlow';
                            intent: string;
                            orderLineId?: string | null;
                            productLine: string;
                            subIntent?: string | null;
                            automationStatus: string;
                            automationStatusReason: string;
                            channel: string;
                          }> | null;
                        } | null;
                      }
                    | {
                        __typename: 'HelpCenterLinkButton';
                        name:
                          | {
                              __typename: 'EGDSOverlayButton';
                              primary?: string | null;
                              action?: {
                                __typename: 'UILinkAction';
                                resource:
                                  | { __typename: 'BasicURI'; value: string }
                                  | { __typename: 'ClipboardURI'; value: string }
                                  | { __typename: 'FBMessengerURI'; value: string }
                                  | { __typename: 'GenericURI'; value: string }
                                  | { __typename: 'GeoURI'; value: string }
                                  | { __typename: 'HttpURI'; value: string }
                                  | { __typename: 'MailToURI'; value: string }
                                  | { __typename: 'MobileAppURI'; value: string }
                                  | { __typename: 'RelativeURI'; value: string }
                                  | { __typename: 'SMSToURI'; value: string }
                                  | { __typename: 'SelfReferencedURI'; value: string }
                                  | { __typename: 'TelURI'; value: string }
                                  | { __typename: 'Uri'; value: string }
                                  | { __typename: 'WhatsappURI'; value: string };
                              } | null;
                            }
                          | {
                              __typename: 'EGDSSearchFormButton';
                              primary?: string | null;
                              action?:
                                | { __typename: 'ActivityAddOfferToTripAction' }
                                | { __typename: 'ActivityCloseDialogAction' }
                                | { __typename: 'ActivityMultiItemTripUpdateAction' }
                                | { __typename: 'ActivityOpenDialogAction' }
                                | { __typename: 'ActivityOpenOffersModalAction' }
                                | { __typename: 'ActivityPaginationAction' }
                                | { __typename: 'ActivityRemoveOffersFromTripAction' }
                                | { __typename: 'ActivityUpdateOfferInTripAction' }
                                | { __typename: 'AgencyQuoteAction' }
                                | { __typename: 'AirCreditWebAction' }
                                | { __typename: 'BannerPlacementServiceUILinkAction' }
                                | { __typename: 'CouponAndCreditAction' }
                                | { __typename: 'CouponAndCreditChatbotAction' }
                                | { __typename: 'CouponsAndCreditsSimpleAction' }
                                | { __typename: 'CrossSellButtonAction' }
                                | { __typename: 'CrossSellLinkAction' }
                                | { __typename: 'CruiseAction' }
                                | { __typename: 'DirectFeedbackOpenFormAction' }
                                | { __typename: 'DirectFeedbackOpenNextPageAction' }
                                | { __typename: 'DirectFeedbackOpenPreviousPageAction' }
                                | { __typename: 'DirectFeedbackSubmitFormAction' }
                                | { __typename: 'EGDSOpenDatePickerAction' }
                                | { __typename: 'EGDSOpenTravelerSelectorAction' }
                                | { __typename: 'EGDSSubmitSearchFormAction' }
                                | { __typename: 'FlightsCreditSelectorOpenUIAction' }
                                | { __typename: 'FlightsDialogCloseUIAction' }
                                | { __typename: 'FlightsDialogTriggerUIAction' }
                                | { __typename: 'MemberWalletBadge' }
                                | { __typename: 'MemberWalletUIAction' }
                                | { __typename: 'MishopDetailsUIAction' }
                                | { __typename: 'MultiItemCrossSellUIButtonAction' }
                                | { __typename: 'MultiItemCrossSellUICheckoutButtonAction' }
                                | { __typename: 'MultiItemCrossSellUILinkAction' }
                                | { __typename: 'OpenTypeaheadAction' }
                                | { __typename: 'PaymentDialogButtonAction' }
                                | { __typename: 'PriceInsightsCardDisclaimerToolTipAction' }
                                | { __typename: 'PriceInsightsExistingDialogButtonAction' }
                                | { __typename: 'PriceInsightsRetryTrackingDialogButtonAction' }
                                | { __typename: 'ProfileAccountFormSubmitAction' }
                                | { __typename: 'ProfileAddMembershipAction' }
                                | { __typename: 'ProfileAddPassportAction' }
                                | { __typename: 'ProfileFormSubmitAction' }
                                | { __typename: 'ProfileLinkAction' }
                                | { __typename: 'ProfileReloadAction' }
                                | { __typename: 'ProfileRewardProgramFormAction' }
                                | { __typename: 'ProfileUpdateMembershipAction' }
                                | { __typename: 'ProfileUpdatePassportAction' }
                                | { __typename: 'QuoteAction' }
                                | { __typename: 'ShoppingSortAndFilterAction' }
                                | { __typename: 'SupplyNavigationHeaderSearchTrigger' }
                                | { __typename: 'TripsRetryOperationAction' }
                                | { __typename: 'UIFlightAction' }
                                | {
                                    __typename: 'UILinkAction';
                                    resource:
                                      | { __typename: 'BasicURI'; value: string }
                                      | { __typename: 'ClipboardURI'; value: string }
                                      | { __typename: 'FBMessengerURI'; value: string }
                                      | { __typename: 'GenericURI'; value: string }
                                      | { __typename: 'GeoURI'; value: string }
                                      | { __typename: 'HttpURI'; value: string }
                                      | { __typename: 'MailToURI'; value: string }
                                      | { __typename: 'MobileAppURI'; value: string }
                                      | { __typename: 'RelativeURI'; value: string }
                                      | { __typename: 'SMSToURI'; value: string }
                                      | { __typename: 'SelfReferencedURI'; value: string }
                                      | { __typename: 'TelURI'; value: string }
                                      | { __typename: 'Uri'; value: string }
                                      | { __typename: 'WhatsappURI'; value: string };
                                  }
                                | { __typename: 'WizardAdditionalUserInputRequiredAction' }
                                | { __typename: 'WizardSubmitAction' }
                                | null;
                            }
                          | {
                              __typename: 'FlightsActionButton';
                              primary?: string | null;
                              action?:
                                | { __typename: 'ActivityAddOfferToTripAction' }
                                | { __typename: 'ActivityCloseDialogAction' }
                                | { __typename: 'ActivityMultiItemTripUpdateAction' }
                                | { __typename: 'ActivityOpenDialogAction' }
                                | { __typename: 'ActivityOpenOffersModalAction' }
                                | { __typename: 'ActivityPaginationAction' }
                                | { __typename: 'ActivityRemoveOffersFromTripAction' }
                                | { __typename: 'ActivityUpdateOfferInTripAction' }
                                | { __typename: 'AgencyQuoteAction' }
                                | { __typename: 'AirCreditWebAction' }
                                | { __typename: 'BannerPlacementServiceUILinkAction' }
                                | { __typename: 'CouponAndCreditAction' }
                                | { __typename: 'CouponAndCreditChatbotAction' }
                                | { __typename: 'CouponsAndCreditsSimpleAction' }
                                | { __typename: 'CrossSellButtonAction' }
                                | { __typename: 'CrossSellLinkAction' }
                                | { __typename: 'CruiseAction' }
                                | { __typename: 'DirectFeedbackOpenFormAction' }
                                | { __typename: 'DirectFeedbackOpenNextPageAction' }
                                | { __typename: 'DirectFeedbackOpenPreviousPageAction' }
                                | { __typename: 'DirectFeedbackSubmitFormAction' }
                                | { __typename: 'EGDSOpenDatePickerAction' }
                                | { __typename: 'EGDSOpenTravelerSelectorAction' }
                                | { __typename: 'EGDSSubmitSearchFormAction' }
                                | { __typename: 'FlightsCreditSelectorOpenUIAction' }
                                | { __typename: 'FlightsDialogCloseUIAction' }
                                | { __typename: 'FlightsDialogTriggerUIAction' }
                                | { __typename: 'MemberWalletBadge' }
                                | { __typename: 'MemberWalletUIAction' }
                                | { __typename: 'MishopDetailsUIAction' }
                                | { __typename: 'MultiItemCrossSellUIButtonAction' }
                                | { __typename: 'MultiItemCrossSellUICheckoutButtonAction' }
                                | { __typename: 'MultiItemCrossSellUILinkAction' }
                                | { __typename: 'OpenTypeaheadAction' }
                                | { __typename: 'PaymentDialogButtonAction' }
                                | { __typename: 'PriceInsightsCardDisclaimerToolTipAction' }
                                | { __typename: 'PriceInsightsExistingDialogButtonAction' }
                                | { __typename: 'PriceInsightsRetryTrackingDialogButtonAction' }
                                | { __typename: 'ProfileAccountFormSubmitAction' }
                                | { __typename: 'ProfileAddMembershipAction' }
                                | { __typename: 'ProfileAddPassportAction' }
                                | { __typename: 'ProfileFormSubmitAction' }
                                | { __typename: 'ProfileLinkAction' }
                                | { __typename: 'ProfileReloadAction' }
                                | { __typename: 'ProfileRewardProgramFormAction' }
                                | { __typename: 'ProfileUpdateMembershipAction' }
                                | { __typename: 'ProfileUpdatePassportAction' }
                                | { __typename: 'QuoteAction' }
                                | { __typename: 'ShoppingSortAndFilterAction' }
                                | { __typename: 'SupplyNavigationHeaderSearchTrigger' }
                                | { __typename: 'TripsRetryOperationAction' }
                                | { __typename: 'UIFlightAction' }
                                | {
                                    __typename: 'UILinkAction';
                                    resource:
                                      | { __typename: 'BasicURI'; value: string }
                                      | { __typename: 'ClipboardURI'; value: string }
                                      | { __typename: 'FBMessengerURI'; value: string }
                                      | { __typename: 'GenericURI'; value: string }
                                      | { __typename: 'GeoURI'; value: string }
                                      | { __typename: 'HttpURI'; value: string }
                                      | { __typename: 'MailToURI'; value: string }
                                      | { __typename: 'MobileAppURI'; value: string }
                                      | { __typename: 'RelativeURI'; value: string }
                                      | { __typename: 'SMSToURI'; value: string }
                                      | { __typename: 'SelfReferencedURI'; value: string }
                                      | { __typename: 'TelURI'; value: string }
                                      | { __typename: 'Uri'; value: string }
                                      | { __typename: 'WhatsappURI'; value: string };
                                  }
                                | { __typename: 'WizardAdditionalUserInputRequiredAction' }
                                | { __typename: 'WizardSubmitAction' }
                                | null;
                            }
                          | {
                              __typename: 'FlightsDialogTrigger';
                              primary?: string | null;
                              action?:
                                | { __typename: 'ActivityAddOfferToTripAction' }
                                | { __typename: 'ActivityCloseDialogAction' }
                                | { __typename: 'ActivityMultiItemTripUpdateAction' }
                                | { __typename: 'ActivityOpenDialogAction' }
                                | { __typename: 'ActivityOpenOffersModalAction' }
                                | { __typename: 'ActivityPaginationAction' }
                                | { __typename: 'ActivityRemoveOffersFromTripAction' }
                                | { __typename: 'ActivityUpdateOfferInTripAction' }
                                | { __typename: 'AgencyQuoteAction' }
                                | { __typename: 'AirCreditWebAction' }
                                | { __typename: 'BannerPlacementServiceUILinkAction' }
                                | { __typename: 'CouponAndCreditAction' }
                                | { __typename: 'CouponAndCreditChatbotAction' }
                                | { __typename: 'CouponsAndCreditsSimpleAction' }
                                | { __typename: 'CrossSellButtonAction' }
                                | { __typename: 'CrossSellLinkAction' }
                                | { __typename: 'CruiseAction' }
                                | { __typename: 'DirectFeedbackOpenFormAction' }
                                | { __typename: 'DirectFeedbackOpenNextPageAction' }
                                | { __typename: 'DirectFeedbackOpenPreviousPageAction' }
                                | { __typename: 'DirectFeedbackSubmitFormAction' }
                                | { __typename: 'EGDSOpenDatePickerAction' }
                                | { __typename: 'EGDSOpenTravelerSelectorAction' }
                                | { __typename: 'EGDSSubmitSearchFormAction' }
                                | { __typename: 'FlightsCreditSelectorOpenUIAction' }
                                | { __typename: 'FlightsDialogCloseUIAction' }
                                | { __typename: 'FlightsDialogTriggerUIAction' }
                                | { __typename: 'MemberWalletBadge' }
                                | { __typename: 'MemberWalletUIAction' }
                                | { __typename: 'MishopDetailsUIAction' }
                                | { __typename: 'MultiItemCrossSellUIButtonAction' }
                                | { __typename: 'MultiItemCrossSellUICheckoutButtonAction' }
                                | { __typename: 'MultiItemCrossSellUILinkAction' }
                                | { __typename: 'OpenTypeaheadAction' }
                                | { __typename: 'PaymentDialogButtonAction' }
                                | { __typename: 'PriceInsightsCardDisclaimerToolTipAction' }
                                | { __typename: 'PriceInsightsExistingDialogButtonAction' }
                                | { __typename: 'PriceInsightsRetryTrackingDialogButtonAction' }
                                | { __typename: 'ProfileAccountFormSubmitAction' }
                                | { __typename: 'ProfileAddMembershipAction' }
                                | { __typename: 'ProfileAddPassportAction' }
                                | { __typename: 'ProfileFormSubmitAction' }
                                | { __typename: 'ProfileLinkAction' }
                                | { __typename: 'ProfileReloadAction' }
                                | { __typename: 'ProfileRewardProgramFormAction' }
                                | { __typename: 'ProfileUpdateMembershipAction' }
                                | { __typename: 'ProfileUpdatePassportAction' }
                                | { __typename: 'QuoteAction' }
                                | { __typename: 'ShoppingSortAndFilterAction' }
                                | { __typename: 'SupplyNavigationHeaderSearchTrigger' }
                                | { __typename: 'TripsRetryOperationAction' }
                                | { __typename: 'UIFlightAction' }
                                | {
                                    __typename: 'UILinkAction';
                                    resource:
                                      | { __typename: 'BasicURI'; value: string }
                                      | { __typename: 'ClipboardURI'; value: string }
                                      | { __typename: 'FBMessengerURI'; value: string }
                                      | { __typename: 'GenericURI'; value: string }
                                      | { __typename: 'GeoURI'; value: string }
                                      | { __typename: 'HttpURI'; value: string }
                                      | { __typename: 'MailToURI'; value: string }
                                      | { __typename: 'MobileAppURI'; value: string }
                                      | { __typename: 'RelativeURI'; value: string }
                                      | { __typename: 'SMSToURI'; value: string }
                                      | { __typename: 'SelfReferencedURI'; value: string }
                                      | { __typename: 'TelURI'; value: string }
                                      | { __typename: 'Uri'; value: string }
                                      | { __typename: 'WhatsappURI'; value: string };
                                  }
                                | { __typename: 'WizardAdditionalUserInputRequiredAction' }
                                | { __typename: 'WizardSubmitAction' }
                                | null;
                            }
                          | {
                              __typename: 'FlightsExperienceActionButton';
                              primary?: string | null;
                              action?:
                                | { __typename: 'ActivityAddOfferToTripAction' }
                                | { __typename: 'ActivityCloseDialogAction' }
                                | { __typename: 'ActivityMultiItemTripUpdateAction' }
                                | { __typename: 'ActivityOpenDialogAction' }
                                | { __typename: 'ActivityOpenOffersModalAction' }
                                | { __typename: 'ActivityPaginationAction' }
                                | { __typename: 'ActivityRemoveOffersFromTripAction' }
                                | { __typename: 'ActivityUpdateOfferInTripAction' }
                                | { __typename: 'AgencyQuoteAction' }
                                | { __typename: 'AirCreditWebAction' }
                                | { __typename: 'BannerPlacementServiceUILinkAction' }
                                | { __typename: 'CouponAndCreditAction' }
                                | { __typename: 'CouponAndCreditChatbotAction' }
                                | { __typename: 'CouponsAndCreditsSimpleAction' }
                                | { __typename: 'CrossSellButtonAction' }
                                | { __typename: 'CrossSellLinkAction' }
                                | { __typename: 'CruiseAction' }
                                | { __typename: 'DirectFeedbackOpenFormAction' }
                                | { __typename: 'DirectFeedbackOpenNextPageAction' }
                                | { __typename: 'DirectFeedbackOpenPreviousPageAction' }
                                | { __typename: 'DirectFeedbackSubmitFormAction' }
                                | { __typename: 'EGDSOpenDatePickerAction' }
                                | { __typename: 'EGDSOpenTravelerSelectorAction' }
                                | { __typename: 'EGDSSubmitSearchFormAction' }
                                | { __typename: 'FlightsCreditSelectorOpenUIAction' }
                                | { __typename: 'FlightsDialogCloseUIAction' }
                                | { __typename: 'FlightsDialogTriggerUIAction' }
                                | { __typename: 'MemberWalletBadge' }
                                | { __typename: 'MemberWalletUIAction' }
                                | { __typename: 'MishopDetailsUIAction' }
                                | { __typename: 'MultiItemCrossSellUIButtonAction' }
                                | { __typename: 'MultiItemCrossSellUICheckoutButtonAction' }
                                | { __typename: 'MultiItemCrossSellUILinkAction' }
                                | { __typename: 'OpenTypeaheadAction' }
                                | { __typename: 'PaymentDialogButtonAction' }
                                | { __typename: 'PriceInsightsCardDisclaimerToolTipAction' }
                                | { __typename: 'PriceInsightsExistingDialogButtonAction' }
                                | { __typename: 'PriceInsightsRetryTrackingDialogButtonAction' }
                                | { __typename: 'ProfileAccountFormSubmitAction' }
                                | { __typename: 'ProfileAddMembershipAction' }
                                | { __typename: 'ProfileAddPassportAction' }
                                | { __typename: 'ProfileFormSubmitAction' }
                                | { __typename: 'ProfileLinkAction' }
                                | { __typename: 'ProfileReloadAction' }
                                | { __typename: 'ProfileRewardProgramFormAction' }
                                | { __typename: 'ProfileUpdateMembershipAction' }
                                | { __typename: 'ProfileUpdatePassportAction' }
                                | { __typename: 'QuoteAction' }
                                | { __typename: 'ShoppingSortAndFilterAction' }
                                | { __typename: 'SupplyNavigationHeaderSearchTrigger' }
                                | { __typename: 'TripsRetryOperationAction' }
                                | { __typename: 'UIFlightAction' }
                                | {
                                    __typename: 'UILinkAction';
                                    resource:
                                      | { __typename: 'BasicURI'; value: string }
                                      | { __typename: 'ClipboardURI'; value: string }
                                      | { __typename: 'FBMessengerURI'; value: string }
                                      | { __typename: 'GenericURI'; value: string }
                                      | { __typename: 'GeoURI'; value: string }
                                      | { __typename: 'HttpURI'; value: string }
                                      | { __typename: 'MailToURI'; value: string }
                                      | { __typename: 'MobileAppURI'; value: string }
                                      | { __typename: 'RelativeURI'; value: string }
                                      | { __typename: 'SMSToURI'; value: string }
                                      | { __typename: 'SelfReferencedURI'; value: string }
                                      | { __typename: 'TelURI'; value: string }
                                      | { __typename: 'Uri'; value: string }
                                      | { __typename: 'WhatsappURI'; value: string };
                                  }
                                | { __typename: 'WizardAdditionalUserInputRequiredAction' }
                                | { __typename: 'WizardSubmitAction' }
                                | null;
                            }
                          | {
                              __typename: 'InsurTechExperienceDialogTrigger';
                              primary?: string | null;
                              action?:
                                | { __typename: 'ActivityAddOfferToTripAction' }
                                | { __typename: 'ActivityCloseDialogAction' }
                                | { __typename: 'ActivityMultiItemTripUpdateAction' }
                                | { __typename: 'ActivityOpenDialogAction' }
                                | { __typename: 'ActivityOpenOffersModalAction' }
                                | { __typename: 'ActivityPaginationAction' }
                                | { __typename: 'ActivityRemoveOffersFromTripAction' }
                                | { __typename: 'ActivityUpdateOfferInTripAction' }
                                | { __typename: 'AgencyQuoteAction' }
                                | { __typename: 'AirCreditWebAction' }
                                | { __typename: 'BannerPlacementServiceUILinkAction' }
                                | { __typename: 'CouponAndCreditAction' }
                                | { __typename: 'CouponAndCreditChatbotAction' }
                                | { __typename: 'CouponsAndCreditsSimpleAction' }
                                | { __typename: 'CrossSellButtonAction' }
                                | { __typename: 'CrossSellLinkAction' }
                                | { __typename: 'CruiseAction' }
                                | { __typename: 'DirectFeedbackOpenFormAction' }
                                | { __typename: 'DirectFeedbackOpenNextPageAction' }
                                | { __typename: 'DirectFeedbackOpenPreviousPageAction' }
                                | { __typename: 'DirectFeedbackSubmitFormAction' }
                                | { __typename: 'EGDSOpenDatePickerAction' }
                                | { __typename: 'EGDSOpenTravelerSelectorAction' }
                                | { __typename: 'EGDSSubmitSearchFormAction' }
                                | { __typename: 'FlightsCreditSelectorOpenUIAction' }
                                | { __typename: 'FlightsDialogCloseUIAction' }
                                | { __typename: 'FlightsDialogTriggerUIAction' }
                                | { __typename: 'MemberWalletBadge' }
                                | { __typename: 'MemberWalletUIAction' }
                                | { __typename: 'MishopDetailsUIAction' }
                                | { __typename: 'MultiItemCrossSellUIButtonAction' }
                                | { __typename: 'MultiItemCrossSellUICheckoutButtonAction' }
                                | { __typename: 'MultiItemCrossSellUILinkAction' }
                                | { __typename: 'OpenTypeaheadAction' }
                                | { __typename: 'PaymentDialogButtonAction' }
                                | { __typename: 'PriceInsightsCardDisclaimerToolTipAction' }
                                | { __typename: 'PriceInsightsExistingDialogButtonAction' }
                                | { __typename: 'PriceInsightsRetryTrackingDialogButtonAction' }
                                | { __typename: 'ProfileAccountFormSubmitAction' }
                                | { __typename: 'ProfileAddMembershipAction' }
                                | { __typename: 'ProfileAddPassportAction' }
                                | { __typename: 'ProfileFormSubmitAction' }
                                | { __typename: 'ProfileLinkAction' }
                                | { __typename: 'ProfileReloadAction' }
                                | { __typename: 'ProfileRewardProgramFormAction' }
                                | { __typename: 'ProfileUpdateMembershipAction' }
                                | { __typename: 'ProfileUpdatePassportAction' }
                                | { __typename: 'QuoteAction' }
                                | { __typename: 'ShoppingSortAndFilterAction' }
                                | { __typename: 'SupplyNavigationHeaderSearchTrigger' }
                                | { __typename: 'TripsRetryOperationAction' }
                                | { __typename: 'UIFlightAction' }
                                | {
                                    __typename: 'UILinkAction';
                                    resource:
                                      | { __typename: 'BasicURI'; value: string }
                                      | { __typename: 'ClipboardURI'; value: string }
                                      | { __typename: 'FBMessengerURI'; value: string }
                                      | { __typename: 'GenericURI'; value: string }
                                      | { __typename: 'GeoURI'; value: string }
                                      | { __typename: 'HttpURI'; value: string }
                                      | { __typename: 'MailToURI'; value: string }
                                      | { __typename: 'MobileAppURI'; value: string }
                                      | { __typename: 'RelativeURI'; value: string }
                                      | { __typename: 'SMSToURI'; value: string }
                                      | { __typename: 'SelfReferencedURI'; value: string }
                                      | { __typename: 'TelURI'; value: string }
                                      | { __typename: 'Uri'; value: string }
                                      | { __typename: 'WhatsappURI'; value: string };
                                  }
                                | { __typename: 'WizardAdditionalUserInputRequiredAction' }
                                | { __typename: 'WizardSubmitAction' }
                                | null;
                            }
                          | {
                              __typename: 'PackageUIActionDialogFooterButton';
                              primary?: string | null;
                              action?:
                                | { __typename: 'ActivityAddOfferToTripAction' }
                                | { __typename: 'ActivityCloseDialogAction' }
                                | { __typename: 'ActivityMultiItemTripUpdateAction' }
                                | { __typename: 'ActivityOpenDialogAction' }
                                | { __typename: 'ActivityOpenOffersModalAction' }
                                | { __typename: 'ActivityPaginationAction' }
                                | { __typename: 'ActivityRemoveOffersFromTripAction' }
                                | { __typename: 'ActivityUpdateOfferInTripAction' }
                                | { __typename: 'AgencyQuoteAction' }
                                | { __typename: 'AirCreditWebAction' }
                                | { __typename: 'BannerPlacementServiceUILinkAction' }
                                | { __typename: 'CouponAndCreditAction' }
                                | { __typename: 'CouponAndCreditChatbotAction' }
                                | { __typename: 'CouponsAndCreditsSimpleAction' }
                                | { __typename: 'CrossSellButtonAction' }
                                | { __typename: 'CrossSellLinkAction' }
                                | { __typename: 'CruiseAction' }
                                | { __typename: 'DirectFeedbackOpenFormAction' }
                                | { __typename: 'DirectFeedbackOpenNextPageAction' }
                                | { __typename: 'DirectFeedbackOpenPreviousPageAction' }
                                | { __typename: 'DirectFeedbackSubmitFormAction' }
                                | { __typename: 'EGDSOpenDatePickerAction' }
                                | { __typename: 'EGDSOpenTravelerSelectorAction' }
                                | { __typename: 'EGDSSubmitSearchFormAction' }
                                | { __typename: 'FlightsCreditSelectorOpenUIAction' }
                                | { __typename: 'FlightsDialogCloseUIAction' }
                                | { __typename: 'FlightsDialogTriggerUIAction' }
                                | { __typename: 'MemberWalletBadge' }
                                | { __typename: 'MemberWalletUIAction' }
                                | { __typename: 'MishopDetailsUIAction' }
                                | { __typename: 'MultiItemCrossSellUIButtonAction' }
                                | { __typename: 'MultiItemCrossSellUICheckoutButtonAction' }
                                | { __typename: 'MultiItemCrossSellUILinkAction' }
                                | { __typename: 'OpenTypeaheadAction' }
                                | { __typename: 'PaymentDialogButtonAction' }
                                | { __typename: 'PriceInsightsCardDisclaimerToolTipAction' }
                                | { __typename: 'PriceInsightsExistingDialogButtonAction' }
                                | { __typename: 'PriceInsightsRetryTrackingDialogButtonAction' }
                                | { __typename: 'ProfileAccountFormSubmitAction' }
                                | { __typename: 'ProfileAddMembershipAction' }
                                | { __typename: 'ProfileAddPassportAction' }
                                | { __typename: 'ProfileFormSubmitAction' }
                                | { __typename: 'ProfileLinkAction' }
                                | { __typename: 'ProfileReloadAction' }
                                | { __typename: 'ProfileRewardProgramFormAction' }
                                | { __typename: 'ProfileUpdateMembershipAction' }
                                | { __typename: 'ProfileUpdatePassportAction' }
                                | { __typename: 'QuoteAction' }
                                | { __typename: 'ShoppingSortAndFilterAction' }
                                | { __typename: 'SupplyNavigationHeaderSearchTrigger' }
                                | { __typename: 'TripsRetryOperationAction' }
                                | { __typename: 'UIFlightAction' }
                                | {
                                    __typename: 'UILinkAction';
                                    resource:
                                      | { __typename: 'BasicURI'; value: string }
                                      | { __typename: 'ClipboardURI'; value: string }
                                      | { __typename: 'FBMessengerURI'; value: string }
                                      | { __typename: 'GenericURI'; value: string }
                                      | { __typename: 'GeoURI'; value: string }
                                      | { __typename: 'HttpURI'; value: string }
                                      | { __typename: 'MailToURI'; value: string }
                                      | { __typename: 'MobileAppURI'; value: string }
                                      | { __typename: 'RelativeURI'; value: string }
                                      | { __typename: 'SMSToURI'; value: string }
                                      | { __typename: 'SelfReferencedURI'; value: string }
                                      | { __typename: 'TelURI'; value: string }
                                      | { __typename: 'Uri'; value: string }
                                      | { __typename: 'WhatsappURI'; value: string };
                                  }
                                | { __typename: 'WizardAdditionalUserInputRequiredAction' }
                                | { __typename: 'WizardSubmitAction' }
                                | null;
                            }
                          | {
                              __typename: 'PackageUIHideSearchFormAction';
                              primary?: string | null;
                              action?:
                                | { __typename: 'ActivityAddOfferToTripAction' }
                                | { __typename: 'ActivityCloseDialogAction' }
                                | { __typename: 'ActivityMultiItemTripUpdateAction' }
                                | { __typename: 'ActivityOpenDialogAction' }
                                | { __typename: 'ActivityOpenOffersModalAction' }
                                | { __typename: 'ActivityPaginationAction' }
                                | { __typename: 'ActivityRemoveOffersFromTripAction' }
                                | { __typename: 'ActivityUpdateOfferInTripAction' }
                                | { __typename: 'AgencyQuoteAction' }
                                | { __typename: 'AirCreditWebAction' }
                                | { __typename: 'BannerPlacementServiceUILinkAction' }
                                | { __typename: 'CouponAndCreditAction' }
                                | { __typename: 'CouponAndCreditChatbotAction' }
                                | { __typename: 'CouponsAndCreditsSimpleAction' }
                                | { __typename: 'CrossSellButtonAction' }
                                | { __typename: 'CrossSellLinkAction' }
                                | { __typename: 'CruiseAction' }
                                | { __typename: 'DirectFeedbackOpenFormAction' }
                                | { __typename: 'DirectFeedbackOpenNextPageAction' }
                                | { __typename: 'DirectFeedbackOpenPreviousPageAction' }
                                | { __typename: 'DirectFeedbackSubmitFormAction' }
                                | { __typename: 'EGDSOpenDatePickerAction' }
                                | { __typename: 'EGDSOpenTravelerSelectorAction' }
                                | { __typename: 'EGDSSubmitSearchFormAction' }
                                | { __typename: 'FlightsCreditSelectorOpenUIAction' }
                                | { __typename: 'FlightsDialogCloseUIAction' }
                                | { __typename: 'FlightsDialogTriggerUIAction' }
                                | { __typename: 'MemberWalletBadge' }
                                | { __typename: 'MemberWalletUIAction' }
                                | { __typename: 'MishopDetailsUIAction' }
                                | { __typename: 'MultiItemCrossSellUIButtonAction' }
                                | { __typename: 'MultiItemCrossSellUICheckoutButtonAction' }
                                | { __typename: 'MultiItemCrossSellUILinkAction' }
                                | { __typename: 'OpenTypeaheadAction' }
                                | { __typename: 'PaymentDialogButtonAction' }
                                | { __typename: 'PriceInsightsCardDisclaimerToolTipAction' }
                                | { __typename: 'PriceInsightsExistingDialogButtonAction' }
                                | { __typename: 'PriceInsightsRetryTrackingDialogButtonAction' }
                                | { __typename: 'ProfileAccountFormSubmitAction' }
                                | { __typename: 'ProfileAddMembershipAction' }
                                | { __typename: 'ProfileAddPassportAction' }
                                | { __typename: 'ProfileFormSubmitAction' }
                                | { __typename: 'ProfileLinkAction' }
                                | { __typename: 'ProfileReloadAction' }
                                | { __typename: 'ProfileRewardProgramFormAction' }
                                | { __typename: 'ProfileUpdateMembershipAction' }
                                | { __typename: 'ProfileUpdatePassportAction' }
                                | { __typename: 'QuoteAction' }
                                | { __typename: 'ShoppingSortAndFilterAction' }
                                | { __typename: 'SupplyNavigationHeaderSearchTrigger' }
                                | { __typename: 'TripsRetryOperationAction' }
                                | { __typename: 'UIFlightAction' }
                                | {
                                    __typename: 'UILinkAction';
                                    resource:
                                      | { __typename: 'BasicURI'; value: string }
                                      | { __typename: 'ClipboardURI'; value: string }
                                      | { __typename: 'FBMessengerURI'; value: string }
                                      | { __typename: 'GenericURI'; value: string }
                                      | { __typename: 'GeoURI'; value: string }
                                      | { __typename: 'HttpURI'; value: string }
                                      | { __typename: 'MailToURI'; value: string }
                                      | { __typename: 'MobileAppURI'; value: string }
                                      | { __typename: 'RelativeURI'; value: string }
                                      | { __typename: 'SMSToURI'; value: string }
                                      | { __typename: 'SelfReferencedURI'; value: string }
                                      | { __typename: 'TelURI'; value: string }
                                      | { __typename: 'Uri'; value: string }
                                      | { __typename: 'WhatsappURI'; value: string };
                                  }
                                | { __typename: 'WizardAdditionalUserInputRequiredAction' }
                                | { __typename: 'WizardSubmitAction' }
                                | null;
                            }
                          | {
                              __typename: 'PackageUITravelGuideButton';
                              primary?: string | null;
                              action?:
                                | { __typename: 'ActivityAddOfferToTripAction' }
                                | { __typename: 'ActivityCloseDialogAction' }
                                | { __typename: 'ActivityMultiItemTripUpdateAction' }
                                | { __typename: 'ActivityOpenDialogAction' }
                                | { __typename: 'ActivityOpenOffersModalAction' }
                                | { __typename: 'ActivityPaginationAction' }
                                | { __typename: 'ActivityRemoveOffersFromTripAction' }
                                | { __typename: 'ActivityUpdateOfferInTripAction' }
                                | { __typename: 'AgencyQuoteAction' }
                                | { __typename: 'AirCreditWebAction' }
                                | { __typename: 'BannerPlacementServiceUILinkAction' }
                                | { __typename: 'CouponAndCreditAction' }
                                | { __typename: 'CouponAndCreditChatbotAction' }
                                | { __typename: 'CouponsAndCreditsSimpleAction' }
                                | { __typename: 'CrossSellButtonAction' }
                                | { __typename: 'CrossSellLinkAction' }
                                | { __typename: 'CruiseAction' }
                                | { __typename: 'DirectFeedbackOpenFormAction' }
                                | { __typename: 'DirectFeedbackOpenNextPageAction' }
                                | { __typename: 'DirectFeedbackOpenPreviousPageAction' }
                                | { __typename: 'DirectFeedbackSubmitFormAction' }
                                | { __typename: 'EGDSOpenDatePickerAction' }
                                | { __typename: 'EGDSOpenTravelerSelectorAction' }
                                | { __typename: 'EGDSSubmitSearchFormAction' }
                                | { __typename: 'FlightsCreditSelectorOpenUIAction' }
                                | { __typename: 'FlightsDialogCloseUIAction' }
                                | { __typename: 'FlightsDialogTriggerUIAction' }
                                | { __typename: 'MemberWalletBadge' }
                                | { __typename: 'MemberWalletUIAction' }
                                | { __typename: 'MishopDetailsUIAction' }
                                | { __typename: 'MultiItemCrossSellUIButtonAction' }
                                | { __typename: 'MultiItemCrossSellUICheckoutButtonAction' }
                                | { __typename: 'MultiItemCrossSellUILinkAction' }
                                | { __typename: 'OpenTypeaheadAction' }
                                | { __typename: 'PaymentDialogButtonAction' }
                                | { __typename: 'PriceInsightsCardDisclaimerToolTipAction' }
                                | { __typename: 'PriceInsightsExistingDialogButtonAction' }
                                | { __typename: 'PriceInsightsRetryTrackingDialogButtonAction' }
                                | { __typename: 'ProfileAccountFormSubmitAction' }
                                | { __typename: 'ProfileAddMembershipAction' }
                                | { __typename: 'ProfileAddPassportAction' }
                                | { __typename: 'ProfileFormSubmitAction' }
                                | { __typename: 'ProfileLinkAction' }
                                | { __typename: 'ProfileReloadAction' }
                                | { __typename: 'ProfileRewardProgramFormAction' }
                                | { __typename: 'ProfileUpdateMembershipAction' }
                                | { __typename: 'ProfileUpdatePassportAction' }
                                | { __typename: 'QuoteAction' }
                                | { __typename: 'ShoppingSortAndFilterAction' }
                                | { __typename: 'SupplyNavigationHeaderSearchTrigger' }
                                | { __typename: 'TripsRetryOperationAction' }
                                | { __typename: 'UIFlightAction' }
                                | {
                                    __typename: 'UILinkAction';
                                    resource:
                                      | { __typename: 'BasicURI'; value: string }
                                      | { __typename: 'ClipboardURI'; value: string }
                                      | { __typename: 'FBMessengerURI'; value: string }
                                      | { __typename: 'GenericURI'; value: string }
                                      | { __typename: 'GeoURI'; value: string }
                                      | { __typename: 'HttpURI'; value: string }
                                      | { __typename: 'MailToURI'; value: string }
                                      | { __typename: 'MobileAppURI'; value: string }
                                      | { __typename: 'RelativeURI'; value: string }
                                      | { __typename: 'SMSToURI'; value: string }
                                      | { __typename: 'SelfReferencedURI'; value: string }
                                      | { __typename: 'TelURI'; value: string }
                                      | { __typename: 'Uri'; value: string }
                                      | { __typename: 'WhatsappURI'; value: string };
                                  }
                                | { __typename: 'WizardAdditionalUserInputRequiredAction' }
                                | { __typename: 'WizardSubmitAction' }
                                | null;
                            }
                          | {
                              __typename: 'SupplyCancelWaiverActionButton';
                              primary: string;
                              action?: {
                                __typename: 'UILinkAction';
                                resource:
                                  | { __typename: 'BasicURI'; value: string }
                                  | { __typename: 'ClipboardURI'; value: string }
                                  | { __typename: 'FBMessengerURI'; value: string }
                                  | { __typename: 'GenericURI'; value: string }
                                  | { __typename: 'GeoURI'; value: string }
                                  | { __typename: 'HttpURI'; value: string }
                                  | { __typename: 'MailToURI'; value: string }
                                  | { __typename: 'MobileAppURI'; value: string }
                                  | { __typename: 'RelativeURI'; value: string }
                                  | { __typename: 'SMSToURI'; value: string }
                                  | { __typename: 'SelfReferencedURI'; value: string }
                                  | { __typename: 'TelURI'; value: string }
                                  | { __typename: 'Uri'; value: string }
                                  | { __typename: 'WhatsappURI'; value: string };
                              } | null;
                            }
                          | {
                              __typename: 'SupplyContentLinkStyleButton';
                              primary?: string | null;
                              action?: {
                                __typename: 'UILinkAction';
                                resource:
                                  | { __typename: 'BasicURI'; value: string }
                                  | { __typename: 'ClipboardURI'; value: string }
                                  | { __typename: 'FBMessengerURI'; value: string }
                                  | { __typename: 'GenericURI'; value: string }
                                  | { __typename: 'GeoURI'; value: string }
                                  | { __typename: 'HttpURI'; value: string }
                                  | { __typename: 'MailToURI'; value: string }
                                  | { __typename: 'MobileAppURI'; value: string }
                                  | { __typename: 'RelativeURI'; value: string }
                                  | { __typename: 'SMSToURI'; value: string }
                                  | { __typename: 'SelfReferencedURI'; value: string }
                                  | { __typename: 'TelURI'; value: string }
                                  | { __typename: 'Uri'; value: string }
                                  | { __typename: 'WhatsappURI'; value: string };
                              } | null;
                            }
                          | {
                              __typename: 'UIPrimaryButton';
                              primary?: string | null;
                              action?:
                                | { __typename: 'ActivityAddOfferToTripAction' }
                                | { __typename: 'ActivityCloseDialogAction' }
                                | { __typename: 'ActivityMultiItemTripUpdateAction' }
                                | { __typename: 'ActivityOpenDialogAction' }
                                | { __typename: 'ActivityOpenOffersModalAction' }
                                | { __typename: 'ActivityPaginationAction' }
                                | { __typename: 'ActivityRemoveOffersFromTripAction' }
                                | { __typename: 'ActivityUpdateOfferInTripAction' }
                                | { __typename: 'AgencyQuoteAction' }
                                | { __typename: 'AirCreditWebAction' }
                                | { __typename: 'BannerPlacementServiceUILinkAction' }
                                | { __typename: 'CouponAndCreditAction' }
                                | { __typename: 'CouponAndCreditChatbotAction' }
                                | { __typename: 'CouponsAndCreditsSimpleAction' }
                                | { __typename: 'CrossSellButtonAction' }
                                | { __typename: 'CrossSellLinkAction' }
                                | { __typename: 'CruiseAction' }
                                | { __typename: 'DirectFeedbackOpenFormAction' }
                                | { __typename: 'DirectFeedbackOpenNextPageAction' }
                                | { __typename: 'DirectFeedbackOpenPreviousPageAction' }
                                | { __typename: 'DirectFeedbackSubmitFormAction' }
                                | { __typename: 'EGDSOpenDatePickerAction' }
                                | { __typename: 'EGDSOpenTravelerSelectorAction' }
                                | { __typename: 'EGDSSubmitSearchFormAction' }
                                | { __typename: 'FlightsCreditSelectorOpenUIAction' }
                                | { __typename: 'FlightsDialogCloseUIAction' }
                                | { __typename: 'FlightsDialogTriggerUIAction' }
                                | { __typename: 'MemberWalletBadge' }
                                | { __typename: 'MemberWalletUIAction' }
                                | { __typename: 'MishopDetailsUIAction' }
                                | { __typename: 'MultiItemCrossSellUIButtonAction' }
                                | { __typename: 'MultiItemCrossSellUICheckoutButtonAction' }
                                | { __typename: 'MultiItemCrossSellUILinkAction' }
                                | { __typename: 'OpenTypeaheadAction' }
                                | { __typename: 'PaymentDialogButtonAction' }
                                | { __typename: 'PriceInsightsCardDisclaimerToolTipAction' }
                                | { __typename: 'PriceInsightsExistingDialogButtonAction' }
                                | { __typename: 'PriceInsightsRetryTrackingDialogButtonAction' }
                                | { __typename: 'ProfileAccountFormSubmitAction' }
                                | { __typename: 'ProfileAddMembershipAction' }
                                | { __typename: 'ProfileAddPassportAction' }
                                | { __typename: 'ProfileFormSubmitAction' }
                                | { __typename: 'ProfileLinkAction' }
                                | { __typename: 'ProfileReloadAction' }
                                | { __typename: 'ProfileRewardProgramFormAction' }
                                | { __typename: 'ProfileUpdateMembershipAction' }
                                | { __typename: 'ProfileUpdatePassportAction' }
                                | { __typename: 'QuoteAction' }
                                | { __typename: 'ShoppingSortAndFilterAction' }
                                | { __typename: 'SupplyNavigationHeaderSearchTrigger' }
                                | { __typename: 'TripsRetryOperationAction' }
                                | { __typename: 'UIFlightAction' }
                                | {
                                    __typename: 'UILinkAction';
                                    resource:
                                      | { __typename: 'BasicURI'; value: string }
                                      | { __typename: 'ClipboardURI'; value: string }
                                      | { __typename: 'FBMessengerURI'; value: string }
                                      | { __typename: 'GenericURI'; value: string }
                                      | { __typename: 'GeoURI'; value: string }
                                      | { __typename: 'HttpURI'; value: string }
                                      | { __typename: 'MailToURI'; value: string }
                                      | { __typename: 'MobileAppURI'; value: string }
                                      | { __typename: 'RelativeURI'; value: string }
                                      | { __typename: 'SMSToURI'; value: string }
                                      | { __typename: 'SelfReferencedURI'; value: string }
                                      | { __typename: 'TelURI'; value: string }
                                      | { __typename: 'Uri'; value: string }
                                      | { __typename: 'WhatsappURI'; value: string };
                                  }
                                | { __typename: 'WizardAdditionalUserInputRequiredAction' }
                                | { __typename: 'WizardSubmitAction' }
                                | null;
                            }
                          | {
                              __typename: 'UISecondaryButton';
                              primary?: string | null;
                              action?:
                                | { __typename: 'ActivityAddOfferToTripAction' }
                                | { __typename: 'ActivityCloseDialogAction' }
                                | { __typename: 'ActivityMultiItemTripUpdateAction' }
                                | { __typename: 'ActivityOpenDialogAction' }
                                | { __typename: 'ActivityOpenOffersModalAction' }
                                | { __typename: 'ActivityPaginationAction' }
                                | { __typename: 'ActivityRemoveOffersFromTripAction' }
                                | { __typename: 'ActivityUpdateOfferInTripAction' }
                                | { __typename: 'AgencyQuoteAction' }
                                | { __typename: 'AirCreditWebAction' }
                                | { __typename: 'BannerPlacementServiceUILinkAction' }
                                | { __typename: 'CouponAndCreditAction' }
                                | { __typename: 'CouponAndCreditChatbotAction' }
                                | { __typename: 'CouponsAndCreditsSimpleAction' }
                                | { __typename: 'CrossSellButtonAction' }
                                | { __typename: 'CrossSellLinkAction' }
                                | { __typename: 'CruiseAction' }
                                | { __typename: 'DirectFeedbackOpenFormAction' }
                                | { __typename: 'DirectFeedbackOpenNextPageAction' }
                                | { __typename: 'DirectFeedbackOpenPreviousPageAction' }
                                | { __typename: 'DirectFeedbackSubmitFormAction' }
                                | { __typename: 'EGDSOpenDatePickerAction' }
                                | { __typename: 'EGDSOpenTravelerSelectorAction' }
                                | { __typename: 'EGDSSubmitSearchFormAction' }
                                | { __typename: 'FlightsCreditSelectorOpenUIAction' }
                                | { __typename: 'FlightsDialogCloseUIAction' }
                                | { __typename: 'FlightsDialogTriggerUIAction' }
                                | { __typename: 'MemberWalletBadge' }
                                | { __typename: 'MemberWalletUIAction' }
                                | { __typename: 'MishopDetailsUIAction' }
                                | { __typename: 'MultiItemCrossSellUIButtonAction' }
                                | { __typename: 'MultiItemCrossSellUICheckoutButtonAction' }
                                | { __typename: 'MultiItemCrossSellUILinkAction' }
                                | { __typename: 'OpenTypeaheadAction' }
                                | { __typename: 'PaymentDialogButtonAction' }
                                | { __typename: 'PriceInsightsCardDisclaimerToolTipAction' }
                                | { __typename: 'PriceInsightsExistingDialogButtonAction' }
                                | { __typename: 'PriceInsightsRetryTrackingDialogButtonAction' }
                                | { __typename: 'ProfileAccountFormSubmitAction' }
                                | { __typename: 'ProfileAddMembershipAction' }
                                | { __typename: 'ProfileAddPassportAction' }
                                | { __typename: 'ProfileFormSubmitAction' }
                                | { __typename: 'ProfileLinkAction' }
                                | { __typename: 'ProfileReloadAction' }
                                | { __typename: 'ProfileRewardProgramFormAction' }
                                | { __typename: 'ProfileUpdateMembershipAction' }
                                | { __typename: 'ProfileUpdatePassportAction' }
                                | { __typename: 'QuoteAction' }
                                | { __typename: 'ShoppingSortAndFilterAction' }
                                | { __typename: 'SupplyNavigationHeaderSearchTrigger' }
                                | { __typename: 'TripsRetryOperationAction' }
                                | { __typename: 'UIFlightAction' }
                                | {
                                    __typename: 'UILinkAction';
                                    resource:
                                      | { __typename: 'BasicURI'; value: string }
                                      | { __typename: 'ClipboardURI'; value: string }
                                      | { __typename: 'FBMessengerURI'; value: string }
                                      | { __typename: 'GenericURI'; value: string }
                                      | { __typename: 'GeoURI'; value: string }
                                      | { __typename: 'HttpURI'; value: string }
                                      | { __typename: 'MailToURI'; value: string }
                                      | { __typename: 'MobileAppURI'; value: string }
                                      | { __typename: 'RelativeURI'; value: string }
                                      | { __typename: 'SMSToURI'; value: string }
                                      | { __typename: 'SelfReferencedURI'; value: string }
                                      | { __typename: 'TelURI'; value: string }
                                      | { __typename: 'Uri'; value: string }
                                      | { __typename: 'WhatsappURI'; value: string };
                                  }
                                | { __typename: 'WizardAdditionalUserInputRequiredAction' }
                                | { __typename: 'WizardSubmitAction' }
                                | null;
                            }
                          | {
                              __typename: 'UITertiaryButton';
                              primary?: string | null;
                              action?:
                                | { __typename: 'ActivityAddOfferToTripAction' }
                                | { __typename: 'ActivityCloseDialogAction' }
                                | { __typename: 'ActivityMultiItemTripUpdateAction' }
                                | { __typename: 'ActivityOpenDialogAction' }
                                | { __typename: 'ActivityOpenOffersModalAction' }
                                | { __typename: 'ActivityPaginationAction' }
                                | { __typename: 'ActivityRemoveOffersFromTripAction' }
                                | { __typename: 'ActivityUpdateOfferInTripAction' }
                                | { __typename: 'AgencyQuoteAction' }
                                | { __typename: 'AirCreditWebAction' }
                                | { __typename: 'BannerPlacementServiceUILinkAction' }
                                | { __typename: 'CouponAndCreditAction' }
                                | { __typename: 'CouponAndCreditChatbotAction' }
                                | { __typename: 'CouponsAndCreditsSimpleAction' }
                                | { __typename: 'CrossSellButtonAction' }
                                | { __typename: 'CrossSellLinkAction' }
                                | { __typename: 'CruiseAction' }
                                | { __typename: 'DirectFeedbackOpenFormAction' }
                                | { __typename: 'DirectFeedbackOpenNextPageAction' }
                                | { __typename: 'DirectFeedbackOpenPreviousPageAction' }
                                | { __typename: 'DirectFeedbackSubmitFormAction' }
                                | { __typename: 'EGDSOpenDatePickerAction' }
                                | { __typename: 'EGDSOpenTravelerSelectorAction' }
                                | { __typename: 'EGDSSubmitSearchFormAction' }
                                | { __typename: 'FlightsCreditSelectorOpenUIAction' }
                                | { __typename: 'FlightsDialogCloseUIAction' }
                                | { __typename: 'FlightsDialogTriggerUIAction' }
                                | { __typename: 'MemberWalletBadge' }
                                | { __typename: 'MemberWalletUIAction' }
                                | { __typename: 'MishopDetailsUIAction' }
                                | { __typename: 'MultiItemCrossSellUIButtonAction' }
                                | { __typename: 'MultiItemCrossSellUICheckoutButtonAction' }
                                | { __typename: 'MultiItemCrossSellUILinkAction' }
                                | { __typename: 'OpenTypeaheadAction' }
                                | { __typename: 'PaymentDialogButtonAction' }
                                | { __typename: 'PriceInsightsCardDisclaimerToolTipAction' }
                                | { __typename: 'PriceInsightsExistingDialogButtonAction' }
                                | { __typename: 'PriceInsightsRetryTrackingDialogButtonAction' }
                                | { __typename: 'ProfileAccountFormSubmitAction' }
                                | { __typename: 'ProfileAddMembershipAction' }
                                | { __typename: 'ProfileAddPassportAction' }
                                | { __typename: 'ProfileFormSubmitAction' }
                                | { __typename: 'ProfileLinkAction' }
                                | { __typename: 'ProfileReloadAction' }
                                | { __typename: 'ProfileRewardProgramFormAction' }
                                | { __typename: 'ProfileUpdateMembershipAction' }
                                | { __typename: 'ProfileUpdatePassportAction' }
                                | { __typename: 'QuoteAction' }
                                | { __typename: 'ShoppingSortAndFilterAction' }
                                | { __typename: 'SupplyNavigationHeaderSearchTrigger' }
                                | { __typename: 'TripsRetryOperationAction' }
                                | { __typename: 'UIFlightAction' }
                                | {
                                    __typename: 'UILinkAction';
                                    resource:
                                      | { __typename: 'BasicURI'; value: string }
                                      | { __typename: 'ClipboardURI'; value: string }
                                      | { __typename: 'FBMessengerURI'; value: string }
                                      | { __typename: 'GenericURI'; value: string }
                                      | { __typename: 'GeoURI'; value: string }
                                      | { __typename: 'HttpURI'; value: string }
                                      | { __typename: 'MailToURI'; value: string }
                                      | { __typename: 'MobileAppURI'; value: string }
                                      | { __typename: 'RelativeURI'; value: string }
                                      | { __typename: 'SMSToURI'; value: string }
                                      | { __typename: 'SelfReferencedURI'; value: string }
                                      | { __typename: 'TelURI'; value: string }
                                      | { __typename: 'Uri'; value: string }
                                      | { __typename: 'WhatsappURI'; value: string };
                                  }
                                | { __typename: 'WizardAdditionalUserInputRequiredAction' }
                                | { __typename: 'WizardSubmitAction' }
                                | null;
                            };
                      }
                  >;
                }
              | {
                  __typename: 'UnSupportedBooking';
                  heading: string;
                  description: string;
                  clickstreamPayload: {
                    __typename: 'BookingActionsClickStreamAnalytics';
                    event: {
                      __typename: 'Event';
                      eventName: string;
                      eventType: string;
                      eventCategory?: string | null;
                      eventVersion?: string | null;
                      actionLocation?: string | null;
                      actionReason?: string | null;
                    };
                    tripDetail?: Array<{ __typename: 'ClickStreamTripInfo'; tripDomainId?: string | null }> | null;
                    experience: {
                      __typename: 'Experience';
                      pageName: string;
                      appName: string;
                      appVersion: string;
                      pageNameDetailed: string;
                    };
                    workFlowList?: Array<{
                      __typename: 'WorkFlow';
                      intent: string;
                      orderLineId?: string | null;
                      productLine: string;
                      subIntent?: string | null;
                      automationStatus: string;
                      automationStatusReason: string;
                      channel: string;
                    }> | null;
                  };
                  goToTrips?: {
                    __typename: 'UISecondaryButton';
                    primary?: string | null;
                    icon?: { __typename: 'Icon'; id: string; description: string; token: string } | null;
                    action?:
                      | {
                          __typename: 'ActivityAddOfferToTripAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'ActivityCloseDialogAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'ActivityMultiItemTripUpdateAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'ActivityOpenDialogAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'ActivityOpenOffersModalAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'ActivityPaginationAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'ActivityRemoveOffersFromTripAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'ActivityUpdateOfferInTripAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'AgencyQuoteAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'AirCreditWebAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'BannerPlacementServiceUILinkAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'CouponAndCreditAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'CouponAndCreditChatbotAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'CouponsAndCreditsSimpleAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'CrossSellButtonAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'CrossSellLinkAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'CruiseAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'DirectFeedbackOpenFormAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'DirectFeedbackOpenNextPageAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'DirectFeedbackOpenPreviousPageAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'DirectFeedbackSubmitFormAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'EGDSOpenDatePickerAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'EGDSOpenTravelerSelectorAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'EGDSSubmitSearchFormAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'FlightsCreditSelectorOpenUIAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'FlightsDialogCloseUIAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'FlightsDialogTriggerUIAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'MemberWalletBadge';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'MemberWalletUIAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'MishopDetailsUIAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'MultiItemCrossSellUIButtonAction';
                          accessibility: string;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'MultiItemCrossSellUICheckoutButtonAction';
                          accessibility: string;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'MultiItemCrossSellUILinkAction';
                          accessibility: string;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'OpenTypeaheadAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'PaymentDialogButtonAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'PriceInsightsCardDisclaimerToolTipAction';
                          accessibility: string;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'PriceInsightsExistingDialogButtonAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'PriceInsightsRetryTrackingDialogButtonAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'ProfileAccountFormSubmitAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'ProfileAddMembershipAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'ProfileAddPassportAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'ProfileFormSubmitAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'ProfileLinkAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'ProfileReloadAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'ProfileRewardProgramFormAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'ProfileUpdateMembershipAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'ProfileUpdatePassportAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'QuoteAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'ShoppingSortAndFilterAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'SupplyNavigationHeaderSearchTrigger';
                          accessibility: string;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'TripsRetryOperationAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'UIFlightAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'UILinkAction';
                          accessibility?: string | null;
                          resource:
                            | { __typename: 'BasicURI'; value: string }
                            | { __typename: 'ClipboardURI'; value: string }
                            | { __typename: 'FBMessengerURI'; value: string }
                            | { __typename: 'GenericURI'; value: string }
                            | { __typename: 'GeoURI'; value: string }
                            | { __typename: 'HttpURI'; value: string }
                            | { __typename: 'MailToURI'; value: string }
                            | { __typename: 'MobileAppURI'; value: string }
                            | { __typename: 'RelativeURI'; value: string }
                            | { __typename: 'SMSToURI'; value: string }
                            | { __typename: 'SelfReferencedURI'; value: string }
                            | { __typename: 'TelURI'; value: string }
                            | { __typename: 'Uri'; value: string }
                            | { __typename: 'WhatsappURI'; value: string };
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'WizardAdditionalUserInputRequiredAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | {
                          __typename: 'WizardSubmitAction';
                          accessibility?: string | null;
                          analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
                        }
                      | null;
                  } | null;
                }
            > | null;
          }> | null;
        }> | null;
      } | null;
      intentButtons?: Array<{
        __typename: 'HelpCenterIntentButtons';
        skillName: string;
        name: {
          __typename: 'UIPrimaryButton';
          primary?: string | null;
          icon?: { __typename: 'Icon'; id: string; token: string; description: string } | null;
        };
      }> | null;
    };
    helpCenterSignInCTAView?: {
      __typename: 'SignInCTA';
      heading: string;
      illustration: { __typename: 'Illustration'; url: any; description: string; id: string };
      signInButton: {
        __typename: 'UIPrimaryButton';
        primary?: string | null;
        action?:
          | {
              __typename: 'ActivityAddOfferToTripAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'ActivityCloseDialogAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'ActivityMultiItemTripUpdateAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'ActivityOpenDialogAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'ActivityOpenOffersModalAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'ActivityPaginationAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'ActivityRemoveOffersFromTripAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'ActivityUpdateOfferInTripAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'AgencyQuoteAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'AirCreditWebAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'BannerPlacementServiceUILinkAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'CouponAndCreditAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'CouponAndCreditChatbotAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'CouponsAndCreditsSimpleAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'CrossSellButtonAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'CrossSellLinkAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'CruiseAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'DirectFeedbackOpenFormAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'DirectFeedbackOpenNextPageAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'DirectFeedbackOpenPreviousPageAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'DirectFeedbackSubmitFormAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'EGDSOpenDatePickerAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'EGDSOpenTravelerSelectorAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'EGDSSubmitSearchFormAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'FlightsCreditSelectorOpenUIAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'FlightsDialogCloseUIAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'FlightsDialogTriggerUIAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'MemberWalletBadge';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'MemberWalletUIAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'MishopDetailsUIAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'MultiItemCrossSellUIButtonAction';
              accessibility: string;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'MultiItemCrossSellUICheckoutButtonAction';
              accessibility: string;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'MultiItemCrossSellUILinkAction';
              accessibility: string;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'OpenTypeaheadAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'PaymentDialogButtonAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'PriceInsightsCardDisclaimerToolTipAction';
              accessibility: string;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'PriceInsightsExistingDialogButtonAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'PriceInsightsRetryTrackingDialogButtonAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'ProfileAccountFormSubmitAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'ProfileAddMembershipAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'ProfileAddPassportAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'ProfileFormSubmitAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'ProfileLinkAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'ProfileReloadAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'ProfileRewardProgramFormAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'ProfileUpdateMembershipAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'ProfileUpdatePassportAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'QuoteAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'ShoppingSortAndFilterAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'SupplyNavigationHeaderSearchTrigger';
              accessibility: string;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'TripsRetryOperationAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'UIFlightAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'UILinkAction';
              accessibility?: string | null;
              resource:
                | { __typename: 'BasicURI'; value: string }
                | { __typename: 'ClipboardURI'; value: string }
                | { __typename: 'FBMessengerURI'; value: string }
                | { __typename: 'GenericURI'; value: string }
                | { __typename: 'GeoURI'; value: string }
                | { __typename: 'HttpURI'; value: string }
                | { __typename: 'MailToURI'; value: string }
                | { __typename: 'MobileAppURI'; value: string }
                | { __typename: 'RelativeURI'; value: string }
                | { __typename: 'SMSToURI'; value: string }
                | { __typename: 'SelfReferencedURI'; value: string }
                | { __typename: 'TelURI'; value: string }
                | { __typename: 'Uri'; value: string }
                | { __typename: 'WhatsappURI'; value: string };
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'WizardAdditionalUserInputRequiredAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'WizardSubmitAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | null;
      };
      dismissButton: {
        __typename: 'UITertiaryButton';
        primary?: string | null;
        action?:
          | {
              __typename: 'ActivityAddOfferToTripAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'ActivityCloseDialogAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'ActivityMultiItemTripUpdateAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'ActivityOpenDialogAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'ActivityOpenOffersModalAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'ActivityPaginationAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'ActivityRemoveOffersFromTripAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'ActivityUpdateOfferInTripAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'AgencyQuoteAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'AirCreditWebAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'BannerPlacementServiceUILinkAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'CouponAndCreditAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'CouponAndCreditChatbotAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'CouponsAndCreditsSimpleAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'CrossSellButtonAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'CrossSellLinkAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'CruiseAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'DirectFeedbackOpenFormAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'DirectFeedbackOpenNextPageAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'DirectFeedbackOpenPreviousPageAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'DirectFeedbackSubmitFormAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'EGDSOpenDatePickerAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'EGDSOpenTravelerSelectorAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'EGDSSubmitSearchFormAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'FlightsCreditSelectorOpenUIAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'FlightsDialogCloseUIAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'FlightsDialogTriggerUIAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'MemberWalletBadge';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'MemberWalletUIAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'MishopDetailsUIAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'MultiItemCrossSellUIButtonAction';
              accessibility: string;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'MultiItemCrossSellUICheckoutButtonAction';
              accessibility: string;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'MultiItemCrossSellUILinkAction';
              accessibility: string;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'OpenTypeaheadAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'PaymentDialogButtonAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'PriceInsightsCardDisclaimerToolTipAction';
              accessibility: string;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'PriceInsightsExistingDialogButtonAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'PriceInsightsRetryTrackingDialogButtonAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'ProfileAccountFormSubmitAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'ProfileAddMembershipAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'ProfileAddPassportAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'ProfileFormSubmitAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'ProfileLinkAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'ProfileReloadAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'ProfileRewardProgramFormAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'ProfileUpdateMembershipAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'ProfileUpdatePassportAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'QuoteAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'ShoppingSortAndFilterAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'SupplyNavigationHeaderSearchTrigger';
              accessibility: string;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'TripsRetryOperationAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'UIFlightAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'UILinkAction';
              accessibility?: string | null;
              resource:
                | { __typename: 'BasicURI'; value: string }
                | { __typename: 'ClipboardURI'; value: string }
                | { __typename: 'FBMessengerURI'; value: string }
                | { __typename: 'GenericURI'; value: string }
                | { __typename: 'GeoURI'; value: string }
                | { __typename: 'HttpURI'; value: string }
                | { __typename: 'MailToURI'; value: string }
                | { __typename: 'MobileAppURI'; value: string }
                | { __typename: 'RelativeURI'; value: string }
                | { __typename: 'SMSToURI'; value: string }
                | { __typename: 'SelfReferencedURI'; value: string }
                | { __typename: 'TelURI'; value: string }
                | { __typename: 'Uri'; value: string }
                | { __typename: 'WhatsappURI'; value: string };
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'WizardAdditionalUserInputRequiredAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | {
              __typename: 'WizardSubmitAction';
              accessibility?: string | null;
              analytics: { __typename: 'ClientSideAnalytics'; linkName: string; referrerId: string };
            }
          | null;
      };
      signInCTAClickstreamPayload: {
        __typename: 'SignInCTAClickStreamAnalytics';
        event: {
          __typename: 'EGClickstreamEvent';
          eventName: string;
          eventType: string;
          eventCategory: string;
          eventVersion: string;
          actionLocation?: string | null;
        };
        experience: {
          __typename: 'Experience';
          appName: string;
          appVersion: string;
          pageName: string;
          pageNameDetailed: string;
        };
      };
      signInCTACookiePayload: { __typename: 'SignInCTACookiePayload'; cookieName: string; cookieTTL: number };
    } | null;
  };
};

type DiscriminateUnion<T, U> = T extends U ? T : never;

export namespace EGDSButton {
  export type fragment = EGDSButtonFragment;
  export type action = NonNullable<EGDSButtonFragment['action']>;
  export type analytics = NonNullable<NonNullable<EGDSButtonFragment['action']>['analytics']>;
  export type UILinkActionInlineFragment = DiscriminateUnion<
    NonNullable<EGDSButtonFragment['action']>,
    { __typename: 'UILinkAction' }
  >;
  export type resource = NonNullable<
    DiscriminateUnion<NonNullable<EGDSButtonFragment['action']>, { __typename: 'UILinkAction' }>['resource']
  >;
}

export namespace EGDSIllustration {
  export type fragment = EGDSIllustrationFragment;
}

export namespace IntentConfigFields {
  export type fragment = IntentConfigFieldsFragment;
  export type intentButtons = NonNullable<NonNullable<IntentConfigFieldsFragment['intentButtons']>[number]>;
  export type name = NonNullable<NonNullable<NonNullable<IntentConfigFieldsFragment['intentButtons']>[number]>['name']>;
  export type icon = NonNullable<
    NonNullable<NonNullable<NonNullable<IntentConfigFieldsFragment['intentButtons']>[number]>['name']>['icon']
  >;
}

export namespace SignInCTAFields {
  export type fragment = SignInCTAFieldsFragment;
  export type illustration = NonNullable<SignInCTAFieldsFragment['illustration']>;
  export type signInButton = NonNullable<SignInCTAFieldsFragment['signInButton']>;
  export type dismissButton = NonNullable<SignInCTAFieldsFragment['dismissButton']>;
  export type signInCTAClickstreamPayload = NonNullable<SignInCTAFieldsFragment['signInCTAClickstreamPayload']>;
  export type event = NonNullable<NonNullable<SignInCTAFieldsFragment['signInCTAClickstreamPayload']>['event']>;
  export type experience = NonNullable<
    NonNullable<SignInCTAFieldsFragment['signInCTAClickstreamPayload']>['experience']
  >;
  export type signInCTACookiePayload = NonNullable<SignInCTAFieldsFragment['signInCTACookiePayload']>;
}

export namespace TaapAcademyComponentFields {
  export type fragment = TaapAcademyComponentFieldsFragment;
  export type academyLink = NonNullable<TaapAcademyComponentFieldsFragment['academyLink']>;
  export type action = NonNullable<NonNullable<TaapAcademyComponentFieldsFragment['academyLink']>['action']>;
  export type resource = NonNullable<
    NonNullable<NonNullable<TaapAcademyComponentFieldsFragment['academyLink']>['action']>['resource']
  >;
}

export namespace TripInfoDetailFields {
  export type fragment = TripInfoDetailFieldsFragment;
  export type allTrips = NonNullable<NonNullable<TripInfoDetailFieldsFragment['allTrips']>[number]>;
  export type tripInfos = NonNullable<
    NonNullable<NonNullable<NonNullable<TripInfoDetailFieldsFragment['allTrips']>[number]>['tripInfos']>[number]
  >;
  export type image = NonNullable<
    NonNullable<
      NonNullable<NonNullable<NonNullable<TripInfoDetailFieldsFragment['allTrips']>[number]>['tripInfos']>[number]
    >['image']
  >;
  export type bookingIcons = NonNullable<
    NonNullable<
      NonNullable<
        NonNullable<NonNullable<NonNullable<TripInfoDetailFieldsFragment['allTrips']>[number]>['tripInfos']>[number]
      >['bookingIcons']
    >[number]
  >;
  export type tripBookings = NonNullable<
    NonNullable<
      NonNullable<
        NonNullable<NonNullable<NonNullable<TripInfoDetailFieldsFragment['allTrips']>[number]>['tripInfos']>[number]
      >['tripBookings']
    >[number]
  >;
  export type UnSupportedBookingInlineFragment = DiscriminateUnion<
    NonNullable<
      NonNullable<
        NonNullable<
          NonNullable<NonNullable<NonNullable<TripInfoDetailFieldsFragment['allTrips']>[number]>['tripInfos']>[number]
        >['tripBookings']
      >[number]
    >,
    { __typename: 'UnSupportedBooking' }
  >;
  export type clickstreamPayload = NonNullable<
    DiscriminateUnion<
      NonNullable<
        NonNullable<
          NonNullable<
            NonNullable<NonNullable<NonNullable<TripInfoDetailFieldsFragment['allTrips']>[number]>['tripInfos']>[number]
          >['tripBookings']
        >[number]
      >,
      { __typename: 'UnSupportedBooking' }
    >['clickstreamPayload']
  >;
  export type goToTrips = NonNullable<
    DiscriminateUnion<
      NonNullable<
        NonNullable<
          NonNullable<
            NonNullable<NonNullable<NonNullable<TripInfoDetailFieldsFragment['allTrips']>[number]>['tripInfos']>[number]
          >['tripBookings']
        >[number]
      >,
      { __typename: 'UnSupportedBooking' }
    >['goToTrips']
  >;
  export type icon = NonNullable<
    NonNullable<
      DiscriminateUnion<
        NonNullable<
          NonNullable<
            NonNullable<
              NonNullable<
                NonNullable<NonNullable<TripInfoDetailFieldsFragment['allTrips']>[number]>['tripInfos']
              >[number]
            >['tripBookings']
          >[number]
        >,
        { __typename: 'UnSupportedBooking' }
      >['goToTrips']
    >['icon']
  >;
  export type action = NonNullable<
    NonNullable<
      DiscriminateUnion<
        NonNullable<
          NonNullable<
            NonNullable<
              NonNullable<
                NonNullable<NonNullable<TripInfoDetailFieldsFragment['allTrips']>[number]>['tripInfos']
              >[number]
            >['tripBookings']
          >[number]
        >,
        { __typename: 'UnSupportedBooking' }
      >['goToTrips']
    >['action']
  >;
  export type UILinkActionInlineFragment = DiscriminateUnion<
    NonNullable<
      NonNullable<
        DiscriminateUnion<
          NonNullable<
            NonNullable<
              NonNullable<
                NonNullable<
                  NonNullable<NonNullable<TripInfoDetailFieldsFragment['allTrips']>[number]>['tripInfos']
                >[number]
              >['tripBookings']
            >[number]
          >,
          { __typename: 'UnSupportedBooking' }
        >['goToTrips']
      >['action']
    >,
    { __typename: 'UILinkAction' }
  >;
  export type resource = NonNullable<
    DiscriminateUnion<
      NonNullable<
        NonNullable<
          DiscriminateUnion<
            NonNullable<
              NonNullable<
                NonNullable<
                  NonNullable<
                    NonNullable<NonNullable<TripInfoDetailFieldsFragment['allTrips']>[number]>['tripInfos']
                  >[number]
                >['tripBookings']
              >[number]
            >,
            { __typename: 'UnSupportedBooking' }
          >['goToTrips']
        >['action']
      >,
      { __typename: 'UILinkAction' }
    >['resource']
  >;
  export type analytics = NonNullable<
    NonNullable<
      NonNullable<
        DiscriminateUnion<
          NonNullable<
            NonNullable<
              NonNullable<
                NonNullable<
                  NonNullable<NonNullable<TripInfoDetailFieldsFragment['allTrips']>[number]>['tripInfos']
                >[number]
              >['tripBookings']
            >[number]
          >,
          { __typename: 'UnSupportedBooking' }
        >['goToTrips']
      >['action']
    >['analytics']
  >;
  export type BookingDetailInlineFragment = DiscriminateUnion<
    NonNullable<
      NonNullable<
        NonNullable<
          NonNullable<NonNullable<NonNullable<TripInfoDetailFieldsFragment['allTrips']>[number]>['tripInfos']>[number]
        >['tripBookings']
      >[number]
    >,
    { __typename: 'BookingDetail' }
  >;
  export type _icon = NonNullable<
    DiscriminateUnion<
      NonNullable<
        NonNullable<
          NonNullable<
            NonNullable<NonNullable<NonNullable<TripInfoDetailFieldsFragment['allTrips']>[number]>['tripInfos']>[number]
          >['tripBookings']
        >[number]
      >,
      { __typename: 'BookingDetail' }
    >['icon']
  >;
  export type helpCenterIntentButton = NonNullable<
    DiscriminateUnion<
      NonNullable<
        NonNullable<
          NonNullable<
            NonNullable<NonNullable<NonNullable<TripInfoDetailFieldsFragment['allTrips']>[number]>['tripInfos']>[number]
          >['tripBookings']
        >[number]
      >,
      { __typename: 'BookingDetail' }
    >['helpCenterIntentButton']
  >;
  export type name = NonNullable<
    NonNullable<
      DiscriminateUnion<
        NonNullable<
          NonNullable<
            NonNullable<
              NonNullable<
                NonNullable<NonNullable<TripInfoDetailFieldsFragment['allTrips']>[number]>['tripInfos']
              >[number]
            >['tripBookings']
          >[number]
        >,
        { __typename: 'BookingDetail' }
      >['helpCenterIntentButton']
    >['name']
  >;
  export type bookingActions = NonNullable<
    NonNullable<
      DiscriminateUnion<
        NonNullable<
          NonNullable<
            NonNullable<
              NonNullable<
                NonNullable<NonNullable<TripInfoDetailFieldsFragment['allTrips']>[number]>['tripInfos']
              >[number]
            >['tripBookings']
          >[number]
        >,
        { __typename: 'BookingDetail' }
      >['bookingActions']
    >[number]
  >;
  export type HelpCenterLinkButtonInlineFragment = DiscriminateUnion<
    NonNullable<
      NonNullable<
        DiscriminateUnion<
          NonNullable<
            NonNullable<
              NonNullable<
                NonNullable<
                  NonNullable<NonNullable<TripInfoDetailFieldsFragment['allTrips']>[number]>['tripInfos']
                >[number]
              >['tripBookings']
            >[number]
          >,
          { __typename: 'BookingDetail' }
        >['bookingActions']
      >[number]
    >,
    { __typename: 'HelpCenterLinkButton' }
  >;
  export type _name = NonNullable<
    DiscriminateUnion<
      NonNullable<
        NonNullable<
          DiscriminateUnion<
            NonNullable<
              NonNullable<
                NonNullable<
                  NonNullable<
                    NonNullable<NonNullable<TripInfoDetailFieldsFragment['allTrips']>[number]>['tripInfos']
                  >[number]
                >['tripBookings']
              >[number]
            >,
            { __typename: 'BookingDetail' }
          >['bookingActions']
        >[number]
      >,
      { __typename: 'HelpCenterLinkButton' }
    >['name']
  >;
  export type _action = NonNullable<
    NonNullable<
      DiscriminateUnion<
        NonNullable<
          NonNullable<
            DiscriminateUnion<
              NonNullable<
                NonNullable<
                  NonNullable<
                    NonNullable<
                      NonNullable<NonNullable<TripInfoDetailFieldsFragment['allTrips']>[number]>['tripInfos']
                    >[number]
                  >['tripBookings']
                >[number]
              >,
              { __typename: 'BookingDetail' }
            >['bookingActions']
          >[number]
        >,
        { __typename: 'HelpCenterLinkButton' }
      >['name']
    >['action']
  >;
  export type _UILinkActionInlineFragment = DiscriminateUnion<
    NonNullable<
      NonNullable<
        DiscriminateUnion<
          NonNullable<
            NonNullable<
              DiscriminateUnion<
                NonNullable<
                  NonNullable<
                    NonNullable<
                      NonNullable<
                        NonNullable<NonNullable<TripInfoDetailFieldsFragment['allTrips']>[number]>['tripInfos']
                      >[number]
                    >['tripBookings']
                  >[number]
                >,
                { __typename: 'BookingDetail' }
              >['bookingActions']
            >[number]
          >,
          { __typename: 'HelpCenterLinkButton' }
        >['name']
      >['action']
    >,
    { __typename: 'UILinkAction' }
  >;
  export type _resource = NonNullable<
    DiscriminateUnion<
      NonNullable<
        NonNullable<
          DiscriminateUnion<
            NonNullable<
              NonNullable<
                DiscriminateUnion<
                  NonNullable<
                    NonNullable<
                      NonNullable<
                        NonNullable<
                          NonNullable<NonNullable<TripInfoDetailFieldsFragment['allTrips']>[number]>['tripInfos']
                        >[number]
                      >['tripBookings']
                    >[number]
                  >,
                  { __typename: 'BookingDetail' }
                >['bookingActions']
              >[number]
            >,
            { __typename: 'HelpCenterLinkButton' }
          >['name']
        >['action']
      >,
      { __typename: 'UILinkAction' }
    >['resource']
  >;
  export type HelpCenterIntentButtonsInlineFragment = DiscriminateUnion<
    NonNullable<
      NonNullable<
        DiscriminateUnion<
          NonNullable<
            NonNullable<
              NonNullable<
                NonNullable<
                  NonNullable<NonNullable<TripInfoDetailFieldsFragment['allTrips']>[number]>['tripInfos']
                >[number]
              >['tripBookings']
            >[number]
          >,
          { __typename: 'BookingDetail' }
        >['bookingActions']
      >[number]
    >,
    { __typename: 'HelpCenterIntentButtons' }
  >;
  export type __name = NonNullable<
    DiscriminateUnion<
      NonNullable<
        NonNullable<
          DiscriminateUnion<
            NonNullable<
              NonNullable<
                NonNullable<
                  NonNullable<
                    NonNullable<NonNullable<TripInfoDetailFieldsFragment['allTrips']>[number]>['tripInfos']
                  >[number]
                >['tripBookings']
              >[number]
            >,
            { __typename: 'BookingDetail' }
          >['bookingActions']
        >[number]
      >,
      { __typename: 'HelpCenterIntentButtons' }
    >['name']
  >;
  export type bookingActionsClickStreamAnalytics = NonNullable<
    DiscriminateUnion<
      NonNullable<
        NonNullable<
          DiscriminateUnion<
            NonNullable<
              NonNullable<
                NonNullable<
                  NonNullable<
                    NonNullable<NonNullable<TripInfoDetailFieldsFragment['allTrips']>[number]>['tripInfos']
                  >[number]
                >['tripBookings']
              >[number]
            >,
            { __typename: 'BookingDetail' }
          >['bookingActions']
        >[number]
      >,
      { __typename: 'HelpCenterIntentButtons' }
    >['bookingActionsClickStreamAnalytics']
  >;
  export type HelpCenterBookingButtonsInlineFragment = DiscriminateUnion<
    NonNullable<
      NonNullable<
        DiscriminateUnion<
          NonNullable<
            NonNullable<
              NonNullable<
                NonNullable<
                  NonNullable<NonNullable<TripInfoDetailFieldsFragment['allTrips']>[number]>['tripInfos']
                >[number]
              >['tripBookings']
            >[number]
          >,
          { __typename: 'BookingDetail' }
        >['bookingActions']
      >[number]
    >,
    { __typename: 'HelpCenterBookingButtons' }
  >;
  export type ___name = NonNullable<
    DiscriminateUnion<
      NonNullable<
        NonNullable<
          DiscriminateUnion<
            NonNullable<
              NonNullable<
                NonNullable<
                  NonNullable<
                    NonNullable<NonNullable<TripInfoDetailFieldsFragment['allTrips']>[number]>['tripInfos']
                  >[number]
                >['tripBookings']
              >[number]
            >,
            { __typename: 'BookingDetail' }
          >['bookingActions']
        >[number]
      >,
      { __typename: 'HelpCenterBookingButtons' }
    >['name']
  >;
  export type __action = NonNullable<
    NonNullable<
      DiscriminateUnion<
        NonNullable<
          NonNullable<
            DiscriminateUnion<
              NonNullable<
                NonNullable<
                  NonNullable<
                    NonNullable<
                      NonNullable<NonNullable<TripInfoDetailFieldsFragment['allTrips']>[number]>['tripInfos']
                    >[number]
                  >['tripBookings']
                >[number]
              >,
              { __typename: 'BookingDetail' }
            >['bookingActions']
          >[number]
        >,
        { __typename: 'HelpCenterBookingButtons' }
      >['name']
    >['action']
  >;
  export type __UILinkActionInlineFragment = DiscriminateUnion<
    NonNullable<
      NonNullable<
        DiscriminateUnion<
          NonNullable<
            NonNullable<
              DiscriminateUnion<
                NonNullable<
                  NonNullable<
                    NonNullable<
                      NonNullable<
                        NonNullable<NonNullable<TripInfoDetailFieldsFragment['allTrips']>[number]>['tripInfos']
                      >[number]
                    >['tripBookings']
                  >[number]
                >,
                { __typename: 'BookingDetail' }
              >['bookingActions']
            >[number]
          >,
          { __typename: 'HelpCenterBookingButtons' }
        >['name']
      >['action']
    >,
    { __typename: 'UILinkAction' }
  >;
  export type __resource = NonNullable<
    DiscriminateUnion<
      NonNullable<
        NonNullable<
          DiscriminateUnion<
            NonNullable<
              NonNullable<
                DiscriminateUnion<
                  NonNullable<
                    NonNullable<
                      NonNullable<
                        NonNullable<
                          NonNullable<NonNullable<TripInfoDetailFieldsFragment['allTrips']>[number]>['tripInfos']
                        >[number]
                      >['tripBookings']
                    >[number]
                  >,
                  { __typename: 'BookingDetail' }
                >['bookingActions']
              >[number]
            >,
            { __typename: 'HelpCenterBookingButtons' }
          >['name']
        >['action']
      >,
      { __typename: 'UILinkAction' }
    >['resource']
  >;
  export type _analytics = NonNullable<
    NonNullable<
      NonNullable<
        DiscriminateUnion<
          NonNullable<
            NonNullable<
              DiscriminateUnion<
                NonNullable<
                  NonNullable<
                    NonNullable<
                      NonNullable<
                        NonNullable<NonNullable<TripInfoDetailFieldsFragment['allTrips']>[number]>['tripInfos']
                      >[number]
                    >['tripBookings']
                  >[number]
                >,
                { __typename: 'BookingDetail' }
              >['bookingActions']
            >[number]
          >,
          { __typename: 'HelpCenterBookingButtons' }
        >['name']
      >['action']
    >['analytics']
  >;
}

export namespace BookingActionsClickStreamAnalyticsFragment {
  export type fragment = BookingActionsClickStreamAnalyticsFragmentFragment;
  export type event = NonNullable<BookingActionsClickStreamAnalyticsFragmentFragment['event']>;
  export type tripDetail = NonNullable<
    NonNullable<BookingActionsClickStreamAnalyticsFragmentFragment['tripDetail']>[number]
  >;
  export type experience = NonNullable<BookingActionsClickStreamAnalyticsFragmentFragment['experience']>;
  export type workFlowList = NonNullable<
    NonNullable<BookingActionsClickStreamAnalyticsFragmentFragment['workFlowList']>[number]
  >;
}

export namespace BannerFields {
  export type fragment = BannerFieldsFragment;
  export type heroImage = NonNullable<BannerFieldsFragment['heroImage']>;
}

export namespace ClickstreamAnalyticsEvent {
  export type fragment = ClickstreamAnalyticsEventFragment;
}

export namespace ClickstreamAnalyticsExperience {
  export type fragment = ClickstreamAnalyticsExperienceFragment;
}

export namespace UpdateUserStateAndSendMessage {
  export type Variables = UpdateUserStateAndSendMessageMutationVariables;
  export type mutation = UpdateUserStateAndSendMessageMutation;
  export type updateUserStateAndSendMessage = NonNullable<
    UpdateUserStateAndSendMessageMutation['updateUserStateAndSendMessage']
  >;
  export type updateUserStateAndSendMessageView = NonNullable<
    NonNullable<
      UpdateUserStateAndSendMessageMutation['updateUserStateAndSendMessage']
    >['updateUserStateAndSendMessageView']
  >;
  export type conversationAuthenticationHeading = NonNullable<
    NonNullable<
      NonNullable<
        UpdateUserStateAndSendMessageMutation['updateUserStateAndSendMessage']
      >['updateUserStateAndSendMessageView']
    >['conversationAuthenticationHeading']
  >;
  export type conversationAuthenticationText = NonNullable<
    NonNullable<
      NonNullable<
        UpdateUserStateAndSendMessageMutation['updateUserStateAndSendMessage']
      >['updateUserStateAndSendMessageView']
    >['conversationAuthenticationText']
  >;
}

export namespace getHelpCenterConfig {
  export type Variables = getHelpCenterConfigQueryVariables;
  export type query = getHelpCenterConfigQuery;
  export type helpCenterPersonalization = NonNullable<getHelpCenterConfigQuery['helpCenterPersonalization']>;
  export type helpCenterPersonalizedView = NonNullable<
    NonNullable<getHelpCenterConfigQuery['helpCenterPersonalization']>['helpCenterPersonalizedView']
  >;
  export type banner = NonNullable<
    NonNullable<
      NonNullable<getHelpCenterConfigQuery['helpCenterPersonalization']>['helpCenterPersonalizedView']
    >['banner']
  >;
  export type taapAcademyComponent = NonNullable<
    NonNullable<
      NonNullable<getHelpCenterConfigQuery['helpCenterPersonalization']>['helpCenterPersonalizedView']
    >['taapAcademyComponent']
  >;
  export type travelerTripDetailedOverview = NonNullable<
    NonNullable<
      NonNullable<getHelpCenterConfigQuery['helpCenterPersonalization']>['helpCenterPersonalizedView']
    >['travelerTripDetailedOverview']
  >;
  export type helpCenterSignInCTAView = NonNullable<
    NonNullable<getHelpCenterConfigQuery['helpCenterPersonalization']>['helpCenterSignInCTAView']
  >;
}

export const IntentConfigFieldsFragmentDoc = gql`
  fragment IntentConfigFields on HelpCenterPersonalizationData {
    intentButtonsHeading
    intentButtons {
      name {
        icon {
          id
          token
          description
        }
        primary
      }
      skillName
    }
  }
`;
export const EGDSIllustrationFragmentDoc = gql`
  fragment EGDSIllustration on Illustration {
    url
    description
    id
  }
`;
export const EGDSButtonFragmentDoc = gql`
  fragment EGDSButton on EGDSButton {
    __typename
    primary
    action {
      accessibility
      analytics {
        linkName
        referrerId
      }
      ... on UILinkAction {
        resource {
          __typename
          value
        }
      }
    }
  }
`;
export const ClickstreamAnalyticsEventFragmentDoc = gql`
  fragment ClickstreamAnalyticsEvent on EGClickstreamEvent {
    eventName
    eventType
    eventCategory
    eventVersion
    actionLocation
  }
`;
export const ClickstreamAnalyticsExperienceFragmentDoc = gql`
  fragment ClickstreamAnalyticsExperience on Experience {
    appName
    appVersion
    pageName
    pageNameDetailed
  }
`;
export const SignInCTAFieldsFragmentDoc = gql`
  fragment SignInCTAFields on SignInCTA {
    heading
    illustration {
      ...EGDSIllustration
    }
    signInButton {
      ...EGDSButton
    }
    dismissButton {
      ...EGDSButton
    }
    signInCTAClickstreamPayload {
      event {
        ...ClickstreamAnalyticsEvent
      }
      experience {
        ...ClickstreamAnalyticsExperience
      }
    }
    signInCTACookiePayload {
      cookieName
      cookieTTL
    }
  }
  ${EGDSIllustrationFragmentDoc}
  ${EGDSButtonFragmentDoc}
  ${ClickstreamAnalyticsEventFragmentDoc}
  ${ClickstreamAnalyticsExperienceFragmentDoc}
`;
export const TaapAcademyComponentFieldsFragmentDoc = gql`
  fragment TaapAcademyComponentFields on TaapAcademyComponent {
    heading
    description
    iconUrl
    academyLink {
      text
      action {
        accessibility
        resource {
          value
        }
      }
    }
  }
`;
export const BookingActionsClickStreamAnalyticsFragmentFragmentDoc = gql`
  fragment BookingActionsClickStreamAnalyticsFragment on BookingActionsClickStreamAnalytics {
    event {
      eventName
      eventType
      eventCategory
      eventVersion
      actionLocation
      actionReason
      __typename
    }
    tripDetail {
      tripDomainId
      __typename
    }
    experience {
      pageName
      appName
      appVersion
      pageNameDetailed
      __typename
    }
    workFlowList {
      intent
      orderLineId
      productLine
      subIntent
      automationStatus
      automationStatusReason
      channel
      __typename
    }
    __typename
  }
`;
export const TripInfoDetailFieldsFragmentDoc = gql`
  fragment TripInfoDetailFields on HelpCenterTripDetailedOverview {
    header
    allTrips {
      header
      tabTitle
      tripInfos {
        backToTripButton
        header
        tripName
        image {
          description
          url
          __typename
        }
        timePeriod
        numberOfBooking
        bookingIcons {
          id
          __typename
        }
        tripBookings {
          ... on UnSupportedBooking {
            heading
            description
            clickstreamPayload {
              ...BookingActionsClickStreamAnalyticsFragment
            }
            goToTrips {
              __typename
              primary
              icon {
                id
                description
                token
                __typename
              }
              action {
                accessibility
                ... on UILinkAction {
                  __typename
                  resource {
                    value
                  }
                }
                analytics {
                  linkName
                  referrerId
                }
                __typename
              }
            }
            __typename
          }
          ... on BookingDetail {
            icon {
              id
              __typename
            }
            helpCenterIntentButton {
              name {
                primary
                __typename
              }
              skillName
              vaText
              payload
              __typename
            }
            timePeriod
            itineraryNumberText
            title
            product
            isDisable
            bookingActions {
              ... on HelpCenterLinkButton {
                name {
                  primary
                  action {
                    ... on UILinkAction {
                      resource {
                        value
                      }
                    }
                  }
                }
              }
              ... on HelpCenterIntentButtons {
                name {
                  primary
                  __typename
                }
                skillName
                vaText
                payload
                bookingActionsClickStreamAnalytics {
                  ...BookingActionsClickStreamAnalyticsFragment
                }
                __typename
              }
              ... on HelpCenterBookingButtons {
                __typename
                name {
                  primary
                  action {
                    accessibility
                    ... on UILinkAction {
                      resource {
                        value
                        __typename
                      }
                    }
                    analytics {
                      linkName
                      referrerId
                      __typename
                    }
                    __typename
                  }
                }
              }
            }
            __typename
          }
        }
        __typename
      }
    }
  }
  ${BookingActionsClickStreamAnalyticsFragmentFragmentDoc}
`;
export const BannerFieldsFragmentDoc = gql`
  fragment BannerFields on HelpCenterWelcomeBanner {
    heading
    heroImage {
      url
      description
    }
    subHeading
  }
`;
export const UpdateUserStateAndSendMessageDocument = gql`
  mutation UpdateUserStateAndSendMessage(
    $context: ContextInput!
    $conversationId: String
    $travelerParticipantId: String
  ) {
    updateUserStateAndSendMessage(context: $context) {
      updateUserStateAndSendMessageView(
        conversationAuthenticationRequest: {
          conversationId: $conversationId
          travelerParticipantId: $travelerParticipantId
        }
      ) {
        success
        conversationAuthenticationHeading {
          text
        }
        conversationAuthenticationText {
          text
        }
      }
    }
  }
`;
export const getHelpCenterConfigDocument = gql`
  query getHelpCenterConfig($context: ContextInput!) {
    helpCenterPersonalization(context: $context) {
      helpCenterPersonalizedView {
        vaLayoutVariant
        banner {
          ...BannerFields
        }
        ...IntentConfigFields
        isVacEnabled
        taapAcademyComponent {
          ...TaapAcademyComponentFields
        }
        travelerTripDetailedOverview {
          ...TripInfoDetailFields
        }
        helpArticleTitle
      }
      helpCenterSignInCTAView {
        ...SignInCTAFields
      }
    }
  }
  ${BannerFieldsFragmentDoc}
  ${IntentConfigFieldsFragmentDoc}
  ${TaapAcademyComponentFieldsFragmentDoc}
  ${TripInfoDetailFieldsFragmentDoc}
  ${SignInCTAFieldsFragmentDoc}
`;

export type SdkFunctionWrapper = <T>(
  action: (requestHeaders?: Record<string, string>) => Promise<T>,
  operationName: string,
  operationType?: string
) => Promise<T>;

const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType) => action();
const UpdateUserStateAndSendMessageDocumentString = print(UpdateUserStateAndSendMessageDocument);
const getHelpCenterConfigDocumentString = print(getHelpCenterConfigDocument);
export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    UpdateUserStateAndSendMessage(
      variables: UpdateUserStateAndSendMessageMutationVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<{
      data: UpdateUserStateAndSendMessageMutation;
      extensions?: any;
      headers: Dom.Headers;
      status: number;
    }> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.rawRequest<UpdateUserStateAndSendMessageMutation>(
            UpdateUserStateAndSendMessageDocumentString,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'UpdateUserStateAndSendMessage',
        'mutation'
      );
    },
    getHelpCenterConfig(
      variables: getHelpCenterConfigQueryVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<{ data: getHelpCenterConfigQuery; extensions?: any; headers: Dom.Headers; status: number }> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.rawRequest<getHelpCenterConfigQuery>(getHelpCenterConfigDocumentString, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'getHelpCenterConfig',
        'query'
      );
    },
  };
}
export type Sdk = ReturnType<typeof getSdk>;
